function doBrowserCheck(a) {
    function b() {
        var a = window.navigator.userAgent,
            b = a.indexOf("MSIE ");
        if (b > 0) return parseInt(a.substring(b + 5, a.indexOf(".", b)), 10);
        var c = a.indexOf("Trident/");
        if (c > 0) {
            var d = a.indexOf("rv:");
            return parseInt(a.substring(d + 3, a.indexOf(".", d)), 10);
        }
        var e = a.indexOf("Edge/");
        return e > 0 && parseInt(a.substring(e + 5, a.indexOf(".", e)), 10);
    }
    if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) (pnpHelper.browser.isFirefox = !0), a && $html.addClass("browser-firefox");
    else if (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)) (pnpHelper.browser.isChrome = !0), a && ($html.addClass("browser-chrome"), $html.addClass("browser-webkit"));
    else if (/Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor)) (pnpHelper.browser.isSafari = !0), a && ($html.addClass("browser-safari"), $html.addClass("browser-webkit"));
    else {
        var c = !1;
        (c = b()),
            c &&
                ((pnpHelper.browser.isIE = !0),
                (pnpHelper.browser.version.ie = c),
                a && ($html.addClass("browser-ie"), $html.addClass("browser-ie-" + c), $html.addClass("browser-lt-ie-" + (c + 1)), c < 12 ? $html.addClass("browser-lt-edge") : 12 == c && $html.addClass("browser-edge")));
    }
    navigator.platform &&
        /iPad|iPhone|iPod/.test(navigator.platform) &&
        ((pnpHelper.browser.isIOS = !0), navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*CPU.*OS 7_\d/i) && ((pnpHelper.browser.version.ios = 7), a && $html.addClass("os-ios-7")), a && $html.addClass("os-ios"));
}
function initBannerVideos() {
    pnpHelper.bootstrap.isSm() &&
        $(".has-background-video").each(function () {
            var a = $(this),
                b = a.find("[data-src]");
            b.attr("src", b.data("src")).removeAttr("data-src"),
                "function" == typeof b.parent().load && b.parent().load(),
                setTimeout(function () {
                    a.find(".loading-cover").addClass("-in");
                }, 4500);
        });
}
!(function (a) {
    a.fn.viewportChecker = function (b) {
        var c = {
            classToAdd: "visible",
            classToRemove: "invisible",
            classToAddForFullView: "full-visible",
            removeClassAfterAnimation: !1,
            offset: 100,
            repeat: !1,
            invertBottomOffset: !0,
            callbackFunction: function (a, b) {},
            scrollHorizontal: !1,
            scrollBox: window,
        };
        a.extend(c, b);
        var d = this,
            e = { height: a(c.scrollBox).height(), width: a(c.scrollBox).width() };
        return (
            (this.checkElements = function () {
                var b, f;
                c.scrollHorizontal
                    ? ((b = Math.max(a("html").scrollLeft(), a("body").scrollLeft(), a(window).scrollLeft())), (f = b + e.width))
                    : ((b = Math.max(a("html").scrollTop(), a("body").scrollTop(), a(window).scrollTop())), (f = b + e.height)),
                    d.each(function () {
                        var d = a(this),
                            g = {},
                            h = {};
                        if (
                            (d.data("vp-add-class") && (h.classToAdd = d.data("vp-add-class")),
                            d.data("vp-remove-class") && (h.classToRemove = d.data("vp-remove-class")),
                            d.data("vp-add-class-full-view") && (h.classToAddForFullView = d.data("vp-add-class-full-view")),
                            d.data("vp-keep-add-class") && (h.removeClassAfterAnimation = d.data("vp-remove-after-animation")),
                            d.data("vp-offset") && (h.offset = d.data("vp-offset")),
                            d.data("vp-repeat") && (h.repeat = d.data("vp-repeat")),
                            d.data("vp-scrollHorizontal") && (h.scrollHorizontal = d.data("vp-scrollHorizontal")),
                            d.data("vp-invertBottomOffset") && (h.scrollHorizontal = d.data("vp-invertBottomOffset")),
                            a.extend(g, c),
                            a.extend(g, h),
                            !d.data("vp-animated") || g.repeat)
                        ) {
                            String(g.offset).indexOf("%") > 0 && (g.offset = (parseInt(g.offset) / 100) * e.height);
                            var i = g.scrollHorizontal ? d.offset().left : d.offset().top,
                                j = g.scrollHorizontal ? i + d.width() : i + d.height(),
                                k = Math.round(i) + g.offset,
                                l = g.scrollHorizontal ? k + d.width() : k + d.height();
                            g.invertBottomOffset && (l -= 2 * g.offset),
                                k < f && l > b
                                    ? (d.removeClass(g.classToRemove),
                                      d.addClass(g.classToAdd),
                                      g.callbackFunction(d, "add"),
                                      j <= f && i >= b ? d.addClass(g.classToAddForFullView) : d.removeClass(g.classToAddForFullView),
                                      d.data("vp-animated", !0),
                                      g.removeClassAfterAnimation &&
                                          d.one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function () {
                                              d.removeClass(g.classToAdd);
                                          }))
                                    : d.hasClass(g.classToAdd) && g.repeat && (d.removeClass(g.classToAdd + " " + g.classToAddForFullView), g.callbackFunction(d, "remove"), d.data("vp-animated", !1));
                        }
                    });
            }),
            ("ontouchstart" in window || "onmsgesturechange" in window) && a(document).bind("touchmove MSPointerMove pointermove", this.checkElements),
            a(c.scrollBox).bind("load scroll", this.checkElements),
            a(window).resize(function (b) {
                (e = { height: a(c.scrollBox).height(), width: a(c.scrollBox).width() }), d.checkElements();
            }),
            this.checkElements(),
            this
        );
    };
})(jQuery);
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
    "use strict";
    _gsScope._gsDefine(
        "plugins.CSSPlugin",
        ["plugins.TweenPlugin", "TweenLite"],
        function (a, b) {
            var c,
                d,
                e,
                f,
                g = function () {
                    a.call(this, "css"), (this._overwriteProps.length = 0), (this.setRatio = g.prototype.setRatio);
                },
                h = _gsScope._gsDefine.globals,
                i = {},
                j = (g.prototype = new a("css"));
            (j.constructor = g),
                (g.version = "1.20.4"),
                (g.API = 2),
                (g.defaultTransformPerspective = 0),
                (g.defaultSkewType = "compensated"),
                (g.defaultSmoothOrigin = !0),
                (j = "px"),
                (g.suffixMap = { top: j, right: j, bottom: j, left: j, width: j, height: j, fontSize: j, padding: j, margin: j, perspective: j, lineHeight: "" });
            var k,
                l,
                m,
                n,
                o,
                p,
                q,
                r,
                s = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
                t = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
                u = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,
                v = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,
                w = /(?:\d|\-|\+|=|#|\.)*/g,
                x = /opacity *= *([^)]*)/i,
                y = /opacity:([^;]*)/i,
                z = /alpha\(opacity *=.+?\)/i,
                A = /^(rgb|hsl)/,
                B = /([A-Z])/g,
                C = /-([a-z])/gi,
                D = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,
                E = function (a, b) {
                    return b.toUpperCase();
                },
                F = /(?:Left|Right|Width)/i,
                G = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
                H = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
                I = /,(?=[^\)]*(?:\(|$))/gi,
                J = /[\s,\(]/i,
                K = Math.PI / 180,
                L = 180 / Math.PI,
                M = {},
                N = { style: {} },
                O = _gsScope.document || {
                    createElement: function () {
                        return N;
                    },
                },
                P = function (a, b) {
                    return O.createElementNS ? O.createElementNS(b || "http://www.w3.org/1999/xhtml", a) : O.createElement(a);
                },
                Q = P("div"),
                R = P("img"),
                S = (g._internals = { _specialProps: i }),
                T = (_gsScope.navigator || {}).userAgent || "",
                U = (function () {
                    var a = T.indexOf("Android"),
                        b = P("a");
                    return (
                        (m = -1 !== T.indexOf("Safari") && -1 === T.indexOf("Chrome") && (-1 === a || parseFloat(T.substr(a + 8, 2)) > 3)),
                        (o = m && parseFloat(T.substr(T.indexOf("Version/") + 8, 2)) < 6),
                        (n = -1 !== T.indexOf("Firefox")),
                        (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(T) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(T)) && (p = parseFloat(RegExp.$1)),
                        !!b && ((b.style.cssText = "top:1px;opacity:.55;"), /^0.55/.test(b.style.opacity))
                    );
                })(),
                V = function (a) {
                    return x.test("string" == typeof a ? a : (a.currentStyle ? a.currentStyle.filter : a.style.filter) || "") ? parseFloat(RegExp.$1) / 100 : 1;
                },
                W = function (a) {
                    _gsScope.console && console.log(a);
                },
                X = "",
                Y = "",
                Z = function (a, b) {
                    b = b || Q;
                    var c,
                        d,
                        e = b.style;
                    if (void 0 !== e[a]) return a;
                    for (a = a.charAt(0).toUpperCase() + a.substr(1), c = ["O", "Moz", "ms", "Ms", "Webkit"], d = 5; --d > -1 && void 0 === e[c[d] + a]; );
                    return d >= 0 ? ((Y = 3 === d ? "ms" : c[d]), (X = "-" + Y.toLowerCase() + "-"), Y + a) : null;
                },
                $ = O.defaultView ? O.defaultView.getComputedStyle : function () {},
                _ = (g.getStyle = function (a, b, c, d, e) {
                    var f;
                    return U || "opacity" !== b
                        ? (!d && a.style[b] ? (f = a.style[b]) : (c = c || $(a)) ? (f = c[b] || c.getPropertyValue(b) || c.getPropertyValue(b.replace(B, "-$1").toLowerCase())) : a.currentStyle && (f = a.currentStyle[b]),
                          null == e || (f && "none" !== f && "auto" !== f && "auto auto" !== f) ? f : e)
                        : V(a);
                }),
                aa = (S.convertToPixels = function (a, c, d, e, f) {
                    if ("px" === e || (!e && "lineHeight" !== c)) return d;
                    if ("auto" === e || !d) return 0;
                    var h,
                        i,
                        j,
                        k = F.test(c),
                        l = a,
                        m = Q.style,
                        n = 0 > d,
                        o = 1 === d;
                    if ((n && (d = -d), o && (d *= 100), "lineHeight" !== c || e))
                        if ("%" === e && -1 !== c.indexOf("border")) h = (d / 100) * (k ? a.clientWidth : a.clientHeight);
                        else {
                            if (((m.cssText = "border:0 solid red;position:" + _(a, "position") + ";line-height:0;"), "%" !== e && l.appendChild && "v" !== e.charAt(0) && "rem" !== e)) m[k ? "borderLeftWidth" : "borderTopWidth"] = d + e;
                            else {
                                if (((l = a.parentNode || O.body), -1 !== _(l, "display").indexOf("flex") && (m.position = "absolute"), (i = l._gsCache), (j = b.ticker.frame), i && k && i.time === j)) return (i.width * d) / 100;
                                m[k ? "width" : "height"] = d + e;
                            }
                            l.appendChild(Q),
                                (h = parseFloat(Q[k ? "offsetWidth" : "offsetHeight"])),
                                l.removeChild(Q),
                                k && "%" === e && g.cacheWidths !== !1 && ((i = l._gsCache = l._gsCache || {}), (i.time = j), (i.width = (h / d) * 100)),
                                0 !== h || f || (h = aa(a, c, d, e, !0));
                        }
                    else (i = $(a).lineHeight), (a.style.lineHeight = d), (h = parseFloat($(a).lineHeight)), (a.style.lineHeight = i);
                    return o && (h /= 100), n ? -h : h;
                }),
                ba = (S.calculateOffset = function (a, b, c) {
                    if ("absolute" !== _(a, "position", c)) return 0;
                    var d = "left" === b ? "Left" : "Top",
                        e = _(a, "margin" + d, c);
                    return a["offset" + d] - (aa(a, b, parseFloat(e), e.replace(w, "")) || 0);
                }),
                ca = function (a, b) {
                    var c,
                        d,
                        e,
                        f = {};
                    if ((b = b || $(a, null)))
                        if ((c = b.length)) for (; --c > -1; ) (e = b[c]), (-1 === e.indexOf("-transform") || Da === e) && (f[e.replace(C, E)] = b.getPropertyValue(e));
                        else for (c in b) (-1 === c.indexOf("Transform") || Ca === c) && (f[c] = b[c]);
                    else if ((b = a.currentStyle || a.style)) for (c in b) "string" == typeof c && void 0 === f[c] && (f[c.replace(C, E)] = b[c]);
                    return (
                        U || (f.opacity = V(a)),
                        (d = Ra(a, b, !1)),
                        (f.rotation = d.rotation),
                        (f.skewX = d.skewX),
                        (f.scaleX = d.scaleX),
                        (f.scaleY = d.scaleY),
                        (f.x = d.x),
                        (f.y = d.y),
                        Fa && ((f.z = d.z), (f.rotationX = d.rotationX), (f.rotationY = d.rotationY), (f.scaleZ = d.scaleZ)),
                        f.filters && delete f.filters,
                        f
                    );
                },
                da = function (a, b, c, d, e) {
                    var f,
                        g,
                        h,
                        i = {},
                        j = a.style;
                    for (g in c)
                        "cssText" !== g &&
                            "length" !== g &&
                            isNaN(g) &&
                            (b[g] !== (f = c[g]) || (e && e[g])) &&
                            -1 === g.indexOf("Origin") &&
                            ("number" == typeof f || "string" == typeof f) &&
                            ((i[g] = "auto" !== f || ("left" !== g && "top" !== g) ? (("" !== f && "auto" !== f && "none" !== f) || "string" != typeof b[g] || "" === b[g].replace(v, "") ? f : 0) : ba(a, g)),
                            void 0 !== j[g] && (h = new sa(j, g, j[g], h)));
                    if (d) for (g in d) "className" !== g && (i[g] = d[g]);
                    return { difs: i, firstMPT: h };
                },
                ea = { width: ["Left", "Right"], height: ["Top", "Bottom"] },
                fa = ["marginLeft", "marginRight", "marginTop", "marginBottom"],
                ga = function (a, b, c) {
                    if ("svg" === (a.nodeName + "").toLowerCase()) return (c || $(a))[b] || 0;
                    if (a.getCTM && Oa(a)) return a.getBBox()[b] || 0;
                    var d = parseFloat("width" === b ? a.offsetWidth : a.offsetHeight),
                        e = ea[b],
                        f = e.length;
                    for (c = c || $(a, null); --f > -1; ) (d -= parseFloat(_(a, "padding" + e[f], c, !0)) || 0), (d -= parseFloat(_(a, "border" + e[f] + "Width", c, !0)) || 0);
                    return d;
                },
                ha = function (a, b) {
                    if ("contain" === a || "auto" === a || "auto auto" === a) return a + " ";
                    (null == a || "" === a) && (a = "0 0");
                    var c,
                        d = a.split(" "),
                        e = -1 !== a.indexOf("left") ? "0%" : -1 !== a.indexOf("right") ? "100%" : d[0],
                        f = -1 !== a.indexOf("top") ? "0%" : -1 !== a.indexOf("bottom") ? "100%" : d[1];
                    if (d.length > 3 && !b) {
                        for (d = a.split(", ").join(",").split(","), a = [], c = 0; c < d.length; c++) a.push(ha(d[c]));
                        return a.join(",");
                    }
                    return (
                        null == f ? (f = "center" === e ? "50%" : "0") : "center" === f && (f = "50%"),
                        ("center" === e || (isNaN(parseFloat(e)) && -1 === (e + "").indexOf("="))) && (e = "50%"),
                        (a = e + " " + f + (d.length > 2 ? " " + d[2] : "")),
                        b &&
                            ((b.oxp = -1 !== e.indexOf("%")),
                            (b.oyp = -1 !== f.indexOf("%")),
                            (b.oxr = "=" === e.charAt(1)),
                            (b.oyr = "=" === f.charAt(1)),
                            (b.ox = parseFloat(e.replace(v, ""))),
                            (b.oy = parseFloat(f.replace(v, ""))),
                            (b.v = a)),
                        b || a
                    );
                },
                ia = function (a, b) {
                    return "function" == typeof a && (a = a(r, q)), "string" == typeof a && "=" === a.charAt(1) ? parseInt(a.charAt(0) + "1", 10) * parseFloat(a.substr(2)) : parseFloat(a) - parseFloat(b) || 0;
                },
                ja = function (a, b) {
                    return "function" == typeof a && (a = a(r, q)), null == a ? b : "string" == typeof a && "=" === a.charAt(1) ? parseInt(a.charAt(0) + "1", 10) * parseFloat(a.substr(2)) + b : parseFloat(a) || 0;
                },
                ka = function (a, b, c, d) {
                    var e,
                        f,
                        g,
                        h,
                        i,
                        j = 1e-6;
                    return (
                        "function" == typeof a && (a = a(r, q)),
                        null == a
                            ? (h = b)
                            : "number" == typeof a
                            ? (h = a)
                            : ((e = 360),
                              (f = a.split("_")),
                              (i = "=" === a.charAt(1)),
                              (g = (i ? parseInt(a.charAt(0) + "1", 10) * parseFloat(f[0].substr(2)) : parseFloat(f[0])) * (-1 === a.indexOf("rad") ? 1 : L) - (i ? 0 : b)),
                              f.length &&
                                  (d && (d[c] = b + g),
                                  -1 !== a.indexOf("short") && ((g %= e), g !== g % (e / 2) && (g = 0 > g ? g + e : g - e)),
                                  -1 !== a.indexOf("_cw") && 0 > g ? (g = ((g + 9999999999 * e) % e) - ((g / e) | 0) * e) : -1 !== a.indexOf("ccw") && g > 0 && (g = ((g - 9999999999 * e) % e) - ((g / e) | 0) * e)),
                              (h = b + g)),
                        j > h && h > -j && (h = 0),
                        h
                    );
                },
                la = {
                    aqua: [0, 255, 255],
                    lime: [0, 255, 0],
                    silver: [192, 192, 192],
                    black: [0, 0, 0],
                    maroon: [128, 0, 0],
                    teal: [0, 128, 128],
                    blue: [0, 0, 255],
                    navy: [0, 0, 128],
                    white: [255, 255, 255],
                    fuchsia: [255, 0, 255],
                    olive: [128, 128, 0],
                    yellow: [255, 255, 0],
                    orange: [255, 165, 0],
                    gray: [128, 128, 128],
                    purple: [128, 0, 128],
                    green: [0, 128, 0],
                    red: [255, 0, 0],
                    pink: [255, 192, 203],
                    cyan: [0, 255, 255],
                    transparent: [255, 255, 255, 0],
                },
                ma = function (a, b, c) {
                    return (a = 0 > a ? a + 1 : a > 1 ? a - 1 : a), (255 * (1 > 6 * a ? b + (c - b) * a * 6 : 0.5 > a ? c : 2 > 3 * a ? b + (c - b) * (2 / 3 - a) * 6 : b) + 0.5) | 0;
                },
                na = (g.parseColor = function (a, b) {
                    var c, d, e, f, g, h, i, j, k, l, m;
                    if (a)
                        if ("number" == typeof a) c = [a >> 16, (a >> 8) & 255, 255 & a];
                        else {
                            if (("," === a.charAt(a.length - 1) && (a = a.substr(0, a.length - 1)), la[a])) c = la[a];
                            else if ("#" === a.charAt(0))
                                4 === a.length && ((d = a.charAt(1)), (e = a.charAt(2)), (f = a.charAt(3)), (a = "#" + d + d + e + e + f + f)), (a = parseInt(a.substr(1), 16)), (c = [a >> 16, (a >> 8) & 255, 255 & a]);
                            else if ("hsl" === a.substr(0, 3))
                                if (((c = m = a.match(s)), b)) {
                                    if (-1 !== a.indexOf("=")) return a.match(t);
                                } else
                                    (g = (Number(c[0]) % 360) / 360),
                                        (h = Number(c[1]) / 100),
                                        (i = Number(c[2]) / 100),
                                        (e = 0.5 >= i ? i * (h + 1) : i + h - i * h),
                                        (d = 2 * i - e),
                                        c.length > 3 && (c[3] = Number(c[3])),
                                        (c[0] = ma(g + 1 / 3, d, e)),
                                        (c[1] = ma(g, d, e)),
                                        (c[2] = ma(g - 1 / 3, d, e));
                            else c = a.match(s) || la.transparent;
                            (c[0] = Number(c[0])), (c[1] = Number(c[1])), (c[2] = Number(c[2])), c.length > 3 && (c[3] = Number(c[3]));
                        }
                    else c = la.black;
                    return (
                        b &&
                            !m &&
                            ((d = c[0] / 255),
                            (e = c[1] / 255),
                            (f = c[2] / 255),
                            (j = Math.max(d, e, f)),
                            (k = Math.min(d, e, f)),
                            (i = (j + k) / 2),
                            j === k ? (g = h = 0) : ((l = j - k), (h = i > 0.5 ? l / (2 - j - k) : l / (j + k)), (g = j === d ? (e - f) / l + (f > e ? 6 : 0) : j === e ? (f - d) / l + 2 : (d - e) / l + 4), (g *= 60)),
                            (c[0] = (g + 0.5) | 0),
                            (c[1] = (100 * h + 0.5) | 0),
                            (c[2] = (100 * i + 0.5) | 0)),
                        c
                    );
                }),
                oa = function (a, b) {
                    var c,
                        d,
                        e,
                        f = a.match(pa) || [],
                        g = 0,
                        h = "";
                    if (!f.length) return a;
                    for (c = 0; c < f.length; c++)
                        (d = f[c]),
                            (e = a.substr(g, a.indexOf(d, g) - g)),
                            (g += e.length + d.length),
                            (d = na(d, b)),
                            3 === d.length && d.push(1),
                            (h += e + (b ? "hsla(" + d[0] + "," + d[1] + "%," + d[2] + "%," + d[3] : "rgba(" + d.join(",")) + ")");
                    return h + a.substr(g);
                },
                pa = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";
            for (j in la) pa += "|" + j + "\\b";
            (pa = new RegExp(pa + ")", "gi")),
                (g.colorStringFilter = function (a) {
                    var b,
                        c = a[0] + " " + a[1];
                    pa.test(c) && ((b = -1 !== c.indexOf("hsl(") || -1 !== c.indexOf("hsla(")), (a[0] = oa(a[0], b)), (a[1] = oa(a[1], b))), (pa.lastIndex = 0);
                }),
                b.defaultStringFilter || (b.defaultStringFilter = g.colorStringFilter);
            var qa = function (a, b, c, d) {
                    if (null == a)
                        return function (a) {
                            return a;
                        };
                    var e,
                        f = b ? (a.match(pa) || [""])[0] : "",
                        g = a.split(f).join("").match(u) || [],
                        h = a.substr(0, a.indexOf(g[0])),
                        i = ")" === a.charAt(a.length - 1) ? ")" : "",
                        j = -1 !== a.indexOf(" ") ? " " : ",",
                        k = g.length,
                        l = k > 0 ? g[0].replace(s, "") : "";
                    return k
                        ? (e = b
                              ? function (a) {
                                    var b, m, n, o;
                                    if ("number" == typeof a) a += l;
                                    else if (d && I.test(a)) {
                                        for (o = a.replace(I, "|").split("|"), n = 0; n < o.length; n++) o[n] = e(o[n]);
                                        return o.join(",");
                                    }
                                    if (((b = (a.match(pa) || [f])[0]), (m = a.split(b).join("").match(u) || []), (n = m.length), k > n--)) for (; ++n < k; ) m[n] = c ? m[((n - 1) / 2) | 0] : g[n];
                                    return h + m.join(j) + j + b + i + (-1 !== a.indexOf("inset") ? " inset" : "");
                                }
                              : function (a) {
                                    var b, f, m;
                                    if ("number" == typeof a) a += l;
                                    else if (d && I.test(a)) {
                                        for (f = a.replace(I, "|").split("|"), m = 0; m < f.length; m++) f[m] = e(f[m]);
                                        return f.join(",");
                                    }
                                    if (((b = a.match(u) || []), (m = b.length), k > m--)) for (; ++m < k; ) b[m] = c ? b[((m - 1) / 2) | 0] : g[m];
                                    return h + b.join(j) + i;
                                })
                        : function (a) {
                              return a;
                          };
                },
                ra = function (a) {
                    return (
                        (a = a.split(",")),
                        function (b, c, d, e, f, g, h) {
                            var i,
                                j = (c + "").split(" ");
                            for (h = {}, i = 0; 4 > i; i++) h[a[i]] = j[i] = j[i] || j[((i - 1) / 2) >> 0];
                            return e.parse(b, h, f, g);
                        }
                    );
                },
                sa =
                    ((S._setPluginRatio = function (a) {
                        this.plugin.setRatio(a);
                        for (var b, c, d, e, f, g = this.data, h = g.proxy, i = g.firstMPT, j = 1e-6; i; ) (b = h[i.v]), i.r ? (b = Math.round(b)) : j > b && b > -j && (b = 0), (i.t[i.p] = b), (i = i._next);
                        if ((g.autoRotate && (g.autoRotate.rotation = g.mod ? g.mod(h.rotation, this.t) : h.rotation), 1 === a || 0 === a))
                            for (i = g.firstMPT, f = 1 === a ? "e" : "b"; i; ) {
                                if (((c = i.t), c.type)) {
                                    if (1 === c.type) {
                                        for (e = c.xs0 + c.s + c.xs1, d = 1; d < c.l; d++) e += c["xn" + d] + c["xs" + (d + 1)];
                                        c[f] = e;
                                    }
                                } else c[f] = c.s + c.xs0;
                                i = i._next;
                            }
                    }),
                    function (a, b, c, d, e) {
                        (this.t = a), (this.p = b), (this.v = c), (this.r = e), d && ((d._prev = this), (this._next = d));
                    }),
                ta =
                    ((S._parseToProxy = function (a, b, c, d, e, f) {
                        var g,
                            h,
                            i,
                            j,
                            k,
                            l = d,
                            m = {},
                            n = {},
                            o = c._transform,
                            p = M;
                        for (c._transform = null, M = b, d = k = c.parse(a, b, d, e), M = p, f && ((c._transform = o), l && ((l._prev = null), l._prev && (l._prev._next = null))); d && d !== l; ) {
                            if (d.type <= 1 && ((h = d.p), (n[h] = d.s + d.c), (m[h] = d.s), f || ((j = new sa(d, "s", h, j, d.r)), (d.c = 0)), 1 === d.type))
                                for (g = d.l; --g > 0; ) (i = "xn" + g), (h = d.p + "_" + i), (n[h] = d.data[i]), (m[h] = d[i]), f || (j = new sa(d, i, h, j, d.rxp[i]));
                            d = d._next;
                        }
                        return { proxy: m, end: n, firstMPT: j, pt: k };
                    }),
                    (S.CSSPropTween = function (a, b, d, e, g, h, i, j, k, l, m) {
                        (this.t = a),
                            (this.p = b),
                            (this.s = d),
                            (this.c = e),
                            (this.n = i || b),
                            a instanceof ta || f.push(this.n),
                            (this.r = j),
                            (this.type = h || 0),
                            k && ((this.pr = k), (c = !0)),
                            (this.b = void 0 === l ? d : l),
                            (this.e = void 0 === m ? d + e : m),
                            g && ((this._next = g), (g._prev = this));
                    })),
                ua = function (a, b, c, d, e, f) {
                    var g = new ta(a, b, c, d - c, e, -1, f);
                    return (g.b = c), (g.e = g.xs0 = d), g;
                },
                va = (g.parseComplex = function (a, b, c, d, e, f, h, i, j, l) {
                    (c = c || f || ""), "function" == typeof d && (d = d(r, q)), (h = new ta(a, b, 0, 0, h, l ? 2 : 1, null, !1, i, c, d)), (d += ""), e && pa.test(d + c) && ((d = [c, d]), g.colorStringFilter(d), (c = d[0]), (d = d[1]));
                    var m,
                        n,
                        o,
                        p,
                        u,
                        v,
                        w,
                        x,
                        y,
                        z,
                        A,
                        B,
                        C,
                        D = c.split(", ").join(",").split(" "),
                        E = d.split(", ").join(",").split(" "),
                        F = D.length,
                        G = k !== !1;
                    for (
                        (-1 !== d.indexOf(",") || -1 !== c.indexOf(",")) &&
                            (-1 !== (d + c).indexOf("rgb") || -1 !== (d + c).indexOf("hsl")
                                ? ((D = D.join(" ").replace(I, ", ").split(" ")), (E = E.join(" ").replace(I, ", ").split(" ")))
                                : ((D = D.join(" ").split(",").join(", ").split(" ")), (E = E.join(" ").split(",").join(", ").split(" "))),
                            (F = D.length)),
                            F !== E.length && ((D = (f || "").split(" ")), (F = D.length)),
                            h.plugin = j,
                            h.setRatio = l,
                            pa.lastIndex = 0,
                            m = 0;
                        F > m;
                        m++
                    )
                        if (((p = D[m]), (u = E[m]), (x = parseFloat(p)), x || 0 === x)) h.appendXtra("", x, ia(u, x), u.replace(t, ""), G && -1 !== u.indexOf("px"), !0);
                        else if (e && pa.test(p))
                            (B = u.indexOf(")") + 1),
                                (B = ")" + (B ? u.substr(B) : "")),
                                (C = -1 !== u.indexOf("hsl") && U),
                                (z = u),
                                (p = na(p, C)),
                                (u = na(u, C)),
                                (y = p.length + u.length > 6),
                                y && !U && 0 === u[3]
                                    ? ((h["xs" + h.l] += h.l ? " transparent" : "transparent"), (h.e = h.e.split(E[m]).join("transparent")))
                                    : (U || (y = !1),
                                      C
                                          ? h
                                                .appendXtra(z.substr(0, z.indexOf("hsl")) + (y ? "hsla(" : "hsl("), p[0], ia(u[0], p[0]), ",", !1, !0)
                                                .appendXtra("", p[1], ia(u[1], p[1]), "%,", !1)
                                                .appendXtra("", p[2], ia(u[2], p[2]), y ? "%," : "%" + B, !1)
                                          : h
                                                .appendXtra(z.substr(0, z.indexOf("rgb")) + (y ? "rgba(" : "rgb("), p[0], u[0] - p[0], ",", !0, !0)
                                                .appendXtra("", p[1], u[1] - p[1], ",", !0)
                                                .appendXtra("", p[2], u[2] - p[2], y ? "," : B, !0),
                                      y && ((p = p.length < 4 ? 1 : p[3]), h.appendXtra("", p, (u.length < 4 ? 1 : u[3]) - p, B, !1))),
                                (pa.lastIndex = 0);
                        else if ((v = p.match(s))) {
                            if (((w = u.match(t)), !w || w.length !== v.length)) return h;
                            for (o = 0, n = 0; n < v.length; n++) (A = v[n]), (z = p.indexOf(A, o)), h.appendXtra(p.substr(o, z - o), Number(A), ia(w[n], A), "", G && "px" === p.substr(z + A.length, 2), 0 === n), (o = z + A.length);
                            h["xs" + h.l] += p.substr(o);
                        } else h["xs" + h.l] += h.l || h["xs" + h.l] ? " " + u : u;
                    if (-1 !== d.indexOf("=") && h.data) {
                        for (B = h.xs0 + h.data.s, m = 1; m < h.l; m++) B += h["xs" + m] + h.data["xn" + m];
                        h.e = B + h["xs" + m];
                    }
                    return h.l || ((h.type = -1), (h.xs0 = h.e)), h.xfirst || h;
                }),
                wa = 9;
            for (j = ta.prototype, j.l = j.pr = 0; --wa > 0; ) (j["xn" + wa] = 0), (j["xs" + wa] = "");
            (j.xs0 = ""),
                (j._next = j._prev = j.xfirst = j.data = j.plugin = j.setRatio = j.rxp = null),
                (j.appendXtra = function (a, b, c, d, e, f) {
                    var g = this,
                        h = g.l;
                    return (
                        (g["xs" + h] += f && (h || g["xs" + h]) ? " " + a : a || ""),
                        c || 0 === h || g.plugin
                            ? (g.l++,
                              (g.type = g.setRatio ? 2 : 1),
                              (g["xs" + g.l] = d || ""),
                              h > 0
                                  ? ((g.data["xn" + h] = b + c), (g.rxp["xn" + h] = e), (g["xn" + h] = b), g.plugin || ((g.xfirst = new ta(g, "xn" + h, b, c, g.xfirst || g, 0, g.n, e, g.pr)), (g.xfirst.xs0 = 0)), g)
                                  : ((g.data = { s: b + c }), (g.rxp = {}), (g.s = b), (g.c = c), (g.r = e), g))
                            : ((g["xs" + h] += b + (d || "")), g)
                    );
                });
            var xa = function (a, b) {
                    (b = b || {}),
                        (this.p = b.prefix ? Z(a) || a : a),
                        (i[a] = i[this.p] = this),
                        (this.format = b.formatter || qa(b.defaultValue, b.color, b.collapsible, b.multi)),
                        b.parser && (this.parse = b.parser),
                        (this.clrs = b.color),
                        (this.multi = b.multi),
                        (this.keyword = b.keyword),
                        (this.dflt = b.defaultValue),
                        (this.pr = b.priority || 0);
                },
                ya = (S._registerComplexSpecialProp = function (a, b, c) {
                    "object" != typeof b && (b = { parser: c });
                    var d,
                        e,
                        f = a.split(","),
                        g = b.defaultValue;
                    for (c = c || [g], d = 0; d < f.length; d++) (b.prefix = 0 === d && b.prefix), (b.defaultValue = c[d] || g), (e = new xa(f[d], b));
                }),
                za = (S._registerPluginProp = function (a) {
                    if (!i[a]) {
                        var b = a.charAt(0).toUpperCase() + a.substr(1) + "Plugin";
                        ya(a, {
                            parser: function (a, c, d, e, f, g, j) {
                                var k = h.com.greensock.plugins[b];
                                return k ? (k._cssRegister(), i[d].parse(a, c, d, e, f, g, j)) : (W("Error: " + b + " js file not loaded."), f);
                            },
                        });
                    }
                });
            (j = xa.prototype),
                (j.parseComplex = function (a, b, c, d, e, f) {
                    var g,
                        h,
                        i,
                        j,
                        k,
                        l,
                        m = this.keyword;
                    if ((this.multi && (I.test(c) || I.test(b) ? ((h = b.replace(I, "|").split("|")), (i = c.replace(I, "|").split("|"))) : m && ((h = [b]), (i = [c]))), i)) {
                        for (j = i.length > h.length ? i.length : h.length, g = 0; j > g; g++)
                            (b = h[g] = h[g] || this.dflt), (c = i[g] = i[g] || this.dflt), m && ((k = b.indexOf(m)), (l = c.indexOf(m)), k !== l && (-1 === l ? (h[g] = h[g].split(m).join("")) : -1 === k && (h[g] += " " + m)));
                        (b = h.join(", ")), (c = i.join(", "));
                    }
                    return va(a, this.p, b, c, this.clrs, this.dflt, d, this.pr, e, f);
                }),
                (j.parse = function (a, b, c, d, f, g, h) {
                    return this.parseComplex(a.style, this.format(_(a, this.p, e, !1, this.dflt)), this.format(b), f, g);
                }),
                (g.registerSpecialProp = function (a, b, c) {
                    ya(a, {
                        parser: function (a, d, e, f, g, h, i) {
                            var j = new ta(a, e, 0, 0, g, 2, e, !1, c);
                            return (j.plugin = h), (j.setRatio = b(a, d, f._tween, e)), j;
                        },
                        priority: c,
                    });
                }),
                (g.useSVGTransformAttr = !0);
            var Aa,
                Ba = "scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),
                Ca = Z("transform"),
                Da = X + "transform",
                Ea = Z("transformOrigin"),
                Fa = null !== Z("perspective"),
                Ga = (S.Transform = function () {
                    (this.perspective = parseFloat(g.defaultTransformPerspective) || 0), (this.force3D = !(g.defaultForce3D === !1 || !Fa) && (g.defaultForce3D || "auto"));
                }),
                Ha = _gsScope.SVGElement,
                Ia = function (a, b, c) {
                    var d,
                        e = O.createElementNS("http://www.w3.org/2000/svg", a),
                        f = /([a-z])([A-Z])/g;
                    for (d in c) e.setAttributeNS(null, d.replace(f, "$1-$2").toLowerCase(), c[d]);
                    return b.appendChild(e), e;
                },
                Ja = O.documentElement || {},
                Ka = (function () {
                    var a,
                        b,
                        c,
                        d = p || (/Android/i.test(T) && !_gsScope.chrome);
                    return (
                        O.createElementNS &&
                            !d &&
                            ((a = Ia("svg", Ja)),
                            (b = Ia("rect", a, { width: 100, height: 50, x: 100 })),
                            (c = b.getBoundingClientRect().width),
                            (b.style[Ea] = "50% 50%"),
                            (b.style[Ca] = "scaleX(0.5)"),
                            (d = c === b.getBoundingClientRect().width && !(n && Fa)),
                            Ja.removeChild(a)),
                        d
                    );
                })(),
                La = function (a, b, c, d, e, f) {
                    var h,
                        i,
                        j,
                        k,
                        l,
                        m,
                        n,
                        o,
                        p,
                        q,
                        r,
                        s,
                        t,
                        u,
                        v = a._gsTransform,
                        w = Qa(a, !0);
                    v && ((t = v.xOrigin), (u = v.yOrigin)),
                        (!d || (h = d.split(" ")).length < 2) &&
                            ((n = a.getBBox()),
                            0 === n.x &&
                                0 === n.y &&
                                n.width + n.height === 0 &&
                                (n = {
                                    x: parseFloat(a.hasAttribute("x") ? a.getAttribute("x") : a.hasAttribute("cx") ? a.getAttribute("cx") : 0) || 0,
                                    y: parseFloat(a.hasAttribute("y") ? a.getAttribute("y") : a.hasAttribute("cy") ? a.getAttribute("cy") : 0) || 0,
                                    width: 0,
                                    height: 0,
                                }),
                            (b = ha(b).split(" ")),
                            (h = [(-1 !== b[0].indexOf("%") ? (parseFloat(b[0]) / 100) * n.width : parseFloat(b[0])) + n.x, (-1 !== b[1].indexOf("%") ? (parseFloat(b[1]) / 100) * n.height : parseFloat(b[1])) + n.y])),
                        (c.xOrigin = k = parseFloat(h[0])),
                        (c.yOrigin = l = parseFloat(h[1])),
                        d &&
                            w !== Pa &&
                            ((m = w[0]),
                            (n = w[1]),
                            (o = w[2]),
                            (p = w[3]),
                            (q = w[4]),
                            (r = w[5]),
                            (s = m * p - n * o),
                            s && ((i = k * (p / s) + l * (-o / s) + (o * r - p * q) / s), (j = k * (-n / s) + l * (m / s) - (m * r - n * q) / s), (k = c.xOrigin = h[0] = i), (l = c.yOrigin = h[1] = j))),
                        v &&
                            (f && ((c.xOffset = v.xOffset), (c.yOffset = v.yOffset), (v = c)),
                            e || (e !== !1 && g.defaultSmoothOrigin !== !1) ? ((i = k - t), (j = l - u), (v.xOffset += i * w[0] + j * w[2] - i), (v.yOffset += i * w[1] + j * w[3] - j)) : (v.xOffset = v.yOffset = 0)),
                        f || a.setAttribute("data-svg-origin", h.join(" "));
                },
                Ma = function (a) {
                    var b,
                        c = P("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
                        d = this.parentNode,
                        e = this.nextSibling,
                        f = this.style.cssText;
                    if ((Ja.appendChild(c), c.appendChild(this), (this.style.display = "block"), a))
                        try {
                            (b = this.getBBox()), (this._originalGetBBox = this.getBBox), (this.getBBox = Ma);
                        } catch (g) {}
                    else this._originalGetBBox && (b = this._originalGetBBox());
                    return e ? d.insertBefore(this, e) : d.appendChild(this), Ja.removeChild(c), (this.style.cssText = f), b;
                },
                Na = function (a) {
                    try {
                        return a.getBBox();
                    } catch (b) {
                        return Ma.call(a, !0);
                    }
                },
                Oa = function (a) {
                    return !(!Ha || !a.getCTM || (a.parentNode && !a.ownerSVGElement) || !Na(a));
                },
                Pa = [1, 0, 0, 1, 0, 0],
                Qa = function (a, b) {
                    var c,
                        d,
                        e,
                        f,
                        g,
                        h,
                        i = a._gsTransform || new Ga(),
                        j = 1e5,
                        k = a.style;
                    if (
                        (Ca
                            ? (d = _(a, Da, null, !0))
                            : a.currentStyle && ((d = a.currentStyle.filter.match(G)), (d = d && 4 === d.length ? [d[0].substr(4), Number(d[2].substr(4)), Number(d[1].substr(4)), d[3].substr(4), i.x || 0, i.y || 0].join(",") : "")),
                        (c = !d || "none" === d || "matrix(1, 0, 0, 1, 0, 0)" === d),
                        !Ca ||
                            (!(h = !$(a) || "none" === $(a).display) && a.parentNode) ||
                            (h && ((f = k.display), (k.display = "block")),
                            a.parentNode || ((g = 1), Ja.appendChild(a)),
                            (d = _(a, Da, null, !0)),
                            (c = !d || "none" === d || "matrix(1, 0, 0, 1, 0, 0)" === d),
                            f ? (k.display = f) : h && Va(k, "display"),
                            g && Ja.removeChild(a)),
                        (i.svg || (a.getCTM && Oa(a))) &&
                            (c && -1 !== (k[Ca] + "").indexOf("matrix") && ((d = k[Ca]), (c = 0)),
                            (e = a.getAttribute("transform")),
                            c && e && ((e = a.transform.baseVal.consolidate().matrix), (d = "matrix(" + e.a + "," + e.b + "," + e.c + "," + e.d + "," + e.e + "," + e.f + ")"), (c = 0))),
                        c)
                    )
                        return Pa;
                    for (e = (d || "").match(s) || [], wa = e.length; --wa > -1; ) (f = Number(e[wa])), (e[wa] = (g = f - (f |= 0)) ? ((g * j + (0 > g ? -0.5 : 0.5)) | 0) / j + f : f);
                    return b && e.length > 6 ? [e[0], e[1], e[4], e[5], e[12], e[13]] : e;
                },
                Ra = (S.getTransform = function (a, c, d, e) {
                    if (a._gsTransform && d && !e) return a._gsTransform;
                    var f,
                        h,
                        i,
                        j,
                        k,
                        l,
                        m = d ? a._gsTransform || new Ga() : new Ga(),
                        n = m.scaleX < 0,
                        o = 2e-5,
                        p = 1e5,
                        q = Fa ? parseFloat(_(a, Ea, c, !1, "0 0 0").split(" ")[2]) || m.zOrigin || 0 : 0,
                        r = parseFloat(g.defaultTransformPerspective) || 0;
                    if (((m.svg = !(!a.getCTM || !Oa(a))), m.svg && (La(a, _(a, Ea, c, !1, "50% 50%") + "", m, a.getAttribute("data-svg-origin")), (Aa = g.useSVGTransformAttr || Ka)), (f = Qa(a)), f !== Pa)) {
                        if (16 === f.length) {
                            var s,
                                t,
                                u,
                                v,
                                w,
                                x = f[0],
                                y = f[1],
                                z = f[2],
                                A = f[3],
                                B = f[4],
                                C = f[5],
                                D = f[6],
                                E = f[7],
                                F = f[8],
                                G = f[9],
                                H = f[10],
                                I = f[12],
                                J = f[13],
                                K = f[14],
                                M = f[11],
                                N = Math.atan2(D, H);
                            m.zOrigin && ((K = -m.zOrigin), (I = F * K - f[12]), (J = G * K - f[13]), (K = H * K + m.zOrigin - f[14])),
                                (m.rotationX = N * L),
                                N &&
                                    ((v = Math.cos(-N)),
                                    (w = Math.sin(-N)),
                                    (s = B * v + F * w),
                                    (t = C * v + G * w),
                                    (u = D * v + H * w),
                                    (F = B * -w + F * v),
                                    (G = C * -w + G * v),
                                    (H = D * -w + H * v),
                                    (M = E * -w + M * v),
                                    (B = s),
                                    (C = t),
                                    (D = u)),
                                (N = Math.atan2(-z, H)),
                                (m.rotationY = N * L),
                                N && ((v = Math.cos(-N)), (w = Math.sin(-N)), (s = x * v - F * w), (t = y * v - G * w), (u = z * v - H * w), (G = y * w + G * v), (H = z * w + H * v), (M = A * w + M * v), (x = s), (y = t), (z = u)),
                                (N = Math.atan2(y, x)),
                                (m.rotation = N * L),
                                N && ((v = Math.cos(N)), (w = Math.sin(N)), (s = x * v + y * w), (t = B * v + C * w), (u = F * v + G * w), (y = y * v - x * w), (C = C * v - B * w), (G = G * v - F * w), (x = s), (B = t), (F = u)),
                                m.rotationX && Math.abs(m.rotationX) + Math.abs(m.rotation) > 359.9 && ((m.rotationX = m.rotation = 0), (m.rotationY = 180 - m.rotationY)),
                                (N = Math.atan2(B, C)),
                                (m.scaleX = ((Math.sqrt(x * x + y * y + z * z) * p + 0.5) | 0) / p),
                                (m.scaleY = ((Math.sqrt(C * C + D * D) * p + 0.5) | 0) / p),
                                (m.scaleZ = ((Math.sqrt(F * F + G * G + H * H) * p + 0.5) | 0) / p),
                                (x /= m.scaleX),
                                (B /= m.scaleY),
                                (y /= m.scaleX),
                                (C /= m.scaleY),
                                Math.abs(N) > o ? ((m.skewX = N * L), (B = 0), "simple" !== m.skewType && (m.scaleY *= 1 / Math.cos(N))) : (m.skewX = 0),
                                (m.perspective = M ? 1 / (0 > M ? -M : M) : 0),
                                (m.x = I),
                                (m.y = J),
                                (m.z = K),
                                m.svg && ((m.x -= m.xOrigin - (m.xOrigin * x - m.yOrigin * B)), (m.y -= m.yOrigin - (m.yOrigin * y - m.xOrigin * C)));
                        } else if (!Fa || e || !f.length || m.x !== f[4] || m.y !== f[5] || (!m.rotationX && !m.rotationY)) {
                            var O = f.length >= 6,
                                P = O ? f[0] : 1,
                                Q = f[1] || 0,
                                R = f[2] || 0,
                                S = O ? f[3] : 1;
                            (m.x = f[4] || 0),
                                (m.y = f[5] || 0),
                                (i = Math.sqrt(P * P + Q * Q)),
                                (j = Math.sqrt(S * S + R * R)),
                                (k = P || Q ? Math.atan2(Q, P) * L : m.rotation || 0),
                                (l = R || S ? Math.atan2(R, S) * L + k : m.skewX || 0),
                                (m.scaleX = i),
                                (m.scaleY = j),
                                (m.rotation = k),
                                (m.skewX = l),
                                Fa && ((m.rotationX = m.rotationY = m.z = 0), (m.perspective = r), (m.scaleZ = 1)),
                                m.svg && ((m.x -= m.xOrigin - (m.xOrigin * P + m.yOrigin * R)), (m.y -= m.yOrigin - (m.xOrigin * Q + m.yOrigin * S)));
                        }
                        Math.abs(m.skewX) > 90 &&
                            Math.abs(m.skewX) < 270 &&
                            (n ? ((m.scaleX *= -1), (m.skewX += m.rotation <= 0 ? 180 : -180), (m.rotation += m.rotation <= 0 ? 180 : -180)) : ((m.scaleY *= -1), (m.skewX += m.skewX <= 0 ? 180 : -180))),
                            (m.zOrigin = q);
                        for (h in m) m[h] < o && m[h] > -o && (m[h] = 0);
                    }
                    return (
                        d &&
                            ((a._gsTransform = m),
                            m.svg &&
                                (Aa && a.style[Ca]
                                    ? b.delayedCall(0.001, function () {
                                          Va(a.style, Ca);
                                      })
                                    : !Aa &&
                                      a.getAttribute("transform") &&
                                      b.delayedCall(0.001, function () {
                                          a.removeAttribute("transform");
                                      }))),
                        m
                    );
                }),
                Sa = function (a) {
                    var b,
                        c,
                        d = this.data,
                        e = -d.rotation * K,
                        f = e + d.skewX * K,
                        g = 1e5,
                        h = ((Math.cos(e) * d.scaleX * g) | 0) / g,
                        i = ((Math.sin(e) * d.scaleX * g) | 0) / g,
                        j = ((Math.sin(f) * -d.scaleY * g) | 0) / g,
                        k = ((Math.cos(f) * d.scaleY * g) | 0) / g,
                        l = this.t.style,
                        m = this.t.currentStyle;
                    if (m) {
                        (c = i), (i = -j), (j = -c), (b = m.filter), (l.filter = "");
                        var n,
                            o,
                            q = this.t.offsetWidth,
                            r = this.t.offsetHeight,
                            s = "absolute" !== m.position,
                            t = "progid:DXImageTransform.Microsoft.Matrix(M11=" + h + ", M12=" + i + ", M21=" + j + ", M22=" + k,
                            u = d.x + (q * d.xPercent) / 100,
                            v = d.y + (r * d.yPercent) / 100;
                        if (
                            (null != d.ox && ((n = (d.oxp ? q * d.ox * 0.01 : d.ox) - q / 2), (o = (d.oyp ? r * d.oy * 0.01 : d.oy) - r / 2), (u += n - (n * h + o * i)), (v += o - (n * j + o * k))),
                            s ? ((n = q / 2), (o = r / 2), (t += ", Dx=" + (n - (n * h + o * i) + u) + ", Dy=" + (o - (n * j + o * k) + v) + ")")) : (t += ", sizingMethod='auto expand')"),
                            -1 !== b.indexOf("DXImageTransform.Microsoft.Matrix(") ? (l.filter = b.replace(H, t)) : (l.filter = t + " " + b),
                            (0 === a || 1 === a) &&
                                1 === h &&
                                0 === i &&
                                0 === j &&
                                1 === k &&
                                ((s && -1 === t.indexOf("Dx=0, Dy=0")) || (x.test(b) && 100 !== parseFloat(RegExp.$1)) || (-1 === b.indexOf(b.indexOf("Alpha")) && l.removeAttribute("filter"))),
                            !s)
                        ) {
                            var y,
                                z,
                                A,
                                B = 8 > p ? 1 : -1;
                            for (
                                n = d.ieOffsetX || 0,
                                    o = d.ieOffsetY || 0,
                                    d.ieOffsetX = Math.round((q - ((0 > h ? -h : h) * q + (0 > i ? -i : i) * r)) / 2 + u),
                                    d.ieOffsetY = Math.round((r - ((0 > k ? -k : k) * r + (0 > j ? -j : j) * q)) / 2 + v),
                                    wa = 0;
                                4 > wa;
                                wa++
                            )
                                (z = fa[wa]),
                                    (y = m[z]),
                                    (c = -1 !== y.indexOf("px") ? parseFloat(y) : aa(this.t, z, parseFloat(y), y.replace(w, "")) || 0),
                                    (A = c !== d[z] ? (2 > wa ? -d.ieOffsetX : -d.ieOffsetY) : 2 > wa ? n - d.ieOffsetX : o - d.ieOffsetY),
                                    (l[z] = (d[z] = Math.round(c - A * (0 === wa || 2 === wa ? 1 : B))) + "px");
                        }
                    }
                },
                Ta = (S.set3DTransformRatio = S.setTransformRatio = function (a) {
                    var b,
                        c,
                        d,
                        e,
                        f,
                        g,
                        h,
                        i,
                        j,
                        k,
                        l,
                        m,
                        o,
                        p,
                        q,
                        r,
                        s,
                        t,
                        u,
                        v,
                        w,
                        x,
                        y,
                        z = this.data,
                        A = this.t.style,
                        B = z.rotation,
                        C = z.rotationX,
                        D = z.rotationY,
                        E = z.scaleX,
                        F = z.scaleY,
                        G = z.scaleZ,
                        H = z.x,
                        I = z.y,
                        J = z.z,
                        L = z.svg,
                        M = z.perspective,
                        N = z.force3D,
                        O = z.skewY,
                        P = z.skewX;
                    if ((O && ((P += O), (B += O)), ((((1 === a || 0 === a) && "auto" === N && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime)) || !N) && !J && !M && !D && !C && 1 === G) || (Aa && L) || !Fa))
                        return void (B || P || L
                            ? ((B *= K),
                              (x = P * K),
                              (y = 1e5),
                              (c = Math.cos(B) * E),
                              (f = Math.sin(B) * E),
                              (d = Math.sin(B - x) * -F),
                              (g = Math.cos(B - x) * F),
                              x && "simple" === z.skewType && ((b = Math.tan(x - O * K)), (b = Math.sqrt(1 + b * b)), (d *= b), (g *= b), O && ((b = Math.tan(O * K)), (b = Math.sqrt(1 + b * b)), (c *= b), (f *= b))),
                              L &&
                                  ((H += z.xOrigin - (z.xOrigin * c + z.yOrigin * d) + z.xOffset),
                                  (I += z.yOrigin - (z.xOrigin * f + z.yOrigin * g) + z.yOffset),
                                  Aa && (z.xPercent || z.yPercent) && ((q = this.t.getBBox()), (H += 0.01 * z.xPercent * q.width), (I += 0.01 * z.yPercent * q.height)),
                                  (q = 1e-6),
                                  q > H && H > -q && (H = 0),
                                  q > I && I > -q && (I = 0)),
                              (u = ((c * y) | 0) / y + "," + ((f * y) | 0) / y + "," + ((d * y) | 0) / y + "," + ((g * y) | 0) / y + "," + H + "," + I + ")"),
                              L && Aa ? this.t.setAttribute("transform", "matrix(" + u) : (A[Ca] = (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix(" : "matrix(") + u))
                            : (A[Ca] = (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix(" : "matrix(") + E + ",0,0," + F + "," + H + "," + I + ")"));
                    if ((n && ((q = 1e-4), q > E && E > -q && (E = G = 2e-5), q > F && F > -q && (F = G = 2e-5), !M || z.z || z.rotationX || z.rotationY || (M = 0)), B || P))
                        (B *= K),
                            (r = c = Math.cos(B)),
                            (s = f = Math.sin(B)),
                            P &&
                                ((B -= P * K),
                                (r = Math.cos(B)),
                                (s = Math.sin(B)),
                                "simple" === z.skewType && ((b = Math.tan((P - O) * K)), (b = Math.sqrt(1 + b * b)), (r *= b), (s *= b), z.skewY && ((b = Math.tan(O * K)), (b = Math.sqrt(1 + b * b)), (c *= b), (f *= b)))),
                            (d = -s),
                            (g = r);
                    else {
                        if (!(D || C || 1 !== G || M || L))
                            return void (A[Ca] =
                                (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) translate3d(" : "translate3d(") +
                                H +
                                "px," +
                                I +
                                "px," +
                                J +
                                "px)" +
                                (1 !== E || 1 !== F ? " scale(" + E + "," + F + ")" : ""));
                        (c = g = 1), (d = f = 0);
                    }
                    (k = 1),
                        (e = h = i = j = l = m = 0),
                        (o = M ? -1 / M : 0),
                        (p = z.zOrigin),
                        (q = 1e-6),
                        (v = ","),
                        (w = "0"),
                        (B = D * K),
                        B && ((r = Math.cos(B)), (s = Math.sin(B)), (i = -s), (l = o * -s), (e = c * s), (h = f * s), (k = r), (o *= r), (c *= r), (f *= r)),
                        (B = C * K),
                        B && ((r = Math.cos(B)), (s = Math.sin(B)), (b = d * r + e * s), (t = g * r + h * s), (j = k * s), (m = o * s), (e = d * -s + e * r), (h = g * -s + h * r), (k *= r), (o *= r), (d = b), (g = t)),
                        1 !== G && ((e *= G), (h *= G), (k *= G), (o *= G)),
                        1 !== F && ((d *= F), (g *= F), (j *= F), (m *= F)),
                        1 !== E && ((c *= E), (f *= E), (i *= E), (l *= E)),
                        (p || L) &&
                            (p && ((H += e * -p), (I += h * -p), (J += k * -p + p)),
                            L && ((H += z.xOrigin - (z.xOrigin * c + z.yOrigin * d) + z.xOffset), (I += z.yOrigin - (z.xOrigin * f + z.yOrigin * g) + z.yOffset)),
                            q > H && H > -q && (H = w),
                            q > I && I > -q && (I = w),
                            q > J && J > -q && (J = 0)),
                        (u = z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix3d(" : "matrix3d("),
                        (u += (q > c && c > -q ? w : c) + v + (q > f && f > -q ? w : f) + v + (q > i && i > -q ? w : i)),
                        (u += v + (q > l && l > -q ? w : l) + v + (q > d && d > -q ? w : d) + v + (q > g && g > -q ? w : g)),
                        C || D || 1 !== G
                            ? ((u += v + (q > j && j > -q ? w : j) + v + (q > m && m > -q ? w : m) + v + (q > e && e > -q ? w : e)), (u += v + (q > h && h > -q ? w : h) + v + (q > k && k > -q ? w : k) + v + (q > o && o > -q ? w : o) + v))
                            : (u += ",0,0,0,0,1,0,"),
                        (u += H + v + I + v + J + v + (M ? 1 + -J / M : 1) + ")"),
                        (A[Ca] = u);
                });
            (j = Ga.prototype),
                (j.x = j.y = j.z = j.skewX = j.skewY = j.rotation = j.rotationX = j.rotationY = j.zOrigin = j.xPercent = j.yPercent = j.xOffset = j.yOffset = 0),
                (j.scaleX = j.scaleY = j.scaleZ = 1),
                ya(
                    "transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin",
                    {
                        parser: function (a, b, c, d, f, h, i) {
                            if (d._lastParsedTransform === i) return f;
                            d._lastParsedTransform = i;
                            var j,
                                k = i.scale && "function" == typeof i.scale ? i.scale : 0;
                            "function" == typeof i[c] && ((j = i[c]), (i[c] = b)), k && (i.scale = k(r, a));
                            var l,
                                m,
                                n,
                                o,
                                p,
                                s,
                                t,
                                u,
                                v,
                                w = a._gsTransform,
                                x = a.style,
                                y = 1e-6,
                                z = Ba.length,
                                A = i,
                                B = {},
                                C = "transformOrigin",
                                D = Ra(a, e, !0, A.parseTransform),
                                E = A.transform && ("function" == typeof A.transform ? A.transform(r, q) : A.transform);
                            if (((D.skewType = A.skewType || D.skewType || g.defaultSkewType), (d._transform = D), E && "string" == typeof E && Ca))
                                (m = Q.style),
                                    (m[Ca] = E),
                                    (m.display = "block"),
                                    (m.position = "absolute"),
                                    O.body.appendChild(Q),
                                    (l = Ra(Q, null, !1)),
                                    "simple" === D.skewType && (l.scaleY *= Math.cos(l.skewX * K)),
                                    D.svg &&
                                        ((s = D.xOrigin),
                                        (t = D.yOrigin),
                                        (l.x -= D.xOffset),
                                        (l.y -= D.yOffset),
                                        (A.transformOrigin || A.svgOrigin) &&
                                            ((E = {}), La(a, ha(A.transformOrigin), E, A.svgOrigin, A.smoothOrigin, !0), (s = E.xOrigin), (t = E.yOrigin), (l.x -= E.xOffset - D.xOffset), (l.y -= E.yOffset - D.yOffset)),
                                        (s || t) && ((u = Qa(Q, !0)), (l.x -= s - (s * u[0] + t * u[2])), (l.y -= t - (s * u[1] + t * u[3])))),
                                    O.body.removeChild(Q),
                                    l.perspective || (l.perspective = D.perspective),
                                    null != A.xPercent && (l.xPercent = ja(A.xPercent, D.xPercent)),
                                    null != A.yPercent && (l.yPercent = ja(A.yPercent, D.yPercent));
                            else if ("object" == typeof A) {
                                if (
                                    ((l = {
                                        scaleX: ja(null != A.scaleX ? A.scaleX : A.scale, D.scaleX),
                                        scaleY: ja(null != A.scaleY ? A.scaleY : A.scale, D.scaleY),
                                        scaleZ: ja(A.scaleZ, D.scaleZ),
                                        x: ja(A.x, D.x),
                                        y: ja(A.y, D.y),
                                        z: ja(A.z, D.z),
                                        xPercent: ja(A.xPercent, D.xPercent),
                                        yPercent: ja(A.yPercent, D.yPercent),
                                        perspective: ja(A.transformPerspective, D.perspective),
                                    }),
                                    (p = A.directionalRotation),
                                    null != p)
                                )
                                    if ("object" == typeof p) for (m in p) A[m] = p[m];
                                    else A.rotation = p;
                                "string" == typeof A.x && -1 !== A.x.indexOf("%") && ((l.x = 0), (l.xPercent = ja(A.x, D.xPercent))),
                                    "string" == typeof A.y && -1 !== A.y.indexOf("%") && ((l.y = 0), (l.yPercent = ja(A.y, D.yPercent))),
                                    (l.rotation = ka("rotation" in A ? A.rotation : "shortRotation" in A ? A.shortRotation + "_short" : "rotationZ" in A ? A.rotationZ : D.rotation, D.rotation, "rotation", B)),
                                    Fa &&
                                        ((l.rotationX = ka("rotationX" in A ? A.rotationX : "shortRotationX" in A ? A.shortRotationX + "_short" : D.rotationX || 0, D.rotationX, "rotationX", B)),
                                        (l.rotationY = ka("rotationY" in A ? A.rotationY : "shortRotationY" in A ? A.shortRotationY + "_short" : D.rotationY || 0, D.rotationY, "rotationY", B))),
                                    (l.skewX = ka(A.skewX, D.skewX)),
                                    (l.skewY = ka(A.skewY, D.skewY));
                            }
                            for (
                                Fa && null != A.force3D && ((D.force3D = A.force3D), (o = !0)),
                                    n = D.force3D || D.z || D.rotationX || D.rotationY || l.z || l.rotationX || l.rotationY || l.perspective,
                                    n || null == A.scale || (l.scaleZ = 1);
                                --z > -1;

                            )
                                (v = Ba[z]),
                                    (E = l[v] - D[v]),
                                    (E > y || -y > E || null != A[v] || null != M[v]) && ((o = !0), (f = new ta(D, v, D[v], E, f)), v in B && (f.e = B[v]), (f.xs0 = 0), (f.plugin = h), d._overwriteProps.push(f.n));
                            return (
                                (E = A.transformOrigin),
                                D.svg &&
                                    (E || A.svgOrigin) &&
                                    ((s = D.xOffset),
                                    (t = D.yOffset),
                                    La(a, ha(E), l, A.svgOrigin, A.smoothOrigin),
                                    (f = ua(D, "xOrigin", (w ? D : l).xOrigin, l.xOrigin, f, C)),
                                    (f = ua(D, "yOrigin", (w ? D : l).yOrigin, l.yOrigin, f, C)),
                                    (s !== D.xOffset || t !== D.yOffset) && ((f = ua(D, "xOffset", w ? s : D.xOffset, D.xOffset, f, C)), (f = ua(D, "yOffset", w ? t : D.yOffset, D.yOffset, f, C))),
                                    (E = "0px 0px")),
                                (E || (Fa && n && D.zOrigin)) &&
                                    (Ca
                                        ? ((o = !0),
                                          (v = Ea),
                                          (E = (E || _(a, v, e, !1, "50% 50%")) + ""),
                                          (f = new ta(x, v, 0, 0, f, -1, C)),
                                          (f.b = x[v]),
                                          (f.plugin = h),
                                          Fa
                                              ? ((m = D.zOrigin),
                                                (E = E.split(" ")),
                                                (D.zOrigin = (E.length > 2 && (0 === m || "0px" !== E[2]) ? parseFloat(E[2]) : m) || 0),
                                                (f.xs0 = f.e = E[0] + " " + (E[1] || "50%") + " 0px"),
                                                (f = new ta(D, "zOrigin", 0, 0, f, -1, f.n)),
                                                (f.b = m),
                                                (f.xs0 = f.e = D.zOrigin))
                                              : (f.xs0 = f.e = E))
                                        : ha(E + "", D)),
                                o && (d._transformType = (D.svg && Aa) || (!n && 3 !== this._transformType) ? 2 : 3),
                                j && (i[c] = j),
                                k && (i.scale = k),
                                f
                            );
                        },
                        prefix: !0,
                    }
                ),
                ya("boxShadow", { defaultValue: "0px 0px 0px 0px #999", prefix: !0, color: !0, multi: !0, keyword: "inset" }),
                ya("borderRadius", {
                    defaultValue: "0px",
                    parser: function (a, b, c, f, g, h) {
                        b = this.format(b);
                        var i,
                            j,
                            k,
                            l,
                            m,
                            n,
                            o,
                            p,
                            q,
                            r,
                            s,
                            t,
                            u,
                            v,
                            w,
                            x,
                            y = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
                            z = a.style;
                        for (q = parseFloat(a.offsetWidth), r = parseFloat(a.offsetHeight), i = b.split(" "), j = 0; j < y.length; j++)
                            this.p.indexOf("border") && (y[j] = Z(y[j])),
                                (m = l = _(a, y[j], e, !1, "0px")),
                                -1 !== m.indexOf(" ") && ((l = m.split(" ")), (m = l[0]), (l = l[1])),
                                (n = k = i[j]),
                                (o = parseFloat(m)),
                                (t = m.substr((o + "").length)),
                                (u = "=" === n.charAt(1)),
                                u ? ((p = parseInt(n.charAt(0) + "1", 10)), (n = n.substr(2)), (p *= parseFloat(n)), (s = n.substr((p + "").length - (0 > p ? 1 : 0)) || "")) : ((p = parseFloat(n)), (s = n.substr((p + "").length))),
                                "" === s && (s = d[c] || t),
                                s !== t &&
                                    ((v = aa(a, "borderLeft", o, t)),
                                    (w = aa(a, "borderTop", o, t)),
                                    "%" === s ? ((m = (v / q) * 100 + "%"), (l = (w / r) * 100 + "%")) : "em" === s ? ((x = aa(a, "borderLeft", 1, "em")), (m = v / x + "em"), (l = w / x + "em")) : ((m = v + "px"), (l = w + "px")),
                                    u && ((n = parseFloat(m) + p + s), (k = parseFloat(l) + p + s))),
                                (g = va(z, y[j], m + " " + l, n + " " + k, !1, "0px", g));
                        return g;
                    },
                    prefix: !0,
                    formatter: qa("0px 0px 0px 0px", !1, !0),
                }),
                ya("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {
                    defaultValue: "0px",
                    parser: function (a, b, c, d, f, g) {
                        return va(a.style, c, this.format(_(a, c, e, !1, "0px 0px")), this.format(b), !1, "0px", f);
                    },
                    prefix: !0,
                    formatter: qa("0px 0px", !1, !0),
                }),
                ya("backgroundPosition", {
                    defaultValue: "0 0",
                    parser: function (a, b, c, d, f, g) {
                        var h,
                            i,
                            j,
                            k,
                            l,
                            m,
                            n = "background-position",
                            o = e || $(a, null),
                            q = this.format((o ? (p ? o.getPropertyValue(n + "-x") + " " + o.getPropertyValue(n + "-y") : o.getPropertyValue(n)) : a.currentStyle.backgroundPositionX + " " + a.currentStyle.backgroundPositionY) || "0 0"),
                            r = this.format(b);
                        if ((-1 !== q.indexOf("%")) != (-1 !== r.indexOf("%")) && r.split(",").length < 2 && ((m = _(a, "backgroundImage").replace(D, "")), m && "none" !== m)) {
                            for (h = q.split(" "), i = r.split(" "), R.setAttribute("src", m), j = 2; --j > -1; )
                                (q = h[j]),
                                    (k = -1 !== q.indexOf("%")),
                                    k !== (-1 !== i[j].indexOf("%")) && ((l = 0 === j ? a.offsetWidth - R.width : a.offsetHeight - R.height), (h[j] = k ? (parseFloat(q) / 100) * l + "px" : (parseFloat(q) / l) * 100 + "%"));
                            q = h.join(" ");
                        }
                        return this.parseComplex(a.style, q, r, f, g);
                    },
                    formatter: ha,
                }),
                ya("backgroundSize", {
                    defaultValue: "0 0",
                    formatter: function (a) {
                        return (a += ""), ha(-1 === a.indexOf(" ") ? a + " " + a : a);
                    },
                }),
                ya("perspective", { defaultValue: "0px", prefix: !0 }),
                ya("perspectiveOrigin", { defaultValue: "50% 50%", prefix: !0 }),
                ya("transformStyle", { prefix: !0 }),
                ya("backfaceVisibility", { prefix: !0 }),
                ya("userSelect", { prefix: !0 }),
                ya("margin", { parser: ra("marginTop,marginRight,marginBottom,marginLeft") }),
                ya("padding", { parser: ra("paddingTop,paddingRight,paddingBottom,paddingLeft") }),
                ya("clip", {
                    defaultValue: "rect(0px,0px,0px,0px)",
                    parser: function (a, b, c, d, f, g) {
                        var h, i, j;
                        return (
                            9 > p
                                ? ((i = a.currentStyle), (j = 8 > p ? " " : ","), (h = "rect(" + i.clipTop + j + i.clipRight + j + i.clipBottom + j + i.clipLeft + ")"), (b = this.format(b).split(",").join(j)))
                                : ((h = this.format(_(a, this.p, e, !1, this.dflt))), (b = this.format(b))),
                            this.parseComplex(a.style, h, b, f, g)
                        );
                    },
                }),
                ya("textShadow", { defaultValue: "0px 0px 0px #999", color: !0, multi: !0 }),
                ya("autoRound,strictUnits", {
                    parser: function (a, b, c, d, e) {
                        return e;
                    },
                }),
                ya("border", {
                    defaultValue: "0px solid #000",
                    parser: function (a, b, c, d, f, g) {
                        var h = _(a, "borderTopWidth", e, !1, "0px"),
                            i = this.format(b).split(" "),
                            j = i[0].replace(w, "");
                        return (
                            "px" !== j && (h = parseFloat(h) / aa(a, "borderTopWidth", 1, j) + j),
                            this.parseComplex(a.style, this.format(h + " " + _(a, "borderTopStyle", e, !1, "solid") + " " + _(a, "borderTopColor", e, !1, "#000")), i.join(" "), f, g)
                        );
                    },
                    color: !0,
                    formatter: function (a) {
                        var b = a.split(" ");
                        return b[0] + " " + (b[1] || "solid") + " " + (a.match(pa) || ["#000"])[0];
                    },
                }),
                ya("borderWidth", { parser: ra("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth") }),
                ya("float,cssFloat,styleFloat", {
                    parser: function (a, b, c, d, e, f) {
                        var g = a.style,
                            h = "cssFloat" in g ? "cssFloat" : "styleFloat";
                        return new ta(g, h, 0, 0, e, -1, c, !1, 0, g[h], b);
                    },
                });
            var Ua = function (a) {
                var b,
                    c = this.t,
                    d = c.filter || _(this.data, "filter") || "",
                    e = (this.s + this.c * a) | 0;
                100 === e && (-1 === d.indexOf("atrix(") && -1 === d.indexOf("radient(") && -1 === d.indexOf("oader(") ? (c.removeAttribute("filter"), (b = !_(this.data, "filter"))) : ((c.filter = d.replace(z, "")), (b = !0))),
                    b || (this.xn1 && (c.filter = d = d || "alpha(opacity=" + e + ")"), -1 === d.indexOf("pacity") ? (0 === e && this.xn1) || (c.filter = d + " alpha(opacity=" + e + ")") : (c.filter = d.replace(x, "opacity=" + e)));
            };
            ya("opacity,alpha,autoAlpha", {
                defaultValue: "1",
                parser: function (a, b, c, d, f, g) {
                    var h = parseFloat(_(a, "opacity", e, !1, "1")),
                        i = a.style,
                        j = "autoAlpha" === c;
                    return (
                        "string" == typeof b && "=" === b.charAt(1) && (b = ("-" === b.charAt(0) ? -1 : 1) * parseFloat(b.substr(2)) + h),
                        j && 1 === h && "hidden" === _(a, "visibility", e) && 0 !== b && (h = 0),
                        U
                            ? (f = new ta(i, "opacity", h, b - h, f))
                            : ((f = new ta(i, "opacity", 100 * h, 100 * (b - h), f)),
                              (f.xn1 = j ? 1 : 0),
                              (i.zoom = 1),
                              (f.type = 2),
                              (f.b = "alpha(opacity=" + f.s + ")"),
                              (f.e = "alpha(opacity=" + (f.s + f.c) + ")"),
                              (f.data = a),
                              (f.plugin = g),
                              (f.setRatio = Ua)),
                        j && ((f = new ta(i, "visibility", 0, 0, f, -1, null, !1, 0, 0 !== h ? "inherit" : "hidden", 0 === b ? "hidden" : "inherit")), (f.xs0 = "inherit"), d._overwriteProps.push(f.n), d._overwriteProps.push(c)),
                        f
                    );
                },
            });
            var Va = function (a, b) {
                    b && (a.removeProperty ? (("ms" === b.substr(0, 2) || "webkit" === b.substr(0, 6)) && (b = "-" + b), a.removeProperty(b.replace(B, "-$1").toLowerCase())) : a.removeAttribute(b));
                },
                Wa = function (a) {
                    if (((this.t._gsClassPT = this), 1 === a || 0 === a)) {
                        this.t.setAttribute("class", 0 === a ? this.b : this.e);
                        for (var b = this.data, c = this.t.style; b; ) b.v ? (c[b.p] = b.v) : Va(c, b.p), (b = b._next);
                        1 === a && this.t._gsClassPT === this && (this.t._gsClassPT = null);
                    } else this.t.getAttribute("class") !== this.e && this.t.setAttribute("class", this.e);
                };
            ya("className", {
                parser: function (a, b, d, f, g, h, i) {
                    var j,
                        k,
                        l,
                        m,
                        n,
                        o = a.getAttribute("class") || "",
                        p = a.style.cssText;
                    if (((g = f._classNamePT = new ta(a, d, 0, 0, g, 2)), (g.setRatio = Wa), (g.pr = -11), (c = !0), (g.b = o), (k = ca(a, e)), (l = a._gsClassPT))) {
                        for (m = {}, n = l.data; n; ) (m[n.p] = 1), (n = n._next);
                        l.setRatio(1);
                    }
                    return (
                        (a._gsClassPT = g),
                        (g.e = "=" !== b.charAt(1) ? b : o.replace(new RegExp("(?:\\s|^)" + b.substr(2) + "(?![\\w-])"), "") + ("+" === b.charAt(0) ? " " + b.substr(2) : "")),
                        a.setAttribute("class", g.e),
                        (j = da(a, k, ca(a), i, m)),
                        a.setAttribute("class", o),
                        (g.data = j.firstMPT),
                        (a.style.cssText = p),
                        (g = g.xfirst = f.parse(a, j.difs, g, h))
                    );
                },
            });
            var Xa = function (a) {
                if ((1 === a || 0 === a) && this.data._totalTime === this.data._totalDuration && "isFromStart" !== this.data.data) {
                    var b,
                        c,
                        d,
                        e,
                        f,
                        g = this.t.style,
                        h = i.transform.parse;
                    if ("all" === this.e) (g.cssText = ""), (e = !0);
                    else for (b = this.e.split(" ").join("").split(","), d = b.length; --d > -1; ) (c = b[d]), i[c] && (i[c].parse === h ? (e = !0) : (c = "transformOrigin" === c ? Ea : i[c].p)), Va(g, c);
                    e && (Va(g, Ca), (f = this.t._gsTransform), f && (f.svg && (this.t.removeAttribute("data-svg-origin"), this.t.removeAttribute("transform")), delete this.t._gsTransform));
                }
            };
            for (
                ya("clearProps", {
                    parser: function (a, b, d, e, f) {
                        return (f = new ta(a, d, 0, 0, f, 2)), (f.setRatio = Xa), (f.e = b), (f.pr = -10), (f.data = e._tween), (c = !0), f;
                    },
                }),
                    j = "bezier,throwProps,physicsProps,physics2D".split(","),
                    wa = j.length;
                wa--;

            )
                za(j[wa]);
            (j = g.prototype),
                (j._firstPT = j._lastParsedTransform = j._transform = null),
                (j._onInitTween = function (a, b, h, j) {
                    if (!a.nodeType) return !1;
                    (this._target = q = a), (this._tween = h), (this._vars = b), (r = j), (k = b.autoRound), (c = !1), (d = b.suffixMap || g.suffixMap), (e = $(a, "")), (f = this._overwriteProps);
                    var n,
                        p,
                        s,
                        t,
                        u,
                        v,
                        w,
                        x,
                        z,
                        A = a.style;
                    if (
                        (l && "" === A.zIndex && ((n = _(a, "zIndex", e)), ("auto" === n || "" === n) && this._addLazySet(A, "zIndex", 0)),
                        "string" == typeof b && ((t = A.cssText), (n = ca(a, e)), (A.cssText = t + ";" + b), (n = da(a, n, ca(a)).difs), !U && y.test(b) && (n.opacity = parseFloat(RegExp.$1)), (b = n), (A.cssText = t)),
                        b.className ? (this._firstPT = p = i.className.parse(a, b.className, "className", this, null, null, b)) : (this._firstPT = p = this.parse(a, b, null)),
                        this._transformType)
                    ) {
                        for (
                            z = 3 === this._transformType,
                                Ca
                                    ? m &&
                                      ((l = !0),
                                      "" === A.zIndex && ((w = _(a, "zIndex", e)), ("auto" === w || "" === w) && this._addLazySet(A, "zIndex", 0)),
                                      o && this._addLazySet(A, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (z ? "visible" : "hidden")))
                                    : (A.zoom = 1),
                                s = p;
                            s && s._next;

                        )
                            s = s._next;
                        (x = new ta(a, "transform", 0, 0, null, 2)), this._linkCSSP(x, null, s), (x.setRatio = Ca ? Ta : Sa), (x.data = this._transform || Ra(a, e, !0)), (x.tween = h), (x.pr = -1), f.pop();
                    }
                    if (c) {
                        for (; p; ) {
                            for (v = p._next, s = t; s && s.pr > p.pr; ) s = s._next;
                            (p._prev = s ? s._prev : u) ? (p._prev._next = p) : (t = p), (p._next = s) ? (s._prev = p) : (u = p), (p = v);
                        }
                        this._firstPT = t;
                    }
                    return !0;
                }),
                (j.parse = function (a, b, c, f) {
                    var g,
                        h,
                        j,
                        l,
                        m,
                        n,
                        o,
                        p,
                        s,
                        t,
                        u = a.style;
                    for (g in b) {
                        if (((n = b[g]), "function" == typeof n && (n = n(r, q)), (h = i[g]))) c = h.parse(a, n, g, this, c, f, b);
                        else {
                            if ("--" === g.substr(0, 2)) {
                                this._tween._propLookup[g] = this._addTween.call(this._tween, a.style, "setProperty", $(a).getPropertyValue(g) + "", n + "", g, !1, g);
                                continue;
                            }
                            (m = _(a, g, e) + ""),
                                (s = "string" == typeof n),
                                "color" === g || "fill" === g || "stroke" === g || -1 !== g.indexOf("Color") || (s && A.test(n))
                                    ? (s || ((n = na(n)), (n = (n.length > 3 ? "rgba(" : "rgb(") + n.join(",") + ")")), (c = va(u, g, m, n, !0, "transparent", c, 0, f)))
                                    : s && J.test(n)
                                    ? (c = va(u, g, m, n, !0, null, c, 0, f))
                                    : ((j = parseFloat(m)),
                                      (o = j || 0 === j ? m.substr((j + "").length) : ""),
                                      ("" === m || "auto" === m) &&
                                          ("width" === g || "height" === g ? ((j = ga(a, g, e)), (o = "px")) : "left" === g || "top" === g ? ((j = ba(a, g, e)), (o = "px")) : ((j = "opacity" !== g ? 0 : 1), (o = ""))),
                                      (t = s && "=" === n.charAt(1)),
                                      t ? ((l = parseInt(n.charAt(0) + "1", 10)), (n = n.substr(2)), (l *= parseFloat(n)), (p = n.replace(w, ""))) : ((l = parseFloat(n)), (p = s ? n.replace(w, "") : "")),
                                      "" === p && (p = g in d ? d[g] : o),
                                      (n = l || 0 === l ? (t ? l + j : l) + p : b[g]),
                                      o !== p &&
                                          ("" !== p || "lineHeight" === g) &&
                                          (l || 0 === l) &&
                                          j &&
                                          ((j = aa(a, g, j, o)),
                                          "%" === p
                                              ? ((j /= aa(a, g, 100, "%") / 100), b.strictUnits !== !0 && (m = j + "%"))
                                              : "em" === p || "rem" === p || "vw" === p || "vh" === p
                                              ? (j /= aa(a, g, 1, p))
                                              : "px" !== p && ((l = aa(a, g, l, p)), (p = "px")),
                                          t && (l || 0 === l) && (n = l + j + p)),
                                      t && (l += j),
                                      (!j && 0 !== j) || (!l && 0 !== l)
                                          ? void 0 !== u[g] && (n || (n + "" != "NaN" && null != n))
                                              ? ((c = new ta(u, g, l || j || 0, 0, c, -1, g, !1, 0, m, n)), (c.xs0 = "none" !== n || ("display" !== g && -1 === g.indexOf("Style")) ? n : m))
                                              : W("invalid " + g + " tween value: " + b[g])
                                          : ((c = new ta(u, g, j, l - j, c, 0, g, k !== !1 && ("px" === p || "zIndex" === g), 0, m, n)), (c.xs0 = p)));
                        }
                        f && c && !c.plugin && (c.plugin = f);
                    }
                    return c;
                }),
                (j.setRatio = function (a) {
                    var b,
                        c,
                        d,
                        e = this._firstPT,
                        f = 1e-6;
                    if (1 !== a || (this._tween._time !== this._tween._duration && 0 !== this._tween._time))
                        if (a || (this._tween._time !== this._tween._duration && 0 !== this._tween._time) || this._tween._rawPrevTime === -1e-6)
                            for (; e; ) {
                                if (((b = e.c * a + e.s), e.r ? (b = Math.round(b)) : f > b && b > -f && (b = 0), e.type))
                                    if (1 === e.type)
                                        if (((d = e.l), 2 === d)) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2;
                                        else if (3 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3;
                                        else if (4 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3 + e.xn3 + e.xs4;
                                        else if (5 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3 + e.xn3 + e.xs4 + e.xn4 + e.xs5;
                                        else {
                                            for (c = e.xs0 + b + e.xs1, d = 1; d < e.l; d++) c += e["xn" + d] + e["xs" + (d + 1)];
                                            e.t[e.p] = c;
                                        }
                                    else -1 === e.type ? (e.t[e.p] = e.xs0) : e.setRatio && e.setRatio(a);
                                else e.t[e.p] = b + e.xs0;
                                e = e._next;
                            }
                        else for (; e; ) 2 !== e.type ? (e.t[e.p] = e.b) : e.setRatio(a), (e = e._next);
                    else
                        for (; e; ) {
                            if (2 !== e.type)
                                if (e.r && -1 !== e.type)
                                    if (((b = Math.round(e.s + e.c)), e.type)) {
                                        if (1 === e.type) {
                                            for (d = e.l, c = e.xs0 + b + e.xs1, d = 1; d < e.l; d++) c += e["xn" + d] + e["xs" + (d + 1)];
                                            e.t[e.p] = c;
                                        }
                                    } else e.t[e.p] = b + e.xs0;
                                else e.t[e.p] = e.e;
                            else e.setRatio(a);
                            e = e._next;
                        }
                }),
                (j._enableTransforms = function (a) {
                    (this._transform = this._transform || Ra(this._target, e, !0)), (this._transformType = (this._transform.svg && Aa) || (!a && 3 !== this._transformType) ? 2 : 3);
                });
            var Ya = function (a) {
                (this.t[this.p] = this.e), this.data._linkCSSP(this, this._next, null, !0);
            };
            (j._addLazySet = function (a, b, c) {
                var d = (this._firstPT = new ta(a, b, 0, 0, this._firstPT, 2));
                (d.e = c), (d.setRatio = Ya), (d.data = this);
            }),
                (j._linkCSSP = function (a, b, c, d) {
                    return (
                        a &&
                            (b && (b._prev = a),
                            a._next && (a._next._prev = a._prev),
                            a._prev ? (a._prev._next = a._next) : this._firstPT === a && ((this._firstPT = a._next), (d = !0)),
                            c ? (c._next = a) : d || null !== this._firstPT || (this._firstPT = a),
                            (a._next = b),
                            (a._prev = c)),
                        a
                    );
                }),
                (j._mod = function (a) {
                    for (var b = this._firstPT; b; ) "function" == typeof a[b.p] && a[b.p] === Math.round && (b.r = 1), (b = b._next);
                }),
                (j._kill = function (b) {
                    var c,
                        d,
                        e,
                        f = b;
                    if (b.autoAlpha || b.alpha) {
                        f = {};
                        for (d in b) f[d] = b[d];
                        (f.opacity = 1), f.autoAlpha && (f.visibility = 1);
                    }
                    for (
                        b.className &&
                            (c = this._classNamePT) &&
                            ((e = c.xfirst),
                            e && e._prev ? this._linkCSSP(e._prev, c._next, e._prev._prev) : e === this._firstPT && (this._firstPT = c._next),
                            c._next && this._linkCSSP(c._next, c._next._next, e._prev),
                            (this._classNamePT = null)),
                            c = this._firstPT;
                        c;

                    )
                        c.plugin && c.plugin !== d && c.plugin._kill && (c.plugin._kill(b), (d = c.plugin)), (c = c._next);
                    return a.prototype._kill.call(this, f);
                });
            var Za = function (a, b, c) {
                var d, e, f, g;
                if (a.slice) for (e = a.length; --e > -1; ) Za(a[e], b, c);
                else for (d = a.childNodes, e = d.length; --e > -1; ) (f = d[e]), (g = f.type), f.style && (b.push(ca(f)), c && c.push(f)), (1 !== g && 9 !== g && 11 !== g) || !f.childNodes.length || Za(f, b, c);
            };
            return (
                (g.cascadeTo = function (a, c, d) {
                    var e,
                        f,
                        g,
                        h,
                        i = b.to(a, c, d),
                        j = [i],
                        k = [],
                        l = [],
                        m = [],
                        n = b._internals.reservedProps;
                    for (a = i._targets || i.target, Za(a, k, m), i.render(c, !0, !0), Za(a, l), i.render(0, !0, !0), i._enabled(!0), e = m.length; --e > -1; )
                        if (((f = da(m[e], k[e], l[e])), f.firstMPT)) {
                            f = f.difs;
                            for (g in d) n[g] && (f[g] = d[g]);
                            h = {};
                            for (g in f) h[g] = k[e][g];
                            j.push(b.fromTo(m[e], c, h, f));
                        }
                    return j;
                }),
                a.activate([g]),
                g
            );
        },
        !0
    );
}),
    _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
    (function (a) {
        "use strict";
        var b = function () {
            return (_gsScope.GreenSockGlobals || _gsScope)[a];
        };
        "undefined" != typeof module && module.exports ? (require("../TweenLite.min.js"), (module.exports = b())) : "function" == typeof define && define.amd && define(["TweenLite"], b);
    })("CSSPlugin");
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
    "use strict";
    _gsScope._gsDefine(
        "utils.Draggable",
        ["events.EventDispatcher", "TweenLite", "plugins.CSSPlugin"],
        function (a, b, c) {
            var d,
                e,
                f,
                g,
                h,
                i,
                j,
                k,
                l,
                m = { css: {}, data: "_draggable" },
                n = { css: {}, data: "_draggable" },
                o = { css: {}, data: "_draggable" },
                p = { css: {} },
                q = _gsScope._gsDefine.globals,
                r = {},
                s = { style: {} },
                t = _gsScope.document || {
                    createElement: function () {
                        return s;
                    },
                },
                u = t.documentElement || {},
                v = function (a) {
                    return t.createElementNS ? t.createElementNS("http://www.w3.org/1999/xhtml", a) : t.createElement(a);
                },
                w = v("div"),
                x = [],
                y = function () {
                    return !1;
                },
                z = 180 / Math.PI,
                A = 999999999999999,
                B =
                    Date.now ||
                    function () {
                        return new Date().getTime();
                    },
                C = !(t.addEventListener || !t.all),
                D = t.createElement("div"),
                E = [],
                F = {},
                G = 0,
                H = /^(?:a|input|textarea|button|select)$/i,
                I = 0,
                J = _gsScope.navigator && -1 !== _gsScope.navigator.userAgent.toLowerCase().indexOf("android"),
                K = 0,
                L = {},
                M = {},
                N = function (a) {
                    if (("string" == typeof a && (a = b.selector(a)), !a || a.nodeType)) return [a];
                    var c,
                        d = [],
                        e = a.length;
                    for (c = 0; c !== e; d.push(a[c++]));
                    return d;
                },
                O = function (a, b) {
                    var c,
                        d = {};
                    if (b) for (c in a) d[c] = a[c] * b;
                    else for (c in a) d[c] = a[c];
                    return d;
                },
                P = function () {
                    for (var a = E.length; --a > -1; ) E[a]();
                },
                Q = function (a) {
                    E.push(a), 1 === E.length && b.ticker.addEventListener("tick", P, this, !1, 1);
                },
                R = function (a) {
                    for (var c = E.length; --c > -1; ) E[c] === a && E.splice(c, 1);
                    b.to(S, 0, { overwrite: "all", delay: 15, onComplete: S, data: "_draggable" });
                },
                S = function () {
                    E.length || b.ticker.removeEventListener("tick", P);
                },
                T = function (a, b) {
                    var c;
                    for (c in b) void 0 === a[c] && (a[c] = b[c]);
                    return a;
                },
                U = function () {
                    return null != window.pageYOffset ? window.pageYOffset : null != t.scrollTop ? t.scrollTop : u.scrollTop || t.body.scrollTop || 0;
                },
                V = function () {
                    return null != window.pageXOffset ? window.pageXOffset : null != t.scrollLeft ? t.scrollLeft : u.scrollLeft || t.body.scrollLeft || 0;
                },
                W = function (a, b) {
                    Ja(a, "scroll", b), Y(a.parentNode) || W(a.parentNode, b);
                },
                X = function (a, b) {
                    Ka(a, "scroll", b), Y(a.parentNode) || X(a.parentNode, b);
                },
                Y = function (a) {
                    return !(a && a !== u && a !== t && a !== t.body && a !== window && a.nodeType && a.parentNode);
                },
                Z = function (a, b) {
                    var c = "x" === b ? "Width" : "Height",
                        d = "scroll" + c,
                        e = "client" + c,
                        f = t.body;
                    return Math.max(0, Y(a) ? Math.max(u[d], f[d]) - (window["inner" + c] || u[e] || f[e]) : a[d] - a[e]);
                },
                $ = function (a) {
                    var b = Y(a),
                        c = Z(a, "x"),
                        d = Z(a, "y");
                    b ? (a = M) : $(a.parentNode), (a._gsMaxScrollX = c), (a._gsMaxScrollY = d), (a._gsScrollX = a.scrollLeft || 0), (a._gsScrollY = a.scrollTop || 0);
                },
                _ = function (a, b) {
                    return (a = a || window.event), (r.pageX = a.clientX + t.body.scrollLeft + u.scrollLeft), (r.pageY = a.clientY + t.body.scrollTop + u.scrollTop), b && (a.returnValue = !1), r;
                },
                aa = function (a) {
                    return a ? ("string" == typeof a && (a = b.selector(a)), a.length && a !== window && a[0] && a[0].style && !a.nodeType && (a = a[0]), a === window || (a.nodeType && a.style) ? a : null) : a;
                },
                ba = function (a, b) {
                    var c,
                        e,
                        f,
                        g = a.style;
                    if (void 0 === g[b]) {
                        for (f = ["O", "Moz", "ms", "Ms", "Webkit"], e = 5, c = b.charAt(0).toUpperCase() + b.substr(1); --e > -1 && void 0 === g[f[e] + c]; );
                        if (0 > e) return "";
                        (d = 3 === e ? "ms" : f[e]), (b = d + c);
                    }
                    return b;
                },
                ca = function (a, b, c) {
                    var d = a.style;
                    d && (void 0 === d[b] && (b = ba(a, b)), null == c ? (d.removeProperty ? d.removeProperty(b.replace(/([A-Z])/g, "-$1").toLowerCase()) : d.removeAttribute(b)) : void 0 !== d[b] && (d[b] = c));
                },
                da = t.defaultView ? t.defaultView.getComputedStyle : y,
                ea = /(?:Left|Right|Width)/i,
                fa = /(?:\d|\-|\+|=|#|\.)*/g,
                ga = function (a, b, c, d, e) {
                    if ("px" === d || !d) return c;
                    if ("auto" === d || !c) return 0;
                    var f,
                        g = ea.test(b),
                        h = a,
                        i = w.style,
                        j = 0 > c;
                    return (
                        j && (c = -c),
                        "%" === d && -1 !== b.indexOf("border")
                            ? (f = (c / 100) * (g ? a.clientWidth : a.clientHeight))
                            : ((i.cssText = "border:0 solid red;position:" + ia(a, "position", !0) + ";line-height:0;"),
                              "%" !== d && h.appendChild ? (i[g ? "borderLeftWidth" : "borderTopWidth"] = c + d) : ((h = a.parentNode || t.body), (i[g ? "width" : "height"] = c + d)),
                              h.appendChild(w),
                              (f = parseFloat(w[g ? "offsetWidth" : "offsetHeight"])),
                              h.removeChild(w),
                              0 !== f || e || (f = ga(a, b, c, d, !0))),
                        j ? -f : f
                    );
                },
                ha = function (a, b) {
                    if ("absolute" !== ia(a, "position", !0)) return 0;
                    var c = "left" === b ? "Left" : "Top",
                        d = ia(a, "margin" + c, !0);
                    return a["offset" + c] - (ga(a, b, parseFloat(d), (d + "").replace(fa, "")) || 0);
                },
                ia = function (a, b, c) {
                    var d,
                        e = (a._gsTransform || {})[b];
                    return e || 0 === e
                        ? e
                        : (a.style[b] ? (e = a.style[b]) : (d = da(a)) ? ((e = d.getPropertyValue(b.replace(/([A-Z])/g, "-$1").toLowerCase())), (e = e || d.length ? e : d[b])) : a.currentStyle && (e = a.currentStyle[b]),
                          "auto" !== e || ("top" !== b && "left" !== b) || (e = ha(a, b)),
                          c ? e : parseFloat(e) || 0);
                },
                ja = function (a, b, c) {
                    var d = a.vars,
                        e = d[c],
                        f = a._listeners[b];
                    "function" == typeof e && e.apply(d[c + "Scope"] || d.callbackScope || a, d[c + "Params"] || [a.pointerEvent]), f && a.dispatchEvent(b);
                },
                ka = function (a, b) {
                    var c,
                        d,
                        e,
                        f = aa(a);
                    return f
                        ? Ea(f, b)
                        : void 0 !== a.left
                        ? ((e = ya(b)), { left: a.left - e.x, top: a.top - e.y, width: a.width, height: a.height })
                        : ((d = a.min || a.minX || a.minRotation || 0), (c = a.min || a.minY || 0), { left: d, top: c, width: (a.max || a.maxX || a.maxRotation || 0) - d, height: (a.max || a.maxY || 0) - c });
                },
                la = function () {
                    if (!t.createElementNS) return (g = 0), void (h = !1);
                    var a,
                        b,
                        c,
                        d,
                        e = v("div"),
                        f = t.createElementNS("http://www.w3.org/2000/svg", "svg"),
                        l = v("div"),
                        m = e.style,
                        n = t.body || u,
                        o = "flex" === ia(n, "display", !0);
                    t.body &&
                        oa &&
                        ((m.position = "absolute"),
                        n.appendChild(l),
                        l.appendChild(e),
                        (d = e.offsetParent),
                        (l.style[oa] = "rotate(1deg)"),
                        (k = e.offsetParent === d),
                        (l.style.position = "absolute"),
                        (m.height = "10px"),
                        (d = e.offsetTop),
                        (l.style.border = "5px solid red"),
                        (j = d !== e.offsetTop),
                        n.removeChild(l)),
                        (m = f.style),
                        f.setAttributeNS(null, "width", "400px"),
                        f.setAttributeNS(null, "height", "400px"),
                        f.setAttributeNS(null, "viewBox", "0 0 400 400"),
                        (m.display = "block"),
                        (m.boxSizing = "border-box"),
                        (m.border = "0px solid red"),
                        (m.transform = "none"),
                        (e.style.cssText = "width:100px;height:100px;overflow:scroll;-ms-overflow-style:none;"),
                        n.appendChild(e),
                        e.appendChild(f),
                        (c = f.createSVGPoint().matrixTransform(f.getScreenCTM())),
                        (b = c.y),
                        (e.scrollTop = 100),
                        (c.x = c.y = 0),
                        (c = c.matrixTransform(f.getScreenCTM())),
                        (i = b - c.y < 100.1 ? 0 : b - c.y - 150),
                        e.removeChild(f),
                        n.removeChild(e),
                        n.appendChild(f),
                        o && (n.style.display = "block"),
                        (a = f.getScreenCTM()),
                        (b = a.e),
                        (m.border = "50px solid red"),
                        (a = f.getScreenCTM()),
                        0 === b && 0 === a.e && 0 === a.f && 1 === a.a ? ((g = 1), (h = !0)) : ((g = b !== a.e ? 1 : 0), (h = 1 !== a.a)),
                        o && (n.style.display = "flex"),
                        n.removeChild(f);
                },
                ma = "" !== ba(w, "perspective"),
                na = ba(w, "transformOrigin")
                    .replace(/^ms/g, "Ms")
                    .replace(/([A-Z])/g, "-$1")
                    .toLowerCase(),
                oa = ba(w, "transform"),
                pa = oa
                    .replace(/^ms/g, "Ms")
                    .replace(/([A-Z])/g, "-$1")
                    .toLowerCase(),
                qa = {},
                ra = {},
                sa = _gsScope.SVGElement,
                ta = function (a) {
                    return !!(sa && "function" == typeof a.getBBox && a.getCTM && (!a.parentNode || (a.parentNode.getBBox && a.parentNode.getCTM)));
                },
                ua = (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(navigator.userAgent) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(navigator.userAgent)) && parseFloat(RegExp.$1) < 11,
                va = [],
                wa = [],
                xa = function (a) {
                    if (!a.getBoundingClientRect || !a.parentNode || !oa) return { offsetTop: 0, offsetLeft: 0, scaleX: 1, scaleY: 1, offsetParent: u };
                    if (Ta.cacheSVGData !== !1 && a._dCache && a._dCache.lastUpdate === b.ticker.frame) return a._dCache;
                    var c,
                        d,
                        e,
                        f,
                        j,
                        k,
                        l,
                        m,
                        n,
                        o,
                        p,
                        q,
                        r = a,
                        s = za(a);
                    if (((s.lastUpdate = b.ticker.frame), a.getBBox && !s.isSVGRoot)) {
                        for (r = a.parentNode, c = a.getBBox(); r && "svg" !== (r.nodeName + "").toLowerCase(); ) r = r.parentNode;
                        return (f = xa(r)), (s.offsetTop = c.y * f.scaleY), (s.offsetLeft = c.x * f.scaleX), (s.scaleX = f.scaleX), (s.scaleY = f.scaleY), (s.offsetParent = r || u), s;
                    }
                    for (
                        e = s.offsetParent, e === t.body && (e = u), wa.length = va.length = 0;
                        r && ((j = ia(r, oa, !0)), "matrix(1, 0, 0, 1, 0, 0)" !== j && "none" !== j && "translate3d(0px, 0px, 0px)" !== j && (wa.push(r), va.push(r.style[oa]), (r.style[oa] = "none")), r !== e);

                    )
                        r = r.parentNode;
                    for (
                        d = e.getBoundingClientRect(),
                            j = a.getScreenCTM(),
                            m = a.createSVGPoint(),
                            l = m.matrixTransform(j),
                            m.x = m.y = 10,
                            m = m.matrixTransform(j),
                            s.scaleX = (m.x - l.x) / 10,
                            s.scaleY = (m.y - l.y) / 10,
                            void 0 === g && la(),
                            s.borderBox &&
                                !h &&
                                a.getAttribute("width") &&
                                ((f = da(a) || {}),
                                (n = parseFloat(f.borderLeftWidth) + parseFloat(f.borderRightWidth) || 0),
                                (o = parseFloat(f.borderTopWidth) + parseFloat(f.borderBottomWidth) || 0),
                                (p = parseFloat(f.width) || 0),
                                (q = parseFloat(f.height) || 0),
                                (s.scaleX *= (p - n) / p),
                                (s.scaleY *= (q - o) / q)),
                            i ? ((c = a.getBoundingClientRect()), (s.offsetLeft = c.left - d.left), (s.offsetTop = c.top - d.top)) : ((s.offsetLeft = l.x - d.left), (s.offsetTop = l.y - d.top)),
                            s.offsetParent = e,
                            k = wa.length;
                        --k > -1;

                    )
                        wa[k].style[oa] = va[k];
                    return s;
                },
                ya = function (a, c) {
                    if (((c = c || {}), !a || a === u || !a.parentNode || a === window)) return { x: 0, y: 0 };
                    var d = da(a),
                        e = na && d ? d.getPropertyValue(na) : "50% 50%",
                        f = e.split(" "),
                        g = -1 !== e.indexOf("left") ? "0%" : -1 !== e.indexOf("right") ? "100%" : f[0],
                        h = -1 !== e.indexOf("top") ? "0%" : -1 !== e.indexOf("bottom") ? "100%" : f[1];
                    return (
                        ("center" === h || null == h) && (h = "50%"),
                        ("center" === g || isNaN(parseFloat(g))) && (g = "50%"),
                        a.getBBox && ta(a)
                            ? (a._gsTransform || (b.set(a, { x: "+=0", overwrite: !1 }), void 0 === a._gsTransform.xOrigin && console.log("Draggable requires at least GSAP 1.17.0")),
                              (e = a.getBBox()),
                              (c.x = a._gsTransform.xOrigin - e.x),
                              (c.y = a._gsTransform.yOrigin - e.y))
                            : (a.getBBox && -1 !== (g + h).indexOf("%") && ((a = a.getBBox()), (a = { offsetWidth: a.width, offsetHeight: a.height })),
                              (c.x = -1 !== g.indexOf("%") ? (a.offsetWidth * parseFloat(g)) / 100 : parseFloat(g)),
                              (c.y = -1 !== h.indexOf("%") ? (a.offsetHeight * parseFloat(h)) / 100 : parseFloat(h))),
                        c
                    );
                },
                za = function (a) {
                    if (Ta.cacheSVGData !== !1 && a._dCache && a._dCache.lastUpdate === b.ticker.frame) return a._dCache;
                    var c,
                        d = (a._dCache = a._dCache || {}),
                        e = da(a),
                        f = a.getBBox && ta(a),
                        g = "svg" === (a.nodeName + "").toLowerCase();
                    if (((d.isSVG = f), (d.isSVGRoot = g), (d.borderBox = "border-box" === e.boxSizing), (d.computedStyle = e), g)) (c = a.parentNode || u), c.insertBefore(w, a), (d.offsetParent = w.offsetParent || u), c.removeChild(w);
                    else if (f) {
                        for (c = a.parentNode; c && "svg" !== (c.nodeName + "").toLowerCase(); ) c = c.parentNode;
                        d.offsetParent = c;
                    } else d.offsetParent = a.offsetParent;
                    return d;
                },
                Aa = function (a, b, c, d, e) {
                    if (a === window || !a || !a.style || !a.parentNode) return [1, 0, 0, 1, 0, 0];
                    var f,
                        h,
                        i,
                        l,
                        m,
                        n,
                        o,
                        p,
                        q,
                        r,
                        s,
                        v,
                        w,
                        x,
                        y = a._dCache || za(a),
                        z = a.parentNode,
                        A = z._dCache || za(z),
                        B = y.computedStyle,
                        C = y.isSVG ? A.offsetParent : z.offsetParent;
                    return (
                        (f = y.isSVG && -1 !== (a.style[oa] + "").indexOf("matrix") ? a.style[oa] : B ? B.getPropertyValue(pa) : a.currentStyle ? a.currentStyle[oa] : "1,0,0,1,0,0"),
                        a.getBBox && -1 !== (a.getAttribute("transform") + "").indexOf("matrix") && (f = a.getAttribute("transform")),
                        (f = (f + "").match(/(?:\-|\.|\b)(\d|\.|e\-)+/g) || [1, 0, 0, 1, 0, 0]),
                        f.length > 6 && (f = [f[0], f[1], f[4], f[5], f[12], f[13]]),
                        d
                            ? (f[4] = f[5] = 0)
                            : y.isSVG &&
                              (m = a._gsTransform) &&
                              (m.xOrigin || m.yOrigin) &&
                              ((f[0] = parseFloat(f[0])),
                              (f[1] = parseFloat(f[1])),
                              (f[2] = parseFloat(f[2])),
                              (f[3] = parseFloat(f[3])),
                              (f[4] = parseFloat(f[4]) - (m.xOrigin - (m.xOrigin * f[0] + m.yOrigin * f[2]))),
                              (f[5] = parseFloat(f[5]) - (m.yOrigin - (m.xOrigin * f[1] + m.yOrigin * f[3])))),
                        b &&
                            (void 0 === g && la(),
                            (i = y.isSVG || y.isSVGRoot ? xa(a) : a),
                            y.isSVG
                                ? ((l = a.getBBox()), (r = A.isSVGRoot ? { x: 0, y: 0 } : z.getBBox()), (i = { offsetLeft: l.x - r.x, offsetTop: l.y - r.y, offsetParent: y.offsetParent }))
                                : y.isSVGRoot
                                ? ((s = parseInt(B.borderTopWidth, 10) || 0),
                                  (v = parseInt(B.borderLeftWidth, 10) || 0),
                                  (w = (f[0] - g) * v + f[2] * s),
                                  (x = f[1] * v + (f[3] - g) * s),
                                  (n = b.x),
                                  (o = b.y),
                                  (p = n - (n * f[0] + o * f[2])),
                                  (q = o - (n * f[1] + o * f[3])),
                                  (f[4] = parseFloat(f[4]) + p),
                                  (f[5] = parseFloat(f[5]) + q),
                                  (b.x -= p),
                                  (b.y -= q),
                                  (n = i.scaleX),
                                  (o = i.scaleY),
                                  e || ((b.x *= n), (b.y *= o)),
                                  (f[0] *= n),
                                  (f[1] *= o),
                                  (f[2] *= n),
                                  (f[3] *= o),
                                  ua || ((b.x += w), (b.y += x)),
                                  C === t.body && i.offsetParent === u && (C = u))
                                : !j && a.offsetParent && ((b.x += parseInt(ia(a.offsetParent, "borderLeftWidth"), 10) || 0), (b.y += parseInt(ia(a.offsetParent, "borderTopWidth"), 10) || 0)),
                            (h = z === u || z === t.body),
                            (f[4] = Number(f[4]) + b.x + (i.offsetLeft || 0) - c.x - (h ? 0 : z.scrollLeft || 0)),
                            (f[5] = Number(f[5]) + b.y + (i.offsetTop || 0) - c.y - (h ? 0 : z.scrollTop || 0)),
                            z && "fixed" === ia(a, "position", B) && ((f[4] += V()), (f[5] += U())),
                            !z ||
                                z === u ||
                                C !== i.offsetParent ||
                                A.isSVG ||
                                (k && "100100" !== Aa(z).join("")) ||
                                ((i = A.isSVGRoot ? xa(z) : z),
                                (f[4] -= i.offsetLeft || 0),
                                (f[5] -= i.offsetTop || 0),
                                j || !A.offsetParent || y.isSVG || y.isSVGRoot || ((f[4] -= parseInt(ia(A.offsetParent, "borderLeftWidth"), 10) || 0), (f[5] -= parseInt(ia(A.offsetParent, "borderTopWidth"), 10) || 0)))),
                        f
                    );
                },
                Ba = function (a, b) {
                    if (!a || a === window || !a.parentNode) return [1, 0, 0, 1, 0, 0];
                    for (var c, d, e, f, g, h, i, j, k = ya(a, qa), l = ya(a.parentNode, ra), m = Aa(a, k, l, !1, !b); (a = a.parentNode) && a.parentNode && a !== u; )
                        (k = l),
                            (l = ya(a.parentNode, k === qa ? ra : qa)),
                            (i = Aa(a, k, l)),
                            (c = m[0]),
                            (d = m[1]),
                            (e = m[2]),
                            (f = m[3]),
                            (g = m[4]),
                            (h = m[5]),
                            (m[0] = c * i[0] + d * i[2]),
                            (m[1] = c * i[1] + d * i[3]),
                            (m[2] = e * i[0] + f * i[2]),
                            (m[3] = e * i[1] + f * i[3]),
                            (m[4] = g * i[0] + h * i[2] + i[4]),
                            (m[5] = g * i[1] + h * i[3] + i[5]);
                    return (
                        b &&
                            ((c = m[0]),
                            (d = m[1]),
                            (e = m[2]),
                            (f = m[3]),
                            (g = m[4]),
                            (h = m[5]),
                            (j = c * f - d * e),
                            (m[0] = f / j),
                            (m[1] = -d / j),
                            (m[2] = -e / j),
                            (m[3] = c / j),
                            (m[4] = (e * h - f * g) / j),
                            (m[5] = -(c * h - d * g) / j)),
                        m
                    );
                },
                Ca = function (a, b, c, d, e) {
                    a = aa(a);
                    var f = Ba(a, !1, e),
                        g = b.x,
                        h = b.y;
                    return c && (ya(a, b), (g -= b.x), (h -= b.y)), (d = d === !0 ? b : d || {}), (d.x = g * f[0] + h * f[2] + f[4]), (d.y = g * f[1] + h * f[3] + f[5]), d;
                },
                Da = function (a, b, c) {
                    var d = a.x * b[0] + a.y * b[2] + b[4],
                        e = a.x * b[1] + a.y * b[3] + b[5];
                    return (a.x = d * c[0] + e * c[2] + c[4]), (a.y = d * c[1] + e * c[3] + c[5]), a;
                },
                Ea = function (a, b, c) {
                    if (!(a = aa(a))) return null;
                    b = aa(b);
                    var d,
                        e,
                        f,
                        g,
                        h,
                        i,
                        j,
                        k,
                        l,
                        m,
                        n,
                        o,
                        p,
                        q,
                        r,
                        s,
                        v,
                        w,
                        x,
                        y,
                        z,
                        A,
                        B = a.getBBox && ta(a);
                    if (a === window)
                        (g = U()), (e = V()), (f = e + (u.clientWidth || a.innerWidth || t.body.clientWidth || 0)), (h = g + ((a.innerHeight || 0) - 20 < u.clientHeight ? u.clientHeight : a.innerHeight || t.body.clientHeight || 0));
                    else {
                        if (void 0 === b || b === window) return a.getBoundingClientRect();
                        (d = ya(a)),
                            (e = -d.x),
                            (g = -d.y),
                            B
                                ? ((o = a.getBBox()), (p = o.width), (q = o.height))
                                : "svg" !== (a.nodeName + "").toLowerCase() && a.offsetWidth
                                ? ((p = a.offsetWidth), (q = a.offsetHeight))
                                : ((z = da(a)), (p = parseFloat(z.width)), (q = parseFloat(z.height))),
                            (f = e + p),
                            (h = g + q),
                            "svg" !== a.nodeName.toLowerCase() ||
                                C ||
                                ((r = xa(a)),
                                (A = r.computedStyle || {}),
                                (w = (a.getAttribute("viewBox") || "0 0").split(" ")),
                                (x = parseFloat(w[0])),
                                (y = parseFloat(w[1])),
                                (s = parseFloat(A.borderLeftWidth) || 0),
                                (v = parseFloat(A.borderTopWidth) || 0),
                                (f -= p - (p - s) / r.scaleX - x),
                                (h -= q - (q - v) / r.scaleY - y),
                                (e -= s / r.scaleX - x),
                                (g -= v / r.scaleY - y),
                                z && ((f += (parseFloat(A.borderRightWidth) + s) / r.scaleX), (h += (v + parseFloat(A.borderBottomWidth)) / r.scaleY)));
                    }
                    return a === b
                        ? { left: e, top: g, width: f - e, height: h - g }
                        : ((i = Ba(a)),
                          (j = Ba(b, !0)),
                          (k = Da({ x: e, y: g }, i, j)),
                          (l = Da({ x: f, y: g }, i, j)),
                          (m = Da({ x: f, y: h }, i, j)),
                          (n = Da({ x: e, y: h }, i, j)),
                          (e = Math.min(k.x, l.x, m.x, n.x)),
                          (g = Math.min(k.y, l.y, m.y, n.y)),
                          (L.x = L.y = 0),
                          c && ya(b, L),
                          { left: e + L.x, top: g + L.y, width: Math.max(k.x, l.x, m.x, n.x) - e, height: Math.max(k.y, l.y, m.y, n.y) - g });
                },
                Fa = function (a) {
                    return !!(a && a.length && a[0] && ((a[0].nodeType && a[0].style && !a.nodeType) || (a[0].length && a[0][0])));
                },
                Ga = function (a) {
                    var b,
                        c,
                        d,
                        e = [],
                        f = a.length;
                    for (b = 0; f > b; b++)
                        if (((c = a[b]), Fa(c))) for (d = c.length, d = 0; d < c.length; d++) e.push(c[d]);
                        else c && 0 !== c.length && e.push(c);
                    return e;
                },
                Ha = "ontouchstart" in u && "orientation" in window,
                Ia = (function (a) {
                    for (
                        var b = a.split(","),
                            c = (void 0 !== w.onpointerdown ? "pointerdown,pointermove,pointerup,pointercancel" : void 0 !== w.onmspointerdown ? "MSPointerDown,MSPointerMove,MSPointerUp,MSPointerCancel" : a).split(","),
                            d = {},
                            e = 4;
                        --e > -1;

                    )
                        (d[b[e]] = c[e]), (d[c[e]] = b[e]);
                    return d;
                })("touchstart,touchmove,touchend,touchcancel"),
                Ja = function (a, b, c, d) {
                    a.addEventListener ? (a.addEventListener(Ia[b], c, d), b !== Ia[b] && a.addEventListener(b, c, d)) : a.attachEvent && a.attachEvent("on" + b, c);
                },
                Ka = function (a, b, c) {
                    a.removeEventListener ? (a.removeEventListener(Ia[b], c), b !== Ia[b] && a.removeEventListener(b, c)) : a.detachEvent && a.detachEvent("on" + b, c);
                },
                La = function (a, b) {
                    for (var c = a.length; --c > -1; ) if (a[c].identifier === b) return !0;
                    return !1;
                },
                Ma = function (a) {
                    (e = a.touches && I < a.touches.length), Ka(a.target, "touchend", Ma);
                },
                Na = function (a) {
                    (e = a.touches && I < a.touches.length), Ja(a.target, "touchend", Ma);
                },
                Oa = function (a, b, c, d, e, f) {
                    var g,
                        h,
                        i,
                        j = {};
                    if (b)
                        if (1 !== e && b instanceof Array) {
                            if (((j.end = g = []), (i = b.length), "object" == typeof b[0])) for (h = 0; i > h; h++) g[h] = O(b[h], e);
                            else for (h = 0; i > h; h++) g[h] = b[h] * e;
                            (c += 1.1), (d -= 1.1);
                        } else
                            "function" == typeof b
                                ? (j.end = function (c) {
                                      var d,
                                          f,
                                          g = b.call(a, c);
                                      if (1 !== e)
                                          if ("object" == typeof g) {
                                              d = {};
                                              for (f in g) d[f] = g[f] * e;
                                              g = d;
                                          } else g *= e;
                                      return g;
                                  })
                                : (j.end = b);
                    return (c || 0 === c) && (j.max = c), (d || 0 === d) && (j.min = d), f && (j.velocity = 0), j;
                },
                Pa = function (a) {
                    var b;
                    return (
                        !(!a || !a.getAttribute || "BODY" === a.nodeName) &&
                        (!("true" !== (b = a.getAttribute("data-clickable")) && ("false" === b || (!a.onclick && !H.test(a.nodeName + "") && "true" !== a.getAttribute("contentEditable")))) || Pa(a.parentNode))
                    );
                },
                Qa = function (a, b) {
                    for (var c, d = a.length; --d > -1; ) (c = a[d]), (c.ondragstart = c.onselectstart = b ? null : y), ca(c, "userSelect", b ? "text" : "none");
                },
                Ra = (function () {
                    var a,
                        b = t.createElement("div"),
                        c = t.createElement("div"),
                        d = c.style,
                        e = t.body || w;
                    return (
                        (d.display = "inline-block"),
                        (d.position = "relative"),
                        (b.style.cssText = c.innerHTML = "width:90px; height:40px; padding:10px; overflow:auto; visibility: hidden"),
                        b.appendChild(c),
                        e.appendChild(b),
                        (l = c.offsetHeight + 18 > b.scrollHeight),
                        (d.width = "100%"),
                        oa || ((d.paddingRight = "500px"), (a = b.scrollLeft = b.scrollWidth - b.clientWidth), (d.left = "-90px"), (a = a !== b.scrollLeft)),
                        e.removeChild(b),
                        a
                    );
                })(),
                Sa = function (a, c) {
                    (a = aa(a)), (c = c || {});
                    var d,
                        e,
                        f,
                        g,
                        h,
                        i,
                        j = t.createElement("div"),
                        k = j.style,
                        m = a.firstChild,
                        n = 0,
                        o = 0,
                        p = a.scrollTop,
                        q = a.scrollLeft,
                        r = a.scrollWidth,
                        s = a.scrollHeight,
                        u = 0,
                        v = 0,
                        w = 0;
                    ma && c.force3D !== !1 ? ((h = "translate3d("), (i = "px,0px)")) : oa && ((h = "translate("), (i = "px)")),
                        (this.scrollTop = function (a, b) {
                            return arguments.length ? void this.top(-a, b) : -this.top();
                        }),
                        (this.scrollLeft = function (a, b) {
                            return arguments.length ? void this.left(-a, b) : -this.left();
                        }),
                        (this.left = function (d, e) {
                            if (!arguments.length) return -(a.scrollLeft + o);
                            var f = a.scrollLeft - q,
                                g = o;
                            return (f > 2 || -2 > f) && !e
                                ? ((q = a.scrollLeft), b.killTweensOf(this, !0, { left: 1, scrollLeft: 1 }), this.left(-q), void (c.onKill && c.onKill()))
                                : ((d = -d),
                                  0 > d ? ((o = (d - 0.5) | 0), (d = 0)) : d > v ? ((o = (d - v) | 0), (d = v)) : (o = 0),
                                  (o || g) && (h ? this._suspendTransforms || (k[oa] = h + -o + "px," + -n + i) : (k.left = -o + "px"), Ra && o + u >= 0 && (k.paddingRight = o + u + "px")),
                                  (a.scrollLeft = 0 | d),
                                  void (q = a.scrollLeft));
                        }),
                        (this.top = function (d, e) {
                            if (!arguments.length) return -(a.scrollTop + n);
                            var f = a.scrollTop - p,
                                g = n;
                            return (f > 2 || -2 > f) && !e
                                ? ((p = a.scrollTop), b.killTweensOf(this, !0, { top: 1, scrollTop: 1 }), this.top(-p), void (c.onKill && c.onKill()))
                                : ((d = -d),
                                  0 > d ? ((n = (d - 0.5) | 0), (d = 0)) : d > w ? ((n = (d - w) | 0), (d = w)) : (n = 0),
                                  (n || g) && (h ? this._suspendTransforms || (k[oa] = h + -o + "px," + -n + i) : (k.top = -n + "px")),
                                  (a.scrollTop = 0 | d),
                                  void (p = a.scrollTop));
                        }),
                        (this.maxScrollTop = function () {
                            return w;
                        }),
                        (this.maxScrollLeft = function () {
                            return v;
                        }),
                        (this.disable = function () {
                            for (m = j.firstChild; m; ) (g = m.nextSibling), a.appendChild(m), (m = g);
                            a === j.parentNode && a.removeChild(j);
                        }),
                        (this.enable = function () {
                            if (((m = a.firstChild), m !== j)) {
                                for (; m; ) (g = m.nextSibling), j.appendChild(m), (m = g);
                                a.appendChild(j), this.calibrate();
                            }
                        }),
                        (this.calibrate = function (b) {
                            var c,
                                g,
                                h = a.clientWidth === d;
                            (p = a.scrollTop),
                                (q = a.scrollLeft),
                                (!h || a.clientHeight !== e || j.offsetHeight !== f || r !== a.scrollWidth || s !== a.scrollHeight || b) &&
                                    ((n || o) && ((c = this.left()), (g = this.top()), this.left(-a.scrollLeft), this.top(-a.scrollTop)),
                                    (!h || b) && ((k.display = "block"), (k.width = "auto"), (k.paddingRight = "0px"), (u = Math.max(0, a.scrollWidth - a.clientWidth)), u && (u += ia(a, "paddingLeft") + (l ? ia(a, "paddingRight") : 0))),
                                    (k.display = "inline-block"),
                                    (k.position = "relative"),
                                    (k.overflow = "visible"),
                                    (k.verticalAlign = "top"),
                                    (k.width = "100%"),
                                    (k.paddingRight = u + "px"),
                                    l && (k.paddingBottom = ia(a, "paddingBottom", !0)),
                                    C && (k.zoom = "1"),
                                    (d = a.clientWidth),
                                    (e = a.clientHeight),
                                    (r = a.scrollWidth),
                                    (s = a.scrollHeight),
                                    (v = a.scrollWidth - d),
                                    (w = a.scrollHeight - e),
                                    (f = j.offsetHeight),
                                    (k.display = "block"),
                                    (c || g) && (this.left(c), this.top(g)));
                        }),
                        (this.content = j),
                        (this.element = a),
                        (this._suspendTransforms = !1),
                        this.enable();
                },
                Ta = function (d, g) {
                    a.call(this, d),
                        (d = aa(d)),
                        f || (f = q.com.greensock.plugins.ThrowPropsPlugin),
                        (this.vars = g = O(g || {})),
                        (this.target = d),
                        (this.x = this.y = this.rotation = 0),
                        (this.dragResistance = parseFloat(g.dragResistance) || 0),
                        (this.edgeResistance = isNaN(g.edgeResistance) ? 1 : parseFloat(g.edgeResistance) || 0),
                        (this.lockAxis = g.lockAxis),
                        (this.autoScroll = g.autoScroll || 0),
                        (this.lockedAxis = null),
                        (this.allowEventDefault = !!g.allowEventDefault);
                    var h,
                        i,
                        j,
                        k,
                        l,
                        r,
                        s,
                        v,
                        w,
                        y,
                        E,
                        H,
                        P,
                        S,
                        U,
                        V,
                        Z,
                        ba,
                        da,
                        ea,
                        fa,
                        ga,
                        ha,
                        la,
                        ma,
                        na,
                        oa,
                        pa,
                        qa,
                        ra,
                        sa,
                        ua,
                        va,
                        wa,
                        xa = (g.type || (C ? "top,left" : "x,y")).toLowerCase(),
                        ya = -1 !== xa.indexOf("x") || -1 !== xa.indexOf("y"),
                        za = -1 !== xa.indexOf("rotation"),
                        Aa = za ? "rotation" : ya ? "x" : "left",
                        Da = ya ? "y" : "top",
                        Ea = -1 !== xa.indexOf("x") || -1 !== xa.indexOf("left") || "scroll" === xa,
                        Fa = -1 !== xa.indexOf("y") || -1 !== xa.indexOf("top") || "scroll" === xa,
                        Ga = g.minimumMovement || 2,
                        Ma = this,
                        Ra = N(g.trigger || g.handle || d),
                        Ua = {},
                        Va = 0,
                        Wa = !1,
                        Ya = g.autoScrollMarginTop || 40,
                        Za = g.autoScrollMarginRight || 40,
                        $a = g.autoScrollMarginBottom || 40,
                        _a = g.autoScrollMarginLeft || 40,
                        ab = g.clickableTest || Pa,
                        bb = 0,
                        cb = function (a) {
                            return Ma.isPressed && a.which < 2 ? void Ma.endDrag() : (a.preventDefault(), a.stopPropagation(), !1);
                        },
                        db = function (a) {
                            if (Ma.autoScroll && Ma.isDragging && (Wa || ba)) {
                                var b,
                                    c,
                                    e,
                                    f,
                                    g,
                                    h,
                                    j,
                                    k,
                                    l = d,
                                    m = 15 * Ma.autoScroll;
                                for (
                                    Wa = !1,
                                        M.scrollTop = null != window.pageYOffset ? window.pageYOffset : null != u.scrollTop ? u.scrollTop : t.body.scrollTop,
                                        M.scrollLeft = null != window.pageXOffset ? window.pageXOffset : null != u.scrollLeft ? u.scrollLeft : t.body.scrollLeft,
                                        f = Ma.pointerX - M.scrollLeft,
                                        g = Ma.pointerY - M.scrollTop;
                                    l && !c;

                                )
                                    (c = Y(l.parentNode)),
                                        (b = c ? M : l.parentNode),
                                        (e = c ? { bottom: Math.max(u.clientHeight, window.innerHeight || 0), right: Math.max(u.clientWidth, window.innerWidth || 0), left: 0, top: 0 } : b.getBoundingClientRect()),
                                        (h = j = 0),
                                        Fa &&
                                            ((k = b._gsMaxScrollY - b.scrollTop),
                                            0 > k
                                                ? (j = k)
                                                : g > e.bottom - $a && k
                                                ? ((Wa = !0), (j = Math.min(k, (m * (1 - Math.max(0, e.bottom - g) / $a)) | 0)))
                                                : g < e.top + Ya && b.scrollTop && ((Wa = !0), (j = -Math.min(b.scrollTop, (m * (1 - Math.max(0, g - e.top) / Ya)) | 0))),
                                            j && (b.scrollTop += j)),
                                        Ea &&
                                            ((k = b._gsMaxScrollX - b.scrollLeft),
                                            0 > k
                                                ? (h = k)
                                                : f > e.right - Za && k
                                                ? ((Wa = !0), (h = Math.min(k, (m * (1 - Math.max(0, e.right - f) / Za)) | 0)))
                                                : f < e.left + _a && b.scrollLeft && ((Wa = !0), (h = -Math.min(b.scrollLeft, (m * (1 - Math.max(0, f - e.left) / _a)) | 0))),
                                            h && (b.scrollLeft += h)),
                                        c && (h || j) && (window.scrollTo(b.scrollLeft, b.scrollTop), rb(Ma.pointerX + h, Ma.pointerY + j)),
                                        (l = b);
                            }
                            if (ba) {
                                var n = Ma.x,
                                    o = Ma.y,
                                    p = 1e-6;
                                p > n && n > -p && (n = 0),
                                    p > o && o > -p && (o = 0),
                                    za
                                        ? ((Ma.deltaX = n - qa.data.rotation), (qa.data.rotation = Ma.rotation = n), qa.setRatio(1))
                                        : i
                                        ? (Fa && ((Ma.deltaY = o - i.top()), i.top(o)), Ea && ((Ma.deltaX = n - i.left()), i.left(n)))
                                        : ya
                                        ? (Fa && ((Ma.deltaY = o - qa.data.y), (qa.data.y = o)), Ea && ((Ma.deltaX = n - qa.data.x), (qa.data.x = n)), qa.setRatio(1))
                                        : (Fa && ((Ma.deltaY = o - parseFloat(d.style.top || 0)), (d.style.top = o + "px")), Ea && ((Ma.deltaY = n - parseFloat(d.style.left || 0)), (d.style.left = n + "px"))),
                                    !v || a || ua || ((ua = !0), ja(Ma, "drag", "onDrag"), (ua = !1));
                            }
                            ba = !1;
                        },
                        eb = function (a, c) {
                            var e,
                                f = Ma.x,
                                g = Ma.y;
                            d._gsTransform || (!ya && !za) || b.set(d, { x: "+=0", overwrite: !1, data: "_draggable" }),
                                ya
                                    ? ((Ma.y = d._gsTransform.y), (Ma.x = d._gsTransform.x))
                                    : za
                                    ? (Ma.x = Ma.rotation = d._gsTransform.rotation)
                                    : i
                                    ? ((Ma.y = i.top()), (Ma.x = i.left()))
                                    : ((Ma.y = parseInt(d.style.top, 10) || 0), (Ma.x = parseInt(d.style.left, 10) || 0)),
                                (ea || fa || ga) &&
                                    !c &&
                                    (Ma.isDragging || Ma.isThrowing) &&
                                    (ga && ((L.x = Ma.x), (L.y = Ma.y), (e = ga(L)), e.x !== Ma.x && ((Ma.x = e.x), (ba = !0)), e.y !== Ma.y && ((Ma.y = e.y), (ba = !0))),
                                    ea && ((e = ea(Ma.x)), e !== Ma.x && ((Ma.x = e), za && (Ma.rotation = e), (ba = !0))),
                                    fa && ((e = fa(Ma.y)), e !== Ma.y && (Ma.y = e), (ba = !0))),
                                ba && db(!0),
                                a || ((Ma.deltaX = Ma.x - f), (Ma.deltaY = Ma.y - g), ja(Ma, "throwupdate", "onThrowUpdate"));
                        },
                        fb = function () {
                            var a, b, c, e;
                            (s = !1),
                                i
                                    ? (i.calibrate(), (Ma.minX = y = -i.maxScrollLeft()), (Ma.minY = H = -i.maxScrollTop()), (Ma.maxX = w = Ma.maxY = E = 0), (s = !0))
                                    : g.bounds &&
                                      ((a = ka(g.bounds, d.parentNode)),
                                      za
                                          ? ((Ma.minX = y = a.left), (Ma.maxX = w = a.left + a.width), (Ma.minY = H = Ma.maxY = E = 0))
                                          : void 0 !== g.bounds.maxX || void 0 !== g.bounds.maxY
                                          ? ((a = g.bounds), (Ma.minX = y = a.minX), (Ma.minY = H = a.minY), (Ma.maxX = w = a.maxX), (Ma.maxY = E = a.maxY))
                                          : ((b = ka(d, d.parentNode)),
                                            (Ma.minX = y = ia(d, Aa) + a.left - b.left),
                                            (Ma.minY = H = ia(d, Da) + a.top - b.top),
                                            (Ma.maxX = w = y + (a.width - b.width)),
                                            (Ma.maxY = E = H + (a.height - b.height))),
                                      y > w && ((Ma.minX = w), (Ma.maxX = w = y), (y = Ma.minX)),
                                      H > E && ((Ma.minY = E), (Ma.maxY = E = H), (H = Ma.minY)),
                                      za && ((Ma.minRotation = y), (Ma.maxRotation = w)),
                                      (s = !0)),
                                g.liveSnap &&
                                    ((c = g.liveSnap === !0 ? g.snap || {} : g.liveSnap),
                                    (e = c instanceof Array || "function" == typeof c),
                                    za
                                        ? ((ea = nb(e ? c : c.rotation, y, w, 1)), (fa = null))
                                        : c.points
                                        ? (ga = ob(e ? c : c.points, y, w, H, E, c.radius, i ? -1 : 1))
                                        : (Ea && (ea = nb(e ? c : c.x || c.left || c.scrollLeft, y, w, i ? -1 : 1)), Fa && (fa = nb(e ? c : c.y || c.top || c.scrollTop, H, E, i ? -1 : 1))));
                        },
                        gb = function () {
                            (Ma.isThrowing = !1), ja(Ma, "throwcomplete", "onThrowComplete");
                        },
                        hb = function () {
                            Ma.isThrowing = !1;
                        },
                        ib = function (a, b) {
                            var c, e, h, j;
                            a && f
                                ? (a === !0 &&
                                      ((c = g.snap || g.liveSnap || {}),
                                      (e = c instanceof Array || "function" == typeof c),
                                      (a = { resistance: (g.throwResistance || g.resistance || 1e3) / (za ? 10 : 1) }),
                                      za
                                          ? (a.rotation = Oa(Ma, e ? c : c.rotation, w, y, 1, b))
                                          : (Ea && (a[Aa] = Oa(Ma, e ? c : c.points || c.x || c.left || c.scrollLeft, w, y, i ? -1 : 1, b || "x" === Ma.lockedAxis)),
                                            Fa && (a[Da] = Oa(Ma, e ? c : c.points || c.y || c.top || c.scrollTop, E, H, i ? -1 : 1, b || "y" === Ma.lockedAxis)),
                                            (c.points || (c instanceof Array && "object" == typeof c[0])) && ((a.linkedProps = Aa + "," + Da), (a.radius = c.radius)))),
                                  (Ma.isThrowing = !0),
                                  (j = isNaN(g.overshootTolerance) ? (1 === g.edgeResistance ? 0 : 1 - Ma.edgeResistance + 0.2) : g.overshootTolerance),
                                  (Ma.tween = h = f.to(
                                      i || d,
                                      {
                                          throwProps: a,
                                          data: "_draggable",
                                          ease: g.ease || q.Power3.easeOut,
                                          onComplete: gb,
                                          onOverwrite: hb,
                                          onUpdate: g.fastMode ? ja : eb,
                                          onUpdateParams: g.fastMode ? [Ma, "onthrowupdate", "onThrowUpdate"] : c && c.radius ? [!1, !0] : x,
                                      },
                                      isNaN(g.maxDuration) ? 2 : g.maxDuration,
                                      isNaN(g.minDuration) ? (0 === j || ("object" == typeof a && a.resistance > 1e3) ? 0 : 0.5) : g.minDuration,
                                      j
                                  )),
                                  g.fastMode ||
                                      (i && (i._suspendTransforms = !0),
                                      h.render(h.duration(), !0, !0),
                                      eb(!0, !0),
                                      (Ma.endX = Ma.x),
                                      (Ma.endY = Ma.y),
                                      za && (Ma.endRotation = Ma.x),
                                      h.play(0),
                                      eb(!0, !0),
                                      i && (i._suspendTransforms = !1)))
                                : s && Ma.applyBounds();
                        },
                        jb = function (a) {
                            var b,
                                c,
                                e,
                                f,
                                g,
                                h,
                                i,
                                l,
                                m,
                                n = ma || [1, 0, 0, 1, 0, 0];
                            (ma = Ba(d.parentNode, !0)),
                                a &&
                                    Ma.isPressed &&
                                    n.join(",") !== ma.join(",") &&
                                    ((b = n[0]),
                                    (c = n[1]),
                                    (e = n[2]),
                                    (f = n[3]),
                                    (g = n[4]),
                                    (h = n[5]),
                                    (i = b * f - c * e),
                                    (l = j * (f / i) + k * (-e / i) + (e * h - f * g) / i),
                                    (m = j * (-c / i) + k * (b / i) + -(b * h - c * g) / i),
                                    (k = l * ma[1] + m * ma[3] + ma[5]),
                                    (j = l * ma[0] + m * ma[2] + ma[4])),
                                ma[1] || ma[2] || 1 != ma[0] || 1 != ma[3] || 0 != ma[4] || 0 != ma[5] || (ma = null);
                        },
                        kb = function () {
                            var a = 1 - Ma.edgeResistance;
                            jb(!1),
                                ma && ((j = Ma.pointerX * ma[0] + Ma.pointerY * ma[2] + ma[4]), (k = Ma.pointerX * ma[1] + Ma.pointerY * ma[3] + ma[5])),
                                ba && (rb(Ma.pointerX, Ma.pointerY), db(!0)),
                                i
                                    ? (fb(), (r = i.top()), (l = i.left()))
                                    : (lb() ? (eb(!0, !0), fb()) : Ma.applyBounds(),
                                      za
                                          ? ((Z = Ma.rotationOrigin = Ca(d, { x: 0, y: 0 })), eb(!0, !0), (l = Ma.x), (r = Ma.y = Math.atan2(Z.y - Ma.pointerY, Ma.pointerX - Z.x) * z))
                                          : ((oa = d.parentNode ? d.parentNode.scrollTop || 0 : 0), (pa = d.parentNode ? d.parentNode.scrollLeft || 0 : 0), (r = ia(d, Da)), (l = ia(d, Aa)))),
                                s && a && (l > w ? (l = w + (l - w) / a) : y > l && (l = y - (y - l) / a), za || (r > E ? (r = E + (r - E) / a) : H > r && (r = H - (H - r) / a))),
                                (Ma.startX = l),
                                (Ma.startY = r);
                        },
                        lb = function () {
                            return Ma.tween && Ma.tween.isActive();
                        },
                        mb = function () {
                            !D.parentNode || lb() || Ma.isDragging || D.parentNode.removeChild(D);
                        },
                        nb = function (a, b, c, d) {
                            return "function" == typeof a
                                ? function (e) {
                                      var f = Ma.isPressed ? 1 - Ma.edgeResistance : 1;
                                      return a.call(Ma, e > c ? c + (e - c) * f : b > e ? b + (e - b) * f : e) * d;
                                  }
                                : a instanceof Array
                                ? function (d) {
                                      for (var e, f, g = a.length, h = 0, i = A; --g > -1; ) (e = a[g]), (f = e - d), 0 > f && (f = -f), i > f && e >= b && c >= e && ((h = g), (i = f));
                                      return a[h];
                                  }
                                : isNaN(a)
                                ? function (a) {
                                      return a;
                                  }
                                : function () {
                                      return a * d;
                                  };
                        },
                        ob = function (a, b, c, d, e, f, g) {
                            return (
                                (f = f && A > f ? f * f : A),
                                "function" == typeof a
                                    ? function (h) {
                                          var i,
                                              j,
                                              k,
                                              l = Ma.isPressed ? 1 - Ma.edgeResistance : 1,
                                              m = h.x,
                                              n = h.y;
                                          return (
                                              (h.x = m = m > c ? c + (m - c) * l : b > m ? b + (m - b) * l : m),
                                              (h.y = n = n > e ? e + (n - e) * l : d > n ? d + (n - d) * l : n),
                                              (i = a.call(Ma, h)),
                                              i !== h && ((h.x = i.x), (h.y = i.y)),
                                              1 !== g && ((h.x *= g), (h.y *= g)),
                                              A > f && ((j = h.x - m), (k = h.y - n), j * j + k * k > f && ((h.x = m), (h.y = n))),
                                              h
                                          );
                                      }
                                    : a instanceof Array
                                    ? function (b) {
                                          for (var c, d, e, g, h = a.length, i = 0, j = A; --h > -1; ) (e = a[h]), (c = e.x - b.x), (d = e.y - b.y), (g = c * c + d * d), j > g && ((i = h), (j = g));
                                          return f >= j ? a[i] : b;
                                      }
                                    : function (a) {
                                          return a;
                                      }
                            );
                        },
                        pb = function (a, c) {
                            var e;
                            if (h && !Ma.isPressed && a && (("mousedown" !== a.type && "pointerdown" !== a.type) || c || !(B() - bb < 30) || !Ia[Ma.pointerEvent.type])) {
                                if (
                                    ((na = lb()),
                                    (Ma.pointerEvent = a),
                                    Ia[a.type]
                                        ? ((la = -1 !== a.type.indexOf("touch") ? a.currentTarget || a.target : t), Ja(la, "touchend", sb), Ja(la, "touchmove", qb), Ja(la, "touchcancel", sb), Ja(t, "touchstart", Na))
                                        : ((la = null), Ja(t, "mousemove", qb)),
                                    (sa = null),
                                    Ja(t, "mouseup", sb),
                                    a && a.target && Ja(a.target, "mouseup", sb),
                                    (ha = ab.call(Ma, a.target) && !g.dragClickables && !c))
                                )
                                    return Ja(a.target, "change", sb), ja(Ma, "press", "onPress"), void Qa(Ra, !0);
                                if (
                                    ((ra = !(!la || Ea === Fa || Ma.vars.allowNativeTouchScrolling === !1) && (Ea ? "y" : "x")),
                                    C ? (a = _(a, !0)) : ra || Ma.allowEventDefault || (a.preventDefault(), a.preventManipulation && a.preventManipulation()),
                                    a.changedTouches ? ((a = U = a.changedTouches[0]), (V = a.identifier)) : a.pointerId ? (V = a.pointerId) : (U = V = null),
                                    I++,
                                    Q(db),
                                    (k = Ma.pointerY = a.pageY),
                                    (j = Ma.pointerX = a.pageX),
                                    (ra || Ma.autoScroll) && $(d.parentNode),
                                    !d.parentNode || !Ma.autoScroll || i || za || !d.parentNode._gsMaxScrollX || D.parentNode || d.getBBox || ((D.style.width = d.parentNode.scrollWidth + "px"), d.parentNode.appendChild(D)),
                                    kb(),
                                    Ma.tween && Ma.tween.kill(),
                                    (Ma.isThrowing = !1),
                                    b.killTweensOf(i || d, !0, Ua),
                                    i && b.killTweensOf(d, !0, { scrollTo: 1 }),
                                    (Ma.tween = Ma.lockedAxis = null),
                                    (g.zIndexBoost || (!za && !i && g.zIndexBoost !== !1)) && (d.style.zIndex = Ta.zIndex++),
                                    (Ma.isPressed = !0),
                                    (v = !(!g.onDrag && !Ma._listeners.drag)),
                                    !za)
                                )
                                    for (e = Ra.length; --e > -1; ) ca(Ra[e], "cursor", g.cursor || "move");
                                ja(Ma, "press", "onPress");
                            }
                        },
                        qb = function (a) {
                            var b,
                                c,
                                d,
                                f,
                                g,
                                i,
                                l = a;
                            if (h && !e && Ma.isPressed && a) {
                                if (((Ma.pointerEvent = a), (b = a.changedTouches))) {
                                    if (((a = b[0]), a !== U && a.identifier !== V)) {
                                        for (f = b.length; --f > -1 && (a = b[f]).identifier !== V; );
                                        if (0 > f) return;
                                    }
                                } else if (a.pointerId && V && a.pointerId !== V) return;
                                if (C) a = _(a, !0);
                                else {
                                    if (
                                        la &&
                                        ra &&
                                        !sa &&
                                        ((c = a.pageX),
                                        (d = a.pageY),
                                        ma && ((f = c * ma[0] + d * ma[2] + ma[4]), (d = c * ma[1] + d * ma[3] + ma[5]), (c = f)),
                                        (g = Math.abs(c - j)),
                                        (i = Math.abs(d - k)),
                                        ((g !== i && (g > Ga || i > Ga)) || (J && ra === sa)) &&
                                            ((sa = g > i && Ea ? "x" : "y"),
                                            Ma.vars.lockAxisOnTouchScroll !== !1 && ((Ma.lockedAxis = "x" === sa ? "y" : "x"), "function" == typeof Ma.vars.onLockAxis && Ma.vars.onLockAxis.call(Ma, l)),
                                            J && ra === sa))
                                    )
                                        return void sb(l);
                                    Ma.allowEventDefault || (ra && (!sa || ra === sa)) || l.cancelable === !1 || (l.preventDefault(), l.preventManipulation && l.preventManipulation());
                                }
                                Ma.autoScroll && (Wa = !0), rb(a.pageX, a.pageY);
                            }
                        },
                        rb = function (a, b) {
                            var c,
                                d,
                                e,
                                f,
                                g,
                                h,
                                i = 1 - Ma.dragResistance,
                                m = 1 - Ma.edgeResistance;
                            (Ma.pointerX = a),
                                (Ma.pointerY = b),
                                za
                                    ? ((f = Math.atan2(Z.y - b, a - Z.x) * z),
                                      (g = Ma.y - f),
                                      g > 180 ? ((r -= 360), (Ma.y = f)) : -180 > g && ((r += 360), (Ma.y = f)),
                                      Ma.x !== l || Math.abs(r - f) > Ga ? ((Ma.y = f), (e = l + (r - f) * i)) : (e = l))
                                    : (ma && ((h = a * ma[0] + b * ma[2] + ma[4]), (b = a * ma[1] + b * ma[3] + ma[5]), (a = h)),
                                      (d = b - k),
                                      (c = a - j),
                                      Ga > d && d > -Ga && (d = 0),
                                      Ga > c && c > -Ga && (c = 0),
                                      (Ma.lockAxis || Ma.lockedAxis) &&
                                          (c || d) &&
                                          ((h = Ma.lockedAxis),
                                          h || ((Ma.lockedAxis = h = Ea && Math.abs(c) > Math.abs(d) ? "y" : Fa ? "x" : null), h && "function" == typeof Ma.vars.onLockAxis && Ma.vars.onLockAxis.call(Ma, Ma.pointerEvent)),
                                          "y" === h ? (d = 0) : "x" === h && (c = 0)),
                                      (e = l + c * i),
                                      (f = r + d * i)),
                                (ea || fa || ga) && (Ma.x !== e || (Ma.y !== f && !za))
                                    ? (ga && ((L.x = e), (L.y = f), (h = ga(L)), (e = h.x), (f = h.y)), ea && (e = ea(e)), fa && (f = fa(f)))
                                    : s && (e > w ? (e = w + (e - w) * m) : y > e && (e = y + (e - y) * m), za || (f > E ? (f = E + (f - E) * m) : H > f && (f = H + (f - H) * m))),
                                za || ma || ((e = Math.round(e)), (f = Math.round(f))),
                                (Ma.x !== e || (Ma.y !== f && !za)) &&
                                    (za ? ((Ma.endRotation = Ma.x = Ma.endX = e), (ba = !0)) : (Fa && ((Ma.y = Ma.endY = f), (ba = !0)), Ea && ((Ma.x = Ma.endX = e), (ba = !0))),
                                    !Ma.isDragging && Ma.isPressed && ((Ma.isDragging = !0), ja(Ma, "dragstart", "onDragStart")));
                        },
                        sb = function (a, c) {
                            if (h && Ma.isPressed && (!a || null == V || c || !((a.pointerId && a.pointerId !== V) || (a.changedTouches && !La(a.changedTouches, V))))) {
                                Ma.isPressed = !1;
                                var e,
                                    f,
                                    i,
                                    j,
                                    k,
                                    l = a,
                                    m = Ma.isDragging,
                                    n = b.delayedCall(0.001, mb);
                                if (
                                    (la ? (Ka(la, "touchend", sb), Ka(la, "touchmove", qb), Ka(la, "touchcancel", sb), Ka(t, "touchstart", Na)) : Ka(t, "mousemove", qb),
                                    Ka(t, "mouseup", sb),
                                    a && a.target && Ka(a.target, "mouseup", sb),
                                    (ba = !1),
                                    ha)
                                )
                                    return a && (Ka(a.target, "change", sb), (Ma.pointerEvent = l)), Qa(Ra, !1), ja(Ma, "release", "onRelease"), ja(Ma, "click", "onClick"), void (ha = !1);
                                if ((R(db), !za)) for (f = Ra.length; --f > -1; ) ca(Ra[f], "cursor", g.cursor || "move");
                                if ((m && ((Va = K = B()), (Ma.isDragging = !1)), I--, a)) {
                                    if ((C && (a = _(a, !1)), (e = a.changedTouches), e && ((a = e[0]), a !== U && a.identifier !== V))) {
                                        for (f = e.length; --f > -1 && (a = e[f]).identifier !== V; );
                                        if (0 > f) return;
                                    }
                                    (Ma.pointerEvent = l), (Ma.pointerX = a.pageX), (Ma.pointerY = a.pageY);
                                }
                                return (
                                    l && !m
                                        ? (na && (g.snap || g.bounds) && ib(g.throwProps),
                                          ja(Ma, "release", "onRelease"),
                                          (J && "touchmove" === l.type) ||
                                              -1 !== l.type.indexOf("cancel") ||
                                              (ja(Ma, "click", "onClick"),
                                              B() - bb < 300 && ja(Ma, "doubleclick", "onDoubleClick"),
                                              (j = l.target || l.srcElement || d),
                                              (bb = B()),
                                              (k = function () {
                                                  bb !== va &&
                                                      Ma.enabled() &&
                                                      !Ma.isPressed &&
                                                      (j.click
                                                          ? j.click()
                                                          : t.createEvent &&
                                                            ((i = t.createEvent("MouseEvents")),
                                                            i.initMouseEvent("click", !0, !0, window, 1, Ma.pointerEvent.screenX, Ma.pointerEvent.screenY, Ma.pointerX, Ma.pointerY, !1, !1, !1, !1, 0, null),
                                                            j.dispatchEvent(i)));
                                              }),
                                              J || l.defaultPrevented || b.delayedCall(1e-5, k)))
                                        : (ib(g.throwProps),
                                          C ||
                                              Ma.allowEventDefault ||
                                              !l ||
                                              (!g.dragClickables && ab.call(Ma, l.target)) ||
                                              !m ||
                                              (ra && (!sa || ra !== sa)) ||
                                              l.cancelable === !1 ||
                                              (l.preventDefault(), l.preventManipulation && l.preventManipulation()),
                                          ja(Ma, "release", "onRelease")),
                                    lb() && n.duration(Ma.tween.duration()),
                                    m && ja(Ma, "dragend", "onDragEnd"),
                                    !0
                                );
                            }
                        },
                        tb = function (a) {
                            if (a && Ma.isDragging && !i) {
                                var b = a.target || a.srcElement || d.parentNode,
                                    c = b.scrollLeft - b._gsScrollX,
                                    e = b.scrollTop - b._gsScrollY;
                                (c || e) && (ma ? ((j -= c * ma[0] + e * ma[2]), (k -= e * ma[3] + c * ma[1])) : ((j -= c), (k -= e)), (b._gsScrollX += c), (b._gsScrollY += e), rb(Ma.pointerX, Ma.pointerY));
                            }
                        },
                        ub = function (a) {
                            var b = B(),
                                c = 40 > b - bb,
                                d = 40 > b - Va,
                                e = c && va === bb,
                                f = !!a.preventDefault,
                                g = Ma.pointerEvent && Ma.pointerEvent.defaultPrevented,
                                h = c && wa === bb,
                                i = a.isTrusted || (null == a.isTrusted && c && e);
                            return (
                                f && (e || (d && Ma.vars.suppressClickOnDrag !== !1)) && a.stopImmediatePropagation(),
                                !c || (Ma.pointerEvent && Ma.pointerEvent.defaultPrevented) || (e && i === h)
                                    ? void ((Ma.isPressed || d || c) && (f ? (i && a.detail && c && !g) || (a.preventDefault(), a.preventManipulation && a.preventManipulation()) : (a.returnValue = !1)))
                                    : (i && e && (wa = bb), void (va = bb))
                            );
                        },
                        vb = function (a) {
                            return ma ? { x: a.x * ma[0] + a.y * ma[2] + ma[4], y: a.x * ma[1] + a.y * ma[3] + ma[5] } : { x: a.x, y: a.y };
                        };
                    (da = Ta.get(this.target)),
                        da && da.kill(),
                        (this.startDrag = function (a, b) {
                            var c, e, f, g;
                            pb(a || Ma.pointerEvent, !0),
                                b &&
                                    !Ma.hitTest(a || Ma.pointerEvent) &&
                                    ((c = Xa(a || Ma.pointerEvent)),
                                    (e = Xa(d)),
                                    (f = vb({ x: c.left + c.width / 2, y: c.top + c.height / 2 })),
                                    (g = vb({ x: e.left + e.width / 2, y: e.top + e.height / 2 })),
                                    (j -= f.x - g.x),
                                    (k -= f.y - g.y)),
                                Ma.isDragging || ((Ma.isDragging = !0), ja(Ma, "dragstart", "onDragStart"));
                        }),
                        (this.drag = qb),
                        (this.endDrag = function (a) {
                            sb(a || Ma.pointerEvent, !0);
                        }),
                        (this.timeSinceDrag = function () {
                            return Ma.isDragging ? 0 : (B() - Va) / 1e3;
                        }),
                        (this.timeSinceClick = function () {
                            return (B() - bb) / 1e3;
                        }),
                        (this.hitTest = function (a, b) {
                            return Ta.hitTest(Ma.target, a, b);
                        }),
                        (this.getDirection = function (a, b) {
                            var c,
                                d,
                                e,
                                g,
                                h,
                                i,
                                j = "velocity" === a && f ? a : "object" != typeof a || za ? "start" : "element";
                            return (
                                "element" === j && ((h = Xa(Ma.target)), (i = Xa(a))),
                                (c = "start" === j ? Ma.x - l : "velocity" === j ? f.getVelocity(this.target, Aa) : h.left + h.width / 2 - (i.left + i.width / 2)),
                                za
                                    ? 0 > c
                                        ? "counter-clockwise"
                                        : "clockwise"
                                    : ((b = b || 2),
                                      (d = "start" === j ? Ma.y - r : "velocity" === j ? f.getVelocity(this.target, Da) : h.top + h.height / 2 - (i.top + i.height / 2)),
                                      (e = Math.abs(c / d)),
                                      (g = 1 / b > e ? "" : 0 > c ? "left" : "right"),
                                      b > e && ("" !== g && (g += "-"), (g += 0 > d ? "up" : "down")),
                                      g)
                            );
                        }),
                        (this.applyBounds = function (a) {
                            var b, c, e, f, h, i;
                            if (a && g.bounds !== a) return (g.bounds = a), Ma.update(!0);
                            if ((eb(!0), fb(), s)) {
                                if (
                                    ((b = Ma.x),
                                    (c = Ma.y),
                                    b > w ? (b = w) : y > b && (b = y),
                                    c > E ? (c = E) : H > c && (c = H),
                                    (Ma.x !== b || Ma.y !== c) && ((e = !0), (Ma.x = Ma.endX = b), za ? (Ma.endRotation = b) : (Ma.y = Ma.endY = c), (ba = !0), db(!0), Ma.autoScroll && !Ma.isDragging))
                                )
                                    for (
                                        $(d.parentNode),
                                            f = d,
                                            M.scrollTop = null != window.pageYOffset ? window.pageYOffset : null != u.scrollTop ? u.scrollTop : t.body.scrollTop,
                                            M.scrollLeft = null != window.pageXOffset ? window.pageXOffset : null != u.scrollLeft ? u.scrollLeft : t.body.scrollLeft;
                                        f && !i;

                                    )
                                        (i = Y(f.parentNode)),
                                            (h = i ? M : f.parentNode),
                                            Fa && h.scrollTop > h._gsMaxScrollY && (h.scrollTop = h._gsMaxScrollY),
                                            Ea && h.scrollLeft > h._gsMaxScrollX && (h.scrollLeft = h._gsMaxScrollX),
                                            (f = h);
                                Ma.isThrowing && (e || Ma.endX > w || Ma.endX < y || Ma.endY > E || Ma.endY < H) && ib(g.throwProps, e);
                            }
                            return Ma;
                        }),
                        (this.update = function (a, b, c) {
                            var e = Ma.x,
                                f = Ma.y;
                            return (
                                jb(!b),
                                a ? Ma.applyBounds() : (ba && c && db(!0), eb(!0)),
                                b && (rb(Ma.pointerX, Ma.pointerY), ba && db(!0)),
                                Ma.isPressed && !b && ((Ea && Math.abs(e - Ma.x) > 0.01) || (Fa && Math.abs(f - Ma.y) > 0.01 && !za)) && kb(),
                                Ma.autoScroll && ($(d.parentNode), (Wa = Ma.isDragging), db(!0)),
                                Ma.autoScroll && (X(d, tb), W(d, tb)),
                                Ma
                            );
                        }),
                        (this.enable = function (a) {
                            var e, j, k;
                            if ("soft" !== a) {
                                for (j = Ra.length; --j > -1; )
                                    (k = Ra[j]),
                                        Ja(k, "mousedown", pb),
                                        Ja(k, "touchstart", pb),
                                        Ja(k, "click", ub, !0),
                                        za || ca(k, "cursor", g.cursor || "move"),
                                        ca(k, "touchCallout", "none"),
                                        ca(k, "touchAction", Ea === Fa ? "none" : Ea ? "pan-y" : "pan-x"),
                                        ta(k) && ca(k.ownerSVGElement || k, "touchAction", Ea === Fa ? "none" : Ea ? "pan-y" : "pan-x"),
                                        this.vars.allowContextMenu || Ja(k, "contextmenu", cb);
                                Qa(Ra, !1);
                            }
                            return (
                                W(d, tb),
                                (h = !0),
                                f && "soft" !== a && f.track(i || d, ya ? "x,y" : za ? "rotation" : "top,left"),
                                i && i.enable(),
                                (d._gsDragID = e = "d" + G++),
                                (F[e] = this),
                                i && (i.element._gsDragID = e),
                                b.set(d, { x: "+=0", overwrite: !1, data: "_draggable" }),
                                (qa = {
                                    t: d,
                                    data: C ? S : d._gsTransform,
                                    tween: {},
                                    setRatio: C
                                        ? function () {
                                              b.set(d, P);
                                          }
                                        : c._internals.setTransformRatio || c._internals.set3DTransformRatio,
                                }),
                                kb(),
                                Ma.update(!0),
                                Ma
                            );
                        }),
                        (this.disable = function (a) {
                            var b,
                                c,
                                e = Ma.isDragging;
                            if (!za) for (b = Ra.length; --b > -1; ) ca(Ra[b], "cursor", null);
                            if ("soft" !== a) {
                                for (b = Ra.length; --b > -1; ) (c = Ra[b]), ca(c, "touchCallout", null), ca(c, "touchAction", null), Ka(c, "mousedown", pb), Ka(c, "touchstart", pb), Ka(c, "click", ub), Ka(c, "contextmenu", cb);
                                Qa(Ra, !0), la && (Ka(la, "touchcancel", sb), Ka(la, "touchend", sb), Ka(la, "touchmove", qb)), Ka(t, "mouseup", sb), Ka(t, "mousemove", qb);
                            }
                            return (
                                X(d, tb),
                                (h = !1),
                                f && "soft" !== a && f.untrack(i || d, ya ? "x,y" : za ? "rotation" : "top,left"),
                                i && i.disable(),
                                R(db),
                                (Ma.isDragging = Ma.isPressed = ha = !1),
                                e && ja(Ma, "dragend", "onDragEnd"),
                                Ma
                            );
                        }),
                        (this.enabled = function (a, b) {
                            return arguments.length ? (a ? Ma.enable(b) : Ma.disable(b)) : h;
                        }),
                        (this.kill = function () {
                            return (Ma.isThrowing = !1), b.killTweensOf(i || d, !0, Ua), Ma.disable(), delete F[d._gsDragID], Ma;
                        }),
                        -1 !== xa.indexOf("scroll") &&
                            ((i = this.scrollProxy = new Sa(
                                d,
                                T(
                                    {
                                        onKill: function () {
                                            Ma.isPressed && sb(null);
                                        },
                                    },
                                    g
                                )
                            )),
                            (d.style.overflowY = Fa && !Ha ? "auto" : "hidden"),
                            (d.style.overflowX = Ea && !Ha ? "auto" : "hidden"),
                            (d = i.content)),
                        g.force3D !== !1 && b.set(d, { force3D: !0 }),
                        za ? (Ua.rotation = 1) : (Ea && (Ua[Aa] = 1), Fa && (Ua[Da] = 1)),
                        za ? ((P = p), (S = P.css), (P.overwrite = !1)) : ya && ((P = Ea && Fa ? m : Ea ? n : o), (S = P.css), (P.overwrite = !1)),
                        this.enable();
                },
                Ua = (Ta.prototype = new a());
            (Ua.constructor = Ta),
                (Ua.pointerX = Ua.pointerY = Ua.startX = Ua.startY = Ua.deltaX = Ua.deltaY = 0),
                (Ua.isDragging = Ua.isPressed = !1),
                (Ta.version = "0.16.1"),
                (Ta.zIndex = 1e3),
                Ja(t, "touchcancel", function () {}),
                Ja(t, "contextmenu", function (a) {
                    var b;
                    for (b in F) F[b].isPressed && F[b].endDrag();
                }),
                (Ta.create = function (a, c) {
                    "string" == typeof a && (a = b.selector(a));
                    for (var d = a && 0 !== a.length ? (Fa(a) ? Ga(a) : [a]) : [], e = d.length; --e > -1; ) d[e] = new Ta(d[e], c);
                    return d;
                }),
                (Ta.get = function (a) {
                    return F[(aa(a) || {})._gsDragID];
                }),
                (Ta.timeSinceDrag = function () {
                    return (B() - K) / 1e3;
                });
            var Va = {},
                Wa = function (a) {
                    var b,
                        c,
                        d = 0,
                        e = 0;
                    for (a = aa(a), b = a.offsetWidth, c = a.offsetHeight; a; ) (d += a.offsetTop), (e += a.offsetLeft), (a = a.offsetParent);
                    return { top: d, left: e, width: b, height: c };
                },
                Xa = function (a, b) {
                    if (a === window)
                        return (
                            (Va.left = Va.top = 0),
                            (Va.width = Va.right = u.clientWidth || a.innerWidth || t.body.clientWidth || 0),
                            (Va.height = Va.bottom = (a.innerHeight || 0) - 20 < u.clientHeight ? u.clientHeight : a.innerHeight || t.body.clientHeight || 0),
                            Va
                        );
                    var c = a.pageX !== b ? { left: a.pageX - V(), top: a.pageY - U(), right: a.pageX - V() + 1, bottom: a.pageY - U() + 1 } : a.nodeType || a.left === b || a.top === b ? (C ? Wa(a) : aa(a).getBoundingClientRect()) : a;
                    return (
                        c.right === b && c.width !== b
                            ? ((c.right = c.left + c.width), (c.bottom = c.top + c.height))
                            : c.width === b && (c = { width: c.right - c.left, height: c.bottom - c.top, right: c.right, left: c.left, bottom: c.bottom, top: c.top }),
                        c
                    );
                };
            return (
                (Ta.hitTest = function (a, b, c) {
                    if (a === b) return !1;
                    var d,
                        e,
                        f,
                        g = Xa(a),
                        h = Xa(b),
                        i = h.left > g.right || h.right < g.left || h.top > g.bottom || h.bottom < g.top;
                    return i || !c
                        ? !i
                        : ((f = -1 !== (c + "").indexOf("%")),
                          (c = parseFloat(c) || 0),
                          (d = { left: Math.max(g.left, h.left), top: Math.max(g.top, h.top) }),
                          (d.width = Math.min(g.right, h.right) - d.left),
                          (d.height = Math.min(g.bottom, h.bottom) - d.top),
                          !(d.width < 0 || d.height < 0) && (f ? ((c *= 0.01), (e = d.width * d.height), e >= g.width * g.height * c || e >= h.width * h.height * c) : d.width > c && d.height > c));
                }),
                (D.style.cssText = "visibility:hidden;height:1px;top:-1px;pointer-events:none;position:relative;clear:both;"),
                Ta
            );
        },
        !0
    );
}),
    _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
    (function (a) {
        "use strict";
        var b = function () {
            return (_gsScope.GreenSockGlobals || _gsScope)[a];
        };
        "undefined" != typeof module && module.exports ? (require("../TweenLite.min.js"), require("../plugins/CSSPlugin.min.js"), (module.exports = b())) : "function" == typeof define && define.amd && define(["TweenLite", "CSSPlugin"], b);
    })("Draggable");
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
    "use strict";
    var a = (_gsScope.document || {}).documentElement,
        b = _gsScope,
        c = function (c, d) {
            var e = "x" === d ? "Width" : "Height",
                f = "scroll" + e,
                g = "client" + e,
                h = document.body;
            return c === b || c === a || c === h ? Math.max(a[f], h[f]) - (b["inner" + e] || a[g] || h[g]) : c[f] - c["offset" + e];
        },
        d = function (a) {
            return "string" == typeof a && (a = TweenLite.selector(a)), a.length && a !== b && a[0] && a[0].style && !a.nodeType && (a = a[0]), a === b || (a.nodeType && a.style) ? a : null;
        },
        e = function (c, d) {
            var e = "scroll" + ("x" === d ? "Left" : "Top");
            return (
                c === b && (null != c.pageXOffset ? (e = "page" + d.toUpperCase() + "Offset") : (c = null != a[e] ? a : document.body)),
                function () {
                    return c[e];
                }
            );
        },
        f = function (c, f) {
            var g = d(c).getBoundingClientRect(),
                h = !f || f === b || f === document.body,
                i = (h ? a : f).getBoundingClientRect(),
                j = { x: g.left - i.left, y: g.top - i.top };
            return !h && f && ((j.x += e(f, "x")()), (j.y += e(f, "y")())), j;
        },
        g = function (a, b, d) {
            var e = typeof a;
            return isNaN(a) ? ("number" === e || ("string" === e && "=" === a.charAt(1)) ? a : "max" === a ? c(b, d) : Math.min(c(b, d), f(a, b)[d])) : parseFloat(a);
        },
        h = _gsScope._gsDefine.plugin({
            propName: "scrollTo",
            API: 2,
            global: !0,
            version: "1.9.0",
            init: function (a, c, d) {
                return (
                    (this._wdw = a === b),
                    (this._target = a),
                    (this._tween = d),
                    "object" != typeof c ? ((c = { y: c }), "string" == typeof c.y && "max" !== c.y && "=" !== c.y.charAt(1) && (c.x = c.y)) : c.nodeType && (c = { y: c, x: c }),
                    (this.vars = c),
                    (this._autoKill = c.autoKill !== !1),
                    (this.getX = e(a, "x")),
                    (this.getY = e(a, "y")),
                    (this.x = this.xPrev = this.getX()),
                    (this.y = this.yPrev = this.getY()),
                    null != c.x ? (this._addTween(this, "x", this.x, g(c.x, a, "x") - (c.offsetX || 0), "scrollTo_x", !0), this._overwriteProps.push("scrollTo_x")) : (this.skipX = !0),
                    null != c.y ? (this._addTween(this, "y", this.y, g(c.y, a, "y") - (c.offsetY || 0), "scrollTo_y", !0), this._overwriteProps.push("scrollTo_y")) : (this.skipY = !0),
                    !0
                );
            },
            set: function (a) {
                this._super.setRatio.call(this, a);
                var d = this._wdw || !this.skipX ? this.getX() : this.xPrev,
                    e = this._wdw || !this.skipY ? this.getY() : this.yPrev,
                    f = e - this.yPrev,
                    g = d - this.xPrev,
                    i = h.autoKillThreshold;
                this.x < 0 && (this.x = 0),
                    this.y < 0 && (this.y = 0),
                    this._autoKill &&
                        (!this.skipX && (g > i || -i > g) && d < c(this._target, "x") && (this.skipX = !0),
                        !this.skipY && (f > i || -i > f) && e < c(this._target, "y") && (this.skipY = !0),
                        this.skipX && this.skipY && (this._tween.kill(), this.vars.onAutoKill && this.vars.onAutoKill.apply(this.vars.onAutoKillScope || this._tween, this.vars.onAutoKillParams || []))),
                    this._wdw ? b.scrollTo(this.skipX ? d : this.x, this.skipY ? e : this.y) : (this.skipY || (this._target.scrollTop = this.y), this.skipX || (this._target.scrollLeft = this.x)),
                    (this.xPrev = this.x),
                    (this.yPrev = this.y);
            },
        }),
        i = h.prototype;
    (h.max = c),
        (h.getOffset = f),
        (h.buildGetter = e),
        (h.autoKillThreshold = 7),
        (i._kill = function (a) {
            return a.scrollTo_x && (this.skipX = !0), a.scrollTo_y && (this.skipY = !0), this._super._kill.call(this, a);
        });
}),
    _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
    (function (a) {
        "use strict";
        var b = function () {
            return (_gsScope.GreenSockGlobals || _gsScope)[a];
        };
        "undefined" != typeof module && module.exports ? (require("../TweenLite.min.js"), (module.exports = b())) : "function" == typeof define && define.amd && define(["TweenLite"], b);
    })("ScrollToPlugin");
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
!(function (a) {
    "use strict";
    var b = a.GreenSockGlobals || a,
        c = function (a) {
            var c,
                d = a.split("."),
                e = b;
            for (c = 0; c < d.length; c++) e[d[c]] = e = e[d[c]] || {};
            return e;
        },
        d = c("com.greensock.utils"),
        e = function (a) {
            var b = a.nodeType,
                c = "";
            if (1 === b || 9 === b || 11 === b) {
                if ("string" == typeof a.textContent) return a.textContent;
                for (a = a.firstChild; a; a = a.nextSibling) c += e(a);
            } else if (3 === b || 4 === b) return a.nodeValue;
            return c;
        },
        f = document,
        g = f.defaultView ? f.defaultView.getComputedStyle : function () {},
        h = /([A-Z])/g,
        i = function (a, b, c, d) {
            var e;
            return (c = c || g(a, null)) ? ((a = c.getPropertyValue(b.replace(h, "-$1").toLowerCase())), (e = a || c.length ? a : c[b])) : a.currentStyle && ((c = a.currentStyle), (e = c[b])), d ? e : parseInt(e, 10) || 0;
        },
        j = function (a) {
            return !!(a.length && a[0] && ((a[0].nodeType && a[0].style && !a.nodeType) || (a[0].length && a[0][0])));
        },
        k = function (a) {
            var b,
                c,
                d,
                e = [],
                f = a.length;
            for (b = 0; b < f; b++)
                if (((c = a[b]), j(c))) for (d = c.length, d = 0; d < c.length; d++) e.push(c[d]);
                else e.push(c);
            return e;
        },
        l = /(?:\r|\n|\t\t)/g,
        m = /(?:\s\s+)/g,
        n = 55296,
        o = 56319,
        p = 56320,
        q = 127462,
        r = 127487,
        s = 127995,
        t = 127999,
        u = function (a) {
            return ((a.charCodeAt(0) - n) << 10) + (a.charCodeAt(1) - p) + 65536;
        },
        v = f.all && !f.addEventListener,
        w = " style='position:relative;display:inline-block;" + (v ? "*display:inline;*zoom:1;'" : "'"),
        x = function (a, b) {
            a = a || "";
            var c = a.indexOf("++") !== -1,
                d = 1;
            return (
                c && (a = a.split("++").join("")),
                function () {
                    return "<" + b + w + (a ? " class='" + a + (c ? d++ : "") + "'>" : ">");
                }
            );
        },
        y = (d.SplitText = b.SplitText = function (a, b) {
            if (("string" == typeof a && (a = y.selector(a)), !a)) throw "cannot split a null element.";
            (this.elements = j(a) ? k(a) : [a]), (this.chars = []), (this.words = []), (this.lines = []), (this._originals = []), (this.vars = b || {}), this.split(b);
        }),
        z = function (a, b, c) {
            var d = a.nodeType;
            if (1 === d || 9 === d || 11 === d) for (a = a.firstChild; a; a = a.nextSibling) z(a, b, c);
            else (3 !== d && 4 !== d) || (a.nodeValue = a.nodeValue.split(b).join(c));
        },
        A = function (a, b) {
            for (var c = b.length; --c > -1; ) a.push(b[c]);
        },
        B = function (a) {
            var b,
                c = [],
                d = a.length;
            for (b = 0; b !== d; c.push(a[b++]));
            return c;
        },
        C = function (a, b, c) {
            for (var d; a && a !== b; ) {
                if ((d = a._next || a.nextSibling)) return d.textContent.charAt(0) === c;
                a = a.parentNode || a._parent;
            }
            return !1;
        },
        D = function (a) {
            var b,
                c,
                d = B(a.childNodes),
                e = d.length;
            for (b = 0; b < e; b++)
                (c = d[b]),
                    c._isSplit
                        ? D(c)
                        : (b && 3 === c.previousSibling.nodeType ? (c.previousSibling.nodeValue += 3 === c.nodeType ? c.nodeValue : c.firstChild.nodeValue) : 3 !== c.nodeType && a.insertBefore(c.firstChild, c), a.removeChild(c));
        },
        E = function (a, b, c, d, e, h, j) {
            var k,
                l,
                m,
                n,
                o,
                p,
                q,
                r,
                s,
                t,
                u,
                v,
                w = g(a),
                x = i(a, "paddingLeft", w),
                y = -999,
                B = i(a, "borderBottomWidth", w) + i(a, "borderTopWidth", w),
                E = i(a, "borderLeftWidth", w) + i(a, "borderRightWidth", w),
                F = i(a, "paddingTop", w) + i(a, "paddingBottom", w),
                G = i(a, "paddingLeft", w) + i(a, "paddingRight", w),
                H = 0.2 * i(a, "fontSize"),
                I = i(a, "textAlign", w, !0),
                J = [],
                K = [],
                L = [],
                M = b.wordDelimiter || " ",
                N = b.span ? "span" : "div",
                O = b.type || b.split || "chars,words,lines",
                P = e && O.indexOf("lines") !== -1 ? [] : null,
                Q = O.indexOf("words") !== -1,
                R = O.indexOf("chars") !== -1,
                S = "absolute" === b.position || b.absolute === !0,
                T = b.linesClass,
                U = (T || "").indexOf("++") !== -1,
                V = [];
            for (P && 1 === a.children.length && a.children[0]._isSplit && (a = a.children[0]), U && (T = T.split("++").join("")), l = a.getElementsByTagName("*"), m = l.length, o = [], k = 0; k < m; k++) o[k] = l[k];
            if (P || S)
                for (k = 0; k < m; k++)
                    (n = o[k]),
                        (p = n.parentNode === a),
                        (p || S || (R && !Q)) &&
                            ((v = n.offsetTop),
                            P && p && Math.abs(v - y) > H && ("BR" !== n.nodeName || 0 === k) && ((q = []), P.push(q), (y = v)),
                            S && ((n._x = n.offsetLeft), (n._y = v), (n._w = n.offsetWidth), (n._h = n.offsetHeight)),
                            P &&
                                (((n._isSplit && p) || (!R && p) || (Q && p) || (!Q && n.parentNode.parentNode === a && !n.parentNode._isSplit)) && (q.push(n), (n._x -= x), C(n, a, M) && (n._wordEnd = !0)),
                                "BR" === n.nodeName && ((n.nextSibling && "BR" === n.nextSibling.nodeName) || 0 === k) && P.push([])));
            for (k = 0; k < m; k++)
                (n = o[k]),
                    (p = n.parentNode === a),
                    "BR" !== n.nodeName
                        ? (S &&
                              ((s = n.style),
                              Q || p || ((n._x += n.parentNode._x), (n._y += n.parentNode._y)),
                              (s.left = n._x + "px"),
                              (s.top = n._y + "px"),
                              (s.position = "absolute"),
                              (s.display = "block"),
                              (s.width = n._w + 1 + "px"),
                              (s.height = n._h + "px")),
                          !Q && R
                              ? n._isSplit
                                  ? ((n._next = n.nextSibling), n.parentNode.appendChild(n))
                                  : n.parentNode._isSplit
                                  ? ((n._parent = n.parentNode),
                                    !n.previousSibling && n.firstChild && (n.firstChild._isFirst = !0),
                                    n.nextSibling && " " === n.nextSibling.textContent && !n.nextSibling.nextSibling && V.push(n.nextSibling),
                                    (n._next = n.nextSibling && n.nextSibling._isFirst ? null : n.nextSibling),
                                    n.parentNode.removeChild(n),
                                    o.splice(k--, 1),
                                    m--)
                                  : p ||
                                    ((v = !n.nextSibling && C(n.parentNode, a, M)),
                                    n.parentNode._parent && n.parentNode._parent.appendChild(n),
                                    v && n.parentNode.appendChild(f.createTextNode(" ")),
                                    b.span && (n.style.display = "inline"),
                                    J.push(n))
                              : n.parentNode._isSplit && !n._isSplit && "" !== n.innerHTML
                              ? K.push(n)
                              : R && !n._isSplit && (b.span && (n.style.display = "inline"), J.push(n)))
                        : P || S
                        ? (n.parentNode && n.parentNode.removeChild(n), o.splice(k--, 1), m--)
                        : Q || a.appendChild(n);
            for (k = V.length; --k > -1; ) V[k].parentNode.removeChild(V[k]);
            if (P) {
                for (S && ((t = f.createElement(N)), a.appendChild(t), (u = t.offsetWidth + "px"), (v = t.offsetParent === a ? 0 : a.offsetLeft), a.removeChild(t)), s = a.style.cssText, a.style.cssText = "display:none;"; a.firstChild; )
                    a.removeChild(a.firstChild);
                for (r = " " === M && (!S || (!Q && !R)), k = 0; k < P.length; k++) {
                    for (
                        q = P[k], t = f.createElement(N), t.style.cssText = "display:block;text-align:" + I + ";position:" + (S ? "absolute;" : "relative;"), T && (t.className = T + (U ? k + 1 : "")), L.push(t), m = q.length, l = 0;
                        l < m;
                        l++
                    )
                        "BR" !== q[l].nodeName &&
                            ((n = q[l]),
                            t.appendChild(n),
                            r && n._wordEnd && t.appendChild(f.createTextNode(" ")),
                            S && (0 === l && ((t.style.top = n._y + "px"), (t.style.left = x + v + "px")), (n.style.top = "0px"), v && (n.style.left = n._x - v + "px")));
                    0 === m ? (t.innerHTML = "&nbsp;") : Q || R || (D(t), z(t, String.fromCharCode(160), " ")), S && ((t.style.width = u), (t.style.height = n._h + "px")), a.appendChild(t);
                }
                a.style.cssText = s;
            }
            S && (j > a.clientHeight && ((a.style.height = j - F + "px"), a.clientHeight < j && (a.style.height = j + B + "px")), h > a.clientWidth && ((a.style.width = h - G + "px"), a.clientWidth < h && (a.style.width = h + E + "px"))),
                A(c, J),
                A(d, K),
                A(e, L);
        },
        F = function (a, b, c, d) {
            var g,
                h,
                i,
                j,
                k,
                p,
                v,
                w,
                x,
                y = b.span ? "span" : "div",
                A = b.type || b.split || "chars,words,lines",
                B = A.indexOf("chars") !== -1,
                C = "absolute" === b.position || b.absolute === !0,
                D = b.wordDelimiter || " ",
                E = " " !== D ? "" : C ? "&#173; " : " ",
                F = b.span ? "</span>" : "</div>",
                G = !0,
                H = f.createElement("div"),
                I = a.parentNode;
            for (
                I.insertBefore(H, a),
                    H.textContent = a.nodeValue,
                    I.removeChild(a),
                    a = H,
                    g = e(a),
                    v = g.indexOf("<") !== -1,
                    b.reduceWhiteSpace !== !1 && (g = g.replace(m, " ").replace(l, "")),
                    v && (g = g.split("<").join("{{LT}}")),
                    k = g.length,
                    h = (" " === g.charAt(0) ? E : "") + c(),
                    i = 0;
                i < k;
                i++
            )
                if (((p = g.charAt(i)), p === D && g.charAt(i - 1) !== D && i)) {
                    for (h += G ? F : "", G = !1; g.charAt(i + 1) === D; ) (h += E), i++;
                    i === k - 1 ? (h += E) : ")" !== g.charAt(i + 1) && ((h += E + c()), (G = !0));
                } else
                    "{" === p && "{{LT}}" === g.substr(i, 6)
                        ? ((h += B ? d() + "{{LT}}</" + y + ">" : "{{LT}}"), (i += 5))
                        : (p.charCodeAt(0) >= n && p.charCodeAt(0) <= o) || (g.charCodeAt(i + 1) >= 65024 && g.charCodeAt(i + 1) <= 65039)
                        ? ((w = u(g.substr(i, 2))),
                          (x = u(g.substr(i + 2, 2))),
                          (j = (w >= q && w <= r && x >= q && x <= r) || (x >= s && x <= t) ? 4 : 2),
                          (h += B && " " !== p ? d() + g.substr(i, j) + "</" + y + ">" : g.substr(i, j)),
                          (i += j - 1))
                        : (h += B && " " !== p ? d() + p + "</" + y + ">" : p);
            (a.outerHTML = h + (G ? F : "")), v && z(I, "{{LT}}", "<");
        },
        G = function (a, b, c, d) {
            var e,
                f,
                g = B(a.childNodes),
                h = g.length,
                j = "absolute" === b.position || b.absolute === !0;
            if (3 !== a.nodeType || h > 1) {
                for (b.absolute = !1, e = 0; e < h; e++)
                    (f = g[e]),
                        (3 !== f.nodeType || /\S+/.test(f.nodeValue)) &&
                            (j && 3 !== f.nodeType && "inline" === i(f, "display", null, !0) && ((f.style.display = "inline-block"), (f.style.position = "relative")), (f._isSplit = !0), G(f, b, c, d));
                return (b.absolute = j), void (a._isSplit = !0);
            }
            F(a, b, c, d);
        },
        H = y.prototype;
    (H.split = function (a) {
        this.isSplit && this.revert(), (this.vars = a = a || this.vars), (this._originals.length = this.chars.length = this.words.length = this.lines.length = 0);
        for (var b, c, d, e = this.elements.length, f = a.span ? "span" : "div", g = x(a.wordsClass, f), h = x(a.charsClass, f); --e > -1; )
            (d = this.elements[e]), (this._originals[e] = d.innerHTML), (b = d.clientHeight), (c = d.clientWidth), G(d, a, g, h), E(d, a, this.chars, this.words, this.lines, c, b);
        return this.chars.reverse(), this.words.reverse(), this.lines.reverse(), (this.isSplit = !0), this;
    }),
        (H.revert = function () {
            if (!this._originals) throw "revert() call wasn't scoped properly.";
            for (var a = this._originals.length; --a > -1; ) this.elements[a].innerHTML = this._originals[a];
            return (this.chars = []), (this.words = []), (this.lines = []), (this.isSplit = !1), this;
        }),
        (y.selector =
            a.$ ||
            a.jQuery ||
            function (b) {
                var c = a.$ || a.jQuery;
                return c ? ((y.selector = c), c(b)) : "undefined" == typeof document ? b : document.querySelectorAll ? document.querySelectorAll(b) : document.getElementById("#" === b.charAt(0) ? b.substr(1) : b);
            }),
        (y.version = "0.5.8");
})(_gsScope),
    (function (a) {
        "use strict";
        var b = function () {
            return (_gsScope.GreenSockGlobals || _gsScope)[a];
        };
        "undefined" != typeof module && module.exports ? (module.exports = b()) : "function" == typeof define && define.amd && define([], b);
    })("SplitText");
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
!(function (a) {
    "use strict";
    var b = a.GreenSockGlobals || a,
        c = function (a) {
            var c,
                d = a.split("."),
                e = b;
            for (c = 0; c < d.length; c++) e[d[c]] = e = e[d[c]] || {};
            return e;
        },
        d = c("com.greensock.utils"),
        e = function (a) {
            var b = a.nodeType,
                c = "";
            if (1 === b || 9 === b || 11 === b) {
                if ("string" == typeof a.textContent) return a.textContent;
                for (a = a.firstChild; a; a = a.nextSibling) c += e(a);
            } else if (3 === b || 4 === b) return a.nodeValue;
            return c;
        },
        f = document,
        g = f.defaultView ? f.defaultView.getComputedStyle : function () {},
        h = /([A-Z])/g,
        i = function (a, b, c, d) {
            var e;
            return (c = c || g(a, null)) ? ((a = c.getPropertyValue(b.replace(h, "-$1").toLowerCase())), (e = a || c.length ? a : c[b])) : a.currentStyle && ((c = a.currentStyle), (e = c[b])), d ? e : parseInt(e, 10) || 0;
        },
        j = function (a) {
            return !!(a.length && a[0] && ((a[0].nodeType && a[0].style && !a.nodeType) || (a[0].length && a[0][0])));
        },
        k = function (a) {
            var b,
                c,
                d,
                e = [],
                f = a.length;
            for (b = 0; f > b; b++)
                if (((c = a[b]), j(c))) for (d = c.length, d = 0; d < c.length; d++) e.push(c[d]);
                else e.push(c);
            return e;
        },
        l = /(?:\r|\n|\t\t)/g,
        m = /(?:\s\s+)/g,
        n = 55296,
        o = 56319,
        p = 56320,
        q = 127462,
        r = 127487,
        s = 127995,
        t = 127999,
        u = function (a) {
            return ((a.charCodeAt(0) - n) << 10) + (a.charCodeAt(1) - p) + 65536;
        },
        v = f.all && !f.addEventListener,
        w = " style='position:relative;display:inline-block;" + (v ? "*display:inline;*zoom:1;'" : "'"),
        x = function (a, b) {
            a = a || "";
            var c = -1 !== a.indexOf("++"),
                d = 1;
            return (
                c && (a = a.split("++").join("")),
                function () {
                    return "<" + b + w + (a ? " class='" + a + (c ? d++ : "") + "'>" : ">");
                }
            );
        },
        y = (d.SplitText = b.SplitText = function (a, b) {
            if (("string" == typeof a && (a = y.selector(a)), !a)) throw "cannot split a null element.";
            (this.elements = j(a) ? k(a) : [a]), (this.chars = []), (this.words = []), (this.lines = []), (this._originals = []), (this.vars = b || {}), this.split(b);
        }),
        z = function (a, b, c) {
            var d = a.nodeType;
            if (1 === d || 9 === d || 11 === d) for (a = a.firstChild; a; a = a.nextSibling) z(a, b, c);
            else (3 === d || 4 === d) && (a.nodeValue = a.nodeValue.split(b).join(c));
        },
        A = function (a, b) {
            for (var c = b.length; --c > -1; ) a.push(b[c]);
        },
        B = function (a) {
            var b,
                c = [],
                d = a.length;
            for (b = 0; b !== d; c.push(a[b++]));
            return c;
        },
        C = function (a, b, c) {
            for (var d; a && a !== b; ) {
                if ((d = a._next || a.nextSibling)) return d.textContent.charAt(0) === c;
                a = a.parentNode || a._parent;
            }
            return !1;
        },
        D = function (a) {
            var b,
                c,
                d = B(a.childNodes),
                e = d.length;
            for (b = 0; e > b; b++)
                (c = d[b]),
                    c._isSplit
                        ? D(c)
                        : (b && 3 === c.previousSibling.nodeType ? (c.previousSibling.nodeValue += 3 === c.nodeType ? c.nodeValue : c.firstChild.nodeValue) : 3 !== c.nodeType && a.insertBefore(c.firstChild, c), a.removeChild(c));
        },
        E = function (a, b, c, d, e, h, j) {
            var k,
                l,
                m,
                n,
                o,
                p,
                q,
                r,
                s,
                t,
                u,
                v,
                w = g(a),
                x = i(a, "paddingLeft", w),
                y = -999,
                B = i(a, "borderBottomWidth", w) + i(a, "borderTopWidth", w),
                E = i(a, "borderLeftWidth", w) + i(a, "borderRightWidth", w),
                F = i(a, "paddingTop", w) + i(a, "paddingBottom", w),
                G = i(a, "paddingLeft", w) + i(a, "paddingRight", w),
                H = 0.2 * i(a, "fontSize"),
                I = i(a, "textAlign", w, !0),
                J = [],
                K = [],
                L = [],
                M = b.wordDelimiter || " ",
                N = b.span ? "span" : "div",
                O = b.type || b.split || "chars,words,lines",
                P = e && -1 !== O.indexOf("lines") ? [] : null,
                Q = -1 !== O.indexOf("words"),
                R = -1 !== O.indexOf("chars"),
                S = "absolute" === b.position || b.absolute === !0,
                T = b.linesClass,
                U = -1 !== (T || "").indexOf("++"),
                V = [];
            for (P && 1 === a.children.length && a.children[0]._isSplit && (a = a.children[0]), U && (T = T.split("++").join("")), l = a.getElementsByTagName("*"), m = l.length, o = [], k = 0; m > k; k++) o[k] = l[k];
            if (P || S)
                for (k = 0; m > k; k++)
                    (n = o[k]),
                        (p = n.parentNode === a),
                        (p || S || (R && !Q)) &&
                            ((v = n.offsetTop),
                            P && p && Math.abs(v - y) > H && ("BR" !== n.nodeName || 0 === k) && ((q = []), P.push(q), (y = v)),
                            S && ((n._x = n.offsetLeft), (n._y = v), (n._w = n.offsetWidth), (n._h = n.offsetHeight)),
                            P &&
                                (((n._isSplit && p) || (!R && p) || (Q && p) || (!Q && n.parentNode.parentNode === a && !n.parentNode._isSplit)) && (q.push(n), (n._x -= x), C(n, a, M) && (n._wordEnd = !0)),
                                "BR" === n.nodeName && ((n.nextSibling && "BR" === n.nextSibling.nodeName) || 0 === k) && P.push([])));
            for (k = 0; m > k; k++)
                (n = o[k]),
                    (p = n.parentNode === a),
                    "BR" !== n.nodeName
                        ? (S &&
                              ((s = n.style),
                              Q || p || ((n._x += n.parentNode._x), (n._y += n.parentNode._y)),
                              (s.left = n._x + "px"),
                              (s.top = n._y + "px"),
                              (s.position = "absolute"),
                              (s.display = "block"),
                              (s.width = n._w + 1 + "px"),
                              (s.height = n._h + "px")),
                          !Q && R
                              ? n._isSplit
                                  ? ((n._next = n.nextSibling), n.parentNode.appendChild(n))
                                  : n.parentNode._isSplit
                                  ? ((n._parent = n.parentNode),
                                    !n.previousSibling && n.firstChild && (n.firstChild._isFirst = !0),
                                    n.nextSibling && " " === n.nextSibling.textContent && !n.nextSibling.nextSibling && V.push(n.nextSibling),
                                    (n._next = n.nextSibling && n.nextSibling._isFirst ? null : n.nextSibling),
                                    n.parentNode.removeChild(n),
                                    o.splice(k--, 1),
                                    m--)
                                  : p ||
                                    ((v = !n.nextSibling && C(n.parentNode, a, M)),
                                    n.parentNode._parent && n.parentNode._parent.appendChild(n),
                                    v && n.parentNode.appendChild(f.createTextNode(" ")),
                                    b.span && (n.style.display = "inline"),
                                    J.push(n))
                              : n.parentNode._isSplit && !n._isSplit && "" !== n.innerHTML
                              ? K.push(n)
                              : R && !n._isSplit && (b.span && (n.style.display = "inline"), J.push(n)))
                        : P || S
                        ? (n.parentNode && n.parentNode.removeChild(n), o.splice(k--, 1), m--)
                        : Q || a.appendChild(n);
            for (k = V.length; --k > -1; ) V[k].parentNode.removeChild(V[k]);
            if (P) {
                for (S && ((t = f.createElement(N)), a.appendChild(t), (u = t.offsetWidth + "px"), (v = t.offsetParent === a ? 0 : a.offsetLeft), a.removeChild(t)), s = a.style.cssText, a.style.cssText = "display:none;"; a.firstChild; )
                    a.removeChild(a.firstChild);
                for (r = " " === M && (!S || (!Q && !R)), k = 0; k < P.length; k++) {
                    for (
                        q = P[k], t = f.createElement(N), t.style.cssText = "display:block;text-align:" + I + ";position:" + (S ? "absolute;" : "relative;"), T && (t.className = T + (U ? k + 1 : "")), L.push(t), m = q.length, l = 0;
                        m > l;
                        l++
                    )
                        "BR" !== q[l].nodeName &&
                            ((n = q[l]),
                            t.appendChild(n),
                            r && n._wordEnd && t.appendChild(f.createTextNode(" ")),
                            S && (0 === l && ((t.style.top = n._y + "px"), (t.style.left = x + v + "px")), (n.style.top = "0px"), v && (n.style.left = n._x - v + "px")));
                    0 === m ? (t.innerHTML = "&nbsp;") : Q || R || (D(t), z(t, String.fromCharCode(160), " ")), S && ((t.style.width = u), (t.style.height = n._h + "px")), a.appendChild(t);
                }
                a.style.cssText = s;
            }
            S && (j > a.clientHeight && ((a.style.height = j - F + "px"), a.clientHeight < j && (a.style.height = j + B + "px")), h > a.clientWidth && ((a.style.width = h - G + "px"), a.clientWidth < h && (a.style.width = h + E + "px"))),
                A(c, J),
                A(d, K),
                A(e, L);
        },
        F = function (a, b, c, d) {
            var g,
                h,
                i,
                j,
                k,
                p,
                v,
                w,
                x,
                y = b.span ? "span" : "div",
                A = b.type || b.split || "chars,words,lines",
                B = -1 !== A.indexOf("chars"),
                C = "absolute" === b.position || b.absolute === !0,
                D = b.wordDelimiter || " ",
                E = " " !== D ? "" : C ? "&#173; " : " ",
                F = b.span ? "</span>" : "</div>",
                G = !0,
                H = f.createElement("div"),
                I = a.parentNode;
            for (
                I.insertBefore(H, a),
                    H.textContent = a.nodeValue,
                    I.removeChild(a),
                    a = H,
                    g = e(a),
                    v = -1 !== g.indexOf("<"),
                    b.reduceWhiteSpace !== !1 && (g = g.replace(m, " ").replace(l, "")),
                    v && (g = g.split("<").join("{{LT}}")),
                    k = g.length,
                    h = (" " === g.charAt(0) ? E : "") + c(),
                    i = 0;
                k > i;
                i++
            )
                if (((p = g.charAt(i)), p === D && g.charAt(i - 1) !== D && i)) {
                    for (h += G ? F : "", G = !1; g.charAt(i + 1) === D; ) (h += E), i++;
                    i === k - 1 ? (h += E) : ")" !== g.charAt(i + 1) && ((h += E + c()), (G = !0));
                } else
                    "{" === p && "{{LT}}" === g.substr(i, 6)
                        ? ((h += B ? d() + "{{LT}}</" + y + ">" : "{{LT}}"), (i += 5))
                        : (p.charCodeAt(0) >= n && p.charCodeAt(0) <= o) || (g.charCodeAt(i + 1) >= 65024 && g.charCodeAt(i + 1) <= 65039)
                        ? ((w = u(g.substr(i, 2))),
                          (x = u(g.substr(i + 2, 2))),
                          (j = (w >= q && r >= w && x >= q && r >= x) || (x >= s && t >= x) ? 4 : 2),
                          (h += B && " " !== p ? d() + g.substr(i, j) + "</" + y + ">" : g.substr(i, j)),
                          (i += j - 1))
                        : (h += B && " " !== p ? d() + p + "</" + y + ">" : p);
            (a.outerHTML = h + (G ? F : "")), v && z(I, "{{LT}}", "<");
        },
        G = function (a, b, c, d) {
            var e,
                f,
                g = B(a.childNodes),
                h = g.length,
                j = "absolute" === b.position || b.absolute === !0;
            if (3 !== a.nodeType || h > 1) {
                for (b.absolute = !1, e = 0; h > e; e++)
                    (f = g[e]),
                        (3 !== f.nodeType || /\S+/.test(f.nodeValue)) &&
                            (j && 3 !== f.nodeType && "inline" === i(f, "display", null, !0) && ((f.style.display = "inline-block"), (f.style.position = "relative")), (f._isSplit = !0), G(f, b, c, d));
                return (b.absolute = j), void (a._isSplit = !0);
            }
            F(a, b, c, d);
        },
        H = y.prototype;
    (H.split = function (a) {
        this.isSplit && this.revert(), (this.vars = a = a || this.vars), (this._originals.length = this.chars.length = this.words.length = this.lines.length = 0);
        for (var b, c, d, e = this.elements.length, f = a.span ? "span" : "div", g = x(a.wordsClass, f), h = x(a.charsClass, f); --e > -1; )
            (d = this.elements[e]), (this._originals[e] = d.innerHTML), (b = d.clientHeight), (c = d.clientWidth), G(d, a, g, h), E(d, a, this.chars, this.words, this.lines, c, b);
        return this.chars.reverse(), this.words.reverse(), this.lines.reverse(), (this.isSplit = !0), this;
    }),
        (H.revert = function () {
            if (!this._originals) throw "revert() call wasn't scoped properly.";
            for (var a = this._originals.length; --a > -1; ) this.elements[a].innerHTML = this._originals[a];
            return (this.chars = []), (this.words = []), (this.lines = []), (this.isSplit = !1), this;
        }),
        (y.selector =
            a.$ ||
            a.jQuery ||
            function (b) {
                var c = a.$ || a.jQuery;
                return c ? ((y.selector = c), c(b)) : "undefined" == typeof document ? b : document.querySelectorAll ? document.querySelectorAll(b) : document.getElementById("#" === b.charAt(0) ? b.substr(1) : b);
            }),
        (y.version = "0.5.8");
})(_gsScope),
    (function (a) {
        "use strict";
        var b = function () {
            return (_gsScope.GreenSockGlobals || _gsScope)[a];
        };
        "undefined" != typeof module && module.exports ? (module.exports = b()) : "function" == typeof define && define.amd && define([], b);
    })("SplitText");
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
    "use strict";
    _gsScope._gsDefine(
        "plugins.ThrowPropsPlugin",
        ["plugins.TweenPlugin", "TweenLite", "easing.Ease", "utils.VelocityTracker"],
        function (a, b, c, d) {
            var e,
                f,
                g,
                h,
                i = function (b, c) {
                    a.call(this, "throwProps"), (this._overwriteProps.length = 0);
                },
                j = 999999999999999,
                k = 1e-10,
                l = _gsScope._gsDefine.globals,
                m = !1,
                n = { x: 1, y: 1, z: 2, scale: 1, scaleX: 1, scaleY: 1, rotation: 1, rotationZ: 1, rotationX: 2, rotationY: 2, skewX: 1, skewY: 1, xPercent: 1, yPercent: 1 },
                o = function (a, b, c, d, e) {
                    var f,
                        g,
                        h,
                        i,
                        k = b.length,
                        l = 0,
                        m = j;
                    if ("object" == typeof a) {
                        for (; --k > -1; ) {
                            (f = b[k]), (g = 0);
                            for (h in a) (i = f[h] - a[h]), (g += i * i);
                            m > g && ((l = k), (m = g));
                        }
                        if (j > (e || j) && e < Math.sqrt(m)) return a;
                    } else for (; --k > -1; ) (f = b[k]), (g = f - a), 0 > g && (g = -g), m > g && f >= d && c >= f && ((l = k), (m = g));
                    return b[l];
                },
                p = function (a, b, c, d, e, f) {
                    if ("auto" === a.end) return a;
                    var g,
                        h,
                        i = a.end;
                    if (((c = isNaN(c) ? j : c), (d = isNaN(d) ? -j : d), "object" == typeof b)) {
                        if (((g = b.calculated ? b : ("function" == typeof i ? i(b) : o(b, i, c, d, f)) || b), !b.calculated)) {
                            for (h in g) b[h] = g[h];
                            b.calculated = !0;
                        }
                        g = g[e];
                    } else g = "function" == typeof i ? i(b) : i instanceof Array ? o(b, i, c, d, f) : Number(i);
                    return g > c ? (g = c) : d > g && (g = d), { max: g, min: g, unitFactor: a.unitFactor };
                },
                q = function (a, b, c) {
                    for (var d in b) void 0 === a[d] && d !== c && (a[d] = b[d]);
                    return a;
                },
                r = (i.calculateChange = function (a, d, e, f) {
                    null == f && (f = 0.05);
                    var g = d instanceof c ? d : d ? new c(d) : b.defaultEase;
                    return (e * f * a) / g.getRatio(f);
                }),
                s = (i.calculateDuration = function (a, d, e, f, g) {
                    g = g || 0.05;
                    var h = f instanceof c ? f : f ? new c(f) : b.defaultEase;
                    return Math.abs(((d - a) * h.getRatio(g)) / e / g);
                }),
                t = (i.calculateTweenDuration = function (a, e, f, g, h, j) {
                    if (("string" == typeof a && (a = b.selector(a)), !a)) return 0;
                    null == f && (f = 10), null == g && (g = 0.2), null == h && (h = 1), a.length && (a = a[0] || a);
                    var l,
                        n,
                        o,
                        t,
                        u,
                        v,
                        w,
                        x,
                        y,
                        z,
                        A,
                        B,
                        C,
                        D = 0,
                        E = 9999999999,
                        F = e.throwProps || e,
                        G = e.ease instanceof c ? e.ease : e.ease ? new c(e.ease) : b.defaultEase,
                        H = isNaN(F.checkpoint) ? 0.05 : Number(F.checkpoint),
                        I = isNaN(F.resistance) ? i.defaultResistance : Number(F.resistance);
                    if (F.linkedProps)
                        for (B = F.linkedProps.split(","), A = {}, C = 0; C < B.length; C++)
                            (l = B[C]),
                                (n = F[l]),
                                n &&
                                    (void 0 !== n.velocity && "number" == typeof n.velocity ? (t = Number(n.velocity) || 0) : ((y = y || d.getByTarget(a)), (t = y && y.isTrackingProp(l) ? y.getVelocity(l) : 0)),
                                    (u = isNaN(n.resistance) ? I : Number(n.resistance)),
                                    (o = t * u > 0 ? t / u : t / -u),
                                    (v = "function" == typeof a[l] ? a[l.indexOf("set") || "function" != typeof a["get" + l.substr(3)] ? l : "get" + l.substr(3)]() : a[l] || 0),
                                    (A[l] = v + r(t, G, o, H)));
                    for (l in F)
                        "resistance" !== l &&
                            "checkpoint" !== l &&
                            "preventOvershoot" !== l &&
                            "linkedProps" !== l &&
                            "radius" !== l &&
                            ((n = F[l]),
                            "object" != typeof n &&
                                ((y = y || d.getByTarget(a)), y && y.isTrackingProp(l) ? (n = "number" == typeof n ? { velocity: n } : { velocity: y.getVelocity(l) }) : ((t = Number(n) || 0), (o = t * I > 0 ? t / I : t / -I))),
                            "object" == typeof n &&
                                (void 0 !== n.velocity && "number" == typeof n.velocity ? (t = Number(n.velocity) || 0) : ((y = y || d.getByTarget(a)), (t = y && y.isTrackingProp(l) ? y.getVelocity(l) : 0)),
                                (u = isNaN(n.resistance) ? I : Number(n.resistance)),
                                (o = t * u > 0 ? t / u : t / -u),
                                (v = "function" == typeof a[l] ? a[l.indexOf("set") || "function" != typeof a["get" + l.substr(3)] ? l : "get" + l.substr(3)]() : a[l] || 0),
                                (w = v + r(t, G, o, H)),
                                void 0 !== n.end && ((n = p(n, A && l in A ? A : w, n.max, n.min, l, F.radius)), (j || m) && (F[l] = q(n, F[l], "end"))),
                                void 0 !== n.max && w > Number(n.max) + k
                                    ? ((z = n.unitFactor || i.defaultUnitFactors[l] || 1), (x = (v > n.max && n.min !== n.max) || (t * z > -15 && 45 > t * z) ? g + 0.1 * (f - g) : s(v, n.max, t, G, H)), E > x + h && (E = x + h))
                                    : void 0 !== n.min &&
                                      w < Number(n.min) - k &&
                                      ((z = n.unitFactor || i.defaultUnitFactors[l] || 1), (x = (v < n.min && n.min !== n.max) || (t * z > -45 && 15 > t * z) ? g + 0.1 * (f - g) : s(v, n.min, t, G, H)), E > x + h && (E = x + h)),
                                x > D && (D = x)),
                            o > D && (D = o));
                    return D > E && (D = E), D > f ? f : g > D ? g : D;
                }),
                u = (i.prototype = new a("throwProps"));
            return (
                (u.constructor = i),
                (i.version = "0.11.1"),
                (i.API = 2),
                (i._autoCSS = !0),
                (i.defaultResistance = 100),
                (i.defaultUnitFactors = { time: 1e3, totalTime: 1e3 }),
                (i.track = function (a, b, c) {
                    return d.track(a, b, c);
                }),
                (i.untrack = function (a, b) {
                    d.untrack(a, b);
                }),
                (i.isTracking = function (a, b) {
                    return d.isTracking(a, b);
                }),
                (i.getVelocity = function (a, b) {
                    var c = d.getByTarget(a);
                    return c ? c.getVelocity(b) : NaN;
                }),
                (i._cssRegister = function () {
                    var a = l.com.greensock.plugins.CSSPlugin;
                    if (a) {
                        var b = a._internals,
                            c = b._parseToProxy,
                            g = b._setPluginRatio,
                            h = b.CSSPropTween;
                        b._registerComplexSpecialProp("throwProps", {
                            parser: function (a, b, j, k, l, m) {
                                m = new i();
                                var o,
                                    p,
                                    q,
                                    r,
                                    s,
                                    t = {},
                                    u = {},
                                    v = {},
                                    w = {},
                                    x = {},
                                    y = {};
                                f = {};
                                for (q in b)
                                    "resistance" !== q &&
                                        "preventOvershoot" !== q &&
                                        "linkedProps" !== q &&
                                        "radius" !== q &&
                                        ((p = b[q]),
                                        "object" == typeof p
                                            ? (void 0 !== p.velocity && "number" == typeof p.velocity ? (t[q] = Number(p.velocity) || 0) : ((s = s || d.getByTarget(a)), (t[q] = s && s.isTrackingProp(q) ? s.getVelocity(q) : 0)),
                                              void 0 !== p.end && (w[q] = p.end),
                                              void 0 !== p.min && (u[q] = p.min),
                                              void 0 !== p.max && (v[q] = p.max),
                                              p.preventOvershoot && (y[q] = !0),
                                              void 0 !== p.resistance && ((o = !0), (x[q] = p.resistance)))
                                            : "number" == typeof p
                                            ? (t[q] = p)
                                            : ((s = s || d.getByTarget(a)), s && s.isTrackingProp(q) ? (t[q] = s.getVelocity(q)) : (t[q] = p || 0)),
                                        n[q] && k._enableTransforms(2 === n[q]));
                                (r = c(a, t, k, l, m)), (e = r.proxy), (t = r.end);
                                for (q in e) f[q] = { velocity: t[q], min: u[q], max: v[q], end: w[q], resistance: x[q], preventOvershoot: y[q] };
                                return (
                                    null != b.resistance && (f.resistance = b.resistance),
                                    null != b.linkedProps && (f.linkedProps = b.linkedProps),
                                    null != b.radius && (f.radius = b.radius),
                                    b.preventOvershoot && (f.preventOvershoot = !0),
                                    (l = new h(a, "throwProps", 0, 0, r.pt, 2)),
                                    k._overwriteProps.pop(),
                                    (l.plugin = m),
                                    (l.setRatio = g),
                                    (l.data = r),
                                    m._onInitTween(e, f, k._tween),
                                    l
                                );
                            },
                        });
                    }
                }),
                (i.to = function (a, c, d, i, j) {
                    c.throwProps || (c = { throwProps: c }), 0 === j && (c.throwProps.preventOvershoot = !0), (m = !0);
                    var k = new b(a, i || 1, c);
                    return (
                        k.render(0, !0, !0),
                        k.vars.css
                            ? (k.duration(t(e, { throwProps: f, ease: c.ease }, d, i, j)), k._delay && !k.vars.immediateRender ? k.invalidate() : g._onInitTween(e, h, k), (m = !1), k)
                            : (k.kill(), (k = new b(a, t(a, c, d, i, j), c)), (m = !1), k)
                    );
                }),
                (u._onInitTween = function (a, b, c, e) {
                    (this.target = a), (this._props = []), (g = this), (h = b);
                    var f,
                        i,
                        j,
                        k,
                        l,
                        n,
                        o,
                        s,
                        t,
                        u,
                        v,
                        w,
                        x = c._ease,
                        y = isNaN(b.checkpoint) ? 0.05 : Number(b.checkpoint),
                        z = c._duration,
                        A = b.preventOvershoot,
                        B = 0;
                    if (b.linkedProps)
                        for (v = b.linkedProps.split(","), u = {}, w = 0; w < v.length; w++)
                            (f = v[w]),
                                (i = b[f]),
                                i &&
                                    (void 0 !== i.velocity && "number" == typeof i.velocity ? (l = Number(i.velocity) || 0) : ((t = t || d.getByTarget(a)), (l = t && t.isTrackingProp(f) ? t.getVelocity(f) : 0)),
                                    (j = "function" == typeof a[f] ? a[f.indexOf("set") || "function" != typeof a["get" + f.substr(3)] ? f : "get" + f.substr(3)]() : a[f] || 0),
                                    (u[f] = j + r(l, x, z, y)));
                    for (f in b)
                        if ("resistance" !== f && "checkpoint" !== f && "preventOvershoot" !== f && "linkedProps" !== f && "radius" !== f) {
                            if (((i = b[f]), "function" == typeof i && (i = i(e, a)), "number" == typeof i)) l = Number(i) || 0;
                            else if ("object" != typeof i || isNaN(i.velocity)) {
                                if (((t = t || d.getByTarget(a)), !t || !t.isTrackingProp(f))) throw "ERROR: No velocity was defined in the throwProps tween of " + a + " property: " + f;
                                l = t.getVelocity(f);
                            } else l = Number(i.velocity);
                            (n = r(l, x, z, y)),
                                (s = 0),
                                (k = "function" == typeof a[f]),
                                (j = k ? a[f.indexOf("set") || "function" != typeof a["get" + f.substr(3)] ? f : "get" + f.substr(3)]() : a[f]),
                                "object" == typeof i &&
                                    ((o = j + n),
                                    void 0 !== i.end && ((i = p(i, u && f in u ? u : o, i.max, i.min, f, b.radius)), m && (b[f] = q(i, b[f], "end"))),
                                    void 0 !== i.max && Number(i.max) < o
                                        ? A || i.preventOvershoot
                                            ? (n = i.max - j)
                                            : (s = i.max - j - n)
                                        : void 0 !== i.min && Number(i.min) > o && (A || i.preventOvershoot ? (n = i.min - j) : (s = i.min - j - n))),
                                (this._overwriteProps[B] = f),
                                (this._props[B++] = { p: f, s: j, c1: n, c2: s, f: k, r: !1 });
                        }
                    return !0;
                }),
                (u._kill = function (b) {
                    for (var c = this._props.length; --c > -1; ) null != b[this._props[c].p] && this._props.splice(c, 1);
                    return a.prototype._kill.call(this, b);
                }),
                (u._mod = function (a) {
                    for (var b, c = this._props, d = c.length; --d > -1; ) (b = a[c[d].p] || a.throwProps), "function" == typeof b && (c[d].m = b);
                }),
                (u.setRatio = function (a) {
                    for (var b, c, d = this._props.length; --d > -1; )
                        (b = this._props[d]), (c = b.s + b.c1 * a + b.c2 * a * a), b.m ? (c = b.m(c, this.target)) : 1 === a && (c = ((1e4 * c + (0 > c ? -0.5 : 0.5)) | 0) / 1e4), b.f ? this.target[b.p](c) : (this.target[b.p] = c);
                }),
                a.activate([i]),
                i
            );
        },
        !0
    ),
        _gsScope._gsDefine(
            "utils.VelocityTracker",
            ["TweenLite"],
            function (a) {
                var b,
                    c,
                    d,
                    e,
                    f = /([A-Z])/g,
                    g = {},
                    h = _gsScope.document,
                    i = { x: 1, y: 1, z: 2, scale: 1, scaleX: 1, scaleY: 1, rotation: 1, rotationZ: 1, rotationX: 2, rotationY: 2, skewX: 1, skewY: 1, xPercent: 1, yPercent: 1 },
                    j = h.defaultView ? h.defaultView.getComputedStyle : function () {},
                    k = function (a, b, c) {
                        var d = (a._gsTransform || g)[b];
                        return d || 0 === d
                            ? d
                            : (a.style[b] ? (d = a.style[b]) : (c = c || j(a, null)) ? (d = c[b] || c.getPropertyValue(b) || c.getPropertyValue(b.replace(f, "-$1").toLowerCase())) : a.currentStyle && (d = a.currentStyle[b]),
                              parseFloat(d) || 0);
                    },
                    l = a.ticker,
                    m = function (a, b, c) {
                        (this.p = a), (this.f = b), (this.v1 = this.v2 = 0), (this.t1 = this.t2 = l.time), (this.css = !1), (this.type = ""), (this._prev = null), c && ((this._next = c), (c._prev = this));
                    },
                    n = function () {
                        var a,
                            c,
                            f = b,
                            g = l.time;
                        if (g - d >= 0.03)
                            for (e = d, d = g; f; ) {
                                for (c = f._firstVP; c; ) (a = c.css ? k(f.target, c.p) : c.f ? f.target[c.p]() : f.target[c.p]), (a !== c.v1 || g - c.t1 > 0.15) && ((c.v2 = c.v1), (c.v1 = a), (c.t2 = c.t1), (c.t1 = g)), (c = c._next);
                                f = f._next;
                            }
                    },
                    o = function (a) {
                        (this._lookup = {}),
                            (this.target = a),
                            (this.elem = !(!a.style || !a.nodeType)),
                            c || (l.addEventListener("tick", n, null, !1, -100), (d = e = l.time), (c = !0)),
                            b && ((this._next = b), (b._prev = this)),
                            (b = this);
                    },
                    p = (o.getByTarget = function (a) {
                        for (var c = b; c; ) {
                            if (c.target === a) return c;
                            c = c._next;
                        }
                    }),
                    q = o.prototype;
                return (
                    (q.addProp = function (b, c) {
                        if (!this._lookup[b]) {
                            var d = this.target,
                                e = "function" == typeof d[b],
                                f = e ? this._altProp(b) : b,
                                g = this._firstVP;
                            (this._firstVP = this._lookup[b] = this._lookup[f] = g = new m(f !== b && 0 === b.indexOf("set") ? f : b, e, g)),
                                (g.css = this.elem && (void 0 !== this.target.style[g.p] || i[g.p])),
                                g.css && i[g.p] && !d._gsTransform && a.set(d, { x: "+=0", overwrite: !1 }),
                                (g.type = c || (g.css && 0 === b.indexOf("rotation")) ? "deg" : ""),
                                (g.v1 = g.v2 = g.css ? k(d, g.p) : e ? d[g.p]() : d[g.p]);
                        }
                    }),
                    (q.removeProp = function (a) {
                        var b = this._lookup[a];
                        b && (b._prev ? (b._prev._next = b._next) : b === this._firstVP && (this._firstVP = b._next), b._next && (b._next._prev = b._prev), (this._lookup[a] = 0), b.f && (this._lookup[this._altProp(a)] = 0));
                    }),
                    (q.isTrackingProp = function (a) {
                        return this._lookup[a] instanceof m;
                    }),
                    (q.getVelocity = function (a) {
                        var b,
                            c,
                            d,
                            e = this._lookup[a],
                            f = this.target;
                        if (!e) throw "The velocity of " + a + " is not being tracked.";
                        return (
                            (b = e.css ? k(f, e.p) : e.f ? f[e.p]() : f[e.p]),
                            (c = b - e.v2),
                            ("rad" === e.type || "deg" === e.type) && ((d = "rad" === e.type ? 2 * Math.PI : 360), (c %= d), c !== c % (d / 2) && (c = 0 > c ? c + d : c - d)),
                            c / (l.time - e.t2)
                        );
                    }),
                    (q._altProp = function (a) {
                        var b = a.substr(0, 3),
                            c = ("get" === b ? "set" : "set" === b ? "get" : b) + a.substr(3);
                        return "function" == typeof this.target[c] ? c : a;
                    }),
                    (o.getByTarget = function (c) {
                        var d = b;
                        for ("string" == typeof c && (c = a.selector(c)), c.length && c !== window && c[0] && c[0].style && !c.nodeType && (c = c[0]); d; ) {
                            if (d.target === c) return d;
                            d = d._next;
                        }
                    }),
                    (o.track = function (a, b, c) {
                        var d = p(a),
                            e = b.split(","),
                            f = e.length;
                        for (c = (c || "").split(","), d || (d = new o(a)); --f > -1; ) d.addProp(e[f], c[f] || c[0]);
                        return d;
                    }),
                    (o.untrack = function (a, c) {
                        var d = p(a),
                            e = (c || "").split(","),
                            f = e.length;
                        if (d) {
                            for (; --f > -1; ) d.removeProp(e[f]);
                            (d._firstVP && c) || (d._prev ? (d._prev._next = d._next) : d === b && (b = d._next), d._next && (d._next._prev = d._prev));
                        }
                    }),
                    (o.isTracking = function (a, b) {
                        var c = p(a);
                        return !!c && (!(b || !c._firstVP) || c.isTrackingProp(b));
                    }),
                    o
                );
            },
            !0
        );
}),
    _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
    (function (a) {
        "use strict";
        var b = function () {
            return (_gsScope.GreenSockGlobals || _gsScope)[a];
        };
        "undefined" != typeof module && module.exports ? (require("../TweenLite.min.js"), (module.exports = b())) : "function" == typeof define && define.amd && define(["TweenLite"], b);
    })("ThrowPropsPlugin");
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
    "use strict";
    _gsScope._gsDefine(
        "TimelineMax",
        ["TimelineLite", "TweenLite", "easing.Ease"],
        function (a, b, c) {
            var d = function (b) {
                    a.call(this, b), (this._repeat = this.vars.repeat || 0), (this._repeatDelay = this.vars.repeatDelay || 0), (this._cycle = 0), (this._yoyo = this.vars.yoyo === !0), (this._dirty = !0);
                },
                e = 1e-10,
                f = b._internals,
                g = f.lazyTweens,
                h = f.lazyRender,
                i = _gsScope._gsDefine.globals,
                j = new c(null, null, 1, 0),
                k = (d.prototype = new a());
            return (
                (k.constructor = d),
                (k.kill()._gc = !1),
                (d.version = "1.20.4"),
                (k.invalidate = function () {
                    return (this._yoyo = this.vars.yoyo === !0), (this._repeat = this.vars.repeat || 0), (this._repeatDelay = this.vars.repeatDelay || 0), this._uncache(!0), a.prototype.invalidate.call(this);
                }),
                (k.addCallback = function (a, c, d, e) {
                    return this.add(b.delayedCall(0, a, d, e), c);
                }),
                (k.removeCallback = function (a, b) {
                    if (a)
                        if (null == b) this._kill(null, a);
                        else for (var c = this.getTweensOf(a, !1), d = c.length, e = this._parseTimeOrLabel(b); --d > -1; ) c[d]._startTime === e && c[d]._enabled(!1, !1);
                    return this;
                }),
                (k.removePause = function (b) {
                    return this.removeCallback(a._internals.pauseCallback, b);
                }),
                (k.tweenTo = function (a, c) {
                    c = c || {};
                    var d,
                        e,
                        f,
                        g = { ease: j, useFrames: this.usesFrames(), immediateRender: !1, lazy: !1 },
                        h = (c.repeat && i.TweenMax) || b;
                    for (e in c) g[e] = c[e];
                    return (
                        (g.time = this._parseTimeOrLabel(a)),
                        (d = Math.abs(Number(g.time) - this._time) / this._timeScale || 0.001),
                        (f = new h(this, d, g)),
                        (g.onStart = function () {
                            f.target.paused(!0),
                                f.vars.time === f.target.time() || d !== f.duration() || f.isFromTo || f.duration(Math.abs(f.vars.time - f.target.time()) / f.target._timeScale).render(f.time(), !0, !0),
                                c.onStart && c.onStart.apply(c.onStartScope || c.callbackScope || f, c.onStartParams || []);
                        }),
                        f
                    );
                }),
                (k.tweenFromTo = function (a, b, c) {
                    (c = c || {}), (a = this._parseTimeOrLabel(a)), (c.startAt = { onComplete: this.seek, onCompleteParams: [a], callbackScope: this }), (c.immediateRender = c.immediateRender !== !1);
                    var d = this.tweenTo(b, c);
                    return (d.isFromTo = 1), d.duration(Math.abs(d.vars.time - a) / this._timeScale || 0.001);
                }),
                (k.render = function (a, b, c) {
                    this._gc && this._enabled(!0, !1);
                    var d,
                        f,
                        i,
                        j,
                        k,
                        l,
                        m,
                        n,
                        o = this._time,
                        p = this._dirty ? this.totalDuration() : this._totalDuration,
                        q = this._duration,
                        r = this._totalTime,
                        s = this._startTime,
                        t = this._timeScale,
                        u = this._rawPrevTime,
                        v = this._paused,
                        w = this._cycle;
                    if ((o !== this._time && (a += this._time - o), a >= p - 1e-7 && a >= 0))
                        this._locked || ((this._totalTime = p), (this._cycle = this._repeat)),
                            this._reversed ||
                                this._hasPausedChild() ||
                                ((f = !0),
                                (j = "onComplete"),
                                (k = !!this._timeline.autoRemoveChildren),
                                0 === this._duration && ((0 >= a && a >= -1e-7) || 0 > u || u === e) && u !== a && this._first && ((k = !0), u > e && (j = "onReverseComplete"))),
                            (this._rawPrevTime = this._duration || !b || a || this._rawPrevTime === a ? a : e),
                            this._yoyo && 0 !== (1 & this._cycle) ? (this._time = a = 0) : ((this._time = q), (a = q + 1e-4));
                    else if (1e-7 > a)
                        if (
                            (this._locked || (this._totalTime = this._cycle = 0),
                            (this._time = 0),
                            (0 !== o || (0 === q && u !== e && (u > 0 || (0 > a && u >= 0)) && !this._locked)) && ((j = "onReverseComplete"), (f = this._reversed)),
                            0 > a)
                        )
                            (this._active = !1), this._timeline.autoRemoveChildren && this._reversed ? ((k = f = !0), (j = "onReverseComplete")) : u >= 0 && this._first && (k = !0), (this._rawPrevTime = a);
                        else {
                            if (((this._rawPrevTime = q || !b || a || this._rawPrevTime === a ? a : e), 0 === a && f)) for (d = this._first; d && 0 === d._startTime; ) d._duration || (f = !1), (d = d._next);
                            (a = 0), this._initted || (k = !0);
                        }
                    else if (
                        (0 === q && 0 > u && (k = !0),
                        (this._time = this._rawPrevTime = a),
                        this._locked ||
                            ((this._totalTime = a),
                            0 !== this._repeat &&
                                ((l = q + this._repeatDelay),
                                (this._cycle = (this._totalTime / l) >> 0),
                                0 !== this._cycle && this._cycle === this._totalTime / l && a >= r && this._cycle--,
                                (this._time = this._totalTime - this._cycle * l),
                                this._yoyo && 0 !== (1 & this._cycle) && (this._time = q - this._time),
                                this._time > q ? ((this._time = q), (a = q + 1e-4)) : this._time < 0 ? (this._time = a = 0) : (a = this._time))),
                        this._hasPause && !this._forcingPlayhead && !b)
                    ) {
                        if (((a = this._time), a >= o || (this._repeat && w !== this._cycle)))
                            for (d = this._first; d && d._startTime <= a && !m; ) d._duration || "isPause" !== d.data || d.ratio || (0 === d._startTime && 0 === this._rawPrevTime) || (m = d), (d = d._next);
                        else for (d = this._last; d && d._startTime >= a && !m; ) d._duration || ("isPause" === d.data && d._rawPrevTime > 0 && (m = d)), (d = d._prev);
                        m && m._startTime < q && ((this._time = a = m._startTime), (this._totalTime = a + this._cycle * (this._totalDuration + this._repeatDelay)));
                    }
                    if (this._cycle !== w && !this._locked) {
                        var x = this._yoyo && 0 !== (1 & w),
                            y = x === (this._yoyo && 0 !== (1 & this._cycle)),
                            z = this._totalTime,
                            A = this._cycle,
                            B = this._rawPrevTime,
                            C = this._time;
                        if (
                            ((this._totalTime = w * q),
                            this._cycle < w ? (x = !x) : (this._totalTime += q),
                            (this._time = o),
                            (this._rawPrevTime = 0 === q ? u - 1e-4 : u),
                            (this._cycle = w),
                            (this._locked = !0),
                            (o = x ? 0 : q),
                            this.render(o, b, 0 === q),
                            b || this._gc || (this.vars.onRepeat && ((this._cycle = A), (this._locked = !1), this._callback("onRepeat"))),
                            o !== this._time)
                        )
                            return;
                        if ((y && ((this._cycle = w), (this._locked = !0), (o = x ? q + 1e-4 : -1e-4), this.render(o, !0, !1)), (this._locked = !1), this._paused && !v)) return;
                        (this._time = C), (this._totalTime = z), (this._cycle = A), (this._rawPrevTime = B);
                    }
                    if (!((this._time !== o && this._first) || c || k || m)) return void (r !== this._totalTime && this._onUpdate && (b || this._callback("onUpdate")));
                    if (
                        (this._initted || (this._initted = !0),
                        this._active || (!this._paused && this._totalTime !== r && a > 0 && (this._active = !0)),
                        0 === r && this.vars.onStart && ((0 === this._totalTime && this._totalDuration) || b || this._callback("onStart")),
                        (n = this._time),
                        n >= o)
                    )
                        for (d = this._first; d && ((i = d._next), n === this._time && (!this._paused || v)); )
                            (d._active || (d._startTime <= this._time && !d._paused && !d._gc)) &&
                                (m === d && this.pause(), d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c)),
                                (d = i);
                    else
                        for (d = this._last; d && ((i = d._prev), n === this._time && (!this._paused || v)); ) {
                            if (d._active || (d._startTime <= o && !d._paused && !d._gc)) {
                                if (m === d) {
                                    for (m = d._prev; m && m.endTime() > this._time; ) m.render(m._reversed ? m.totalDuration() - (a - m._startTime) * m._timeScale : (a - m._startTime) * m._timeScale, b, c), (m = m._prev);
                                    (m = null), this.pause();
                                }
                                d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c);
                            }
                            d = i;
                        }
                    this._onUpdate && (b || (g.length && h(), this._callback("onUpdate"))),
                        j &&
                            (this._locked ||
                                this._gc ||
                                ((s === this._startTime || t !== this._timeScale) &&
                                    (0 === this._time || p >= this.totalDuration()) &&
                                    (f && (g.length && h(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), (this._active = !1)), !b && this.vars[j] && this._callback(j))));
                }),
                (k.getActive = function (a, b, c) {
                    null == a && (a = !0), null == b && (b = !0), null == c && (c = !1);
                    var d,
                        e,
                        f = [],
                        g = this.getChildren(a, b, c),
                        h = 0,
                        i = g.length;
                    for (d = 0; i > d; d++) (e = g[d]), e.isActive() && (f[h++] = e);
                    return f;
                }),
                (k.getLabelAfter = function (a) {
                    a || (0 !== a && (a = this._time));
                    var b,
                        c = this.getLabelsArray(),
                        d = c.length;
                    for (b = 0; d > b; b++) if (c[b].time > a) return c[b].name;
                    return null;
                }),
                (k.getLabelBefore = function (a) {
                    null == a && (a = this._time);
                    for (var b = this.getLabelsArray(), c = b.length; --c > -1; ) if (b[c].time < a) return b[c].name;
                    return null;
                }),
                (k.getLabelsArray = function () {
                    var a,
                        b = [],
                        c = 0;
                    for (a in this._labels) b[c++] = { time: this._labels[a], name: a };
                    return (
                        b.sort(function (a, b) {
                            return a.time - b.time;
                        }),
                        b
                    );
                }),
                (k.invalidate = function () {
                    return (this._locked = !1), a.prototype.invalidate.call(this);
                }),
                (k.progress = function (a, b) {
                    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - a : a) + this._cycle * (this._duration + this._repeatDelay), b) : this._time / this.duration() || 0;
                }),
                (k.totalProgress = function (a, b) {
                    return arguments.length ? this.totalTime(this.totalDuration() * a, b) : this._totalTime / this.totalDuration() || 0;
                }),
                (k.totalDuration = function (b) {
                    return arguments.length
                        ? -1 !== this._repeat && b
                            ? this.timeScale(this.totalDuration() / b)
                            : this
                        : (this._dirty && (a.prototype.totalDuration.call(this), (this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat)), this._totalDuration);
                }),
                (k.time = function (a, b) {
                    return arguments.length
                        ? (this._dirty && this.totalDuration(),
                          a > this._duration && (a = this._duration),
                          this._yoyo && 0 !== (1 & this._cycle) ? (a = this._duration - a + this._cycle * (this._duration + this._repeatDelay)) : 0 !== this._repeat && (a += this._cycle * (this._duration + this._repeatDelay)),
                          this.totalTime(a, b))
                        : this._time;
                }),
                (k.repeat = function (a) {
                    return arguments.length ? ((this._repeat = a), this._uncache(!0)) : this._repeat;
                }),
                (k.repeatDelay = function (a) {
                    return arguments.length ? ((this._repeatDelay = a), this._uncache(!0)) : this._repeatDelay;
                }),
                (k.yoyo = function (a) {
                    return arguments.length ? ((this._yoyo = a), this) : this._yoyo;
                }),
                (k.currentLabel = function (a) {
                    return arguments.length ? this.seek(a, !0) : this.getLabelBefore(this._time + 1e-8);
                }),
                d
            );
        },
        !0
    ),
        _gsScope._gsDefine(
            "TimelineLite",
            ["core.Animation", "core.SimpleTimeline", "TweenLite"],
            function (a, b, c) {
                var d = function (a) {
                        b.call(this, a),
                            (this._labels = {}),
                            (this.autoRemoveChildren = this.vars.autoRemoveChildren === !0),
                            (this.smoothChildTiming = this.vars.smoothChildTiming === !0),
                            (this._sortChildren = !0),
                            (this._onUpdate = this.vars.onUpdate);
                        var c,
                            d,
                            e = this.vars;
                        for (d in e) (c = e[d]), i(c) && -1 !== c.join("").indexOf("{self}") && (e[d] = this._swapSelfInParams(c));
                        i(e.tweens) && this.add(e.tweens, 0, e.align, e.stagger);
                    },
                    e = 1e-10,
                    f = c._internals,
                    g = (d._internals = {}),
                    h = f.isSelector,
                    i = f.isArray,
                    j = f.lazyTweens,
                    k = f.lazyRender,
                    l = _gsScope._gsDefine.globals,
                    m = function (a) {
                        var b,
                            c = {};
                        for (b in a) c[b] = a[b];
                        return c;
                    },
                    n = function (a, b, c) {
                        var d,
                            e,
                            f = a.cycle;
                        for (d in f) (e = f[d]), (a[d] = "function" == typeof e ? e(c, b[c]) : e[c % e.length]);
                        delete a.cycle;
                    },
                    o = (g.pauseCallback = function () {}),
                    p = function (a) {
                        var b,
                            c = [],
                            d = a.length;
                        for (b = 0; b !== d; c.push(a[b++]));
                        return c;
                    },
                    q = (d.prototype = new b());
                return (
                    (d.version = "1.20.4"),
                    (q.constructor = d),
                    (q.kill()._gc = q._forcingPlayhead = q._hasPause = !1),
                    (q.to = function (a, b, d, e) {
                        var f = (d.repeat && l.TweenMax) || c;
                        return b ? this.add(new f(a, b, d), e) : this.set(a, d, e);
                    }),
                    (q.from = function (a, b, d, e) {
                        return this.add(((d.repeat && l.TweenMax) || c).from(a, b, d), e);
                    }),
                    (q.fromTo = function (a, b, d, e, f) {
                        var g = (e.repeat && l.TweenMax) || c;
                        return b ? this.add(g.fromTo(a, b, d, e), f) : this.set(a, e, f);
                    }),
                    (q.staggerTo = function (a, b, e, f, g, i, j, k) {
                        var l,
                            o,
                            q = new d({ onComplete: i, onCompleteParams: j, callbackScope: k, smoothChildTiming: this.smoothChildTiming }),
                            r = e.cycle;
                        for ("string" == typeof a && (a = c.selector(a) || a), a = a || [], h(a) && (a = p(a)), f = f || 0, 0 > f && ((a = p(a)), a.reverse(), (f *= -1)), o = 0; o < a.length; o++)
                            (l = m(e)), l.startAt && ((l.startAt = m(l.startAt)), l.startAt.cycle && n(l.startAt, a, o)), r && (n(l, a, o), null != l.duration && ((b = l.duration), delete l.duration)), q.to(a[o], b, l, o * f);
                        return this.add(q, g);
                    }),
                    (q.staggerFrom = function (a, b, c, d, e, f, g, h) {
                        return (c.immediateRender = 0 != c.immediateRender), (c.runBackwards = !0), this.staggerTo(a, b, c, d, e, f, g, h);
                    }),
                    (q.staggerFromTo = function (a, b, c, d, e, f, g, h, i) {
                        return (d.startAt = c), (d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender), this.staggerTo(a, b, d, e, f, g, h, i);
                    }),
                    (q.call = function (a, b, d, e) {
                        return this.add(c.delayedCall(0, a, b, d), e);
                    }),
                    (q.set = function (a, b, d) {
                        return (d = this._parseTimeOrLabel(d, 0, !0)), null == b.immediateRender && (b.immediateRender = d === this._time && !this._paused), this.add(new c(a, 0, b), d);
                    }),
                    (d.exportRoot = function (a, b) {
                        (a = a || {}), null == a.smoothChildTiming && (a.smoothChildTiming = !0);
                        var e,
                            f,
                            g,
                            h,
                            i = new d(a),
                            j = i._timeline;
                        for (null == b && (b = !0), j._remove(i, !0), i._startTime = 0, i._rawPrevTime = i._time = i._totalTime = j._time, g = j._first; g; )
                            (h = g._next), (b && g instanceof c && g.target === g.vars.onComplete) || ((f = g._startTime - g._delay), 0 > f && (e = 1), i.add(g, f)), (g = h);
                        return j.add(i, 0), e && i.totalDuration(), i;
                    }),
                    (q.add = function (e, f, g, h) {
                        var j, k, l, m, n, o;
                        if (("number" != typeof f && (f = this._parseTimeOrLabel(f, 0, !0, e)), !(e instanceof a))) {
                            if (e instanceof Array || (e && e.push && i(e))) {
                                for (g = g || "normal", h = h || 0, j = f, k = e.length, l = 0; k > l; l++)
                                    i((m = e[l])) && (m = new d({ tweens: m })),
                                        this.add(m, j),
                                        "string" != typeof m && "function" != typeof m && ("sequence" === g ? (j = m._startTime + m.totalDuration() / m._timeScale) : "start" === g && (m._startTime -= m.delay())),
                                        (j += h);
                                return this._uncache(!0);
                            }
                            if ("string" == typeof e) return this.addLabel(e, f);
                            if ("function" != typeof e) throw "Cannot add " + e + " into the timeline; it is not a tween, timeline, function, or string.";
                            e = c.delayedCall(0, e);
                        }
                        if ((b.prototype.add.call(this, e, f), e._time && e.render((this.rawTime() - e._startTime) * e._timeScale, !1, !1), (this._gc || this._time === this._duration) && !this._paused && this._duration < this.duration()))
                            for (n = this, o = n.rawTime() > e._startTime; n._timeline; ) o && n._timeline.smoothChildTiming ? n.totalTime(n._totalTime, !0) : n._gc && n._enabled(!0, !1), (n = n._timeline);
                        return this;
                    }),
                    (q.remove = function (b) {
                        if (b instanceof a) {
                            this._remove(b, !1);
                            var c = (b._timeline = b.vars.useFrames ? a._rootFramesTimeline : a._rootTimeline);
                            return (b._startTime = (b._paused ? b._pauseTime : c._time) - (b._reversed ? b.totalDuration() - b._totalTime : b._totalTime) / b._timeScale), this;
                        }
                        if (b instanceof Array || (b && b.push && i(b))) {
                            for (var d = b.length; --d > -1; ) this.remove(b[d]);
                            return this;
                        }
                        return "string" == typeof b ? this.removeLabel(b) : this.kill(null, b);
                    }),
                    (q._remove = function (a, c) {
                        b.prototype._remove.call(this, a, c);
                        var d = this._last;
                        return d ? this._time > this.duration() && ((this._time = this._duration), (this._totalTime = this._totalDuration)) : (this._time = this._totalTime = this._duration = this._totalDuration = 0), this;
                    }),
                    (q.append = function (a, b) {
                        return this.add(a, this._parseTimeOrLabel(null, b, !0, a));
                    }),
                    (q.insert = q.insertMultiple = function (a, b, c, d) {
                        return this.add(a, b || 0, c, d);
                    }),
                    (q.appendMultiple = function (a, b, c, d) {
                        return this.add(a, this._parseTimeOrLabel(null, b, !0, a), c, d);
                    }),
                    (q.addLabel = function (a, b) {
                        return (this._labels[a] = this._parseTimeOrLabel(b)), this;
                    }),
                    (q.addPause = function (a, b, d, e) {
                        var f = c.delayedCall(0, o, d, e || this);
                        return (f.vars.onComplete = f.vars.onReverseComplete = b), (f.data = "isPause"), (this._hasPause = !0), this.add(f, a);
                    }),
                    (q.removeLabel = function (a) {
                        return delete this._labels[a], this;
                    }),
                    (q.getLabelTime = function (a) {
                        return null != this._labels[a] ? this._labels[a] : -1;
                    }),
                    (q._parseTimeOrLabel = function (b, c, d, e) {
                        var f, g;
                        if (e instanceof a && e.timeline === this) this.remove(e);
                        else if (e && (e instanceof Array || (e.push && i(e)))) for (g = e.length; --g > -1; ) e[g] instanceof a && e[g].timeline === this && this.remove(e[g]);
                        if (((f = "number" != typeof b || c ? (this.duration() > 99999999999 ? this.recent().endTime(!1) : this._duration) : 0), "string" == typeof c))
                            return this._parseTimeOrLabel(c, d && "number" == typeof b && null == this._labels[c] ? b - f : 0, d);
                        if (((c = c || 0), "string" != typeof b || (!isNaN(b) && null == this._labels[b]))) null == b && (b = f);
                        else {
                            if (((g = b.indexOf("=")), -1 === g)) return null == this._labels[b] ? (d ? (this._labels[b] = f + c) : c) : this._labels[b] + c;
                            (c = parseInt(b.charAt(g - 1) + "1", 10) * Number(b.substr(g + 1))), (b = g > 1 ? this._parseTimeOrLabel(b.substr(0, g - 1), 0, d) : f);
                        }
                        return Number(b) + c;
                    }),
                    (q.seek = function (a, b) {
                        return this.totalTime("number" == typeof a ? a : this._parseTimeOrLabel(a), b !== !1);
                    }),
                    (q.stop = function () {
                        return this.paused(!0);
                    }),
                    (q.gotoAndPlay = function (a, b) {
                        return this.play(a, b);
                    }),
                    (q.gotoAndStop = function (a, b) {
                        return this.pause(a, b);
                    }),
                    (q.render = function (a, b, c) {
                        this._gc && this._enabled(!0, !1);
                        var d,
                            f,
                            g,
                            h,
                            i,
                            l,
                            m,
                            n = this._dirty ? this.totalDuration() : this._totalDuration,
                            o = this._time,
                            p = this._startTime,
                            q = this._timeScale,
                            r = this._paused;
                        if (a >= n - 1e-7 && a >= 0)
                            (this._totalTime = this._time = n),
                                this._reversed ||
                                    this._hasPausedChild() ||
                                    ((f = !0),
                                    (h = "onComplete"),
                                    (i = !!this._timeline.autoRemoveChildren),
                                    0 === this._duration &&
                                        ((0 >= a && a >= -1e-7) || this._rawPrevTime < 0 || this._rawPrevTime === e) &&
                                        this._rawPrevTime !== a &&
                                        this._first &&
                                        ((i = !0), this._rawPrevTime > e && (h = "onReverseComplete"))),
                                (this._rawPrevTime = this._duration || !b || a || this._rawPrevTime === a ? a : e),
                                (a = n + 1e-4);
                        else if (1e-7 > a)
                            if (
                                ((this._totalTime = this._time = 0),
                                (0 !== o || (0 === this._duration && this._rawPrevTime !== e && (this._rawPrevTime > 0 || (0 > a && this._rawPrevTime >= 0)))) && ((h = "onReverseComplete"), (f = this._reversed)),
                                0 > a)
                            )
                                (this._active = !1), this._timeline.autoRemoveChildren && this._reversed ? ((i = f = !0), (h = "onReverseComplete")) : this._rawPrevTime >= 0 && this._first && (i = !0), (this._rawPrevTime = a);
                            else {
                                if (((this._rawPrevTime = this._duration || !b || a || this._rawPrevTime === a ? a : e), 0 === a && f)) for (d = this._first; d && 0 === d._startTime; ) d._duration || (f = !1), (d = d._next);
                                (a = 0), this._initted || (i = !0);
                            }
                        else {
                            if (this._hasPause && !this._forcingPlayhead && !b) {
                                if (a >= o) for (d = this._first; d && d._startTime <= a && !l; ) d._duration || "isPause" !== d.data || d.ratio || (0 === d._startTime && 0 === this._rawPrevTime) || (l = d), (d = d._next);
                                else for (d = this._last; d && d._startTime >= a && !l; ) d._duration || ("isPause" === d.data && d._rawPrevTime > 0 && (l = d)), (d = d._prev);
                                l && ((this._time = a = l._startTime), (this._totalTime = a + this._cycle * (this._totalDuration + this._repeatDelay)));
                            }
                            this._totalTime = this._time = this._rawPrevTime = a;
                        }
                        if ((this._time !== o && this._first) || c || i || l) {
                            if (
                                (this._initted || (this._initted = !0),
                                this._active || (!this._paused && this._time !== o && a > 0 && (this._active = !0)),
                                0 === o && this.vars.onStart && ((0 === this._time && this._duration) || b || this._callback("onStart")),
                                (m = this._time),
                                m >= o)
                            )
                                for (d = this._first; d && ((g = d._next), m === this._time && (!this._paused || r)); )
                                    (d._active || (d._startTime <= m && !d._paused && !d._gc)) &&
                                        (l === d && this.pause(), d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c)),
                                        (d = g);
                            else
                                for (d = this._last; d && ((g = d._prev), m === this._time && (!this._paused || r)); ) {
                                    if (d._active || (d._startTime <= o && !d._paused && !d._gc)) {
                                        if (l === d) {
                                            for (l = d._prev; l && l.endTime() > this._time; ) l.render(l._reversed ? l.totalDuration() - (a - l._startTime) * l._timeScale : (a - l._startTime) * l._timeScale, b, c), (l = l._prev);
                                            (l = null), this.pause();
                                        }
                                        d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c);
                                    }
                                    d = g;
                                }
                            this._onUpdate && (b || (j.length && k(), this._callback("onUpdate"))),
                                h &&
                                    (this._gc ||
                                        ((p === this._startTime || q !== this._timeScale) &&
                                            (0 === this._time || n >= this.totalDuration()) &&
                                            (f && (j.length && k(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), (this._active = !1)), !b && this.vars[h] && this._callback(h))));
                        }
                    }),
                    (q._hasPausedChild = function () {
                        for (var a = this._first; a; ) {
                            if (a._paused || (a instanceof d && a._hasPausedChild())) return !0;
                            a = a._next;
                        }
                        return !1;
                    }),
                    (q.getChildren = function (a, b, d, e) {
                        e = e || -9999999999;
                        for (var f = [], g = this._first, h = 0; g; )
                            g._startTime < e || (g instanceof c ? b !== !1 && (f[h++] = g) : (d !== !1 && (f[h++] = g), a !== !1 && ((f = f.concat(g.getChildren(!0, b, d))), (h = f.length)))), (g = g._next);
                        return f;
                    }),
                    (q.getTweensOf = function (a, b) {
                        var d,
                            e,
                            f = this._gc,
                            g = [],
                            h = 0;
                        for (f && this._enabled(!0, !0), d = c.getTweensOf(a), e = d.length; --e > -1; ) (d[e].timeline === this || (b && this._contains(d[e]))) && (g[h++] = d[e]);
                        return f && this._enabled(!1, !0), g;
                    }),
                    (q.recent = function () {
                        return this._recent;
                    }),
                    (q._contains = function (a) {
                        for (var b = a.timeline; b; ) {
                            if (b === this) return !0;
                            b = b.timeline;
                        }
                        return !1;
                    }),
                    (q.shiftChildren = function (a, b, c) {
                        c = c || 0;
                        for (var d, e = this._first, f = this._labels; e; ) e._startTime >= c && (e._startTime += a), (e = e._next);
                        if (b) for (d in f) f[d] >= c && (f[d] += a);
                        return this._uncache(!0);
                    }),
                    (q._kill = function (a, b) {
                        if (!a && !b) return this._enabled(!1, !1);
                        for (var c = b ? this.getTweensOf(b) : this.getChildren(!0, !0, !1), d = c.length, e = !1; --d > -1; ) c[d]._kill(a, b) && (e = !0);
                        return e;
                    }),
                    (q.clear = function (a) {
                        var b = this.getChildren(!1, !0, !0),
                            c = b.length;
                        for (this._time = this._totalTime = 0; --c > -1; ) b[c]._enabled(!1, !1);
                        return a !== !1 && (this._labels = {}), this._uncache(!0);
                    }),
                    (q.invalidate = function () {
                        for (var b = this._first; b; ) b.invalidate(), (b = b._next);
                        return a.prototype.invalidate.call(this);
                    }),
                    (q._enabled = function (a, c) {
                        if (a === this._gc) for (var d = this._first; d; ) d._enabled(a, !0), (d = d._next);
                        return b.prototype._enabled.call(this, a, c);
                    }),
                    (q.totalTime = function (b, c, d) {
                        this._forcingPlayhead = !0;
                        var e = a.prototype.totalTime.apply(this, arguments);
                        return (this._forcingPlayhead = !1), e;
                    }),
                    (q.duration = function (a) {
                        return arguments.length ? (0 !== this.duration() && 0 !== a && this.timeScale(this._duration / a), this) : (this._dirty && this.totalDuration(), this._duration);
                    }),
                    (q.totalDuration = function (a) {
                        if (!arguments.length) {
                            if (this._dirty) {
                                for (var b, c, d = 0, e = this._last, f = 999999999999; e; )
                                    (b = e._prev),
                                        e._dirty && e.totalDuration(),
                                        e._startTime > f && this._sortChildren && !e._paused && !this._calculatingDuration
                                            ? ((this._calculatingDuration = 1), this.add(e, e._startTime - e._delay), (this._calculatingDuration = 0))
                                            : (f = e._startTime),
                                        e._startTime < 0 &&
                                            !e._paused &&
                                            ((d -= e._startTime),
                                            this._timeline.smoothChildTiming && ((this._startTime += e._startTime / this._timeScale), (this._time -= e._startTime), (this._totalTime -= e._startTime), (this._rawPrevTime -= e._startTime)),
                                            this.shiftChildren(-e._startTime, !1, -9999999999),
                                            (f = 0)),
                                        (c = e._startTime + e._totalDuration / e._timeScale),
                                        c > d && (d = c),
                                        (e = b);
                                (this._duration = this._totalDuration = d), (this._dirty = !1);
                            }
                            return this._totalDuration;
                        }
                        return a && this.totalDuration() ? this.timeScale(this._totalDuration / a) : this;
                    }),
                    (q.paused = function (b) {
                        if (!b) for (var c = this._first, d = this._time; c; ) c._startTime === d && "isPause" === c.data && (c._rawPrevTime = 0), (c = c._next);
                        return a.prototype.paused.apply(this, arguments);
                    }),
                    (q.usesFrames = function () {
                        for (var b = this._timeline; b._timeline; ) b = b._timeline;
                        return b === a._rootFramesTimeline;
                    }),
                    (q.rawTime = function (a) {
                        return a && (this._paused || (this._repeat && this.time() > 0 && this.totalProgress() < 1))
                            ? this._totalTime % (this._duration + this._repeatDelay)
                            : this._paused
                            ? this._totalTime
                            : (this._timeline.rawTime(a) - this._startTime) * this._timeScale;
                    }),
                    d
                );
            },
            !0
        );
}),
    _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
    (function (a) {
        "use strict";
        var b = function () {
            return (_gsScope.GreenSockGlobals || _gsScope)[a];
        };
        "undefined" != typeof module && module.exports ? (require("./TweenLite.min.js"), (module.exports = b())) : "function" == typeof define && define.amd && define(["TweenLite"], b);
    })("TimelineMax");
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
    "use strict";
    _gsScope._gsDefine(
        "TweenMax",
        ["core.Animation", "core.SimpleTimeline", "TweenLite"],
        function (a, b, c) {
            var d = function (a) {
                    var b,
                        c = [],
                        d = a.length;
                    for (b = 0; b !== d; c.push(a[b++]));
                    return c;
                },
                e = function (a, b, c) {
                    var d,
                        e,
                        f = a.cycle;
                    for (d in f) (e = f[d]), (a[d] = "function" == typeof e ? e(c, b[c]) : e[c % e.length]);
                    delete a.cycle;
                },
                f = function (a, b, d) {
                    c.call(this, a, b, d),
                        (this._cycle = 0),
                        (this._yoyo = this.vars.yoyo === !0 || !!this.vars.yoyoEase),
                        (this._repeat = this.vars.repeat || 0),
                        (this._repeatDelay = this.vars.repeatDelay || 0),
                        this._repeat && this._uncache(!0),
                        (this.render = f.prototype.render);
                },
                g = 1e-10,
                h = c._internals,
                i = h.isSelector,
                j = h.isArray,
                k = (f.prototype = c.to({}, 0.1, {})),
                l = [];
            (f.version = "1.20.4"),
                (k.constructor = f),
                (k.kill()._gc = !1),
                (f.killTweensOf = f.killDelayedCallsTo = c.killTweensOf),
                (f.getTweensOf = c.getTweensOf),
                (f.lagSmoothing = c.lagSmoothing),
                (f.ticker = c.ticker),
                (f.render = c.render),
                (k.invalidate = function () {
                    return (
                        (this._yoyo = this.vars.yoyo === !0 || !!this.vars.yoyoEase),
                        (this._repeat = this.vars.repeat || 0),
                        (this._repeatDelay = this.vars.repeatDelay || 0),
                        (this._yoyoEase = null),
                        this._uncache(!0),
                        c.prototype.invalidate.call(this)
                    );
                }),
                (k.updateTo = function (a, b) {
                    var d,
                        e = this.ratio,
                        f = this.vars.immediateRender || a.immediateRender;
                    b && this._startTime < this._timeline._time && ((this._startTime = this._timeline._time), this._uncache(!1), this._gc ? this._enabled(!0, !1) : this._timeline.insert(this, this._startTime - this._delay));
                    for (d in a) this.vars[d] = a[d];
                    if (this._initted || f)
                        if (b) (this._initted = !1), f && this.render(0, !0, !0);
                        else if ((this._gc && this._enabled(!0, !1), this._notifyPluginsOfEnabled && this._firstPT && c._onPluginEvent("_onDisable", this), this._time / this._duration > 0.998)) {
                            var g = this._totalTime;
                            this.render(0, !0, !1), (this._initted = !1), this.render(g, !0, !1);
                        } else if (((this._initted = !1), this._init(), this._time > 0 || f)) for (var h, i = 1 / (1 - e), j = this._firstPT; j; ) (h = j.s + j.c), (j.c *= i), (j.s = h - j.c), (j = j._next);
                    return this;
                }),
                (k.render = function (a, b, d) {
                    this._initted || (0 === this._duration && this.vars.repeat && this.invalidate());
                    var e,
                        f,
                        i,
                        j,
                        k,
                        l,
                        m,
                        n,
                        o,
                        p = this._dirty ? this.totalDuration() : this._totalDuration,
                        q = this._time,
                        r = this._totalTime,
                        s = this._cycle,
                        t = this._duration,
                        u = this._rawPrevTime;
                    if (
                        (a >= p - 1e-7 && a >= 0
                            ? ((this._totalTime = p),
                              (this._cycle = this._repeat),
                              this._yoyo && 0 !== (1 & this._cycle) ? ((this._time = 0), (this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0)) : ((this._time = t), (this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1)),
                              this._reversed || ((e = !0), (f = "onComplete"), (d = d || this._timeline.autoRemoveChildren)),
                              0 === t &&
                                  (this._initted || !this.vars.lazy || d) &&
                                  (this._startTime === this._timeline._duration && (a = 0),
                                  (0 > u || (0 >= a && a >= -1e-7) || (u === g && "isPause" !== this.data)) && u !== a && ((d = !0), u > g && (f = "onReverseComplete")),
                                  (this._rawPrevTime = n = !b || a || u === a ? a : g)))
                            : 1e-7 > a
                            ? ((this._totalTime = this._time = this._cycle = 0),
                              (this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0),
                              (0 !== r || (0 === t && u > 0)) && ((f = "onReverseComplete"), (e = this._reversed)),
                              0 > a && ((this._active = !1), 0 === t && (this._initted || !this.vars.lazy || d) && (u >= 0 && (d = !0), (this._rawPrevTime = n = !b || a || u === a ? a : g))),
                              this._initted || (d = !0))
                            : ((this._totalTime = this._time = a),
                              0 !== this._repeat &&
                                  ((j = t + this._repeatDelay),
                                  (this._cycle = (this._totalTime / j) >> 0),
                                  0 !== this._cycle && this._cycle === this._totalTime / j && a >= r && this._cycle--,
                                  (this._time = this._totalTime - this._cycle * j),
                                  this._yoyo &&
                                      0 !== (1 & this._cycle) &&
                                      ((this._time = t - this._time),
                                      (o = this._yoyoEase || this.vars.yoyoEase),
                                      o &&
                                          (this._yoyoEase ||
                                              (o !== !0 || this._initted
                                                  ? (this._yoyoEase = o = o === !0 ? this._ease : o instanceof Ease ? o : Ease.map[o])
                                                  : ((o = this.vars.ease), (this._yoyoEase = o = o ? (o instanceof Ease ? o : "function" == typeof o ? new Ease(o, this.vars.easeParams) : Ease.map[o] || c.defaultEase) : c.defaultEase))),
                                          (this.ratio = o ? 1 - o.getRatio((t - this._time) / t) : 0))),
                                  this._time > t ? (this._time = t) : this._time < 0 && (this._time = 0)),
                              this._easeType && !o
                                  ? ((k = this._time / t),
                                    (l = this._easeType),
                                    (m = this._easePower),
                                    (1 === l || (3 === l && k >= 0.5)) && (k = 1 - k),
                                    3 === l && (k *= 2),
                                    1 === m ? (k *= k) : 2 === m ? (k *= k * k) : 3 === m ? (k *= k * k * k) : 4 === m && (k *= k * k * k * k),
                                    1 === l ? (this.ratio = 1 - k) : 2 === l ? (this.ratio = k) : this._time / t < 0.5 ? (this.ratio = k / 2) : (this.ratio = 1 - k / 2))
                                  : o || (this.ratio = this._ease.getRatio(this._time / t))),
                        q === this._time && !d && s === this._cycle)
                    )
                        return void (r !== this._totalTime && this._onUpdate && (b || this._callback("onUpdate")));
                    if (!this._initted) {
                        if ((this._init(), !this._initted || this._gc)) return;
                        if (!d && this._firstPT && ((this.vars.lazy !== !1 && this._duration) || (this.vars.lazy && !this._duration)))
                            return (this._time = q), (this._totalTime = r), (this._rawPrevTime = u), (this._cycle = s), h.lazyTweens.push(this), void (this._lazy = [a, b]);
                        !this._time || e || o ? e && this._ease._calcEnd && !o && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1)) : (this.ratio = this._ease.getRatio(this._time / t));
                    }
                    for (
                        this._lazy !== !1 && (this._lazy = !1),
                            this._active || (!this._paused && this._time !== q && a >= 0 && (this._active = !0)),
                            0 === r &&
                                (2 === this._initted && a > 0 && this._init(),
                                this._startAt && (a >= 0 ? this._startAt.render(a, !0, d) : f || (f = "_dummyGS")),
                                this.vars.onStart && (0 !== this._totalTime || 0 === t) && (b || this._callback("onStart"))),
                            i = this._firstPT;
                        i;

                    )
                        i.f ? i.t[i.p](i.c * this.ratio + i.s) : (i.t[i.p] = i.c * this.ratio + i.s), (i = i._next);
                    this._onUpdate && (0 > a && this._startAt && this._startTime && this._startAt.render(a, !0, d), b || ((this._totalTime !== r || f) && this._callback("onUpdate"))),
                        this._cycle !== s && (b || this._gc || (this.vars.onRepeat && this._callback("onRepeat"))),
                        f &&
                            (!this._gc || d) &&
                            (0 > a && this._startAt && !this._onUpdate && this._startTime && this._startAt.render(a, !0, d),
                            e && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), (this._active = !1)),
                            !b && this.vars[f] && this._callback(f),
                            0 === t && this._rawPrevTime === g && n !== g && (this._rawPrevTime = 0));
                }),
                (f.to = function (a, b, c) {
                    return new f(a, b, c);
                }),
                (f.from = function (a, b, c) {
                    return (c.runBackwards = !0), (c.immediateRender = 0 != c.immediateRender), new f(a, b, c);
                }),
                (f.fromTo = function (a, b, c, d) {
                    return (d.startAt = c), (d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender), new f(a, b, d);
                }),
                (f.staggerTo = f.allTo = function (a, b, g, h, k, m, n) {
                    h = h || 0;
                    var o,
                        p,
                        q,
                        r,
                        s = 0,
                        t = [],
                        u = function () {
                            g.onComplete && g.onComplete.apply(g.onCompleteScope || this, arguments), k.apply(n || g.callbackScope || this, m || l);
                        },
                        v = g.cycle,
                        w = g.startAt && g.startAt.cycle;
                    for (j(a) || ("string" == typeof a && (a = c.selector(a) || a), i(a) && (a = d(a))), a = a || [], 0 > h && ((a = d(a)), a.reverse(), (h *= -1)), o = a.length - 1, q = 0; o >= q; q++) {
                        p = {};
                        for (r in g) p[r] = g[r];
                        if ((v && (e(p, a, q), null != p.duration && ((b = p.duration), delete p.duration)), w)) {
                            w = p.startAt = {};
                            for (r in g.startAt) w[r] = g.startAt[r];
                            e(p.startAt, a, q);
                        }
                        (p.delay = s + (p.delay || 0)), q === o && k && (p.onComplete = u), (t[q] = new f(a[q], b, p)), (s += h);
                    }
                    return t;
                }),
                (f.staggerFrom = f.allFrom = function (a, b, c, d, e, g, h) {
                    return (c.runBackwards = !0), (c.immediateRender = 0 != c.immediateRender), f.staggerTo(a, b, c, d, e, g, h);
                }),
                (f.staggerFromTo = f.allFromTo = function (a, b, c, d, e, g, h, i) {
                    return (d.startAt = c), (d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender), f.staggerTo(a, b, d, e, g, h, i);
                }),
                (f.delayedCall = function (a, b, c, d, e) {
                    return new f(b, 0, { delay: a, onComplete: b, onCompleteParams: c, callbackScope: d, onReverseComplete: b, onReverseCompleteParams: c, immediateRender: !1, useFrames: e, overwrite: 0 });
                }),
                (f.set = function (a, b) {
                    return new f(a, 0, b);
                }),
                (f.isTweening = function (a) {
                    return c.getTweensOf(a, !0).length > 0;
                });
            var m = function (a, b) {
                    for (var d = [], e = 0, f = a._first; f; ) f instanceof c ? (d[e++] = f) : (b && (d[e++] = f), (d = d.concat(m(f, b))), (e = d.length)), (f = f._next);
                    return d;
                },
                n = (f.getAllTweens = function (b) {
                    return m(a._rootTimeline, b).concat(m(a._rootFramesTimeline, b));
                });
            (f.killAll = function (a, c, d, e) {
                null == c && (c = !0), null == d && (d = !0);
                var f,
                    g,
                    h,
                    i = n(0 != e),
                    j = i.length,
                    k = c && d && e;
                for (h = 0; j > h; h++) (g = i[h]), (k || g instanceof b || ((f = g.target === g.vars.onComplete) && d) || (c && !f)) && (a ? g.totalTime(g._reversed ? 0 : g.totalDuration()) : g._enabled(!1, !1));
            }),
                (f.killChildTweensOf = function (a, b) {
                    if (null != a) {
                        var e,
                            g,
                            k,
                            l,
                            m,
                            n = h.tweenLookup;
                        if (("string" == typeof a && (a = c.selector(a) || a), i(a) && (a = d(a)), j(a))) for (l = a.length; --l > -1; ) f.killChildTweensOf(a[l], b);
                        else {
                            e = [];
                            for (k in n) for (g = n[k].target.parentNode; g; ) g === a && (e = e.concat(n[k].tweens)), (g = g.parentNode);
                            for (m = e.length, l = 0; m > l; l++) b && e[l].totalTime(e[l].totalDuration()), e[l]._enabled(!1, !1);
                        }
                    }
                });
            var o = function (a, c, d, e) {
                (c = c !== !1), (d = d !== !1), (e = e !== !1);
                for (var f, g, h = n(e), i = c && d && e, j = h.length; --j > -1; ) (g = h[j]), (i || g instanceof b || ((f = g.target === g.vars.onComplete) && d) || (c && !f)) && g.paused(a);
            };
            return (
                (f.pauseAll = function (a, b, c) {
                    o(!0, a, b, c);
                }),
                (f.resumeAll = function (a, b, c) {
                    o(!1, a, b, c);
                }),
                (f.globalTimeScale = function (b) {
                    var d = a._rootTimeline,
                        e = c.ticker.time;
                    return arguments.length
                        ? ((b = b || g),
                          (d._startTime = e - ((e - d._startTime) * d._timeScale) / b),
                          (d = a._rootFramesTimeline),
                          (e = c.ticker.frame),
                          (d._startTime = e - ((e - d._startTime) * d._timeScale) / b),
                          (d._timeScale = a._rootTimeline._timeScale = b),
                          b)
                        : d._timeScale;
                }),
                (k.progress = function (a, b) {
                    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - a : a) + this._cycle * (this._duration + this._repeatDelay), b) : this._time / this.duration();
                }),
                (k.totalProgress = function (a, b) {
                    return arguments.length ? this.totalTime(this.totalDuration() * a, b) : this._totalTime / this.totalDuration();
                }),
                (k.time = function (a, b) {
                    return arguments.length
                        ? (this._dirty && this.totalDuration(),
                          a > this._duration && (a = this._duration),
                          this._yoyo && 0 !== (1 & this._cycle) ? (a = this._duration - a + this._cycle * (this._duration + this._repeatDelay)) : 0 !== this._repeat && (a += this._cycle * (this._duration + this._repeatDelay)),
                          this.totalTime(a, b))
                        : this._time;
                }),
                (k.duration = function (b) {
                    return arguments.length ? a.prototype.duration.call(this, b) : this._duration;
                }),
                (k.totalDuration = function (a) {
                    return arguments.length
                        ? -1 === this._repeat
                            ? this
                            : this.duration((a - this._repeat * this._repeatDelay) / (this._repeat + 1))
                        : (this._dirty && ((this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat), (this._dirty = !1)), this._totalDuration);
                }),
                (k.repeat = function (a) {
                    return arguments.length ? ((this._repeat = a), this._uncache(!0)) : this._repeat;
                }),
                (k.repeatDelay = function (a) {
                    return arguments.length ? ((this._repeatDelay = a), this._uncache(!0)) : this._repeatDelay;
                }),
                (k.yoyo = function (a) {
                    return arguments.length ? ((this._yoyo = a), this) : this._yoyo;
                }),
                f
            );
        },
        !0
    ),
        _gsScope._gsDefine(
            "TimelineLite",
            ["core.Animation", "core.SimpleTimeline", "TweenLite"],
            function (a, b, c) {
                var d = function (a) {
                        b.call(this, a),
                            (this._labels = {}),
                            (this.autoRemoveChildren = this.vars.autoRemoveChildren === !0),
                            (this.smoothChildTiming = this.vars.smoothChildTiming === !0),
                            (this._sortChildren = !0),
                            (this._onUpdate = this.vars.onUpdate);
                        var c,
                            d,
                            e = this.vars;
                        for (d in e) (c = e[d]), i(c) && -1 !== c.join("").indexOf("{self}") && (e[d] = this._swapSelfInParams(c));
                        i(e.tweens) && this.add(e.tweens, 0, e.align, e.stagger);
                    },
                    e = 1e-10,
                    f = c._internals,
                    g = (d._internals = {}),
                    h = f.isSelector,
                    i = f.isArray,
                    j = f.lazyTweens,
                    k = f.lazyRender,
                    l = _gsScope._gsDefine.globals,
                    m = function (a) {
                        var b,
                            c = {};
                        for (b in a) c[b] = a[b];
                        return c;
                    },
                    n = function (a, b, c) {
                        var d,
                            e,
                            f = a.cycle;
                        for (d in f) (e = f[d]), (a[d] = "function" == typeof e ? e(c, b[c]) : e[c % e.length]);
                        delete a.cycle;
                    },
                    o = (g.pauseCallback = function () {}),
                    p = function (a) {
                        var b,
                            c = [],
                            d = a.length;
                        for (b = 0; b !== d; c.push(a[b++]));
                        return c;
                    },
                    q = (d.prototype = new b());
                return (
                    (d.version = "1.20.4"),
                    (q.constructor = d),
                    (q.kill()._gc = q._forcingPlayhead = q._hasPause = !1),
                    (q.to = function (a, b, d, e) {
                        var f = (d.repeat && l.TweenMax) || c;
                        return b ? this.add(new f(a, b, d), e) : this.set(a, d, e);
                    }),
                    (q.from = function (a, b, d, e) {
                        return this.add(((d.repeat && l.TweenMax) || c).from(a, b, d), e);
                    }),
                    (q.fromTo = function (a, b, d, e, f) {
                        var g = (e.repeat && l.TweenMax) || c;
                        return b ? this.add(g.fromTo(a, b, d, e), f) : this.set(a, e, f);
                    }),
                    (q.staggerTo = function (a, b, e, f, g, i, j, k) {
                        var l,
                            o,
                            q = new d({ onComplete: i, onCompleteParams: j, callbackScope: k, smoothChildTiming: this.smoothChildTiming }),
                            r = e.cycle;
                        for ("string" == typeof a && (a = c.selector(a) || a), a = a || [], h(a) && (a = p(a)), f = f || 0, 0 > f && ((a = p(a)), a.reverse(), (f *= -1)), o = 0; o < a.length; o++)
                            (l = m(e)), l.startAt && ((l.startAt = m(l.startAt)), l.startAt.cycle && n(l.startAt, a, o)), r && (n(l, a, o), null != l.duration && ((b = l.duration), delete l.duration)), q.to(a[o], b, l, o * f);
                        return this.add(q, g);
                    }),
                    (q.staggerFrom = function (a, b, c, d, e, f, g, h) {
                        return (c.immediateRender = 0 != c.immediateRender), (c.runBackwards = !0), this.staggerTo(a, b, c, d, e, f, g, h);
                    }),
                    (q.staggerFromTo = function (a, b, c, d, e, f, g, h, i) {
                        return (d.startAt = c), (d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender), this.staggerTo(a, b, d, e, f, g, h, i);
                    }),
                    (q.call = function (a, b, d, e) {
                        return this.add(c.delayedCall(0, a, b, d), e);
                    }),
                    (q.set = function (a, b, d) {
                        return (d = this._parseTimeOrLabel(d, 0, !0)), null == b.immediateRender && (b.immediateRender = d === this._time && !this._paused), this.add(new c(a, 0, b), d);
                    }),
                    (d.exportRoot = function (a, b) {
                        (a = a || {}), null == a.smoothChildTiming && (a.smoothChildTiming = !0);
                        var e,
                            f,
                            g,
                            h,
                            i = new d(a),
                            j = i._timeline;
                        for (null == b && (b = !0), j._remove(i, !0), i._startTime = 0, i._rawPrevTime = i._time = i._totalTime = j._time, g = j._first; g; )
                            (h = g._next), (b && g instanceof c && g.target === g.vars.onComplete) || ((f = g._startTime - g._delay), 0 > f && (e = 1), i.add(g, f)), (g = h);
                        return j.add(i, 0), e && i.totalDuration(), i;
                    }),
                    (q.add = function (e, f, g, h) {
                        var j, k, l, m, n, o;
                        if (("number" != typeof f && (f = this._parseTimeOrLabel(f, 0, !0, e)), !(e instanceof a))) {
                            if (e instanceof Array || (e && e.push && i(e))) {
                                for (g = g || "normal", h = h || 0, j = f, k = e.length, l = 0; k > l; l++)
                                    i((m = e[l])) && (m = new d({ tweens: m })),
                                        this.add(m, j),
                                        "string" != typeof m && "function" != typeof m && ("sequence" === g ? (j = m._startTime + m.totalDuration() / m._timeScale) : "start" === g && (m._startTime -= m.delay())),
                                        (j += h);
                                return this._uncache(!0);
                            }
                            if ("string" == typeof e) return this.addLabel(e, f);
                            if ("function" != typeof e) throw "Cannot add " + e + " into the timeline; it is not a tween, timeline, function, or string.";
                            e = c.delayedCall(0, e);
                        }
                        if ((b.prototype.add.call(this, e, f), e._time && e.render((this.rawTime() - e._startTime) * e._timeScale, !1, !1), (this._gc || this._time === this._duration) && !this._paused && this._duration < this.duration()))
                            for (n = this, o = n.rawTime() > e._startTime; n._timeline; ) o && n._timeline.smoothChildTiming ? n.totalTime(n._totalTime, !0) : n._gc && n._enabled(!0, !1), (n = n._timeline);
                        return this;
                    }),
                    (q.remove = function (b) {
                        if (b instanceof a) {
                            this._remove(b, !1);
                            var c = (b._timeline = b.vars.useFrames ? a._rootFramesTimeline : a._rootTimeline);
                            return (b._startTime = (b._paused ? b._pauseTime : c._time) - (b._reversed ? b.totalDuration() - b._totalTime : b._totalTime) / b._timeScale), this;
                        }
                        if (b instanceof Array || (b && b.push && i(b))) {
                            for (var d = b.length; --d > -1; ) this.remove(b[d]);
                            return this;
                        }
                        return "string" == typeof b ? this.removeLabel(b) : this.kill(null, b);
                    }),
                    (q._remove = function (a, c) {
                        b.prototype._remove.call(this, a, c);
                        var d = this._last;
                        return d ? this._time > this.duration() && ((this._time = this._duration), (this._totalTime = this._totalDuration)) : (this._time = this._totalTime = this._duration = this._totalDuration = 0), this;
                    }),
                    (q.append = function (a, b) {
                        return this.add(a, this._parseTimeOrLabel(null, b, !0, a));
                    }),
                    (q.insert = q.insertMultiple = function (a, b, c, d) {
                        return this.add(a, b || 0, c, d);
                    }),
                    (q.appendMultiple = function (a, b, c, d) {
                        return this.add(a, this._parseTimeOrLabel(null, b, !0, a), c, d);
                    }),
                    (q.addLabel = function (a, b) {
                        return (this._labels[a] = this._parseTimeOrLabel(b)), this;
                    }),
                    (q.addPause = function (a, b, d, e) {
                        var f = c.delayedCall(0, o, d, e || this);
                        return (f.vars.onComplete = f.vars.onReverseComplete = b), (f.data = "isPause"), (this._hasPause = !0), this.add(f, a);
                    }),
                    (q.removeLabel = function (a) {
                        return delete this._labels[a], this;
                    }),
                    (q.getLabelTime = function (a) {
                        return null != this._labels[a] ? this._labels[a] : -1;
                    }),
                    (q._parseTimeOrLabel = function (b, c, d, e) {
                        var f, g;
                        if (e instanceof a && e.timeline === this) this.remove(e);
                        else if (e && (e instanceof Array || (e.push && i(e)))) for (g = e.length; --g > -1; ) e[g] instanceof a && e[g].timeline === this && this.remove(e[g]);
                        if (((f = "number" != typeof b || c ? (this.duration() > 99999999999 ? this.recent().endTime(!1) : this._duration) : 0), "string" == typeof c))
                            return this._parseTimeOrLabel(c, d && "number" == typeof b && null == this._labels[c] ? b - f : 0, d);
                        if (((c = c || 0), "string" != typeof b || (!isNaN(b) && null == this._labels[b]))) null == b && (b = f);
                        else {
                            if (((g = b.indexOf("=")), -1 === g)) return null == this._labels[b] ? (d ? (this._labels[b] = f + c) : c) : this._labels[b] + c;
                            (c = parseInt(b.charAt(g - 1) + "1", 10) * Number(b.substr(g + 1))), (b = g > 1 ? this._parseTimeOrLabel(b.substr(0, g - 1), 0, d) : f);
                        }
                        return Number(b) + c;
                    }),
                    (q.seek = function (a, b) {
                        return this.totalTime("number" == typeof a ? a : this._parseTimeOrLabel(a), b !== !1);
                    }),
                    (q.stop = function () {
                        return this.paused(!0);
                    }),
                    (q.gotoAndPlay = function (a, b) {
                        return this.play(a, b);
                    }),
                    (q.gotoAndStop = function (a, b) {
                        return this.pause(a, b);
                    }),
                    (q.render = function (a, b, c) {
                        this._gc && this._enabled(!0, !1);
                        var d,
                            f,
                            g,
                            h,
                            i,
                            l,
                            m,
                            n = this._time,
                            o = this._dirty ? this.totalDuration() : this._totalDuration,
                            p = this._startTime,
                            q = this._timeScale,
                            r = this._paused;
                        if ((n !== this._time && (a += this._time - n), a >= o - 1e-7 && a >= 0))
                            (this._totalTime = this._time = o),
                                this._reversed ||
                                    this._hasPausedChild() ||
                                    ((f = !0),
                                    (h = "onComplete"),
                                    (i = !!this._timeline.autoRemoveChildren),
                                    0 === this._duration &&
                                        ((0 >= a && a >= -1e-7) || this._rawPrevTime < 0 || this._rawPrevTime === e) &&
                                        this._rawPrevTime !== a &&
                                        this._first &&
                                        ((i = !0), this._rawPrevTime > e && (h = "onReverseComplete"))),
                                (this._rawPrevTime = this._duration || !b || a || this._rawPrevTime === a ? a : e),
                                (a = o + 1e-4);
                        else if (1e-7 > a)
                            if (
                                ((this._totalTime = this._time = 0),
                                (0 !== n || (0 === this._duration && this._rawPrevTime !== e && (this._rawPrevTime > 0 || (0 > a && this._rawPrevTime >= 0)))) && ((h = "onReverseComplete"), (f = this._reversed)),
                                0 > a)
                            )
                                (this._active = !1), this._timeline.autoRemoveChildren && this._reversed ? ((i = f = !0), (h = "onReverseComplete")) : this._rawPrevTime >= 0 && this._first && (i = !0), (this._rawPrevTime = a);
                            else {
                                if (((this._rawPrevTime = this._duration || !b || a || this._rawPrevTime === a ? a : e), 0 === a && f)) for (d = this._first; d && 0 === d._startTime; ) d._duration || (f = !1), (d = d._next);
                                (a = 0), this._initted || (i = !0);
                            }
                        else {
                            if (this._hasPause && !this._forcingPlayhead && !b) {
                                if (a >= n) for (d = this._first; d && d._startTime <= a && !l; ) d._duration || "isPause" !== d.data || d.ratio || (0 === d._startTime && 0 === this._rawPrevTime) || (l = d), (d = d._next);
                                else for (d = this._last; d && d._startTime >= a && !l; ) d._duration || ("isPause" === d.data && d._rawPrevTime > 0 && (l = d)), (d = d._prev);
                                l && ((this._time = a = l._startTime), (this._totalTime = a + this._cycle * (this._totalDuration + this._repeatDelay)));
                            }
                            this._totalTime = this._time = this._rawPrevTime = a;
                        }
                        if ((this._time !== n && this._first) || c || i || l) {
                            if (
                                (this._initted || (this._initted = !0),
                                this._active || (!this._paused && this._time !== n && a > 0 && (this._active = !0)),
                                0 === n && this.vars.onStart && ((0 === this._time && this._duration) || b || this._callback("onStart")),
                                (m = this._time),
                                m >= n)
                            )
                                for (d = this._first; d && ((g = d._next), m === this._time && (!this._paused || r)); )
                                    (d._active || (d._startTime <= m && !d._paused && !d._gc)) &&
                                        (l === d && this.pause(), d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c)),
                                        (d = g);
                            else
                                for (d = this._last; d && ((g = d._prev), m === this._time && (!this._paused || r)); ) {
                                    if (d._active || (d._startTime <= n && !d._paused && !d._gc)) {
                                        if (l === d) {
                                            for (l = d._prev; l && l.endTime() > this._time; ) l.render(l._reversed ? l.totalDuration() - (a - l._startTime) * l._timeScale : (a - l._startTime) * l._timeScale, b, c), (l = l._prev);
                                            (l = null), this.pause();
                                        }
                                        d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c);
                                    }
                                    d = g;
                                }
                            this._onUpdate && (b || (j.length && k(), this._callback("onUpdate"))),
                                h &&
                                    (this._gc ||
                                        ((p === this._startTime || q !== this._timeScale) &&
                                            (0 === this._time || o >= this.totalDuration()) &&
                                            (f && (j.length && k(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), (this._active = !1)), !b && this.vars[h] && this._callback(h))));
                        }
                    }),
                    (q._hasPausedChild = function () {
                        for (var a = this._first; a; ) {
                            if (a._paused || (a instanceof d && a._hasPausedChild())) return !0;
                            a = a._next;
                        }
                        return !1;
                    }),
                    (q.getChildren = function (a, b, d, e) {
                        e = e || -9999999999;
                        for (var f = [], g = this._first, h = 0; g; )
                            g._startTime < e || (g instanceof c ? b !== !1 && (f[h++] = g) : (d !== !1 && (f[h++] = g), a !== !1 && ((f = f.concat(g.getChildren(!0, b, d))), (h = f.length)))), (g = g._next);
                        return f;
                    }),
                    (q.getTweensOf = function (a, b) {
                        var d,
                            e,
                            f = this._gc,
                            g = [],
                            h = 0;
                        for (f && this._enabled(!0, !0), d = c.getTweensOf(a), e = d.length; --e > -1; ) (d[e].timeline === this || (b && this._contains(d[e]))) && (g[h++] = d[e]);
                        return f && this._enabled(!1, !0), g;
                    }),
                    (q.recent = function () {
                        return this._recent;
                    }),
                    (q._contains = function (a) {
                        for (var b = a.timeline; b; ) {
                            if (b === this) return !0;
                            b = b.timeline;
                        }
                        return !1;
                    }),
                    (q.shiftChildren = function (a, b, c) {
                        c = c || 0;
                        for (var d, e = this._first, f = this._labels; e; ) e._startTime >= c && (e._startTime += a), (e = e._next);
                        if (b) for (d in f) f[d] >= c && (f[d] += a);
                        return this._uncache(!0);
                    }),
                    (q._kill = function (a, b) {
                        if (!a && !b) return this._enabled(!1, !1);
                        for (var c = b ? this.getTweensOf(b) : this.getChildren(!0, !0, !1), d = c.length, e = !1; --d > -1; ) c[d]._kill(a, b) && (e = !0);
                        return e;
                    }),
                    (q.clear = function (a) {
                        var b = this.getChildren(!1, !0, !0),
                            c = b.length;
                        for (this._time = this._totalTime = 0; --c > -1; ) b[c]._enabled(!1, !1);
                        return a !== !1 && (this._labels = {}), this._uncache(!0);
                    }),
                    (q.invalidate = function () {
                        for (var b = this._first; b; ) b.invalidate(), (b = b._next);
                        return a.prototype.invalidate.call(this);
                    }),
                    (q._enabled = function (a, c) {
                        if (a === this._gc) for (var d = this._first; d; ) d._enabled(a, !0), (d = d._next);
                        return b.prototype._enabled.call(this, a, c);
                    }),
                    (q.totalTime = function (b, c, d) {
                        this._forcingPlayhead = !0;
                        var e = a.prototype.totalTime.apply(this, arguments);
                        return (this._forcingPlayhead = !1), e;
                    }),
                    (q.duration = function (a) {
                        return arguments.length ? (0 !== this.duration() && 0 !== a && this.timeScale(this._duration / a), this) : (this._dirty && this.totalDuration(), this._duration);
                    }),
                    (q.totalDuration = function (a) {
                        if (!arguments.length) {
                            if (this._dirty) {
                                for (var b, c, d = 0, e = this._last, f = 999999999999; e; )
                                    (b = e._prev),
                                        e._dirty && e.totalDuration(),
                                        e._startTime > f && this._sortChildren && !e._paused && !this._calculatingDuration
                                            ? ((this._calculatingDuration = 1), this.add(e, e._startTime - e._delay), (this._calculatingDuration = 0))
                                            : (f = e._startTime),
                                        e._startTime < 0 &&
                                            !e._paused &&
                                            ((d -= e._startTime),
                                            this._timeline.smoothChildTiming && ((this._startTime += e._startTime / this._timeScale), (this._time -= e._startTime), (this._totalTime -= e._startTime), (this._rawPrevTime -= e._startTime)),
                                            this.shiftChildren(-e._startTime, !1, -9999999999),
                                            (f = 0)),
                                        (c = e._startTime + e._totalDuration / e._timeScale),
                                        c > d && (d = c),
                                        (e = b);
                                (this._duration = this._totalDuration = d), (this._dirty = !1);
                            }
                            return this._totalDuration;
                        }
                        return a && this.totalDuration() ? this.timeScale(this._totalDuration / a) : this;
                    }),
                    (q.paused = function (b) {
                        if (!b) for (var c = this._first, d = this._time; c; ) c._startTime === d && "isPause" === c.data && (c._rawPrevTime = 0), (c = c._next);
                        return a.prototype.paused.apply(this, arguments);
                    }),
                    (q.usesFrames = function () {
                        for (var b = this._timeline; b._timeline; ) b = b._timeline;
                        return b === a._rootFramesTimeline;
                    }),
                    (q.rawTime = function (a) {
                        return a && (this._paused || (this._repeat && this.time() > 0 && this.totalProgress() < 1))
                            ? this._totalTime % (this._duration + this._repeatDelay)
                            : this._paused
                            ? this._totalTime
                            : (this._timeline.rawTime(a) - this._startTime) * this._timeScale;
                    }),
                    d
                );
            },
            !0
        ),
        _gsScope._gsDefine(
            "TimelineMax",
            ["TimelineLite", "TweenLite", "easing.Ease"],
            function (a, b, c) {
                var d = function (b) {
                        a.call(this, b), (this._repeat = this.vars.repeat || 0), (this._repeatDelay = this.vars.repeatDelay || 0), (this._cycle = 0), (this._yoyo = this.vars.yoyo === !0), (this._dirty = !0);
                    },
                    e = 1e-10,
                    f = b._internals,
                    g = f.lazyTweens,
                    h = f.lazyRender,
                    i = _gsScope._gsDefine.globals,
                    j = new c(null, null, 1, 0),
                    k = (d.prototype = new a());
                return (
                    (k.constructor = d),
                    (k.kill()._gc = !1),
                    (d.version = "1.20.4"),
                    (k.invalidate = function () {
                        return (this._yoyo = this.vars.yoyo === !0), (this._repeat = this.vars.repeat || 0), (this._repeatDelay = this.vars.repeatDelay || 0), this._uncache(!0), a.prototype.invalidate.call(this);
                    }),
                    (k.addCallback = function (a, c, d, e) {
                        return this.add(b.delayedCall(0, a, d, e), c);
                    }),
                    (k.removeCallback = function (a, b) {
                        if (a)
                            if (null == b) this._kill(null, a);
                            else for (var c = this.getTweensOf(a, !1), d = c.length, e = this._parseTimeOrLabel(b); --d > -1; ) c[d]._startTime === e && c[d]._enabled(!1, !1);
                        return this;
                    }),
                    (k.removePause = function (b) {
                        return this.removeCallback(a._internals.pauseCallback, b);
                    }),
                    (k.tweenTo = function (a, c) {
                        c = c || {};
                        var d,
                            e,
                            f,
                            g = { ease: j, useFrames: this.usesFrames(), immediateRender: !1, lazy: !1 },
                            h = (c.repeat && i.TweenMax) || b;
                        for (e in c) g[e] = c[e];
                        return (
                            (g.time = this._parseTimeOrLabel(a)),
                            (d = Math.abs(Number(g.time) - this._time) / this._timeScale || 0.001),
                            (f = new h(this, d, g)),
                            (g.onStart = function () {
                                f.target.paused(!0),
                                    f.vars.time === f.target.time() || d !== f.duration() || f.isFromTo || f.duration(Math.abs(f.vars.time - f.target.time()) / f.target._timeScale).render(f.time(), !0, !0),
                                    c.onStart && c.onStart.apply(c.onStartScope || c.callbackScope || f, c.onStartParams || []);
                            }),
                            f
                        );
                    }),
                    (k.tweenFromTo = function (a, b, c) {
                        (c = c || {}), (a = this._parseTimeOrLabel(a)), (c.startAt = { onComplete: this.seek, onCompleteParams: [a], callbackScope: this }), (c.immediateRender = c.immediateRender !== !1);
                        var d = this.tweenTo(b, c);
                        return (d.isFromTo = 1), d.duration(Math.abs(d.vars.time - a) / this._timeScale || 0.001);
                    }),
                    (k.render = function (a, b, c) {
                        this._gc && this._enabled(!0, !1);
                        var d,
                            f,
                            i,
                            j,
                            k,
                            l,
                            m,
                            n,
                            o = this._time,
                            p = this._dirty ? this.totalDuration() : this._totalDuration,
                            q = this._duration,
                            r = this._totalTime,
                            s = this._startTime,
                            t = this._timeScale,
                            u = this._rawPrevTime,
                            v = this._paused,
                            w = this._cycle;
                        if ((o !== this._time && (a += this._time - o), a >= p - 1e-7 && a >= 0))
                            this._locked || ((this._totalTime = p), (this._cycle = this._repeat)),
                                this._reversed ||
                                    this._hasPausedChild() ||
                                    ((f = !0),
                                    (j = "onComplete"),
                                    (k = !!this._timeline.autoRemoveChildren),
                                    0 === this._duration && ((0 >= a && a >= -1e-7) || 0 > u || u === e) && u !== a && this._first && ((k = !0), u > e && (j = "onReverseComplete"))),
                                (this._rawPrevTime = this._duration || !b || a || this._rawPrevTime === a ? a : e),
                                this._yoyo && 0 !== (1 & this._cycle) ? (this._time = a = 0) : ((this._time = q), (a = q + 1e-4));
                        else if (1e-7 > a)
                            if (
                                (this._locked || (this._totalTime = this._cycle = 0),
                                (this._time = 0),
                                (0 !== o || (0 === q && u !== e && (u > 0 || (0 > a && u >= 0)) && !this._locked)) && ((j = "onReverseComplete"), (f = this._reversed)),
                                0 > a)
                            )
                                (this._active = !1), this._timeline.autoRemoveChildren && this._reversed ? ((k = f = !0), (j = "onReverseComplete")) : u >= 0 && this._first && (k = !0), (this._rawPrevTime = a);
                            else {
                                if (((this._rawPrevTime = q || !b || a || this._rawPrevTime === a ? a : e), 0 === a && f)) for (d = this._first; d && 0 === d._startTime; ) d._duration || (f = !1), (d = d._next);
                                (a = 0), this._initted || (k = !0);
                            }
                        else if (
                            (0 === q && 0 > u && (k = !0),
                            (this._time = this._rawPrevTime = a),
                            this._locked ||
                                ((this._totalTime = a),
                                0 !== this._repeat &&
                                    ((l = q + this._repeatDelay),
                                    (this._cycle = (this._totalTime / l) >> 0),
                                    0 !== this._cycle && this._cycle === this._totalTime / l && a >= r && this._cycle--,
                                    (this._time = this._totalTime - this._cycle * l),
                                    this._yoyo && 0 !== (1 & this._cycle) && (this._time = q - this._time),
                                    this._time > q ? ((this._time = q), (a = q + 1e-4)) : this._time < 0 ? (this._time = a = 0) : (a = this._time))),
                            this._hasPause && !this._forcingPlayhead && !b)
                        ) {
                            if (((a = this._time), a >= o || (this._repeat && w !== this._cycle)))
                                for (d = this._first; d && d._startTime <= a && !m; ) d._duration || "isPause" !== d.data || d.ratio || (0 === d._startTime && 0 === this._rawPrevTime) || (m = d), (d = d._next);
                            else for (d = this._last; d && d._startTime >= a && !m; ) d._duration || ("isPause" === d.data && d._rawPrevTime > 0 && (m = d)), (d = d._prev);
                            m && m._startTime < q && ((this._time = a = m._startTime), (this._totalTime = a + this._cycle * (this._totalDuration + this._repeatDelay)));
                        }
                        if (this._cycle !== w && !this._locked) {
                            var x = this._yoyo && 0 !== (1 & w),
                                y = x === (this._yoyo && 0 !== (1 & this._cycle)),
                                z = this._totalTime,
                                A = this._cycle,
                                B = this._rawPrevTime,
                                C = this._time;
                            if (
                                ((this._totalTime = w * q),
                                this._cycle < w ? (x = !x) : (this._totalTime += q),
                                (this._time = o),
                                (this._rawPrevTime = 0 === q ? u - 1e-4 : u),
                                (this._cycle = w),
                                (this._locked = !0),
                                (o = x ? 0 : q),
                                this.render(o, b, 0 === q),
                                b || this._gc || (this.vars.onRepeat && ((this._cycle = A), (this._locked = !1), this._callback("onRepeat"))),
                                o !== this._time)
                            )
                                return;
                            if ((y && ((this._cycle = w), (this._locked = !0), (o = x ? q + 1e-4 : -1e-4), this.render(o, !0, !1)), (this._locked = !1), this._paused && !v)) return;
                            (this._time = C), (this._totalTime = z), (this._cycle = A), (this._rawPrevTime = B);
                        }
                        if (!((this._time !== o && this._first) || c || k || m)) return void (r !== this._totalTime && this._onUpdate && (b || this._callback("onUpdate")));
                        if (
                            (this._initted || (this._initted = !0),
                            this._active || (!this._paused && this._totalTime !== r && a > 0 && (this._active = !0)),
                            0 === r && this.vars.onStart && ((0 === this._totalTime && this._totalDuration) || b || this._callback("onStart")),
                            (n = this._time),
                            n >= o)
                        )
                            for (d = this._first; d && ((i = d._next), n === this._time && (!this._paused || v)); )
                                (d._active || (d._startTime <= this._time && !d._paused && !d._gc)) &&
                                    (m === d && this.pause(), d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c)),
                                    (d = i);
                        else
                            for (d = this._last; d && ((i = d._prev), n === this._time && (!this._paused || v)); ) {
                                if (d._active || (d._startTime <= o && !d._paused && !d._gc)) {
                                    if (m === d) {
                                        for (m = d._prev; m && m.endTime() > this._time; ) m.render(m._reversed ? m.totalDuration() - (a - m._startTime) * m._timeScale : (a - m._startTime) * m._timeScale, b, c), (m = m._prev);
                                        (m = null), this.pause();
                                    }
                                    d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c);
                                }
                                d = i;
                            }
                        this._onUpdate && (b || (g.length && h(), this._callback("onUpdate"))),
                            j &&
                                (this._locked ||
                                    this._gc ||
                                    ((s === this._startTime || t !== this._timeScale) &&
                                        (0 === this._time || p >= this.totalDuration()) &&
                                        (f && (g.length && h(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), (this._active = !1)), !b && this.vars[j] && this._callback(j))));
                    }),
                    (k.getActive = function (a, b, c) {
                        null == a && (a = !0), null == b && (b = !0), null == c && (c = !1);
                        var d,
                            e,
                            f = [],
                            g = this.getChildren(a, b, c),
                            h = 0,
                            i = g.length;
                        for (d = 0; i > d; d++) (e = g[d]), e.isActive() && (f[h++] = e);
                        return f;
                    }),
                    (k.getLabelAfter = function (a) {
                        a || (0 !== a && (a = this._time));
                        var b,
                            c = this.getLabelsArray(),
                            d = c.length;
                        for (b = 0; d > b; b++) if (c[b].time > a) return c[b].name;
                        return null;
                    }),
                    (k.getLabelBefore = function (a) {
                        null == a && (a = this._time);
                        for (var b = this.getLabelsArray(), c = b.length; --c > -1; ) if (b[c].time < a) return b[c].name;
                        return null;
                    }),
                    (k.getLabelsArray = function () {
                        var a,
                            b = [],
                            c = 0;
                        for (a in this._labels) b[c++] = { time: this._labels[a], name: a };
                        return (
                            b.sort(function (a, b) {
                                return a.time - b.time;
                            }),
                            b
                        );
                    }),
                    (k.invalidate = function () {
                        return (this._locked = !1), a.prototype.invalidate.call(this);
                    }),
                    (k.progress = function (a, b) {
                        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - a : a) + this._cycle * (this._duration + this._repeatDelay), b) : this._time / this.duration() || 0;
                    }),
                    (k.totalProgress = function (a, b) {
                        return arguments.length ? this.totalTime(this.totalDuration() * a, b) : this._totalTime / this.totalDuration() || 0;
                    }),
                    (k.totalDuration = function (b) {
                        return arguments.length
                            ? -1 !== this._repeat && b
                                ? this.timeScale(this.totalDuration() / b)
                                : this
                            : (this._dirty && (a.prototype.totalDuration.call(this), (this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat)), this._totalDuration);
                    }),
                    (k.time = function (a, b) {
                        return arguments.length
                            ? (this._dirty && this.totalDuration(),
                              a > this._duration && (a = this._duration),
                              this._yoyo && 0 !== (1 & this._cycle) ? (a = this._duration - a + this._cycle * (this._duration + this._repeatDelay)) : 0 !== this._repeat && (a += this._cycle * (this._duration + this._repeatDelay)),
                              this.totalTime(a, b))
                            : this._time;
                    }),
                    (k.repeat = function (a) {
                        return arguments.length ? ((this._repeat = a), this._uncache(!0)) : this._repeat;
                    }),
                    (k.repeatDelay = function (a) {
                        return arguments.length ? ((this._repeatDelay = a), this._uncache(!0)) : this._repeatDelay;
                    }),
                    (k.yoyo = function (a) {
                        return arguments.length ? ((this._yoyo = a), this) : this._yoyo;
                    }),
                    (k.currentLabel = function (a) {
                        return arguments.length ? this.seek(a, !0) : this.getLabelBefore(this._time + 1e-8);
                    }),
                    d
                );
            },
            !0
        ),
        (function () {
            var a = 180 / Math.PI,
                b = [],
                c = [],
                d = [],
                e = {},
                f = _gsScope._gsDefine.globals,
                g = function (a, b, c, d) {
                    c === d && (c = d - (d - b) / 1e6), a === b && (b = a + (c - a) / 1e6), (this.a = a), (this.b = b), (this.c = c), (this.d = d), (this.da = d - a), (this.ca = c - a), (this.ba = b - a);
                },
                h = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
                i = function (a, b, c, d) {
                    var e = { a: a },
                        f = {},
                        g = {},
                        h = { c: d },
                        i = (a + b) / 2,
                        j = (b + c) / 2,
                        k = (c + d) / 2,
                        l = (i + j) / 2,
                        m = (j + k) / 2,
                        n = (m - l) / 8;
                    return (e.b = i + (a - i) / 4), (f.b = l + n), (e.c = f.a = (e.b + f.b) / 2), (f.c = g.a = (l + m) / 2), (g.b = m - n), (h.b = k + (d - k) / 4), (g.c = h.a = (g.b + h.b) / 2), [e, f, g, h];
                },
                j = function (a, e, f, g, h) {
                    var j,
                        k,
                        l,
                        m,
                        n,
                        o,
                        p,
                        q,
                        r,
                        s,
                        t,
                        u,
                        v,
                        w = a.length - 1,
                        x = 0,
                        y = a[0].a;
                    for (j = 0; w > j; j++)
                        (n = a[x]),
                            (k = n.a),
                            (l = n.d),
                            (m = a[x + 1].d),
                            h
                                ? ((t = b[j]),
                                  (u = c[j]),
                                  (v = ((u + t) * e * 0.25) / (g ? 0.5 : d[j] || 0.5)),
                                  (o = l - (l - k) * (g ? 0.5 * e : 0 !== t ? v / t : 0)),
                                  (p = l + (m - l) * (g ? 0.5 * e : 0 !== u ? v / u : 0)),
                                  (q = l - (o + (((p - o) * ((3 * t) / (t + u) + 0.5)) / 4 || 0))))
                                : ((o = l - (l - k) * e * 0.5), (p = l + (m - l) * e * 0.5), (q = l - (o + p) / 2)),
                            (o += q),
                            (p += q),
                            (n.c = r = o),
                            0 !== j ? (n.b = y) : (n.b = y = n.a + 0.6 * (n.c - n.a)),
                            (n.da = l - k),
                            (n.ca = r - k),
                            (n.ba = y - k),
                            f ? ((s = i(k, y, r, l)), a.splice(x, 1, s[0], s[1], s[2], s[3]), (x += 4)) : x++,
                            (y = p);
                    (n = a[x]), (n.b = y), (n.c = y + 0.4 * (n.d - y)), (n.da = n.d - n.a), (n.ca = n.c - n.a), (n.ba = y - n.a), f && ((s = i(n.a, y, n.c, n.d)), a.splice(x, 1, s[0], s[1], s[2], s[3]));
                },
                k = function (a, d, e, f) {
                    var h,
                        i,
                        j,
                        k,
                        l,
                        m,
                        n = [];
                    if (f) for (a = [f].concat(a), i = a.length; --i > -1; ) "string" == typeof (m = a[i][d]) && "=" === m.charAt(1) && (a[i][d] = f[d] + Number(m.charAt(0) + m.substr(2)));
                    if (((h = a.length - 2), 0 > h)) return (n[0] = new g(a[0][d], 0, 0, a[0][d])), n;
                    for (i = 0; h > i; i++) (j = a[i][d]), (k = a[i + 1][d]), (n[i] = new g(j, 0, 0, k)), e && ((l = a[i + 2][d]), (b[i] = (b[i] || 0) + (k - j) * (k - j)), (c[i] = (c[i] || 0) + (l - k) * (l - k)));
                    return (n[i] = new g(a[i][d], 0, 0, a[i + 1][d])), n;
                },
                l = function (a, f, g, i, l, m) {
                    var n,
                        o,
                        p,
                        q,
                        r,
                        s,
                        t,
                        u,
                        v = {},
                        w = [],
                        x = m || a[0];
                    (l = "string" == typeof l ? "," + l + "," : h), null == f && (f = 1);
                    for (o in a[0]) w.push(o);
                    if (a.length > 1) {
                        for (u = a[a.length - 1], t = !0, n = w.length; --n > -1; )
                            if (((o = w[n]), Math.abs(x[o] - u[o]) > 0.05)) {
                                t = !1;
                                break;
                            }
                        t && ((a = a.concat()), m && a.unshift(m), a.push(a[1]), (m = a[a.length - 3]));
                    }
                    for (b.length = c.length = d.length = 0, n = w.length; --n > -1; ) (o = w[n]), (e[o] = -1 !== l.indexOf("," + o + ",")), (v[o] = k(a, o, e[o], m));
                    for (n = b.length; --n > -1; ) (b[n] = Math.sqrt(b[n])), (c[n] = Math.sqrt(c[n]));
                    if (!i) {
                        for (n = w.length; --n > -1; ) if (e[o]) for (p = v[w[n]], s = p.length - 1, q = 0; s > q; q++) (r = p[q + 1].da / c[q] + p[q].da / b[q] || 0), (d[q] = (d[q] || 0) + r * r);
                        for (n = d.length; --n > -1; ) d[n] = Math.sqrt(d[n]);
                    }
                    for (n = w.length, q = g ? 4 : 1; --n > -1; ) (o = w[n]), (p = v[o]), j(p, f, g, i, e[o]), t && (p.splice(0, q), p.splice(p.length - q, q));
                    return v;
                },
                m = function (a, b, c) {
                    b = b || "soft";
                    var d,
                        e,
                        f,
                        h,
                        i,
                        j,
                        k,
                        l,
                        m,
                        n,
                        o,
                        p = {},
                        q = "cubic" === b ? 3 : 2,
                        r = "soft" === b,
                        s = [];
                    if ((r && c && (a = [c].concat(a)), null == a || a.length < q + 1)) throw "invalid Bezier data";
                    for (m in a[0]) s.push(m);
                    for (j = s.length; --j > -1; ) {
                        for (m = s[j], p[m] = i = [], n = 0, l = a.length, k = 0; l > k; k++)
                            (d = null == c ? a[k][m] : "string" == typeof (o = a[k][m]) && "=" === o.charAt(1) ? c[m] + Number(o.charAt(0) + o.substr(2)) : Number(o)), r && k > 1 && l - 1 > k && (i[n++] = (d + i[n - 2]) / 2), (i[n++] = d);
                        for (l = n - q + 1, n = 0, k = 0; l > k; k += q) (d = i[k]), (e = i[k + 1]), (f = i[k + 2]), (h = 2 === q ? 0 : i[k + 3]), (i[n++] = o = 3 === q ? new g(d, e, f, h) : new g(d, (2 * e + d) / 3, (2 * e + f) / 3, f));
                        i.length = n;
                    }
                    return p;
                },
                n = function (a, b, c) {
                    for (var d, e, f, g, h, i, j, k, l, m, n, o = 1 / c, p = a.length; --p > -1; )
                        for (m = a[p], f = m.a, g = m.d - f, h = m.c - f, i = m.b - f, d = e = 0, k = 1; c >= k; k++)
                            (j = o * k), (l = 1 - j), (d = e - (e = (j * j * g + 3 * l * (j * h + l * i)) * j)), (n = p * c + k - 1), (b[n] = (b[n] || 0) + d * d);
                },
                o = function (a, b) {
                    b = b >> 0 || 6;
                    var c,
                        d,
                        e,
                        f,
                        g = [],
                        h = [],
                        i = 0,
                        j = 0,
                        k = b - 1,
                        l = [],
                        m = [];
                    for (c in a) n(a[c], g, b);
                    for (e = g.length, d = 0; e > d; d++) (i += Math.sqrt(g[d])), (f = d % b), (m[f] = i), f === k && ((j += i), (f = (d / b) >> 0), (l[f] = m), (h[f] = j), (i = 0), (m = []));
                    return { length: j, lengths: h, segments: l };
                },
                p = _gsScope._gsDefine.plugin({
                    propName: "bezier",
                    priority: -1,
                    version: "1.3.8",
                    API: 2,
                    global: !0,
                    init: function (a, b, c) {
                        (this._target = a), b instanceof Array && (b = { values: b }), (this._func = {}), (this._mod = {}), (this._props = []), (this._timeRes = null == b.timeResolution ? 6 : parseInt(b.timeResolution, 10));
                        var d,
                            e,
                            f,
                            g,
                            h,
                            i = b.values || [],
                            j = {},
                            k = i[0],
                            n = b.autoRotate || c.vars.orientToBezier;
                        this._autoRotate = n ? (n instanceof Array ? n : [["x", "y", "rotation", n === !0 ? 0 : Number(n) || 0]]) : null;
                        for (d in k) this._props.push(d);
                        for (f = this._props.length; --f > -1; )
                            (d = this._props[f]),
                                this._overwriteProps.push(d),
                                (e = this._func[d] = "function" == typeof a[d]),
                                (j[d] = e ? a[d.indexOf("set") || "function" != typeof a["get" + d.substr(3)] ? d : "get" + d.substr(3)]() : parseFloat(a[d])),
                                h || (j[d] !== i[0][d] && (h = j));
                        if (
                            ((this._beziers = "cubic" !== b.type && "quadratic" !== b.type && "soft" !== b.type ? l(i, isNaN(b.curviness) ? 1 : b.curviness, !1, "thruBasic" === b.type, b.correlate, h) : m(i, b.type, j)),
                            (this._segCount = this._beziers[d].length),
                            this._timeRes)
                        ) {
                            var p = o(this._beziers, this._timeRes);
                            (this._length = p.length),
                                (this._lengths = p.lengths),
                                (this._segments = p.segments),
                                (this._l1 = this._li = this._s1 = this._si = 0),
                                (this._l2 = this._lengths[0]),
                                (this._curSeg = this._segments[0]),
                                (this._s2 = this._curSeg[0]),
                                (this._prec = 1 / this._curSeg.length);
                        }
                        if ((n = this._autoRotate))
                            for (this._initialRotations = [], n[0] instanceof Array || (this._autoRotate = n = [n]), f = n.length; --f > -1; ) {
                                for (g = 0; 3 > g; g++) (d = n[f][g]), (this._func[d] = "function" == typeof a[d] && a[d.indexOf("set") || "function" != typeof a["get" + d.substr(3)] ? d : "get" + d.substr(3)]);
                                (d = n[f][2]), (this._initialRotations[f] = (this._func[d] ? this._func[d].call(this._target) : this._target[d]) || 0), this._overwriteProps.push(d);
                            }
                        return (this._startRatio = c.vars.runBackwards ? 1 : 0), !0;
                    },
                    set: function (b) {
                        var c,
                            d,
                            e,
                            f,
                            g,
                            h,
                            i,
                            j,
                            k,
                            l,
                            m = this._segCount,
                            n = this._func,
                            o = this._target,
                            p = b !== this._startRatio;
                        if (this._timeRes) {
                            if (((k = this._lengths), (l = this._curSeg), (b *= this._length), (e = this._li), b > this._l2 && m - 1 > e)) {
                                for (j = m - 1; j > e && (this._l2 = k[++e]) <= b; );
                                (this._l1 = k[e - 1]), (this._li = e), (this._curSeg = l = this._segments[e]), (this._s2 = l[(this._s1 = this._si = 0)]);
                            } else if (b < this._l1 && e > 0) {
                                for (; e > 0 && (this._l1 = k[--e]) >= b; );
                                0 === e && b < this._l1 ? (this._l1 = 0) : e++, (this._l2 = k[e]), (this._li = e), (this._curSeg = l = this._segments[e]), (this._s1 = l[(this._si = l.length - 1) - 1] || 0), (this._s2 = l[this._si]);
                            }
                            if (((c = e), (b -= this._l1), (e = this._si), b > this._s2 && e < l.length - 1)) {
                                for (j = l.length - 1; j > e && (this._s2 = l[++e]) <= b; );
                                (this._s1 = l[e - 1]), (this._si = e);
                            } else if (b < this._s1 && e > 0) {
                                for (; e > 0 && (this._s1 = l[--e]) >= b; );
                                0 === e && b < this._s1 ? (this._s1 = 0) : e++, (this._s2 = l[e]), (this._si = e);
                            }
                            h = (e + (b - this._s1) / (this._s2 - this._s1)) * this._prec || 0;
                        } else (c = 0 > b ? 0 : b >= 1 ? m - 1 : (m * b) >> 0), (h = (b - c * (1 / m)) * m);
                        for (d = 1 - h, e = this._props.length; --e > -1; )
                            (f = this._props[e]), (g = this._beziers[f][c]), (i = (h * h * g.da + 3 * d * (h * g.ca + d * g.ba)) * h + g.a), this._mod[f] && (i = this._mod[f](i, o)), n[f] ? o[f](i) : (o[f] = i);
                        if (this._autoRotate) {
                            var q,
                                r,
                                s,
                                t,
                                u,
                                v,
                                w,
                                x = this._autoRotate;
                            for (e = x.length; --e > -1; )
                                (f = x[e][2]),
                                    (v = x[e][3] || 0),
                                    (w = x[e][4] === !0 ? 1 : a),
                                    (g = this._beziers[x[e][0]]),
                                    (q = this._beziers[x[e][1]]),
                                    g &&
                                        q &&
                                        ((g = g[c]),
                                        (q = q[c]),
                                        (r = g.a + (g.b - g.a) * h),
                                        (t = g.b + (g.c - g.b) * h),
                                        (r += (t - r) * h),
                                        (t += (g.c + (g.d - g.c) * h - t) * h),
                                        (s = q.a + (q.b - q.a) * h),
                                        (u = q.b + (q.c - q.b) * h),
                                        (s += (u - s) * h),
                                        (u += (q.c + (q.d - q.c) * h - u) * h),
                                        (i = p ? Math.atan2(u - s, t - r) * w + v : this._initialRotations[e]),
                                        this._mod[f] && (i = this._mod[f](i, o)),
                                        n[f] ? o[f](i) : (o[f] = i));
                        }
                    },
                }),
                q = p.prototype;
            (p.bezierThrough = l),
                (p.cubicToQuadratic = i),
                (p._autoCSS = !0),
                (p.quadraticToCubic = function (a, b, c) {
                    return new g(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
                }),
                (p._cssRegister = function () {
                    var a = f.CSSPlugin;
                    if (a) {
                        var b = a._internals,
                            c = b._parseToProxy,
                            d = b._setPluginRatio,
                            e = b.CSSPropTween;
                        b._registerComplexSpecialProp("bezier", {
                            parser: function (a, b, f, g, h, i) {
                                b instanceof Array && (b = { values: b }), (i = new p());
                                var j,
                                    k,
                                    l,
                                    m = b.values,
                                    n = m.length - 1,
                                    o = [],
                                    q = {};
                                if (0 > n) return h;
                                for (j = 0; n >= j; j++) (l = c(a, m[j], g, h, i, n !== j)), (o[j] = l.end);
                                for (k in b) q[k] = b[k];
                                return (
                                    (q.values = o),
                                    (h = new e(a, "bezier", 0, 0, l.pt, 2)),
                                    (h.data = l),
                                    (h.plugin = i),
                                    (h.setRatio = d),
                                    0 === q.autoRotate && (q.autoRotate = !0),
                                    !q.autoRotate ||
                                        q.autoRotate instanceof Array ||
                                        ((j = q.autoRotate === !0 ? 0 : Number(q.autoRotate)), (q.autoRotate = null != l.end.left ? [["left", "top", "rotation", j, !1]] : null != l.end.x && [["x", "y", "rotation", j, !1]])),
                                    q.autoRotate && (g._transform || g._enableTransforms(!1), (l.autoRotate = g._target._gsTransform), (l.proxy.rotation = l.autoRotate.rotation || 0), g._overwriteProps.push("rotation")),
                                    i._onInitTween(l.proxy, q, g._tween),
                                    h
                                );
                            },
                        });
                    }
                }),
                (q._mod = function (a) {
                    for (var b, c = this._overwriteProps, d = c.length; --d > -1; ) (b = a[c[d]]), b && "function" == typeof b && (this._mod[c[d]] = b);
                }),
                (q._kill = function (a) {
                    var b,
                        c,
                        d = this._props;
                    for (b in this._beziers) if (b in a) for (delete this._beziers[b], delete this._func[b], c = d.length; --c > -1; ) d[c] === b && d.splice(c, 1);
                    if ((d = this._autoRotate)) for (c = d.length; --c > -1; ) a[d[c][2]] && d.splice(c, 1);
                    return this._super._kill.call(this, a);
                });
        })(),
        _gsScope._gsDefine(
            "plugins.CSSPlugin",
            ["plugins.TweenPlugin", "TweenLite"],
            function (a, b) {
                var c,
                    d,
                    e,
                    f,
                    g = function () {
                        a.call(this, "css"), (this._overwriteProps.length = 0), (this.setRatio = g.prototype.setRatio);
                    },
                    h = _gsScope._gsDefine.globals,
                    i = {},
                    j = (g.prototype = new a("css"));
                (j.constructor = g),
                    (g.version = "1.20.4"),
                    (g.API = 2),
                    (g.defaultTransformPerspective = 0),
                    (g.defaultSkewType = "compensated"),
                    (g.defaultSmoothOrigin = !0),
                    (j = "px"),
                    (g.suffixMap = { top: j, right: j, bottom: j, left: j, width: j, height: j, fontSize: j, padding: j, margin: j, perspective: j, lineHeight: "" });
                var k,
                    l,
                    m,
                    n,
                    o,
                    p,
                    q,
                    r,
                    s = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
                    t = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
                    u = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,
                    v = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,
                    w = /(?:\d|\-|\+|=|#|\.)*/g,
                    x = /opacity *= *([^)]*)/i,
                    y = /opacity:([^;]*)/i,
                    z = /alpha\(opacity *=.+?\)/i,
                    A = /^(rgb|hsl)/,
                    B = /([A-Z])/g,
                    C = /-([a-z])/gi,
                    D = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,
                    E = function (a, b) {
                        return b.toUpperCase();
                    },
                    F = /(?:Left|Right|Width)/i,
                    G = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
                    H = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
                    I = /,(?=[^\)]*(?:\(|$))/gi,
                    J = /[\s,\(]/i,
                    K = Math.PI / 180,
                    L = 180 / Math.PI,
                    M = {},
                    N = { style: {} },
                    O = _gsScope.document || {
                        createElement: function () {
                            return N;
                        },
                    },
                    P = function (a, b) {
                        return O.createElementNS ? O.createElementNS(b || "http://www.w3.org/1999/xhtml", a) : O.createElement(a);
                    },
                    Q = P("div"),
                    R = P("img"),
                    S = (g._internals = { _specialProps: i }),
                    T = (_gsScope.navigator || {}).userAgent || "",
                    U = (function () {
                        var a = T.indexOf("Android"),
                            b = P("a");
                        return (
                            (m = -1 !== T.indexOf("Safari") && -1 === T.indexOf("Chrome") && (-1 === a || parseFloat(T.substr(a + 8, 2)) > 3)),
                            (o = m && parseFloat(T.substr(T.indexOf("Version/") + 8, 2)) < 6),
                            (n = -1 !== T.indexOf("Firefox")),
                            (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(T) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(T)) && (p = parseFloat(RegExp.$1)),
                            !!b && ((b.style.cssText = "top:1px;opacity:.55;"), /^0.55/.test(b.style.opacity))
                        );
                    })(),
                    V = function (a) {
                        return x.test("string" == typeof a ? a : (a.currentStyle ? a.currentStyle.filter : a.style.filter) || "") ? parseFloat(RegExp.$1) / 100 : 1;
                    },
                    W = function (a) {
                        _gsScope.console && console.log(a);
                    },
                    X = "",
                    Y = "",
                    Z = function (a, b) {
                        b = b || Q;
                        var c,
                            d,
                            e = b.style;
                        if (void 0 !== e[a]) return a;
                        for (a = a.charAt(0).toUpperCase() + a.substr(1), c = ["O", "Moz", "ms", "Ms", "Webkit"], d = 5; --d > -1 && void 0 === e[c[d] + a]; );
                        return d >= 0 ? ((Y = 3 === d ? "ms" : c[d]), (X = "-" + Y.toLowerCase() + "-"), Y + a) : null;
                    },
                    $ = O.defaultView ? O.defaultView.getComputedStyle : function () {},
                    _ = (g.getStyle = function (a, b, c, d, e) {
                        var f;
                        return U || "opacity" !== b
                            ? (!d && a.style[b] ? (f = a.style[b]) : (c = c || $(a)) ? (f = c[b] || c.getPropertyValue(b) || c.getPropertyValue(b.replace(B, "-$1").toLowerCase())) : a.currentStyle && (f = a.currentStyle[b]),
                              null == e || (f && "none" !== f && "auto" !== f && "auto auto" !== f) ? f : e)
                            : V(a);
                    }),
                    aa = (S.convertToPixels = function (a, c, d, e, f) {
                        if ("px" === e || (!e && "lineHeight" !== c)) return d;
                        if ("auto" === e || !d) return 0;
                        var h,
                            i,
                            j,
                            k = F.test(c),
                            l = a,
                            m = Q.style,
                            n = 0 > d,
                            o = 1 === d;
                        if ((n && (d = -d), o && (d *= 100), "lineHeight" !== c || e))
                            if ("%" === e && -1 !== c.indexOf("border")) h = (d / 100) * (k ? a.clientWidth : a.clientHeight);
                            else {
                                if (((m.cssText = "border:0 solid red;position:" + _(a, "position") + ";line-height:0;"), "%" !== e && l.appendChild && "v" !== e.charAt(0) && "rem" !== e))
                                    m[k ? "borderLeftWidth" : "borderTopWidth"] = d + e;
                                else {
                                    if (((l = a.parentNode || O.body), -1 !== _(l, "display").indexOf("flex") && (m.position = "absolute"), (i = l._gsCache), (j = b.ticker.frame), i && k && i.time === j)) return (i.width * d) / 100;
                                    m[k ? "width" : "height"] = d + e;
                                }
                                l.appendChild(Q),
                                    (h = parseFloat(Q[k ? "offsetWidth" : "offsetHeight"])),
                                    l.removeChild(Q),
                                    k && "%" === e && g.cacheWidths !== !1 && ((i = l._gsCache = l._gsCache || {}), (i.time = j), (i.width = (h / d) * 100)),
                                    0 !== h || f || (h = aa(a, c, d, e, !0));
                            }
                        else (i = $(a).lineHeight), (a.style.lineHeight = d), (h = parseFloat($(a).lineHeight)), (a.style.lineHeight = i);
                        return o && (h /= 100), n ? -h : h;
                    }),
                    ba = (S.calculateOffset = function (a, b, c) {
                        if ("absolute" !== _(a, "position", c)) return 0;
                        var d = "left" === b ? "Left" : "Top",
                            e = _(a, "margin" + d, c);
                        return a["offset" + d] - (aa(a, b, parseFloat(e), e.replace(w, "")) || 0);
                    }),
                    ca = function (a, b) {
                        var c,
                            d,
                            e,
                            f = {};
                        if ((b = b || $(a, null)))
                            if ((c = b.length)) for (; --c > -1; ) (e = b[c]), (-1 === e.indexOf("-transform") || Da === e) && (f[e.replace(C, E)] = b.getPropertyValue(e));
                            else for (c in b) (-1 === c.indexOf("Transform") || Ca === c) && (f[c] = b[c]);
                        else if ((b = a.currentStyle || a.style)) for (c in b) "string" == typeof c && void 0 === f[c] && (f[c.replace(C, E)] = b[c]);
                        return (
                            U || (f.opacity = V(a)),
                            (d = Ra(a, b, !1)),
                            (f.rotation = d.rotation),
                            (f.skewX = d.skewX),
                            (f.scaleX = d.scaleX),
                            (f.scaleY = d.scaleY),
                            (f.x = d.x),
                            (f.y = d.y),
                            Fa && ((f.z = d.z), (f.rotationX = d.rotationX), (f.rotationY = d.rotationY), (f.scaleZ = d.scaleZ)),
                            f.filters && delete f.filters,
                            f
                        );
                    },
                    da = function (a, b, c, d, e) {
                        var f,
                            g,
                            h,
                            i = {},
                            j = a.style;
                        for (g in c)
                            "cssText" !== g &&
                                "length" !== g &&
                                isNaN(g) &&
                                (b[g] !== (f = c[g]) || (e && e[g])) &&
                                -1 === g.indexOf("Origin") &&
                                ("number" == typeof f || "string" == typeof f) &&
                                ((i[g] = "auto" !== f || ("left" !== g && "top" !== g) ? (("" !== f && "auto" !== f && "none" !== f) || "string" != typeof b[g] || "" === b[g].replace(v, "") ? f : 0) : ba(a, g)),
                                void 0 !== j[g] && (h = new sa(j, g, j[g], h)));
                        if (d) for (g in d) "className" !== g && (i[g] = d[g]);
                        return { difs: i, firstMPT: h };
                    },
                    ea = { width: ["Left", "Right"], height: ["Top", "Bottom"] },
                    fa = ["marginLeft", "marginRight", "marginTop", "marginBottom"],
                    ga = function (a, b, c) {
                        if ("svg" === (a.nodeName + "").toLowerCase()) return (c || $(a))[b] || 0;
                        if (a.getCTM && Oa(a)) return a.getBBox()[b] || 0;
                        var d = parseFloat("width" === b ? a.offsetWidth : a.offsetHeight),
                            e = ea[b],
                            f = e.length;
                        for (c = c || $(a, null); --f > -1; ) (d -= parseFloat(_(a, "padding" + e[f], c, !0)) || 0), (d -= parseFloat(_(a, "border" + e[f] + "Width", c, !0)) || 0);
                        return d;
                    },
                    ha = function (a, b) {
                        if ("contain" === a || "auto" === a || "auto auto" === a) return a + " ";
                        (null == a || "" === a) && (a = "0 0");
                        var c,
                            d = a.split(" "),
                            e = -1 !== a.indexOf("left") ? "0%" : -1 !== a.indexOf("right") ? "100%" : d[0],
                            f = -1 !== a.indexOf("top") ? "0%" : -1 !== a.indexOf("bottom") ? "100%" : d[1];
                        if (d.length > 3 && !b) {
                            for (d = a.split(", ").join(",").split(","), a = [], c = 0; c < d.length; c++) a.push(ha(d[c]));
                            return a.join(",");
                        }
                        return (
                            null == f ? (f = "center" === e ? "50%" : "0") : "center" === f && (f = "50%"),
                            ("center" === e || (isNaN(parseFloat(e)) && -1 === (e + "").indexOf("="))) && (e = "50%"),
                            (a = e + " " + f + (d.length > 2 ? " " + d[2] : "")),
                            b &&
                                ((b.oxp = -1 !== e.indexOf("%")),
                                (b.oyp = -1 !== f.indexOf("%")),
                                (b.oxr = "=" === e.charAt(1)),
                                (b.oyr = "=" === f.charAt(1)),
                                (b.ox = parseFloat(e.replace(v, ""))),
                                (b.oy = parseFloat(f.replace(v, ""))),
                                (b.v = a)),
                            b || a
                        );
                    },
                    ia = function (a, b) {
                        return "function" == typeof a && (a = a(r, q)), "string" == typeof a && "=" === a.charAt(1) ? parseInt(a.charAt(0) + "1", 10) * parseFloat(a.substr(2)) : parseFloat(a) - parseFloat(b) || 0;
                    },
                    ja = function (a, b) {
                        return "function" == typeof a && (a = a(r, q)), null == a ? b : "string" == typeof a && "=" === a.charAt(1) ? parseInt(a.charAt(0) + "1", 10) * parseFloat(a.substr(2)) + b : parseFloat(a) || 0;
                    },
                    ka = function (a, b, c, d) {
                        var e,
                            f,
                            g,
                            h,
                            i,
                            j = 1e-6;
                        return (
                            "function" == typeof a && (a = a(r, q)),
                            null == a
                                ? (h = b)
                                : "number" == typeof a
                                ? (h = a)
                                : ((e = 360),
                                  (f = a.split("_")),
                                  (i = "=" === a.charAt(1)),
                                  (g = (i ? parseInt(a.charAt(0) + "1", 10) * parseFloat(f[0].substr(2)) : parseFloat(f[0])) * (-1 === a.indexOf("rad") ? 1 : L) - (i ? 0 : b)),
                                  f.length &&
                                      (d && (d[c] = b + g),
                                      -1 !== a.indexOf("short") && ((g %= e), g !== g % (e / 2) && (g = 0 > g ? g + e : g - e)),
                                      -1 !== a.indexOf("_cw") && 0 > g ? (g = ((g + 9999999999 * e) % e) - ((g / e) | 0) * e) : -1 !== a.indexOf("ccw") && g > 0 && (g = ((g - 9999999999 * e) % e) - ((g / e) | 0) * e)),
                                  (h = b + g)),
                            j > h && h > -j && (h = 0),
                            h
                        );
                    },
                    la = {
                        aqua: [0, 255, 255],
                        lime: [0, 255, 0],
                        silver: [192, 192, 192],
                        black: [0, 0, 0],
                        maroon: [128, 0, 0],
                        teal: [0, 128, 128],
                        blue: [0, 0, 255],
                        navy: [0, 0, 128],
                        white: [255, 255, 255],
                        fuchsia: [255, 0, 255],
                        olive: [128, 128, 0],
                        yellow: [255, 255, 0],
                        orange: [255, 165, 0],
                        gray: [128, 128, 128],
                        purple: [128, 0, 128],
                        green: [0, 128, 0],
                        red: [255, 0, 0],
                        pink: [255, 192, 203],
                        cyan: [0, 255, 255],
                        transparent: [255, 255, 255, 0],
                    },
                    ma = function (a, b, c) {
                        return (a = 0 > a ? a + 1 : a > 1 ? a - 1 : a), (255 * (1 > 6 * a ? b + (c - b) * a * 6 : 0.5 > a ? c : 2 > 3 * a ? b + (c - b) * (2 / 3 - a) * 6 : b) + 0.5) | 0;
                    },
                    na = (g.parseColor = function (a, b) {
                        var c, d, e, f, g, h, i, j, k, l, m;
                        if (a)
                            if ("number" == typeof a) c = [a >> 16, (a >> 8) & 255, 255 & a];
                            else {
                                if (("," === a.charAt(a.length - 1) && (a = a.substr(0, a.length - 1)), la[a])) c = la[a];
                                else if ("#" === a.charAt(0))
                                    4 === a.length && ((d = a.charAt(1)), (e = a.charAt(2)), (f = a.charAt(3)), (a = "#" + d + d + e + e + f + f)), (a = parseInt(a.substr(1), 16)), (c = [a >> 16, (a >> 8) & 255, 255 & a]);
                                else if ("hsl" === a.substr(0, 3))
                                    if (((c = m = a.match(s)), b)) {
                                        if (-1 !== a.indexOf("=")) return a.match(t);
                                    } else
                                        (g = (Number(c[0]) % 360) / 360),
                                            (h = Number(c[1]) / 100),
                                            (i = Number(c[2]) / 100),
                                            (e = 0.5 >= i ? i * (h + 1) : i + h - i * h),
                                            (d = 2 * i - e),
                                            c.length > 3 && (c[3] = Number(c[3])),
                                            (c[0] = ma(g + 1 / 3, d, e)),
                                            (c[1] = ma(g, d, e)),
                                            (c[2] = ma(g - 1 / 3, d, e));
                                else c = a.match(s) || la.transparent;
                                (c[0] = Number(c[0])), (c[1] = Number(c[1])), (c[2] = Number(c[2])), c.length > 3 && (c[3] = Number(c[3]));
                            }
                        else c = la.black;
                        return (
                            b &&
                                !m &&
                                ((d = c[0] / 255),
                                (e = c[1] / 255),
                                (f = c[2] / 255),
                                (j = Math.max(d, e, f)),
                                (k = Math.min(d, e, f)),
                                (i = (j + k) / 2),
                                j === k ? (g = h = 0) : ((l = j - k), (h = i > 0.5 ? l / (2 - j - k) : l / (j + k)), (g = j === d ? (e - f) / l + (f > e ? 6 : 0) : j === e ? (f - d) / l + 2 : (d - e) / l + 4), (g *= 60)),
                                (c[0] = (g + 0.5) | 0),
                                (c[1] = (100 * h + 0.5) | 0),
                                (c[2] = (100 * i + 0.5) | 0)),
                            c
                        );
                    }),
                    oa = function (a, b) {
                        var c,
                            d,
                            e,
                            f = a.match(pa) || [],
                            g = 0,
                            h = "";
                        if (!f.length) return a;
                        for (c = 0; c < f.length; c++)
                            (d = f[c]),
                                (e = a.substr(g, a.indexOf(d, g) - g)),
                                (g += e.length + d.length),
                                (d = na(d, b)),
                                3 === d.length && d.push(1),
                                (h += e + (b ? "hsla(" + d[0] + "," + d[1] + "%," + d[2] + "%," + d[3] : "rgba(" + d.join(",")) + ")");
                        return h + a.substr(g);
                    },
                    pa = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";
                for (j in la) pa += "|" + j + "\\b";
                (pa = new RegExp(pa + ")", "gi")),
                    (g.colorStringFilter = function (a) {
                        var b,
                            c = a[0] + " " + a[1];
                        pa.test(c) && ((b = -1 !== c.indexOf("hsl(") || -1 !== c.indexOf("hsla(")), (a[0] = oa(a[0], b)), (a[1] = oa(a[1], b))), (pa.lastIndex = 0);
                    }),
                    b.defaultStringFilter || (b.defaultStringFilter = g.colorStringFilter);
                var qa = function (a, b, c, d) {
                        if (null == a)
                            return function (a) {
                                return a;
                            };
                        var e,
                            f = b ? (a.match(pa) || [""])[0] : "",
                            g = a.split(f).join("").match(u) || [],
                            h = a.substr(0, a.indexOf(g[0])),
                            i = ")" === a.charAt(a.length - 1) ? ")" : "",
                            j = -1 !== a.indexOf(" ") ? " " : ",",
                            k = g.length,
                            l = k > 0 ? g[0].replace(s, "") : "";
                        return k
                            ? (e = b
                                  ? function (a) {
                                        var b, m, n, o;
                                        if ("number" == typeof a) a += l;
                                        else if (d && I.test(a)) {
                                            for (o = a.replace(I, "|").split("|"), n = 0; n < o.length; n++) o[n] = e(o[n]);
                                            return o.join(",");
                                        }
                                        if (((b = (a.match(pa) || [f])[0]), (m = a.split(b).join("").match(u) || []), (n = m.length), k > n--)) for (; ++n < k; ) m[n] = c ? m[((n - 1) / 2) | 0] : g[n];
                                        return h + m.join(j) + j + b + i + (-1 !== a.indexOf("inset") ? " inset" : "");
                                    }
                                  : function (a) {
                                        var b, f, m;
                                        if ("number" == typeof a) a += l;
                                        else if (d && I.test(a)) {
                                            for (f = a.replace(I, "|").split("|"), m = 0; m < f.length; m++) f[m] = e(f[m]);
                                            return f.join(",");
                                        }
                                        if (((b = a.match(u) || []), (m = b.length), k > m--)) for (; ++m < k; ) b[m] = c ? b[((m - 1) / 2) | 0] : g[m];
                                        return h + b.join(j) + i;
                                    })
                            : function (a) {
                                  return a;
                              };
                    },
                    ra = function (a) {
                        return (
                            (a = a.split(",")),
                            function (b, c, d, e, f, g, h) {
                                var i,
                                    j = (c + "").split(" ");
                                for (h = {}, i = 0; 4 > i; i++) h[a[i]] = j[i] = j[i] || j[((i - 1) / 2) >> 0];
                                return e.parse(b, h, f, g);
                            }
                        );
                    },
                    sa =
                        ((S._setPluginRatio = function (a) {
                            this.plugin.setRatio(a);
                            for (var b, c, d, e, f, g = this.data, h = g.proxy, i = g.firstMPT, j = 1e-6; i; ) (b = h[i.v]), i.r ? (b = Math.round(b)) : j > b && b > -j && (b = 0), (i.t[i.p] = b), (i = i._next);
                            if ((g.autoRotate && (g.autoRotate.rotation = g.mod ? g.mod(h.rotation, this.t) : h.rotation), 1 === a || 0 === a))
                                for (i = g.firstMPT, f = 1 === a ? "e" : "b"; i; ) {
                                    if (((c = i.t), c.type)) {
                                        if (1 === c.type) {
                                            for (e = c.xs0 + c.s + c.xs1, d = 1; d < c.l; d++) e += c["xn" + d] + c["xs" + (d + 1)];
                                            c[f] = e;
                                        }
                                    } else c[f] = c.s + c.xs0;
                                    i = i._next;
                                }
                        }),
                        function (a, b, c, d, e) {
                            (this.t = a), (this.p = b), (this.v = c), (this.r = e), d && ((d._prev = this), (this._next = d));
                        }),
                    ta =
                        ((S._parseToProxy = function (a, b, c, d, e, f) {
                            var g,
                                h,
                                i,
                                j,
                                k,
                                l = d,
                                m = {},
                                n = {},
                                o = c._transform,
                                p = M;
                            for (c._transform = null, M = b, d = k = c.parse(a, b, d, e), M = p, f && ((c._transform = o), l && ((l._prev = null), l._prev && (l._prev._next = null))); d && d !== l; ) {
                                if (d.type <= 1 && ((h = d.p), (n[h] = d.s + d.c), (m[h] = d.s), f || ((j = new sa(d, "s", h, j, d.r)), (d.c = 0)), 1 === d.type))
                                    for (g = d.l; --g > 0; ) (i = "xn" + g), (h = d.p + "_" + i), (n[h] = d.data[i]), (m[h] = d[i]), f || (j = new sa(d, i, h, j, d.rxp[i]));
                                d = d._next;
                            }
                            return { proxy: m, end: n, firstMPT: j, pt: k };
                        }),
                        (S.CSSPropTween = function (a, b, d, e, g, h, i, j, k, l, m) {
                            (this.t = a),
                                (this.p = b),
                                (this.s = d),
                                (this.c = e),
                                (this.n = i || b),
                                a instanceof ta || f.push(this.n),
                                (this.r = j),
                                (this.type = h || 0),
                                k && ((this.pr = k), (c = !0)),
                                (this.b = void 0 === l ? d : l),
                                (this.e = void 0 === m ? d + e : m),
                                g && ((this._next = g), (g._prev = this));
                        })),
                    ua = function (a, b, c, d, e, f) {
                        var g = new ta(a, b, c, d - c, e, -1, f);
                        return (g.b = c), (g.e = g.xs0 = d), g;
                    },
                    va = (g.parseComplex = function (a, b, c, d, e, f, h, i, j, l) {
                        (c = c || f || ""),
                            "function" == typeof d && (d = d(r, q)),
                            (h = new ta(a, b, 0, 0, h, l ? 2 : 1, null, !1, i, c, d)),
                            (d += ""),
                            e && pa.test(d + c) && ((d = [c, d]), g.colorStringFilter(d), (c = d[0]), (d = d[1]));
                        var m,
                            n,
                            o,
                            p,
                            u,
                            v,
                            w,
                            x,
                            y,
                            z,
                            A,
                            B,
                            C,
                            D = c.split(", ").join(",").split(" "),
                            E = d.split(", ").join(",").split(" "),
                            F = D.length,
                            G = k !== !1;
                        for (
                            (-1 !== d.indexOf(",") || -1 !== c.indexOf(",")) &&
                                (-1 !== (d + c).indexOf("rgb") || -1 !== (d + c).indexOf("hsl")
                                    ? ((D = D.join(" ").replace(I, ", ").split(" ")), (E = E.join(" ").replace(I, ", ").split(" ")))
                                    : ((D = D.join(" ").split(",").join(", ").split(" ")), (E = E.join(" ").split(",").join(", ").split(" "))),
                                (F = D.length)),
                                F !== E.length && ((D = (f || "").split(" ")), (F = D.length)),
                                h.plugin = j,
                                h.setRatio = l,
                                pa.lastIndex = 0,
                                m = 0;
                            F > m;
                            m++
                        )
                            if (((p = D[m]), (u = E[m]), (x = parseFloat(p)), x || 0 === x)) h.appendXtra("", x, ia(u, x), u.replace(t, ""), G && -1 !== u.indexOf("px"), !0);
                            else if (e && pa.test(p))
                                (B = u.indexOf(")") + 1),
                                    (B = ")" + (B ? u.substr(B) : "")),
                                    (C = -1 !== u.indexOf("hsl") && U),
                                    (z = u),
                                    (p = na(p, C)),
                                    (u = na(u, C)),
                                    (y = p.length + u.length > 6),
                                    y && !U && 0 === u[3]
                                        ? ((h["xs" + h.l] += h.l ? " transparent" : "transparent"), (h.e = h.e.split(E[m]).join("transparent")))
                                        : (U || (y = !1),
                                          C
                                              ? h
                                                    .appendXtra(z.substr(0, z.indexOf("hsl")) + (y ? "hsla(" : "hsl("), p[0], ia(u[0], p[0]), ",", !1, !0)
                                                    .appendXtra("", p[1], ia(u[1], p[1]), "%,", !1)
                                                    .appendXtra("", p[2], ia(u[2], p[2]), y ? "%," : "%" + B, !1)
                                              : h
                                                    .appendXtra(z.substr(0, z.indexOf("rgb")) + (y ? "rgba(" : "rgb("), p[0], u[0] - p[0], ",", !0, !0)
                                                    .appendXtra("", p[1], u[1] - p[1], ",", !0)
                                                    .appendXtra("", p[2], u[2] - p[2], y ? "," : B, !0),
                                          y && ((p = p.length < 4 ? 1 : p[3]), h.appendXtra("", p, (u.length < 4 ? 1 : u[3]) - p, B, !1))),
                                    (pa.lastIndex = 0);
                            else if ((v = p.match(s))) {
                                if (((w = u.match(t)), !w || w.length !== v.length)) return h;
                                for (o = 0, n = 0; n < v.length; n++) (A = v[n]), (z = p.indexOf(A, o)), h.appendXtra(p.substr(o, z - o), Number(A), ia(w[n], A), "", G && "px" === p.substr(z + A.length, 2), 0 === n), (o = z + A.length);
                                h["xs" + h.l] += p.substr(o);
                            } else h["xs" + h.l] += h.l || h["xs" + h.l] ? " " + u : u;
                        if (-1 !== d.indexOf("=") && h.data) {
                            for (B = h.xs0 + h.data.s, m = 1; m < h.l; m++) B += h["xs" + m] + h.data["xn" + m];
                            h.e = B + h["xs" + m];
                        }
                        return h.l || ((h.type = -1), (h.xs0 = h.e)), h.xfirst || h;
                    }),
                    wa = 9;
                for (j = ta.prototype, j.l = j.pr = 0; --wa > 0; ) (j["xn" + wa] = 0), (j["xs" + wa] = "");
                (j.xs0 = ""),
                    (j._next = j._prev = j.xfirst = j.data = j.plugin = j.setRatio = j.rxp = null),
                    (j.appendXtra = function (a, b, c, d, e, f) {
                        var g = this,
                            h = g.l;
                        return (
                            (g["xs" + h] += f && (h || g["xs" + h]) ? " " + a : a || ""),
                            c || 0 === h || g.plugin
                                ? (g.l++,
                                  (g.type = g.setRatio ? 2 : 1),
                                  (g["xs" + g.l] = d || ""),
                                  h > 0
                                      ? ((g.data["xn" + h] = b + c), (g.rxp["xn" + h] = e), (g["xn" + h] = b), g.plugin || ((g.xfirst = new ta(g, "xn" + h, b, c, g.xfirst || g, 0, g.n, e, g.pr)), (g.xfirst.xs0 = 0)), g)
                                      : ((g.data = { s: b + c }), (g.rxp = {}), (g.s = b), (g.c = c), (g.r = e), g))
                                : ((g["xs" + h] += b + (d || "")), g)
                        );
                    });
                var xa = function (a, b) {
                        (b = b || {}),
                            (this.p = b.prefix ? Z(a) || a : a),
                            (i[a] = i[this.p] = this),
                            (this.format = b.formatter || qa(b.defaultValue, b.color, b.collapsible, b.multi)),
                            b.parser && (this.parse = b.parser),
                            (this.clrs = b.color),
                            (this.multi = b.multi),
                            (this.keyword = b.keyword),
                            (this.dflt = b.defaultValue),
                            (this.pr = b.priority || 0);
                    },
                    ya = (S._registerComplexSpecialProp = function (a, b, c) {
                        "object" != typeof b && (b = { parser: c });
                        var d,
                            e,
                            f = a.split(","),
                            g = b.defaultValue;
                        for (c = c || [g], d = 0; d < f.length; d++) (b.prefix = 0 === d && b.prefix), (b.defaultValue = c[d] || g), (e = new xa(f[d], b));
                    }),
                    za = (S._registerPluginProp = function (a) {
                        if (!i[a]) {
                            var b = a.charAt(0).toUpperCase() + a.substr(1) + "Plugin";
                            ya(a, {
                                parser: function (a, c, d, e, f, g, j) {
                                    var k = h.com.greensock.plugins[b];
                                    return k ? (k._cssRegister(), i[d].parse(a, c, d, e, f, g, j)) : (W("Error: " + b + " js file not loaded."), f);
                                },
                            });
                        }
                    });
                (j = xa.prototype),
                    (j.parseComplex = function (a, b, c, d, e, f) {
                        var g,
                            h,
                            i,
                            j,
                            k,
                            l,
                            m = this.keyword;
                        if ((this.multi && (I.test(c) || I.test(b) ? ((h = b.replace(I, "|").split("|")), (i = c.replace(I, "|").split("|"))) : m && ((h = [b]), (i = [c]))), i)) {
                            for (j = i.length > h.length ? i.length : h.length, g = 0; j > g; g++)
                                (b = h[g] = h[g] || this.dflt), (c = i[g] = i[g] || this.dflt), m && ((k = b.indexOf(m)), (l = c.indexOf(m)), k !== l && (-1 === l ? (h[g] = h[g].split(m).join("")) : -1 === k && (h[g] += " " + m)));
                            (b = h.join(", ")), (c = i.join(", "));
                        }
                        return va(a, this.p, b, c, this.clrs, this.dflt, d, this.pr, e, f);
                    }),
                    (j.parse = function (a, b, c, d, f, g, h) {
                        return this.parseComplex(a.style, this.format(_(a, this.p, e, !1, this.dflt)), this.format(b), f, g);
                    }),
                    (g.registerSpecialProp = function (a, b, c) {
                        ya(a, {
                            parser: function (a, d, e, f, g, h, i) {
                                var j = new ta(a, e, 0, 0, g, 2, e, !1, c);
                                return (j.plugin = h), (j.setRatio = b(a, d, f._tween, e)), j;
                            },
                            priority: c,
                        });
                    }),
                    (g.useSVGTransformAttr = !0);
                var Aa,
                    Ba = "scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),
                    Ca = Z("transform"),
                    Da = X + "transform",
                    Ea = Z("transformOrigin"),
                    Fa = null !== Z("perspective"),
                    Ga = (S.Transform = function () {
                        (this.perspective = parseFloat(g.defaultTransformPerspective) || 0), (this.force3D = !(g.defaultForce3D === !1 || !Fa) && (g.defaultForce3D || "auto"));
                    }),
                    Ha = _gsScope.SVGElement,
                    Ia = function (a, b, c) {
                        var d,
                            e = O.createElementNS("http://www.w3.org/2000/svg", a),
                            f = /([a-z])([A-Z])/g;
                        for (d in c) e.setAttributeNS(null, d.replace(f, "$1-$2").toLowerCase(), c[d]);
                        return b.appendChild(e), e;
                    },
                    Ja = O.documentElement || {},
                    Ka = (function () {
                        var a,
                            b,
                            c,
                            d = p || (/Android/i.test(T) && !_gsScope.chrome);
                        return (
                            O.createElementNS &&
                                !d &&
                                ((a = Ia("svg", Ja)),
                                (b = Ia("rect", a, { width: 100, height: 50, x: 100 })),
                                (c = b.getBoundingClientRect().width),
                                (b.style[Ea] = "50% 50%"),
                                (b.style[Ca] = "scaleX(0.5)"),
                                (d = c === b.getBoundingClientRect().width && !(n && Fa)),
                                Ja.removeChild(a)),
                            d
                        );
                    })(),
                    La = function (a, b, c, d, e, f) {
                        var h,
                            i,
                            j,
                            k,
                            l,
                            m,
                            n,
                            o,
                            p,
                            q,
                            r,
                            s,
                            t,
                            u,
                            v = a._gsTransform,
                            w = Qa(a, !0);
                        v && ((t = v.xOrigin), (u = v.yOrigin)),
                            (!d || (h = d.split(" ")).length < 2) &&
                                ((n = a.getBBox()),
                                0 === n.x &&
                                    0 === n.y &&
                                    n.width + n.height === 0 &&
                                    (n = {
                                        x: parseFloat(a.hasAttribute("x") ? a.getAttribute("x") : a.hasAttribute("cx") ? a.getAttribute("cx") : 0) || 0,
                                        y: parseFloat(a.hasAttribute("y") ? a.getAttribute("y") : a.hasAttribute("cy") ? a.getAttribute("cy") : 0) || 0,
                                        width: 0,
                                        height: 0,
                                    }),
                                (b = ha(b).split(" ")),
                                (h = [(-1 !== b[0].indexOf("%") ? (parseFloat(b[0]) / 100) * n.width : parseFloat(b[0])) + n.x, (-1 !== b[1].indexOf("%") ? (parseFloat(b[1]) / 100) * n.height : parseFloat(b[1])) + n.y])),
                            (c.xOrigin = k = parseFloat(h[0])),
                            (c.yOrigin = l = parseFloat(h[1])),
                            d &&
                                w !== Pa &&
                                ((m = w[0]),
                                (n = w[1]),
                                (o = w[2]),
                                (p = w[3]),
                                (q = w[4]),
                                (r = w[5]),
                                (s = m * p - n * o),
                                s && ((i = k * (p / s) + l * (-o / s) + (o * r - p * q) / s), (j = k * (-n / s) + l * (m / s) - (m * r - n * q) / s), (k = c.xOrigin = h[0] = i), (l = c.yOrigin = h[1] = j))),
                            v &&
                                (f && ((c.xOffset = v.xOffset), (c.yOffset = v.yOffset), (v = c)),
                                e || (e !== !1 && g.defaultSmoothOrigin !== !1) ? ((i = k - t), (j = l - u), (v.xOffset += i * w[0] + j * w[2] - i), (v.yOffset += i * w[1] + j * w[3] - j)) : (v.xOffset = v.yOffset = 0)),
                            f || a.setAttribute("data-svg-origin", h.join(" "));
                    },
                    Ma = function (a) {
                        var b,
                            c = P("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
                            d = this.parentNode,
                            e = this.nextSibling,
                            f = this.style.cssText;
                        if ((Ja.appendChild(c), c.appendChild(this), (this.style.display = "block"), a))
                            try {
                                (b = this.getBBox()), (this._originalGetBBox = this.getBBox), (this.getBBox = Ma);
                            } catch (g) {}
                        else this._originalGetBBox && (b = this._originalGetBBox());
                        return e ? d.insertBefore(this, e) : d.appendChild(this), Ja.removeChild(c), (this.style.cssText = f), b;
                    },
                    Na = function (a) {
                        try {
                            return a.getBBox();
                        } catch (b) {
                            return Ma.call(a, !0);
                        }
                    },
                    Oa = function (a) {
                        return !(!Ha || !a.getCTM || (a.parentNode && !a.ownerSVGElement) || !Na(a));
                    },
                    Pa = [1, 0, 0, 1, 0, 0],
                    Qa = function (a, b) {
                        var c,
                            d,
                            e,
                            f,
                            g,
                            h,
                            i = a._gsTransform || new Ga(),
                            j = 1e5,
                            k = a.style;
                        if (
                            (Ca
                                ? (d = _(a, Da, null, !0))
                                : a.currentStyle && ((d = a.currentStyle.filter.match(G)), (d = d && 4 === d.length ? [d[0].substr(4), Number(d[2].substr(4)), Number(d[1].substr(4)), d[3].substr(4), i.x || 0, i.y || 0].join(",") : "")),
                            (c = !d || "none" === d || "matrix(1, 0, 0, 1, 0, 0)" === d),
                            !Ca ||
                                (!(h = !$(a) || "none" === $(a).display) && a.parentNode) ||
                                (h && ((f = k.display), (k.display = "block")),
                                a.parentNode || ((g = 1), Ja.appendChild(a)),
                                (d = _(a, Da, null, !0)),
                                (c = !d || "none" === d || "matrix(1, 0, 0, 1, 0, 0)" === d),
                                f ? (k.display = f) : h && Va(k, "display"),
                                g && Ja.removeChild(a)),
                            (i.svg || (a.getCTM && Oa(a))) &&
                                (c && -1 !== (k[Ca] + "").indexOf("matrix") && ((d = k[Ca]), (c = 0)),
                                (e = a.getAttribute("transform")),
                                c && e && ((e = a.transform.baseVal.consolidate().matrix), (d = "matrix(" + e.a + "," + e.b + "," + e.c + "," + e.d + "," + e.e + "," + e.f + ")"), (c = 0))),
                            c)
                        )
                            return Pa;
                        for (e = (d || "").match(s) || [], wa = e.length; --wa > -1; ) (f = Number(e[wa])), (e[wa] = (g = f - (f |= 0)) ? ((g * j + (0 > g ? -0.5 : 0.5)) | 0) / j + f : f);
                        return b && e.length > 6 ? [e[0], e[1], e[4], e[5], e[12], e[13]] : e;
                    },
                    Ra = (S.getTransform = function (a, c, d, e) {
                        if (a._gsTransform && d && !e) return a._gsTransform;
                        var f,
                            h,
                            i,
                            j,
                            k,
                            l,
                            m = d ? a._gsTransform || new Ga() : new Ga(),
                            n = m.scaleX < 0,
                            o = 2e-5,
                            p = 1e5,
                            q = Fa ? parseFloat(_(a, Ea, c, !1, "0 0 0").split(" ")[2]) || m.zOrigin || 0 : 0,
                            r = parseFloat(g.defaultTransformPerspective) || 0;
                        if (((m.svg = !(!a.getCTM || !Oa(a))), m.svg && (La(a, _(a, Ea, c, !1, "50% 50%") + "", m, a.getAttribute("data-svg-origin")), (Aa = g.useSVGTransformAttr || Ka)), (f = Qa(a)), f !== Pa)) {
                            if (16 === f.length) {
                                var s,
                                    t,
                                    u,
                                    v,
                                    w,
                                    x = f[0],
                                    y = f[1],
                                    z = f[2],
                                    A = f[3],
                                    B = f[4],
                                    C = f[5],
                                    D = f[6],
                                    E = f[7],
                                    F = f[8],
                                    G = f[9],
                                    H = f[10],
                                    I = f[12],
                                    J = f[13],
                                    K = f[14],
                                    M = f[11],
                                    N = Math.atan2(D, H);
                                m.zOrigin && ((K = -m.zOrigin), (I = F * K - f[12]), (J = G * K - f[13]), (K = H * K + m.zOrigin - f[14])),
                                    (m.rotationX = N * L),
                                    N &&
                                        ((v = Math.cos(-N)),
                                        (w = Math.sin(-N)),
                                        (s = B * v + F * w),
                                        (t = C * v + G * w),
                                        (u = D * v + H * w),
                                        (F = B * -w + F * v),
                                        (G = C * -w + G * v),
                                        (H = D * -w + H * v),
                                        (M = E * -w + M * v),
                                        (B = s),
                                        (C = t),
                                        (D = u)),
                                    (N = Math.atan2(-z, H)),
                                    (m.rotationY = N * L),
                                    N && ((v = Math.cos(-N)), (w = Math.sin(-N)), (s = x * v - F * w), (t = y * v - G * w), (u = z * v - H * w), (G = y * w + G * v), (H = z * w + H * v), (M = A * w + M * v), (x = s), (y = t), (z = u)),
                                    (N = Math.atan2(y, x)),
                                    (m.rotation = N * L),
                                    N && ((v = Math.cos(N)), (w = Math.sin(N)), (s = x * v + y * w), (t = B * v + C * w), (u = F * v + G * w), (y = y * v - x * w), (C = C * v - B * w), (G = G * v - F * w), (x = s), (B = t), (F = u)),
                                    m.rotationX && Math.abs(m.rotationX) + Math.abs(m.rotation) > 359.9 && ((m.rotationX = m.rotation = 0), (m.rotationY = 180 - m.rotationY)),
                                    (N = Math.atan2(B, C)),
                                    (m.scaleX = ((Math.sqrt(x * x + y * y + z * z) * p + 0.5) | 0) / p),
                                    (m.scaleY = ((Math.sqrt(C * C + D * D) * p + 0.5) | 0) / p),
                                    (m.scaleZ = ((Math.sqrt(F * F + G * G + H * H) * p + 0.5) | 0) / p),
                                    (x /= m.scaleX),
                                    (B /= m.scaleY),
                                    (y /= m.scaleX),
                                    (C /= m.scaleY),
                                    Math.abs(N) > o ? ((m.skewX = N * L), (B = 0), "simple" !== m.skewType && (m.scaleY *= 1 / Math.cos(N))) : (m.skewX = 0),
                                    (m.perspective = M ? 1 / (0 > M ? -M : M) : 0),
                                    (m.x = I),
                                    (m.y = J),
                                    (m.z = K),
                                    m.svg && ((m.x -= m.xOrigin - (m.xOrigin * x - m.yOrigin * B)), (m.y -= m.yOrigin - (m.yOrigin * y - m.xOrigin * C)));
                            } else if (!Fa || e || !f.length || m.x !== f[4] || m.y !== f[5] || (!m.rotationX && !m.rotationY)) {
                                var O = f.length >= 6,
                                    P = O ? f[0] : 1,
                                    Q = f[1] || 0,
                                    R = f[2] || 0,
                                    S = O ? f[3] : 1;
                                (m.x = f[4] || 0),
                                    (m.y = f[5] || 0),
                                    (i = Math.sqrt(P * P + Q * Q)),
                                    (j = Math.sqrt(S * S + R * R)),
                                    (k = P || Q ? Math.atan2(Q, P) * L : m.rotation || 0),
                                    (l = R || S ? Math.atan2(R, S) * L + k : m.skewX || 0),
                                    (m.scaleX = i),
                                    (m.scaleY = j),
                                    (m.rotation = k),
                                    (m.skewX = l),
                                    Fa && ((m.rotationX = m.rotationY = m.z = 0), (m.perspective = r), (m.scaleZ = 1)),
                                    m.svg && ((m.x -= m.xOrigin - (m.xOrigin * P + m.yOrigin * R)), (m.y -= m.yOrigin - (m.xOrigin * Q + m.yOrigin * S)));
                            }
                            Math.abs(m.skewX) > 90 &&
                                Math.abs(m.skewX) < 270 &&
                                (n ? ((m.scaleX *= -1), (m.skewX += m.rotation <= 0 ? 180 : -180), (m.rotation += m.rotation <= 0 ? 180 : -180)) : ((m.scaleY *= -1), (m.skewX += m.skewX <= 0 ? 180 : -180))),
                                (m.zOrigin = q);
                            for (h in m) m[h] < o && m[h] > -o && (m[h] = 0);
                        }
                        return (
                            d &&
                                ((a._gsTransform = m),
                                m.svg &&
                                    (Aa && a.style[Ca]
                                        ? b.delayedCall(0.001, function () {
                                              Va(a.style, Ca);
                                          })
                                        : !Aa &&
                                          a.getAttribute("transform") &&
                                          b.delayedCall(0.001, function () {
                                              a.removeAttribute("transform");
                                          }))),
                            m
                        );
                    }),
                    Sa = function (a) {
                        var b,
                            c,
                            d = this.data,
                            e = -d.rotation * K,
                            f = e + d.skewX * K,
                            g = 1e5,
                            h = ((Math.cos(e) * d.scaleX * g) | 0) / g,
                            i = ((Math.sin(e) * d.scaleX * g) | 0) / g,
                            j = ((Math.sin(f) * -d.scaleY * g) | 0) / g,
                            k = ((Math.cos(f) * d.scaleY * g) | 0) / g,
                            l = this.t.style,
                            m = this.t.currentStyle;
                        if (m) {
                            (c = i), (i = -j), (j = -c), (b = m.filter), (l.filter = "");
                            var n,
                                o,
                                q = this.t.offsetWidth,
                                r = this.t.offsetHeight,
                                s = "absolute" !== m.position,
                                t = "progid:DXImageTransform.Microsoft.Matrix(M11=" + h + ", M12=" + i + ", M21=" + j + ", M22=" + k,
                                u = d.x + (q * d.xPercent) / 100,
                                v = d.y + (r * d.yPercent) / 100;
                            if (
                                (null != d.ox && ((n = (d.oxp ? q * d.ox * 0.01 : d.ox) - q / 2), (o = (d.oyp ? r * d.oy * 0.01 : d.oy) - r / 2), (u += n - (n * h + o * i)), (v += o - (n * j + o * k))),
                                s ? ((n = q / 2), (o = r / 2), (t += ", Dx=" + (n - (n * h + o * i) + u) + ", Dy=" + (o - (n * j + o * k) + v) + ")")) : (t += ", sizingMethod='auto expand')"),
                                -1 !== b.indexOf("DXImageTransform.Microsoft.Matrix(") ? (l.filter = b.replace(H, t)) : (l.filter = t + " " + b),
                                (0 === a || 1 === a) &&
                                    1 === h &&
                                    0 === i &&
                                    0 === j &&
                                    1 === k &&
                                    ((s && -1 === t.indexOf("Dx=0, Dy=0")) || (x.test(b) && 100 !== parseFloat(RegExp.$1)) || (-1 === b.indexOf(b.indexOf("Alpha")) && l.removeAttribute("filter"))),
                                !s)
                            ) {
                                var y,
                                    z,
                                    A,
                                    B = 8 > p ? 1 : -1;
                                for (
                                    n = d.ieOffsetX || 0,
                                        o = d.ieOffsetY || 0,
                                        d.ieOffsetX = Math.round((q - ((0 > h ? -h : h) * q + (0 > i ? -i : i) * r)) / 2 + u),
                                        d.ieOffsetY = Math.round((r - ((0 > k ? -k : k) * r + (0 > j ? -j : j) * q)) / 2 + v),
                                        wa = 0;
                                    4 > wa;
                                    wa++
                                )
                                    (z = fa[wa]),
                                        (y = m[z]),
                                        (c = -1 !== y.indexOf("px") ? parseFloat(y) : aa(this.t, z, parseFloat(y), y.replace(w, "")) || 0),
                                        (A = c !== d[z] ? (2 > wa ? -d.ieOffsetX : -d.ieOffsetY) : 2 > wa ? n - d.ieOffsetX : o - d.ieOffsetY),
                                        (l[z] = (d[z] = Math.round(c - A * (0 === wa || 2 === wa ? 1 : B))) + "px");
                            }
                        }
                    },
                    Ta = (S.set3DTransformRatio = S.setTransformRatio = function (a) {
                        var b,
                            c,
                            d,
                            e,
                            f,
                            g,
                            h,
                            i,
                            j,
                            k,
                            l,
                            m,
                            o,
                            p,
                            q,
                            r,
                            s,
                            t,
                            u,
                            v,
                            w,
                            x,
                            y,
                            z = this.data,
                            A = this.t.style,
                            B = z.rotation,
                            C = z.rotationX,
                            D = z.rotationY,
                            E = z.scaleX,
                            F = z.scaleY,
                            G = z.scaleZ,
                            H = z.x,
                            I = z.y,
                            J = z.z,
                            L = z.svg,
                            M = z.perspective,
                            N = z.force3D,
                            O = z.skewY,
                            P = z.skewX;
                        if (
                            (O && ((P += O), (B += O)),
                            ((((1 === a || 0 === a) && "auto" === N && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime)) || !N) && !J && !M && !D && !C && 1 === G) || (Aa && L) || !Fa)
                        )
                            return void (B || P || L
                                ? ((B *= K),
                                  (x = P * K),
                                  (y = 1e5),
                                  (c = Math.cos(B) * E),
                                  (f = Math.sin(B) * E),
                                  (d = Math.sin(B - x) * -F),
                                  (g = Math.cos(B - x) * F),
                                  x && "simple" === z.skewType && ((b = Math.tan(x - O * K)), (b = Math.sqrt(1 + b * b)), (d *= b), (g *= b), O && ((b = Math.tan(O * K)), (b = Math.sqrt(1 + b * b)), (c *= b), (f *= b))),
                                  L &&
                                      ((H += z.xOrigin - (z.xOrigin * c + z.yOrigin * d) + z.xOffset),
                                      (I += z.yOrigin - (z.xOrigin * f + z.yOrigin * g) + z.yOffset),
                                      Aa && (z.xPercent || z.yPercent) && ((q = this.t.getBBox()), (H += 0.01 * z.xPercent * q.width), (I += 0.01 * z.yPercent * q.height)),
                                      (q = 1e-6),
                                      q > H && H > -q && (H = 0),
                                      q > I && I > -q && (I = 0)),
                                  (u = ((c * y) | 0) / y + "," + ((f * y) | 0) / y + "," + ((d * y) | 0) / y + "," + ((g * y) | 0) / y + "," + H + "," + I + ")"),
                                  L && Aa ? this.t.setAttribute("transform", "matrix(" + u) : (A[Ca] = (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix(" : "matrix(") + u))
                                : (A[Ca] = (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix(" : "matrix(") + E + ",0,0," + F + "," + H + "," + I + ")"));
                        if ((n && ((q = 1e-4), q > E && E > -q && (E = G = 2e-5), q > F && F > -q && (F = G = 2e-5), !M || z.z || z.rotationX || z.rotationY || (M = 0)), B || P))
                            (B *= K),
                                (r = c = Math.cos(B)),
                                (s = f = Math.sin(B)),
                                P &&
                                    ((B -= P * K),
                                    (r = Math.cos(B)),
                                    (s = Math.sin(B)),
                                    "simple" === z.skewType && ((b = Math.tan((P - O) * K)), (b = Math.sqrt(1 + b * b)), (r *= b), (s *= b), z.skewY && ((b = Math.tan(O * K)), (b = Math.sqrt(1 + b * b)), (c *= b), (f *= b)))),
                                (d = -s),
                                (g = r);
                        else {
                            if (!(D || C || 1 !== G || M || L))
                                return void (A[Ca] =
                                    (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) translate3d(" : "translate3d(") +
                                    H +
                                    "px," +
                                    I +
                                    "px," +
                                    J +
                                    "px)" +
                                    (1 !== E || 1 !== F ? " scale(" + E + "," + F + ")" : ""));
                            (c = g = 1), (d = f = 0);
                        }
                        (k = 1),
                            (e = h = i = j = l = m = 0),
                            (o = M ? -1 / M : 0),
                            (p = z.zOrigin),
                            (q = 1e-6),
                            (v = ","),
                            (w = "0"),
                            (B = D * K),
                            B && ((r = Math.cos(B)), (s = Math.sin(B)), (i = -s), (l = o * -s), (e = c * s), (h = f * s), (k = r), (o *= r), (c *= r), (f *= r)),
                            (B = C * K),
                            B && ((r = Math.cos(B)), (s = Math.sin(B)), (b = d * r + e * s), (t = g * r + h * s), (j = k * s), (m = o * s), (e = d * -s + e * r), (h = g * -s + h * r), (k *= r), (o *= r), (d = b), (g = t)),
                            1 !== G && ((e *= G), (h *= G), (k *= G), (o *= G)),
                            1 !== F && ((d *= F), (g *= F), (j *= F), (m *= F)),
                            1 !== E && ((c *= E), (f *= E), (i *= E), (l *= E)),
                            (p || L) &&
                                (p && ((H += e * -p), (I += h * -p), (J += k * -p + p)),
                                L && ((H += z.xOrigin - (z.xOrigin * c + z.yOrigin * d) + z.xOffset), (I += z.yOrigin - (z.xOrigin * f + z.yOrigin * g) + z.yOffset)),
                                q > H && H > -q && (H = w),
                                q > I && I > -q && (I = w),
                                q > J && J > -q && (J = 0)),
                            (u = z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix3d(" : "matrix3d("),
                            (u += (q > c && c > -q ? w : c) + v + (q > f && f > -q ? w : f) + v + (q > i && i > -q ? w : i)),
                            (u += v + (q > l && l > -q ? w : l) + v + (q > d && d > -q ? w : d) + v + (q > g && g > -q ? w : g)),
                            C || D || 1 !== G
                                ? ((u += v + (q > j && j > -q ? w : j) + v + (q > m && m > -q ? w : m) + v + (q > e && e > -q ? w : e)),
                                  (u += v + (q > h && h > -q ? w : h) + v + (q > k && k > -q ? w : k) + v + (q > o && o > -q ? w : o) + v))
                                : (u += ",0,0,0,0,1,0,"),
                            (u += H + v + I + v + J + v + (M ? 1 + -J / M : 1) + ")"),
                            (A[Ca] = u);
                    });
                (j = Ga.prototype),
                    (j.x = j.y = j.z = j.skewX = j.skewY = j.rotation = j.rotationX = j.rotationY = j.zOrigin = j.xPercent = j.yPercent = j.xOffset = j.yOffset = 0),
                    (j.scaleX = j.scaleY = j.scaleZ = 1),
                    ya(
                        "transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin",
                        {
                            parser: function (a, b, c, d, f, h, i) {
                                if (d._lastParsedTransform === i) return f;
                                d._lastParsedTransform = i;
                                var j,
                                    k = i.scale && "function" == typeof i.scale ? i.scale : 0;
                                "function" == typeof i[c] && ((j = i[c]), (i[c] = b)), k && (i.scale = k(r, a));
                                var l,
                                    m,
                                    n,
                                    o,
                                    p,
                                    s,
                                    t,
                                    u,
                                    v,
                                    w = a._gsTransform,
                                    x = a.style,
                                    y = 1e-6,
                                    z = Ba.length,
                                    A = i,
                                    B = {},
                                    C = "transformOrigin",
                                    D = Ra(a, e, !0, A.parseTransform),
                                    E = A.transform && ("function" == typeof A.transform ? A.transform(r, q) : A.transform);
                                if (((D.skewType = A.skewType || D.skewType || g.defaultSkewType), (d._transform = D), E && "string" == typeof E && Ca))
                                    (m = Q.style),
                                        (m[Ca] = E),
                                        (m.display = "block"),
                                        (m.position = "absolute"),
                                        O.body.appendChild(Q),
                                        (l = Ra(Q, null, !1)),
                                        "simple" === D.skewType && (l.scaleY *= Math.cos(l.skewX * K)),
                                        D.svg &&
                                            ((s = D.xOrigin),
                                            (t = D.yOrigin),
                                            (l.x -= D.xOffset),
                                            (l.y -= D.yOffset),
                                            (A.transformOrigin || A.svgOrigin) &&
                                                ((E = {}), La(a, ha(A.transformOrigin), E, A.svgOrigin, A.smoothOrigin, !0), (s = E.xOrigin), (t = E.yOrigin), (l.x -= E.xOffset - D.xOffset), (l.y -= E.yOffset - D.yOffset)),
                                            (s || t) && ((u = Qa(Q, !0)), (l.x -= s - (s * u[0] + t * u[2])), (l.y -= t - (s * u[1] + t * u[3])))),
                                        O.body.removeChild(Q),
                                        l.perspective || (l.perspective = D.perspective),
                                        null != A.xPercent && (l.xPercent = ja(A.xPercent, D.xPercent)),
                                        null != A.yPercent && (l.yPercent = ja(A.yPercent, D.yPercent));
                                else if ("object" == typeof A) {
                                    if (
                                        ((l = {
                                            scaleX: ja(null != A.scaleX ? A.scaleX : A.scale, D.scaleX),
                                            scaleY: ja(null != A.scaleY ? A.scaleY : A.scale, D.scaleY),
                                            scaleZ: ja(A.scaleZ, D.scaleZ),
                                            x: ja(A.x, D.x),
                                            y: ja(A.y, D.y),
                                            z: ja(A.z, D.z),
                                            xPercent: ja(A.xPercent, D.xPercent),
                                            yPercent: ja(A.yPercent, D.yPercent),
                                            perspective: ja(A.transformPerspective, D.perspective),
                                        }),
                                        (p = A.directionalRotation),
                                        null != p)
                                    )
                                        if ("object" == typeof p) for (m in p) A[m] = p[m];
                                        else A.rotation = p;
                                    "string" == typeof A.x && -1 !== A.x.indexOf("%") && ((l.x = 0), (l.xPercent = ja(A.x, D.xPercent))),
                                        "string" == typeof A.y && -1 !== A.y.indexOf("%") && ((l.y = 0), (l.yPercent = ja(A.y, D.yPercent))),
                                        (l.rotation = ka("rotation" in A ? A.rotation : "shortRotation" in A ? A.shortRotation + "_short" : "rotationZ" in A ? A.rotationZ : D.rotation, D.rotation, "rotation", B)),
                                        Fa &&
                                            ((l.rotationX = ka("rotationX" in A ? A.rotationX : "shortRotationX" in A ? A.shortRotationX + "_short" : D.rotationX || 0, D.rotationX, "rotationX", B)),
                                            (l.rotationY = ka("rotationY" in A ? A.rotationY : "shortRotationY" in A ? A.shortRotationY + "_short" : D.rotationY || 0, D.rotationY, "rotationY", B))),
                                        (l.skewX = ka(A.skewX, D.skewX)),
                                        (l.skewY = ka(A.skewY, D.skewY));
                                }
                                for (
                                    Fa && null != A.force3D && ((D.force3D = A.force3D), (o = !0)),
                                        n = D.force3D || D.z || D.rotationX || D.rotationY || l.z || l.rotationX || l.rotationY || l.perspective,
                                        n || null == A.scale || (l.scaleZ = 1);
                                    --z > -1;

                                )
                                    (v = Ba[z]),
                                        (E = l[v] - D[v]),
                                        (E > y || -y > E || null != A[v] || null != M[v]) && ((o = !0), (f = new ta(D, v, D[v], E, f)), v in B && (f.e = B[v]), (f.xs0 = 0), (f.plugin = h), d._overwriteProps.push(f.n));
                                return (
                                    (E = A.transformOrigin),
                                    D.svg &&
                                        (E || A.svgOrigin) &&
                                        ((s = D.xOffset),
                                        (t = D.yOffset),
                                        La(a, ha(E), l, A.svgOrigin, A.smoothOrigin),
                                        (f = ua(D, "xOrigin", (w ? D : l).xOrigin, l.xOrigin, f, C)),
                                        (f = ua(D, "yOrigin", (w ? D : l).yOrigin, l.yOrigin, f, C)),
                                        (s !== D.xOffset || t !== D.yOffset) && ((f = ua(D, "xOffset", w ? s : D.xOffset, D.xOffset, f, C)), (f = ua(D, "yOffset", w ? t : D.yOffset, D.yOffset, f, C))),
                                        (E = "0px 0px")),
                                    (E || (Fa && n && D.zOrigin)) &&
                                        (Ca
                                            ? ((o = !0),
                                              (v = Ea),
                                              (E = (E || _(a, v, e, !1, "50% 50%")) + ""),
                                              (f = new ta(x, v, 0, 0, f, -1, C)),
                                              (f.b = x[v]),
                                              (f.plugin = h),
                                              Fa
                                                  ? ((m = D.zOrigin),
                                                    (E = E.split(" ")),
                                                    (D.zOrigin = (E.length > 2 && (0 === m || "0px" !== E[2]) ? parseFloat(E[2]) : m) || 0),
                                                    (f.xs0 = f.e = E[0] + " " + (E[1] || "50%") + " 0px"),
                                                    (f = new ta(D, "zOrigin", 0, 0, f, -1, f.n)),
                                                    (f.b = m),
                                                    (f.xs0 = f.e = D.zOrigin))
                                                  : (f.xs0 = f.e = E))
                                            : ha(E + "", D)),
                                    o && (d._transformType = (D.svg && Aa) || (!n && 3 !== this._transformType) ? 2 : 3),
                                    j && (i[c] = j),
                                    k && (i.scale = k),
                                    f
                                );
                            },
                            prefix: !0,
                        }
                    ),
                    ya("boxShadow", { defaultValue: "0px 0px 0px 0px #999", prefix: !0, color: !0, multi: !0, keyword: "inset" }),
                    ya("borderRadius", {
                        defaultValue: "0px",
                        parser: function (a, b, c, f, g, h) {
                            b = this.format(b);
                            var i,
                                j,
                                k,
                                l,
                                m,
                                n,
                                o,
                                p,
                                q,
                                r,
                                s,
                                t,
                                u,
                                v,
                                w,
                                x,
                                y = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
                                z = a.style;
                            for (q = parseFloat(a.offsetWidth), r = parseFloat(a.offsetHeight), i = b.split(" "), j = 0; j < y.length; j++)
                                this.p.indexOf("border") && (y[j] = Z(y[j])),
                                    (m = l = _(a, y[j], e, !1, "0px")),
                                    -1 !== m.indexOf(" ") && ((l = m.split(" ")), (m = l[0]), (l = l[1])),
                                    (n = k = i[j]),
                                    (o = parseFloat(m)),
                                    (t = m.substr((o + "").length)),
                                    (u = "=" === n.charAt(1)),
                                    u ? ((p = parseInt(n.charAt(0) + "1", 10)), (n = n.substr(2)), (p *= parseFloat(n)), (s = n.substr((p + "").length - (0 > p ? 1 : 0)) || "")) : ((p = parseFloat(n)), (s = n.substr((p + "").length))),
                                    "" === s && (s = d[c] || t),
                                    s !== t &&
                                        ((v = aa(a, "borderLeft", o, t)),
                                        (w = aa(a, "borderTop", o, t)),
                                        "%" === s ? ((m = (v / q) * 100 + "%"), (l = (w / r) * 100 + "%")) : "em" === s ? ((x = aa(a, "borderLeft", 1, "em")), (m = v / x + "em"), (l = w / x + "em")) : ((m = v + "px"), (l = w + "px")),
                                        u && ((n = parseFloat(m) + p + s), (k = parseFloat(l) + p + s))),
                                    (g = va(z, y[j], m + " " + l, n + " " + k, !1, "0px", g));
                            return g;
                        },
                        prefix: !0,
                        formatter: qa("0px 0px 0px 0px", !1, !0),
                    }),
                    ya("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {
                        defaultValue: "0px",
                        parser: function (a, b, c, d, f, g) {
                            return va(a.style, c, this.format(_(a, c, e, !1, "0px 0px")), this.format(b), !1, "0px", f);
                        },
                        prefix: !0,
                        formatter: qa("0px 0px", !1, !0),
                    }),
                    ya("backgroundPosition", {
                        defaultValue: "0 0",
                        parser: function (a, b, c, d, f, g) {
                            var h,
                                i,
                                j,
                                k,
                                l,
                                m,
                                n = "background-position",
                                o = e || $(a, null),
                                q = this.format((o ? (p ? o.getPropertyValue(n + "-x") + " " + o.getPropertyValue(n + "-y") : o.getPropertyValue(n)) : a.currentStyle.backgroundPositionX + " " + a.currentStyle.backgroundPositionY) || "0 0"),
                                r = this.format(b);
                            if ((-1 !== q.indexOf("%")) != (-1 !== r.indexOf("%")) && r.split(",").length < 2 && ((m = _(a, "backgroundImage").replace(D, "")), m && "none" !== m)) {
                                for (h = q.split(" "), i = r.split(" "), R.setAttribute("src", m), j = 2; --j > -1; )
                                    (q = h[j]),
                                        (k = -1 !== q.indexOf("%")),
                                        k !== (-1 !== i[j].indexOf("%")) && ((l = 0 === j ? a.offsetWidth - R.width : a.offsetHeight - R.height), (h[j] = k ? (parseFloat(q) / 100) * l + "px" : (parseFloat(q) / l) * 100 + "%"));
                                q = h.join(" ");
                            }
                            return this.parseComplex(a.style, q, r, f, g);
                        },
                        formatter: ha,
                    }),
                    ya("backgroundSize", {
                        defaultValue: "0 0",
                        formatter: function (a) {
                            return (a += ""), ha(-1 === a.indexOf(" ") ? a + " " + a : a);
                        },
                    }),
                    ya("perspective", { defaultValue: "0px", prefix: !0 }),
                    ya("perspectiveOrigin", { defaultValue: "50% 50%", prefix: !0 }),
                    ya("transformStyle", { prefix: !0 }),
                    ya("backfaceVisibility", { prefix: !0 }),
                    ya("userSelect", { prefix: !0 }),
                    ya("margin", { parser: ra("marginTop,marginRight,marginBottom,marginLeft") }),
                    ya("padding", { parser: ra("paddingTop,paddingRight,paddingBottom,paddingLeft") }),
                    ya("clip", {
                        defaultValue: "rect(0px,0px,0px,0px)",
                        parser: function (a, b, c, d, f, g) {
                            var h, i, j;
                            return (
                                9 > p
                                    ? ((i = a.currentStyle), (j = 8 > p ? " " : ","), (h = "rect(" + i.clipTop + j + i.clipRight + j + i.clipBottom + j + i.clipLeft + ")"), (b = this.format(b).split(",").join(j)))
                                    : ((h = this.format(_(a, this.p, e, !1, this.dflt))), (b = this.format(b))),
                                this.parseComplex(a.style, h, b, f, g)
                            );
                        },
                    }),
                    ya("textShadow", { defaultValue: "0px 0px 0px #999", color: !0, multi: !0 }),
                    ya("autoRound,strictUnits", {
                        parser: function (a, b, c, d, e) {
                            return e;
                        },
                    }),
                    ya("border", {
                        defaultValue: "0px solid #000",
                        parser: function (a, b, c, d, f, g) {
                            var h = _(a, "borderTopWidth", e, !1, "0px"),
                                i = this.format(b).split(" "),
                                j = i[0].replace(w, "");
                            return (
                                "px" !== j && (h = parseFloat(h) / aa(a, "borderTopWidth", 1, j) + j),
                                this.parseComplex(a.style, this.format(h + " " + _(a, "borderTopStyle", e, !1, "solid") + " " + _(a, "borderTopColor", e, !1, "#000")), i.join(" "), f, g)
                            );
                        },
                        color: !0,
                        formatter: function (a) {
                            var b = a.split(" ");
                            return b[0] + " " + (b[1] || "solid") + " " + (a.match(pa) || ["#000"])[0];
                        },
                    }),
                    ya("borderWidth", { parser: ra("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth") }),
                    ya("float,cssFloat,styleFloat", {
                        parser: function (a, b, c, d, e, f) {
                            var g = a.style,
                                h = "cssFloat" in g ? "cssFloat" : "styleFloat";
                            return new ta(g, h, 0, 0, e, -1, c, !1, 0, g[h], b);
                        },
                    });
                var Ua = function (a) {
                    var b,
                        c = this.t,
                        d = c.filter || _(this.data, "filter") || "",
                        e = (this.s + this.c * a) | 0;
                    100 === e && (-1 === d.indexOf("atrix(") && -1 === d.indexOf("radient(") && -1 === d.indexOf("oader(") ? (c.removeAttribute("filter"), (b = !_(this.data, "filter"))) : ((c.filter = d.replace(z, "")), (b = !0))),
                        b || (this.xn1 && (c.filter = d = d || "alpha(opacity=" + e + ")"), -1 === d.indexOf("pacity") ? (0 === e && this.xn1) || (c.filter = d + " alpha(opacity=" + e + ")") : (c.filter = d.replace(x, "opacity=" + e)));
                };
                ya("opacity,alpha,autoAlpha", {
                    defaultValue: "1",
                    parser: function (a, b, c, d, f, g) {
                        var h = parseFloat(_(a, "opacity", e, !1, "1")),
                            i = a.style,
                            j = "autoAlpha" === c;
                        return (
                            "string" == typeof b && "=" === b.charAt(1) && (b = ("-" === b.charAt(0) ? -1 : 1) * parseFloat(b.substr(2)) + h),
                            j && 1 === h && "hidden" === _(a, "visibility", e) && 0 !== b && (h = 0),
                            U
                                ? (f = new ta(i, "opacity", h, b - h, f))
                                : ((f = new ta(i, "opacity", 100 * h, 100 * (b - h), f)),
                                  (f.xn1 = j ? 1 : 0),
                                  (i.zoom = 1),
                                  (f.type = 2),
                                  (f.b = "alpha(opacity=" + f.s + ")"),
                                  (f.e = "alpha(opacity=" + (f.s + f.c) + ")"),
                                  (f.data = a),
                                  (f.plugin = g),
                                  (f.setRatio = Ua)),
                            j && ((f = new ta(i, "visibility", 0, 0, f, -1, null, !1, 0, 0 !== h ? "inherit" : "hidden", 0 === b ? "hidden" : "inherit")), (f.xs0 = "inherit"), d._overwriteProps.push(f.n), d._overwriteProps.push(c)),
                            f
                        );
                    },
                });
                var Va = function (a, b) {
                        b && (a.removeProperty ? (("ms" === b.substr(0, 2) || "webkit" === b.substr(0, 6)) && (b = "-" + b), a.removeProperty(b.replace(B, "-$1").toLowerCase())) : a.removeAttribute(b));
                    },
                    Wa = function (a) {
                        if (((this.t._gsClassPT = this), 1 === a || 0 === a)) {
                            this.t.setAttribute("class", 0 === a ? this.b : this.e);
                            for (var b = this.data, c = this.t.style; b; ) b.v ? (c[b.p] = b.v) : Va(c, b.p), (b = b._next);
                            1 === a && this.t._gsClassPT === this && (this.t._gsClassPT = null);
                        } else this.t.getAttribute("class") !== this.e && this.t.setAttribute("class", this.e);
                    };
                ya("className", {
                    parser: function (a, b, d, f, g, h, i) {
                        var j,
                            k,
                            l,
                            m,
                            n,
                            o = a.getAttribute("class") || "",
                            p = a.style.cssText;
                        if (((g = f._classNamePT = new ta(a, d, 0, 0, g, 2)), (g.setRatio = Wa), (g.pr = -11), (c = !0), (g.b = o), (k = ca(a, e)), (l = a._gsClassPT))) {
                            for (m = {}, n = l.data; n; ) (m[n.p] = 1), (n = n._next);
                            l.setRatio(1);
                        }
                        return (
                            (a._gsClassPT = g),
                            (g.e = "=" !== b.charAt(1) ? b : o.replace(new RegExp("(?:\\s|^)" + b.substr(2) + "(?![\\w-])"), "") + ("+" === b.charAt(0) ? " " + b.substr(2) : "")),
                            a.setAttribute("class", g.e),
                            (j = da(a, k, ca(a), i, m)),
                            a.setAttribute("class", o),
                            (g.data = j.firstMPT),
                            (a.style.cssText = p),
                            (g = g.xfirst = f.parse(a, j.difs, g, h))
                        );
                    },
                });
                var Xa = function (a) {
                    if ((1 === a || 0 === a) && this.data._totalTime === this.data._totalDuration && "isFromStart" !== this.data.data) {
                        var b,
                            c,
                            d,
                            e,
                            f,
                            g = this.t.style,
                            h = i.transform.parse;
                        if ("all" === this.e) (g.cssText = ""), (e = !0);
                        else for (b = this.e.split(" ").join("").split(","), d = b.length; --d > -1; ) (c = b[d]), i[c] && (i[c].parse === h ? (e = !0) : (c = "transformOrigin" === c ? Ea : i[c].p)), Va(g, c);
                        e && (Va(g, Ca), (f = this.t._gsTransform), f && (f.svg && (this.t.removeAttribute("data-svg-origin"), this.t.removeAttribute("transform")), delete this.t._gsTransform));
                    }
                };
                for (
                    ya("clearProps", {
                        parser: function (a, b, d, e, f) {
                            return (f = new ta(a, d, 0, 0, f, 2)), (f.setRatio = Xa), (f.e = b), (f.pr = -10), (f.data = e._tween), (c = !0), f;
                        },
                    }),
                        j = "bezier,throwProps,physicsProps,physics2D".split(","),
                        wa = j.length;
                    wa--;

                )
                    za(j[wa]);
                (j = g.prototype),
                    (j._firstPT = j._lastParsedTransform = j._transform = null),
                    (j._onInitTween = function (a, b, h, j) {
                        if (!a.nodeType) return !1;
                        (this._target = q = a), (this._tween = h), (this._vars = b), (r = j), (k = b.autoRound), (c = !1), (d = b.suffixMap || g.suffixMap), (e = $(a, "")), (f = this._overwriteProps);
                        var n,
                            p,
                            s,
                            t,
                            u,
                            v,
                            w,
                            x,
                            z,
                            A = a.style;
                        if (
                            (l && "" === A.zIndex && ((n = _(a, "zIndex", e)), ("auto" === n || "" === n) && this._addLazySet(A, "zIndex", 0)),
                            "string" == typeof b && ((t = A.cssText), (n = ca(a, e)), (A.cssText = t + ";" + b), (n = da(a, n, ca(a)).difs), !U && y.test(b) && (n.opacity = parseFloat(RegExp.$1)), (b = n), (A.cssText = t)),
                            b.className ? (this._firstPT = p = i.className.parse(a, b.className, "className", this, null, null, b)) : (this._firstPT = p = this.parse(a, b, null)),
                            this._transformType)
                        ) {
                            for (
                                z = 3 === this._transformType,
                                    Ca
                                        ? m &&
                                          ((l = !0),
                                          "" === A.zIndex && ((w = _(a, "zIndex", e)), ("auto" === w || "" === w) && this._addLazySet(A, "zIndex", 0)),
                                          o && this._addLazySet(A, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (z ? "visible" : "hidden")))
                                        : (A.zoom = 1),
                                    s = p;
                                s && s._next;

                            )
                                s = s._next;
                            (x = new ta(a, "transform", 0, 0, null, 2)), this._linkCSSP(x, null, s), (x.setRatio = Ca ? Ta : Sa), (x.data = this._transform || Ra(a, e, !0)), (x.tween = h), (x.pr = -1), f.pop();
                        }
                        if (c) {
                            for (; p; ) {
                                for (v = p._next, s = t; s && s.pr > p.pr; ) s = s._next;
                                (p._prev = s ? s._prev : u) ? (p._prev._next = p) : (t = p), (p._next = s) ? (s._prev = p) : (u = p), (p = v);
                            }
                            this._firstPT = t;
                        }
                        return !0;
                    }),
                    (j.parse = function (a, b, c, f) {
                        var g,
                            h,
                            j,
                            l,
                            m,
                            n,
                            o,
                            p,
                            s,
                            t,
                            u = a.style;
                        for (g in b) {
                            if (((n = b[g]), "function" == typeof n && (n = n(r, q)), (h = i[g]))) c = h.parse(a, n, g, this, c, f, b);
                            else {
                                if ("--" === g.substr(0, 2)) {
                                    this._tween._propLookup[g] = this._addTween.call(this._tween, a.style, "setProperty", $(a).getPropertyValue(g) + "", n + "", g, !1, g);
                                    continue;
                                }
                                (m = _(a, g, e) + ""),
                                    (s = "string" == typeof n),
                                    "color" === g || "fill" === g || "stroke" === g || -1 !== g.indexOf("Color") || (s && A.test(n))
                                        ? (s || ((n = na(n)), (n = (n.length > 3 ? "rgba(" : "rgb(") + n.join(",") + ")")), (c = va(u, g, m, n, !0, "transparent", c, 0, f)))
                                        : s && J.test(n)
                                        ? (c = va(u, g, m, n, !0, null, c, 0, f))
                                        : ((j = parseFloat(m)),
                                          (o = j || 0 === j ? m.substr((j + "").length) : ""),
                                          ("" === m || "auto" === m) &&
                                              ("width" === g || "height" === g ? ((j = ga(a, g, e)), (o = "px")) : "left" === g || "top" === g ? ((j = ba(a, g, e)), (o = "px")) : ((j = "opacity" !== g ? 0 : 1), (o = ""))),
                                          (t = s && "=" === n.charAt(1)),
                                          t ? ((l = parseInt(n.charAt(0) + "1", 10)), (n = n.substr(2)), (l *= parseFloat(n)), (p = n.replace(w, ""))) : ((l = parseFloat(n)), (p = s ? n.replace(w, "") : "")),
                                          "" === p && (p = g in d ? d[g] : o),
                                          (n = l || 0 === l ? (t ? l + j : l) + p : b[g]),
                                          o !== p &&
                                              ("" !== p || "lineHeight" === g) &&
                                              (l || 0 === l) &&
                                              j &&
                                              ((j = aa(a, g, j, o)),
                                              "%" === p
                                                  ? ((j /= aa(a, g, 100, "%") / 100), b.strictUnits !== !0 && (m = j + "%"))
                                                  : "em" === p || "rem" === p || "vw" === p || "vh" === p
                                                  ? (j /= aa(a, g, 1, p))
                                                  : "px" !== p && ((l = aa(a, g, l, p)), (p = "px")),
                                              t && (l || 0 === l) && (n = l + j + p)),
                                          t && (l += j),
                                          (!j && 0 !== j) || (!l && 0 !== l)
                                              ? void 0 !== u[g] && (n || (n + "" != "NaN" && null != n))
                                                  ? ((c = new ta(u, g, l || j || 0, 0, c, -1, g, !1, 0, m, n)), (c.xs0 = "none" !== n || ("display" !== g && -1 === g.indexOf("Style")) ? n : m))
                                                  : W("invalid " + g + " tween value: " + b[g])
                                              : ((c = new ta(u, g, j, l - j, c, 0, g, k !== !1 && ("px" === p || "zIndex" === g), 0, m, n)), (c.xs0 = p)));
                            }
                            f && c && !c.plugin && (c.plugin = f);
                        }
                        return c;
                    }),
                    (j.setRatio = function (a) {
                        var b,
                            c,
                            d,
                            e = this._firstPT,
                            f = 1e-6;
                        if (1 !== a || (this._tween._time !== this._tween._duration && 0 !== this._tween._time))
                            if (a || (this._tween._time !== this._tween._duration && 0 !== this._tween._time) || this._tween._rawPrevTime === -1e-6)
                                for (; e; ) {
                                    if (((b = e.c * a + e.s), e.r ? (b = Math.round(b)) : f > b && b > -f && (b = 0), e.type))
                                        if (1 === e.type)
                                            if (((d = e.l), 2 === d)) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2;
                                            else if (3 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3;
                                            else if (4 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3 + e.xn3 + e.xs4;
                                            else if (5 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3 + e.xn3 + e.xs4 + e.xn4 + e.xs5;
                                            else {
                                                for (c = e.xs0 + b + e.xs1, d = 1; d < e.l; d++) c += e["xn" + d] + e["xs" + (d + 1)];
                                                e.t[e.p] = c;
                                            }
                                        else -1 === e.type ? (e.t[e.p] = e.xs0) : e.setRatio && e.setRatio(a);
                                    else e.t[e.p] = b + e.xs0;
                                    e = e._next;
                                }
                            else for (; e; ) 2 !== e.type ? (e.t[e.p] = e.b) : e.setRatio(a), (e = e._next);
                        else
                            for (; e; ) {
                                if (2 !== e.type)
                                    if (e.r && -1 !== e.type)
                                        if (((b = Math.round(e.s + e.c)), e.type)) {
                                            if (1 === e.type) {
                                                for (d = e.l, c = e.xs0 + b + e.xs1, d = 1; d < e.l; d++) c += e["xn" + d] + e["xs" + (d + 1)];
                                                e.t[e.p] = c;
                                            }
                                        } else e.t[e.p] = b + e.xs0;
                                    else e.t[e.p] = e.e;
                                else e.setRatio(a);
                                e = e._next;
                            }
                    }),
                    (j._enableTransforms = function (a) {
                        (this._transform = this._transform || Ra(this._target, e, !0)), (this._transformType = (this._transform.svg && Aa) || (!a && 3 !== this._transformType) ? 2 : 3);
                    });
                var Ya = function (a) {
                    (this.t[this.p] = this.e), this.data._linkCSSP(this, this._next, null, !0);
                };
                (j._addLazySet = function (a, b, c) {
                    var d = (this._firstPT = new ta(a, b, 0, 0, this._firstPT, 2));
                    (d.e = c), (d.setRatio = Ya), (d.data = this);
                }),
                    (j._linkCSSP = function (a, b, c, d) {
                        return (
                            a &&
                                (b && (b._prev = a),
                                a._next && (a._next._prev = a._prev),
                                a._prev ? (a._prev._next = a._next) : this._firstPT === a && ((this._firstPT = a._next), (d = !0)),
                                c ? (c._next = a) : d || null !== this._firstPT || (this._firstPT = a),
                                (a._next = b),
                                (a._prev = c)),
                            a
                        );
                    }),
                    (j._mod = function (a) {
                        for (var b = this._firstPT; b; ) "function" == typeof a[b.p] && a[b.p] === Math.round && (b.r = 1), (b = b._next);
                    }),
                    (j._kill = function (b) {
                        var c,
                            d,
                            e,
                            f = b;
                        if (b.autoAlpha || b.alpha) {
                            f = {};
                            for (d in b) f[d] = b[d];
                            (f.opacity = 1), f.autoAlpha && (f.visibility = 1);
                        }
                        for (
                            b.className &&
                                (c = this._classNamePT) &&
                                ((e = c.xfirst),
                                e && e._prev ? this._linkCSSP(e._prev, c._next, e._prev._prev) : e === this._firstPT && (this._firstPT = c._next),
                                c._next && this._linkCSSP(c._next, c._next._next, e._prev),
                                (this._classNamePT = null)),
                                c = this._firstPT;
                            c;

                        )
                            c.plugin && c.plugin !== d && c.plugin._kill && (c.plugin._kill(b), (d = c.plugin)), (c = c._next);
                        return a.prototype._kill.call(this, f);
                    });
                var Za = function (a, b, c) {
                    var d, e, f, g;
                    if (a.slice) for (e = a.length; --e > -1; ) Za(a[e], b, c);
                    else for (d = a.childNodes, e = d.length; --e > -1; ) (f = d[e]), (g = f.type), f.style && (b.push(ca(f)), c && c.push(f)), (1 !== g && 9 !== g && 11 !== g) || !f.childNodes.length || Za(f, b, c);
                };
                return (
                    (g.cascadeTo = function (a, c, d) {
                        var e,
                            f,
                            g,
                            h,
                            i = b.to(a, c, d),
                            j = [i],
                            k = [],
                            l = [],
                            m = [],
                            n = b._internals.reservedProps;
                        for (a = i._targets || i.target, Za(a, k, m), i.render(c, !0, !0), Za(a, l), i.render(0, !0, !0), i._enabled(!0), e = m.length; --e > -1; )
                            if (((f = da(m[e], k[e], l[e])), f.firstMPT)) {
                                f = f.difs;
                                for (g in d) n[g] && (f[g] = d[g]);
                                h = {};
                                for (g in f) h[g] = k[e][g];
                                j.push(b.fromTo(m[e], c, h, f));
                            }
                        return j;
                    }),
                    a.activate([g]),
                    g
                );
            },
            !0
        ),
        (function () {
            var a = _gsScope._gsDefine.plugin({
                    propName: "roundProps",
                    version: "1.6.0",
                    priority: -1,
                    API: 2,
                    init: function (a, b, c) {
                        return (this._tween = c), !0;
                    },
                }),
                b = function (a) {
                    for (; a; ) a.f || a.blob || (a.m = Math.round), (a = a._next);
                },
                c = a.prototype;
            (c._onInitAllProps = function () {
                for (var a, c, d, e = this._tween, f = e.vars.roundProps.join ? e.vars.roundProps : e.vars.roundProps.split(","), g = f.length, h = {}, i = e._propLookup.roundProps; --g > -1; ) h[f[g]] = Math.round;
                for (g = f.length; --g > -1; )
                    for (a = f[g], c = e._firstPT; c; )
                        (d = c._next),
                            c.pg
                                ? c.t._mod(h)
                                : c.n === a &&
                                  (2 === c.f && c.t
                                      ? b(c.t._firstPT)
                                      : (this._add(c.t, a, c.s, c.c), d && (d._prev = c._prev), c._prev ? (c._prev._next = d) : e._firstPT === c && (e._firstPT = d), (c._next = c._prev = null), (e._propLookup[a] = i))),
                            (c = d);
                return !1;
            }),
                (c._add = function (a, b, c, d) {
                    this._addTween(a, b, c, c + d, b, Math.round), this._overwriteProps.push(b);
                });
        })(),
        (function () {
            _gsScope._gsDefine.plugin({
                propName: "attr",
                API: 2,
                version: "0.6.1",
                init: function (a, b, c, d) {
                    var e, f;
                    if ("function" != typeof a.setAttribute) return !1;
                    for (e in b) (f = b[e]), "function" == typeof f && (f = f(d, a)), this._addTween(a, "setAttribute", a.getAttribute(e) + "", f + "", e, !1, e), this._overwriteProps.push(e);
                    return !0;
                },
            });
        })(),
        (_gsScope._gsDefine.plugin({
            propName: "directionalRotation",
            version: "0.3.1",
            API: 2,
            init: function (a, b, c, d) {
                "object" != typeof b && (b = { rotation: b }), (this.finals = {});
                var e,
                    f,
                    g,
                    h,
                    i,
                    j,
                    k = b.useRadians === !0 ? 2 * Math.PI : 360,
                    l = 1e-6;
                for (e in b)
                    "useRadians" !== e &&
                        ((h = b[e]),
                        "function" == typeof h && (h = h(d, a)),
                        (j = (h + "").split("_")),
                        (f = j[0]),
                        (g = parseFloat("function" != typeof a[e] ? a[e] : a[e.indexOf("set") || "function" != typeof a["get" + e.substr(3)] ? e : "get" + e.substr(3)]())),
                        (h = this.finals[e] = "string" == typeof f && "=" === f.charAt(1) ? g + parseInt(f.charAt(0) + "1", 10) * Number(f.substr(2)) : Number(f) || 0),
                        (i = h - g),
                        j.length &&
                            ((f = j.join("_")),
                            -1 !== f.indexOf("short") && ((i %= k), i !== i % (k / 2) && (i = 0 > i ? i + k : i - k)),
                            -1 !== f.indexOf("_cw") && 0 > i ? (i = ((i + 9999999999 * k) % k) - ((i / k) | 0) * k) : -1 !== f.indexOf("ccw") && i > 0 && (i = ((i - 9999999999 * k) % k) - ((i / k) | 0) * k)),
                        (i > l || -l > i) && (this._addTween(a, e, g, g + i, e), this._overwriteProps.push(e)));
                return !0;
            },
            set: function (a) {
                var b;
                if (1 !== a) this._super.setRatio.call(this, a);
                else for (b = this._firstPT; b; ) b.f ? b.t[b.p](this.finals[b.p]) : (b.t[b.p] = this.finals[b.p]), (b = b._next);
            },
        })._autoCSS = !0),
        _gsScope._gsDefine(
            "easing.Back",
            ["easing.Ease"],
            function (a) {
                var b,
                    c,
                    d,
                    e,
                    f = _gsScope.GreenSockGlobals || _gsScope,
                    g = f.com.greensock,
                    h = 2 * Math.PI,
                    i = Math.PI / 2,
                    j = g._class,
                    k = function (b, c) {
                        var d = j("easing." + b, function () {}, !0),
                            e = (d.prototype = new a());
                        return (e.constructor = d), (e.getRatio = c), d;
                    },
                    l = a.register || function () {},
                    m = function (a, b, c, d, e) {
                        var f = j("easing." + a, { easeOut: new b(), easeIn: new c(), easeInOut: new d() }, !0);
                        return l(f, a), f;
                    },
                    n = function (a, b, c) {
                        (this.t = a), (this.v = b), c && ((this.next = c), (c.prev = this), (this.c = c.v - b), (this.gap = c.t - a));
                    },
                    o = function (b, c) {
                        var d = j(
                                "easing." + b,
                                function (a) {
                                    (this._p1 = a || 0 === a ? a : 1.70158), (this._p2 = 1.525 * this._p1);
                                },
                                !0
                            ),
                            e = (d.prototype = new a());
                        return (
                            (e.constructor = d),
                            (e.getRatio = c),
                            (e.config = function (a) {
                                return new d(a);
                            }),
                            d
                        );
                    },
                    p = m(
                        "Back",
                        o("BackOut", function (a) {
                            return (a -= 1) * a * ((this._p1 + 1) * a + this._p1) + 1;
                        }),
                        o("BackIn", function (a) {
                            return a * a * ((this._p1 + 1) * a - this._p1);
                        }),
                        o("BackInOut", function (a) {
                            return (a *= 2) < 1 ? 0.5 * a * a * ((this._p2 + 1) * a - this._p2) : 0.5 * ((a -= 2) * a * ((this._p2 + 1) * a + this._p2) + 2);
                        })
                    ),
                    q = j(
                        "easing.SlowMo",
                        function (a, b, c) {
                            (b = b || 0 === b ? b : 0.7), null == a ? (a = 0.7) : a > 1 && (a = 1), (this._p = 1 !== a ? b : 0), (this._p1 = (1 - a) / 2), (this._p2 = a), (this._p3 = this._p1 + this._p2), (this._calcEnd = c === !0);
                        },
                        !0
                    ),
                    r = (q.prototype = new a());
                return (
                    (r.constructor = q),
                    (r.getRatio = function (a) {
                        var b = a + (0.5 - a) * this._p;
                        return a < this._p1
                            ? this._calcEnd
                                ? 1 - (a = 1 - a / this._p1) * a
                                : b - (a = 1 - a / this._p1) * a * a * a * b
                            : a > this._p3
                            ? this._calcEnd
                                ? 1 === a
                                    ? 0
                                    : 1 - (a = (a - this._p3) / this._p1) * a
                                : b + (a - b) * (a = (a - this._p3) / this._p1) * a * a * a
                            : this._calcEnd
                            ? 1
                            : b;
                    }),
                    (q.ease = new q(0.7, 0.7)),
                    (r.config = q.config = function (a, b, c) {
                        return new q(a, b, c);
                    }),
                    (b = j(
                        "easing.SteppedEase",
                        function (a, b) {
                            (a = a || 1), (this._p1 = 1 / a), (this._p2 = a + (b ? 0 : 1)), (this._p3 = b ? 1 : 0);
                        },
                        !0
                    )),
                    (r = b.prototype = new a()),
                    (r.constructor = b),
                    (r.getRatio = function (a) {
                        return 0 > a ? (a = 0) : a >= 1 && (a = 0.999999999), (((this._p2 * a) | 0) + this._p3) * this._p1;
                    }),
                    (r.config = b.config = function (a, c) {
                        return new b(a, c);
                    }),
                    (c = j(
                        "easing.ExpoScaleEase",
                        function (a, b, c) {
                            (this._p1 = Math.log(b / a)), (this._p2 = b - a), (this._p3 = a), (this._ease = c);
                        },
                        !0
                    )),
                    (r = c.prototype = new a()),
                    (r.constructor = c),
                    (r.getRatio = function (a) {
                        return this._ease && (a = this._ease.getRatio(a)), (this._p3 * Math.exp(this._p1 * a) - this._p3) / this._p2;
                    }),
                    (r.config = c.config = function (a, b, d) {
                        return new c(a, b, d);
                    }),
                    (d = j(
                        "easing.RoughEase",
                        function (b) {
                            b = b || {};
                            for (
                                var c,
                                    d,
                                    e,
                                    f,
                                    g,
                                    h,
                                    i = b.taper || "none",
                                    j = [],
                                    k = 0,
                                    l = 0 | (b.points || 20),
                                    m = l,
                                    o = b.randomize !== !1,
                                    p = b.clamp === !0,
                                    q = b.template instanceof a ? b.template : null,
                                    r = "number" == typeof b.strength ? 0.4 * b.strength : 0.4;
                                --m > -1;

                            )
                                (c = o ? Math.random() : (1 / l) * m),
                                    (d = q ? q.getRatio(c) : c),
                                    "none" === i ? (e = r) : "out" === i ? ((f = 1 - c), (e = f * f * r)) : "in" === i ? (e = c * c * r) : 0.5 > c ? ((f = 2 * c), (e = f * f * 0.5 * r)) : ((f = 2 * (1 - c)), (e = f * f * 0.5 * r)),
                                    o ? (d += Math.random() * e - 0.5 * e) : m % 2 ? (d += 0.5 * e) : (d -= 0.5 * e),
                                    p && (d > 1 ? (d = 1) : 0 > d && (d = 0)),
                                    (j[k++] = { x: c, y: d });
                            for (
                                j.sort(function (a, b) {
                                    return a.x - b.x;
                                }),
                                    h = new n(1, 1, null),
                                    m = l;
                                --m > -1;

                            )
                                (g = j[m]), (h = new n(g.x, g.y, h));
                            this._prev = new n(0, 0, 0 !== h.t ? h : h.next);
                        },
                        !0
                    )),
                    (r = d.prototype = new a()),
                    (r.constructor = d),
                    (r.getRatio = function (a) {
                        var b = this._prev;
                        if (a > b.t) {
                            for (; b.next && a >= b.t; ) b = b.next;
                            b = b.prev;
                        } else for (; b.prev && a <= b.t; ) b = b.prev;
                        return (this._prev = b), b.v + ((a - b.t) / b.gap) * b.c;
                    }),
                    (r.config = function (a) {
                        return new d(a);
                    }),
                    (d.ease = new d()),
                    m(
                        "Bounce",
                        k("BounceOut", function (a) {
                            return 1 / 2.75 > a ? 7.5625 * a * a : 2 / 2.75 > a ? 7.5625 * (a -= 1.5 / 2.75) * a + 0.75 : 2.5 / 2.75 > a ? 7.5625 * (a -= 2.25 / 2.75) * a + 0.9375 : 7.5625 * (a -= 2.625 / 2.75) * a + 0.984375;
                        }),
                        k("BounceIn", function (a) {
                            return (a = 1 - a) < 1 / 2.75
                                ? 1 - 7.5625 * a * a
                                : 2 / 2.75 > a
                                ? 1 - (7.5625 * (a -= 1.5 / 2.75) * a + 0.75)
                                : 2.5 / 2.75 > a
                                ? 1 - (7.5625 * (a -= 2.25 / 2.75) * a + 0.9375)
                                : 1 - (7.5625 * (a -= 2.625 / 2.75) * a + 0.984375);
                        }),
                        k("BounceInOut", function (a) {
                            var b = 0.5 > a;
                            return (
                                (a = b ? 1 - 2 * a : 2 * a - 1),
                                (a = 1 / 2.75 > a ? 7.5625 * a * a : 2 / 2.75 > a ? 7.5625 * (a -= 1.5 / 2.75) * a + 0.75 : 2.5 / 2.75 > a ? 7.5625 * (a -= 2.25 / 2.75) * a + 0.9375 : 7.5625 * (a -= 2.625 / 2.75) * a + 0.984375),
                                b ? 0.5 * (1 - a) : 0.5 * a + 0.5
                            );
                        })
                    ),
                    m(
                        "Circ",
                        k("CircOut", function (a) {
                            return Math.sqrt(1 - (a -= 1) * a);
                        }),
                        k("CircIn", function (a) {
                            return -(Math.sqrt(1 - a * a) - 1);
                        }),
                        k("CircInOut", function (a) {
                            return (a *= 2) < 1 ? -0.5 * (Math.sqrt(1 - a * a) - 1) : 0.5 * (Math.sqrt(1 - (a -= 2) * a) + 1);
                        })
                    ),
                    (e = function (b, c, d) {
                        var e = j(
                                "easing." + b,
                                function (a, b) {
                                    (this._p1 = a >= 1 ? a : 1), (this._p2 = (b || d) / (1 > a ? a : 1)), (this._p3 = (this._p2 / h) * (Math.asin(1 / this._p1) || 0)), (this._p2 = h / this._p2);
                                },
                                !0
                            ),
                            f = (e.prototype = new a());
                        return (
                            (f.constructor = e),
                            (f.getRatio = c),
                            (f.config = function (a, b) {
                                return new e(a, b);
                            }),
                            e
                        );
                    }),
                    m(
                        "Elastic",
                        e(
                            "ElasticOut",
                            function (a) {
                                return this._p1 * Math.pow(2, -10 * a) * Math.sin((a - this._p3) * this._p2) + 1;
                            },
                            0.3
                        ),
                        e(
                            "ElasticIn",
                            function (a) {
                                return -(this._p1 * Math.pow(2, 10 * (a -= 1)) * Math.sin((a - this._p3) * this._p2));
                            },
                            0.3
                        ),
                        e(
                            "ElasticInOut",
                            function (a) {
                                return (a *= 2) < 1 ? -0.5 * (this._p1 * Math.pow(2, 10 * (a -= 1)) * Math.sin((a - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 * (a -= 1)) * Math.sin((a - this._p3) * this._p2) * 0.5 + 1;
                            },
                            0.45
                        )
                    ),
                    m(
                        "Expo",
                        k("ExpoOut", function (a) {
                            return 1 - Math.pow(2, -10 * a);
                        }),
                        k("ExpoIn", function (a) {
                            return Math.pow(2, 10 * (a - 1)) - 0.001;
                        }),
                        k("ExpoInOut", function (a) {
                            return (a *= 2) < 1 ? 0.5 * Math.pow(2, 10 * (a - 1)) : 0.5 * (2 - Math.pow(2, -10 * (a - 1)));
                        })
                    ),
                    m(
                        "Sine",
                        k("SineOut", function (a) {
                            return Math.sin(a * i);
                        }),
                        k("SineIn", function (a) {
                            return -Math.cos(a * i) + 1;
                        }),
                        k("SineInOut", function (a) {
                            return -0.5 * (Math.cos(Math.PI * a) - 1);
                        })
                    ),
                    j(
                        "easing.EaseLookup",
                        {
                            find: function (b) {
                                return a.map[b];
                            },
                        },
                        !0
                    ),
                    l(f.SlowMo, "SlowMo", "ease,"),
                    l(d, "RoughEase", "ease,"),
                    l(b, "SteppedEase", "ease,"),
                    p
                );
            },
            !0
        );
}),
    _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
    (function (a, b) {
        "use strict";
        var c = {},
            d = a.document,
            e = (a.GreenSockGlobals = a.GreenSockGlobals || a);
        if (!e.TweenLite) {
            var f,
                g,
                h,
                i,
                j,
                k = function (a) {
                    var b,
                        c = a.split("."),
                        d = e;
                    for (b = 0; b < c.length; b++) d[c[b]] = d = d[c[b]] || {};
                    return d;
                },
                l = k("com.greensock"),
                m = 1e-10,
                n = function (a) {
                    var b,
                        c = [],
                        d = a.length;
                    for (b = 0; b !== d; c.push(a[b++]));
                    return c;
                },
                o = function () {},
                p = (function () {
                    var a = Object.prototype.toString,
                        b = a.call([]);
                    return function (c) {
                        return null != c && (c instanceof Array || ("object" == typeof c && !!c.push && a.call(c) === b));
                    };
                })(),
                q = {},
                r = function (d, f, g, h) {
                    (this.sc = q[d] ? q[d].sc : []), (q[d] = this), (this.gsClass = null), (this.func = g);
                    var i = [];
                    (this.check = function (j) {
                        for (var l, m, n, o, p = f.length, s = p; --p > -1; ) (l = q[f[p]] || new r(f[p], [])).gsClass ? ((i[p] = l.gsClass), s--) : j && l.sc.push(this);
                        if (0 === s && g) {
                            if (((m = ("com.greensock." + d).split(".")), (n = m.pop()), (o = k(m.join("."))[n] = this.gsClass = g.apply(g, i)), h))
                                if (((e[n] = c[n] = o), "undefined" != typeof module && module.exports))
                                    if (d === b) {
                                        module.exports = c[b] = o;
                                        for (p in c) o[p] = c[p];
                                    } else c[b] && (c[b][n] = o);
                                else
                                    "function" == typeof define &&
                                        define.amd &&
                                        define((a.GreenSockAMDPath ? a.GreenSockAMDPath + "/" : "") + d.split(".").pop(), [], function () {
                                            return o;
                                        });
                            for (p = 0; p < this.sc.length; p++) this.sc[p].check();
                        }
                    }),
                        this.check(!0);
                },
                s = (a._gsDefine = function (a, b, c, d) {
                    return new r(a, b, c, d);
                }),
                t = (l._class = function (a, b, c) {
                    return (
                        (b = b || function () {}),
                        s(
                            a,
                            [],
                            function () {
                                return b;
                            },
                            c
                        ),
                        b
                    );
                });
            s.globals = e;
            var u = [0, 0, 1, 1],
                v = t(
                    "easing.Ease",
                    function (a, b, c, d) {
                        (this._func = a), (this._type = c || 0), (this._power = d || 0), (this._params = b ? u.concat(b) : u);
                    },
                    !0
                ),
                w = (v.map = {}),
                x = (v.register = function (a, b, c, d) {
                    for (var e, f, g, h, i = b.split(","), j = i.length, k = (c || "easeIn,easeOut,easeInOut").split(","); --j > -1; )
                        for (f = i[j], e = d ? t("easing." + f, null, !0) : l.easing[f] || {}, g = k.length; --g > -1; ) (h = k[g]), (w[f + "." + h] = w[h + f] = e[h] = a.getRatio ? a : a[h] || new a());
                });
            for (
                h = v.prototype,
                    h._calcEnd = !1,
                    h.getRatio = function (a) {
                        if (this._func) return (this._params[0] = a), this._func.apply(null, this._params);
                        var b = this._type,
                            c = this._power,
                            d = 1 === b ? 1 - a : 2 === b ? a : 0.5 > a ? 2 * a : 2 * (1 - a);
                        return 1 === c ? (d *= d) : 2 === c ? (d *= d * d) : 3 === c ? (d *= d * d * d) : 4 === c && (d *= d * d * d * d), 1 === b ? 1 - d : 2 === b ? d : 0.5 > a ? d / 2 : 1 - d / 2;
                    },
                    f = ["Linear", "Quad", "Cubic", "Quart", "Quint,Strong"],
                    g = f.length;
                --g > -1;

            )
                (h = f[g] + ",Power" + g), x(new v(null, null, 1, g), h, "easeOut", !0), x(new v(null, null, 2, g), h, "easeIn" + (0 === g ? ",easeNone" : "")), x(new v(null, null, 3, g), h, "easeInOut");
            (w.linear = l.easing.Linear.easeIn), (w.swing = l.easing.Quad.easeInOut);
            var y = t("events.EventDispatcher", function (a) {
                (this._listeners = {}), (this._eventTarget = a || this);
            });
            (h = y.prototype),
                (h.addEventListener = function (a, b, c, d, e) {
                    e = e || 0;
                    var f,
                        g,
                        h = this._listeners[a],
                        k = 0;
                    for (this !== i || j || i.wake(), null == h && (this._listeners[a] = h = []), g = h.length; --g > -1; ) (f = h[g]), f.c === b && f.s === c ? h.splice(g, 1) : 0 === k && f.pr < e && (k = g + 1);
                    h.splice(k, 0, { c: b, s: c, up: d, pr: e });
                }),
                (h.removeEventListener = function (a, b) {
                    var c,
                        d = this._listeners[a];
                    if (d) for (c = d.length; --c > -1; ) if (d[c].c === b) return void d.splice(c, 1);
                }),
                (h.dispatchEvent = function (a) {
                    var b,
                        c,
                        d,
                        e = this._listeners[a];
                    if (e) for (b = e.length, b > 1 && (e = e.slice(0)), c = this._eventTarget; --b > -1; ) (d = e[b]), d && (d.up ? d.c.call(d.s || c, { type: a, target: c }) : d.c.call(d.s || c));
                });
            var z = a.requestAnimationFrame,
                A = a.cancelAnimationFrame,
                B =
                    Date.now ||
                    function () {
                        return new Date().getTime();
                    },
                C = B();
            for (f = ["ms", "moz", "webkit", "o"], g = f.length; --g > -1 && !z; ) (z = a[f[g] + "RequestAnimationFrame"]), (A = a[f[g] + "CancelAnimationFrame"] || a[f[g] + "CancelRequestAnimationFrame"]);
            t("Ticker", function (a, b) {
                var c,
                    e,
                    f,
                    g,
                    h,
                    k = this,
                    l = B(),
                    n = !(b === !1 || !z) && "auto",
                    p = 500,
                    q = 33,
                    r = "tick",
                    s = function (a) {
                        var b,
                            d,
                            i = B() - C;
                        i > p && (l += i - q), (C += i), (k.time = (C - l) / 1e3), (b = k.time - h), (!c || b > 0 || a === !0) && (k.frame++, (h += b + (b >= g ? 0.004 : g - b)), (d = !0)), a !== !0 && (f = e(s)), d && k.dispatchEvent(r);
                    };
                y.call(k),
                    (k.time = k.frame = 0),
                    (k.tick = function () {
                        s(!0);
                    }),
                    (k.lagSmoothing = function (a, b) {
                        return arguments.length ? ((p = a || 1 / m), void (q = Math.min(b, p, 0))) : 1 / m > p;
                    }),
                    (k.sleep = function () {
                        null != f && (n && A ? A(f) : clearTimeout(f), (e = o), (f = null), k === i && (j = !1));
                    }),
                    (k.wake = function (a) {
                        null !== f ? k.sleep() : a ? (l += -C + (C = B())) : k.frame > 10 && (C = B() - p + 5),
                            (e =
                                0 === c
                                    ? o
                                    : n && z
                                    ? z
                                    : function (a) {
                                          return setTimeout(a, (1e3 * (h - k.time) + 1) | 0);
                                      }),
                            k === i && (j = !0),
                            s(2);
                    }),
                    (k.fps = function (a) {
                        return arguments.length ? ((c = a), (g = 1 / (c || 60)), (h = this.time + g), void k.wake()) : c;
                    }),
                    (k.useRAF = function (a) {
                        return arguments.length ? (k.sleep(), (n = a), void k.fps(c)) : n;
                    }),
                    k.fps(a),
                    setTimeout(function () {
                        "auto" === n && k.frame < 5 && "hidden" !== (d || {}).visibilityState && k.useRAF(!1);
                    }, 1500);
            }),
                (h = l.Ticker.prototype = new l.events.EventDispatcher()),
                (h.constructor = l.Ticker);
            var D = t("core.Animation", function (a, b) {
                if (
                    ((this.vars = b = b || {}),
                    (this._duration = this._totalDuration = a || 0),
                    (this._delay = Number(b.delay) || 0),
                    (this._timeScale = 1),
                    (this._active = b.immediateRender === !0),
                    (this.data = b.data),
                    (this._reversed = b.reversed === !0),
                    X)
                ) {
                    j || i.wake();
                    var c = this.vars.useFrames ? W : X;
                    c.add(this, c._time), this.vars.paused && this.paused(!0);
                }
            });
            (i = D.ticker = new l.Ticker()),
                (h = D.prototype),
                (h._dirty = h._gc = h._initted = h._paused = !1),
                (h._totalTime = h._time = 0),
                (h._rawPrevTime = -1),
                (h._next = h._last = h._onUpdate = h._timeline = h.timeline = null),
                (h._paused = !1);
            var E = function () {
                j && B() - C > 2e3 && ("hidden" !== (d || {}).visibilityState || !i.lagSmoothing()) && i.wake();
                var a = setTimeout(E, 2e3);
                a.unref && a.unref();
            };
            E(),
                (h.play = function (a, b) {
                    return null != a && this.seek(a, b), this.reversed(!1).paused(!1);
                }),
                (h.pause = function (a, b) {
                    return null != a && this.seek(a, b), this.paused(!0);
                }),
                (h.resume = function (a, b) {
                    return null != a && this.seek(a, b), this.paused(!1);
                }),
                (h.seek = function (a, b) {
                    return this.totalTime(Number(a), b !== !1);
                }),
                (h.restart = function (a, b) {
                    return this.reversed(!1)
                        .paused(!1)
                        .totalTime(a ? -this._delay : 0, b !== !1, !0);
                }),
                (h.reverse = function (a, b) {
                    return null != a && this.seek(a || this.totalDuration(), b), this.reversed(!0).paused(!1);
                }),
                (h.render = function (a, b, c) {}),
                (h.invalidate = function () {
                    return (this._time = this._totalTime = 0), (this._initted = this._gc = !1), (this._rawPrevTime = -1), (this._gc || !this.timeline) && this._enabled(!0), this;
                }),
                (h.isActive = function () {
                    var a,
                        b = this._timeline,
                        c = this._startTime;
                    return !b || (!this._gc && !this._paused && b.isActive() && (a = b.rawTime(!0)) >= c && a < c + this.totalDuration() / this._timeScale - 1e-7);
                }),
                (h._enabled = function (a, b) {
                    return (
                        j || i.wake(),
                        (this._gc = !a),
                        (this._active = this.isActive()),
                        b !== !0 && (a && !this.timeline ? this._timeline.add(this, this._startTime - this._delay) : !a && this.timeline && this._timeline._remove(this, !0)),
                        !1
                    );
                }),
                (h._kill = function (a, b) {
                    return this._enabled(!1, !1);
                }),
                (h.kill = function (a, b) {
                    return this._kill(a, b), this;
                }),
                (h._uncache = function (a) {
                    for (var b = a ? this : this.timeline; b; ) (b._dirty = !0), (b = b.timeline);
                    return this;
                }),
                (h._swapSelfInParams = function (a) {
                    for (var b = a.length, c = a.concat(); --b > -1; ) "{self}" === a[b] && (c[b] = this);
                    return c;
                }),
                (h._callback = function (a) {
                    var b = this.vars,
                        c = b[a],
                        d = b[a + "Params"],
                        e = b[a + "Scope"] || b.callbackScope || this,
                        f = d ? d.length : 0;
                    switch (f) {
                        case 0:
                            c.call(e);
                            break;
                        case 1:
                            c.call(e, d[0]);
                            break;
                        case 2:
                            c.call(e, d[0], d[1]);
                            break;
                        default:
                            c.apply(e, d);
                    }
                }),
                (h.eventCallback = function (a, b, c, d) {
                    if ("on" === (a || "").substr(0, 2)) {
                        var e = this.vars;
                        if (1 === arguments.length) return e[a];
                        null == b ? delete e[a] : ((e[a] = b), (e[a + "Params"] = p(c) && -1 !== c.join("").indexOf("{self}") ? this._swapSelfInParams(c) : c), (e[a + "Scope"] = d)), "onUpdate" === a && (this._onUpdate = b);
                    }
                    return this;
                }),
                (h.delay = function (a) {
                    return arguments.length ? (this._timeline.smoothChildTiming && this.startTime(this._startTime + a - this._delay), (this._delay = a), this) : this._delay;
                }),
                (h.duration = function (a) {
                    return arguments.length
                        ? ((this._duration = this._totalDuration = a),
                          this._uncache(!0),
                          this._timeline.smoothChildTiming && this._time > 0 && this._time < this._duration && 0 !== a && this.totalTime(this._totalTime * (a / this._duration), !0),
                          this)
                        : ((this._dirty = !1), this._duration);
                }),
                (h.totalDuration = function (a) {
                    return (this._dirty = !1), arguments.length ? this.duration(a) : this._totalDuration;
                }),
                (h.time = function (a, b) {
                    return arguments.length ? (this._dirty && this.totalDuration(), this.totalTime(a > this._duration ? this._duration : a, b)) : this._time;
                }),
                (h.totalTime = function (a, b, c) {
                    if ((j || i.wake(), !arguments.length)) return this._totalTime;
                    if (this._timeline) {
                        if ((0 > a && !c && (a += this.totalDuration()), this._timeline.smoothChildTiming)) {
                            this._dirty && this.totalDuration();
                            var d = this._totalDuration,
                                e = this._timeline;
                            if ((a > d && !c && (a = d), (this._startTime = (this._paused ? this._pauseTime : e._time) - (this._reversed ? d - a : a) / this._timeScale), e._dirty || this._uncache(!1), e._timeline))
                                for (; e._timeline; ) e._timeline._time !== (e._startTime + e._totalTime) / e._timeScale && e.totalTime(e._totalTime, !0), (e = e._timeline);
                        }
                        this._gc && this._enabled(!0, !1), (this._totalTime !== a || 0 === this._duration) && (J.length && Z(), this.render(a, b, !1), J.length && Z());
                    }
                    return this;
                }),
                (h.progress = h.totalProgress = function (a, b) {
                    var c = this.duration();
                    return arguments.length ? this.totalTime(c * a, b) : c ? this._time / c : this.ratio;
                }),
                (h.startTime = function (a) {
                    return arguments.length ? (a !== this._startTime && ((this._startTime = a), this.timeline && this.timeline._sortChildren && this.timeline.add(this, a - this._delay)), this) : this._startTime;
                }),
                (h.endTime = function (a) {
                    return this._startTime + (0 != a ? this.totalDuration() : this.duration()) / this._timeScale;
                }),
                (h.timeScale = function (a) {
                    if (!arguments.length) return this._timeScale;
                    var b, c;
                    for (
                        a = a || m,
                            this._timeline && this._timeline.smoothChildTiming && ((b = this._pauseTime), (c = b || 0 === b ? b : this._timeline.totalTime()), (this._startTime = c - ((c - this._startTime) * this._timeScale) / a)),
                            this._timeScale = a,
                            c = this.timeline;
                        c && c.timeline;

                    )
                        (c._dirty = !0), c.totalDuration(), (c = c.timeline);
                    return this;
                }),
                (h.reversed = function (a) {
                    return arguments.length
                        ? (a != this._reversed && ((this._reversed = a), this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, !0)), this)
                        : this._reversed;
                }),
                (h.paused = function (a) {
                    if (!arguments.length) return this._paused;
                    var b,
                        c,
                        d = this._timeline;
                    return (
                        a != this._paused &&
                            d &&
                            (j || a || i.wake(),
                            (b = d.rawTime()),
                            (c = b - this._pauseTime),
                            !a && d.smoothChildTiming && ((this._startTime += c), this._uncache(!1)),
                            (this._pauseTime = a ? b : null),
                            (this._paused = a),
                            (this._active = this.isActive()),
                            !a && 0 !== c && this._initted && this.duration() && ((b = d.smoothChildTiming ? this._totalTime : (b - this._startTime) / this._timeScale), this.render(b, b === this._totalTime, !0))),
                        this._gc && !a && this._enabled(!0, !1),
                        this
                    );
                });
            var F = t("core.SimpleTimeline", function (a) {
                D.call(this, 0, a), (this.autoRemoveChildren = this.smoothChildTiming = !0);
            });
            (h = F.prototype = new D()),
                (h.constructor = F),
                (h.kill()._gc = !1),
                (h._first = h._last = h._recent = null),
                (h._sortChildren = !1),
                (h.add = h.insert = function (a, b, c, d) {
                    var e, f;
                    if (
                        ((a._startTime = Number(b || 0) + a._delay),
                        a._paused && this !== a._timeline && (a._pauseTime = a._startTime + (this.rawTime() - a._startTime) / a._timeScale),
                        a.timeline && a.timeline._remove(a, !0),
                        (a.timeline = a._timeline = this),
                        a._gc && a._enabled(!0, !0),
                        (e = this._last),
                        this._sortChildren)
                    )
                        for (f = a._startTime; e && e._startTime > f; ) e = e._prev;
                    return (
                        e ? ((a._next = e._next), (e._next = a)) : ((a._next = this._first), (this._first = a)), a._next ? (a._next._prev = a) : (this._last = a), (a._prev = e), (this._recent = a), this._timeline && this._uncache(!0), this
                    );
                }),
                (h._remove = function (a, b) {
                    return (
                        a.timeline === this &&
                            (b || a._enabled(!1, !0),
                            a._prev ? (a._prev._next = a._next) : this._first === a && (this._first = a._next),
                            a._next ? (a._next._prev = a._prev) : this._last === a && (this._last = a._prev),
                            (a._next = a._prev = a.timeline = null),
                            a === this._recent && (this._recent = this._last),
                            this._timeline && this._uncache(!0)),
                        this
                    );
                }),
                (h.render = function (a, b, c) {
                    var d,
                        e = this._first;
                    for (this._totalTime = this._time = this._rawPrevTime = a; e; )
                        (d = e._next),
                            (e._active || (a >= e._startTime && !e._paused && !e._gc)) &&
                                (e._reversed ? e.render((e._dirty ? e.totalDuration() : e._totalDuration) - (a - e._startTime) * e._timeScale, b, c) : e.render((a - e._startTime) * e._timeScale, b, c)),
                            (e = d);
                }),
                (h.rawTime = function () {
                    return j || i.wake(), this._totalTime;
                });
            var G = t(
                    "TweenLite",
                    function (b, c, d) {
                        if ((D.call(this, c, d), (this.render = G.prototype.render), null == b)) throw "Cannot tween a null target.";
                        this.target = b = "string" != typeof b ? b : G.selector(b) || b;
                        var e,
                            f,
                            g,
                            h = b.jquery || (b.length && b !== a && b[0] && (b[0] === a || (b[0].nodeType && b[0].style && !b.nodeType))),
                            i = this.vars.overwrite;
                        if (((this._overwrite = i = null == i ? V[G.defaultOverwrite] : "number" == typeof i ? i >> 0 : V[i]), (h || b instanceof Array || (b.push && p(b))) && "number" != typeof b[0]))
                            for (this._targets = g = n(b), this._propLookup = [], this._siblings = [], e = 0; e < g.length; e++)
                                (f = g[e]),
                                    f
                                        ? "string" != typeof f
                                            ? f.length && f !== a && f[0] && (f[0] === a || (f[0].nodeType && f[0].style && !f.nodeType))
                                                ? (g.splice(e--, 1), (this._targets = g = g.concat(n(f))))
                                                : ((this._siblings[e] = $(f, this, !1)), 1 === i && this._siblings[e].length > 1 && aa(f, this, null, 1, this._siblings[e]))
                                            : ((f = g[e--] = G.selector(f)), "string" == typeof f && g.splice(e + 1, 1))
                                        : g.splice(e--, 1);
                        else (this._propLookup = {}), (this._siblings = $(b, this, !1)), 1 === i && this._siblings.length > 1 && aa(b, this, null, 1, this._siblings);
                        (this.vars.immediateRender || (0 === c && 0 === this._delay && this.vars.immediateRender !== !1)) && ((this._time = -m), this.render(Math.min(0, -this._delay)));
                    },
                    !0
                ),
                H = function (b) {
                    return b && b.length && b !== a && b[0] && (b[0] === a || (b[0].nodeType && b[0].style && !b.nodeType));
                },
                I = function (a, b) {
                    var c,
                        d = {};
                    for (c in a)
                        U[c] || (c in b && "transform" !== c && "x" !== c && "y" !== c && "width" !== c && "height" !== c && "className" !== c && "border" !== c) || !(!R[c] || (R[c] && R[c]._autoCSS)) || ((d[c] = a[c]), delete a[c]);
                    a.css = d;
                };
            (h = G.prototype = new D()),
                (h.constructor = G),
                (h.kill()._gc = !1),
                (h.ratio = 0),
                (h._firstPT = h._targets = h._overwrittenProps = h._startAt = null),
                (h._notifyPluginsOfEnabled = h._lazy = !1),
                (G.version = "1.20.4"),
                (G.defaultEase = h._ease = new v(null, null, 1, 1)),
                (G.defaultOverwrite = "auto"),
                (G.ticker = i),
                (G.autoSleep = 120),
                (G.lagSmoothing = function (a, b) {
                    i.lagSmoothing(a, b);
                }),
                (G.selector =
                    a.$ ||
                    a.jQuery ||
                    function (b) {
                        var c = a.$ || a.jQuery;
                        return c ? ((G.selector = c), c(b)) : "undefined" == typeof d ? b : d.querySelectorAll ? d.querySelectorAll(b) : d.getElementById("#" === b.charAt(0) ? b.substr(1) : b);
                    });
            var J = [],
                K = {},
                L = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,
                M = /[\+-]=-?[\.\d]/,
                N = function (a) {
                    for (var b, c = this._firstPT, d = 1e-6; c; )
                        (b = c.blob ? (1 === a && null != this.end ? this.end : a ? this.join("") : this.start) : c.c * a + c.s),
                            c.m ? (b = c.m(b, this._target || c.t)) : d > b && b > -d && !c.blob && (b = 0),
                            c.f ? (c.fp ? c.t[c.p](c.fp, b) : c.t[c.p](b)) : (c.t[c.p] = b),
                            (c = c._next);
                },
                O = function (a, b, c, d) {
                    var e,
                        f,
                        g,
                        h,
                        i,
                        j,
                        k,
                        l = [],
                        m = 0,
                        n = "",
                        o = 0;
                    for (
                        l.start = a,
                            l.end = b,
                            a = l[0] = a + "",
                            b = l[1] = b + "",
                            c && (c(l), (a = l[0]), (b = l[1])),
                            l.length = 0,
                            e = a.match(L) || [],
                            f = b.match(L) || [],
                            d && ((d._next = null), (d.blob = 1), (l._firstPT = l._applyPT = d)),
                            i = f.length,
                            h = 0;
                        i > h;
                        h++
                    )
                        (k = f[h]),
                            (j = b.substr(m, b.indexOf(k, m) - m)),
                            (n += j || !h ? j : ","),
                            (m += j.length),
                            o ? (o = (o + 1) % 5) : "rgba(" === j.substr(-5) && (o = 1),
                            k === e[h] || e.length <= h
                                ? (n += k)
                                : (n && (l.push(n), (n = "")),
                                  (g = parseFloat(e[h])),
                                  l.push(g),
                                  (l._firstPT = {
                                      _next: l._firstPT,
                                      t: l,
                                      p: l.length - 1,
                                      s: g,
                                      c: ("=" === k.charAt(1) ? parseInt(k.charAt(0) + "1", 10) * parseFloat(k.substr(2)) : parseFloat(k) - g) || 0,
                                      f: 0,
                                      m: o && 4 > o ? Math.round : 0,
                                  })),
                            (m += k.length);
                    return (n += b.substr(m)), n && l.push(n), (l.setRatio = N), M.test(b) && (l.end = null), l;
                },
                P = function (a, b, c, d, e, f, g, h, i) {
                    "function" == typeof d && (d = d(i || 0, a));
                    var j,
                        k = typeof a[b],
                        l = "function" !== k ? "" : b.indexOf("set") || "function" != typeof a["get" + b.substr(3)] ? b : "get" + b.substr(3),
                        m = "get" !== c ? c : l ? (g ? a[l](g) : a[l]()) : a[b],
                        n = "string" == typeof d && "=" === d.charAt(1),
                        o = { t: a, p: b, s: m, f: "function" === k, pg: 0, n: e || b, m: f ? ("function" == typeof f ? f : Math.round) : 0, pr: 0, c: n ? parseInt(d.charAt(0) + "1", 10) * parseFloat(d.substr(2)) : parseFloat(d) - m || 0 };
                    return (
                        ("number" != typeof m || ("number" != typeof d && !n)) &&
                            (g || isNaN(m) || (!n && isNaN(d)) || "boolean" == typeof m || "boolean" == typeof d
                                ? ((o.fp = g), (j = O(m, n ? parseFloat(o.s) + o.c + (o.s + "").replace(/[0-9\-\.]/g, "") : d, h || G.defaultStringFilter, o)), (o = { t: j, p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: e || b, pr: 0, m: 0 }))
                                : ((o.s = parseFloat(m)), n || (o.c = parseFloat(d) - o.s || 0))),
                        o.c ? ((o._next = this._firstPT) && (o._next._prev = o), (this._firstPT = o), o) : void 0
                    );
                },
                Q = (G._internals = { isArray: p, isSelector: H, lazyTweens: J, blobDif: O }),
                R = (G._plugins = {}),
                S = (Q.tweenLookup = {}),
                T = 0,
                U = (Q.reservedProps = {
                    ease: 1,
                    delay: 1,
                    overwrite: 1,
                    onComplete: 1,
                    onCompleteParams: 1,
                    onCompleteScope: 1,
                    useFrames: 1,
                    runBackwards: 1,
                    startAt: 1,
                    onUpdate: 1,
                    onUpdateParams: 1,
                    onUpdateScope: 1,
                    onStart: 1,
                    onStartParams: 1,
                    onStartScope: 1,
                    onReverseComplete: 1,
                    onReverseCompleteParams: 1,
                    onReverseCompleteScope: 1,
                    onRepeat: 1,
                    onRepeatParams: 1,
                    onRepeatScope: 1,
                    easeParams: 1,
                    yoyo: 1,
                    immediateRender: 1,
                    repeat: 1,
                    repeatDelay: 1,
                    data: 1,
                    paused: 1,
                    reversed: 1,
                    autoCSS: 1,
                    lazy: 1,
                    onOverwrite: 1,
                    callbackScope: 1,
                    stringFilter: 1,
                    id: 1,
                    yoyoEase: 1,
                }),
                V = { none: 0, all: 1, auto: 2, concurrent: 3, allOnStart: 4, preexisting: 5, true: 1, false: 0 },
                W = (D._rootFramesTimeline = new F()),
                X = (D._rootTimeline = new F()),
                Y = 30,
                Z = (Q.lazyRender = function () {
                    var a,
                        b = J.length;
                    for (K = {}; --b > -1; ) (a = J[b]), a && a._lazy !== !1 && (a.render(a._lazy[0], a._lazy[1], !0), (a._lazy = !1));
                    J.length = 0;
                });
            (X._startTime = i.time),
                (W._startTime = i.frame),
                (X._active = W._active = !0),
                setTimeout(Z, 1),
                (D._updateRoot = G.render = function () {
                    var a, b, c;
                    if ((J.length && Z(), X.render((i.time - X._startTime) * X._timeScale, !1, !1), W.render((i.frame - W._startTime) * W._timeScale, !1, !1), J.length && Z(), i.frame >= Y)) {
                        Y = i.frame + (parseInt(G.autoSleep, 10) || 120);
                        for (c in S) {
                            for (b = S[c].tweens, a = b.length; --a > -1; ) b[a]._gc && b.splice(a, 1);
                            0 === b.length && delete S[c];
                        }
                        if (((c = X._first), (!c || c._paused) && G.autoSleep && !W._first && 1 === i._listeners.tick.length)) {
                            for (; c && c._paused; ) c = c._next;
                            c || i.sleep();
                        }
                    }
                }),
                i.addEventListener("tick", D._updateRoot);
            var $ = function (a, b, c) {
                    var d,
                        e,
                        f = a._gsTweenID;
                    if ((S[f || (a._gsTweenID = f = "t" + T++)] || (S[f] = { target: a, tweens: [] }), b && ((d = S[f].tweens), (d[(e = d.length)] = b), c))) for (; --e > -1; ) d[e] === b && d.splice(e, 1);
                    return S[f].tweens;
                },
                _ = function (a, b, c, d) {
                    var e,
                        f,
                        g = a.vars.onOverwrite;
                    return g && (e = g(a, b, c, d)), (g = G.onOverwrite), g && (f = g(a, b, c, d)), e !== !1 && f !== !1;
                },
                aa = function (a, b, c, d, e) {
                    var f, g, h, i;
                    if (1 === d || d >= 4) {
                        for (i = e.length, f = 0; i > f; f++)
                            if ((h = e[f]) !== b) h._gc || (h._kill(null, a, b) && (g = !0));
                            else if (5 === d) break;
                        return g;
                    }
                    var j,
                        k = b._startTime + m,
                        l = [],
                        n = 0,
                        o = 0 === b._duration;
                    for (f = e.length; --f > -1; )
                        (h = e[f]) === b ||
                            h._gc ||
                            h._paused ||
                            (h._timeline !== b._timeline
                                ? ((j = j || ba(b, 0, o)), 0 === ba(h, j, o) && (l[n++] = h))
                                : h._startTime <= k && h._startTime + h.totalDuration() / h._timeScale > k && (((o || !h._initted) && k - h._startTime <= 2e-10) || (l[n++] = h)));
                    for (f = n; --f > -1; )
                        if (((h = l[f]), 2 === d && h._kill(c, a, b) && (g = !0), 2 !== d || (!h._firstPT && h._initted))) {
                            if (2 !== d && !_(h, b)) continue;
                            h._enabled(!1, !1) && (g = !0);
                        }
                    return g;
                },
                ba = function (a, b, c) {
                    for (var d = a._timeline, e = d._timeScale, f = a._startTime; d._timeline; ) {
                        if (((f += d._startTime), (e *= d._timeScale), d._paused)) return -100;
                        d = d._timeline;
                    }
                    return (f /= e), f > b ? f - b : (c && f === b) || (!a._initted && 2 * m > f - b) ? m : (f += a.totalDuration() / a._timeScale / e) > b + m ? 0 : f - b - m;
                };
            (h._init = function () {
                var a,
                    b,
                    c,
                    d,
                    e,
                    f,
                    g = this.vars,
                    h = this._overwrittenProps,
                    i = this._duration,
                    j = !!g.immediateRender,
                    k = g.ease;
                if (g.startAt) {
                    this._startAt && (this._startAt.render(-1, !0), this._startAt.kill()), (e = {});
                    for (d in g.startAt) e[d] = g.startAt[d];
                    if (
                        ((e.data = "isStart"),
                        (e.overwrite = !1),
                        (e.immediateRender = !0),
                        (e.lazy = j && g.lazy !== !1),
                        (e.startAt = e.delay = null),
                        (e.onUpdate = g.onUpdate),
                        (e.onUpdateParams = g.onUpdateParams),
                        (e.onUpdateScope = g.onUpdateScope || g.callbackScope || this),
                        (this._startAt = G.to(this.target, 0, e)),
                        j)
                    )
                        if (this._time > 0) this._startAt = null;
                        else if (0 !== i) return;
                } else if (g.runBackwards && 0 !== i)
                    if (this._startAt) this._startAt.render(-1, !0), this._startAt.kill(), (this._startAt = null);
                    else {
                        0 !== this._time && (j = !1), (c = {});
                        for (d in g) (U[d] && "autoCSS" !== d) || (c[d] = g[d]);
                        if (((c.overwrite = 0), (c.data = "isFromStart"), (c.lazy = j && g.lazy !== !1), (c.immediateRender = j), (this._startAt = G.to(this.target, 0, c)), j)) {
                            if (0 === this._time) return;
                        } else this._startAt._init(), this._startAt._enabled(!1), this.vars.immediateRender && (this._startAt = null);
                    }
                if (
                    ((this._ease = k = k ? (k instanceof v ? k : "function" == typeof k ? new v(k, g.easeParams) : w[k] || G.defaultEase) : G.defaultEase),
                    g.easeParams instanceof Array && k.config && (this._ease = k.config.apply(k, g.easeParams)),
                    (this._easeType = this._ease._type),
                    (this._easePower = this._ease._power),
                    (this._firstPT = null),
                    this._targets)
                )
                    for (f = this._targets.length, a = 0; f > a; a++) this._initProps(this._targets[a], (this._propLookup[a] = {}), this._siblings[a], h ? h[a] : null, a) && (b = !0);
                else b = this._initProps(this.target, this._propLookup, this._siblings, h, 0);
                if ((b && G._onPluginEvent("_onInitAllProps", this), h && (this._firstPT || ("function" != typeof this.target && this._enabled(!1, !1))), g.runBackwards))
                    for (c = this._firstPT; c; ) (c.s += c.c), (c.c = -c.c), (c = c._next);
                (this._onUpdate = g.onUpdate), (this._initted = !0);
            }),
                (h._initProps = function (b, c, d, e, f) {
                    var g, h, i, j, k, l;
                    if (null == b) return !1;
                    K[b._gsTweenID] && Z(), this.vars.css || (b.style && b !== a && b.nodeType && R.css && this.vars.autoCSS !== !1 && I(this.vars, b));
                    for (g in this.vars)
                        if (((l = this.vars[g]), U[g])) l && (l instanceof Array || (l.push && p(l))) && -1 !== l.join("").indexOf("{self}") && (this.vars[g] = l = this._swapSelfInParams(l, this));
                        else if (R[g] && (j = new R[g]())._onInitTween(b, this.vars[g], this, f)) {
                            for (this._firstPT = k = { _next: this._firstPT, t: j, p: "setRatio", s: 0, c: 1, f: 1, n: g, pg: 1, pr: j._priority, m: 0 }, h = j._overwriteProps.length; --h > -1; ) c[j._overwriteProps[h]] = this._firstPT;
                            (j._priority || j._onInitAllProps) && (i = !0), (j._onDisable || j._onEnable) && (this._notifyPluginsOfEnabled = !0), k._next && (k._next._prev = k);
                        } else c[g] = P.call(this, b, g, "get", l, g, 0, null, this.vars.stringFilter, f);
                    return e && this._kill(e, b)
                        ? this._initProps(b, c, d, e, f)
                        : this._overwrite > 1 && this._firstPT && d.length > 1 && aa(b, this, c, this._overwrite, d)
                        ? (this._kill(c, b), this._initProps(b, c, d, e, f))
                        : (this._firstPT && ((this.vars.lazy !== !1 && this._duration) || (this.vars.lazy && !this._duration)) && (K[b._gsTweenID] = !0), i);
                }),
                (h.render = function (a, b, c) {
                    var d,
                        e,
                        f,
                        g,
                        h = this._time,
                        i = this._duration,
                        j = this._rawPrevTime;
                    if (a >= i - 1e-7 && a >= 0)
                        (this._totalTime = this._time = i),
                            (this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1),
                            this._reversed || ((d = !0), (e = "onComplete"), (c = c || this._timeline.autoRemoveChildren)),
                            0 === i &&
                                (this._initted || !this.vars.lazy || c) &&
                                (this._startTime === this._timeline._duration && (a = 0),
                                (0 > j || (0 >= a && a >= -1e-7) || (j === m && "isPause" !== this.data)) && j !== a && ((c = !0), j > m && (e = "onReverseComplete")),
                                (this._rawPrevTime = g = !b || a || j === a ? a : m));
                    else if (1e-7 > a)
                        (this._totalTime = this._time = 0),
                            (this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0),
                            (0 !== h || (0 === i && j > 0)) && ((e = "onReverseComplete"), (d = this._reversed)),
                            0 > a && ((this._active = !1), 0 === i && (this._initted || !this.vars.lazy || c) && (j >= 0 && (j !== m || "isPause" !== this.data) && (c = !0), (this._rawPrevTime = g = !b || a || j === a ? a : m))),
                            (!this._initted || (this._startAt && this._startAt.progress())) && (c = !0);
                    else if (((this._totalTime = this._time = a), this._easeType)) {
                        var k = a / i,
                            l = this._easeType,
                            n = this._easePower;
                        (1 === l || (3 === l && k >= 0.5)) && (k = 1 - k),
                            3 === l && (k *= 2),
                            1 === n ? (k *= k) : 2 === n ? (k *= k * k) : 3 === n ? (k *= k * k * k) : 4 === n && (k *= k * k * k * k),
                            1 === l ? (this.ratio = 1 - k) : 2 === l ? (this.ratio = k) : 0.5 > a / i ? (this.ratio = k / 2) : (this.ratio = 1 - k / 2);
                    } else this.ratio = this._ease.getRatio(a / i);
                    if (this._time !== h || c) {
                        if (!this._initted) {
                            if ((this._init(), !this._initted || this._gc)) return;
                            if (!c && this._firstPT && ((this.vars.lazy !== !1 && this._duration) || (this.vars.lazy && !this._duration)))
                                return (this._time = this._totalTime = h), (this._rawPrevTime = j), J.push(this), void (this._lazy = [a, b]);
                            this._time && !d ? (this.ratio = this._ease.getRatio(this._time / i)) : d && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1));
                        }
                        for (
                            this._lazy !== !1 && (this._lazy = !1),
                                this._active || (!this._paused && this._time !== h && a >= 0 && (this._active = !0)),
                                0 === h && (this._startAt && (a >= 0 ? this._startAt.render(a, !0, c) : e || (e = "_dummyGS")), this.vars.onStart && (0 !== this._time || 0 === i) && (b || this._callback("onStart"))),
                                f = this._firstPT;
                            f;

                        )
                            f.f ? f.t[f.p](f.c * this.ratio + f.s) : (f.t[f.p] = f.c * this.ratio + f.s), (f = f._next);
                        this._onUpdate && (0 > a && this._startAt && a !== -1e-4 && this._startAt.render(a, !0, c), b || ((this._time !== h || d || c) && this._callback("onUpdate"))),
                            e &&
                                (!this._gc || c) &&
                                (0 > a && this._startAt && !this._onUpdate && a !== -1e-4 && this._startAt.render(a, !0, c),
                                d && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), (this._active = !1)),
                                !b && this.vars[e] && this._callback(e),
                                0 === i && this._rawPrevTime === m && g !== m && (this._rawPrevTime = 0));
                    }
                }),
                (h._kill = function (a, b, c) {
                    if (("all" === a && (a = null), null == a && (null == b || b === this.target))) return (this._lazy = !1), this._enabled(!1, !1);
                    b = "string" != typeof b ? b || this._targets || this.target : G.selector(b) || b;
                    var d,
                        e,
                        f,
                        g,
                        h,
                        i,
                        j,
                        k,
                        l,
                        m = c && this._time && c._startTime === this._startTime && this._timeline === c._timeline;
                    if ((p(b) || H(b)) && "number" != typeof b[0]) for (d = b.length; --d > -1; ) this._kill(a, b[d], c) && (i = !0);
                    else {
                        if (this._targets) {
                            for (d = this._targets.length; --d > -1; )
                                if (b === this._targets[d]) {
                                    (h = this._propLookup[d] || {}), (this._overwrittenProps = this._overwrittenProps || []), (e = this._overwrittenProps[d] = a ? this._overwrittenProps[d] || {} : "all");
                                    break;
                                }
                        } else {
                            if (b !== this.target) return !1;
                            (h = this._propLookup), (e = this._overwrittenProps = a ? this._overwrittenProps || {} : "all");
                        }
                        if (h) {
                            if (((j = a || h), (k = a !== e && "all" !== e && a !== h && ("object" != typeof a || !a._tempKill)), c && (G.onOverwrite || this.vars.onOverwrite))) {
                                for (f in j) h[f] && (l || (l = []), l.push(f));
                                if ((l || !a) && !_(this, c, b, l)) return !1;
                            }
                            for (f in j)
                                (g = h[f]) &&
                                    (m && (g.f ? g.t[g.p](g.s) : (g.t[g.p] = g.s), (i = !0)),
                                    g.pg && g.t._kill(j) && (i = !0),
                                    (g.pg && 0 !== g.t._overwriteProps.length) || (g._prev ? (g._prev._next = g._next) : g === this._firstPT && (this._firstPT = g._next), g._next && (g._next._prev = g._prev), (g._next = g._prev = null)),
                                    delete h[f]),
                                    k && (e[f] = 1);
                            !this._firstPT && this._initted && this._enabled(!1, !1);
                        }
                    }
                    return i;
                }),
                (h.invalidate = function () {
                    return (
                        this._notifyPluginsOfEnabled && G._onPluginEvent("_onDisable", this),
                        (this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null),
                        (this._notifyPluginsOfEnabled = this._active = this._lazy = !1),
                        (this._propLookup = this._targets ? {} : []),
                        D.prototype.invalidate.call(this),
                        this.vars.immediateRender && ((this._time = -m), this.render(Math.min(0, -this._delay))),
                        this
                    );
                }),
                (h._enabled = function (a, b) {
                    if ((j || i.wake(), a && this._gc)) {
                        var c,
                            d = this._targets;
                        if (d) for (c = d.length; --c > -1; ) this._siblings[c] = $(d[c], this, !0);
                        else this._siblings = $(this.target, this, !0);
                    }
                    return D.prototype._enabled.call(this, a, b), !(!this._notifyPluginsOfEnabled || !this._firstPT) && G._onPluginEvent(a ? "_onEnable" : "_onDisable", this);
                }),
                (G.to = function (a, b, c) {
                    return new G(a, b, c);
                }),
                (G.from = function (a, b, c) {
                    return (c.runBackwards = !0), (c.immediateRender = 0 != c.immediateRender), new G(a, b, c);
                }),
                (G.fromTo = function (a, b, c, d) {
                    return (d.startAt = c), (d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender), new G(a, b, d);
                }),
                (G.delayedCall = function (a, b, c, d, e) {
                    return new G(b, 0, { delay: a, onComplete: b, onCompleteParams: c, callbackScope: d, onReverseComplete: b, onReverseCompleteParams: c, immediateRender: !1, lazy: !1, useFrames: e, overwrite: 0 });
                }),
                (G.set = function (a, b) {
                    return new G(a, 0, b);
                }),
                (G.getTweensOf = function (a, b) {
                    if (null == a) return [];
                    a = "string" != typeof a ? a : G.selector(a) || a;
                    var c, d, e, f;
                    if ((p(a) || H(a)) && "number" != typeof a[0]) {
                        for (c = a.length, d = []; --c > -1; ) d = d.concat(G.getTweensOf(a[c], b));
                        for (c = d.length; --c > -1; ) for (f = d[c], e = c; --e > -1; ) f === d[e] && d.splice(c, 1);
                    } else if (a._gsTweenID) for (d = $(a).concat(), c = d.length; --c > -1; ) (d[c]._gc || (b && !d[c].isActive())) && d.splice(c, 1);
                    return d || [];
                }),
                (G.killTweensOf = G.killDelayedCallsTo = function (a, b, c) {
                    "object" == typeof b && ((c = b), (b = !1));
                    for (var d = G.getTweensOf(a, b), e = d.length; --e > -1; ) d[e]._kill(c, a);
                });
            var ca = t(
                "plugins.TweenPlugin",
                function (a, b) {
                    (this._overwriteProps = (a || "").split(",")), (this._propName = this._overwriteProps[0]), (this._priority = b || 0), (this._super = ca.prototype);
                },
                !0
            );
            if (
                ((h = ca.prototype),
                (ca.version = "1.19.0"),
                (ca.API = 2),
                (h._firstPT = null),
                (h._addTween = P),
                (h.setRatio = N),
                (h._kill = function (a) {
                    var b,
                        c = this._overwriteProps,
                        d = this._firstPT;
                    if (null != a[this._propName]) this._overwriteProps = [];
                    else for (b = c.length; --b > -1; ) null != a[c[b]] && c.splice(b, 1);
                    for (; d; ) null != a[d.n] && (d._next && (d._next._prev = d._prev), d._prev ? ((d._prev._next = d._next), (d._prev = null)) : this._firstPT === d && (this._firstPT = d._next)), (d = d._next);
                    return !1;
                }),
                (h._mod = h._roundProps = function (a) {
                    for (var b, c = this._firstPT; c; ) (b = a[this._propName] || (null != c.n && a[c.n.split(this._propName + "_").join("")])), b && "function" == typeof b && (2 === c.f ? (c.t._applyPT.m = b) : (c.m = b)), (c = c._next);
                }),
                (G._onPluginEvent = function (a, b) {
                    var c,
                        d,
                        e,
                        f,
                        g,
                        h = b._firstPT;
                    if ("_onInitAllProps" === a) {
                        for (; h; ) {
                            for (g = h._next, d = e; d && d.pr > h.pr; ) d = d._next;
                            (h._prev = d ? d._prev : f) ? (h._prev._next = h) : (e = h), (h._next = d) ? (d._prev = h) : (f = h), (h = g);
                        }
                        h = b._firstPT = e;
                    }
                    for (; h; ) h.pg && "function" == typeof h.t[a] && h.t[a]() && (c = !0), (h = h._next);
                    return c;
                }),
                (ca.activate = function (a) {
                    for (var b = a.length; --b > -1; ) a[b].API === ca.API && (R[new a[b]()._propName] = a[b]);
                    return !0;
                }),
                (s.plugin = function (a) {
                    if (!(a && a.propName && a.init && a.API)) throw "illegal plugin definition.";
                    var b,
                        c = a.propName,
                        d = a.priority || 0,
                        e = a.overwriteProps,
                        f = { init: "_onInitTween", set: "setRatio", kill: "_kill", round: "_mod", mod: "_mod", initAll: "_onInitAllProps" },
                        g = t(
                            "plugins." + c.charAt(0).toUpperCase() + c.substr(1) + "Plugin",
                            function () {
                                ca.call(this, c, d), (this._overwriteProps = e || []);
                            },
                            a.global === !0
                        ),
                        h = (g.prototype = new ca(c));
                    (h.constructor = g), (g.API = a.API);
                    for (b in f) "function" == typeof a[b] && (h[f[b]] = a[b]);
                    return (g.version = a.version), ca.activate([g]), g;
                }),
                (f = a._gsQueue))
            ) {
                for (g = 0; g < f.length; g++) f[g]();
                for (h in q) q[h].func || a.console.log("GSAP encountered missing dependency: " + h);
            }
            j = !1;
        }
    })("undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window, "TweenMax");
var fixto = (function (a, b, c) {
    function d() {
        this._vendor = null;
    }
    function e() {
        var a = !1,
            b = c.createElement("div"),
            d = c.createElement("div");
        b.appendChild(d), (b.style[n] = "translate(0)"), (b.style.marginTop = "10px"), (b.style.visibility = "hidden"), (d.style.position = "fixed"), (d.style.top = 0), c.body.appendChild(b);
        var e = d.getBoundingClientRect();
        return e.top > 0 && (a = !0), c.body.removeChild(b), a;
    }
    function f(b, c, d) {
        (this.child = b), (this._$child = a(b)), (this.parent = c), (this.options = { className: "fixto-fixed", top: 0 }), this._setOptions(d);
    }
    function g(a, b, c) {
        f.call(this, a, b, c),
            (this._replacer = new j.MimicNode(a)),
            (this._ghostNode = this._replacer.replacer),
            this._saveStyles(),
            this._saveViewportHeight(),
            (this._proxied_onscroll = this._bind(this._onscroll, this)),
            (this._proxied_onresize = this._bind(this._onresize, this)),
            this.start();
    }
    function h(a, b, c) {
        f.call(this, a, b, c), this.start();
    }
    var i = (function () {
            var a = {
                getAll: function (a) {
                    return c.defaultView.getComputedStyle(a);
                },
                get: function (a, b) {
                    return this.getAll(a)[b];
                },
                toFloat: function (a) {
                    return parseFloat(a, 10) || 0;
                },
                getFloat: function (a, b) {
                    return this.toFloat(this.get(a, b));
                },
                _getAllCurrentStyle: function (a) {
                    return a.currentStyle;
                },
            };
            return c.documentElement.currentStyle && (a.getAll = a._getAllCurrentStyle), a;
        })(),
        j = (function () {
            function b(a) {
                (this.element = a), (this.replacer = c.createElement("div")), (this.replacer.style.visibility = "hidden"), this.hide(), a.parentNode.insertBefore(this.replacer, a);
            }
            b.prototype = {
                replace: function () {
                    var a = this.replacer.style,
                        b = i.getAll(this.element);
                    (a.width = this._width()),
                        (a.height = this._height()),
                        (a.marginTop = b.marginTop),
                        (a.marginBottom = b.marginBottom),
                        (a.marginLeft = b.marginLeft),
                        (a.marginRight = b.marginRight),
                        (a.cssFloat = b.cssFloat),
                        (a.styleFloat = b.styleFloat),
                        (a.position = b.position),
                        (a.top = b.top),
                        (a.right = b.right),
                        (a.bottom = b.bottom),
                        (a.left = b.left),
                        (a.display = b.display);
                },
                hide: function () {
                    this.replacer.style.display = "none";
                },
                _width: function () {
                    return this.element.getBoundingClientRect().width + "px";
                },
                _widthOffset: function () {
                    return this.element.offsetWidth + "px";
                },
                _height: function () {
                    return this.element.getBoundingClientRect().height + "px";
                },
                _heightOffset: function () {
                    return this.element.offsetHeight + "px";
                },
                destroy: function () {
                    a(this.replacer).remove();
                    for (var b in this) this.hasOwnProperty(b) && (this[b] = null);
                },
            };
            var d = c.documentElement.getBoundingClientRect();
            return d.width || ((b.prototype._width = b.prototype._widthOffset), (b.prototype._height = b.prototype._heightOffset)), { MimicNode: b, computedStyle: i };
        })();
    d.prototype = {
        _vendors: { webkit: { cssPrefix: "-webkit-", jsPrefix: "Webkit" }, moz: { cssPrefix: "-moz-", jsPrefix: "Moz" }, ms: { cssPrefix: "-ms-", jsPrefix: "ms" }, opera: { cssPrefix: "-o-", jsPrefix: "O" } },
        _prefixJsProperty: function (a, b) {
            return a.jsPrefix + b[0].toUpperCase() + b.substr(1);
        },
        _prefixValue: function (a, b) {
            return a.cssPrefix + b;
        },
        _valueSupported: function (a, b, c) {
            try {
                return (c.style[a] = b), c.style[a] === b;
            } catch (d) {
                return !1;
            }
        },
        propertySupported: function (a) {
            return void 0 !== c.documentElement.style[a];
        },
        getJsProperty: function (a) {
            if (this.propertySupported(a)) return a;
            if (this._vendor) return this._prefixJsProperty(this._vendor, a);
            var b;
            for (var c in this._vendors) if (((b = this._prefixJsProperty(this._vendors[c], a)), this.propertySupported(b))) return (this._vendor = this._vendors[c]), b;
            return null;
        },
        getCssValue: function (a, b) {
            var d = c.createElement("div"),
                e = this.getJsProperty(a);
            if (this._valueSupported(e, b, d)) return b;
            var f;
            if (this._vendor && ((f = this._prefixValue(this._vendor, b)), this._valueSupported(e, f, d))) return f;
            for (var g in this._vendors) if (((f = this._prefixValue(this._vendors[g], b)), this._valueSupported(e, f, d))) return (this._vendor = this._vendors[g]), f;
            return null;
        },
    };
    var k,
        l,
        m = new d(),
        n = m.getJsProperty("transform"),
        o = m.getCssValue("position", "sticky"),
        p = m.getCssValue("position", "fixed"),
        q = "Microsoft Internet Explorer" === navigator.appName;
    q && (l = parseFloat(navigator.appVersion.split("MSIE")[1])),
        (f.prototype = {
            _mindtop: function () {
                var a = 0;
                if (this._$mind)
                    for (var b, c, d = 0, e = this._$mind.length; d < e; d++)
                        if (((b = this._$mind[d]), (c = b.getBoundingClientRect()), c.height)) a += c.height;
                        else {
                            var f = i.getAll(b);
                            a += b.offsetHeight + i.toFloat(f.marginTop) + i.toFloat(f.marginBottom);
                        }
                return a;
            },
            stop: function () {
                this._stop(), (this._running = !1);
            },
            start: function () {
                this._running || (this._start(), (this._running = !0));
            },
            destroy: function () {
                this.stop(), this._destroy(), this._$child.removeData("fixto-instance");
                for (var a in this) this.hasOwnProperty(a) && (this[a] = null);
            },
            _setOptions: function (b) {
                a.extend(this.options, b), this.options.mind && (this._$mind = a(this.options.mind)), this.options.zIndex && (this.child.style.zIndex = this.options.zIndex);
            },
            setOptions: function (a) {
                this._setOptions(a), this.refresh();
            },
            _stop: function () {},
            _start: function () {},
            _destroy: function () {},
            refresh: function () {},
        }),
        (g.prototype = new f()),
        a.extend(g.prototype, {
            _bind: function (a, b) {
                return function () {
                    return a.call(b);
                };
            },
            _toresize: 8 === l ? c.documentElement : b,
            _onscroll: function () {
                if (
                    ((this._scrollTop = c.documentElement.scrollTop || c.body.scrollTop),
                    (this._parentBottom = this.parent.offsetHeight + this._fullOffset("offsetTop", this.parent)),
                    this.options.mindBottomPadding !== !1 && (this._parentBottom -= i.getFloat(this.parent, "paddingBottom")),
                    this.fixed)
                ) {
                    if (this._scrollTop > this._parentBottom || this._scrollTop < this._fullOffset("offsetTop", this._ghostNode) - this.options.top - this._mindtop()) return void this._unfix();
                    this._adjust();
                } else {
                    var a = i.getAll(this.child);
                    this._scrollTop < this._parentBottom &&
                        this._scrollTop > this._fullOffset("offsetTop", this.child) - this.options.top - this._mindtop() &&
                        this._viewportHeight > this.child.offsetHeight + i.toFloat(a.marginTop) + i.toFloat(a.marginBottom) &&
                        (this._fix(), this._adjust());
                }
            },
            _adjust: function () {
                var a = 0,
                    b = this._mindtop(),
                    c = 0,
                    d = i.getAll(this.child),
                    e = null;
                k && ((e = this._getContext()), e && (a = Math.abs(e.getBoundingClientRect().top))),
                    (c = this._parentBottom - this._scrollTop - (this.child.offsetHeight + i.toFloat(d.marginBottom) + b + this.options.top)),
                    c > 0 && (c = 0),
                    (this.child.style.top = c + b + a + this.options.top - i.toFloat(d.marginTop) + "px");
            },
            _fullOffset: function (a, b, c) {
                for (var d = b[a], e = b.offsetParent; null !== e && e !== c; ) (d += e[a]), (e = e.offsetParent);
                return d;
            },
            _getContext: function () {
                for (var a, b, d = this.child, e = null; !e; ) {
                    if (((a = d.parentNode), a === c.documentElement)) return null;
                    if (((b = i.getAll(a)), "none" !== b[n])) {
                        e = a;
                        break;
                    }
                    d = a;
                }
                return e;
            },
            _fix: function () {
                var a = this.child,
                    b = a.style,
                    d = i.getAll(a),
                    e = a.getBoundingClientRect().left,
                    f = d.width;
                if ((this._saveStyles(), c.documentElement.currentStyle && (f = a.offsetWidth - (i.toFloat(d.paddingLeft) + i.toFloat(d.paddingRight) + i.toFloat(d.borderLeftWidth) + i.toFloat(d.borderRightWidth)) + "px"), k)) {
                    var g = this._getContext();
                    g && (e = a.getBoundingClientRect().left - g.getBoundingClientRect().left);
                }
                this._replacer.replace(),
                    (b.left = e - i.toFloat(d.marginLeft) + "px"),
                    (b.width = f),
                    (b.position = "fixed"),
                    (b.top = this._mindtop() + this.options.top - i.toFloat(d.marginTop) + "px"),
                    this._$child.addClass(this.options.className),
                    (this.fixed = !0);
            },
            _unfix: function () {
                var a = this.child.style;
                this._replacer.hide(),
                    (a.position = this._childOriginalPosition),
                    (a.top = this._childOriginalTop),
                    (a.width = this._childOriginalWidth),
                    (a.left = this._childOriginalLeft),
                    this._$child.removeClass(this.options.className),
                    (this.fixed = !1);
            },
            _saveStyles: function () {
                var a = this.child.style;
                (this._childOriginalPosition = a.position), (this._childOriginalTop = a.top), (this._childOriginalWidth = a.width), (this._childOriginalLeft = a.left);
            },
            _onresize: function () {
                this.refresh();
            },
            _saveViewportHeight: function () {
                this._viewportHeight = b.innerHeight || c.documentElement.clientHeight;
            },
            _stop: function () {
                this._unfix(), a(b).unbind("scroll", this._proxied_onscroll), a(this._toresize).unbind("resize", this._proxied_onresize);
            },
            _start: function () {
                this._onscroll(), a(b).bind("scroll", this._proxied_onscroll), a(this._toresize).bind("resize", this._proxied_onresize);
            },
            _destroy: function () {
                this._replacer.destroy();
            },
            refresh: function () {
                this._saveViewportHeight(), this._unfix(), this._onscroll();
            },
        }),
        (h.prototype = new f()),
        a.extend(h.prototype, {
            _start: function () {
                var a = i.getAll(this.child);
                (this._childOriginalPosition = a.position), (this._childOriginalTop = a.top), (this.child.style.position = o), this.refresh();
            },
            _stop: function () {
                (this.child.style.position = this._childOriginalPosition), (this.child.style.top = this._childOriginalTop);
            },
            refresh: function () {
                this.child.style.top = this._mindtop() + this.options.top + "px";
            },
        });
    var r = function (a, b, c) {
        return (o && !c) || (o && c && c.useNativeSticky !== !1) ? new h(a, b, c) : p ? (void 0 === k && (k = e()), new g(a, b, c)) : "Neither fixed nor sticky positioning supported";
    };
    return (
        l < 8 &&
            (r = function () {
                return "not supported";
            }),
        (a.fn.fixTo = function (b, c) {
            var d = a(b),
                e = 0;
            return this.each(function () {
                var f = a(this).data("fixto-instance");
                if (f) {
                    var g = b;
                    f[g].call(f, c);
                } else a(this).data("fixto-instance", r(this, d[e], c));
                e++;
            });
        }),
        { FixToContainer: g, fixTo: r, computedStyle: i, mimicNode: j }
    );
})(window.jQuery, window, document);
if (
    ((function (a, b) {
        "function" == typeof define && define.amd ? define(b) : "object" == typeof exports ? (module.exports = b()) : (a.ScrollMagic = b());
    })(this, function () {
        "use strict";
        var a = function () {
            e.log(2, "(COMPATIBILITY NOTICE) -> As of ScrollMagic 2.0.0 you need to use 'new ScrollMagic.Controller()' to create a new controller instance. Use 'new ScrollMagic.Scene()' to instance a scene.");
        };
        (a.version = "2.0.5"), window.addEventListener("mousewheel", function () {});
        var b = "data-scrollmagic-pin-spacer";
        a.Controller = function (d) {
            var f,
                g,
                h = "ScrollMagic.Controller",
                i = "FORWARD",
                j = "REVERSE",
                k = "PAUSED",
                l = c.defaults,
                m = this,
                n = e.extend({}, l, d),
                o = [],
                p = !1,
                q = 0,
                r = k,
                s = !0,
                t = 0,
                u = !0,
                v = function () {
                    for (var b in n) l.hasOwnProperty(b) || (E(2, 'WARNING: Unknown option "' + b + '"'), delete n[b]);
                    if (((n.container = e.get.elements(n.container)[0]), !n.container)) throw (E(1, "ERROR creating object " + h + ": No valid scroll container supplied"), h + " init failed.");
                    (s = n.container === window || n.container === document.body || !document.body.contains(n.container)),
                        s && (n.container = window),
                        (t = y()),
                        n.container.addEventListener("resize", C),
                        n.container.addEventListener("scroll", C),
                        (n.refreshInterval = parseInt(n.refreshInterval) || l.refreshInterval),
                        w(),
                        E(3, "added new " + h + " controller (v" + a.version + ")");
                },
                w = function () {
                    n.refreshInterval > 0 && (g = window.setTimeout(D, n.refreshInterval));
                },
                x = function () {
                    return n.vertical ? e.get.scrollTop(n.container) : e.get.scrollLeft(n.container);
                },
                y = function () {
                    return n.vertical ? e.get.height(n.container) : e.get.width(n.container);
                },
                z = (this._setScrollPos = function (a) {
                    n.vertical ? (s ? window.scrollTo(e.get.scrollLeft(), a) : (n.container.scrollTop = a)) : s ? window.scrollTo(a, e.get.scrollTop()) : (n.container.scrollLeft = a);
                }),
                A = function () {
                    if (u && p) {
                        var a = e.type.Array(p) ? p : o.slice(0);
                        p = !1;
                        var b = q;
                        q = m.scrollPos();
                        var c = q - b;
                        0 !== c && (r = c > 0 ? i : j),
                            r === j && a.reverse(),
                            a.forEach(function (b, c) {
                                E(3, "updating Scene " + (c + 1) + "/" + a.length + " (" + o.length + " total)"), b.update(!0);
                            }),
                            0 === a.length && n.loglevel >= 3 && E(3, "updating 0 Scenes (nothing added to controller)");
                    }
                },
                B = function () {
                    f = e.rAF(A);
                },
                C = function (a) {
                    E(3, "event fired causing an update:", a.type), "resize" == a.type && ((t = y()), (r = k)), p !== !0 && ((p = !0), B());
                },
                D = function () {
                    if (!s && t != y()) {
                        var a;
                        try {
                            a = new Event("resize", { bubbles: !1, cancelable: !1 });
                        } catch (b) {
                            (a = document.createEvent("Event")), a.initEvent("resize", !1, !1);
                        }
                        n.container.dispatchEvent(a);
                    }
                    o.forEach(function (a, b) {
                        a.refresh();
                    }),
                        w();
                },
                E = (this._log = function (a, b) {
                    n.loglevel >= a && (Array.prototype.splice.call(arguments, 1, 0, "(" + h + ") ->"), e.log.apply(window, arguments));
                });
            this._options = n;
            var F = function (a) {
                if (a.length <= 1) return a;
                var b = a.slice(0);
                return (
                    b.sort(function (a, b) {
                        return a.scrollOffset() > b.scrollOffset() ? 1 : -1;
                    }),
                    b
                );
            };
            return (
                (this.addScene = function (b) {
                    if (e.type.Array(b))
                        b.forEach(function (a, b) {
                            m.addScene(a);
                        });
                    else if (b instanceof a.Scene) {
                        if (b.controller() !== m) b.addTo(m);
                        else if (o.indexOf(b) < 0) {
                            o.push(b),
                                (o = F(o)),
                                b.on("shift.controller_sort", function () {
                                    o = F(o);
                                });
                            for (var c in n.globalSceneOptions) b[c] && b[c].call(b, n.globalSceneOptions[c]);
                            E(3, "adding Scene (now " + o.length + " total)");
                        }
                    } else E(1, "ERROR: invalid argument supplied for '.addScene()'");
                    return m;
                }),
                (this.removeScene = function (a) {
                    if (e.type.Array(a))
                        a.forEach(function (a, b) {
                            m.removeScene(a);
                        });
                    else {
                        var b = o.indexOf(a);
                        b > -1 && (a.off("shift.controller_sort"), o.splice(b, 1), E(3, "removing Scene (now " + o.length + " left)"), a.remove());
                    }
                    return m;
                }),
                (this.updateScene = function (b, c) {
                    return (
                        e.type.Array(b)
                            ? b.forEach(function (a, b) {
                                  m.updateScene(a, c);
                              })
                            : c
                            ? b.update(!0)
                            : p !== !0 && b instanceof a.Scene && ((p = p || []), p.indexOf(b) == -1 && p.push(b), (p = F(p)), B()),
                        m
                    );
                }),
                (this.update = function (a) {
                    return C({ type: "resize" }), a && A(), m;
                }),
                (this.scrollTo = function (c, d) {
                    if (e.type.Number(c)) z.call(n.container, c, d);
                    else if (c instanceof a.Scene) c.controller() === m ? m.scrollTo(c.scrollOffset(), d) : E(2, "scrollTo(): The supplied scene does not belong to this controller. Scroll cancelled.", c);
                    else if (e.type.Function(c)) z = c;
                    else {
                        var f = e.get.elements(c)[0];
                        if (f) {
                            for (; f.parentNode.hasAttribute(b); ) f = f.parentNode;
                            var g = n.vertical ? "top" : "left",
                                h = e.get.offset(n.container),
                                i = e.get.offset(f);
                            s || (h[g] -= m.scrollPos()), m.scrollTo(i[g] - h[g], d);
                        } else E(2, "scrollTo(): The supplied argument is invalid. Scroll cancelled.", c);
                    }
                    return m;
                }),
                (this.scrollPos = function (a) {
                    return arguments.length ? (e.type.Function(a) ? (x = a) : E(2, "Provided value for method 'scrollPos' is not a function. To change the current scroll position use 'scrollTo()'."), m) : x.call(m);
                }),
                (this.info = function (a) {
                    var b = { size: t, vertical: n.vertical, scrollPos: q, scrollDirection: r, container: n.container, isDocument: s };
                    return arguments.length ? (void 0 !== b[a] ? b[a] : void E(1, 'ERROR: option "' + a + '" is not available')) : b;
                }),
                (this.loglevel = function (a) {
                    return arguments.length ? (n.loglevel != a && (n.loglevel = a), m) : n.loglevel;
                }),
                (this.enabled = function (a) {
                    return arguments.length ? (u != a && ((u = !!a), m.updateScene(o, !0)), m) : u;
                }),
                (this.destroy = function (a) {
                    window.clearTimeout(g);
                    for (var b = o.length; b--; ) o[b].destroy(a);
                    return n.container.removeEventListener("resize", C), n.container.removeEventListener("scroll", C), e.cAF(f), E(3, "destroyed " + h + " (reset: " + (a ? "true" : "false") + ")"), null;
                }),
                v(),
                m
            );
        };
        var c = { defaults: { container: window, vertical: !0, globalSceneOptions: {}, loglevel: 2, refreshInterval: 100 } };
        (a.Controller.addOption = function (a, b) {
            c.defaults[a] = b;
        }),
            (a.Controller.extend = function (b) {
                var c = this;
                (a.Controller = function () {
                    return c.apply(this, arguments), (this.$super = e.extend({}, this)), b.apply(this, arguments) || this;
                }),
                    e.extend(a.Controller, c),
                    (a.Controller.prototype = c.prototype),
                    (a.Controller.prototype.constructor = a.Controller);
            }),
            (a.Scene = function (c) {
                var f,
                    g,
                    h = "ScrollMagic.Scene",
                    i = "BEFORE",
                    j = "DURING",
                    k = "AFTER",
                    l = d.defaults,
                    m = this,
                    n = e.extend({}, l, c),
                    o = i,
                    p = 0,
                    q = { start: 0, end: 0 },
                    r = 0,
                    s = !0,
                    t = function () {
                        for (var a in n) l.hasOwnProperty(a) || (v(2, 'WARNING: Unknown option "' + a + '"'), delete n[a]);
                        for (var b in l) D(b);
                        B();
                    },
                    u = {};
                (this.on = function (a, b) {
                    return (
                        e.type.Function(b)
                            ? ((a = a.trim().split(" ")),
                              a.forEach(function (a) {
                                  var c = a.split("."),
                                      d = c[0],
                                      e = c[1];
                                  "*" != d && (u[d] || (u[d] = []), u[d].push({ namespace: e || "", callback: b }));
                              }))
                            : v(1, "ERROR when calling '.on()': Supplied callback for '" + a + "' is not a valid function!"),
                        m
                    );
                }),
                    (this.off = function (a, b) {
                        return a
                            ? ((a = a.trim().split(" ")),
                              a.forEach(function (a, c) {
                                  var d = a.split("."),
                                      e = d[0],
                                      f = d[1] || "",
                                      g = "*" === e ? Object.keys(u) : [e];
                                  g.forEach(function (a) {
                                      for (var c = u[a] || [], d = c.length; d--; ) {
                                          var e = c[d];
                                          !e || (f !== e.namespace && "*" !== f) || (b && b != e.callback) || c.splice(d, 1);
                                      }
                                      c.length || delete u[a];
                                  });
                              }),
                              m)
                            : (v(1, "ERROR: Invalid event name supplied."), m);
                    }),
                    (this.trigger = function (b, c) {
                        if (b) {
                            var d = b.trim().split("."),
                                e = d[0],
                                f = d[1],
                                g = u[e];
                            v(3, "event fired:", e, c ? "->" : "", c || ""),
                                g &&
                                    g.forEach(function (b, d) {
                                        (f && f !== b.namespace) || b.callback.call(m, new a.Event(e, b.namespace, m, c));
                                    });
                        } else v(1, "ERROR: Invalid event name supplied.");
                        return m;
                    }),
                    m
                        .on("change.internal", function (a) {
                            "loglevel" !== a.what && "tweenChanges" !== a.what && ("triggerElement" === a.what ? y() : "reverse" === a.what && m.update());
                        })
                        .on("shift.internal", function (a) {
                            w(), m.update();
                        });
                var v = (this._log = function (a, b) {
                    n.loglevel >= a && (Array.prototype.splice.call(arguments, 1, 0, "(" + h + ") ->"), e.log.apply(window, arguments));
                });
                (this.addTo = function (b) {
                    return (
                        b instanceof a.Controller
                            ? g != b &&
                              (g && g.removeScene(m), (g = b), B(), x(!0), y(!0), w(), g.info("container").addEventListener("resize", z), b.addScene(m), m.trigger("add", { controller: g }), v(3, "added " + h + " to controller"), m.update())
                            : v(1, "ERROR: supplied argument of 'addTo()' is not a valid ScrollMagic Controller"),
                        m
                    );
                }),
                    (this.enabled = function (a) {
                        return arguments.length ? (s != a && ((s = !!a), m.update(!0)), m) : s;
                    }),
                    (this.remove = function () {
                        if (g) {
                            g.info("container").removeEventListener("resize", z);
                            var a = g;
                            (g = void 0), a.removeScene(m), m.trigger("remove"), v(3, "removed " + h + " from controller");
                        }
                        return m;
                    }),
                    (this.destroy = function (a) {
                        return m.trigger("destroy", { reset: a }), m.remove(), m.off("*.*"), v(3, "destroyed " + h + " (reset: " + (a ? "true" : "false") + ")"), null;
                    }),
                    (this.update = function (a) {
                        if (g)
                            if (a)
                                if (g.enabled() && s) {
                                    var b,
                                        c = g.info("scrollPos");
                                    (b = n.duration > 0 ? (c - q.start) / (q.end - q.start) : c >= q.start ? 1 : 0), m.trigger("update", { startPos: q.start, endPos: q.end, scrollPos: c }), m.progress(b);
                                } else E && o === j && G(!0);
                            else g.updateScene(m, !1);
                        return m;
                    }),
                    (this.refresh = function () {
                        return x(), y(), m;
                    }),
                    (this.progress = function (a) {
                        if (arguments.length) {
                            var b = !1,
                                c = o,
                                d = g ? g.info("scrollDirection") : "PAUSED",
                                e = n.reverse || a >= p;
                            if (
                                (0 === n.duration
                                    ? ((b = p != a), (p = a < 1 && e ? 0 : 1), (o = 0 === p ? i : j))
                                    : a < 0 && o !== i && e
                                    ? ((p = 0), (o = i), (b = !0))
                                    : a >= 0 && a < 1 && e
                                    ? ((p = a), (o = j), (b = !0))
                                    : a >= 1 && o !== k
                                    ? ((p = 1), (o = k), (b = !0))
                                    : o !== j || e || G(),
                                b)
                            ) {
                                var f = { progress: p, state: o, scrollDirection: d },
                                    h = o != c,
                                    l = function (a) {
                                        m.trigger(a, f);
                                    };
                                h && c !== j && (l("enter"), l(c === i ? "start" : "end")), l("progress"), h && o !== j && (l(o === i ? "start" : "end"), l("leave"));
                            }
                            return m;
                        }
                        return p;
                    });
                var w = function () {
                        (q = { start: r + n.offset }), g && n.triggerElement && (q.start -= g.info("size") * n.triggerHook), (q.end = q.start + n.duration);
                    },
                    x = function (a) {
                        if (f) {
                            var b = "duration";
                            C(b, f.call(m)) && !a && (m.trigger("change", { what: b, newval: n[b] }), m.trigger("shift", { reason: b }));
                        }
                    },
                    y = function (a) {
                        var c = 0,
                            d = n.triggerElement;
                        if (g && d) {
                            for (var f = g.info(), h = e.get.offset(f.container), i = f.vertical ? "top" : "left"; d.parentNode.hasAttribute(b); ) d = d.parentNode;
                            var j = e.get.offset(d);
                            f.isDocument || (h[i] -= g.scrollPos()), (c = j[i] - h[i]);
                        }
                        var k = c != r;
                        (r = c), k && !a && m.trigger("shift", { reason: "triggerElementPosition" });
                    },
                    z = function (a) {
                        n.triggerHook > 0 && m.trigger("shift", { reason: "containerResize" });
                    },
                    A = e.extend(d.validate, {
                        duration: function (a) {
                            if (e.type.String(a) && a.match(/^(\.|\d)*\d+%$/)) {
                                var b = parseFloat(a) / 100;
                                a = function () {
                                    return g ? g.info("size") * b : 0;
                                };
                            }
                            if (e.type.Function(a)) {
                                f = a;
                                try {
                                    a = parseFloat(f());
                                } catch (c) {
                                    a = -1;
                                }
                            }
                            if (((a = parseFloat(a)), !e.type.Number(a) || a < 0)) throw f ? ((f = void 0), ['Invalid return value of supplied function for option "duration":', a]) : ['Invalid value for option "duration":', a];
                            return a;
                        },
                    }),
                    B = function (a) {
                        (a = arguments.length ? [a] : Object.keys(A)),
                            a.forEach(function (a, b) {
                                var c;
                                if (A[a])
                                    try {
                                        c = A[a](n[a]);
                                    } catch (d) {
                                        c = l[a];
                                        var f = e.type.String(d) ? [d] : d;
                                        e.type.Array(f) ? ((f[0] = "ERROR: " + f[0]), f.unshift(1), v.apply(this, f)) : v(1, "ERROR: Problem executing validation callback for option '" + a + "':", d.message);
                                    } finally {
                                        n[a] = c;
                                    }
                            });
                    },
                    C = function (a, b) {
                        var c = !1,
                            d = n[a];
                        return n[a] != b && ((n[a] = b), B(a), (c = d != n[a])), c;
                    },
                    D = function (a) {
                        m[a] ||
                            (m[a] = function (b) {
                                return arguments.length ? ("duration" === a && (f = void 0), C(a, b) && (m.trigger("change", { what: a, newval: n[a] }), d.shifts.indexOf(a) > -1 && m.trigger("shift", { reason: a })), m) : n[a];
                            });
                    };
                (this.controller = function () {
                    return g;
                }),
                    (this.state = function () {
                        return o;
                    }),
                    (this.scrollOffset = function () {
                        return q.start;
                    }),
                    (this.triggerPosition = function () {
                        var a = n.offset;
                        return g && (a += n.triggerElement ? r : g.info("size") * m.triggerHook()), a;
                    });
                var E, F;
                m.on("shift.internal", function (a) {
                    var b = "duration" === a.reason;
                    ((o === k && b) || (o === j && 0 === n.duration)) && G(), b && H();
                })
                    .on("progress.internal", function (a) {
                        G();
                    })
                    .on("add.internal", function (a) {
                        H();
                    })
                    .on("destroy.internal", function (a) {
                        m.removePin(a.reset);
                    });
                var G = function (a) {
                        if (E && g) {
                            var b = g.info(),
                                c = F.spacer.firstChild;
                            if (a || o !== j) {
                                var d = { position: F.inFlow ? "relative" : "absolute", top: 0, left: 0 },
                                    f = e.css(c, "position") != d.position;
                                F.pushFollowers
                                    ? n.duration > 0 && (o === k && 0 === parseFloat(e.css(F.spacer, "padding-top")) ? (f = !0) : o === i && 0 === parseFloat(e.css(F.spacer, "padding-bottom")) && (f = !0))
                                    : (d[b.vertical ? "top" : "left"] = n.duration * p),
                                    e.css(c, d),
                                    f && H();
                            } else {
                                "fixed" != e.css(c, "position") && (e.css(c, { position: "fixed" }), H());
                                var h = e.get.offset(F.spacer, !0),
                                    l = n.reverse || 0 === n.duration ? b.scrollPos - q.start : Math.round(p * n.duration * 10) / 10;
                                (h[b.vertical ? "top" : "left"] += l), e.css(F.spacer.firstChild, { top: h.top, left: h.left });
                            }
                        }
                    },
                    H = function () {
                        if (E && g && F.inFlow) {
                            var a = o === j,
                                b = g.info("vertical"),
                                c = F.spacer.firstChild,
                                d = e.isMarginCollapseType(e.css(F.spacer, "display")),
                                f = {};
                            F.relSize.width || F.relSize.autoFullWidth
                                ? a
                                    ? e.css(E, { width: e.get.width(F.spacer) })
                                    : e.css(E, { width: "100%" })
                                : ((f["min-width"] = e.get.width(b ? E : c, !0, !0)), (f.width = a ? f["min-width"] : "auto")),
                                F.relSize.height
                                    ? a
                                        ? e.css(E, { height: e.get.height(F.spacer) - (F.pushFollowers ? n.duration : 0) })
                                        : e.css(E, { height: "100%" })
                                    : ((f["min-height"] = e.get.height(b ? c : E, !0, !d)), (f.height = a ? f["min-height"] : "auto")),
                                F.pushFollowers && ((f["padding" + (b ? "Top" : "Left")] = n.duration * p), (f["padding" + (b ? "Bottom" : "Right")] = n.duration * (1 - p))),
                                e.css(F.spacer, f);
                        }
                    },
                    I = function () {
                        g && E && o === j && !g.info("isDocument") && G();
                    },
                    J = function () {
                        g &&
                            E &&
                            o === j &&
                            (((F.relSize.width || F.relSize.autoFullWidth) && e.get.width(window) != e.get.width(F.spacer.parentNode)) || (F.relSize.height && e.get.height(window) != e.get.height(F.spacer.parentNode))) &&
                            H();
                    },
                    K = function (a) {
                        g && E && o === j && !g.info("isDocument") && (a.preventDefault(), g._setScrollPos(g.info("scrollPos") - ((a.wheelDelta || a[g.info("vertical") ? "wheelDeltaY" : "wheelDeltaX"]) / 3 || 30 * -a.detail)));
                    };
                (this.setPin = function (a, c) {
                    var d = { pushFollowers: !0, spacerClass: "scrollmagic-pin-spacer" };
                    if (((c = e.extend({}, d, c)), (a = e.get.elements(a)[0]), !a)) return v(1, "ERROR calling method 'setPin()': Invalid pin element supplied."), m;
                    if ("fixed" === e.css(a, "position")) return v(1, "ERROR calling method 'setPin()': Pin does not work with elements that are positioned 'fixed'."), m;
                    if (E) {
                        if (E === a) return m;
                        m.removePin();
                    }
                    E = a;
                    var f = E.parentNode.style.display,
                        g = ["top", "left", "bottom", "right", "margin", "marginLeft", "marginRight", "marginTop", "marginBottom"];
                    E.parentNode.style.display = "none";
                    var h = "absolute" != e.css(E, "position"),
                        i = e.css(E, g.concat(["display"])),
                        j = e.css(E, ["width", "height"]);
                    (E.parentNode.style.display = f),
                        !h && c.pushFollowers && (v(2, "WARNING: If the pinned element is positioned absolutely pushFollowers will be disabled."), (c.pushFollowers = !1)),
                        window.setTimeout(function () {
                            E && 0 === n.duration && c.pushFollowers && v(2, "WARNING: pushFollowers =", !0, "has no effect, when scene duration is 0.");
                        }, 0);
                    var k = E.parentNode.insertBefore(document.createElement("div"), E),
                        l = e.extend(i, { position: h ? "relative" : "absolute", boxSizing: "content-box", mozBoxSizing: "content-box", webkitBoxSizing: "content-box" });
                    if (
                        (h || e.extend(l, e.css(E, ["width", "height"])),
                        e.css(k, l),
                        k.setAttribute(b, ""),
                        e.addClass(k, c.spacerClass),
                        (F = {
                            spacer: k,
                            relSize: { width: "%" === j.width.slice(-1), height: "%" === j.height.slice(-1), autoFullWidth: "auto" === j.width && h && e.isMarginCollapseType(i.display) },
                            pushFollowers: c.pushFollowers,
                            inFlow: h,
                        }),
                        !E.___origStyle)
                    ) {
                        E.___origStyle = {};
                        var o = E.style,
                            p = g.concat(["width", "height", "position", "boxSizing", "mozBoxSizing", "webkitBoxSizing"]);
                        p.forEach(function (a) {
                            E.___origStyle[a] = o[a] || "";
                        });
                    }
                    return (
                        F.relSize.width && e.css(k, { width: j.width }),
                        F.relSize.height && e.css(k, { height: j.height }),
                        k.appendChild(E),
                        e.css(E, { position: h ? "relative" : "absolute", margin: "auto", top: "auto", left: "auto", bottom: "auto", right: "auto" }),
                        (F.relSize.width || F.relSize.autoFullWidth) && e.css(E, { boxSizing: "border-box", mozBoxSizing: "border-box", webkitBoxSizing: "border-box" }),
                        window.addEventListener("scroll", I),
                        window.addEventListener("resize", I),
                        window.addEventListener("resize", J),
                        E.addEventListener("mousewheel", K),
                        E.addEventListener("DOMMouseScroll", K),
                        v(3, "added pin"),
                        G(),
                        m
                    );
                }),
                    (this.removePin = function (a) {
                        if (E) {
                            if ((o === j && G(!0), a || !g)) {
                                var c = F.spacer.firstChild;
                                if (c.hasAttribute(b)) {
                                    var d = F.spacer.style,
                                        f = ["margin", "marginLeft", "marginRight", "marginTop", "marginBottom"];
                                    (margins = {}),
                                        f.forEach(function (a) {
                                            margins[a] = d[a] || "";
                                        }),
                                        e.css(c, margins);
                                }
                                F.spacer.parentNode.insertBefore(c, F.spacer), F.spacer.parentNode.removeChild(F.spacer), E.parentNode.hasAttribute(b) || (e.css(E, E.___origStyle), delete E.___origStyle);
                            }
                            window.removeEventListener("scroll", I),
                                window.removeEventListener("resize", I),
                                window.removeEventListener("resize", J),
                                E.removeEventListener("mousewheel", K),
                                E.removeEventListener("DOMMouseScroll", K),
                                (E = void 0),
                                v(3, "removed pin (reset: " + (a ? "true" : "false") + ")");
                        }
                        return m;
                    });
                var L,
                    M = [];
                return (
                    m.on("destroy.internal", function (a) {
                        m.removeClassToggle(a.reset);
                    }),
                    (this.setClassToggle = function (a, b) {
                        var c = e.get.elements(a);
                        return 0 !== c.length && e.type.String(b)
                            ? (M.length > 0 && m.removeClassToggle(),
                              (L = b),
                              (M = c),
                              m.on("enter.internal_class leave.internal_class", function (a) {
                                  var b = "enter" === a.type ? e.addClass : e.removeClass;
                                  M.forEach(function (a, c) {
                                      b(a, L);
                                  });
                              }),
                              m)
                            : (v(1, "ERROR calling method 'setClassToggle()': Invalid " + (0 === c.length ? "element" : "classes") + " supplied."), m);
                    }),
                    (this.removeClassToggle = function (a) {
                        return (
                            a &&
                                M.forEach(function (a, b) {
                                    e.removeClass(a, L);
                                }),
                            m.off("start.internal_class end.internal_class"),
                            (L = void 0),
                            (M = []),
                            m
                        );
                    }),
                    t(),
                    m
                );
            });
        var d = {
            defaults: { duration: 0, offset: 0, triggerElement: void 0, triggerHook: 0.5, reverse: !0, loglevel: 2 },
            validate: {
                offset: function (a) {
                    if (((a = parseFloat(a)), !e.type.Number(a))) throw ['Invalid value for option "offset":', a];
                    return a;
                },
                triggerElement: function (a) {
                    if ((a = a || void 0)) {
                        var b = e.get.elements(a)[0];
                        if (!b) throw ['Element defined in option "triggerElement" was not found:', a];
                        a = b;
                    }
                    return a;
                },
                triggerHook: function (a) {
                    var b = { onCenter: 0.5, onEnter: 1, onLeave: 0 };
                    if (e.type.Number(a)) a = Math.max(0, Math.min(parseFloat(a), 1));
                    else {
                        if (!(a in b)) throw ['Invalid value for option "triggerHook": ', a];
                        a = b[a];
                    }
                    return a;
                },
                reverse: function (a) {
                    return !!a;
                },
                loglevel: function (a) {
                    if (((a = parseInt(a)), !e.type.Number(a) || a < 0 || a > 3)) throw ['Invalid value for option "loglevel":', a];
                    return a;
                },
            },
            shifts: ["duration", "offset", "triggerHook"],
        };
        (a.Scene.addOption = function (b, c, e, f) {
            b in d.defaults ? a._util.log(1, "[static] ScrollMagic.Scene -> Cannot add Scene option '" + b + "', because it already exists.") : ((d.defaults[b] = c), (d.validate[b] = e), f && d.shifts.push(b));
        }),
            (a.Scene.extend = function (b) {
                var c = this;
                (a.Scene = function () {
                    return c.apply(this, arguments), (this.$super = e.extend({}, this)), b.apply(this, arguments) || this;
                }),
                    e.extend(a.Scene, c),
                    (a.Scene.prototype = c.prototype),
                    (a.Scene.prototype.constructor = a.Scene);
            }),
            (a.Event = function (a, b, c, d) {
                d = d || {};
                for (var e in d) this[e] = d[e];
                return (this.type = a), (this.target = this.currentTarget = c), (this.namespace = b || ""), (this.timeStamp = this.timestamp = Date.now()), this;
            });
        var e = (a._util = (function (a) {
            var b,
                c = {},
                d = function (a) {
                    return parseFloat(a) || 0;
                },
                e = function (b) {
                    return b.currentStyle ? b.currentStyle : a.getComputedStyle(b);
                },
                f = function (b, c, f, g) {
                    if (((c = c === document ? a : c), c === a)) g = !1;
                    else if (!o.DomElement(c)) return 0;
                    b = b.charAt(0).toUpperCase() + b.substr(1).toLowerCase();
                    var h = (f ? c["offset" + b] || c["outer" + b] : c["client" + b] || c["inner" + b]) || 0;
                    if (f && g) {
                        var i = e(c);
                        h += "Height" === b ? d(i.marginTop) + d(i.marginBottom) : d(i.marginLeft) + d(i.marginRight);
                    }
                    return h;
                },
                g = function (a) {
                    return a.replace(/^[^a-z]+([a-z])/g, "$1").replace(/-([a-z])/g, function (a) {
                        return a[1].toUpperCase();
                    });
                };
            (c.extend = function (a) {
                for (a = a || {}, b = 1; b < arguments.length; b++) if (arguments[b]) for (var c in arguments[b]) arguments[b].hasOwnProperty(c) && (a[c] = arguments[b][c]);
                return a;
            }),
                (c.isMarginCollapseType = function (a) {
                    return ["block", "flex", "list-item", "table", "-webkit-box"].indexOf(a) > -1;
                });
            var h = 0,
                i = ["ms", "moz", "webkit", "o"],
                j = a.requestAnimationFrame,
                k = a.cancelAnimationFrame;
            for (b = 0; !j && b < i.length; ++b) (j = a[i[b] + "RequestAnimationFrame"]), (k = a[i[b] + "CancelAnimationFrame"] || a[i[b] + "CancelRequestAnimationFrame"]);
            j ||
                (j = function (b) {
                    var c = new Date().getTime(),
                        d = Math.max(0, 16 - (c - h)),
                        e = a.setTimeout(function () {
                            b(c + d);
                        }, d);
                    return (h = c + d), e;
                }),
                k ||
                    (k = function (b) {
                        a.clearTimeout(b);
                    }),
                (c.rAF = j.bind(a)),
                (c.cAF = k.bind(a));
            var l = ["error", "warn", "log"],
                m = a.console || {};
            for (m.log = m.log || function () {}, b = 0; b < l.length; b++) {
                var n = l[b];
                m[n] || (m[n] = m.log);
            }
            c.log = function (a) {
                (a > l.length || a <= 0) && (a = l.length);
                var b = new Date(),
                    c = ("0" + b.getHours()).slice(-2) + ":" + ("0" + b.getMinutes()).slice(-2) + ":" + ("0" + b.getSeconds()).slice(-2) + ":" + ("00" + b.getMilliseconds()).slice(-3),
                    d = l[a - 1],
                    e = Array.prototype.splice.call(arguments, 1),
                    f = Function.prototype.bind.call(m[d], m);
                e.unshift(c), f.apply(m, e);
            };
            var o = (c.type = function (a) {
                return Object.prototype.toString
                    .call(a)
                    .replace(/^\[object (.+)\]$/, "$1")
                    .toLowerCase();
            });
            (o.String = function (a) {
                return "string" === o(a);
            }),
                (o.Function = function (a) {
                    return "function" === o(a);
                }),
                (o.Array = function (a) {
                    return Array.isArray(a);
                }),
                (o.Number = function (a) {
                    return !o.Array(a) && a - parseFloat(a) + 1 >= 0;
                }),
                (o.DomElement = function (a) {
                    return "object" == typeof HTMLElement ? a instanceof HTMLElement : a && "object" == typeof a && null !== a && 1 === a.nodeType && "string" == typeof a.nodeName;
                });
            var p = (c.get = {});
            return (
                (p.elements = function (b) {
                    var c = [];
                    if (o.String(b))
                        try {
                            b = document.querySelectorAll(b);
                        } catch (d) {
                            return c;
                        }
                    if ("nodelist" === o(b) || o.Array(b))
                        for (var e = 0, f = (c.length = b.length); e < f; e++) {
                            var g = b[e];
                            c[e] = o.DomElement(g) ? g : p.elements(g);
                        }
                    else (o.DomElement(b) || b === document || b === a) && (c = [b]);
                    return c;
                }),
                (p.scrollTop = function (b) {
                    return b && "number" == typeof b.scrollTop ? b.scrollTop : a.pageYOffset || 0;
                }),
                (p.scrollLeft = function (b) {
                    return b && "number" == typeof b.scrollLeft ? b.scrollLeft : a.pageXOffset || 0;
                }),
                (p.width = function (a, b, c) {
                    return f("width", a, b, c);
                }),
                (p.height = function (a, b, c) {
                    return f("height", a, b, c);
                }),
                (p.offset = function (a, b) {
                    var c = { top: 0, left: 0 };
                    if (a && a.getBoundingClientRect) {
                        var d = a.getBoundingClientRect();
                        (c.top = d.top), (c.left = d.left), b || ((c.top += p.scrollTop()), (c.left += p.scrollLeft()));
                    }
                    return c;
                }),
                (c.addClass = function (a, b) {
                    b && (a.classList ? a.classList.add(b) : (a.className += " " + b));
                }),
                (c.removeClass = function (a, b) {
                    b && (a.classList ? a.classList.remove(b) : (a.className = a.className.replace(new RegExp("(^|\\b)" + b.split(" ").join("|") + "(\\b|$)", "gi"), " ")));
                }),
                (c.css = function (a, b) {
                    if (o.String(b)) return e(a)[g(b)];
                    if (o.Array(b)) {
                        var c = {},
                            d = e(a);
                        return (
                            b.forEach(function (a, b) {
                                c[a] = d[g(a)];
                            }),
                            c
                        );
                    }
                    for (var f in b) {
                        var h = b[f];
                        h == parseFloat(h) && (h += "px"), (a.style[g(f)] = h);
                    }
                }),
                c
            );
        })(window || {}));
        return (
            (a.Scene.prototype.addIndicators = function () {
                return a._util.log(1, "(ScrollMagic.Scene) -> ERROR calling addIndicators() due to missing Plugin 'debug.addIndicators'. Please make sure to include plugins/debug.addIndicators.js"), this;
            }),
            (a.Scene.prototype.removeIndicators = function () {
                return a._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeIndicators() due to missing Plugin 'debug.addIndicators'. Please make sure to include plugins/debug.addIndicators.js"), this;
            }),
            (a.Scene.prototype.setTween = function () {
                return a._util.log(1, "(ScrollMagic.Scene) -> ERROR calling setTween() due to missing Plugin 'animation.gsap'. Please make sure to include plugins/animation.gsap.js"), this;
            }),
            (a.Scene.prototype.removeTween = function () {
                return a._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeTween() due to missing Plugin 'animation.gsap'. Please make sure to include plugins/animation.gsap.js"), this;
            }),
            (a.Scene.prototype.setVelocity = function () {
                return a._util.log(1, "(ScrollMagic.Scene) -> ERROR calling setVelocity() due to missing Plugin 'animation.velocity'. Please make sure to include plugins/animation.velocity.js"), this;
            }),
            (a.Scene.prototype.removeVelocity = function () {
                return a._util.log(1, "(ScrollMagic.Scene) -> ERROR calling removeVelocity() due to missing Plugin 'animation.velocity'. Please make sure to include plugins/animation.velocity.js"), this;
            }),
            a
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define(["ScrollMagic", "TweenMax", "TimelineMax"], b)
            : "object" == typeof exports
            ? (require("gsap"), b(require("scrollmagic"), TweenMax, TimelineMax))
            : b(a.ScrollMagic || (a.jQuery && a.jQuery.ScrollMagic), a.TweenMax || a.TweenLite, a.TimelineMax || a.TimelineLite);
    })(this, function (a, b, c) {
        "use strict";
        var d = "animation.gsap",
            e = window.console || {},
            f = Function.prototype.bind.call(e.error || e.log || function () {}, e);
        a || f("(" + d + ") -> ERROR: The ScrollMagic main module could not be found. Please make sure it's loaded before this plugin or use an asynchronous loader like requirejs."),
            b || f("(" + d + ") -> ERROR: TweenLite or TweenMax could not be found. Please make sure GSAP is loaded before ScrollMagic or use an asynchronous loader like requirejs."),
            a.Scene.addOption("tweenChanges", !1, function (a) {
                return !!a;
            }),
            a.Scene.extend(function () {
                var a,
                    e = this,
                    f = function () {
                        e._log && (Array.prototype.splice.call(arguments, 1, 0, "(" + d + ")", "->"), e._log.apply(this, arguments));
                    };
                e.on("progress.plugin_gsap", function () {
                    g();
                }),
                    e.on("destroy.plugin_gsap", function (a) {
                        e.removeTween(a.reset);
                    });
                var g = function () {
                    if (a) {
                        var b = e.progress(),
                            c = e.state();
                        a.repeat && a.repeat() === -1
                            ? "DURING" === c && a.paused()
                                ? a.play()
                                : "DURING" === c || a.paused() || a.pause()
                            : b != a.progress() && (0 === e.duration() ? (b > 0 ? a.play() : a.reverse()) : e.tweenChanges() && a.tweenTo ? a.tweenTo(b * a.duration()) : a.progress(b).pause());
                    }
                };
                (e.setTween = function (d, h, i) {
                    var j;
                    arguments.length > 1 && (arguments.length < 3 && ((i = h), (h = 1)), (d = b.to(d, h, i)));
                    try {
                        (j = c ? new c({ smoothChildTiming: !0 }).add(d) : d), j.pause();
                    } catch (k) {
                        return f(1, "ERROR calling method 'setTween()': Supplied argument is not a valid TweenObject"), e;
                    }
                    if (
                        (a && e.removeTween(),
                        (a = j),
                        d.repeat && d.repeat() === -1 && (a.repeat(-1), a.yoyo(d.yoyo())),
                        e.tweenChanges() && !a.tweenTo && f(2, "WARNING: tweenChanges will only work if the TimelineMax object is available for ScrollMagic."),
                        a && e.controller() && e.triggerElement() && e.loglevel() >= 2)
                    ) {
                        var l = b.getTweensOf(e.triggerElement()),
                            m = e.controller().info("vertical");
                        l.forEach(function (a, b) {
                            var c = a.vars.css || a.vars,
                                d = m ? void 0 !== c.top || void 0 !== c.bottom : void 0 !== c.left || void 0 !== c.right;
                            if (d) return f(2, "WARNING: Tweening the position of the trigger element affects the scene timing and should be avoided!"), !1;
                        });
                    }
                    if (parseFloat(TweenLite.version) >= 1.14)
                        for (
                            var n,
                                o,
                                p = a.getChildren ? a.getChildren(!0, !0, !1) : [a],
                                q = function () {
                                    f(2, "WARNING: tween was overwritten by another. To learn how to avoid this issue see here: https://github.com/janpaepke/ScrollMagic/wiki/WARNING:-tween-was-overwritten-by-another");
                                },
                                r = 0;
                            r < p.length;
                            r++
                        )
                            (n = p[r]),
                                o !== q &&
                                    ((o = n.vars.onOverwrite),
                                    (n.vars.onOverwrite = function () {
                                        o && o.apply(this, arguments), q.apply(this, arguments);
                                    }));
                    return f(3, "added tween"), g(), e;
                }),
                    (e.removeTween = function (b) {
                        return a && (b && a.progress(0).pause(), a.kill(), (a = void 0), f(3, "removed tween (reset: " + (b ? "true" : "false") + ")")), e;
                    });
            });
    }),
    (function (a, b) {
        "function" == typeof define && define.amd ? define(["ScrollMagic"], b) : b("object" == typeof exports ? require("scrollmagic") : a.ScrollMagic || (a.jQuery && a.jQuery.ScrollMagic));
    })(this, function (a) {
        "use strict";
        var b = "debug.addIndicators",
            c = window.console || {},
            d = Function.prototype.bind.call(c.error || c.log || function () {}, c);
        a || d("(" + b + ") -> ERROR: The ScrollMagic main module could not be found. Please make sure it's loaded before this plugin or use an asynchronous loader like requirejs.");
        var e = "0.85em",
            f = "9999",
            g = 15,
            h = a._util,
            i = 0;
        a.Scene.extend(function () {
            var a,
                b = this;
            (b.addIndicators = function (c) {
                if (!a) {
                    var d = { name: "", indent: 0, parent: void 0, colorStart: "green", colorEnd: "red", colorTrigger: "blue" };
                    (c = h.extend({}, d, c)),
                        i++,
                        (a = new j(b, c)),
                        b.on("add.plugin_addIndicators", a.add),
                        b.on("remove.plugin_addIndicators", a.remove),
                        b.on("destroy.plugin_addIndicators", b.removeIndicators),
                        b.controller() && a.add();
                }
                return b;
            }),
                (b.removeIndicators = function () {
                    return a && (a.remove(), this.off("*.plugin_addIndicators"), (a = void 0)), b;
                });
        }),
            a.Controller.addOption("addIndicators", !1),
            a.Controller.extend(function () {
                var c = this,
                    d = c.info(),
                    e = d.container,
                    f = d.isDocument,
                    i = d.vertical,
                    j = { groups: [] },
                    k = function () {
                        c._log && (Array.prototype.splice.call(arguments, 1, 0, "(" + b + ")", "->"), c._log.apply(this, arguments));
                    };
                c._indicators && k(2, "WARNING: Scene already has a property '_indicators', which will be overwritten by plugin."), (this._indicators = j);
                var l = function () {
                        j.updateBoundsPositions();
                    },
                    m = function () {
                        j.updateTriggerGroupPositions();
                    };
                return (
                    e.addEventListener("resize", m),
                    f || (window.addEventListener("resize", m), window.addEventListener("scroll", m)),
                    e.addEventListener("resize", l),
                    e.addEventListener("scroll", l),
                    (this._indicators.updateBoundsPositions = function (a) {
                        for (
                            var b,
                                c,
                                d,
                                f = a ? [h.extend({}, a.triggerGroup, { members: [a] })] : j.groups,
                                k = f.length,
                                l = {},
                                m = i ? "left" : "top",
                                n = i ? "width" : "height",
                                o = i ? h.get.scrollLeft(e) + h.get.width(e) - g : h.get.scrollTop(e) + h.get.height(e) - g;
                            k--;

                        )
                            for (d = f[k], b = d.members.length, c = h.get[n](d.element.firstChild); b--; ) (l[m] = o - c), h.css(d.members[b].bounds, l);
                    }),
                    (this._indicators.updateTriggerGroupPositions = function (a) {
                        for (
                            var b,
                                d,
                                k,
                                l,
                                m,
                                n = a ? [a] : j.groups,
                                o = n.length,
                                p = f ? document.body : e,
                                q = f ? { top: 0, left: 0 } : h.get.offset(p, !0),
                                r = i ? h.get.width(e) - g : h.get.height(e) - g,
                                s = i ? "width" : "height",
                                t = i ? "Y" : "X";
                            o--;

                        )
                            (b = n[o]),
                                (d = b.element),
                                (k = b.triggerHook * c.info("size")),
                                (l = h.get[s](d.firstChild.firstChild)),
                                (m = k > l ? "translate" + t + "(-100%)" : ""),
                                h.css(d, { top: q.top + (i ? k : r - b.members[0].options.indent), left: q.left + (i ? r - b.members[0].options.indent : k) }),
                                h.css(d.firstChild.firstChild, { "-ms-transform": m, "-webkit-transform": m, transform: m });
                    }),
                    (this._indicators.updateTriggerGroupLabel = function (a) {
                        var b = "trigger" + (a.members.length > 1 ? "" : " " + a.members[0].options.name),
                            c = a.element.firstChild.firstChild,
                            d = c.textContent !== b;
                        d && ((c.textContent = b), i && j.updateBoundsPositions());
                    }),
                    (this.addScene = function (b) {
                        this._options.addIndicators && b instanceof a.Scene && b.controller() === c && b.addIndicators(), this.$super.addScene.apply(this, arguments);
                    }),
                    (this.destroy = function () {
                        e.removeEventListener("resize", m),
                            f || (window.removeEventListener("resize", m), window.removeEventListener("scroll", m)),
                            e.removeEventListener("resize", l),
                            e.removeEventListener("scroll", l),
                            this.$super.destroy.apply(this, arguments);
                    }),
                    c
                );
            });
        var j = function (a, c) {
                var d,
                    e,
                    f = this,
                    g = k.bounds(),
                    j = k.start(c.colorStart),
                    l = k.end(c.colorEnd),
                    m = c.parent && h.get.elements(c.parent)[0],
                    n = function () {
                        a._log && (Array.prototype.splice.call(arguments, 1, 0, "(" + b + ")", "->"), a._log.apply(this, arguments));
                    };
                (c.name = c.name || i),
                    (j.firstChild.textContent += " " + c.name),
                    (l.textContent += " " + c.name),
                    g.appendChild(j),
                    g.appendChild(l),
                    (f.options = c),
                    (f.bounds = g),
                    (f.triggerGroup = void 0),
                    (this.add = function () {
                        (e = a.controller()), (d = e.info("vertical"));
                        var b = e.info("isDocument");
                        m || (m = b ? document.body : e.info("container")),
                            b || "static" !== h.css(m, "position") || h.css(m, { position: "relative" }),
                            a.on("change.plugin_addIndicators", p),
                            a.on("shift.plugin_addIndicators", o),
                            v(),
                            s(),
                            setTimeout(function () {
                                e._indicators.updateBoundsPositions(f);
                            }, 0),
                            n(3, "added indicators");
                    }),
                    (this.remove = function () {
                        if (f.triggerGroup) {
                            if ((a.off("change.plugin_addIndicators", p), a.off("shift.plugin_addIndicators", o), f.triggerGroup.members.length > 1)) {
                                var b = f.triggerGroup;
                                b.members.splice(b.members.indexOf(f), 1), e._indicators.updateTriggerGroupLabel(b), e._indicators.updateTriggerGroupPositions(b), (f.triggerGroup = void 0);
                            } else u();
                            r(), n(3, "removed indicators");
                        }
                    });
                var o = function () {
                        s();
                    },
                    p = function (a) {
                        "triggerHook" === a.what && v();
                    },
                    q = function () {
                        var a = e.info("vertical");
                        h.css(j.firstChild, { "border-bottom-width": a ? 1 : 0, "border-right-width": a ? 0 : 1, bottom: a ? -1 : c.indent, right: a ? c.indent : -1, padding: a ? "0 8px" : "2px 4px" }),
                            h.css(l, { "border-top-width": a ? 1 : 0, "border-left-width": a ? 0 : 1, top: a ? "100%" : "", right: a ? c.indent : "", bottom: a ? "" : c.indent, left: a ? "" : "100%", padding: a ? "0 8px" : "2px 4px" }),
                            m.appendChild(g);
                    },
                    r = function () {
                        g.parentNode.removeChild(g);
                    },
                    s = function () {
                        g.parentNode !== m && q();
                        var b = {};
                        (b[d ? "top" : "left"] = a.triggerPosition()), (b[d ? "height" : "width"] = a.duration()), h.css(g, b), h.css(l, { display: a.duration() > 0 ? "" : "none" });
                    },
                    t = function () {
                        var b = k.trigger(c.colorTrigger),
                            g = {};
                        (g[d ? "right" : "bottom"] = 0),
                            (g[d ? "border-top-width" : "border-left-width"] = 1),
                            h.css(b.firstChild, g),
                            h.css(b.firstChild.firstChild, { padding: d ? "0 8px 3px 8px" : "3px 4px" }),
                            document.body.appendChild(b);
                        var i = { triggerHook: a.triggerHook(), element: b, members: [f] };
                        e._indicators.groups.push(i), (f.triggerGroup = i), e._indicators.updateTriggerGroupLabel(i), e._indicators.updateTriggerGroupPositions(i);
                    },
                    u = function () {
                        e._indicators.groups.splice(e._indicators.groups.indexOf(f.triggerGroup), 1), f.triggerGroup.element.parentNode.removeChild(f.triggerGroup.element), (f.triggerGroup = void 0);
                    },
                    v = function () {
                        var b = a.triggerHook(),
                            c = 1e-4;
                        if (!(f.triggerGroup && Math.abs(f.triggerGroup.triggerHook - b) < c)) {
                            for (var d, g = e._indicators.groups, h = g.length; h--; )
                                if (((d = g[h]), Math.abs(d.triggerHook - b) < c))
                                    return (
                                        f.triggerGroup &&
                                            (1 === f.triggerGroup.members.length
                                                ? u()
                                                : (f.triggerGroup.members.splice(f.triggerGroup.members.indexOf(f), 1), e._indicators.updateTriggerGroupLabel(f.triggerGroup), e._indicators.updateTriggerGroupPositions(f.triggerGroup))),
                                        d.members.push(f),
                                        (f.triggerGroup = d),
                                        void e._indicators.updateTriggerGroupLabel(d)
                                    );
                            if (f.triggerGroup) {
                                if (1 === f.triggerGroup.members.length) return (f.triggerGroup.triggerHook = b), void e._indicators.updateTriggerGroupPositions(f.triggerGroup);
                                f.triggerGroup.members.splice(f.triggerGroup.members.indexOf(f), 1),
                                    e._indicators.updateTriggerGroupLabel(f.triggerGroup),
                                    e._indicators.updateTriggerGroupPositions(f.triggerGroup),
                                    (f.triggerGroup = void 0);
                            }
                            t();
                        }
                    };
            },
            k = {
                start: function (a) {
                    var b = document.createElement("div");
                    (b.textContent = "start"), h.css(b, { position: "absolute", overflow: "visible", "border-width": 0, "border-style": "solid", color: a, "border-color": a });
                    var c = document.createElement("div");
                    return h.css(c, { position: "absolute", overflow: "visible", width: 0, height: 0 }), c.appendChild(b), c;
                },
                end: function (a) {
                    var b = document.createElement("div");
                    return (b.textContent = "end"), h.css(b, { position: "absolute", overflow: "visible", "border-width": 0, "border-style": "solid", color: a, "border-color": a }), b;
                },
                bounds: function () {
                    var a = document.createElement("div");
                    return h.css(a, { position: "absolute", overflow: "visible", "white-space": "nowrap", "pointer-events": "none", "font-size": e }), (a.style.zIndex = f), a;
                },
                trigger: function (a) {
                    var b = document.createElement("div");
                    (b.textContent = "trigger"), h.css(b, { position: "relative" });
                    var c = document.createElement("div");
                    h.css(c, { position: "absolute", overflow: "visible", "border-width": 0, "border-style": "solid", color: a, "border-color": a }), c.appendChild(b);
                    var d = document.createElement("div");
                    return h.css(d, { position: "fixed", overflow: "visible", "white-space": "nowrap", "pointer-events": "none", "font-size": e }), (d.style.zIndex = f), d.appendChild(c), d;
                },
            };
    }),
    (function (a) {
        if (!Modernizr.touch) {
            if (!a.fn.viewportChecker) return void console.error("MISSING DEPENDANCY: The component 'animate-on-scroll' requires the library 'jquery-viewport-checker'. Please update packages.json to include this library.");
            a("[data-pnp-animation-delay]").each(function () {
                a(this).css("animation-delay", a(this).data("pnp-animation-delay"));
            }),
                a("[data-pnp-animation-duration]").each(function () {
                    a(this).css("animation-duration", a(this).data("pnp-animation-duration"));
                }),
                a("[data-pnp-animate]").each(function () {
                    a(this)
                        .addClass("aos-transparent")
                        .viewportChecker({ classToAdd: "aos-not-transparent animated " + a(this).data("pnp-animate"), offset: "10%", invertBottomOffset: !0 });
                });
        }
    })(jQuery),
    "undefined" == typeof jQuery)
)
    throw new Error("Bootstrap's JavaScript requires jQuery");
if (
    (+(function (a) {
        "use strict";
        var b = a.fn.jquery.split(" ")[0].split(".");
        if ((b[0] < 2 && b[1] < 9) || (1 == b[0] && 9 == b[1] && b[2] < 1) || b[0] > 2) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 3");
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b) {
            return this.each(function () {
                var d = a(this),
                    e = d.data("bs.tooltip"),
                    f = "object" == typeof b && b;
                (!e && /destroy|hide/.test(b)) || (e || d.data("bs.tooltip", (e = new c(this, f))), "string" == typeof b && e[b]());
            });
        }
        var c = function (a, b) {
            (this.type = null), (this.options = null), (this.enabled = null), (this.timeout = null), (this.hoverState = null), (this.$element = null), (this.inState = null), this.init("tooltip", a, b);
        };
        (c.VERSION = "3.3.6"),
            (c.TRANSITION_DURATION = 150),
            (c.DEFAULTS = {
                animation: !0,
                placement: "top",
                selector: !1,
                template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
                trigger: "hover focus",
                title: "",
                delay: 0,
                html: !1,
                container: !1,
                viewport: { selector: "body", padding: 0 },
            }),
            (c.prototype.init = function (b, c, d) {
                if (
                    ((this.enabled = !0),
                    (this.type = b),
                    (this.$element = a(c)),
                    (this.options = this.getOptions(d)),
                    (this.$viewport = this.options.viewport && a(a.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport)),
                    (this.inState = { click: !1, hover: !1, focus: !1 }),
                    this.$element[0] instanceof document.constructor && !this.options.selector)
                )
                    throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");
                for (var e = this.options.trigger.split(" "), f = e.length; f--; ) {
                    var g = e[f];
                    if ("click" == g) this.$element.on("click." + this.type, this.options.selector, a.proxy(this.toggle, this));
                    else if ("manual" != g) {
                        var h = "hover" == g ? "mouseenter" : "focusin",
                            i = "hover" == g ? "mouseleave" : "focusout";
                        this.$element.on(h + "." + this.type, this.options.selector, a.proxy(this.enter, this)), this.$element.on(i + "." + this.type, this.options.selector, a.proxy(this.leave, this));
                    }
                }
                this.options.selector ? (this._options = a.extend({}, this.options, { trigger: "manual", selector: "" })) : this.fixTitle();
            }),
            (c.prototype.getDefaults = function () {
                return c.DEFAULTS;
            }),
            (c.prototype.getOptions = function (b) {
                return (b = a.extend({}, this.getDefaults(), this.$element.data(), b)), b.delay && "number" == typeof b.delay && (b.delay = { show: b.delay, hide: b.delay }), b;
            }),
            (c.prototype.getDelegateOptions = function () {
                var b = {},
                    c = this.getDefaults();
                return (
                    this._options &&
                        a.each(this._options, function (a, d) {
                            c[a] != d && (b[a] = d);
                        }),
                    b
                );
            }),
            (c.prototype.enter = function (b) {
                var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
                return (
                    c || ((c = new this.constructor(b.currentTarget, this.getDelegateOptions())), a(b.currentTarget).data("bs." + this.type, c)),
                    b instanceof a.Event && (c.inState["focusin" == b.type ? "focus" : "hover"] = !0),
                    c.tip().hasClass("in") || "in" == c.hoverState
                        ? void (c.hoverState = "in")
                        : (clearTimeout(c.timeout),
                          (c.hoverState = "in"),
                          c.options.delay && c.options.delay.show
                              ? void (c.timeout = setTimeout(function () {
                                    "in" == c.hoverState && c.show();
                                }, c.options.delay.show))
                              : c.show())
                );
            }),
            (c.prototype.isInStateTrue = function () {
                for (var a in this.inState) if (this.inState[a]) return !0;
                return !1;
            }),
            (c.prototype.leave = function (b) {
                var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
                if (
                    (c || ((c = new this.constructor(b.currentTarget, this.getDelegateOptions())), a(b.currentTarget).data("bs." + this.type, c)),
                    b instanceof a.Event && (c.inState["focusout" == b.type ? "focus" : "hover"] = !1),
                    !c.isInStateTrue())
                )
                    return (
                        clearTimeout(c.timeout),
                        (c.hoverState = "out"),
                        c.options.delay && c.options.delay.hide
                            ? void (c.timeout = setTimeout(function () {
                                  "out" == c.hoverState && c.hide();
                              }, c.options.delay.hide))
                            : c.hide()
                    );
            }),
            (c.prototype.show = function () {
                var b = a.Event("show.bs." + this.type);
                if (this.hasContent() && this.enabled) {
                    this.$element.trigger(b);
                    var d = a.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
                    if (b.isDefaultPrevented() || !d) return;
                    var e = this,
                        f = this.tip(),
                        g = this.getUID(this.type);
                    this.setContent(), f.attr("id", g), this.$element.attr("aria-describedby", g), this.options.animation && f.addClass("fade");
                    var h = "function" == typeof this.options.placement ? this.options.placement.call(this, f[0], this.$element[0]) : this.options.placement,
                        i = /\s?auto?\s?/i,
                        j = i.test(h);
                    j && (h = h.replace(i, "") || "top"),
                        f
                            .detach()
                            .css({ top: 0, left: 0, display: "block" })
                            .addClass(h)
                            .data("bs." + this.type, this),
                        this.options.container ? f.appendTo(this.options.container) : f.insertAfter(this.$element),
                        this.$element.trigger("inserted.bs." + this.type);
                    var k = this.getPosition(),
                        l = f[0].offsetWidth,
                        m = f[0].offsetHeight;
                    if (j) {
                        var n = h,
                            o = this.getPosition(this.$viewport);
                        (h = "bottom" == h && k.bottom + m > o.bottom ? "top" : "top" == h && k.top - m < o.top ? "bottom" : "right" == h && k.right + l > o.width ? "left" : "left" == h && k.left - l < o.left ? "right" : h),
                            f.removeClass(n).addClass(h);
                    }
                    var p = this.getCalculatedOffset(h, k, l, m);
                    this.applyPlacement(p, h);
                    var q = function () {
                        var a = e.hoverState;
                        e.$element.trigger("shown.bs." + e.type), (e.hoverState = null), "out" == a && e.leave(e);
                    };
                    a.support.transition && this.$tip.hasClass("fade") ? f.one("bsTransitionEnd", q).emulateTransitionEnd(c.TRANSITION_DURATION) : q();
                }
            }),
            (c.prototype.applyPlacement = function (b, c) {
                var d = this.tip(),
                    e = d[0].offsetWidth,
                    f = d[0].offsetHeight,
                    g = parseInt(d.css("margin-top"), 10),
                    h = parseInt(d.css("margin-left"), 10);
                isNaN(g) && (g = 0),
                    isNaN(h) && (h = 0),
                    (b.top += g),
                    (b.left += h),
                    a.offset.setOffset(
                        d[0],
                        a.extend(
                            {
                                using: function (a) {
                                    d.css({ top: Math.round(a.top), left: Math.round(a.left) });
                                },
                            },
                            b
                        ),
                        0
                    ),
                    d.addClass("in");
                var i = d[0].offsetWidth,
                    j = d[0].offsetHeight;
                "top" == c && j != f && (b.top = b.top + f - j);
                var k = this.getViewportAdjustedDelta(c, b, i, j);
                k.left ? (b.left += k.left) : (b.top += k.top);
                var l = /top|bottom/.test(c),
                    m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
                    n = l ? "offsetWidth" : "offsetHeight";
                d.offset(b), this.replaceArrow(m, d[0][n], l);
            }),
            (c.prototype.replaceArrow = function (a, b, c) {
                this.arrow()
                    .css(c ? "left" : "top", 50 * (1 - a / b) + "%")
                    .css(c ? "top" : "left", "");
            }),
            (c.prototype.setContent = function () {
                var a = this.tip(),
                    b = this.getTitle();
                a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b), a.removeClass("fade in top bottom left right");
            }),
            (c.prototype.hide = function (b) {
                function d() {
                    "in" != e.hoverState && f.detach(), e.$element.removeAttr("aria-describedby").trigger("hidden.bs." + e.type), b && b();
                }
                var e = this,
                    f = a(this.$tip),
                    g = a.Event("hide.bs." + this.type);
                if ((this.$element.trigger(g), !g.isDefaultPrevented()))
                    return f.removeClass("in"), a.support.transition && f.hasClass("fade") ? f.one("bsTransitionEnd", d).emulateTransitionEnd(c.TRANSITION_DURATION) : d(), (this.hoverState = null), this;
            }),
            (c.prototype.fixTitle = function () {
                var a = this.$element;
                (a.attr("title") || "string" != typeof a.attr("data-original-title")) && a.attr("data-original-title", a.attr("title") || "").attr("title", "");
            }),
            (c.prototype.hasContent = function () {
                return this.getTitle();
            }),
            (c.prototype.getPosition = function (b) {
                b = b || this.$element;
                var c = b[0],
                    d = "BODY" == c.tagName,
                    e = c.getBoundingClientRect();
                null == e.width && (e = a.extend({}, e, { width: e.right - e.left, height: e.bottom - e.top }));
                var f = d ? { top: 0, left: 0 } : b.offset(),
                    g = { scroll: d ? document.documentElement.scrollTop || document.body.scrollTop : b.scrollTop() },
                    h = d ? { width: a(window).width(), height: a(window).height() } : null;
                return a.extend({}, e, g, h, f);
            }),
            (c.prototype.getCalculatedOffset = function (a, b, c, d) {
                return "bottom" == a
                    ? { top: b.top + b.height, left: b.left + b.width / 2 - c / 2 }
                    : "top" == a
                    ? { top: b.top - d, left: b.left + b.width / 2 - c / 2 }
                    : "left" == a
                    ? { top: b.top + b.height / 2 - d / 2, left: b.left - c }
                    : { top: b.top + b.height / 2 - d / 2, left: b.left + b.width };
            }),
            (c.prototype.getViewportAdjustedDelta = function (a, b, c, d) {
                var e = { top: 0, left: 0 };
                if (!this.$viewport) return e;
                var f = (this.options.viewport && this.options.viewport.padding) || 0,
                    g = this.getPosition(this.$viewport);
                if (/right|left/.test(a)) {
                    var h = b.top - f - g.scroll,
                        i = b.top + f - g.scroll + d;
                    h < g.top ? (e.top = g.top - h) : i > g.top + g.height && (e.top = g.top + g.height - i);
                } else {
                    var j = b.left - f,
                        k = b.left + f + c;
                    j < g.left ? (e.left = g.left - j) : k > g.right && (e.left = g.left + g.width - k);
                }
                return e;
            }),
            (c.prototype.getTitle = function () {
                var a,
                    b = this.$element,
                    c = this.options;
                return (a = b.attr("data-original-title") || ("function" == typeof c.title ? c.title.call(b[0]) : c.title));
            }),
            (c.prototype.getUID = function (a) {
                do a += ~~(1e6 * Math.random());
                while (document.getElementById(a));
                return a;
            }),
            (c.prototype.tip = function () {
                if (!this.$tip && ((this.$tip = a(this.options.template)), 1 != this.$tip.length)) throw new Error(this.type + " `template` option must consist of exactly 1 top-level element!");
                return this.$tip;
            }),
            (c.prototype.arrow = function () {
                return (this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow"));
            }),
            (c.prototype.enable = function () {
                this.enabled = !0;
            }),
            (c.prototype.disable = function () {
                this.enabled = !1;
            }),
            (c.prototype.toggleEnabled = function () {
                this.enabled = !this.enabled;
            }),
            (c.prototype.toggle = function (b) {
                var c = this;
                b && ((c = a(b.currentTarget).data("bs." + this.type)), c || ((c = new this.constructor(b.currentTarget, this.getDelegateOptions())), a(b.currentTarget).data("bs." + this.type, c))),
                    b ? ((c.inState.click = !c.inState.click), c.isInStateTrue() ? c.enter(c) : c.leave(c)) : c.tip().hasClass("in") ? c.leave(c) : c.enter(c);
            }),
            (c.prototype.destroy = function () {
                var a = this;
                clearTimeout(this.timeout),
                    this.hide(function () {
                        a.$element.off("." + a.type).removeData("bs." + a.type), a.$tip && a.$tip.detach(), (a.$tip = null), (a.$arrow = null), (a.$viewport = null);
                    });
            });
        var d = a.fn.tooltip;
        (a.fn.tooltip = b),
            (a.fn.tooltip.Constructor = c),
            (a.fn.tooltip.noConflict = function () {
                return (a.fn.tooltip = d), this;
            });
    })(jQuery),
    (function (a) {
        function b(b) {
            var c = null,
                d = null,
                e = a(b),
                f = a(".dropdown-menu", b),
                g = e.parents("ul.nav");
            return g.size() > 0 && ((c = g.data("dropdown-in") || null), (d = g.data("dropdown-out") || null)), { target: b, dropdown: e, dropdownMenu: f, effectIn: f.data("dropdown-in") || c, effectOut: f.data("dropdown-out") || d };
        }
        function c(a, b) {
            b && (a.dropdown.addClass("dropdown-animating"), a.dropdownMenu.addClass("animated"), a.dropdownMenu.addClass(b));
        }
        function d(a, b) {
            var c = "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";
            a.dropdown.one(c, function () {
                a.dropdown.removeClass("dropdown-animating"), a.dropdownMenu.removeClass("animated"), a.dropdownMenu.removeClass(a.effectIn), a.dropdownMenu.removeClass(a.effectOut), "function" == typeof b && b();
            });
        }
        var e = a(".dropdown, .dropup");
        e.on({
            "show.bs.dropdown": function () {
                var d = b(this);
                c(d, d.effectIn),
                    d.dropdownMenu.hasClass("-no-backdrop") ||
                        (a("body").append('<div class="modal-backdrop -dropdown fade"></div>'),
                        setTimeout(function () {
                            a(".modal-backdrop").addClass("in");
                        }, 50),
                        $body.addClass("-dropdown-open")),
                    d.dropdownMenu.closest(".component-anchor-point-bar").length && $body.addClass("-sub-nav-dropdown");
            },
            "shown.bs.dropdown": function () {
                var a = b(this);
                a.effectIn && a.effectOut && d(a, function () {});
            },
            "hide.bs.dropdown": function (e) {
                var f = b(this);
                f.effectOut &&
                    (e.preventDefault(),
                    c(f, f.effectOut),
                    d(f, function () {
                        f.dropdown.removeClass("open");
                    })),
                    a(".modal-backdrop").removeClass("in").addClass("-remove-me"),
                    setTimeout(function () {
                        a(".modal-backdrop.-remove-me").remove();
                    }, 700),
                    $body.removeClass("-dropdown-open").removeClass("-sub-nav-dropdown");
            },
        });
    })(jQuery),
    "undefined" == typeof jQuery)
)
    throw new Error("Bootstrap's JavaScript requires jQuery");
if (
    (+(function (a) {
        "use strict";
        var b = a.fn.jquery.split(" ")[0].split(".");
        if ((b[0] < 2 && b[1] < 9) || (1 == b[0] && 9 == b[1] && b[2] < 1) || b[0] > 2) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 3");
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b) {
            var c = b.attr("data-target");
            c || ((c = b.attr("href")), (c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, "")));
            var d = c && a(c);
            return d && d.length ? d : b.parent();
        }
        function c(c) {
            (c && 3 === c.which) ||
                (a(e).remove(),
                a(f).each(function () {
                    var d = a(this),
                        e = b(d),
                        f = { relatedTarget: this };
                    e.hasClass("open") &&
                        ((c && "click" == c.type && /input|textarea/i.test(c.target.tagName) && a.contains(e[0], c.target)) ||
                            (e.trigger((c = a.Event("hide.bs.dropdown", f))), c.isDefaultPrevented() || (d.attr("aria-expanded", "false"), e.removeClass("open").trigger(a.Event("hidden.bs.dropdown", f)))));
                }));
        }
        function d(b) {
            return this.each(function () {
                var c = a(this),
                    d = c.data("bs.dropdown");
                d || c.data("bs.dropdown", (d = new g(this))), "string" == typeof b && d[b].call(c);
            });
        }
        var e = ".dropdown-backdrop",
            f = '[data-toggle="dropdown"]',
            g = function (b) {
                a(b).on("click.bs.dropdown", this.toggle);
            };
        (g.VERSION = "3.3.6"),
            (g.prototype.toggle = function (d) {
                var e = a(this);
                if (!e.is(".disabled, :disabled")) {
                    var f = b(e),
                        g = f.hasClass("open");
                    if ((c(), !g)) {
                        "ontouchstart" in document.documentElement && !f.closest(".navbar-nav").length && a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click", c);
                        var h = { relatedTarget: this };
                        if ((f.trigger((d = a.Event("show.bs.dropdown", h))), d.isDefaultPrevented())) return;
                        e.trigger("focus").attr("aria-expanded", "true"), f.toggleClass("open").trigger(a.Event("shown.bs.dropdown", h));
                    }
                    return !1;
                }
            }),
            (g.prototype.keydown = function (c) {
                if (/(38|40|27|32)/.test(c.which) && !/input|textarea/i.test(c.target.tagName)) {
                    var d = a(this);
                    if ((c.preventDefault(), c.stopPropagation(), !d.is(".disabled, :disabled"))) {
                        var e = b(d),
                            g = e.hasClass("open");
                        if ((!g && 27 != c.which) || (g && 27 == c.which)) return 27 == c.which && e.find(f).trigger("focus"), d.trigger("click");
                        var h = " li:not(.disabled):visible a",
                            i = e.find(".dropdown-menu" + h);
                        if (i.length) {
                            var j = i.index(c.target);
                            38 == c.which && j > 0 && j--, 40 == c.which && j < i.length - 1 && j++, ~j || (j = 0), i.eq(j).trigger("focus");
                        }
                    }
                }
            });
        var h = a.fn.dropdown;
        (a.fn.dropdown = d),
            (a.fn.dropdown.Constructor = g),
            (a.fn.dropdown.noConflict = function () {
                return (a.fn.dropdown = h), this;
            }),
            a(document)
                .on("click.bs.dropdown.data-api", c)
                .on("click.bs.dropdown.data-api", ".dropdown form", function (a) {
                    a.stopPropagation();
                })
                .on("click.bs.dropdown.data-api", f, g.prototype.toggle)
                .on("keydown.bs.dropdown.data-api", f, g.prototype.keydown)
                .on("keydown.bs.dropdown.data-api", ".dropdown-menu", g.prototype.keydown);
    })(jQuery),
    "undefined" == typeof jQuery)
)
    throw new Error("Bootstrap's JavaScript requires jQuery");
if (
    (+(function (a) {
        "use strict";
        var b = a.fn.jquery.split(" ")[0].split(".");
        if ((b[0] < 2 && b[1] < 9) || (1 == b[0] && 9 == b[1] && b[2] < 1) || b[0] > 2) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 3");
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b, d) {
            return this.each(function () {
                var e = a(this),
                    f = e.data("bs.modal"),
                    g = a.extend({}, c.DEFAULTS, e.data(), "object" == typeof b && b);
                f || e.data("bs.modal", (f = new c(this, g))), "string" == typeof b ? f[b](d) : g.show && f.show(d);
            });
        }
        var c = function (b, c) {
            (this.options = c),
                (this.$body = a(document.body)),
                (this.$element = a(b)),
                (this.$dialog = this.$element.find(".modal-dialog")),
                (this.$backdrop = null),
                (this.isShown = null),
                (this.originalBodyPad = null),
                (this.scrollbarWidth = 0),
                (this.ignoreBackdropClick = !1),
                this.options.remote &&
                    this.$element.find(".modal-content").load(
                        this.options.remote,
                        a.proxy(function () {
                            this.$element.trigger("loaded.bs.modal");
                        }, this)
                    );
        };
        (c.VERSION = "3.3.6"),
            (c.TRANSITION_DURATION = 300),
            (c.BACKDROP_TRANSITION_DURATION = 150),
            (c.DEFAULTS = { backdrop: !0, keyboard: !0, show: !0 }),
            (c.prototype.toggle = function (a) {
                return this.isShown ? this.hide() : this.show(a);
            }),
            (c.prototype.show = function (b) {
                var d = this,
                    e = a.Event("show.bs.modal", { relatedTarget: b });
                this.$element.trigger(e),
                    this.isShown ||
                        e.isDefaultPrevented() ||
                        ((this.isShown = !0),
                        this.checkScrollbar(),
                        this.setScrollbar(),
                        this.$body.addClass("modal-open"),
                        this.escape(),
                        this.resize(),
                        this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', a.proxy(this.hide, this)),
                        this.$dialog.on("mousedown.dismiss.bs.modal", function () {
                            d.$element.one("mouseup.dismiss.bs.modal", function (b) {
                                a(b.target).is(d.$element) && (d.ignoreBackdropClick = !0);
                            });
                        }),
                        this.backdrop(function () {
                            var e = a.support.transition && d.$element.hasClass("fade");
                            d.$element.parent().length || d.$element.appendTo(d.$body), d.$element.show().scrollTop(0), d.adjustDialog(), e && d.$element[0].offsetWidth, d.$element.addClass("in"), d.enforceFocus();
                            var f = a.Event("shown.bs.modal", { relatedTarget: b });
                            e
                                ? d.$dialog
                                      .one("bsTransitionEnd", function () {
                                          d.$element.trigger("focus").trigger(f);
                                      })
                                      .emulateTransitionEnd(c.TRANSITION_DURATION)
                                : d.$element.trigger("focus").trigger(f);
                        }));
            }),
            (c.prototype.hide = function (b) {
                b && b.preventDefault(),
                    (b = a.Event("hide.bs.modal")),
                    this.$element.trigger(b),
                    this.isShown &&
                        !b.isDefaultPrevented() &&
                        ((this.isShown = !1),
                        this.escape(),
                        this.resize(),
                        a(document).off("focusin.bs.modal"),
                        this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),
                        this.$dialog.off("mousedown.dismiss.bs.modal"),
                        a.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", a.proxy(this.hideModal, this)).emulateTransitionEnd(c.TRANSITION_DURATION) : this.hideModal());
            }),
            (c.prototype.enforceFocus = function () {
                a(document)
                    .off("focusin.bs.modal")
                    .on(
                        "focusin.bs.modal",
                        a.proxy(function (a) {
                            this.$element[0] === a.target || this.$element.has(a.target).length || this.$element.trigger("focus");
                        }, this)
                    );
            }),
            (c.prototype.escape = function () {
                this.isShown && this.options.keyboard
                    ? this.$element.on(
                          "keydown.dismiss.bs.modal",
                          a.proxy(function (a) {
                              27 == a.which && this.hide();
                          }, this)
                      )
                    : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
            }),
            (c.prototype.resize = function () {
                this.isShown ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this)) : a(window).off("resize.bs.modal");
            }),
            (c.prototype.hideModal = function () {
                var a = this;
                this.$element.hide(),
                    this.backdrop(function () {
                        a.$body.removeClass("modal-open"), a.resetAdjustments(), a.resetScrollbar(), a.$element.trigger("hidden.bs.modal");
                    });
            }),
            (c.prototype.removeBackdrop = function () {
                this.$backdrop && this.$backdrop.remove(), (this.$backdrop = null);
            }),
            (c.prototype.backdrop = function (b) {
                var d = this,
                    e = this.$element.hasClass("fade") ? "fade" : "";
                if (this.isShown && this.options.backdrop) {
                    var f = a.support.transition && e;
                    if (
                        ((this.$backdrop = a(document.createElement("div"))
                            .addClass("modal-backdrop " + e)
                            .appendTo(this.$body)),
                        this.$element.on(
                            "click.dismiss.bs.modal",
                            a.proxy(function (a) {
                                return this.ignoreBackdropClick ? void (this.ignoreBackdropClick = !1) : void (a.target === a.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide()));
                            }, this)
                        ),
                        f && this.$backdrop[0].offsetWidth,
                        this.$backdrop.addClass("in"),
                        !b)
                    )
                        return;
                    f ? this.$backdrop.one("bsTransitionEnd", b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : b();
                } else if (!this.isShown && this.$backdrop) {
                    this.$backdrop.removeClass("in");
                    var g = function () {
                        d.removeBackdrop(), b && b();
                    };
                    a.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : g();
                } else b && b();
            }),
            (c.prototype.handleUpdate = function () {
                this.adjustDialog();
            }),
            (c.prototype.adjustDialog = function () {
                var a = this.$element[0].scrollHeight > document.documentElement.clientHeight;
                this.$element.css({ paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "", paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : "" });
            }),
            (c.prototype.resetAdjustments = function () {
                this.$element.css({ paddingLeft: "", paddingRight: "" });
            }),
            (c.prototype.checkScrollbar = function () {
                var a = window.innerWidth;
                if (!a) {
                    var b = document.documentElement.getBoundingClientRect();
                    a = b.right - Math.abs(b.left);
                }
                (this.bodyIsOverflowing = document.body.clientWidth < a), (this.scrollbarWidth = this.measureScrollbar());
            }),
            (c.prototype.setScrollbar = function () {
                var a = parseInt(this.$body.css("padding-right") || 0, 10);
                (this.originalBodyPad = document.body.style.paddingRight || ""), this.bodyIsOverflowing && this.$body.css("padding-right", a + this.scrollbarWidth);
            }),
            (c.prototype.resetScrollbar = function () {
                this.$body.css("padding-right", this.originalBodyPad);
            }),
            (c.prototype.measureScrollbar = function () {
                var a = document.createElement("div");
                (a.className = "modal-scrollbar-measure"), this.$body.append(a);
                var b = a.offsetWidth - a.clientWidth;
                return this.$body[0].removeChild(a), b;
            });
        var d = a.fn.modal;
        (a.fn.modal = b),
            (a.fn.modal.Constructor = c),
            (a.fn.modal.noConflict = function () {
                return (a.fn.modal = d), this;
            }),
            a(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function (c) {
                var d = a(this),
                    e = d.attr("href"),
                    f = a(d.attr("data-target") || (e && e.replace(/.*(?=#[^\s]+$)/, ""))),
                    g = f.data("bs.modal") ? "toggle" : a.extend({ remote: !/#/.test(e) && e }, f.data(), d.data());
                d.is("a") && c.preventDefault(),
                    f.one("show.bs.modal", function (a) {
                        a.isDefaultPrevented() ||
                            f.one("hidden.bs.modal", function () {
                                d.is(":visible") && d.trigger("focus");
                            });
                    }),
                    b.call(f, g, this);
            });
    })(jQuery),
    +(function (a) {
        "use strict";
        function b() {
            var a = document.createElement("bootstrap"),
                b = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd otransitionend", transition: "transitionend" };
            for (var c in b) if (void 0 !== a.style[c]) return { end: b[c] };
            return !1;
        }
        (a.fn.emulateTransitionEnd = function (b) {
            var c = !1,
                d = this;
            a(this).one("bsTransitionEnd", function () {
                c = !0;
            });
            var e = function () {
                c || a(d).trigger(a.support.transition.end);
            };
            return setTimeout(e, b), this;
        }),
            a(function () {
                (a.support.transition = b()),
                    a.support.transition &&
                        (a.event.special.bsTransitionEnd = {
                            bindType: a.support.transition.end,
                            delegateType: a.support.transition.end,
                            handle: function (b) {
                                if (a(b.target).is(this)) return b.handleObj.handler.apply(this, arguments);
                            },
                        });
            });
    })(jQuery),
    +(function (a) {
        "use strict";
        function b(b) {
            return this.each(function () {
                var d = a(this),
                    e = d.data("bs.popover"),
                    f = "object" == typeof b && b;
                (!e && /destroy|hide/.test(b)) || (e || d.data("bs.popover", (e = new c(this, f))), "string" == typeof b && e[b]());
            });
        }
        var c = function (a, b) {
            this.init("popover", a, b);
        };
        if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");
        (c.VERSION = "3.3.6"),
            (c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, {
                placement: "right",
                trigger: "click",
                content: "",
                template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
            })),
            (c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype)),
            (c.prototype.constructor = c),
            (c.prototype.getDefaults = function () {
                return c.DEFAULTS;
            }),
            (c.prototype.setContent = function () {
                var a = this.tip(),
                    b = this.getTitle(),
                    c = this.getContent();
                a.find(".popover-title")[this.options.html ? "html" : "text"](b),
                    a.find(".popover-content").children().detach().end()[this.options.html ? ("string" == typeof c ? "html" : "append") : "text"](c),
                    a.removeClass("fade top bottom left right in"),
                    a.find(".popover-title").html() || a.find(".popover-title").hide();
            }),
            (c.prototype.hasContent = function () {
                return this.getTitle() || this.getContent();
            }),
            (c.prototype.getContent = function () {
                var a = this.$element,
                    b = this.options;
                return a.attr("data-content") || ("function" == typeof b.content ? b.content.call(a[0]) : b.content);
            }),
            (c.prototype.arrow = function () {
                return (this.$arrow = this.$arrow || this.tip().find(".arrow"));
            });
        var d = a.fn.popover;
        (a.fn.popover = b),
            (a.fn.popover.Constructor = c),
            (a.fn.popover.noConflict = function () {
                return (a.fn.popover = d), this;
            });
    })(jQuery),
    "undefined" == typeof jQuery)
)
    throw new Error("Bootstrap's JavaScript requires jQuery");
+(function (a) {
    "use strict";
    var b = a.fn.jquery.split(" ")[0].split(".");
    if ((b[0] < 2 && b[1] < 9) || (1 == b[0] && 9 == b[1] && b[2] < 1) || b[0] > 3) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4");
})(jQuery),
    +(function (a) {
        "use strict";
        function b(c, d) {
            (this.$body = a(document.body)),
                (this.$scrollElement = a(a(c).is(document.body) ? window : c)),
                (this.options = a.extend({}, b.DEFAULTS, d)),
                (this.selector = (this.options.target || "") + " .nav li > a"),
                (this.offsets = []),
                (this.targets = []),
                (this.activeTarget = null),
                (this.scrollHeight = 0),
                this.$scrollElement.on("scroll.bs.scrollspy", a.proxy(this.process, this)),
                this.refresh(),
                this.process();
        }
        function c(c) {
            return this.each(function () {
                var d = a(this),
                    e = d.data("bs.scrollspy"),
                    f = "object" == typeof c && c;
                e || d.data("bs.scrollspy", (e = new b(this, f))), "string" == typeof c && e[c]();
            });
        }
        (b.VERSION = "3.3.7"),
            (b.DEFAULTS = { offset: 10 }),
            (b.prototype.getScrollHeight = function () {
                return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
            }),
            (b.prototype.refresh = function () {
                var b = this,
                    c = "offset",
                    d = 0;
                (this.offsets = []),
                    (this.targets = []),
                    (this.scrollHeight = this.getScrollHeight()),
                    a.isWindow(this.$scrollElement[0]) || ((c = "position"), (d = this.$scrollElement.scrollTop())),
                    this.$body
                        .find(this.selector)
                        .map(function () {
                            var b = a(this),
                                e = b.data("target") || b.attr("href"),
                                f = /^#./.test(e) && a(e);
                            return (f && f.length && f.is(":visible") && [[f[c]().top + d, e]]) || null;
                        })
                        .sort(function (a, b) {
                            return a[0] - b[0];
                        })
                        .each(function () {
                            b.offsets.push(this[0]), b.targets.push(this[1]);
                        });
            }),
            (b.prototype.process = function () {
                var a,
                    b = this.$scrollElement.scrollTop() + this.options.offset,
                    c = this.getScrollHeight(),
                    d = this.options.offset + c - this.$scrollElement.height(),
                    e = this.offsets,
                    f = this.targets,
                    g = this.activeTarget;
                if ((this.scrollHeight != c && this.refresh(), b >= d)) return g != (a = f[f.length - 1]) && this.activate(a);
                if (g && b < e[0]) return (this.activeTarget = null), this.clear();
                for (a = e.length; a--; ) g != f[a] && b >= e[a] && (void 0 === e[a + 1] || b < e[a + 1]) && this.activate(f[a]);
            }),
            (b.prototype.activate = function (b) {
                (this.activeTarget = b), this.clear();
                var c = this.selector + '[data-target="' + b + '"],' + this.selector + '[href="' + b + '"]',
                    d = a(c).parents("li").addClass("active");
                d.parent(".dropdown-menu").length && (d = d.closest("li.dropdown").addClass("active")), d.trigger("activate.bs.scrollspy");
            }),
            (b.prototype.clear = function () {
                a(this.selector).parentsUntil(this.options.target, ".active").removeClass("active");
            });
        var d = a.fn.scrollspy;
        (a.fn.scrollspy = c),
            (a.fn.scrollspy.Constructor = b),
            (a.fn.scrollspy.noConflict = function () {
                return (a.fn.scrollspy = d), this;
            }),
            a(window).on("load.bs.scrollspy.data-api", function () {
                a('[data-spy="scroll"]').each(function () {
                    var b = a(this);
                    c.call(b, b.data());
                });
            });
    })(jQuery),
    (function (a) {
        "use strict";
        function b(a) {
            var b = { path: !0, query: !0, hash: !0 };
            return a ? (/^[a-z]+:/.test(a) && ((b.protocol = !0), (b.host = !0), /[-a-z0-9]+(\.[-a-z0-9])*:\d+/i.test(a) && (b.port = !0), /\/\/(.*?)(?::(.*?))?@/.test(a) && ((b.user = !0), (b.pass = !0))), b) : b;
        }
        function c(a, c, d) {
            var l,
                m,
                n,
                o = h ? "file://" + (process.platform.match(/^win/i) ? "/" : "") + i("fs").realpathSync(".") : document.location.href;
            c || (c = o), h ? (l = i("url").parse(c)) : ((l = document.createElement("a")), (l.href = c));
            var p = b(c);
            n = c.match(/\/\/(.*?)(?::(.*?))?@/) || [];
            for (m in j) p[m] ? (a[m] = l[j[m]] || "") : (a[m] = "");
            if (
                ((a.protocol = a.protocol.replace(/:$/, "")),
                (a.query = a.query.replace(/^\?/, "")),
                (a.hash = e(a.hash.replace(/^#/, ""))),
                (a.user = e(n[1] || "")),
                (a.pass = e(n[2] || "")),
                (a.port = k[a.protocol] == a.port || 0 == a.port ? "" : a.port),
                !p.protocol && /[^/#?]/.test(c.charAt(0)) && (a.path = c.split("?")[0].split("#")[0]),
                !p.protocol && d)
            ) {
                var q = new g(o.match(/(.*\/)/)[0]),
                    r = q.path.split("/"),
                    s = a.path.split("/"),
                    t = ["protocol", "user", "pass", "host", "port"],
                    u = t.length;
                for (r.pop(), m = 0; m < u; m++) a[t[m]] = q[t[m]];
                for (; ".." === s[0]; ) r.pop(), s.shift();
                a.path = ("/" !== c.charAt(0) ? r.join("/") : "") + "/" + s.join("/");
            }
            (a.path = a.path.replace(/^\/{2,}/, "/")), a.paths(("/" === a.path.charAt(0) ? a.path.slice(1) : a.path).split("/")), (a.query = new f(a.query));
        }
        function d(a) {
            return encodeURIComponent(a).replace(/'/g, "%27");
        }
        function e(a) {
            return (
                (a = a.replace(/\+/g, " ")),
                (a = a.replace(/%([ef][0-9a-f])%([89ab][0-9a-f])%([89ab][0-9a-f])/gi, function (a, b, c, d) {
                    var e = parseInt(b, 16) - 224,
                        f = parseInt(c, 16) - 128;
                    if (0 === e && f < 32) return a;
                    var g = parseInt(d, 16) - 128,
                        h = (e << 12) + (f << 6) + g;
                    return h > 65535 ? a : String.fromCharCode(h);
                })),
                (a = a.replace(/%([cd][0-9a-f])%([89ab][0-9a-f])/gi, function (a, b, c) {
                    var d = parseInt(b, 16) - 192;
                    if (d < 2) return a;
                    var e = parseInt(c, 16) - 128;
                    return String.fromCharCode((d << 6) + e);
                })),
                a.replace(/%([0-7][0-9a-f])/gi, function (a, b) {
                    return String.fromCharCode(parseInt(b, 16));
                })
            );
        }
        function f(a) {
            for (var b, c = /([^=&]+)(=([^&]*))?/g; (b = c.exec(a)); ) {
                var d = decodeURIComponent(b[1].replace(/\+/g, " ")),
                    f = b[3] ? e(b[3]) : "";
                void 0 !== this[d] && null !== this[d] ? (this[d] instanceof Array || (this[d] = [this[d]]), this[d].push(f)) : (this[d] = f);
            }
        }
        function g(a, b) {
            c(this, a, !b);
        }
        var h = "undefined" == typeof window && "undefined" != typeof global && "function" == typeof require,
            i = h ? a.require : null,
            j = { protocol: "protocol", host: "hostname", port: "port", path: "pathname", query: "search", hash: "hash" },
            k = { ftp: 21, gopher: 70, http: 80, https: 443, ws: 80, wss: 443 };
        (f.prototype.toString = function () {
            var a,
                b,
                c = "",
                e = d;
            for (a in this)
                if (!(this[a] instanceof Function || null === this[a]))
                    if (this[a] instanceof Array) {
                        var f = this[a].length;
                        if (f) for (b = 0; b < f; b++) (c += c ? "&" : ""), (c += e(a) + "=" + e(this[a][b]));
                        else c += (c ? "&" : "") + e(a) + "=";
                    } else (c += c ? "&" : ""), (c += e(a) + "=" + e(this[a]));
            return c;
        }),
            (g.prototype.clearQuery = function () {
                for (var a in this.query) this.query[a] instanceof Function || delete this.query[a];
                return this;
            }),
            (g.prototype.queryLength = function () {
                var a,
                    b = 0;
                for (a in this) this[a] instanceof Function || b++;
                return b;
            }),
            (g.prototype.isEmptyQuery = function () {
                return 0 === this.queryLength();
            }),
            (g.prototype.paths = function (a) {
                var b,
                    c = "",
                    f = 0;
                if (a && a.length && a + "" !== a) {
                    for (this.isAbsolute() && (c = "/"), b = a.length; f < b; f++) a[f] = !f && a[f].match(/^\w:$/) ? a[f] : d(a[f]);
                    this.path = c + a.join("/");
                }
                for (a = ("/" === this.path.charAt(0) ? this.path.slice(1) : this.path).split("/"), f = 0, b = a.length; f < b; f++) a[f] = e(a[f]);
                return a;
            }),
            (g.prototype.encode = d),
            (g.prototype.decode = e),
            (g.prototype.isAbsolute = function () {
                return this.protocol || "/" === this.path.charAt(0);
            }),
            (g.prototype.toString = function () {
                return (
                    (this.protocol && this.protocol + "://") +
                    (this.user && d(this.user) + (this.pass && ":" + d(this.pass)) + "@") +
                    (this.host && this.host) +
                    (this.port && ":" + this.port) +
                    (this.path && this.path) +
                    (this.query.toString() && "?" + this.query) +
                    (this.hash && "#" + d(this.hash))
                );
            }),
            (a[a.exports ? "exports" : "Url"] = g);
    })("undefined" != typeof module && module.exports ? module : window),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("jquery-bridget/jquery-bridget", ["jquery"], function (c) {
                  return b(a, c);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("jquery")))
            : (a.jQueryBridget = b(a, a.jQuery));
    })(window, function (a, b) {
        "use strict";
        function c(c, f, h) {
            function i(a, b, d) {
                var e,
                    f = "$()." + c + '("' + b + '")';
                return (
                    a.each(function (a, i) {
                        var j = h.data(i, c);
                        if (!j) return void g(c + " not initialized. Cannot call methods, i.e. " + f);
                        var k = j[b];
                        if (!k || "_" == b.charAt(0)) return void g(f + " is not a valid method");
                        var l = k.apply(j, d);
                        e = void 0 === e ? l : e;
                    }),
                    void 0 !== e ? e : a
                );
            }
            function j(a, b) {
                a.each(function (a, d) {
                    var e = h.data(d, c);
                    e ? (e.option(b), e._init()) : ((e = new f(d, b)), h.data(d, c, e));
                });
            }
            (h = h || b || a.jQuery),
                h &&
                    (f.prototype.option ||
                        (f.prototype.option = function (a) {
                            h.isPlainObject(a) && (this.options = h.extend(!0, this.options, a));
                        }),
                    (h.fn[c] = function (a) {
                        if ("string" == typeof a) {
                            var b = e.call(arguments, 1);
                            return i(this, a, b);
                        }
                        return j(this, a), this;
                    }),
                    d(h));
        }
        function d(a) {
            !a || (a && a.bridget) || (a.bridget = c);
        }
        var e = Array.prototype.slice,
            f = a.console,
            g =
                "undefined" == typeof f
                    ? function () {}
                    : function (a) {
                          f.error(a);
                      };
        return d(b || a.jQuery), c;
    }),
    (function (a, b) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", b) : "object" == typeof module && module.exports ? (module.exports = b()) : (a.EvEmitter = b());
    })("undefined" != typeof window ? window : this, function () {
        function a() {}
        var b = a.prototype;
        return (
            (b.on = function (a, b) {
                if (a && b) {
                    var c = (this._events = this._events || {}),
                        d = (c[a] = c[a] || []);
                    return d.indexOf(b) == -1 && d.push(b), this;
                }
            }),
            (b.once = function (a, b) {
                if (a && b) {
                    this.on(a, b);
                    var c = (this._onceEvents = this._onceEvents || {}),
                        d = (c[a] = c[a] || {});
                    return (d[b] = !0), this;
                }
            }),
            (b.off = function (a, b) {
                var c = this._events && this._events[a];
                if (c && c.length) {
                    var d = c.indexOf(b);
                    return d != -1 && c.splice(d, 1), this;
                }
            }),
            (b.emitEvent = function (a, b) {
                var c = this._events && this._events[a];
                if (c && c.length) {
                    (c = c.slice(0)), (b = b || []);
                    for (var d = this._onceEvents && this._onceEvents[a], e = 0; e < c.length; e++) {
                        var f = c[e],
                            g = d && d[f];
                        g && (this.off(a, f), delete d[f]), f.apply(this, b);
                    }
                    return this;
                }
            }),
            (b.allOff = function () {
                delete this._events, delete this._onceEvents;
            }),
            a
        );
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("get-size/get-size", [], function () {
                  return b();
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b())
            : (a.getSize = b());
    })(window, function () {
        "use strict";
        function a(a) {
            var b = parseFloat(a),
                c = a.indexOf("%") == -1 && !isNaN(b);
            return c && b;
        }
        function b() {}
        function c() {
            for (var a = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, b = 0; b < j; b++) {
                var c = i[b];
                a[c] = 0;
            }
            return a;
        }
        function d(a) {
            var b = getComputedStyle(a);
            return b || h("Style returned " + b + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"), b;
        }
        function e() {
            if (!k) {
                k = !0;
                var b = document.createElement("div");
                (b.style.width = "200px"), (b.style.padding = "1px 2px 3px 4px"), (b.style.borderStyle = "solid"), (b.style.borderWidth = "1px 2px 3px 4px"), (b.style.boxSizing = "border-box");
                var c = document.body || document.documentElement;
                c.appendChild(b);
                var e = d(b);
                (f.isBoxSizeOuter = g = 200 == a(e.width)), c.removeChild(b);
            }
        }
        function f(b) {
            if ((e(), "string" == typeof b && (b = document.querySelector(b)), b && "object" == typeof b && b.nodeType)) {
                var f = d(b);
                if ("none" == f.display) return c();
                var h = {};
                (h.width = b.offsetWidth), (h.height = b.offsetHeight);
                for (var k = (h.isBorderBox = "border-box" == f.boxSizing), l = 0; l < j; l++) {
                    var m = i[l],
                        n = f[m],
                        o = parseFloat(n);
                    h[m] = isNaN(o) ? 0 : o;
                }
                var p = h.paddingLeft + h.paddingRight,
                    q = h.paddingTop + h.paddingBottom,
                    r = h.marginLeft + h.marginRight,
                    s = h.marginTop + h.marginBottom,
                    t = h.borderLeftWidth + h.borderRightWidth,
                    u = h.borderTopWidth + h.borderBottomWidth,
                    v = k && g,
                    w = a(f.width);
                w !== !1 && (h.width = w + (v ? 0 : p + t));
                var x = a(f.height);
                return x !== !1 && (h.height = x + (v ? 0 : q + u)), (h.innerWidth = h.width - (p + t)), (h.innerHeight = h.height - (q + u)), (h.outerWidth = h.width + r), (h.outerHeight = h.height + s), h;
            }
        }
        var g,
            h =
                "undefined" == typeof console
                    ? b
                    : function (a) {
                          console.error(a);
                      },
            i = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            j = i.length,
            k = !1;
        return f;
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", b) : "object" == typeof module && module.exports ? (module.exports = b()) : (a.matchesSelector = b());
    })(window, function () {
        "use strict";
        var a = (function () {
            var a = window.Element.prototype;
            if (a.matches) return "matches";
            if (a.matchesSelector) return "matchesSelector";
            for (var b = ["webkit", "moz", "ms", "o"], c = 0; c < b.length; c++) {
                var d = b[c],
                    e = d + "MatchesSelector";
                if (a[e]) return e;
            }
        })();
        return function (b, c) {
            return b[a](c);
        };
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (c) {
                  return b(a, c);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("desandro-matches-selector")))
            : (a.fizzyUIUtils = b(a, a.matchesSelector));
    })(window, function (a, b) {
        var c = {};
        (c.extend = function (a, b) {
            for (var c in b) a[c] = b[c];
            return a;
        }),
            (c.modulo = function (a, b) {
                return ((a % b) + b) % b;
            });
        var d = Array.prototype.slice;
        (c.makeArray = function (a) {
            if (Array.isArray(a)) return a;
            if (null === a || void 0 === a) return [];
            var b = "object" == typeof a && "number" == typeof a.length;
            return b ? d.call(a) : [a];
        }),
            (c.removeFrom = function (a, b) {
                var c = a.indexOf(b);
                c != -1 && a.splice(c, 1);
            }),
            (c.getParent = function (a, c) {
                for (; a.parentNode && a != document.body; ) if (((a = a.parentNode), b(a, c))) return a;
            }),
            (c.getQueryElement = function (a) {
                return "string" == typeof a ? document.querySelector(a) : a;
            }),
            (c.handleEvent = function (a) {
                var b = "on" + a.type;
                this[b] && this[b](a);
            }),
            (c.filterFindElements = function (a, d) {
                a = c.makeArray(a);
                var e = [];
                return (
                    a.forEach(function (a) {
                        if (a instanceof HTMLElement) {
                            if (!d) return void e.push(a);
                            b(a, d) && e.push(a);
                            for (var c = a.querySelectorAll(d), f = 0; f < c.length; f++) e.push(c[f]);
                        }
                    }),
                    e
                );
            }),
            (c.debounceMethod = function (a, b, c) {
                c = c || 100;
                var d = a.prototype[b],
                    e = b + "Timeout";
                a.prototype[b] = function () {
                    var a = this[e];
                    clearTimeout(a);
                    var b = arguments,
                        f = this;
                    this[e] = setTimeout(function () {
                        d.apply(f, b), delete f[e];
                    }, c);
                };
            }),
            (c.docReady = function (a) {
                var b = document.readyState;
                "complete" == b || "interactive" == b ? setTimeout(a) : document.addEventListener("DOMContentLoaded", a);
            }),
            (c.toDashed = function (a) {
                return a
                    .replace(/(.)([A-Z])/g, function (a, b, c) {
                        return b + "-" + c;
                    })
                    .toLowerCase();
            });
        var e = a.console;
        return (
            (c.htmlInit = function (b, d) {
                c.docReady(function () {
                    var f = c.toDashed(d),
                        g = "data-" + f,
                        h = document.querySelectorAll("[" + g + "]"),
                        i = document.querySelectorAll(".js-" + f),
                        j = c.makeArray(h).concat(c.makeArray(i)),
                        k = g + "-options",
                        l = a.jQuery;
                    j.forEach(function (a) {
                        var c,
                            f = a.getAttribute(g) || a.getAttribute(k);
                        try {
                            c = f && JSON.parse(f);
                        } catch (h) {
                            return void (e && e.error("Error parsing " + g + " on " + a.className + ": " + h));
                        }
                        var i = new b(a, c);
                        l && l.data(a, d, i);
                    });
                });
            }),
            c
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("flickity/js/cell", ["get-size/get-size"], function (c) {
                  return b(a, c);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("get-size")))
            : ((a.Flickity = a.Flickity || {}), (a.Flickity.Cell = b(a, a.getSize)));
    })(window, function (a, b) {
        function c(a, b) {
            (this.element = a), (this.parent = b), this.create();
        }
        var d = c.prototype;
        return (
            (d.create = function () {
                (this.element.style.position = "absolute"), this.element.setAttribute("aria-selected", "false"), (this.x = 0), (this.shift = 0);
            }),
            (d.destroy = function () {
                this.element.style.position = "";
                var a = this.parent.originSide;
                this.element.removeAttribute("aria-selected"), (this.element.style[a] = "");
            }),
            (d.getSize = function () {
                this.size = b(this.element);
            }),
            (d.setPosition = function (a) {
                (this.x = a), this.updateTarget(), this.renderPosition(a);
            }),
            (d.updateTarget = d.setDefaultTarget = function () {
                var a = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
                this.target = this.x + this.size[a] + this.size.width * this.parent.cellAlign;
            }),
            (d.renderPosition = function (a) {
                var b = this.parent.originSide;
                this.element.style[b] = this.parent.getPositionValue(a);
            }),
            (d.wrapShift = function (a) {
                (this.shift = a), this.renderPosition(this.x + this.parent.slideableWidth * a);
            }),
            (d.remove = function () {
                this.element.parentNode.removeChild(this.element);
            }),
            c
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd ? define("flickity/js/slide", b) : "object" == typeof module && module.exports ? (module.exports = b()) : ((a.Flickity = a.Flickity || {}), (a.Flickity.Slide = b()));
    })(window, function () {
        "use strict";
        function a(a) {
            (this.parent = a), (this.isOriginLeft = "left" == a.originSide), (this.cells = []), (this.outerWidth = 0), (this.height = 0);
        }
        var b = a.prototype;
        return (
            (b.addCell = function (a) {
                if ((this.cells.push(a), (this.outerWidth += a.size.outerWidth), (this.height = Math.max(a.size.outerHeight, this.height)), 1 == this.cells.length)) {
                    this.x = a.x;
                    var b = this.isOriginLeft ? "marginLeft" : "marginRight";
                    this.firstMargin = a.size[b];
                }
            }),
            (b.updateTarget = function () {
                var a = this.isOriginLeft ? "marginRight" : "marginLeft",
                    b = this.getLastCell(),
                    c = b ? b.size[a] : 0,
                    d = this.outerWidth - (this.firstMargin + c);
                this.target = this.x + this.firstMargin + d * this.parent.cellAlign;
            }),
            (b.getLastCell = function () {
                return this.cells[this.cells.length - 1];
            }),
            (b.select = function () {
                this.changeSelected(!0);
            }),
            (b.unselect = function () {
                this.changeSelected(!1);
            }),
            (b.changeSelected = function (a) {
                var b = a ? "add" : "remove";
                this.cells.forEach(function (c) {
                    c.element.classList[b]("is-selected"), c.element.setAttribute("aria-selected", a.toString());
                });
            }),
            (b.getCellElements = function () {
                return this.cells.map(function (a) {
                    return a.element;
                });
            }),
            a
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function (c) {
                  return b(a, c);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("fizzy-ui-utils")))
            : ((a.Flickity = a.Flickity || {}), (a.Flickity.animatePrototype = b(a, a.fizzyUIUtils)));
    })(window, function (a, b) {
        var c = {};
        return (
            (c.startAnimation = function () {
                this.isAnimating || ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
            }),
            (c.animate = function () {
                this.applyDragForce(), this.applySelectedAttraction();
                var a = this.x;
                if ((this.integratePhysics(), this.positionSlider(), this.settle(a), this.isAnimating)) {
                    var b = this;
                    requestAnimationFrame(function () {
                        b.animate();
                    });
                }
            }),
            (c.positionSlider = function () {
                var a = this.x;
                this.options.wrapAround && this.cells.length > 1 && ((a = b.modulo(a, this.slideableWidth)), (a -= this.slideableWidth), this.shiftWrapCells(a)), (a += this.cursorPosition), (a = this.options.rightToLeft ? -a : a);
                var c = this.getPositionValue(a);
                this.slider.style.transform = this.isAnimating ? "translate3d(" + c + ",0,0)" : "translateX(" + c + ")";
                var d = this.slides[0];
                if (d) {
                    var e = -this.x - d.target,
                        f = e / this.slidesWidth;
                    this.dispatchEvent("scroll", null, [f, e]);
                }
            }),
            (c.positionSliderAtSelected = function () {
                this.cells.length && ((this.x = -this.selectedSlide.target), (this.velocity = 0), this.positionSlider());
            }),
            (c.getPositionValue = function (a) {
                return this.options.percentPosition ? 0.01 * Math.round((a / this.size.innerWidth) * 1e4) + "%" : Math.round(a) + "px";
            }),
            (c.settle = function (a) {
                this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * a) || this.restingFrames++,
                    this.restingFrames > 2 && ((this.isAnimating = !1), delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]));
            }),
            (c.shiftWrapCells = function (a) {
                var b = this.cursorPosition + a;
                this._shiftCells(this.beforeShiftCells, b, -1);
                var c = this.size.innerWidth - (a + this.slideableWidth + this.cursorPosition);
                this._shiftCells(this.afterShiftCells, c, 1);
            }),
            (c._shiftCells = function (a, b, c) {
                for (var d = 0; d < a.length; d++) {
                    var e = a[d],
                        f = b > 0 ? c : 0;
                    e.wrapShift(f), (b -= e.size.outerWidth);
                }
            }),
            (c._unshiftCells = function (a) {
                if (a && a.length) for (var b = 0; b < a.length; b++) a[b].wrapShift(0);
            }),
            (c.integratePhysics = function () {
                (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
            }),
            (c.applyForce = function (a) {
                this.velocity += a;
            }),
            (c.getFrictionFactor = function () {
                return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
            }),
            (c.getRestingPosition = function () {
                return this.x + this.velocity / (1 - this.getFrictionFactor());
            }),
            (c.applyDragForce = function () {
                if (this.isDraggable && this.isPointerDown) {
                    var a = this.dragX - this.x,
                        b = a - this.velocity;
                    this.applyForce(b);
                }
            }),
            (c.applySelectedAttraction = function () {
                var a = this.isDraggable && this.isPointerDown;
                if (!a && !this.isFreeScrolling && this.slides.length) {
                    var b = this.selectedSlide.target * -1 - this.x,
                        c = b * this.options.selectedAttraction;
                    this.applyForce(c);
                }
            }),
            c
        );
    }),
    (function (a, b) {
        if ("function" == typeof define && define.amd)
            define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function (c, d, e, f, g, h) {
                return b(a, c, d, e, f, g, h);
            });
        else if ("object" == typeof module && module.exports) module.exports = b(a, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
        else {
            var c = a.Flickity;
            a.Flickity = b(a, a.EvEmitter, a.getSize, a.fizzyUIUtils, c.Cell, c.Slide, c.animatePrototype);
        }
    })(window, function (a, b, c, d, e, f, g) {
        function h(a, b) {
            for (a = d.makeArray(a); a.length; ) b.appendChild(a.shift());
        }
        function i(a, b) {
            var c = d.getQueryElement(a);
            if (!c) return void (l && l.error("Bad element for Flickity: " + (c || a)));
            if (((this.element = c), this.element.flickityGUID)) {
                var e = n[this.element.flickityGUID];
                return e.option(b), e;
            }
            j && (this.$element = j(this.element)), (this.options = d.extend({}, this.constructor.defaults)), this.option(b), this._create();
        }
        var j = a.jQuery,
            k = a.getComputedStyle,
            l = a.console,
            m = 0,
            n = {};
        (i.defaults = { accessibility: !0, cellAlign: "center", freeScrollFriction: 0.075, friction: 0.28, namespaceJQueryEvents: !0, percentPosition: !0, resize: !0, selectedAttraction: 0.025, setGallerySize: !0 }), (i.createMethods = []);
        var o = i.prototype;
        d.extend(o, b.prototype),
            (o._create = function () {
                var b = (this.guid = ++m);
                (this.element.flickityGUID = b),
                    (n[b] = this),
                    (this.selectedIndex = 0),
                    (this.restingFrames = 0),
                    (this.x = 0),
                    (this.velocity = 0),
                    (this.originSide = this.options.rightToLeft ? "right" : "left"),
                    (this.viewport = document.createElement("div")),
                    (this.viewport.className = "flickity-viewport"),
                    this._createSlider(),
                    (this.options.resize || this.options.watchCSS) && a.addEventListener("resize", this);
                for (var c in this.options.on) {
                    var d = this.options.on[c];
                    this.on(c, d);
                }
                i.createMethods.forEach(function (a) {
                    this[a]();
                }, this),
                    this.options.watchCSS ? this.watchCSS() : this.activate();
            }),
            (o.option = function (a) {
                d.extend(this.options, a);
            }),
            (o.activate = function () {
                if (!this.isActive) {
                    (this.isActive = !0), this.element.classList.add("flickity-enabled"), this.options.rightToLeft && this.element.classList.add("flickity-rtl"), this.getSize();
                    var a = this._filterFindCellElements(this.element.children);
                    h(a, this.slider),
                        this.viewport.appendChild(this.slider),
                        this.element.appendChild(this.viewport),
                        this.reloadCells(),
                        this.options.accessibility && ((this.element.tabIndex = 0), this.element.addEventListener("keydown", this)),
                        this.emitEvent("activate");
                    var b,
                        c = this.options.initialIndex;
                    (b = this.isInitActivated ? this.selectedIndex : void 0 !== c && this.cells[c] ? c : 0), this.select(b, !1, !0), (this.isInitActivated = !0), this.dispatchEvent("ready");
                }
            }),
            (o._createSlider = function () {
                var a = document.createElement("div");
                (a.className = "flickity-slider"), (a.style[this.originSide] = 0), (this.slider = a);
            }),
            (o._filterFindCellElements = function (a) {
                return d.filterFindElements(a, this.options.cellSelector);
            }),
            (o.reloadCells = function () {
                (this.cells = this._makeCells(this.slider.children)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize();
            }),
            (o._makeCells = function (a) {
                var b = this._filterFindCellElements(a),
                    c = b.map(function (a) {
                        return new e(a, this);
                    }, this);
                return c;
            }),
            (o.getLastCell = function () {
                return this.cells[this.cells.length - 1];
            }),
            (o.getLastSlide = function () {
                return this.slides[this.slides.length - 1];
            }),
            (o.positionCells = function () {
                this._sizeCells(this.cells), this._positionCells(0);
            }),
            (o._positionCells = function (a) {
                (a = a || 0), (this.maxCellHeight = a ? this.maxCellHeight || 0 : 0);
                var b = 0;
                if (a > 0) {
                    var c = this.cells[a - 1];
                    b = c.x + c.size.outerWidth;
                }
                for (var d = this.cells.length, e = a; e < d; e++) {
                    var f = this.cells[e];
                    f.setPosition(b), (b += f.size.outerWidth), (this.maxCellHeight = Math.max(f.size.outerHeight, this.maxCellHeight));
                }
                (this.slideableWidth = b), this.updateSlides(), this._containSlides(), (this.slidesWidth = d ? this.getLastSlide().target - this.slides[0].target : 0);
            }),
            (o._sizeCells = function (a) {
                a.forEach(function (a) {
                    a.getSize();
                });
            }),
            (o.updateSlides = function () {
                if (((this.slides = []), this.cells.length)) {
                    var a = new f(this);
                    this.slides.push(a);
                    var b = "left" == this.originSide,
                        c = b ? "marginRight" : "marginLeft",
                        d = this._getCanCellFit();
                    this.cells.forEach(function (b, e) {
                        if (!a.cells.length) return void a.addCell(b);
                        var g = a.outerWidth - a.firstMargin + (b.size.outerWidth - b.size[c]);
                        d.call(this, e, g) ? a.addCell(b) : (a.updateTarget(), (a = new f(this)), this.slides.push(a), a.addCell(b));
                    }, this),
                        a.updateTarget(),
                        this.updateSelectedSlide();
                }
            }),
            (o._getCanCellFit = function () {
                var a = this.options.groupCells;
                if (!a)
                    return function () {
                        return !1;
                    };
                if ("number" == typeof a) {
                    var b = parseInt(a, 10);
                    return function (a) {
                        return a % b !== 0;
                    };
                }
                var c = "string" == typeof a && a.match(/^(\d+)%$/),
                    d = c ? parseInt(c[1], 10) / 100 : 1;
                return function (a, b) {
                    return b <= (this.size.innerWidth + 1) * d;
                };
            }),
            (o._init = o.reposition = function () {
                this.positionCells(), this.positionSliderAtSelected();
            }),
            (o.getSize = function () {
                (this.size = c(this.element)), this.setCellAlign(), (this.cursorPosition = this.size.innerWidth * this.cellAlign);
            });
        var p = { center: { left: 0.5, right: 0.5 }, left: { left: 0, right: 1 }, right: { right: 0, left: 1 } };
        return (
            (o.setCellAlign = function () {
                var a = p[this.options.cellAlign];
                this.cellAlign = a ? a[this.originSide] : this.options.cellAlign;
            }),
            (o.setGallerySize = function () {
                if (this.options.setGallerySize) {
                    var a = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                    this.viewport.style.height = a + "px";
                }
            }),
            (o._getWrapShiftCells = function () {
                if (this.options.wrapAround) {
                    this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                    var a = this.cursorPosition,
                        b = this.cells.length - 1;
                    (this.beforeShiftCells = this._getGapCells(a, b, -1)), (a = this.size.innerWidth - this.cursorPosition), (this.afterShiftCells = this._getGapCells(a, 0, 1));
                }
            }),
            (o._getGapCells = function (a, b, c) {
                for (var d = []; a > 0; ) {
                    var e = this.cells[b];
                    if (!e) break;
                    d.push(e), (b += c), (a -= e.size.outerWidth);
                }
                return d;
            }),
            (o._containSlides = function () {
                if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                    var a = this.options.rightToLeft,
                        b = a ? "marginRight" : "marginLeft",
                        c = a ? "marginLeft" : "marginRight",
                        d = this.slideableWidth - this.getLastCell().size[c],
                        e = d < this.size.innerWidth,
                        f = this.cursorPosition + this.cells[0].size[b],
                        g = d - this.size.innerWidth * (1 - this.cellAlign);
                    this.slides.forEach(function (a) {
                        e ? (a.target = d * this.cellAlign) : ((a.target = Math.max(a.target, f)), (a.target = Math.min(a.target, g)));
                    }, this);
                }
            }),
            (o.dispatchEvent = function (a, b, c) {
                var d = b ? [b].concat(c) : c;
                if ((this.emitEvent(a, d), j && this.$element)) {
                    a += this.options.namespaceJQueryEvents ? ".flickity" : "";
                    var e = a;
                    if (b) {
                        var f = j.Event(b);
                        (f.type = a), (e = f);
                    }
                    this.$element.trigger(e, c);
                }
            }),
            (o.select = function (a, b, c) {
                if (this.isActive && ((a = parseInt(a, 10)), this._wrapSelect(a), (this.options.wrapAround || b) && (a = d.modulo(a, this.slides.length)), this.slides[a])) {
                    var e = this.selectedIndex;
                    (this.selectedIndex = a),
                        this.updateSelectedSlide(),
                        c ? this.positionSliderAtSelected() : this.startAnimation(),
                        this.options.adaptiveHeight && this.setGallerySize(),
                        this.dispatchEvent("select", null, [a]),
                        a != e && this.dispatchEvent("change", null, [a]),
                        this.dispatchEvent("cellSelect");
                }
            }),
            (o._wrapSelect = function (a) {
                var b = this.slides.length,
                    c = this.options.wrapAround && b > 1;
                if (!c) return a;
                var e = d.modulo(a, b),
                    f = Math.abs(e - this.selectedIndex),
                    g = Math.abs(e + b - this.selectedIndex),
                    h = Math.abs(e - b - this.selectedIndex);
                !this.isDragSelect && g < f ? (a += b) : !this.isDragSelect && h < f && (a -= b), a < 0 ? (this.x -= this.slideableWidth) : a >= b && (this.x += this.slideableWidth);
            }),
            (o.previous = function (a, b) {
                this.select(this.selectedIndex - 1, a, b);
            }),
            (o.next = function (a, b) {
                this.select(this.selectedIndex + 1, a, b);
            }),
            (o.updateSelectedSlide = function () {
                var a = this.slides[this.selectedIndex];
                a &&
                    (this.unselectSelectedSlide(),
                    (this.selectedSlide = a),
                    a.select(),
                    (this.selectedCells = a.cells),
                    (this.selectedElements = a.getCellElements()),
                    (this.selectedCell = a.cells[0]),
                    (this.selectedElement = this.selectedElements[0]));
            }),
            (o.unselectSelectedSlide = function () {
                this.selectedSlide && this.selectedSlide.unselect();
            }),
            (o.selectCell = function (a, b, c) {
                var d = this.queryCell(a);
                if (d) {
                    var e = this.getCellSlideIndex(d);
                    this.select(e, b, c);
                }
            }),
            (o.getCellSlideIndex = function (a) {
                for (var b = 0; b < this.slides.length; b++) {
                    var c = this.slides[b],
                        d = c.cells.indexOf(a);
                    if (d != -1) return b;
                }
            }),
            (o.getCell = function (a) {
                for (var b = 0; b < this.cells.length; b++) {
                    var c = this.cells[b];
                    if (c.element == a) return c;
                }
            }),
            (o.getCells = function (a) {
                a = d.makeArray(a);
                var b = [];
                return (
                    a.forEach(function (a) {
                        var c = this.getCell(a);
                        c && b.push(c);
                    }, this),
                    b
                );
            }),
            (o.getCellElements = function () {
                return this.cells.map(function (a) {
                    return a.element;
                });
            }),
            (o.getParentCell = function (a) {
                var b = this.getCell(a);
                return b ? b : ((a = d.getParent(a, ".flickity-slider > *")), this.getCell(a));
            }),
            (o.getAdjacentCellElements = function (a, b) {
                if (!a) return this.selectedSlide.getCellElements();
                b = void 0 === b ? this.selectedIndex : b;
                var c = this.slides.length;
                if (1 + 2 * a >= c) return this.getCellElements();
                for (var e = [], f = b - a; f <= b + a; f++) {
                    var g = this.options.wrapAround ? d.modulo(f, c) : f,
                        h = this.slides[g];
                    h && (e = e.concat(h.getCellElements()));
                }
                return e;
            }),
            (o.queryCell = function (a) {
                return "number" == typeof a ? this.cells[a] : ("string" == typeof a && (a = this.element.querySelector(a)), this.getCell(a));
            }),
            (o.uiChange = function () {
                this.emitEvent("uiChange");
            }),
            (o.childUIPointerDown = function (a) {
                this.emitEvent("childUIPointerDown", [a]);
            }),
            (o.onresize = function () {
                this.watchCSS(), this.resize();
            }),
            d.debounceMethod(i, "onresize", 150),
            (o.resize = function () {
                if (this.isActive) {
                    this.getSize(), this.options.wrapAround && (this.x = d.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
                    var a = this.selectedElements && this.selectedElements[0];
                    this.selectCell(a, !1, !0);
                }
            }),
            (o.watchCSS = function () {
                var a = this.options.watchCSS;
                if (a) {
                    var b = k(this.element, ":after").content;
                    b.indexOf("flickity") != -1 ? this.activate() : this.deactivate();
                }
            }),
            (o.onkeydown = function (a) {
                var b = document.activeElement && document.activeElement != this.element;
                if (this.options.accessibility && !b) {
                    var c = i.keyboardHandlers[a.keyCode];
                    c && c.call(this);
                }
            }),
            (i.keyboardHandlers = {
                37: function () {
                    var a = this.options.rightToLeft ? "next" : "previous";
                    this.uiChange(), this[a]();
                },
                39: function () {
                    var a = this.options.rightToLeft ? "previous" : "next";
                    this.uiChange(), this[a]();
                },
            }),
            (o.focus = function () {
                var b = a.pageYOffset;
                this.element.focus(), a.pageYOffset != b && a.scrollTo(a.pageXOffset, b);
            }),
            (o.deactivate = function () {
                this.isActive &&
                    (this.element.classList.remove("flickity-enabled"),
                    this.element.classList.remove("flickity-rtl"),
                    this.unselectSelectedSlide(),
                    this.cells.forEach(function (a) {
                        a.destroy();
                    }),
                    this.element.removeChild(this.viewport),
                    h(this.slider.children, this.element),
                    this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)),
                    (this.isActive = !1),
                    this.emitEvent("deactivate"));
            }),
            (o.destroy = function () {
                this.deactivate(), a.removeEventListener("resize", this), this.emitEvent("destroy"), j && this.$element && j.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete n[this.guid];
            }),
            d.extend(o, g),
            (i.data = function (a) {
                a = d.getQueryElement(a);
                var b = a && a.flickityGUID;
                return b && n[b];
            }),
            d.htmlInit(i, "flickity"),
            j && j.bridget && j.bridget("flickity", i),
            (i.setJQuery = function (a) {
                j = a;
            }),
            (i.Cell = e),
            i
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function (c) {
                  return b(a, c);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("ev-emitter")))
            : (a.Unipointer = b(a, a.EvEmitter));
    })(window, function (a, b) {
        function c() {}
        function d() {}
        var e = (d.prototype = Object.create(b.prototype));
        (e.bindStartEvent = function (a) {
            this._bindStartEvent(a, !0);
        }),
            (e.unbindStartEvent = function (a) {
                this._bindStartEvent(a, !1);
            }),
            (e._bindStartEvent = function (b, c) {
                c = void 0 === c || c;
                var d = c ? "addEventListener" : "removeEventListener",
                    e = "mousedown";
                a.PointerEvent ? (e = "pointerdown") : "ontouchstart" in a && (e = "touchstart"), b[d](e, this);
            }),
            (e.handleEvent = function (a) {
                var b = "on" + a.type;
                this[b] && this[b](a);
            }),
            (e.getTouch = function (a) {
                for (var b = 0; b < a.length; b++) {
                    var c = a[b];
                    if (c.identifier == this.pointerIdentifier) return c;
                }
            }),
            (e.onmousedown = function (a) {
                var b = a.button;
                (b && 0 !== b && 1 !== b) || this._pointerDown(a, a);
            }),
            (e.ontouchstart = function (a) {
                this._pointerDown(a, a.changedTouches[0]);
            }),
            (e.onpointerdown = function (a) {
                this._pointerDown(a, a);
            }),
            (e._pointerDown = function (a, b) {
                a.button || this.isPointerDown || ((this.isPointerDown = !0), (this.pointerIdentifier = void 0 !== b.pointerId ? b.pointerId : b.identifier), this.pointerDown(a, b));
            }),
            (e.pointerDown = function (a, b) {
                this._bindPostStartEvents(a), this.emitEvent("pointerDown", [a, b]);
            });
        var f = { mousedown: ["mousemove", "mouseup"], touchstart: ["touchmove", "touchend", "touchcancel"], pointerdown: ["pointermove", "pointerup", "pointercancel"] };
        return (
            (e._bindPostStartEvents = function (b) {
                if (b) {
                    var c = f[b.type];
                    c.forEach(function (b) {
                        a.addEventListener(b, this);
                    }, this),
                        (this._boundPointerEvents = c);
                }
            }),
            (e._unbindPostStartEvents = function () {
                this._boundPointerEvents &&
                    (this._boundPointerEvents.forEach(function (b) {
                        a.removeEventListener(b, this);
                    }, this),
                    delete this._boundPointerEvents);
            }),
            (e.onmousemove = function (a) {
                this._pointerMove(a, a);
            }),
            (e.onpointermove = function (a) {
                a.pointerId == this.pointerIdentifier && this._pointerMove(a, a);
            }),
            (e.ontouchmove = function (a) {
                var b = this.getTouch(a.changedTouches);
                b && this._pointerMove(a, b);
            }),
            (e._pointerMove = function (a, b) {
                this.pointerMove(a, b);
            }),
            (e.pointerMove = function (a, b) {
                this.emitEvent("pointerMove", [a, b]);
            }),
            (e.onmouseup = function (a) {
                this._pointerUp(a, a);
            }),
            (e.onpointerup = function (a) {
                a.pointerId == this.pointerIdentifier && this._pointerUp(a, a);
            }),
            (e.ontouchend = function (a) {
                var b = this.getTouch(a.changedTouches);
                b && this._pointerUp(a, b);
            }),
            (e._pointerUp = function (a, b) {
                this._pointerDone(), this.pointerUp(a, b);
            }),
            (e.pointerUp = function (a, b) {
                this.emitEvent("pointerUp", [a, b]);
            }),
            (e._pointerDone = function () {
                this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone();
            }),
            (e._pointerReset = function () {
                (this.isPointerDown = !1), delete this.pointerIdentifier;
            }),
            (e.pointerDone = c),
            (e.onpointercancel = function (a) {
                a.pointerId == this.pointerIdentifier && this._pointerCancel(a, a);
            }),
            (e.ontouchcancel = function (a) {
                var b = this.getTouch(a.changedTouches);
                b && this._pointerCancel(a, b);
            }),
            (e._pointerCancel = function (a, b) {
                this._pointerDone(), this.pointerCancel(a, b);
            }),
            (e.pointerCancel = function (a, b) {
                this.emitEvent("pointerCancel", [a, b]);
            }),
            (d.getPointerPoint = function (a) {
                return { x: a.pageX, y: a.pageY };
            }),
            d
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("unidragger/unidragger", ["unipointer/unipointer"], function (c) {
                  return b(a, c);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("unipointer")))
            : (a.Unidragger = b(a, a.Unipointer));
    })(window, function (a, b) {
        function c() {}
        var d = (c.prototype = Object.create(b.prototype));
        (d.bindHandles = function () {
            this._bindHandles(!0);
        }),
            (d.unbindHandles = function () {
                this._bindHandles(!1);
            }),
            (d._bindHandles = function (b) {
                b = void 0 === b || b;
                for (var c = b ? "addEventListener" : "removeEventListener", d = b ? this._touchActionValue : "", e = 0; e < this.handles.length; e++) {
                    var f = this.handles[e];
                    this._bindStartEvent(f, b), f[c]("click", this), a.PointerEvent && (f.style.touchAction = d);
                }
            }),
            (d._touchActionValue = "none"),
            (d.pointerDown = function (a, b) {
                var c = this.okayPointerDown(a);
                c && ((this.pointerDownPointer = b), a.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(a), this.emitEvent("pointerDown", [a, b]));
            });
        var e = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
            f = { radio: !0, checkbox: !0, button: !0, submit: !0, image: !0, file: !0 };
        return (
            (d.okayPointerDown = function (a) {
                var b = e[a.target.nodeName],
                    c = f[a.target.type],
                    d = !b || c;
                return d || this._pointerReset(), d;
            }),
            (d.pointerDownBlur = function () {
                var a = document.activeElement,
                    b = a && a.blur && a != document.body;
                b && a.blur();
            }),
            (d.pointerMove = function (a, b) {
                var c = this._dragPointerMove(a, b);
                this.emitEvent("pointerMove", [a, b, c]), this._dragMove(a, b, c);
            }),
            (d._dragPointerMove = function (a, b) {
                var c = { x: b.pageX - this.pointerDownPointer.pageX, y: b.pageY - this.pointerDownPointer.pageY };
                return !this.isDragging && this.hasDragStarted(c) && this._dragStart(a, b), c;
            }),
            (d.hasDragStarted = function (a) {
                return Math.abs(a.x) > 3 || Math.abs(a.y) > 3;
            }),
            (d.pointerUp = function (a, b) {
                this.emitEvent("pointerUp", [a, b]), this._dragPointerUp(a, b);
            }),
            (d._dragPointerUp = function (a, b) {
                this.isDragging ? this._dragEnd(a, b) : this._staticClick(a, b);
            }),
            (d._dragStart = function (a, b) {
                (this.isDragging = !0), (this.isPreventingClicks = !0), this.dragStart(a, b);
            }),
            (d.dragStart = function (a, b) {
                this.emitEvent("dragStart", [a, b]);
            }),
            (d._dragMove = function (a, b, c) {
                this.isDragging && this.dragMove(a, b, c);
            }),
            (d.dragMove = function (a, b, c) {
                a.preventDefault(), this.emitEvent("dragMove", [a, b, c]);
            }),
            (d._dragEnd = function (a, b) {
                (this.isDragging = !1),
                    setTimeout(
                        function () {
                            delete this.isPreventingClicks;
                        }.bind(this)
                    ),
                    this.dragEnd(a, b);
            }),
            (d.dragEnd = function (a, b) {
                this.emitEvent("dragEnd", [a, b]);
            }),
            (d.onclick = function (a) {
                this.isPreventingClicks && a.preventDefault();
            }),
            (d._staticClick = function (a, b) {
                (this.isIgnoringMouseUp && "mouseup" == a.type) ||
                    (this.staticClick(a, b),
                    "mouseup" != a.type &&
                        ((this.isIgnoringMouseUp = !0),
                        setTimeout(
                            function () {
                                delete this.isIgnoringMouseUp;
                            }.bind(this),
                            400
                        )));
            }),
            (d.staticClick = function (a, b) {
                this.emitEvent("staticClick", [a, b]);
            }),
            (c.getPointerPoint = b.getPointerPoint),
            c
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function (c, d, e) {
                  return b(a, c, d, e);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")))
            : (a.Flickity = b(a, a.Flickity, a.Unidragger, a.fizzyUIUtils));
    })(window, function (a, b, c, d) {
        function e() {
            return { x: a.pageXOffset, y: a.pageYOffset };
        }
        d.extend(b.defaults, { draggable: ">1", dragThreshold: 3 }), b.createMethods.push("_createDrag");
        var f = b.prototype;
        d.extend(f, c.prototype), (f._touchActionValue = "pan-y");
        var g = "createTouch" in document,
            h = !1;
        (f._createDrag = function () {
            this.on("activate", this.onActivateDrag),
                this.on("uiChange", this._uiChangeDrag),
                this.on("childUIPointerDown", this._childUIPointerDownDrag),
                this.on("deactivate", this.unbindDrag),
                this.on("cellChange", this.updateDraggable),
                g && !h && (a.addEventListener("touchmove", function () {}), (h = !0));
        }),
            (f.onActivateDrag = function () {
                (this.handles = [this.viewport]), this.bindHandles(), this.updateDraggable();
            }),
            (f.onDeactivateDrag = function () {
                this.unbindHandles(), this.element.classList.remove("is-draggable");
            }),
            (f.updateDraggable = function () {
                ">1" == this.options.draggable ? (this.isDraggable = this.slides.length > 1) : (this.isDraggable = this.options.draggable),
                    this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable");
            }),
            (f.bindDrag = function () {
                (this.options.draggable = !0), this.updateDraggable();
            }),
            (f.unbindDrag = function () {
                (this.options.draggable = !1), this.updateDraggable();
            }),
            (f._uiChangeDrag = function () {
                delete this.isFreeScrolling;
            }),
            (f._childUIPointerDownDrag = function (a) {
                a.preventDefault(), this.pointerDownFocus(a);
            }),
            (f.pointerDown = function (b, c) {
                if (!this.isDraggable) return void this._pointerDownDefault(b, c);
                var d = this.okayPointerDown(b);
                d &&
                    (this._pointerDownPreventDefault(b),
                    this.pointerDownFocus(b),
                    document.activeElement != this.element && this.pointerDownBlur(),
                    (this.dragX = this.x),
                    this.viewport.classList.add("is-pointer-down"),
                    (this.pointerDownScroll = e()),
                    a.addEventListener("scroll", this),
                    this._pointerDownDefault(b, c));
            }),
            (f._pointerDownDefault = function (a, b) {
                (this.pointerDownPointer = b), this._bindPostStartEvents(a), this.dispatchEvent("pointerDown", a, [b]);
            });
        var i = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
        return (
            (f.pointerDownFocus = function (a) {
                var b = i[a.target.nodeName];
                b || this.focus();
            }),
            (f._pointerDownPreventDefault = function (a) {
                var b = "touchstart" == a.type,
                    c = "touch" == a.pointerType,
                    d = i[a.target.nodeName];
                b || c || d || a.preventDefault();
            }),
            (f.hasDragStarted = function (a) {
                return Math.abs(a.x) > this.options.dragThreshold;
            }),
            (f.pointerUp = function (a, b) {
                delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", a, [b]), this._dragPointerUp(a, b);
            }),
            (f.pointerDone = function () {
                a.removeEventListener("scroll", this), delete this.pointerDownScroll;
            }),
            (f.dragStart = function (b, c) {
                this.isDraggable && ((this.dragStartPosition = this.x), this.startAnimation(), a.removeEventListener("scroll", this), this.dispatchEvent("dragStart", b, [c]));
            }),
            (f.pointerMove = function (a, b) {
                var c = this._dragPointerMove(a, b);
                this.dispatchEvent("pointerMove", a, [b, c]), this._dragMove(a, b, c);
            }),
            (f.dragMove = function (a, b, c) {
                if (this.isDraggable) {
                    a.preventDefault(), (this.previousDragX = this.dragX);
                    var d = this.options.rightToLeft ? -1 : 1;
                    this.options.wrapAround && (c.x = c.x % this.slideableWidth);
                    var e = this.dragStartPosition + c.x * d;
                    if (!this.options.wrapAround && this.slides.length) {
                        var f = Math.max(-this.slides[0].target, this.dragStartPosition);
                        e = e > f ? 0.5 * (e + f) : e;
                        var g = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                        e = e < g ? 0.5 * (e + g) : e;
                    }
                    (this.dragX = e), (this.dragMoveTime = new Date()), this.dispatchEvent("dragMove", a, [b, c]);
                }
            }),
            (f.dragEnd = function (a, b) {
                if (this.isDraggable) {
                    this.options.freeScroll && (this.isFreeScrolling = !0);
                    var c = this.dragEndRestingSelect();
                    if (this.options.freeScroll && !this.options.wrapAround) {
                        var d = this.getRestingPosition();
                        this.isFreeScrolling = -d > this.slides[0].target && -d < this.getLastSlide().target;
                    } else this.options.freeScroll || c != this.selectedIndex || (c += this.dragEndBoostSelect());
                    delete this.previousDragX, (this.isDragSelect = this.options.wrapAround), this.select(c), delete this.isDragSelect, this.dispatchEvent("dragEnd", a, [b]);
                }
            }),
            (f.dragEndRestingSelect = function () {
                var a = this.getRestingPosition(),
                    b = Math.abs(this.getSlideDistance(-a, this.selectedIndex)),
                    c = this._getClosestResting(a, b, 1),
                    d = this._getClosestResting(a, b, -1),
                    e = c.distance < d.distance ? c.index : d.index;
                return e;
            }),
            (f._getClosestResting = function (a, b, c) {
                for (
                    var d = this.selectedIndex,
                        e = 1 / 0,
                        f =
                            this.options.contain && !this.options.wrapAround
                                ? function (a, b) {
                                      return a <= b;
                                  }
                                : function (a, b) {
                                      return a < b;
                                  };
                    f(b, e) && ((d += c), (e = b), (b = this.getSlideDistance(-a, d)), null !== b);

                )
                    b = Math.abs(b);
                return { distance: e, index: d - c };
            }),
            (f.getSlideDistance = function (a, b) {
                var c = this.slides.length,
                    e = this.options.wrapAround && c > 1,
                    f = e ? d.modulo(b, c) : b,
                    g = this.slides[f];
                if (!g) return null;
                var h = e ? this.slideableWidth * Math.floor(b / c) : 0;
                return a - (g.target + h);
            }),
            (f.dragEndBoostSelect = function () {
                if (void 0 === this.previousDragX || !this.dragMoveTime || new Date() - this.dragMoveTime > 100) return 0;
                var a = this.getSlideDistance(-this.dragX, this.selectedIndex),
                    b = this.previousDragX - this.dragX;
                return a > 0 && b > 0 ? 1 : a < 0 && b < 0 ? -1 : 0;
            }),
            (f.staticClick = function (a, b) {
                var c = this.getParentCell(a.target),
                    d = c && c.element,
                    e = c && this.cells.indexOf(c);
                this.dispatchEvent("staticClick", a, [b, d, e]);
            }),
            (f.onscroll = function () {
                var a = e(),
                    b = this.pointerDownScroll.x - a.x,
                    c = this.pointerDownScroll.y - a.y;
                (Math.abs(b) > 3 || Math.abs(c) > 3) && this._pointerDone();
            }),
            b
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("tap-listener/tap-listener", ["unipointer/unipointer"], function (c) {
                  return b(a, c);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("unipointer")))
            : (a.TapListener = b(a, a.Unipointer));
    })(window, function (a, b) {
        function c(a) {
            this.bindTap(a);
        }
        var d = (c.prototype = Object.create(b.prototype));
        return (
            (d.bindTap = function (a) {
                a && (this.unbindTap(), (this.tapElement = a), this._bindStartEvent(a, !0));
            }),
            (d.unbindTap = function () {
                this.tapElement && (this._bindStartEvent(this.tapElement, !0), delete this.tapElement);
            }),
            (d.pointerUp = function (c, d) {
                if (!this.isIgnoringMouseUp || "mouseup" != c.type) {
                    var e = b.getPointerPoint(d),
                        f = this.tapElement.getBoundingClientRect(),
                        g = a.pageXOffset,
                        h = a.pageYOffset,
                        i = e.x >= f.left + g && e.x <= f.right + g && e.y >= f.top + h && e.y <= f.bottom + h;
                    if ((i && this.emitEvent("tap", [c, d]), "mouseup" != c.type)) {
                        this.isIgnoringMouseUp = !0;
                        var j = this;
                        setTimeout(function () {
                            delete j.isIgnoringMouseUp;
                        }, 400);
                    }
                }
            }),
            (d.destroy = function () {
                this.pointerDone(), this.unbindTap();
            }),
            c
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("flickity/js/prev-next-button", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function (c, d, e) {
                  return b(a, c, d, e);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")))
            : b(a, a.Flickity, a.TapListener, a.fizzyUIUtils);
    })(window, function (a, b, c, d) {
        "use strict";
        function e(a, b) {
            (this.direction = a), (this.parent = b), this._create();
        }
        function f(a) {
            return "string" == typeof a ? a : "M " + a.x0 + ",50 L " + a.x1 + "," + (a.y1 + 50) + " L " + a.x2 + "," + (a.y2 + 50) + " L " + a.x3 + ",50  L " + a.x2 + "," + (50 - a.y2) + " L " + a.x1 + "," + (50 - a.y1) + " Z";
        }
        var g = "http://www.w3.org/2000/svg";
        (e.prototype = Object.create(c.prototype)),
            (e.prototype._create = function () {
                (this.isEnabled = !0), (this.isPrevious = this.direction == -1);
                var a = this.parent.options.rightToLeft ? 1 : -1;
                this.isLeft = this.direction == a;
                var b = (this.element = document.createElement("button"));
                (b.className = "flickity-button flickity-prev-next-button"),
                    (b.className += this.isPrevious ? " previous" : " next"),
                    b.setAttribute("type", "button"),
                    this.disable(),
                    b.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
                var c = this.createSVG();
                b.appendChild(c), this.on("tap", this.onTap), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
            }),
            (e.prototype.activate = function () {
                this.bindTap(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element);
            }),
            (e.prototype.deactivate = function () {
                this.parent.element.removeChild(this.element), c.prototype.destroy.call(this), this.element.removeEventListener("click", this);
            }),
            (e.prototype.createSVG = function () {
                var a = document.createElementNS(g, "svg");
                a.setAttribute("class", "flickity-button-icon"), a.setAttribute("viewBox", "0 0 100 100");
                var b = document.createElementNS(g, "path"),
                    c = f(this.parent.options.arrowShape);
                return b.setAttribute("d", c), b.setAttribute("class", "arrow"), this.isLeft || b.setAttribute("transform", "translate(100, 100) rotate(180) "), a.appendChild(b), a;
            }),
            (e.prototype.onTap = function () {
                if (this.isEnabled) {
                    this.parent.uiChange();
                    var a = this.isPrevious ? "previous" : "next";
                    this.parent[a]();
                }
            }),
            (e.prototype.handleEvent = d.handleEvent),
            (e.prototype.onclick = function (a) {
                var b = document.activeElement;
                b && b == this.element && this.onTap(a, a);
            }),
            (e.prototype.enable = function () {
                this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0));
            }),
            (e.prototype.disable = function () {
                this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1));
            }),
            (e.prototype.update = function () {
                var a = this.parent.slides;
                if (this.parent.options.wrapAround && a.length > 1) return void this.enable();
                var b = a.length ? a.length - 1 : 0,
                    c = this.isPrevious ? 0 : b,
                    d = this.parent.selectedIndex == c ? "disable" : "enable";
                this[d]();
            }),
            (e.prototype.destroy = function () {
                this.deactivate();
            }),
            d.extend(b.defaults, { prevNextButtons: !0, arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 } }),
            b.createMethods.push("_createPrevNextButtons");
        var h = b.prototype;
        return (
            (h._createPrevNextButtons = function () {
                this.options.prevNextButtons && ((this.prevButton = new e(-1, this)), (this.nextButton = new e(1, this)), this.on("activate", this.activatePrevNextButtons));
            }),
            (h.activatePrevNextButtons = function () {
                this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons);
            }),
            (h.deactivatePrevNextButtons = function () {
                this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons);
            }),
            (b.PrevNextButton = e),
            b
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("flickity/js/page-dots", ["./flickity", "tap-listener/tap-listener", "fizzy-ui-utils/utils"], function (c, d, e) {
                  return b(a, c, d, e);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("./flickity"), require("tap-listener"), require("fizzy-ui-utils")))
            : b(a, a.Flickity, a.TapListener, a.fizzyUIUtils);
    })(window, function (a, b, c, d) {
        function e(a) {
            (this.parent = a), this._create();
        }
        (e.prototype = new c()),
            (e.prototype._create = function () {
                (this.holder = document.createElement("ol")), (this.holder.className = "flickity-page-dots"), (this.dots = []), this.on("tap", this.onTap), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
            }),
            (e.prototype.activate = function () {
                this.setDots(), this.bindTap(this.holder), this.parent.element.appendChild(this.holder);
            }),
            (e.prototype.deactivate = function () {
                this.parent.element.removeChild(this.holder), c.prototype.destroy.call(this);
            }),
            (e.prototype.setDots = function () {
                var a = this.parent.slides.length - this.dots.length;
                a > 0 ? this.addDots(a) : a < 0 && this.removeDots(-a);
            }),
            (e.prototype.addDots = function (a) {
                for (var b = document.createDocumentFragment(), c = [], d = this.dots.length, e = d + a, f = d; f < e; f++) {
                    var g = document.createElement("li");
                    (g.className = "dot"), g.setAttribute("aria-label", "Page dot " + (f + 1)), b.appendChild(g), c.push(g);
                }
                this.holder.appendChild(b), (this.dots = this.dots.concat(c));
            }),
            (e.prototype.removeDots = function (a) {
                var b = this.dots.splice(this.dots.length - a, a);
                b.forEach(function (a) {
                    this.holder.removeChild(a);
                }, this);
            }),
            (e.prototype.updateSelected = function () {
                this.selectedDot && ((this.selectedDot.className = "dot"), this.selectedDot.removeAttribute("aria-current")),
                    this.dots.length && ((this.selectedDot = this.dots[this.parent.selectedIndex]), (this.selectedDot.className = "dot is-selected"), this.selectedDot.setAttribute("aria-current", "step"));
            }),
            (e.prototype.onTap = function (a) {
                var b = a.target;
                if ("LI" == b.nodeName) {
                    this.parent.uiChange();
                    var c = this.dots.indexOf(b);
                    this.parent.select(c);
                }
            }),
            (e.prototype.destroy = function () {
                this.deactivate();
            }),
            (b.PageDots = e),
            d.extend(b.defaults, { pageDots: !0 }),
            b.createMethods.push("_createPageDots");
        var f = b.prototype;
        return (
            (f._createPageDots = function () {
                this.options.pageDots &&
                    ((this.pageDots = new e(this)),
                    this.on("activate", this.activatePageDots),
                    this.on("select", this.updateSelectedPageDots),
                    this.on("cellChange", this.updatePageDots),
                    this.on("resize", this.updatePageDots),
                    this.on("deactivate", this.deactivatePageDots));
            }),
            (f.activatePageDots = function () {
                this.pageDots.activate();
            }),
            (f.updateSelectedPageDots = function () {
                this.pageDots.updateSelected();
            }),
            (f.updatePageDots = function () {
                this.pageDots.setDots();
            }),
            (f.deactivatePageDots = function () {
                this.pageDots.deactivate();
            }),
            (b.PageDots = e),
            b
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], function (a, c, d) {
                  return b(a, c, d);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")))
            : b(a.EvEmitter, a.fizzyUIUtils, a.Flickity);
    })(window, function (a, b, c) {
        function d(a) {
            (this.parent = a), (this.state = "stopped"), (this.onVisibilityChange = this.visibilityChange.bind(this)), (this.onVisibilityPlay = this.visibilityPlay.bind(this));
        }
        (d.prototype = Object.create(a.prototype)),
            (d.prototype.play = function () {
                if ("playing" != this.state) {
                    var a = document.hidden;
                    if (a) return void document.addEventListener("visibilitychange", this.onVisibilityPlay);
                    (this.state = "playing"), document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick();
                }
            }),
            (d.prototype.tick = function () {
                if ("playing" == this.state) {
                    var a = this.parent.options.autoPlay;
                    a = "number" == typeof a ? a : 3e3;
                    var b = this;
                    this.clear(),
                        (this.timeout = setTimeout(function () {
                            b.parent.next(!0), b.tick();
                        }, a));
                }
            }),
            (d.prototype.stop = function () {
                (this.state = "stopped"), this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange);
            }),
            (d.prototype.clear = function () {
                clearTimeout(this.timeout);
            }),
            (d.prototype.pause = function () {
                "playing" == this.state && ((this.state = "paused"), this.clear());
            }),
            (d.prototype.unpause = function () {
                "paused" == this.state && this.play();
            }),
            (d.prototype.visibilityChange = function () {
                var a = document.hidden;
                this[a ? "pause" : "unpause"]();
            }),
            (d.prototype.visibilityPlay = function () {
                this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay);
            }),
            b.extend(c.defaults, { pauseAutoPlayOnHover: !0 }),
            c.createMethods.push("_createPlayer");
        var e = c.prototype;
        return (
            (e._createPlayer = function () {
                (this.player = new d(this)), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer);
            }),
            (e.activatePlayer = function () {
                this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this));
            }),
            (e.playPlayer = function () {
                this.player.play();
            }),
            (e.stopPlayer = function () {
                this.player.stop();
            }),
            (e.pausePlayer = function () {
                this.player.pause();
            }),
            (e.unpausePlayer = function () {
                this.player.unpause();
            }),
            (e.deactivatePlayer = function () {
                this.player.stop(), this.element.removeEventListener("mouseenter", this);
            }),
            (e.onmouseenter = function () {
                this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this));
            }),
            (e.onmouseleave = function () {
                this.player.unpause(), this.element.removeEventListener("mouseleave", this);
            }),
            (c.Player = d),
            c
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function (c, d) {
                  return b(a, c, d);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("./flickity"), require("fizzy-ui-utils")))
            : b(a, a.Flickity, a.fizzyUIUtils);
    })(window, function (a, b, c) {
        function d(a) {
            var b = document.createDocumentFragment();
            return (
                a.forEach(function (a) {
                    b.appendChild(a.element);
                }),
                b
            );
        }
        var e = b.prototype;
        return (
            (e.insert = function (a, b) {
                var c = this._makeCells(a);
                if (c && c.length) {
                    var e = this.cells.length;
                    b = void 0 === b ? e : b;
                    var f = d(c),
                        g = b == e;
                    if (g) this.slider.appendChild(f);
                    else {
                        var h = this.cells[b].element;
                        this.slider.insertBefore(f, h);
                    }
                    if (0 === b) this.cells = c.concat(this.cells);
                    else if (g) this.cells = this.cells.concat(c);
                    else {
                        var i = this.cells.splice(b, e - b);
                        this.cells = this.cells.concat(c).concat(i);
                    }
                    this._sizeCells(c), this.cellChange(b, !0);
                }
            }),
            (e.append = function (a) {
                this.insert(a, this.cells.length);
            }),
            (e.prepend = function (a) {
                this.insert(a, 0);
            }),
            (e.remove = function (a) {
                var b = this.getCells(a);
                if (b && b.length) {
                    var d = this.cells.length - 1;
                    b.forEach(function (a) {
                        a.remove();
                        var b = this.cells.indexOf(a);
                        (d = Math.min(b, d)), c.removeFrom(this.cells, a);
                    }, this),
                        this.cellChange(d, !0);
                }
            }),
            (e.cellSizeChange = function (a) {
                var b = this.getCell(a);
                if (b) {
                    b.getSize();
                    var c = this.cells.indexOf(b);
                    this.cellChange(c);
                }
            }),
            (e.cellChange = function (a, b) {
                var c = this.selectedElement;
                this._positionCells(a), this._getWrapShiftCells(), this.setGallerySize();
                var d = this.getCell(c);
                d && (this.selectedIndex = this.getCellSlideIndex(d)),
                    (this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex)),
                    this.emitEvent("cellChange", [a]),
                    this.select(this.selectedIndex),
                    b && this.positionSliderAtSelected();
            }),
            b
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("flickity/js/lazyload", ["./flickity", "fizzy-ui-utils/utils"], function (c, d) {
                  return b(a, c, d);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("./flickity"), require("fizzy-ui-utils")))
            : b(a, a.Flickity, a.fizzyUIUtils);
    })(window, function (a, b, c) {
        "use strict";
        function d(a) {
            if ("IMG" == a.nodeName) {
                var b = a.getAttribute("data-flickity-lazyload"),
                    d = a.getAttribute("data-flickity-lazyload-src"),
                    e = a.getAttribute("data-flickity-lazyload-srcset");
                if (b || d || e) return [a];
            }
            var f = "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",
                g = a.querySelectorAll(f);
            return c.makeArray(g);
        }
        function e(a, b) {
            (this.img = a), (this.flickity = b), this.load();
        }
        b.createMethods.push("_createLazyload");
        var f = b.prototype;
        return (
            (f._createLazyload = function () {
                this.on("select", this.lazyLoad);
            }),
            (f.lazyLoad = function () {
                var a = this.options.lazyLoad;
                if (a) {
                    var b = "number" == typeof a ? a : 0,
                        c = this.getAdjacentCellElements(b),
                        f = [];
                    c.forEach(function (a) {
                        var b = d(a);
                        f = f.concat(b);
                    }),
                        f.forEach(function (a) {
                            new e(a, this);
                        }, this);
                }
            }),
            (e.prototype.handleEvent = c.handleEvent),
            (e.prototype.load = function () {
                this.img.addEventListener("load", this), this.img.addEventListener("error", this);
                var a = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"),
                    b = this.img.getAttribute("data-flickity-lazyload-srcset");
                (this.img.src = a),
                    b && this.img.setAttribute("srcset", b),
                    this.img.removeAttribute("data-flickity-lazyload"),
                    this.img.removeAttribute("data-flickity-lazyload-src"),
                    this.img.removeAttribute("data-flickity-lazyload-srcset");
            }),
            (e.prototype.onload = function (a) {
                this.complete(a, "flickity-lazyloaded");
            }),
            (e.prototype.onerror = function (a) {
                this.complete(a, "flickity-lazyerror");
            }),
            (e.prototype.complete = function (a, b) {
                this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                var c = this.flickity.getParentCell(this.img),
                    d = c && c.element;
                this.flickity.cellSizeChange(d), this.img.classList.add(b), this.flickity.dispatchEvent("lazyLoad", a, d);
            }),
            (b.LazyLoader = e),
            b
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], b)
            : "object" == typeof module &&
              module.exports &&
              (module.exports = b(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")));
    })(window, function (a) {
        return a;
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("flickity-as-nav-for/as-nav-for", ["flickity/js/index", "fizzy-ui-utils/utils"], b)
            : "object" == typeof module && module.exports
            ? (module.exports = b(require("flickity"), require("fizzy-ui-utils")))
            : (a.Flickity = b(a.Flickity, a.fizzyUIUtils));
    })(window, function (a, b) {
        function c(a, b, c) {
            return (b - a) * c + a;
        }
        a.createMethods.push("_createAsNavFor");
        var d = a.prototype;
        return (
            (d._createAsNavFor = function () {
                this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), this.on("destroy", this.destroyAsNavFor);
                var a = this.options.asNavFor;
                if (a) {
                    var b = this;
                    setTimeout(function () {
                        b.setNavCompanion(a);
                    });
                }
            }),
            (d.setNavCompanion = function (c) {
                c = b.getQueryElement(c);
                var d = a.data(c);
                if (d && d != this) {
                    this.navCompanion = d;
                    var e = this;
                    (this.onNavCompanionSelect = function () {
                        e.navCompanionSelect();
                    }),
                        d.on("select", this.onNavCompanionSelect),
                        this.on("staticClick", this.onNavStaticClick),
                        this.navCompanionSelect(!0);
                }
            }),
            (d.navCompanionSelect = function (a) {
                if (this.navCompanion) {
                    var b = this.navCompanion.selectedCells[0],
                        d = this.navCompanion.cells.indexOf(b),
                        e = d + this.navCompanion.selectedCells.length - 1,
                        f = Math.floor(c(d, e, this.navCompanion.cellAlign));
                    if ((this.selectCell(f, !1, a), this.removeNavSelectedElements(), !(f >= this.cells.length))) {
                        var g = this.cells.slice(d, e + 1);
                        (this.navSelectedElements = g.map(function (a) {
                            return a.element;
                        })),
                            this.changeNavSelectedClass("add");
                    }
                }
            }),
            (d.changeNavSelectedClass = function (a) {
                this.navSelectedElements.forEach(function (b) {
                    b.classList[a]("is-nav-selected");
                });
            }),
            (d.activateAsNavFor = function () {
                this.navCompanionSelect(!0);
            }),
            (d.removeNavSelectedElements = function () {
                this.navSelectedElements && (this.changeNavSelectedClass("remove"), delete this.navSelectedElements);
            }),
            (d.onNavStaticClick = function (a, b, c, d) {
                "number" == typeof d && this.navCompanion.selectCell(d);
            }),
            (d.deactivateAsNavFor = function () {
                this.removeNavSelectedElements();
            }),
            (d.destroyAsNavFor = function () {
                this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect), this.off("staticClick", this.onNavStaticClick), delete this.navCompanion);
            }),
            a
        );
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("imagesloaded/imagesloaded", ["ev-emitter/ev-emitter"], function (c) {
                  return b(a, c);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("ev-emitter")))
            : (a.imagesLoaded = b(a, a.EvEmitter));
    })("undefined" != typeof window ? window : this, function (a, b) {
        function c(a, b) {
            for (var c in b) a[c] = b[c];
            return a;
        }
        function d(a) {
            if (Array.isArray(a)) return a;
            var b = "object" == typeof a && "number" == typeof a.length;
            return b ? j.call(a) : [a];
        }
        function e(a, b, f) {
            if (!(this instanceof e)) return new e(a, b, f);
            var g = a;
            return (
                "string" == typeof a && (g = document.querySelectorAll(a)),
                g
                    ? ((this.elements = d(g)),
                      (this.options = c({}, this.options)),
                      "function" == typeof b ? (f = b) : c(this.options, b),
                      f && this.on("always", f),
                      this.getImages(),
                      h && (this.jqDeferred = new h.Deferred()),
                      void setTimeout(this.check.bind(this)))
                    : void i.error("Bad element for imagesLoaded " + (g || a))
            );
        }
        function f(a) {
            this.img = a;
        }
        function g(a, b) {
            (this.url = a), (this.element = b), (this.img = new Image());
        }
        var h = a.jQuery,
            i = a.console,
            j = Array.prototype.slice;
        (e.prototype = Object.create(b.prototype)),
            (e.prototype.options = {}),
            (e.prototype.getImages = function () {
                (this.images = []), this.elements.forEach(this.addElementImages, this);
            }),
            (e.prototype.addElementImages = function (a) {
                "IMG" == a.nodeName && this.addImage(a), this.options.background === !0 && this.addElementBackgroundImages(a);
                var b = a.nodeType;
                if (b && k[b]) {
                    for (var c = a.querySelectorAll("img"), d = 0; d < c.length; d++) {
                        var e = c[d];
                        this.addImage(e);
                    }
                    if ("string" == typeof this.options.background) {
                        var f = a.querySelectorAll(this.options.background);
                        for (d = 0; d < f.length; d++) {
                            var g = f[d];
                            this.addElementBackgroundImages(g);
                        }
                    }
                }
            });
        var k = { 1: !0, 9: !0, 11: !0 };
        return (
            (e.prototype.addElementBackgroundImages = function (a) {
                var b = getComputedStyle(a);
                if (b)
                    for (var c = /url\((['"])?(.*?)\1\)/gi, d = c.exec(b.backgroundImage); null !== d; ) {
                        var e = d && d[2];
                        e && this.addBackground(e, a), (d = c.exec(b.backgroundImage));
                    }
            }),
            (e.prototype.addImage = function (a) {
                var b = new f(a);
                this.images.push(b);
            }),
            (e.prototype.addBackground = function (a, b) {
                var c = new g(a, b);
                this.images.push(c);
            }),
            (e.prototype.check = function () {
                function a(a, c, d) {
                    setTimeout(function () {
                        b.progress(a, c, d);
                    });
                }
                var b = this;
                return (
                    (this.progressedCount = 0),
                    (this.hasAnyBroken = !1),
                    this.images.length
                        ? void this.images.forEach(function (b) {
                              b.once("progress", a), b.check();
                          })
                        : void this.complete()
                );
            }),
            (e.prototype.progress = function (a, b, c) {
                this.progressedCount++,
                    (this.hasAnyBroken = this.hasAnyBroken || !a.isLoaded),
                    this.emitEvent("progress", [this, a, b]),
                    this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, a),
                    this.progressedCount == this.images.length && this.complete(),
                    this.options.debug && i && i.log("progress: " + c, a, b);
            }),
            (e.prototype.complete = function () {
                var a = this.hasAnyBroken ? "fail" : "done";
                if (((this.isComplete = !0), this.emitEvent(a, [this]), this.emitEvent("always", [this]), this.jqDeferred)) {
                    var b = this.hasAnyBroken ? "reject" : "resolve";
                    this.jqDeferred[b](this);
                }
            }),
            (f.prototype = Object.create(b.prototype)),
            (f.prototype.check = function () {
                var a = this.getIsImageComplete();
                return a
                    ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
                    : ((this.proxyImage = new Image()),
                      this.proxyImage.addEventListener("load", this),
                      this.proxyImage.addEventListener("error", this),
                      this.img.addEventListener("load", this),
                      this.img.addEventListener("error", this),
                      void (this.proxyImage.src = this.img.src));
            }),
            (f.prototype.getIsImageComplete = function () {
                return this.img.complete && this.img.naturalWidth;
            }),
            (f.prototype.confirm = function (a, b) {
                (this.isLoaded = a), this.emitEvent("progress", [this, this.img, b]);
            }),
            (f.prototype.handleEvent = function (a) {
                var b = "on" + a.type;
                this[b] && this[b](a);
            }),
            (f.prototype.onload = function () {
                this.confirm(!0, "onload"), this.unbindEvents();
            }),
            (f.prototype.onerror = function () {
                this.confirm(!1, "onerror"), this.unbindEvents();
            }),
            (f.prototype.unbindEvents = function () {
                this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            }),
            (g.prototype = Object.create(f.prototype)),
            (g.prototype.check = function () {
                this.img.addEventListener("load", this), this.img.addEventListener("error", this), (this.img.src = this.url);
                var a = this.getIsImageComplete();
                a && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
            }),
            (g.prototype.unbindEvents = function () {
                this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            }),
            (g.prototype.confirm = function (a, b) {
                (this.isLoaded = a), this.emitEvent("progress", [this, this.element, b]);
            }),
            (e.makeJQueryPlugin = function (b) {
                (b = b || a.jQuery),
                    b &&
                        ((h = b),
                        (h.fn.imagesLoaded = function (a, b) {
                            var c = new e(this, a, b);
                            return c.jqDeferred.promise(h(this));
                        }));
            }),
            e.makeJQueryPlugin(),
            e
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define(["flickity/js/index", "imagesloaded/imagesloaded"], function (c, d) {
                  return b(a, c, d);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("flickity"), require("imagesloaded")))
            : (a.Flickity = b(a, a.Flickity, a.imagesLoaded));
    })(window, function (a, b, c) {
        "use strict";
        b.createMethods.push("_createImagesLoaded");
        var d = b.prototype;
        return (
            (d._createImagesLoaded = function () {
                this.on("activate", this.imagesLoaded);
            }),
            (d.imagesLoaded = function () {
                function a(a, c) {
                    var d = b.getParentCell(c.img);
                    b.cellSizeChange(d && d.element), b.options.freeScroll || b.positionSliderAtSelected();
                }
                if (this.options.imagesLoaded) {
                    var b = this;
                    c(this.slider).on("progress", a);
                }
            }),
            b
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define(["flickity/js/index", "fizzy-ui-utils/utils"], b)
            : "object" == typeof module && module.exports
            ? (module.exports = b(require("flickity"), require("fizzy-ui-utils")))
            : (a.Flickity = b(a.Flickity, a.fizzyUIUtils));
    })(window, function (a, b) {
        "use strict";
        return (
            a.createMethods.push("_createSync"),
            (a.prototype._createSync = function () {
                this.syncers = {};
                var a = this.options.sync;
                if ((this.on("destroy", this.unsyncAll), a)) {
                    var b = this;
                    setTimeout(function () {
                        b.sync(a);
                    });
                }
            }),
            (a.prototype.sync = function (c) {
                c = b.getQueryElement(c);
                var d = a.data(c);
                d && (this._syncCompanion(d), d._syncCompanion(this));
            }),
            (a.prototype._syncCompanion = function (a) {
                function b() {
                    var b = c.selectedIndex;
                    a.selectedIndex != b && a.select(b);
                }
                var c = this;
                this.on("select", b), (this.syncers[a.guid] = { flickity: a, listener: b });
            }),
            (a.prototype.unsync = function (c) {
                c = b.getQueryElement(c);
                var d = a.data(c);
                this._unsync(d);
            }),
            (a.prototype._unsync = function (a) {
                a && (this._unsyncCompanion(a), a._unsyncCompanion(this));
            }),
            (a.prototype._unsyncCompanion = function (a) {
                var b = a.guid,
                    c = this.syncers[b];
                this.off("select", c.listener), delete this.syncers[b];
            }),
            (a.prototype.unsyncAll = function () {
                for (var a in this.syncers) {
                    var b = this.syncers[a];
                    this._unsync(b.flickity);
                }
            }),
            a
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define(["flickity/js/index", "fizzy-ui-utils/utils"], b)
            : "object" == typeof module && module.exports
            ? (module.exports = b(require("flickity"), require("fizzy-ui-utils")))
            : (a.Flickity = b(a.Flickity, a.fizzyUIUtils));
    })(window, function (a, b) {
        "use strict";
        (a.defaults.mimic = { indexOffset: 0 }), a.createMethods.push("_mimic");
        var c = a.prototype;
        return (
            (c._mimic = function () {
                this.on("activate", this.activateMimic), this.on("destroy", this.destroyMimic);
                var a = this.options.mimic;
                if (a.target && !this.options.groupCells) {
                    var b = this;
                    setTimeout(function () {
                        b.setCompanion(a.target);
                    });
                }
            }),
            (c.setCompanion = function (c) {
                c = b.getQueryElement(c);
                var d = a.data(c);
                if (d && d != this && d.cells.length === this.cells.length && !d.options.groupCells) {
                    this.companion = d;
                    var e = this;
                    (this.onCompanionSelect = function () {
                        e.companionSelect();
                    }),
                        d.on("select", this.onCompanionSelect),
                        (this.onCompanionScroll = function () {
                            e.companionScroll.apply(e, arguments);
                        }),
                        d.on("scroll", this.onCompanionScroll),
                        this.companionSelect(!0);
                }
            }),
            (c.companionSelect = function (a) {
                if (this.companion) {
                    var b = this.companion.cells.length,
                        c = this.companion.selectedIndex,
                        d = c + this.options.mimic.indexOffset;
                    d < 0 ? (d += b) : d > b - 1 && (d = b - d), this.selectCell(d, !1, a);
                }
            }),
            (c.companionScroll = function (a, b) {
                var c = ((this.companion.selectedCell.target - (b + this.companion.cursorPosition)) / this.companion.size.innerWidth) * 100;
                (this.x = -this.selectedCell.target + (this.size.innerWidth / 100) * c), (this.isAnimating = !1), (this.velocity = 0), this.positionSlider();
            }),
            (c.activateMimic = function () {
                this.companionSelect(!0);
            }),
            (c.destroyMimic = function () {
                this.companion && (this.companion.off("select", this.onCompanionSelect), this.companion.off("scroll", this.onCompanionScroll), delete this.companion);
            }),
            a
        );
    }),
    (function (a) {
        var b = a(window),
            c = function (b) {
                if (b.valAttr("error-msg-container")) return a(b.valAttr("error-msg-container"));
                var c = b.parent();
                if (!c.hasClass("form-group") && !c.closest("form").hasClass("form-horizontal")) {
                    var d = c.closest(".form-group");
                    if (d.length) return d.eq(0);
                }
                return c;
            },
            d = function (a, b) {
                a.addClass(b.errorElementClass).removeClass("valid"), c(a).addClass(b.inputParentClassOnError).removeClass(b.inputParentClassOnSuccess), "" !== b.borderColorOnError && a.css("border-color", b.borderColorOnError);
            },
            e = function (b, d) {
                b.each(function () {
                    var b = a(this);
                    f(b, "", d, d.errorMessagePosition),
                        b.removeClass("valid").removeClass(d.errorElementClass).css("border-color", ""),
                        c(b)
                            .removeClass(d.inputParentClassOnError)
                            .removeClass(d.inputParentClassOnSuccess)
                            .find("." + d.errorMessageClass)
                            .remove();
                });
            },
            f = function (d, e, f, h) {
                var i = document.getElementById(d.attr("name") + "_err_msg"),
                    j = function (a) {
                        b.trigger("validationErrorDisplay", [d, a]), a.html(e);
                    },
                    k = {};
                if ((i ? (g("Using deprecated element reference " + i.id), (h = a(i))) : "function" == typeof h && (h = h(d, e, f)), "object" == typeof h)) {
                    var l = !1;
                    h.find("." + f.errorMessageClass).each(function () {
                        if (this.inputReferer === d[0]) return (l = a(this)), !1;
                    }),
                        l ? (e ? j(l) : l.remove()) : ((k = a('<div class="' + f.errorMessageClass + '"></div>')), j(k), (k[0].inputReferer = d[0]), h.prepend(k));
                } else {
                    var m = c(d);
                    (k = m.find("." + f.errorMessageClass + ".help-block")), 0 === k.length && ((k = a("<span></span>").addClass("help-block").addClass(f.errorMessageClass)), k.appendTo(m)), j(k);
                }
            },
            g = function (a) {
                "console" in window ? ("function" == typeof window.console.warn ? window.console.warn(a) : "function" == typeof window.console.log && window.console.log(a)) : alert(a);
            },
            h = function (b, c, d, e) {
                var f,
                    g = e.errorMessageTemplate.messages.replace(/\{errorTitle\}/g, c),
                    h = [];
                a.each(d, function (a, b) {
                    h.push(e.errorMessageTemplate.field.replace(/\{msg\}/g, b));
                }),
                    (g = g.replace(/\{fields\}/g, h.join(""))),
                    (f = e.errorMessageTemplate.container.replace(/\{errorMessageClass\}/g, e.errorMessageClass)),
                    (f = f.replace(/\{messages\}/g, g)),
                    b.children().eq(0).before(f);
            };
        (a.fn.validateOnBlur = function (b, c) {
            return (
                this.find("*[data-validation]").bind("blur.validation", function () {
                    a(this).validateInputOnBlur(b, c, !0, "blur");
                }),
                c.validateCheckboxRadioOnClick &&
                    this.find("input[type=checkbox][data-validation],input[type=radio][data-validation]").bind("click.validation", function () {
                        a(this).validateInputOnBlur(b, c, !0, "click");
                    }),
                this
            );
        }),
            (a.fn.validateOnEvent = function (b, c) {
                return (
                    this.find("*[data-validation-event]").each(function () {
                        var d = a(this),
                            e = d.valAttr("event");
                        e &&
                            d.unbind(e + ".validation").bind(e + ".validation", function (d) {
                                9 !== (d || {}).keyCode && a(this).validateInputOnBlur(b, c, !0, e);
                            });
                    }),
                    this
                );
            });
        var i = 0;
        (a.fn.showHelpOnFocus = function (b) {
            return (
                b || (b = "data-validation-help"),
                this.find(".has-help-txt").valAttr("has-keyup-event", !1).removeClass("has-help-txt"),
                this.find("textarea,input").each(function () {
                    var c = a(this),
                        d = "jquery_form_help_" + ++i,
                        e = c.attr(b);
                    e &&
                        c
                            .addClass("has-help-txt")
                            .unbind("focus.help")
                            .bind("focus.help", function () {
                                var b = c.parent().find("." + d);
                                0 === b.length && ((b = a("<span />").addClass(d).addClass("help").addClass("help-block").text(e).hide()), c.after(b)), b.fadeIn();
                            })
                            .unbind("blur.help")
                            .bind("blur.help", function () {
                                a(this)
                                    .parent()
                                    .find("." + d)
                                    .fadeOut("slow");
                            });
                }),
                this
            );
        }),
            (a.fn.validate = function (b, c, d) {
                var e = a.extend({}, a.formUtils.LANG, d || {});
                this.each(function () {
                    var d = a(this),
                        f = d.closest("form").get(0).validationConfig || {};
                    d.one("validation", function (a, c) {
                        "function" == typeof b && b(c, this, a);
                    }),
                        d.validateInputOnBlur(e, a.extend({}, f, c || {}), !0);
                });
            }),
            (a.fn.willPostponeValidation = function () {
                return (this.valAttr("suggestion-nr") || this.valAttr("postpone") || this.hasClass("hasDatepicker")) && !window.postponedValidation;
            }),
            (a.fn.validateInputOnBlur = function (b, g, h, i) {
                if (((a.formUtils.eventType = i), this.willPostponeValidation())) {
                    var j = this,
                        k = this.valAttr("postpone") || 200;
                    return (
                        (window.postponedValidation = function () {
                            j.validateInputOnBlur(b, g, h, i), (window.postponedValidation = !1);
                        }),
                        setTimeout(function () {
                            window.postponedValidation && window.postponedValidation();
                        }, k),
                        this
                    );
                }
                (b = a.extend({}, a.formUtils.LANG, b || {})), e(this, g);
                var l = this,
                    m = l.closest("form"),
                    n = a.formUtils.validateInput(l, b, g, m, i);
                return n.isValid ? n.shouldChangeDisplay && (l.addClass("valid"), c(l).addClass(g.inputParentClassOnSuccess)) : n.isValid || (d(l, g), f(l, n.errorMsg, g, g.errorMessagePosition)), this;
            }),
            (a.fn.valAttr = function (a, b) {
                return void 0 === b ? this.attr("data-validation-" + a) : b === !1 || null === b ? this.removeAttr("data-validation-" + a) : ((a = a.length > 0 ? "-" + a : ""), this.attr("data-validation" + a, b));
            }),
            (a.fn.isValid = function (i, j, k) {
                if (a.formUtils.isLoadingModules) {
                    var l = this;
                    return (
                        setTimeout(function () {
                            l.isValid(i, j, k);
                        }, 200),
                        null
                    );
                }
                (j = a.extend({}, a.formUtils.defaultConfig(), j || {})),
                    (i = a.extend({}, a.formUtils.LANG, i || {})),
                    (k = k !== !1),
                    a.formUtils.errorDisplayPreventedWhenHalted && (delete a.formUtils.errorDisplayPreventedWhenHalted, (k = !1)),
                    (a.formUtils.isValidatingEntireForm = !0),
                    (a.formUtils.haltValidation = !1);
                var m = function (b, c) {
                        a.inArray(b, o) < 0 && o.push(b), p.push(c), c.attr("current-error", b), k && d(c, j);
                    },
                    n = [],
                    o = [],
                    p = [],
                    q = this,
                    r = function (b, c) {
                        return "submit" === c || "button" === c || "reset" === c || a.inArray(b, j.ignore || []) > -1;
                    };
                if (
                    (k && (q.find("." + j.errorMessageClass + ".alert").remove(), e(q.find("." + j.errorElementClass + ",.valid"), j)),
                    q
                        .find("input,textarea,select")
                        .filter(':not([type="submit"],[type="button"])')
                        .each(function () {
                            var b = a(this),
                                d = b.attr("type"),
                                e = "radio" === d || "checkbox" === d,
                                f = b.attr("name");
                            if (!r(f, d) && (!e || a.inArray(f, n) < 0)) {
                                e && n.push(f);
                                var g = a.formUtils.validateInput(b, i, j, q, "submit");
                                g.shouldChangeDisplay && (g.isValid ? g.isValid && (b.valAttr("current-error", !1).addClass("valid"), c(b).addClass(j.inputParentClassOnSuccess)) : m(g.errorMsg, b));
                            }
                        }),
                    "function" == typeof j.onValidate)
                ) {
                    var s = j.onValidate(q);
                    a.isArray(s)
                        ? a.each(s, function (a, b) {
                              m(b.message, b.element);
                          })
                        : s && s.element && s.message && m(s.message, s.element);
                }
                return (
                    (a.formUtils.isValidatingEntireForm = !1),
                    !a.formUtils.haltValidation && p.length > 0
                        ? (k &&
                              ("top" === j.errorMessagePosition
                                  ? h(q, i.errorTitle, o, j)
                                  : "custom" === j.errorMessagePosition
                                  ? (g("Use deprecated function errorMessageCustom"), "function" == typeof j.errorMessageCustom && j.errorMessageCustom(q, i.errorTitle, o, j))
                                  : a.each(p, function (a, b) {
                                        f(b, b.attr("current-error"), j, j.errorMessagePosition);
                                    }),
                              j.scrollToTopOnError && b.scrollTop(q.offset().top - 20)),
                          !1)
                        : (!k && a.formUtils.haltValidation && (a.formUtils.errorDisplayPreventedWhenHalted = !0), !a.formUtils.haltValidation)
                );
            }),
            (a.fn.validateForm = function (a, b) {
                return g("Use of deprecated function $.validateForm, use $.isValid instead"), this.isValid(a, b, !0);
            }),
            (a.fn.restrictLength = function (b) {
                return new a.formUtils.lengthRestriction(this, b), this;
            }),
            (a.fn.addSuggestions = function (b) {
                var c = !1;
                return (
                    this.find("input").each(function () {
                        var d = a(this);
                        (c = a.split(d.attr("data-suggestions"))), c.length > 0 && !d.hasClass("has-suggestions") && (a.formUtils.suggest(d, c, b), d.addClass("has-suggestions"));
                    }),
                    this
                );
            }),
            (a.split = function (b, c) {
                if ("function" != typeof c) {
                    if (!b) return [];
                    var d = [];
                    return (
                        a.each(b.split(c ? c : /[,|\-\s]\s*/g), function (b, c) {
                            (c = a.trim(c)), c.length && d.push(c);
                        }),
                        d
                    );
                }
                b &&
                    a.each(b.split(/[,|\-\s]\s*/g), function (b, d) {
                        if (((d = a.trim(d)), d.length)) return c(d, b);
                    });
            }),
            (a.validate = function (c) {
                var d = a.extend(a.formUtils.defaultConfig(), {
                    form: "form",
                    validateOnEvent: !1,
                    validateOnBlur: !0,
                    validateCheckboxRadioOnClick: !0,
                    showHelpOnFocus: !0,
                    addSuggestions: !0,
                    modules: "",
                    onModulesLoaded: null,
                    language: !1,
                    onSuccess: !1,
                    onError: !1,
                    onElementValidate: !1,
                });
                if (((c = a.extend(d, c || {})), c.lang && "en" !== c.lang)) {
                    var f = "lang/" + c.lang + ".js";
                    c.modules += c.modules.length ? "," + f : f;
                }
                a(c.form).each(function (d, f) {
                    f.validationConfig = c;
                    var g = a(f);
                    b.trigger("formValidationSetup", [g, c]),
                        g.trigger("formValidationSetup", [c]),
                        g.find(".has-help-txt").unbind("focus.validation").unbind("blur.validation"),
                        g.removeClass("has-validation-callback").unbind("submit.validation").unbind("reset.validation").find("input[data-validation],textarea[data-validation]").unbind("blur.validation"),
                        g
                            .bind("submit.validation", function () {
                                var b = a(this);
                                if (a.formUtils.haltValidation) return !1;
                                if (a.formUtils.isLoadingModules)
                                    return (
                                        setTimeout(function () {
                                            b.trigger("submit.validation");
                                        }, 200),
                                        !1
                                    );
                                var d = b.isValid(c.language, c);
                                if (a.formUtils.haltValidation) return !1;
                                if (!d || "function" != typeof c.onSuccess) return d || "function" != typeof c.onError ? d : (c.onError(b), !1);
                                var e = c.onSuccess(b);
                                return e !== !1 && void 0;
                            })
                            .bind("reset.validation", function () {
                                a(this)
                                    .find("." + c.errorMessageClass + ".alert")
                                    .remove(),
                                    e(a(this).find("." + c.errorElementClass + ",.valid"), c);
                            })
                            .addClass("has-validation-callback"),
                        c.showHelpOnFocus && g.showHelpOnFocus(),
                        c.addSuggestions && g.addSuggestions(),
                        c.validateOnBlur &&
                            (g.validateOnBlur(c.language, c),
                            g.bind("html5ValidationAttrsFound", function () {
                                g.validateOnBlur(c.language, c);
                            })),
                        c.validateOnEvent && g.validateOnEvent(c.language, c);
                }),
                    "" !== c.modules &&
                        a.formUtils.loadModules(c.modules, !1, function () {
                            "function" == typeof c.onModulesLoaded && c.onModulesLoaded(), b.trigger("validatorsLoaded", ["string" == typeof c.form ? a(c.form) : c.form, c]);
                        });
            }),
            (a.formUtils = {
                defaultConfig: function () {
                    return {
                        ignore: [],
                        errorElementClass: "error",
                        borderColorOnError: "#b94a48",
                        errorMessageClass: "form-error",
                        validationRuleAttribute: "data-validation",
                        validationErrorMsgAttribute: "data-validation-error-msg",
                        errorMessagePosition: "element",
                        errorMessageTemplate: { container: '<div class="{errorMessageClass} alert alert-danger">{messages}</div>', messages: "<strong>{errorTitle}</strong><ul>{fields}</ul>", field: "<li>{msg}</li>" },
                        errorMessageCustom: h,
                        scrollToTopOnError: !0,
                        dateFormat: "yyyy-mm-dd",
                        addValidClassOnAll: !1,
                        decimalSeparator: ".",
                        inputParentClassOnError: "has-error",
                        inputParentClassOnSuccess: "has-success",
                        validateHiddenInputs: !1,
                    };
                },
                validators: {},
                _events: { load: [], valid: [], invalid: [] },
                haltValidation: !1,
                isValidatingEntireForm: !1,
                addValidator: function (a) {
                    var b = 0 === a.name.indexOf("validate_") ? a.name : "validate_" + a.name;
                    void 0 === a.validateOnKeyUp && (a.validateOnKeyUp = !0), (this.validators[b] = a);
                },
                isLoadingModules: !1,
                loadedModules: {},
                loadModules: function (c, d, e) {
                    if ((void 0 === e && (e = !0), a.formUtils.isLoadingModules))
                        return void setTimeout(function () {
                            a.formUtils.loadModules(c, d, e);
                        });
                    var f = !1,
                        h = function (c, d) {
                            var h = a.split(c),
                                i = h.length,
                                j = function () {
                                    i--, 0 === i && ((a.formUtils.isLoadingModules = !1), e && f && ("function" == typeof e ? e() : b.trigger("validatorsLoaded")));
                                };
                            i > 0 && (a.formUtils.isLoadingModules = !0);
                            var k = "?_=" + new Date().getTime(),
                                l = document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0];
                            a.each(h, function (b, c) {
                                if (((c = a.trim(c)), 0 === c.length)) j();
                                else {
                                    var e = d + c + (".js" === c.slice(-3) ? "" : ".js"),
                                        h = document.createElement("SCRIPT");
                                    e in a.formUtils.loadedModules
                                        ? j()
                                        : ((a.formUtils.loadedModules[e] = 1),
                                          (f = !0),
                                          (h.type = "text/javascript"),
                                          (h.onload = j),
                                          (h.src = e + (".dev.js" === e.slice(-7) ? k : "")),
                                          (h.onerror = function () {
                                              g("Unable to load form validation module " + e);
                                          }),
                                          (h.onreadystatechange = function () {
                                              ("complete" !== this.readyState && "loaded" !== this.readyState) || (j(), (this.onload = null), (this.onreadystatechange = null));
                                          }),
                                          l.appendChild(h));
                                }
                            });
                        };
                    if (d) h(c, d);
                    else {
                        var i = function () {
                            var b = !1;
                            return (
                                a('script[src*="form-validator"]').each(function () {
                                    return (b = this.src.substr(0, this.src.lastIndexOf("/")) + "/"), "/" === b && (b = ""), !1;
                                }),
                                b !== !1 && (h(c, b), !0)
                            );
                        };
                        i() || a(i);
                    }
                },
                validateInput: function (b, c, d, e, f) {
                    b.trigger("beforeValidation"), (d = d || a.formUtils.defaultConfig()), (c = c || a.formUtils.LANG);
                    var g = b.val() || "",
                        h = { isValid: !0, shouldChangeDisplay: !0, errorMsg: "" },
                        i = b.valAttr("optional"),
                        j = !1,
                        k = !1,
                        l = !1,
                        m = b.valAttr("if-checked"),
                        n = b.valAttr("if-checked-value");
                    if (b.attr("disabled") || (!b.is(":visible") && !d.validateHiddenInputs)) return (h.shouldChangeDisplay = !1), h;
                    null != m &&
                        ((j = !0),
                        (l = e.find('input[name="' + m + '"]')),
                        null != n
                            ? l.each(function (b, c) {
                                  a(c).prop("checked") && a(c).val() === n && (k = !0);
                              })
                            : l.prop("checked") && (k = !0));
                    var o = !g && "number" === b[0].type;
                    if ((!g && "true" === i && !o) || (j && !k)) return (h.shouldChangeDisplay = d.addValidClassOnAll), h;
                    var p = b.attr(d.validationRuleAttribute),
                        q = !0;
                    if (!p) return (h.shouldChangeDisplay = d.addValidClassOnAll), h;
                    var r = b.valAttr("ignore");
                    return (
                        r &&
                            (console.log("HAS IGNORE " + g),
                            a.each(r.split(""), function (a, b) {
                                console.log(b + " -> IGNORED"), (g = g.replace(new RegExp("\\" + b, "g"), ""));
                            }),
                            console.log("AFTER IGNORE FILTER " + g)),
                        a.split(
                            p,
                            function (h) {
                                0 !== h.indexOf("validate_") && (h = "validate_" + h);
                                var i = a.formUtils.validators[h];
                                if (!i || "function" != typeof i.validatorFunction) throw new Error('Using undefined validator "' + h + '"');
                                "validate_checkbox_group" === h && (b = e.find('[name="' + b.attr("name") + '"]:eq(0)'));
                                var j = null;
                                if ((("keyup" !== f || i.validateOnKeyUp) && (j = i.validatorFunction(g, b, d, c, e)), !j))
                                    return (
                                        (q = null),
                                        null !== j &&
                                            ((q = b.attr(d.validationErrorMsgAttribute + "-" + h.replace("validate_", ""))),
                                            q || ((q = b.attr(d.validationErrorMsgAttribute)), q || ((q = "function" != typeof i.errorMessageKey ? c[i.errorMessageKey] : c[i.errorMessageKey(d)]), q || (q = i.errorMessage)))),
                                        !1
                                    );
                            },
                            " "
                        ),
                        "string" == typeof q
                            ? (b.trigger("validation", !1), (h.errorMsg = q), (h.isValid = !1), (h.shouldChangeDisplay = !0))
                            : null === q
                            ? (h.shouldChangeDisplay = d.addValidClassOnAll)
                            : (b.trigger("validation", !0), (h.shouldChangeDisplay = !0)),
                        "function" == typeof d.onElementValidate && null !== q && d.onElementValidate(h.isValid, b, e, q),
                        h
                    );
                },
                parseDate: function (b, c) {
                    var d,
                        e,
                        f,
                        g,
                        h = c.replace(/[a-zA-Z]/gi, "").substring(0, 1),
                        i = "^",
                        j = c.split(h || null);
                    if (
                        (a.each(j, function (a, b) {
                            i += (a > 0 ? "\\" + h : "") + "(\\d{" + b.length + "})";
                        }),
                        (i += "$"),
                        (d = b.match(new RegExp(i))),
                        null === d)
                    )
                        return !1;
                    var k = function (b, c, d) {
                        for (var e = 0; e < c.length; e++) if (c[e].substring(0, 1) === b) return a.formUtils.parseDateInt(d[e + 1]);
                        return -1;
                    };
                    return (
                        (f = k("m", j, d)),
                        (e = k("d", j, d)),
                        (g = k("y", j, d)),
                        !((2 === f && e > 28 && (g % 4 !== 0 || (g % 100 === 0 && g % 400 !== 0))) || (2 === f && e > 29 && (g % 4 === 0 || (g % 100 !== 0 && g % 400 === 0))) || f > 12 || 0 === f) &&
                            !((this.isShortMonth(f) && e > 30) || (!this.isShortMonth(f) && e > 31) || 0 === e) && [g, f, e]
                    );
                },
                parseDateInt: function (a) {
                    return 0 === a.indexOf("0") && (a = a.replace("0", "")), parseInt(a, 10);
                },
                isShortMonth: function (a) {
                    return (a % 2 === 0 && a < 7) || (a % 2 !== 0 && a > 7);
                },
                lengthRestriction: function (b, c) {
                    var d = parseInt(c.text(), 10),
                        e = 0,
                        f = function () {
                            var a = b.val().length;
                            if (a > d) {
                                var f = b.scrollTop();
                                b.val(b.val().substring(0, d)), b.scrollTop(f);
                            }
                            (e = d - a), e < 0 && (e = 0), c.text(e);
                        };
                    a(b)
                        .bind("keydown keyup keypress focus blur", f)
                        .bind("cut paste", function () {
                            setTimeout(f, 100);
                        }),
                        a(document).bind("ready", f);
                },
                numericRangeCheck: function (b, c) {
                    var d = a.split(c),
                        e = parseInt(c.substr(3), 10);
                    return (
                        1 === d.length && c.indexOf("min") === -1 && c.indexOf("max") === -1 && (d = [c, c]),
                        2 === d.length && (b < parseInt(d[0], 10) || b > parseInt(d[1], 10)) ? ["out", d[0], d[1]] : 0 === c.indexOf("min") && b < e ? ["min", e] : 0 === c.indexOf("max") && b > e ? ["max", e] : ["ok"]
                    );
                },
                _numSuggestionElements: 0,
                _selectedSuggestion: null,
                _previousTypedVal: null,
                suggest: function (c, d, e) {
                    var f = {
                            css: { maxHeight: "150px", background: "#FFF", lineHeight: "150%", textDecoration: "underline", overflowX: "hidden", overflowY: "auto", border: "#CCC solid 1px", borderTop: "none", cursor: "pointer" },
                            activeSuggestionCSS: { background: "#E9E9E9" },
                        },
                        g = function (a, b) {
                            var c = b.offset();
                            a.css({ width: b.outerWidth(), left: c.left + "px", top: c.top + b.outerHeight() + "px" });
                        };
                    e && a.extend(f, e),
                        (f.css.position = "absolute"),
                        (f.css["z-index"] = 9999),
                        c.attr("autocomplete", "off"),
                        0 === this._numSuggestionElements &&
                            b.bind("resize", function () {
                                a(".jquery-form-suggestions").each(function () {
                                    var b = a(this),
                                        c = b.attr("data-suggest-container");
                                    g(b, a(".suggestions-" + c).eq(0));
                                });
                            }),
                        this._numSuggestionElements++;
                    var h = function (b) {
                        var c = b.valAttr("suggestion-nr");
                        (a.formUtils._selectedSuggestion = null), (a.formUtils._previousTypedVal = null), a(".jquery-form-suggestion-" + c).fadeOut("fast");
                    };
                    return (
                        c
                            .data("suggestions", d)
                            .valAttr("suggestion-nr", this._numSuggestionElements)
                            .unbind("focus.suggest")
                            .bind("focus.suggest", function () {
                                a(this).trigger("keyup"), (a.formUtils._selectedSuggestion = null);
                            })
                            .unbind("keyup.suggest")
                            .bind("keyup.suggest", function () {
                                var b = a(this),
                                    d = [],
                                    e = a.trim(b.val()).toLocaleLowerCase();
                                if (e !== a.formUtils._previousTypedVal) {
                                    a.formUtils._previousTypedVal = e;
                                    var i = !1,
                                        j = b.valAttr("suggestion-nr"),
                                        k = a(".jquery-form-suggestion-" + j);
                                    if ((k.scrollTop(0), "" !== e)) {
                                        var l = e.length > 2;
                                        a.each(b.data("suggestions"), function (a, b) {
                                            var c = b.toLocaleLowerCase();
                                            return c === e ? (d.push("<strong>" + b + "</strong>"), (i = !0), !1) : void ((0 === c.indexOf(e) || (l && c.indexOf(e) > -1)) && d.push(b.replace(new RegExp(e, "gi"), "<strong>$&</strong>")));
                                        });
                                    }
                                    i || (0 === d.length && k.length > 0)
                                        ? k.hide()
                                        : d.length > 0 && 0 === k.length
                                        ? ((k = a("<div></div>").css(f.css).appendTo("body")),
                                          c.addClass("suggestions-" + j),
                                          k
                                              .attr("data-suggest-container", j)
                                              .addClass("jquery-form-suggestions")
                                              .addClass("jquery-form-suggestion-" + j))
                                        : d.length > 0 && !k.is(":visible") && k.show(),
                                        d.length > 0 &&
                                            e.length !== d[0].length &&
                                            (g(k, b),
                                            k.html(""),
                                            a.each(d, function (c, d) {
                                                a("<div></div>")
                                                    .append(d)
                                                    .css({ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", padding: "5px" })
                                                    .addClass("form-suggest-element")
                                                    .appendTo(k)
                                                    .click(function () {
                                                        b.focus(), b.val(a(this).text()), h(b);
                                                    });
                                            }));
                                }
                            })
                            .unbind("keydown.validation")
                            .bind("keydown.validation", function (b) {
                                var c,
                                    d,
                                    e = b.keyCode ? b.keyCode : b.which,
                                    g = a(this);
                                if (13 === e && null !== a.formUtils._selectedSuggestion) {
                                    if (((c = g.valAttr("suggestion-nr")), (d = a(".jquery-form-suggestion-" + c)), d.length > 0)) {
                                        var i = d.find("div").eq(a.formUtils._selectedSuggestion).text();
                                        g.val(i), h(g), b.preventDefault();
                                    }
                                } else {
                                    (c = g.valAttr("suggestion-nr")), (d = a(".jquery-form-suggestion-" + c));
                                    var j = d.children();
                                    if (j.length > 0 && a.inArray(e, [38, 40]) > -1) {
                                        38 === e
                                            ? (null === a.formUtils._selectedSuggestion ? (a.formUtils._selectedSuggestion = j.length - 1) : a.formUtils._selectedSuggestion--,
                                              a.formUtils._selectedSuggestion < 0 && (a.formUtils._selectedSuggestion = j.length - 1))
                                            : 40 === e &&
                                              (null === a.formUtils._selectedSuggestion ? (a.formUtils._selectedSuggestion = 0) : a.formUtils._selectedSuggestion++,
                                              a.formUtils._selectedSuggestion > j.length - 1 && (a.formUtils._selectedSuggestion = 0));
                                        var k = d.innerHeight(),
                                            l = d.scrollTop(),
                                            m = d.children().eq(0).outerHeight(),
                                            n = m * a.formUtils._selectedSuggestion;
                                        return (
                                            (n < l || n > l + k) && d.scrollTop(n),
                                            j.removeClass("active-suggestion").css("background", "none").eq(a.formUtils._selectedSuggestion).addClass("active-suggestion").css(f.activeSuggestionCSS),
                                            b.preventDefault(),
                                            !1
                                        );
                                    }
                                }
                            })
                            .unbind("blur.suggest")
                            .bind("blur.suggest", function () {
                                h(a(this));
                            }),
                        c
                    );
                },
                LANG: {
                    errorTitle: "Form submission failed!",
                    requiredField: "This is a required field",
                    requiredFields: "You have not answered all required fields",
                    badTime: "You have not given a correct time",
                    badEmail: "You have not given a correct e-mail address",
                    badTelephone: "You have not given a correct phone number",
                    badSecurityAnswer: "You have not given a correct answer to the security question",
                    badDate: "You have not given a correct date",
                    lengthBadStart: "The input value must be between ",
                    lengthBadEnd: " characters",
                    lengthTooLongStart: "The input value is longer than ",
                    lengthTooShortStart: "The input value is shorter than ",
                    notConfirmed: "Input values could not be confirmed",
                    badDomain: "Incorrect domain value",
                    badUrl: "The input value is not a correct URL",
                    badCustomVal: "The input value is incorrect",
                    andSpaces: " and spaces ",
                    badInt: "The input value was not a correct number",
                    badSecurityNumber: "Your social security number was incorrect",
                    badUKVatAnswer: "Incorrect UK VAT Number",
                    badStrength: "The password isn't strong enough",
                    badNumberOfSelectedOptionsStart: "You have to choose at least ",
                    badNumberOfSelectedOptionsEnd: " answers",
                    badAlphaNumeric: "The input value can only contain alphanumeric characters ",
                    badAlphaNumericExtra: " and ",
                    wrongFileSize: "The file you are trying to upload is too large (max %s)",
                    wrongFileType: "Only files of type %s is allowed",
                    groupCheckedRangeStart: "Please choose between ",
                    groupCheckedTooFewStart: "Please choose at least ",
                    groupCheckedTooManyStart: "Please choose a maximum of ",
                    groupCheckedEnd: " item(s)",
                    badCreditCard: "The credit card number is not correct",
                    badCVV: "The CVV number was not correct",
                    wrongFileDim: "Incorrect image dimensions,",
                    imageTooTall: "the image can not be taller than",
                    imageTooWide: "the image can not be wider than",
                    imageTooSmall: "the image was too small",
                    min: "min",
                    max: "max",
                    imageRatioNotAccepted: "Image ratio is not be accepted",
                    badBrazilTelephoneAnswer: "The phone number entered is invalid",
                    badBrazilCEPAnswer: "The CEP entered is invalid",
                    badBrazilCPFAnswer: "The CPF entered is invalid",
                },
            }),
            a.formUtils.addValidator({
                name: "email",
                validatorFunction: function (b) {
                    var c = b.toLowerCase().split("@"),
                        d = c[0],
                        e = c[1];
                    if (d && e) {
                        if (0 === d.indexOf('"')) {
                            var f = d.length;
                            if (((d = d.replace(/\"/g, "")), d.length !== f - 2)) return !1;
                        }
                        return (
                            a.formUtils.validators.validate_domain.validatorFunction(c[1]) &&
                            0 !== d.indexOf(".") &&
                            "." !== d.substring(d.length - 1, d.length) &&
                            d.indexOf("..") === -1 &&
                            !/[^\w\+\.\-\#\-\_\~\!\$\&\'\(\)\*\+\,\;\=\:]/.test(d)
                        );
                    }
                    return !1;
                },
                errorMessage: "",
                errorMessageKey: "badEmail",
            }),
            a.formUtils.addValidator({
                name: "domain",
                validatorFunction: function (a) {
                    return a.length > 0 && a.length <= 253 && !/[^a-zA-Z0-9]/.test(a.slice(-2)) && !/[^a-zA-Z0-9]/.test(a.substr(0, 1)) && !/[^a-zA-Z0-9\.\-]/.test(a) && 1 === a.split("..").length && a.split(".").length > 1;
                },
                errorMessage: "",
                errorMessageKey: "badDomain",
            }),
            a.formUtils.addValidator({
                name: "required",
                validatorFunction: function (b, c, d, e, f) {
                    switch (c.attr("type")) {
                        case "checkbox":
                            return c.is(":checked");
                        case "radio":
                            return f.find('input[name="' + c.attr("name") + '"]').filter(":checked").length > 0;
                        default:
                            return "" !== a.trim(b);
                    }
                },
                errorMessage: "",
                errorMessageKey: function (a) {
                    return "top" === a.errorMessagePosition || "custom" === a.errorMessagePosition ? "requiredFields" : "requiredField";
                },
            }),
            a.formUtils.addValidator({
                name: "length",
                validatorFunction: function (b, c, d, e) {
                    var f = c.valAttr("length"),
                        g = c.attr("type");
                    if (void 0 === f) return alert('Please add attribute "data-validation-length" to ' + c[0].nodeName + " named " + c.attr("name")), !0;
                    var h,
                        i = "file" === g && void 0 !== c.get(0).files ? c.get(0).files.length : b.length,
                        j = a.formUtils.numericRangeCheck(i, f);
                    switch (j[0]) {
                        case "out":
                            (this.errorMessage = e.lengthBadStart + f + e.lengthBadEnd), (h = !1);
                            break;
                        case "min":
                            (this.errorMessage = e.lengthTooShortStart + j[1] + e.lengthBadEnd), (h = !1);
                            break;
                        case "max":
                            (this.errorMessage = e.lengthTooLongStart + j[1] + e.lengthBadEnd), (h = !1);
                            break;
                        default:
                            h = !0;
                    }
                    return h;
                },
                errorMessage: "",
                errorMessageKey: "",
            }),
            a.formUtils.addValidator({
                name: "url",
                validatorFunction: function (b) {
                    var c = /^(https?|ftp):\/\/((((\w|-|\.|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])(\w|-|\.|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])(\w|-|\.|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/(((\w|-|\.|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/((\w|-|\.|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|\[|\]|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#(((\w|-|\.|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
                    if (c.test(b)) {
                        var d = b.split("://")[1],
                            e = d.indexOf("/");
                        return e > -1 && (d = d.substr(0, e)), a.formUtils.validators.validate_domain.validatorFunction(d);
                    }
                    return !1;
                },
                errorMessage: "",
                errorMessageKey: "badUrl",
            }),
            a.formUtils.addValidator({
                name: "number",
                validatorFunction: function (a, b, c) {
                    if ("" !== a) {
                        var d,
                            e,
                            f = b.valAttr("allowing") || "",
                            g = b.valAttr("decimal-separator") || c.decimalSeparator,
                            h = !1,
                            i = b.valAttr("step") || "",
                            j = !1;
                        if ((f.indexOf("number") === -1 && (f += ",number"), f.indexOf("negative") === -1 && 0 === a.indexOf("-"))) return !1;
                        if ((f.indexOf("range") > -1 && ((d = parseFloat(f.substring(f.indexOf("[") + 1, f.indexOf(";")))), (e = parseFloat(f.substring(f.indexOf(";") + 1, f.indexOf("]")))), (h = !0)), "" !== i && (j = !0), "," === g)) {
                            if (a.indexOf(".") > -1) return !1;
                            a = a.replace(",", ".");
                        }
                        if (f.indexOf("number") > -1 && "" === a.replace(/[0-9-]/g, "") && (!h || (a >= d && a <= e)) && (!j || a % i === 0)) return !0;
                        if (f.indexOf("float") > -1 && null !== a.match(new RegExp("^([0-9-]+)\\.([0-9]+)$")) && (!h || (a >= d && a <= e)) && (!j || a % i === 0)) return !0;
                    }
                    return !1;
                },
                errorMessage: "",
                errorMessageKey: "badInt",
            }),
            a.formUtils.addValidator({
                name: "alphanumeric",
                validatorFunction: function (b, c, d, e) {
                    var f = "^([a-zA-Z0-9",
                        g = "]+)$",
                        h = c.valAttr("allowing"),
                        i = "";
                    if (h) {
                        i = f + h + g;
                        var j = h.replace(/\\/g, "");
                        j.indexOf(" ") > -1 && ((j = j.replace(" ", "")), (j += e.andSpaces || a.formUtils.LANG.andSpaces)), (this.errorMessage = e.badAlphaNumeric + e.badAlphaNumericExtra + j);
                    } else (i = f + g), (this.errorMessage = e.badAlphaNumeric);
                    return new RegExp(i).test(b);
                },
                errorMessage: "",
                errorMessageKey: "",
            }),
            a.formUtils.addValidator({
                name: "custom",
                validatorFunction: function (a, b) {
                    var c = new RegExp(b.valAttr("regexp"));
                    return c.test(a);
                },
                errorMessage: "",
                errorMessageKey: "badCustomVal",
            }),
            a.formUtils.addValidator({
                name: "date",
                validatorFunction: function (b, c, d) {
                    var e = c.valAttr("format") || d.dateFormat || "yyyy-mm-dd";
                    return a.formUtils.parseDate(b, e) !== !1;
                },
                errorMessage: "",
                errorMessageKey: "badDate",
            }),
            a.formUtils.addValidator({
                name: "checkbox_group",
                validatorFunction: function (b, c, d, e, f) {
                    var g = !0,
                        h = c.attr("name"),
                        i = a('input[type=checkbox][name^="' + h + '"]', f),
                        j = i.filter(":checked").length,
                        k = c.valAttr("qty");
                    if (void 0 === k) {
                        var l = c.get(0).nodeName;
                        alert('Attribute "data-validation-qty" is missing from ' + l + " named " + c.attr("name"));
                    }
                    var m = a.formUtils.numericRangeCheck(j, k);
                    switch (m[0]) {
                        case "out":
                            (this.errorMessage = e.groupCheckedRangeStart + k + e.groupCheckedEnd), (g = !1);
                            break;
                        case "min":
                            (this.errorMessage = e.groupCheckedTooFewStart + m[1] + e.groupCheckedEnd), (g = !1);
                            break;
                        case "max":
                            (this.errorMessage = e.groupCheckedTooManyStart + m[1] + e.groupCheckedEnd), (g = !1);
                            break;
                        default:
                            g = !0;
                    }
                    if (!g) {
                        var n = function () {
                            i.unbind("click", n), i.filter("*[data-validation]").validateInputOnBlur(e, d, !1, "blur");
                        };
                        i.bind("click", n);
                    }
                    return g;
                },
            });
    })(jQuery),
    (function (a) {
        a.formUtils.addValidator({
            name: "time",
            validatorFunction: function (a) {
                if (null === a.match(/^(\d{2}):(\d{2})$/)) return !1;
                var b = parseInt(a.split(":")[0], 10),
                    c = parseInt(a.split(":")[1], 10);
                return !(b > 23 || c > 59);
            },
            errorMessage: "",
            errorMessageKey: "badTime",
        }),
            a.formUtils.addValidator({
                name: "birthdate",
                validatorFunction: function (b, c, d) {
                    var e = "yyyy-mm-dd";
                    c.valAttr("format") ? (e = c.valAttr("format")) : "undefined" != typeof d.dateFormat && (e = d.dateFormat);
                    var f = a.formUtils.parseDate(b, e);
                    if (!f) return !1;
                    var g = new Date(),
                        h = g.getFullYear(),
                        i = f[0],
                        j = f[1],
                        k = f[2];
                    if (i === h) {
                        var l = g.getMonth() + 1;
                        if (j === l) {
                            var m = g.getDate();
                            return k <= m;
                        }
                        return j < l;
                    }
                    return i < h && i > h - 124;
                },
                errorMessage: "",
                errorMessageKey: "badDate",
            });
    })(jQuery),
    (function (a, b) {
        "use strict";
        var c = "undefined" != typeof b.FileReader,
            d = function (b) {
                var c = a.split((b.valAttr("allowing") || "").toLowerCase());
                return a.inArray("jpg", c) > -1 && a.inArray("jpeg", c) == -1 ? c.push("jpeg") : a.inArray("jpeg", c) > -1 && a.inArray("jpg", c) == -1 && c.push("jpg"), c;
            },
            e = function (a, b, c, d) {
                var e = d[b] || "";
                (a.errorMessageKey = ""), (a.errorMessage = e.replace("%s", c));
            },
            f = function (a) {
                b.console && b.console.log && b.console.log(a);
            },
            g = function (c, d, e) {
                var f = new FileReader(),
                    g = new Image();
                f.readAsDataURL(c),
                    (f.onload = function (c) {
                        (g.onload = function () {
                            a(b).trigger("imageValidation", [this]), d(this);
                        }),
                            (g.onerror = function () {
                                e();
                            }),
                            (g.src = c.target.result);
                    });
            };
        a.formUtils.addValidator({
            name: "mime",
            validatorFunction: function (b, g, h, i) {
                if (c) {
                    var j = !0,
                        k = g.get(0).files || [],
                        l = "",
                        m = d(g);
                    return (
                        k.length &&
                            (a.each(k, function (b, c) {
                                return (
                                    (j = !1),
                                    (l = c.type || ""),
                                    a.each(m, function (a, b) {
                                        if ((j = l.indexOf(b) > -1)) return !1;
                                    }),
                                    j
                                );
                            }),
                            j || (f("Trying to upload a file with mime type " + l + " which is not allowed"), e(this, "wrongFileType", m.join(", "), i))),
                        j
                    );
                }
                return f("FileReader not supported by browser, will check file extension"), a.formUtils.validators.validate_extension.validatorFunction(b, g, h, i);
            },
            errorMessage: "",
            errorMessageKey: "wrongFileType",
        }),
            a.formUtils.addValidator({
                name: "extension",
                validatorFunction: function (b, c, f, g) {
                    var h = !0,
                        i = this,
                        j = d(c);
                    return (
                        a.each(c.get(0).files || [b], function (b, c) {
                            var d = "string" == typeof c ? c : c.value || c.fileName || c.name,
                                f = d.substr(d.lastIndexOf(".") + 1);
                            if (a.inArray(f.toLowerCase(), j) == -1) return (h = !1), e(i, "wrongFileType", j.join(", "), g), !1;
                        }),
                        h
                    );
                },
                errorMessage: "",
                errorMessageKey: "wrongFileType",
            }),
            a.formUtils.addValidator({
                name: "size",
                validatorFunction: function (b, d, g, h) {
                    var i = d.valAttr("max-size");
                    if (!i) return f('Input "' + d.attr("name") + '" is missing data-validation-max-size attribute'), !0;
                    if (!c) return !0;
                    var j = a.formUtils.convertSizeNameToBytes(i),
                        k = !0;
                    return (
                        a.each(d.get(0).files || [], function (a, b) {
                            return (k = b.size <= j);
                        }),
                        k || e(this, "wrongFileSize", i, h),
                        k
                    );
                },
                errorMessage: "",
                errorMessageKey: "wrongFileSize",
            }),
            (a.formUtils.convertSizeNameToBytes = function (a) {
                return (
                    (a = a.toUpperCase()),
                    "M" == a.substr(a.length - 1, 1)
                        ? 1024 * parseInt(a.substr(0, a.length - 1), 10) * 1024
                        : "MB" == a.substr(a.length - 2, 2)
                        ? 1024 * parseInt(a.substr(0, a.length - 2), 10) * 1024
                        : "KB" == a.substr(a.length - 2, 2)
                        ? 1024 * parseInt(a.substr(0, a.length - 2), 10)
                        : "B" == a.substr(a.length - 1, 1)
                        ? parseInt(a.substr(0, a.length - 1), 10)
                        : parseInt(a, 10)
                );
            });
        var h = function () {
            return !1;
        };
        (a.formUtils.checkImageDimension = function (a, b, c) {
            var d = !1,
                e = { width: 0, height: 0 },
                f = function (a) {
                    a = a.replace("min", "").replace("max", "");
                    var b = a.split("x");
                    (e.width = b[0]), (e.height = b[1] ? b[1] : b[0]);
                },
                g = !1,
                h = !1,
                i = b.split("-");
            return (
                1 == i.length ? (0 === i[0].indexOf("min") ? (g = i[0]) : (h = i[0])) : ((g = i[0]), (h = i[1])),
                g && (f(g), (a.width < e.width || a.height < e.height) && (d = c.imageTooSmall + " (" + c.min + " " + e.width + "x" + e.height + "px)")),
                !d &&
                    h &&
                    (f(h),
                    (a.width > e.width || a.height > e.height) && ((d = a.width > e.width ? c.imageTooWide + " " + e.width + "px" : c.imageTooTall + " " + e.height + "px"), (d += " (" + c.max + " " + e.width + "x" + e.height + "px)"))),
                d
            );
        }),
            (a.formUtils.checkImageRatio = function (a, b, c) {
                var d = a.width / a.height,
                    e = function (a) {
                        var b = a.replace("max", "").replace("min", "").split(":");
                        return b[0] / b[1];
                    },
                    f = b.split("-"),
                    g = function (a, b, c) {
                        return console.log(a + ">=" + b + " && " + a + " <= " + c), a >= b && a <= c;
                    };
                if (1 == f.length) {
                    if (d !== e(f[0])) return c.imageRatioNotAccepted;
                } else if (2 == f.length && !g(d, e(f[0]), e(f[1]))) return c.imageRatioNotAccepted;
                return !1;
            }),
            a.formUtils.addValidator({
                name: "dimension",
                validatorFunction: function (b, d, e, f, i) {
                    if (c) {
                        var j = !0,
                            k = d.get(0).files || [];
                        if (d.attr("data-validation").indexOf("mime") == -1) return alert("You should validate file type being jpg, gif or png on input " + d[0].name), !1;
                        if (k.length > 1) return alert("Validating image dimensions does not support inputs allowing multiple files"), !1;
                        if (0 == k.length) return !0;
                        if (d.valAttr("has-valid-dim")) return !0;
                        if (d.valAttr("has-not-valid-dim")) return (this.errorMessage = f.wrongFileDim + " " + d.valAttr("has-not-valid-dim")), !1;
                        if ("keyup" == a.formUtils.eventType) return null;
                        var l = !1;
                        return (
                            a.formUtils.isValidatingEntireForm && ((l = !0), (a.formUtils.haltValidation = !0), i.bind("submit", h).addClass("on-blur")),
                            g(
                                k[0],
                                function (b) {
                                    var c = !1;
                                    d.valAttr("dimension") && (c = a.formUtils.checkImageDimension(b, d.valAttr("dimension"), f)),
                                        !c && d.valAttr("ratio") && (c = a.formUtils.checkImageRatio(b, d.valAttr("ratio"), f)),
                                        c ? d.valAttr("has-not-valid-dim", c) : d.valAttr("has-valid-dim", "true"),
                                        d.valAttr("has-keyup-event") ||
                                            d.valAttr("has-keyup-event", "1").bind("keyup change", function (b) {
                                                9 != b.keyCode && 16 != b.keyCode && a(this).valAttr("has-not-valid-dim", !1).valAttr("has-valid-dim", !1);
                                            }),
                                        l ? ((a.formUtils.haltValidation = !1), (i.removeClass("on-blur").get(0).onsubmit = function () {}), i.unbind("submit", h), i.trigger("submit")) : d.trigger("blur");
                                },
                                function (a) {
                                    throw a;
                                }
                            ),
                            !0
                        );
                    }
                    return j;
                },
                errorMessage: "",
                errorMessageKey: "",
            }),
            a(b).one("validatorsLoaded formValidationSetup", function (b, c) {
                var d;
                (d = c ? c.find('input[type="file"]') : a('input[type="file"]')),
                    d.filter("*[data-validation]").bind("change", function () {
                        a(this).removeClass("error").parent().find(".form-error").remove();
                    });
            });
    })(jQuery, window),
    (function (a, b) {
        "use strict";
        a.formUtils.addValidator({
            name: "spamcheck",
            validatorFunction: function (a, b) {
                var c = b.valAttr("captcha");
                return c === a;
            },
            errorMessage: "",
            errorMessageKey: "badSecurityAnswer",
        }),
            a.formUtils.addValidator({
                name: "confirmation",
                validatorFunction: function (a, b, c, d, e) {
                    var f = "",
                        g = b.valAttr("confirm") || b.attr("name") + "_confirmation",
                        h = e.find('[name="' + g + '"]').eq(0);
                    if (h) {
                        if (((f = h.val()), c.validateOnBlur && !h.attr("hasValidationCallback"))) {
                            h.attr("hasValidationCallback", "true");
                            var i = function () {
                                b.validate();
                            };
                            h.on("keyup", i),
                                e.one("formValidationSetup", function () {
                                    h.attr("hasValidationCallback", "false"), h.off("keyup", i);
                                });
                        }
                    } else alert('Could not find an input with name "' + g + '"');
                    return a === f;
                },
                errorMessage: "",
                errorMessageKey: "notConfirmed",
            });
        var c = { amex: [15, 15], diners_club: [14, 14], cjb: [16, 16], laser: [16, 19], visa: [16, 16], mastercard: [16, 16], maestro: [12, 19], discover: [16, 16] },
            d = !1,
            e = !1;
        a.formUtils.addValidator({
            name: "creditcard",
            validatorFunction: function (f, g) {
                var h = a.split(g.valAttr("allowing") || "");
                if (((e = a.inArray("amex", h) > -1), (d = e && 1 === h.length), h.length > 0)) {
                    var i = !1;
                    if (
                        (a.each(h, function (a, d) {
                            if (d in c) {
                                if (f.length >= c[d][0] && f.length <= c[d][1]) return (i = !0), !1;
                            } else b.console && console.warn('Use of unknown credit card "' + d + '"');
                        }),
                        !i)
                    )
                        return !1;
                }
                if ("" !== f.replace(new RegExp("[0-9]", "g"), "")) return !1;
                var j = 0;
                return (
                    a.each(f.split("").reverse(), function (a, b) {
                        (b = parseInt(b, 10)), a % 2 === 0 ? (j += b) : ((b *= 2), (j += b < 10 ? b : b - 9));
                    }),
                    j % 10 === 0
                );
            },
            errorMessage: "",
            errorMessageKey: "badCreditCard",
        }),
            a.formUtils.addValidator({
                name: "cvv",
                validatorFunction: function (a) {
                    return "" === a.replace(/[0-9]/g, "") && ((a += ""), d ? 4 === a.length : e ? 3 === a.length || 4 === a.length : 3 === a.length);
                },
                errorMessage: "",
                errorMessageKey: "badCVV",
            }),
            a.formUtils.addValidator({
                name: "strength",
                validatorFunction: function (b, c) {
                    var d = c.valAttr("strength") || 2;
                    return d && d > 3 && (d = 3), a.formUtils.validators.validate_strength.calculatePasswordStrength(b) >= d;
                },
                errorMessage: "",
                errorMessageKey: "badStrength",
                calculatePasswordStrength: function (a) {
                    if (a.length < 4) return 0;
                    var b = 0,
                        c = function (a, b) {
                            for (var c = "", d = 0; d < b.length; d++) {
                                for (var e = !0, f = 0; f < a && f + d + a < b.length; f++) e = e && b.charAt(f + d) === b.charAt(f + d + a);
                                f < a && (e = !1), e ? ((d += a - 1), (e = !1)) : (c += b.charAt(d));
                            }
                            return c;
                        };
                    return (
                        (b += 4 * a.length),
                        (b += 1 * (c(1, a).length - a.length)),
                        (b += 1 * (c(2, a).length - a.length)),
                        (b += 1 * (c(3, a).length - a.length)),
                        (b += 1 * (c(4, a).length - a.length)),
                        a.match(/(.*[0-9].*[0-9].*[0-9])/) && (b += 5),
                        a.match(/(.*[!,@,#,$,%,^,&,*,?,_,~].*[!,@,#,$,%,^,&,*,?,_,~])/) && (b += 5),
                        a.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/) && (b += 10),
                        a.match(/([a-zA-Z])/) && a.match(/([0-9])/) && (b += 15),
                        a.match(/([!,@,#,$,%,^,&,*,?,_,~])/) && a.match(/([0-9])/) && (b += 15),
                        a.match(/([!,@,#,$,%,^,&,*,?,_,~])/) && a.match(/([a-zA-Z])/) && (b += 15),
                        (a.match(/^\w+$/) || a.match(/^\d+$/)) && (b -= 10),
                        b < 0 && (b = 0),
                        b > 100 && (b = 100),
                        b < 20 ? 0 : b < 40 ? 1 : b <= 60 ? 2 : 3
                    );
                },
                strengthDisplay: function (b, c) {
                    var d = { fontSize: "12pt", padding: "4px", bad: "Very bad", weak: "Weak", good: "Good", strong: "Strong" };
                    c && a.extend(d, c),
                        b.bind("keyup", function () {
                            var b = a(this).val(),
                                c = "undefined" == typeof d.parent ? a(this).parent() : a(d.parent),
                                e = c.find(".strength-meter"),
                                f = a.formUtils.validators.validate_strength.calculatePasswordStrength(b),
                                g = { background: "pink", color: "#FF0000", fontWeight: "bold", border: "red solid 1px", borderWidth: "0px 0px 4px", display: "inline-block", fontSize: d.fontSize, padding: d.padding },
                                h = d.bad;
                            0 === e.length && ((e = a("<span></span>")), e.addClass("strength-meter").appendTo(c)),
                                b ? e.show() : e.hide(),
                                1 === f
                                    ? (h = d.weak)
                                    : 2 === f
                                    ? ((g.background = "lightyellow"), (g.borderColor = "yellow"), (g.color = "goldenrod"), (h = d.good))
                                    : f >= 3 && ((g.background = "lightgreen"), (g.borderColor = "darkgreen"), (g.color = "darkgreen"), (h = d.strong)),
                                e.css(g).text(h);
                        });
                },
            });
        var f = function (b, c, d, e, f) {
                var g = c.valAttr("req-params") || c.data("validation-req-params") || {},
                    h = function (b, d) {
                        b.valid ? c.valAttr("backend-valid", "true") : (c.valAttr("backend-invalid", "true"), b.message && c.attr(e.validationErrorMsgAttribute, b.message)),
                            c.valAttr("has-keyup-event") ||
                                c.valAttr("has-keyup-event", "1").bind("keyup change", function (b) {
                                    9 !== b.keyCode && 16 !== b.keyCode && a(this).valAttr("backend-valid", !1).valAttr("backend-invalid", !1);
                                }),
                            d();
                    };
                g || (g = {}),
                    "string" == typeof g && (g = a.parseJSON(g)),
                    (g[c.valAttr("param-name") || c.attr("name")] = d),
                    a.ajax({
                        url: b,
                        type: "POST",
                        cache: !1,
                        data: g,
                        dataType: "json",
                        error: function (a) {
                            return h({ valid: !1, message: "Connection failed with status: " + a.statusText }, f), !1;
                        },
                        success: function (a) {
                            h(a, f);
                        },
                    });
            },
            g = function () {
                return !1;
            };
        a.formUtils.addValidator({
            name: "server",
            validatorFunction: function (b, c, d, e, h) {
                var i = c.valAttr("backend-valid"),
                    j = c.valAttr("backend-invalid"),
                    k = document.location.href;
                return (
                    c.valAttr("url") ? (k = c.valAttr("url")) : "serverURL" in d && (k = d.backendUrl),
                    !!i ||
                        (!j &&
                            ("keyup" === a.formUtils.eventType
                                ? null
                                : a.formUtils.isValidatingEntireForm
                                ? (h.bind("submit", g).addClass("validating-server-side").addClass("on-blur"),
                                  c.addClass("validating-server-side"),
                                  (a.formUtils.haltValidation = !0),
                                  f(k, c, b, d, function () {
                                      (h.removeClass("validating-server-side").removeClass("on-blur").get(0).onsubmit = function () {}),
                                          h.unbind("submit", g),
                                          c.removeClass("validating-server-side"),
                                          c.valAttr("value-length", b.length),
                                          (a.formUtils.haltValidation = !1),
                                          h.trigger("submit");
                                  }),
                                  null)
                                : (h.addClass("validating-server-side"),
                                  c.addClass("validating-server-side"),
                                  f(k, c, b, d, function () {
                                      h.removeClass("validating-server-side"), c.removeClass("validating-server-side"), c.trigger("blur");
                                  }),
                                  null)))
                );
            },
            errorMessage: "",
            errorMessageKey: "badBackend",
            validateOnKeyUp: !1,
        }),
            a.formUtils.addValidator({
                name: "letternumeric",
                validatorFunction: function (b, c, d, e) {
                    var f =
                            "^([a-zA-Z0-9ÂªÂµÂºÃ€-Ã–Ã˜-Ã¶Ã¸-ËË†-Ë‘Ë -Ë¤Ë¬Ë®Í°-Í´Í¶Í·Íº-Í½Î†Îˆ-ÎŠÎŒÎŽ-Î¡Î£-ÏµÏ·-ÒÒŠ-Ô§Ô±-Õ–Õ™Õ¡-Ö‡×-×ª×°-×²Ø -ÙŠÙ®Ù¯Ù±-Û“Û•Û¥Û¦Û®Û¯Ûº-Û¼Û¿ÜÜ’-Ü¯Ý-Þ¥Þ±ßŠ-ßªß´ßµßºà €-à •à šà ¤à ¨à¡€-à¡˜à¢ à¢¢-à¢¬à¤„-à¤¹à¤½à¥à¥˜-à¥¡à¥±-à¥·à¥¹-à¥¿à¦…-à¦Œà¦à¦à¦“-à¦¨à¦ª-à¦°à¦²à¦¶-à¦¹à¦½à§Žà§œà§à§Ÿ-à§¡à§°à§±à¨…-à¨Šà¨à¨à¨“-à¨¨à¨ª-à¨°à¨²à¨³à¨µà¨¶à¨¸à¨¹à©™-à©œà©žà©²-à©´àª…-àªàª-àª‘àª“-àª¨àªª-àª°àª²àª³àªµ-àª¹àª½à«à« à«¡à¬…-à¬Œà¬à¬à¬“-à¬¨à¬ª-à¬°à¬²à¬³à¬µ-à¬¹à¬½à­œà­à­Ÿ-à­¡à­±à®ƒà®…-à®Šà®Ž-à®à®’-à®•à®™à®šà®œà®žà®Ÿà®£à®¤à®¨-à®ªà®®-à®¹à¯à°…-à°Œà°Ž-à°à°’-à°¨à°ª-à°³à°µ-à°¹à°½à±˜à±™à± à±¡à²…-à²Œà²Ž-à²à²’-à²¨à²ª-à²³à²µ-à²¹à²½à³žà³ à³¡à³±à³²à´…-à´Œà´Ž-à´à´’-à´ºà´½àµŽàµ àµ¡àµº-àµ¿à¶…-à¶–à¶š-à¶±à¶³-à¶»à¶½à·€-à·†à¸-à¸°à¸²à¸³à¹€-à¹†àºàº‚àº„àº‡àºˆàºŠàºàº”-àº—àº™-àºŸàº¡-àº£àº¥àº§àºªàº«àº­-àº°àº²àº³àº½à»€-à»„à»†à»œ-à»Ÿà¼€à½€-à½‡à½‰-à½¬à¾ˆ-à¾Œá€€-á€ªá€¿á-á•áš-áá¡á¥á¦á®-á°áµ-á‚á‚Žá‚ -áƒ…áƒ‡áƒáƒ-áƒºáƒ¼-á‰ˆá‰Š-á‰á‰-á‰–á‰˜á‰š-á‰á‰ -áŠˆáŠŠ-áŠáŠ-áŠ°áŠ²-áŠµáŠ¸-áŠ¾á‹€á‹‚-á‹…á‹ˆ-á‹–á‹˜-áŒáŒ’-áŒ•áŒ˜-ášáŽ€-áŽáŽ -á´á-á™¬á™¯-á™¿áš-áššáš -á›ªáœ€-áœŒáœŽ-áœ‘áœ -áœ±á€-á‘á -á¬á®-á°áž€-áž³áŸ—áŸœá  -á¡·á¢€-á¢¨á¢ªá¢°-á£µá¤€-á¤œá¥-á¥­á¥°-á¥´á¦€-á¦«á§-á§‡á¨€-á¨–á¨ -á©”áª§á¬…-á¬³á­…-á­‹á®ƒ-á® á®®á®¯á®º-á¯¥á°€-á°£á±-á±á±š-á±½á³©-á³¬á³®-á³±á³µá³¶á´€-á¶¿á¸€-á¼•á¼˜-á¼á¼ -á½…á½ˆ-á½á½-á½—á½™á½›á½á½Ÿ-á½½á¾€-á¾´á¾¶-á¾¼á¾¾á¿‚-á¿„á¿†-á¿Œá¿-á¿“á¿–-á¿›á¿ -á¿¬á¿²-á¿´á¿¶-á¿¼â±â¿â‚-â‚œâ„‚â„‡â„Š-â„“â„•â„™-â„â„¤â„¦â„¨â„ª-â„­â„¯-â„¹â„¼-â„¿â……-â…‰â…Žâ†ƒâ†„â°€-â°®â°°-â±žâ± -â³¤â³«-â³®â³²â³³â´€-â´¥â´§â´­â´°-âµ§âµ¯â¶€-â¶–â¶ -â¶¦â¶¨-â¶®â¶°-â¶¶â¶¸-â¶¾â·€-â·†â·ˆ-â·Žâ·-â·–â·˜-â·žâ¸¯ã€…ã€†ã€±-ã€µã€»ã€¼ã-ã‚–ã‚-ã‚Ÿã‚¡-ãƒºãƒ¼-ãƒ¿ã„…-ã„­ã„±-ã†Žã† -ã†ºã‡°-ã‡¿ã€-ä¶µä¸€-é¿Œê€€-ê’Œê“-ê“½ê”€-ê˜Œê˜-ê˜Ÿê˜ªê˜«ê™€-ê™®ê™¿-êš—êš -ê›¥êœ—-êœŸêœ¢-êžˆêž‹-êžŽêž-êž“êž -êžªêŸ¸-ê ê ƒ-ê …ê ‡-ê Šê Œ-ê ¢ê¡€-ê¡³ê¢‚-ê¢³ê£²-ê£·ê£»ê¤Š-ê¤¥ê¤°-ê¥†ê¥ -ê¥¼ê¦„-ê¦²ê§ê¨€-ê¨¨ê©€-ê©‚ê©„-ê©‹ê© -ê©¶ê©ºêª€-êª¯êª±êªµêª¶êª¹-êª½ê«€ê«‚ê«›-ê«ê« -ê«ªê«²-ê«´ê¬-ê¬†ê¬‰-ê¬Žê¬‘-ê¬–ê¬ -ê¬¦ê¬¨-ê¬®ê¯€-ê¯¢ê°€-íž£íž°-íŸ†íŸ‹-íŸ»ï¤€-ï©­ï©°-ï«™ï¬€-ï¬†ï¬“-ï¬—ï¬ï¬Ÿ-ï¬¨ï¬ª-ï¬¶ï¬¸-ï¬¼ï¬¾ï­€ï­ï­ƒï­„ï­†-ï®±ï¯“-ï´½ïµ-ï¶ï¶’-ï·‡ï·°-ï·»ï¹°-ï¹´ï¹¶-ï»¼ï¼¡-ï¼ºï½-ï½šï½¦-ï¾¾ï¿‚-ï¿‡ï¿Š-ï¿ï¿’-ï¿—ï¿š-ï¿œ",
                        g = "]+)$",
                        h = c.valAttr("allowing"),
                        i = "";
                    if (h) {
                        i = f + h + g;
                        var j = h.replace(/\\/g, "");
                        j.indexOf(" ") > -1 && ((j = j.replace(" ", "")), (j += e.andSpaces || a.formUtils.LANG.andSpaces)), (this.errorMessage = e.badAlphaNumeric + e.badAlphaNumericExtra + j);
                    } else (i = f + g), (this.errorMessage = e.badAlphaNumeric);
                    return new RegExp(i).test(b);
                },
                errorMessage: "",
                errorMessageKey: "requiredFields",
            }),
            (a.fn.displayPasswordStrength = function (b) {
                return new a.formUtils.validators.validate_strength.strengthDisplay(this, b), this;
            });
    })(jQuery, window),
    $.formUtils.addValidator({
        name: "ukvatnumber",
        validatorFunction: function (a) {
            if (((a = a.replace(/[^0-9]/g, "")), a.length < 9)) return !1;
            var b = !1,
                c = [];
            c = a.split("");
            var d = Number(c[7] + c[8]),
                e = c[0],
                f = c[1];
            if (0 === e && f > 0) return !1;
            for (var g = 0, h = 0; h < 7; h++) g += c[h] * (8 - h);
            for (var i = 0, j = 0, k = 8; k >= 2; k--) (i += c[j] * k), j++;
            for (; g > 0; ) g -= 97;
            return (g = Math.abs(g)), d === g && (b = !0), b || ((g %= 97), g >= 55 ? (g -= 55) : (g += 42), g === d && (b = !0)), b;
        },
        errorMessage: "",
        errorMessageKey: "badUKVatAnswer",
    }),
    !(function (a, b, c, d) {
        "use strict";
        function e(a, b, c) {
            return setTimeout(j(a, c), b);
        }
        function f(a, b, c) {
            return !!Array.isArray(a) && (g(a, c[b], c), !0);
        }
        function g(a, b, c) {
            var e;
            if (a)
                if (a.forEach) a.forEach(b, c);
                else if (a.length !== d) for (e = 0; e < a.length; ) b.call(c, a[e], e, a), e++;
                else for (e in a) a.hasOwnProperty(e) && b.call(c, a[e], e, a);
        }
        function h(b, c, d) {
            var e = "DEPRECATED METHOD: " + c + "\n" + d + " AT \n";
            return function () {
                var c = new Error("get-stack-trace"),
                    d =
                        c && c.stack
                            ? c.stack
                                  .replace(/^[^\(]+?[\n$]/gm, "")
                                  .replace(/^\s+at\s+/gm, "")
                                  .replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@")
                            : "Unknown Stack Trace",
                    f = a.console && (a.console.warn || a.console.log);
                return f && f.call(a.console, e, d), b.apply(this, arguments);
            };
        }
        function i(a, b, c) {
            var d,
                e = b.prototype;
            (d = a.prototype = Object.create(e)), (d.constructor = a), (d._super = e), c && la(d, c);
        }
        function j(a, b) {
            return function () {
                return a.apply(b, arguments);
            };
        }
        function k(a, b) {
            return typeof a == oa ? a.apply(b ? b[0] || d : d, b) : a;
        }
        function l(a, b) {
            return a === d ? b : a;
        }
        function m(a, b, c) {
            g(q(b), function (b) {
                a.addEventListener(b, c, !1);
            });
        }
        function n(a, b, c) {
            g(q(b), function (b) {
                a.removeEventListener(b, c, !1);
            });
        }
        function o(a, b) {
            for (; a; ) {
                if (a == b) return !0;
                a = a.parentNode;
            }
            return !1;
        }
        function p(a, b) {
            return a.indexOf(b) > -1;
        }
        function q(a) {
            return a.trim().split(/\s+/g);
        }
        function r(a, b, c) {
            if (a.indexOf && !c) return a.indexOf(b);
            for (var d = 0; d < a.length; ) {
                if ((c && a[d][c] == b) || (!c && a[d] === b)) return d;
                d++;
            }
            return -1;
        }
        function s(a) {
            return Array.prototype.slice.call(a, 0);
        }
        function t(a, b, c) {
            for (var d = [], e = [], f = 0; f < a.length; ) {
                var g = b ? a[f][b] : a[f];
                r(e, g) < 0 && d.push(a[f]), (e[f] = g), f++;
            }
            return (
                c &&
                    (d = b
                        ? d.sort(function (a, c) {
                              return a[b] > c[b];
                          })
                        : d.sort()),
                d
            );
        }
        function u(a, b) {
            for (var c, e, f = b[0].toUpperCase() + b.slice(1), g = 0; g < ma.length; ) {
                if (((c = ma[g]), (e = c ? c + f : b), e in a)) return e;
                g++;
            }
            return d;
        }
        function v() {
            return ua++;
        }
        function w(b) {
            var c = b.ownerDocument || b;
            return c.defaultView || c.parentWindow || a;
        }
        function x(a, b) {
            var c = this;
            (this.manager = a),
                (this.callback = b),
                (this.element = a.element),
                (this.target = a.options.inputTarget),
                (this.domHandler = function (b) {
                    k(a.options.enable, [a]) && c.handler(b);
                }),
                this.init();
        }
        function y(a) {
            var b,
                c = a.options.inputClass;
            return new (b = c ? c : xa ? M : ya ? P : wa ? R : L)(a, z);
        }
        function z(a, b, c) {
            var d = c.pointers.length,
                e = c.changedPointers.length,
                f = b & Ea && d - e === 0,
                g = b & (Ga | Ha) && d - e === 0;
            (c.isFirst = !!f), (c.isFinal = !!g), f && (a.session = {}), (c.eventType = b), A(a, c), a.emit("hammer.input", c), a.recognize(c), (a.session.prevInput = c);
        }
        function A(a, b) {
            var c = a.session,
                d = b.pointers,
                e = d.length;
            c.firstInput || (c.firstInput = D(b)), e > 1 && !c.firstMultiple ? (c.firstMultiple = D(b)) : 1 === e && (c.firstMultiple = !1);
            var f = c.firstInput,
                g = c.firstMultiple,
                h = g ? g.center : f.center,
                i = (b.center = E(d));
            (b.timeStamp = ra()), (b.deltaTime = b.timeStamp - f.timeStamp), (b.angle = I(h, i)), (b.distance = H(h, i)), B(c, b), (b.offsetDirection = G(b.deltaX, b.deltaY));
            var j = F(b.deltaTime, b.deltaX, b.deltaY);
            (b.overallVelocityX = j.x),
                (b.overallVelocityY = j.y),
                (b.overallVelocity = qa(j.x) > qa(j.y) ? j.x : j.y),
                (b.scale = g ? K(g.pointers, d) : 1),
                (b.rotation = g ? J(g.pointers, d) : 0),
                (b.maxPointers = c.prevInput ? (b.pointers.length > c.prevInput.maxPointers ? b.pointers.length : c.prevInput.maxPointers) : b.pointers.length),
                C(c, b);
            var k = a.element;
            o(b.srcEvent.target, k) && (k = b.srcEvent.target), (b.target = k);
        }
        function B(a, b) {
            var c = b.center,
                d = a.offsetDelta || {},
                e = a.prevDelta || {},
                f = a.prevInput || {};
            (b.eventType !== Ea && f.eventType !== Ga) || ((e = a.prevDelta = { x: f.deltaX || 0, y: f.deltaY || 0 }), (d = a.offsetDelta = { x: c.x, y: c.y })), (b.deltaX = e.x + (c.x - d.x)), (b.deltaY = e.y + (c.y - d.y));
        }
        function C(a, b) {
            var c,
                e,
                f,
                g,
                h = a.lastInterval || b,
                i = b.timeStamp - h.timeStamp;
            if (b.eventType != Ha && (i > Da || h.velocity === d)) {
                var j = b.deltaX - h.deltaX,
                    k = b.deltaY - h.deltaY,
                    l = F(i, j, k);
                (e = l.x), (f = l.y), (c = qa(l.x) > qa(l.y) ? l.x : l.y), (g = G(j, k)), (a.lastInterval = b);
            } else (c = h.velocity), (e = h.velocityX), (f = h.velocityY), (g = h.direction);
            (b.velocity = c), (b.velocityX = e), (b.velocityY = f), (b.direction = g);
        }
        function D(a) {
            for (var b = [], c = 0; c < a.pointers.length; ) (b[c] = { clientX: pa(a.pointers[c].clientX), clientY: pa(a.pointers[c].clientY) }), c++;
            return { timeStamp: ra(), pointers: b, center: E(b), deltaX: a.deltaX, deltaY: a.deltaY };
        }
        function E(a) {
            var b = a.length;
            if (1 === b) return { x: pa(a[0].clientX), y: pa(a[0].clientY) };
            for (var c = 0, d = 0, e = 0; b > e; ) (c += a[e].clientX), (d += a[e].clientY), e++;
            return { x: pa(c / b), y: pa(d / b) };
        }
        function F(a, b, c) {
            return { x: b / a || 0, y: c / a || 0 };
        }
        function G(a, b) {
            return a === b ? Ia : qa(a) >= qa(b) ? (0 > a ? Ja : Ka) : 0 > b ? La : Ma;
        }
        function H(a, b, c) {
            c || (c = Qa);
            var d = b[c[0]] - a[c[0]],
                e = b[c[1]] - a[c[1]];
            return Math.sqrt(d * d + e * e);
        }
        function I(a, b, c) {
            c || (c = Qa);
            var d = b[c[0]] - a[c[0]],
                e = b[c[1]] - a[c[1]];
            return (180 * Math.atan2(e, d)) / Math.PI;
        }
        function J(a, b) {
            return I(b[1], b[0], Ra) + I(a[1], a[0], Ra);
        }
        function K(a, b) {
            return H(b[0], b[1], Ra) / H(a[0], a[1], Ra);
        }
        function L() {
            (this.evEl = Ta), (this.evWin = Ua), (this.pressed = !1), x.apply(this, arguments);
        }
        function M() {
            (this.evEl = Xa), (this.evWin = Ya), x.apply(this, arguments), (this.store = this.manager.session.pointerEvents = []);
        }
        function N() {
            (this.evTarget = $a), (this.evWin = _a), (this.started = !1), x.apply(this, arguments);
        }
        function O(a, b) {
            var c = s(a.touches),
                d = s(a.changedTouches);
            return b & (Ga | Ha) && (c = t(c.concat(d), "identifier", !0)), [c, d];
        }
        function P() {
            (this.evTarget = bb), (this.targetIds = {}), x.apply(this, arguments);
        }
        function Q(a, b) {
            var c = s(a.touches),
                d = this.targetIds;
            if (b & (Ea | Fa) && 1 === c.length) return (d[c[0].identifier] = !0), [c, c];
            var e,
                f,
                g = s(a.changedTouches),
                h = [],
                i = this.target;
            if (
                ((f = c.filter(function (a) {
                    return o(a.target, i);
                })),
                b === Ea)
            )
                for (e = 0; e < f.length; ) (d[f[e].identifier] = !0), e++;
            for (e = 0; e < g.length; ) d[g[e].identifier] && h.push(g[e]), b & (Ga | Ha) && delete d[g[e].identifier], e++;
            return h.length ? [t(f.concat(h), "identifier", !0), h] : void 0;
        }
        function R() {
            x.apply(this, arguments);
            var a = j(this.handler, this);
            (this.touch = new P(this.manager, a)), (this.mouse = new L(this.manager, a)), (this.primaryTouch = null), (this.lastTouches = []);
        }
        function S(a, b) {
            a & Ea ? ((this.primaryTouch = b.changedPointers[0].identifier), T.call(this, b)) : a & (Ga | Ha) && T.call(this, b);
        }
        function T(a) {
            var b = a.changedPointers[0];
            if (b.identifier === this.primaryTouch) {
                var c = { x: b.clientX, y: b.clientY };
                this.lastTouches.push(c);
                var d = this.lastTouches,
                    e = function () {
                        var a = d.indexOf(c);
                        a > -1 && d.splice(a, 1);
                    };
                setTimeout(e, cb);
            }
        }
        function U(a) {
            for (var b = a.srcEvent.clientX, c = a.srcEvent.clientY, d = 0; d < this.lastTouches.length; d++) {
                var e = this.lastTouches[d],
                    f = Math.abs(b - e.x),
                    g = Math.abs(c - e.y);
                if (db >= f && db >= g) return !0;
            }
            return !1;
        }
        function V(a, b) {
            (this.manager = a), this.set(b);
        }
        function W(a) {
            if (p(a, jb)) return jb;
            var b = p(a, kb),
                c = p(a, lb);
            return b && c ? jb : b || c ? (b ? kb : lb) : p(a, ib) ? ib : hb;
        }
        function X() {
            if (!fb) return !1;
            var b = {},
                c = a.CSS && a.CSS.supports;
            return (
                ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function (d) {
                    b[d] = !c || a.CSS.supports("touch-action", d);
                }),
                b
            );
        }
        function Y(a) {
            (this.options = la({}, this.defaults, a || {})), (this.id = v()), (this.manager = null), (this.options.enable = l(this.options.enable, !0)), (this.state = nb), (this.simultaneous = {}), (this.requireFail = []);
        }
        function Z(a) {
            return a & sb ? "cancel" : a & qb ? "end" : a & pb ? "move" : a & ob ? "start" : "";
        }
        function $(a) {
            return a == Ma ? "down" : a == La ? "up" : a == Ja ? "left" : a == Ka ? "right" : "";
        }
        function _(a, b) {
            var c = b.manager;
            return c ? c.get(a) : a;
        }
        function aa() {
            Y.apply(this, arguments);
        }
        function ba() {
            aa.apply(this, arguments), (this.pX = null), (this.pY = null);
        }
        function ca() {
            aa.apply(this, arguments);
        }
        function da() {
            Y.apply(this, arguments), (this._timer = null), (this._input = null);
        }
        function ea() {
            aa.apply(this, arguments);
        }
        function fa() {
            aa.apply(this, arguments);
        }
        function ga() {
            Y.apply(this, arguments), (this.pTime = !1), (this.pCenter = !1), (this._timer = null), (this._input = null), (this.count = 0);
        }
        function ha(a, b) {
            return (b = b || {}), (b.recognizers = l(b.recognizers, ha.defaults.preset)), new ia(a, b);
        }
        function ia(a, b) {
            (this.options = la({}, ha.defaults, b || {})),
                (this.options.inputTarget = this.options.inputTarget || a),
                (this.handlers = {}),
                (this.session = {}),
                (this.recognizers = []),
                (this.oldCssProps = {}),
                (this.element = a),
                (this.input = y(this)),
                (this.touchAction = new V(this, this.options.touchAction)),
                ja(this, !0),
                g(
                    this.options.recognizers,
                    function (a) {
                        var b = this.add(new a[0](a[1]));
                        a[2] && b.recognizeWith(a[2]), a[3] && b.requireFailure(a[3]);
                    },
                    this
                );
        }
        function ja(a, b) {
            var c = a.element;
            if (c.style) {
                var d;
                g(a.options.cssProps, function (e, f) {
                    (d = u(c.style, f)), b ? ((a.oldCssProps[d] = c.style[d]), (c.style[d] = e)) : (c.style[d] = a.oldCssProps[d] || "");
                }),
                    b || (a.oldCssProps = {});
            }
        }
        function ka(a, c) {
            var d = b.createEvent("Event");
            d.initEvent(a, !0, !0), (d.gesture = c), c.target.dispatchEvent(d);
        }
        var la,
            ma = ["", "webkit", "Moz", "MS", "ms", "o"],
            na = b.createElement("div"),
            oa = "function",
            pa = Math.round,
            qa = Math.abs,
            ra = Date.now;
        la =
            "function" != typeof Object.assign
                ? function (a) {
                      if (a === d || null === a) throw new TypeError("Cannot convert undefined or null to object");
                      for (var b = Object(a), c = 1; c < arguments.length; c++) {
                          var e = arguments[c];
                          if (e !== d && null !== e) for (var f in e) e.hasOwnProperty(f) && (b[f] = e[f]);
                      }
                      return b;
                  }
                : Object.assign;
        var sa = h(
                function (a, b, c) {
                    for (var e = Object.keys(b), f = 0; f < e.length; ) (!c || (c && a[e[f]] === d)) && (a[e[f]] = b[e[f]]), f++;
                    return a;
                },
                "extend",
                "Use `assign`."
            ),
            ta = h(
                function (a, b) {
                    return sa(a, b, !0);
                },
                "merge",
                "Use `assign`."
            ),
            ua = 1,
            va = /mobile|tablet|ip(ad|hone|od)|android/i,
            wa = "ontouchstart" in a,
            xa = u(a, "PointerEvent") !== d,
            ya = wa && va.test(navigator.userAgent),
            za = "touch",
            Aa = "pen",
            Ba = "mouse",
            Ca = "kinect",
            Da = 25,
            Ea = 1,
            Fa = 2,
            Ga = 4,
            Ha = 8,
            Ia = 1,
            Ja = 2,
            Ka = 4,
            La = 8,
            Ma = 16,
            Na = Ja | Ka,
            Oa = La | Ma,
            Pa = Na | Oa,
            Qa = ["x", "y"],
            Ra = ["clientX", "clientY"];
        x.prototype = {
            handler: function () {},
            init: function () {
                this.evEl && m(this.element, this.evEl, this.domHandler), this.evTarget && m(this.target, this.evTarget, this.domHandler), this.evWin && m(w(this.element), this.evWin, this.domHandler);
            },
            destroy: function () {
                this.evEl && n(this.element, this.evEl, this.domHandler), this.evTarget && n(this.target, this.evTarget, this.domHandler), this.evWin && n(w(this.element), this.evWin, this.domHandler);
            },
        };
        var Sa = { mousedown: Ea, mousemove: Fa, mouseup: Ga },
            Ta = "mousedown",
            Ua = "mousemove mouseup";
        i(L, x, {
            handler: function (a) {
                var b = Sa[a.type];
                b & Ea && 0 === a.button && (this.pressed = !0),
                    b & Fa && 1 !== a.which && (b = Ga),
                    this.pressed && (b & Ga && (this.pressed = !1), this.callback(this.manager, b, { pointers: [a], changedPointers: [a], pointerType: Ba, srcEvent: a }));
            },
        });
        var Va = { pointerdown: Ea, pointermove: Fa, pointerup: Ga, pointercancel: Ha, pointerout: Ha },
            Wa = { 2: za, 3: Aa, 4: Ba, 5: Ca },
            Xa = "pointerdown",
            Ya = "pointermove pointerup pointercancel";
        a.MSPointerEvent && !a.PointerEvent && ((Xa = "MSPointerDown"), (Ya = "MSPointerMove MSPointerUp MSPointerCancel")),
            i(M, x, {
                handler: function (a) {
                    var b = this.store,
                        c = !1,
                        d = a.type.toLowerCase().replace("ms", ""),
                        e = Va[d],
                        f = Wa[a.pointerType] || a.pointerType,
                        g = f == za,
                        h = r(b, a.pointerId, "pointerId");
                    e & Ea && (0 === a.button || g) ? 0 > h && (b.push(a), (h = b.length - 1)) : e & (Ga | Ha) && (c = !0),
                        0 > h || ((b[h] = a), this.callback(this.manager, e, { pointers: b, changedPointers: [a], pointerType: f, srcEvent: a }), c && b.splice(h, 1));
                },
            });
        var Za = { touchstart: Ea, touchmove: Fa, touchend: Ga, touchcancel: Ha },
            $a = "touchstart",
            _a = "touchstart touchmove touchend touchcancel";
        i(N, x, {
            handler: function (a) {
                var b = Za[a.type];
                if ((b === Ea && (this.started = !0), this.started)) {
                    var c = O.call(this, a, b);
                    b & (Ga | Ha) && c[0].length - c[1].length === 0 && (this.started = !1), this.callback(this.manager, b, { pointers: c[0], changedPointers: c[1], pointerType: za, srcEvent: a });
                }
            },
        });
        var ab = { touchstart: Ea, touchmove: Fa, touchend: Ga, touchcancel: Ha },
            bb = "touchstart touchmove touchend touchcancel";
        i(P, x, {
            handler: function (a) {
                var b = ab[a.type],
                    c = Q.call(this, a, b);
                c && this.callback(this.manager, b, { pointers: c[0], changedPointers: c[1], pointerType: za, srcEvent: a });
            },
        });
        var cb = 2500,
            db = 25;
        i(R, x, {
            handler: function (a, b, c) {
                var d = c.pointerType == za,
                    e = c.pointerType == Ba;
                if (!(e && c.sourceCapabilities && c.sourceCapabilities.firesTouchEvents)) {
                    if (d) S.call(this, b, c);
                    else if (e && U.call(this, c)) return;
                    this.callback(a, b, c);
                }
            },
            destroy: function () {
                this.touch.destroy(), this.mouse.destroy();
            },
        });
        var eb = u(na.style, "touchAction"),
            fb = eb !== d,
            gb = "compute",
            hb = "auto",
            ib = "manipulation",
            jb = "none",
            kb = "pan-x",
            lb = "pan-y",
            mb = X();
        V.prototype = {
            set: function (a) {
                a == gb && (a = this.compute()), fb && this.manager.element.style && mb[a] && (this.manager.element.style[eb] = a), (this.actions = a.toLowerCase().trim());
            },
            update: function () {
                this.set(this.manager.options.touchAction);
            },
            compute: function () {
                var a = [];
                return (
                    g(this.manager.recognizers, function (b) {
                        k(b.options.enable, [b]) && (a = a.concat(b.getTouchAction()));
                    }),
                    W(a.join(" "))
                );
            },
            preventDefaults: function (a) {
                var b = a.srcEvent,
                    c = a.offsetDirection;
                if (this.manager.session.prevented) return void b.preventDefault();
                var d = this.actions,
                    e = p(d, jb) && !mb[jb],
                    f = p(d, lb) && !mb[lb],
                    g = p(d, kb) && !mb[kb];
                if (e) {
                    var h = 1 === a.pointers.length,
                        i = a.distance < 2,
                        j = a.deltaTime < 250;
                    if (h && i && j) return;
                }
                return g && f ? void 0 : e || (f && c & Na) || (g && c & Oa) ? this.preventSrc(b) : void 0;
            },
            preventSrc: function (a) {
                (this.manager.session.prevented = !0), a.preventDefault();
            },
        };
        var nb = 1,
            ob = 2,
            pb = 4,
            qb = 8,
            rb = qb,
            sb = 16,
            tb = 32;
        (Y.prototype = {
            defaults: {},
            set: function (a) {
                return la(this.options, a), this.manager && this.manager.touchAction.update(), this;
            },
            recognizeWith: function (a) {
                if (f(a, "recognizeWith", this)) return this;
                var b = this.simultaneous;
                return (a = _(a, this)), b[a.id] || ((b[a.id] = a), a.recognizeWith(this)), this;
            },
            dropRecognizeWith: function (a) {
                return f(a, "dropRecognizeWith", this) ? this : ((a = _(a, this)), delete this.simultaneous[a.id], this);
            },
            requireFailure: function (a) {
                if (f(a, "requireFailure", this)) return this;
                var b = this.requireFail;
                return (a = _(a, this)), -1 === r(b, a) && (b.push(a), a.requireFailure(this)), this;
            },
            dropRequireFailure: function (a) {
                if (f(a, "dropRequireFailure", this)) return this;
                a = _(a, this);
                var b = r(this.requireFail, a);
                return b > -1 && this.requireFail.splice(b, 1), this;
            },
            hasRequireFailures: function () {
                return this.requireFail.length > 0;
            },
            canRecognizeWith: function (a) {
                return !!this.simultaneous[a.id];
            },
            emit: function (a) {
                function b(b) {
                    c.manager.emit(b, a);
                }
                var c = this,
                    d = this.state;
                qb > d && b(c.options.event + Z(d)), b(c.options.event), a.additionalEvent && b(a.additionalEvent), d >= qb && b(c.options.event + Z(d));
            },
            tryEmit: function (a) {
                return this.canEmit() ? this.emit(a) : void (this.state = tb);
            },
            canEmit: function () {
                for (var a = 0; a < this.requireFail.length; ) {
                    if (!(this.requireFail[a].state & (tb | nb))) return !1;
                    a++;
                }
                return !0;
            },
            recognize: function (a) {
                var b = la({}, a);
                return k(this.options.enable, [this, b])
                    ? (this.state & (rb | sb | tb) && (this.state = nb), (this.state = this.process(b)), void (this.state & (ob | pb | qb | sb) && this.tryEmit(b)))
                    : (this.reset(), void (this.state = tb));
            },
            process: function (a) {},
            getTouchAction: function () {},
            reset: function () {},
        }),
            i(aa, Y, {
                defaults: { pointers: 1 },
                attrTest: function (a) {
                    var b = this.options.pointers;
                    return 0 === b || a.pointers.length === b;
                },
                process: function (a) {
                    var b = this.state,
                        c = a.eventType,
                        d = b & (ob | pb),
                        e = this.attrTest(a);
                    return d && (c & Ha || !e) ? b | sb : d || e ? (c & Ga ? b | qb : b & ob ? b | pb : ob) : tb;
                },
            }),
            i(ba, aa, {
                defaults: { event: "pan", threshold: 10, pointers: 1, direction: Pa },
                getTouchAction: function () {
                    var a = this.options.direction,
                        b = [];
                    return a & Na && b.push(lb), a & Oa && b.push(kb), b;
                },
                directionTest: function (a) {
                    var b = this.options,
                        c = !0,
                        d = a.distance,
                        e = a.direction,
                        f = a.deltaX,
                        g = a.deltaY;
                    return (
                        e & b.direction || (b.direction & Na ? ((e = 0 === f ? Ia : 0 > f ? Ja : Ka), (c = f != this.pX), (d = Math.abs(a.deltaX))) : ((e = 0 === g ? Ia : 0 > g ? La : Ma), (c = g != this.pY), (d = Math.abs(a.deltaY)))),
                        (a.direction = e),
                        c && d > b.threshold && e & b.direction
                    );
                },
                attrTest: function (a) {
                    return aa.prototype.attrTest.call(this, a) && (this.state & ob || (!(this.state & ob) && this.directionTest(a)));
                },
                emit: function (a) {
                    (this.pX = a.deltaX), (this.pY = a.deltaY);
                    var b = $(a.direction);
                    b && (a.additionalEvent = this.options.event + b), this._super.emit.call(this, a);
                },
            }),
            i(ca, aa, {
                defaults: { event: "pinch", threshold: 0, pointers: 2 },
                getTouchAction: function () {
                    return [jb];
                },
                attrTest: function (a) {
                    return this._super.attrTest.call(this, a) && (Math.abs(a.scale - 1) > this.options.threshold || this.state & ob);
                },
                emit: function (a) {
                    if (1 !== a.scale) {
                        var b = a.scale < 1 ? "in" : "out";
                        a.additionalEvent = this.options.event + b;
                    }
                    this._super.emit.call(this, a);
                },
            }),
            i(da, Y, {
                defaults: { event: "press", pointers: 1, time: 251, threshold: 9 },
                getTouchAction: function () {
                    return [hb];
                },
                process: function (a) {
                    var b = this.options,
                        c = a.pointers.length === b.pointers,
                        d = a.distance < b.threshold,
                        f = a.deltaTime > b.time;
                    if (((this._input = a), !d || !c || (a.eventType & (Ga | Ha) && !f))) this.reset();
                    else if (a.eventType & Ea)
                        this.reset(),
                            (this._timer = e(
                                function () {
                                    (this.state = rb), this.tryEmit();
                                },
                                b.time,
                                this
                            ));
                    else if (a.eventType & Ga) return rb;
                    return tb;
                },
                reset: function () {
                    clearTimeout(this._timer);
                },
                emit: function (a) {
                    this.state === rb && (a && a.eventType & Ga ? this.manager.emit(this.options.event + "up", a) : ((this._input.timeStamp = ra()), this.manager.emit(this.options.event, this._input)));
                },
            }),
            i(ea, aa, {
                defaults: { event: "rotate", threshold: 0, pointers: 2 },
                getTouchAction: function () {
                    return [jb];
                },
                attrTest: function (a) {
                    return this._super.attrTest.call(this, a) && (Math.abs(a.rotation) > this.options.threshold || this.state & ob);
                },
            }),
            i(fa, aa, {
                defaults: { event: "swipe", threshold: 10, velocity: 0.3, direction: Na | Oa, pointers: 1 },
                getTouchAction: function () {
                    return ba.prototype.getTouchAction.call(this);
                },
                attrTest: function (a) {
                    var b,
                        c = this.options.direction;
                    return (
                        c & (Na | Oa) ? (b = a.overallVelocity) : c & Na ? (b = a.overallVelocityX) : c & Oa && (b = a.overallVelocityY),
                        this._super.attrTest.call(this, a) && c & a.offsetDirection && a.distance > this.options.threshold && a.maxPointers == this.options.pointers && qa(b) > this.options.velocity && a.eventType & Ga
                    );
                },
                emit: function (a) {
                    var b = $(a.offsetDirection);
                    b && this.manager.emit(this.options.event + b, a), this.manager.emit(this.options.event, a);
                },
            }),
            i(ga, Y, {
                defaults: { event: "tap", pointers: 1, taps: 1, interval: 300, time: 250, threshold: 9, posThreshold: 10 },
                getTouchAction: function () {
                    return [ib];
                },
                process: function (a) {
                    var b = this.options,
                        c = a.pointers.length === b.pointers,
                        d = a.distance < b.threshold,
                        f = a.deltaTime < b.time;
                    if ((this.reset(), a.eventType & Ea && 0 === this.count)) return this.failTimeout();
                    if (d && f && c) {
                        if (a.eventType != Ga) return this.failTimeout();
                        var g = !this.pTime || a.timeStamp - this.pTime < b.interval,
                            h = !this.pCenter || H(this.pCenter, a.center) < b.posThreshold;
                        (this.pTime = a.timeStamp), (this.pCenter = a.center), h && g ? (this.count += 1) : (this.count = 1), (this._input = a);
                        var i = this.count % b.taps;
                        if (0 === i)
                            return this.hasRequireFailures()
                                ? ((this._timer = e(
                                      function () {
                                          (this.state = rb), this.tryEmit();
                                      },
                                      b.interval,
                                      this
                                  )),
                                  ob)
                                : rb;
                    }
                    return tb;
                },
                failTimeout: function () {
                    return (
                        (this._timer = e(
                            function () {
                                this.state = tb;
                            },
                            this.options.interval,
                            this
                        )),
                        tb
                    );
                },
                reset: function () {
                    clearTimeout(this._timer);
                },
                emit: function () {
                    this.state == rb && ((this._input.tapCount = this.count), this.manager.emit(this.options.event, this._input));
                },
            }),
            (ha.VERSION = "2.0.8"),
            (ha.defaults = {
                domEvents: !1,
                touchAction: gb,
                enable: !0,
                inputTarget: null,
                inputClass: null,
                preset: [[ea, { enable: !1 }], [ca, { enable: !1 }, ["rotate"]], [fa, { direction: Na }], [ba, { direction: Na }, ["swipe"]], [ga], [ga, { event: "doubletap", taps: 2 }, ["tap"]], [da]],
                cssProps: { userSelect: "none", touchSelect: "none", touchCallout: "none", contentZooming: "none", userDrag: "none", tapHighlightColor: "rgba(0,0,0,0)" },
            });
        var ub = 1,
            vb = 2;
        (ia.prototype = {
            set: function (a) {
                return la(this.options, a), a.touchAction && this.touchAction.update(), a.inputTarget && (this.input.destroy(), (this.input.target = a.inputTarget), this.input.init()), this;
            },
            stop: function (a) {
                this.session.stopped = a ? vb : ub;
            },
            recognize: function (a) {
                var b = this.session;
                if (!b.stopped) {
                    this.touchAction.preventDefaults(a);
                    var c,
                        d = this.recognizers,
                        e = b.curRecognizer;
                    (!e || (e && e.state & rb)) && (e = b.curRecognizer = null);
                    for (var f = 0; f < d.length; ) (c = d[f]), b.stopped === vb || (e && c != e && !c.canRecognizeWith(e)) ? c.reset() : c.recognize(a), !e && c.state & (ob | pb | qb) && (e = b.curRecognizer = c), f++;
                }
            },
            get: function (a) {
                if (a instanceof Y) return a;
                for (var b = this.recognizers, c = 0; c < b.length; c++) if (b[c].options.event == a) return b[c];
                return null;
            },
            add: function (a) {
                if (f(a, "add", this)) return this;
                var b = this.get(a.options.event);
                return b && this.remove(b), this.recognizers.push(a), (a.manager = this), this.touchAction.update(), a;
            },
            remove: function (a) {
                if (f(a, "remove", this)) return this;
                if ((a = this.get(a))) {
                    var b = this.recognizers,
                        c = r(b, a);
                    -1 !== c && (b.splice(c, 1), this.touchAction.update());
                }
                return this;
            },
            on: function (a, b) {
                if (a !== d && b !== d) {
                    var c = this.handlers;
                    return (
                        g(q(a), function (a) {
                            (c[a] = c[a] || []), c[a].push(b);
                        }),
                        this
                    );
                }
            },
            off: function (a, b) {
                if (a !== d) {
                    var c = this.handlers;
                    return (
                        g(q(a), function (a) {
                            b ? c[a] && c[a].splice(r(c[a], b), 1) : delete c[a];
                        }),
                        this
                    );
                }
            },
            emit: function (a, b) {
                this.options.domEvents && ka(a, b);
                var c = this.handlers[a] && this.handlers[a].slice();
                if (c && c.length) {
                    (b.type = a),
                        (b.preventDefault = function () {
                            b.srcEvent.preventDefault();
                        });
                    for (var d = 0; d < c.length; ) c[d](b), d++;
                }
            },
            destroy: function () {
                this.element && ja(this, !1), (this.handlers = {}), (this.session = {}), this.input.destroy(), (this.element = null);
            },
        }),
            la(ha, {
                INPUT_START: Ea,
                INPUT_MOVE: Fa,
                INPUT_END: Ga,
                INPUT_CANCEL: Ha,
                STATE_POSSIBLE: nb,
                STATE_BEGAN: ob,
                STATE_CHANGED: pb,
                STATE_ENDED: qb,
                STATE_RECOGNIZED: rb,
                STATE_CANCELLED: sb,
                STATE_FAILED: tb,
                DIRECTION_NONE: Ia,
                DIRECTION_LEFT: Ja,
                DIRECTION_RIGHT: Ka,
                DIRECTION_UP: La,
                DIRECTION_DOWN: Ma,
                DIRECTION_HORIZONTAL: Na,
                DIRECTION_VERTICAL: Oa,
                DIRECTION_ALL: Pa,
                Manager: ia,
                Input: x,
                TouchAction: V,
                TouchInput: P,
                MouseInput: L,
                PointerEventInput: M,
                TouchMouseInput: R,
                SingleTouchInput: N,
                Recognizer: Y,
                AttrRecognizer: aa,
                Tap: ga,
                Pan: ba,
                Swipe: fa,
                Pinch: ca,
                Rotate: ea,
                Press: da,
                on: m,
                off: n,
                each: g,
                merge: ta,
                extend: sa,
                assign: la,
                inherit: i,
                bindFn: j,
                prefixed: u,
            });
        var wb = "undefined" != typeof a ? a : "undefined" != typeof self ? self : {};
        (wb.Hammer = ha),
            "function" == typeof define && define.amd
                ? define(function () {
                      return ha;
                  })
                : "undefined" != typeof module && module.exports
                ? (module.exports = ha)
                : (a[c] = ha);
    })(window, document, "Hammer"),
    (function (a) {
        "function" == typeof define && define.amd ? define(["jquery", "hammerjs"], a) : "object" == typeof exports ? a(require("jquery"), require("hammerjs")) : a(jQuery, Hammer);
    })(function (a, b) {
        function c(c, d) {
            var e = a(c);
            e.data("hammer") || e.data("hammer", new b(e[0], d));
        }
        (a.fn.hammer = function (a) {
            return this.each(function () {
                c(this, a);
            });
        }),
            (b.Manager.prototype.emit = (function (b) {
                return function (c, d) {
                    b.call(this, c, d), a(this.element).trigger({ type: c, gesture: d });
                };
            })(b.Manager.prototype.emit));
    }),
    (function (a) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], a) : jQuery && !jQuery.fn.hoverIntent && a(jQuery);
    })(function (a) {
        "use strict";
        var b,
            c,
            d = { interval: 100, sensitivity: 6, timeout: 0 },
            e = 0,
            f = function (a) {
                (b = a.pageX), (c = a.pageY);
            },
            g = function (a, d, e, h) {
                return Math.sqrt((e.pX - b) * (e.pX - b) + (e.pY - c) * (e.pY - c)) < h.sensitivity
                    ? (d.off(e.event, f), delete e.timeoutId, (e.isActive = !0), (a.pageX = b), (a.pageY = c), delete e.pX, delete e.pY, h.over.apply(d[0], [a]))
                    : ((e.pX = b),
                      (e.pY = c),
                      (e.timeoutId = setTimeout(function () {
                          g(a, d, e, h);
                      }, h.interval)),
                      void 0);
            },
            h = function (a, b, c, d) {
                return delete b.data("hoverIntent")[c.id], d.apply(b[0], [a]);
            };
        a.fn.hoverIntent = function (b, c, i) {
            var j = e++,
                k = a.extend({}, d);
            a.isPlainObject(b) ? ((k = a.extend(k, b)), a.isFunction(k.out) || (k.out = k.over)) : (k = a.isFunction(c) ? a.extend(k, { over: b, out: c, selector: i }) : a.extend(k, { over: b, out: b, selector: c }));
            var l = function (b) {
                var c = a.extend({}, b),
                    d = a(this),
                    e = d.data("hoverIntent");
                e || d.data("hoverIntent", (e = {}));
                var i = e[j];
                i || (e[j] = i = { id: j }), i.timeoutId && (i.timeoutId = clearTimeout(i.timeoutId));
                var l = (i.event = "mousemove.hoverIntent.hoverIntent" + j);
                if ("mouseenter" === b.type) {
                    if (i.isActive) return;
                    (i.pX = c.pageX),
                        (i.pY = c.pageY),
                        d.off(l, f).on(l, f),
                        (i.timeoutId = setTimeout(function () {
                            g(c, d, i, k);
                        }, k.interval));
                } else {
                    if (!i.isActive) return;
                    d.off(l, f),
                        (i.timeoutId = setTimeout(function () {
                            h(c, d, i, k.out);
                        }, k.timeout));
                }
            };
            return this.on({ "mouseenter.hoverIntent": l, "mouseleave.hoverIntent": l }, k.selector);
        };
    }),
    (function (a) {
        function b() {}
        function c(a) {
            function c(b) {
                b.prototype.option ||
                    (b.prototype.option = function (b) {
                        a.isPlainObject(b) && (this.options = a.extend(!0, this.options, b));
                    });
            }
            function e(b, c) {
                a.fn[b] = function (e) {
                    if ("string" == typeof e) {
                        for (var g = d.call(arguments, 1), h = 0, i = this.length; h < i; h++) {
                            var j = this[h],
                                k = a.data(j, b);
                            if (k)
                                if (a.isFunction(k[e]) && "_" !== e.charAt(0)) {
                                    var l = k[e].apply(k, g);
                                    if (void 0 !== l) return l;
                                } else f("no such method '" + e + "' for " + b + " instance");
                            else f("cannot call methods on " + b + " prior to initialization; attempted to call '" + e + "'");
                        }
                        return this;
                    }
                    return this.each(function () {
                        var d = a.data(this, b);
                        d ? (d.option(e), d._init()) : ((d = new c(this, e)), a.data(this, b, d));
                    });
                };
            }
            if (a) {
                var f =
                    "undefined" == typeof console
                        ? b
                        : function (a) {
                              console.error(a);
                          };
                return (
                    (a.bridget = function (a, b) {
                        c(b), e(a, b);
                    }),
                    a.bridget
                );
            }
        }
        var d = Array.prototype.slice;
        "function" == typeof define && define.amd ? define("jquery-bridget/jquery.bridget", ["jquery"], c) : c("object" == typeof exports ? require("jquery") : a.jQuery);
    })(window),
    (function (a) {
        function b(b) {
            var c = a.event;
            return (c.target = c.target || c.srcElement || b), c;
        }
        var c = document.documentElement,
            d = function () {};
        c.addEventListener
            ? (d = function (a, b, c) {
                  a.addEventListener(b, c, !1);
              })
            : c.attachEvent &&
              (d = function (a, c, d) {
                  (a[c + d] = d.handleEvent
                      ? function () {
                            var c = b(a);
                            d.handleEvent.call(d, c);
                        }
                      : function () {
                            var c = b(a);
                            d.call(a, c);
                        }),
                      a.attachEvent("on" + c, a[c + d]);
              });
        var e = function () {};
        c.removeEventListener
            ? (e = function (a, b, c) {
                  a.removeEventListener(b, c, !1);
              })
            : c.detachEvent &&
              (e = function (a, b, c) {
                  a.detachEvent("on" + b, a[b + c]);
                  try {
                      delete a[b + c];
                  } catch (d) {
                      a[b + c] = void 0;
                  }
              });
        var f = { bind: d, unbind: e };
        "function" == typeof define && define.amd ? define("eventie/eventie", f) : "object" == typeof exports ? (module.exports = f) : (a.eventie = f);
    })(window),
    function () {
        "use strict";
        function a() {}
        function b(a, b) {
            for (var c = a.length; c--; ) if (a[c].listener === b) return c;
            return -1;
        }
        function c(a) {
            return function () {
                return this[a].apply(this, arguments);
            };
        }
        var d = a.prototype,
            e = this,
            f = e.EventEmitter;
        (d.getListeners = function (a) {
            var b,
                c,
                d = this._getEvents();
            if (a instanceof RegExp) {
                b = {};
                for (c in d) d.hasOwnProperty(c) && a.test(c) && (b[c] = d[c]);
            } else b = d[a] || (d[a] = []);
            return b;
        }),
            (d.flattenListeners = function (a) {
                var b,
                    c = [];
                for (b = 0; b < a.length; b += 1) c.push(a[b].listener);
                return c;
            }),
            (d.getListenersAsObject = function (a) {
                var b,
                    c = this.getListeners(a);
                return c instanceof Array && ((b = {}), (b[a] = c)), b || c;
            }),
            (d.addListener = function (a, c) {
                var d,
                    e = this.getListenersAsObject(a),
                    f = "object" == typeof c;
                for (d in e) e.hasOwnProperty(d) && b(e[d], c) === -1 && e[d].push(f ? c : { listener: c, once: !1 });
                return this;
            }),
            (d.on = c("addListener")),
            (d.addOnceListener = function (a, b) {
                return this.addListener(a, { listener: b, once: !0 });
            }),
            (d.once = c("addOnceListener")),
            (d.defineEvent = function (a) {
                return this.getListeners(a), this;
            }),
            (d.defineEvents = function (a) {
                for (var b = 0; b < a.length; b += 1) this.defineEvent(a[b]);
                return this;
            }),
            (d.removeListener = function (a, c) {
                var d,
                    e,
                    f = this.getListenersAsObject(a);
                for (e in f) f.hasOwnProperty(e) && ((d = b(f[e], c)), d !== -1 && f[e].splice(d, 1));
                return this;
            }),
            (d.off = c("removeListener")),
            (d.addListeners = function (a, b) {
                return this.manipulateListeners(!1, a, b);
            }),
            (d.removeListeners = function (a, b) {
                return this.manipulateListeners(!0, a, b);
            }),
            (d.manipulateListeners = function (a, b, c) {
                var d,
                    e,
                    f = a ? this.removeListener : this.addListener,
                    g = a ? this.removeListeners : this.addListeners;
                if ("object" != typeof b || b instanceof RegExp) for (d = c.length; d--; ) f.call(this, b, c[d]);
                else for (d in b) b.hasOwnProperty(d) && (e = b[d]) && ("function" == typeof e ? f.call(this, d, e) : g.call(this, d, e));
                return this;
            }),
            (d.removeEvent = function (a) {
                var b,
                    c = typeof a,
                    d = this._getEvents();
                if ("string" === c) delete d[a];
                else if (a instanceof RegExp) for (b in d) d.hasOwnProperty(b) && a.test(b) && delete d[b];
                else delete this._events;
                return this;
            }),
            (d.removeAllListeners = c("removeEvent")),
            (d.emitEvent = function (a, b) {
                var c,
                    d,
                    e,
                    f,
                    g = this.getListenersAsObject(a);
                for (e in g)
                    if (g.hasOwnProperty(e))
                        for (d = g[e].length; d--; ) (c = g[e][d]), c.once === !0 && this.removeListener(a, c.listener), (f = c.listener.apply(this, b || [])), f === this._getOnceReturnValue() && this.removeListener(a, c.listener);
                return this;
            }),
            (d.trigger = c("emitEvent")),
            (d.emit = function (a) {
                var b = Array.prototype.slice.call(arguments, 1);
                return this.emitEvent(a, b);
            }),
            (d.setOnceReturnValue = function (a) {
                return (this._onceReturnValue = a), this;
            }),
            (d._getOnceReturnValue = function () {
                return !this.hasOwnProperty("_onceReturnValue") || this._onceReturnValue;
            }),
            (d._getEvents = function () {
                return this._events || (this._events = {});
            }),
            (a.noConflict = function () {
                return (e.EventEmitter = f), a;
            }),
            "function" == typeof define && define.amd
                ? define("eventEmitter/EventEmitter", [], function () {
                      return a;
                  })
                : "object" == typeof module && module.exports
                ? (module.exports = a)
                : (e.EventEmitter = a);
    }.call(this),
    (function (a) {
        function b(a) {
            if (a) {
                if ("string" == typeof d[a]) return a;
                a = a.charAt(0).toUpperCase() + a.slice(1);
                for (var b, e = 0, f = c.length; e < f; e++) if (((b = c[e] + a), "string" == typeof d[b])) return b;
            }
        }
        var c = "Webkit Moz ms Ms O".split(" "),
            d = document.documentElement.style;
        "function" == typeof define && define.amd
            ? define("get-style-property/get-style-property", [], function () {
                  return b;
              })
            : "object" == typeof exports
            ? (module.exports = b)
            : (a.getStyleProperty = b);
    })(window),
    (function (a, b) {
        function c(a) {
            var b = parseFloat(a),
                c = a.indexOf("%") === -1 && !isNaN(b);
            return c && b;
        }
        function d() {}
        function e() {
            for (var a = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, b = 0, c = h.length; b < c; b++) {
                var d = h[b];
                a[d] = 0;
            }
            return a;
        }
        function f(b) {
            function d() {
                if (!m) {
                    m = !0;
                    var d = a.getComputedStyle;
                    if (
                        ((j = (function () {
                            var a = d
                                ? function (a) {
                                      return d(a, null);
                                  }
                                : function (a) {
                                      return a.currentStyle;
                                  };
                            return function (b) {
                                var c = a(b);
                                return c || g("Style returned " + c + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"), c;
                            };
                        })()),
                        (k = b("boxSizing")))
                    ) {
                        var e = document.createElement("div");
                        (e.style.width = "200px"), (e.style.padding = "1px 2px 3px 4px"), (e.style.borderStyle = "solid"), (e.style.borderWidth = "1px 2px 3px 4px"), (e.style[k] = "border-box");
                        var f = document.body || document.documentElement;
                        f.appendChild(e);
                        var h = j(e);
                        (l = 200 === c(h.width)), f.removeChild(e);
                    }
                }
            }
            function f(a) {
                if ((d(), "string" == typeof a && (a = document.querySelector(a)), a && "object" == typeof a && a.nodeType)) {
                    var b = j(a);
                    if ("none" === b.display) return e();
                    var f = {};
                    (f.width = a.offsetWidth), (f.height = a.offsetHeight);
                    for (var g = (f.isBorderBox = !(!k || !b[k] || "border-box" !== b[k])), m = 0, n = h.length; m < n; m++) {
                        var o = h[m],
                            p = b[o];
                        p = i(a, p);
                        var q = parseFloat(p);
                        f[o] = isNaN(q) ? 0 : q;
                    }
                    var r = f.paddingLeft + f.paddingRight,
                        s = f.paddingTop + f.paddingBottom,
                        t = f.marginLeft + f.marginRight,
                        u = f.marginTop + f.marginBottom,
                        v = f.borderLeftWidth + f.borderRightWidth,
                        w = f.borderTopWidth + f.borderBottomWidth,
                        x = g && l,
                        y = c(b.width);
                    y !== !1 && (f.width = y + (x ? 0 : r + v));
                    var z = c(b.height);
                    return z !== !1 && (f.height = z + (x ? 0 : s + w)), (f.innerWidth = f.width - (r + v)), (f.innerHeight = f.height - (s + w)), (f.outerWidth = f.width + t), (f.outerHeight = f.height + u), f;
                }
            }
            function i(b, c) {
                if (a.getComputedStyle || c.indexOf("%") === -1) return c;
                var d = b.style,
                    e = d.left,
                    f = b.runtimeStyle,
                    g = f && f.left;
                return g && (f.left = b.currentStyle.left), (d.left = c), (c = d.pixelLeft), (d.left = e), g && (f.left = g), c;
            }
            var j,
                k,
                l,
                m = !1;
            return f;
        }
        var g =
                "undefined" == typeof console
                    ? d
                    : function (a) {
                          console.error(a);
                      },
            h = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"];
        "function" == typeof define && define.amd
            ? define("get-size/get-size", ["get-style-property/get-style-property"], f)
            : "object" == typeof exports
            ? (module.exports = f(require("desandro-get-style-property")))
            : (a.getSize = f(a.getStyleProperty));
    })(window),
    (function (a) {
        function b(a) {
            "function" == typeof a && (b.isReady ? a() : g.push(a));
        }
        function c(a) {
            var c = "readystatechange" === a.type && "complete" !== f.readyState;
            b.isReady || c || d();
        }
        function d() {
            b.isReady = !0;
            for (var a = 0, c = g.length; a < c; a++) {
                var d = g[a];
                d();
            }
        }
        function e(e) {
            return "complete" === f.readyState ? d() : (e.bind(f, "DOMContentLoaded", c), e.bind(f, "readystatechange", c), e.bind(a, "load", c)), b;
        }
        var f = a.document,
            g = [];
        (b.isReady = !1), "function" == typeof define && define.amd ? define("doc-ready/doc-ready", ["eventie/eventie"], e) : "object" == typeof exports ? (module.exports = e(require("eventie"))) : (a.docReady = e(a.eventie));
    })(window),
    (function (a) {
        "use strict";
        function b(a, b) {
            return a[g](b);
        }
        function c(a) {
            if (!a.parentNode) {
                var b = document.createDocumentFragment();
                b.appendChild(a);
            }
        }
        function d(a, b) {
            c(a);
            for (var d = a.parentNode.querySelectorAll(b), e = 0, f = d.length; e < f; e++) if (d[e] === a) return !0;
            return !1;
        }
        function e(a, d) {
            return c(a), b(a, d);
        }
        var f,
            g = (function () {
                if (a.matches) return "matches";
                if (a.matchesSelector) return "matchesSelector";
                for (var b = ["webkit", "moz", "ms", "o"], c = 0, d = b.length; c < d; c++) {
                    var e = b[c],
                        f = e + "MatchesSelector";
                    if (a[f]) return f;
                }
            })();
        if (g) {
            var h = document.createElement("div"),
                i = b(h, "div");
            f = i ? b : e;
        } else f = d;
        "function" == typeof define && define.amd
            ? define("matches-selector/matches-selector", [], function () {
                  return f;
              })
            : "object" == typeof exports
            ? (module.exports = f)
            : (window.matchesSelector = f);
    })(Element.prototype),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("fizzy-ui-utils/utils", ["doc-ready/doc-ready", "matches-selector/matches-selector"], function (c, d) {
                  return b(a, c, d);
              })
            : "object" == typeof exports
            ? (module.exports = b(a, require("doc-ready"), require("desandro-matches-selector")))
            : (a.fizzyUIUtils = b(a, a.docReady, a.matchesSelector));
    })(window, function (a, b, c) {
        var d = {};
        (d.extend = function (a, b) {
            for (var c in b) a[c] = b[c];
            return a;
        }),
            (d.modulo = function (a, b) {
                return ((a % b) + b) % b;
            });
        var e = Object.prototype.toString;
        (d.isArray = function (a) {
            return "[object Array]" == e.call(a);
        }),
            (d.makeArray = function (a) {
                var b = [];
                if (d.isArray(a)) b = a;
                else if (a && "number" == typeof a.length) for (var c = 0, e = a.length; c < e; c++) b.push(a[c]);
                else b.push(a);
                return b;
            }),
            (d.indexOf = Array.prototype.indexOf
                ? function (a, b) {
                      return a.indexOf(b);
                  }
                : function (a, b) {
                      for (var c = 0, d = a.length; c < d; c++) if (a[c] === b) return c;
                      return -1;
                  }),
            (d.removeFrom = function (a, b) {
                var c = d.indexOf(a, b);
                c != -1 && a.splice(c, 1);
            }),
            (d.isElement =
                "function" == typeof HTMLElement || "object" == typeof HTMLElement
                    ? function (a) {
                          return a instanceof HTMLElement;
                      }
                    : function (a) {
                          return a && "object" == typeof a && 1 == a.nodeType && "string" == typeof a.nodeName;
                      }),
            (d.setText = (function () {
                function a(a, c) {
                    (b = b || (void 0 !== document.documentElement.textContent ? "textContent" : "innerText")), (a[b] = c);
                }
                var b;
                return a;
            })()),
            (d.getParent = function (a, b) {
                for (; a != document.body; ) if (((a = a.parentNode), c(a, b))) return a;
            }),
            (d.getQueryElement = function (a) {
                return "string" == typeof a ? document.querySelector(a) : a;
            }),
            (d.handleEvent = function (a) {
                var b = "on" + a.type;
                this[b] && this[b](a);
            }),
            (d.filterFindElements = function (a, b) {
                a = d.makeArray(a);
                for (var e = [], f = 0, g = a.length; f < g; f++) {
                    var h = a[f];
                    if (d.isElement(h))
                        if (b) {
                            c(h, b) && e.push(h);
                            for (var i = h.querySelectorAll(b), j = 0, k = i.length; j < k; j++) e.push(i[j]);
                        } else e.push(h);
                }
                return e;
            }),
            (d.debounceMethod = function (a, b, c) {
                var d = a.prototype[b],
                    e = b + "Timeout";
                a.prototype[b] = function () {
                    var a = this[e];
                    a && clearTimeout(a);
                    var b = arguments,
                        f = this;
                    this[e] = setTimeout(function () {
                        d.apply(f, b), delete f[e];
                    }, c || 100);
                };
            }),
            (d.toDashed = function (a) {
                return a
                    .replace(/(.)([A-Z])/g, function (a, b, c) {
                        return b + "-" + c;
                    })
                    .toLowerCase();
            });
        var f = a.console;
        return (
            (d.htmlInit = function (c, e) {
                b(function () {
                    for (var b = d.toDashed(e), g = document.querySelectorAll(".js-" + b), h = "data-" + b + "-options", i = 0, j = g.length; i < j; i++) {
                        var k,
                            l = g[i],
                            m = l.getAttribute(h);
                        try {
                            k = m && JSON.parse(m);
                        } catch (n) {
                            f && f.error("Error parsing " + h + " on " + l.nodeName.toLowerCase() + (l.id ? "#" + l.id : "") + ": " + n);
                            continue;
                        }
                        var o = new c(l, k),
                            p = a.jQuery;
                        p && p.data(l, e, o);
                    }
                });
            }),
            d
        );
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("outlayer/item", ["eventEmitter/EventEmitter", "get-size/get-size", "get-style-property/get-style-property", "fizzy-ui-utils/utils"], function (c, d, e, f) {
                  return b(a, c, d, e, f);
              })
            : "object" == typeof exports
            ? (module.exports = b(a, require("wolfy87-eventemitter"), require("get-size"), require("desandro-get-style-property"), require("fizzy-ui-utils")))
            : ((a.Outlayer = {}), (a.Outlayer.Item = b(a, a.EventEmitter, a.getSize, a.getStyleProperty, a.fizzyUIUtils)));
    })(window, function (a, b, c, d, e) {
        "use strict";
        function f(a) {
            for (var b in a) return !1;
            return (b = null), !0;
        }
        function g(a, b) {
            a && ((this.element = a), (this.layout = b), (this.position = { x: 0, y: 0 }), this._create());
        }
        function h(a) {
            return a.replace(/([A-Z])/g, function (a) {
                return "-" + a.toLowerCase();
            });
        }
        var i = a.getComputedStyle,
            j = i
                ? function (a) {
                      return i(a, null);
                  }
                : function (a) {
                      return a.currentStyle;
                  },
            k = d("transition"),
            l = d("transform"),
            m = k && l,
            n = !!d("perspective"),
            o = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "otransitionend", transition: "transitionend" }[k],
            p = ["transform", "transition", "transitionDuration", "transitionProperty"],
            q = (function () {
                for (var a = {}, b = 0, c = p.length; b < c; b++) {
                    var e = p[b],
                        f = d(e);
                    f && f !== e && (a[e] = f);
                }
                return a;
            })();
        e.extend(g.prototype, b.prototype),
            (g.prototype._create = function () {
                (this._transn = { ingProperties: {}, clean: {}, onEnd: {} }), this.css({ position: "absolute" });
            }),
            (g.prototype.handleEvent = function (a) {
                var b = "on" + a.type;
                this[b] && this[b](a);
            }),
            (g.prototype.getSize = function () {
                this.size = c(this.element);
            }),
            (g.prototype.css = function (a) {
                var b = this.element.style;
                for (var c in a) {
                    var d = q[c] || c;
                    b[d] = a[c];
                }
            }),
            (g.prototype.getPosition = function () {
                var a = j(this.element),
                    b = this.layout.options,
                    c = b.isOriginLeft,
                    d = b.isOriginTop,
                    e = a[c ? "left" : "right"],
                    f = a[d ? "top" : "bottom"],
                    g = this.layout.size,
                    h = e.indexOf("%") != -1 ? (parseFloat(e) / 100) * g.width : parseInt(e, 10),
                    i = f.indexOf("%") != -1 ? (parseFloat(f) / 100) * g.height : parseInt(f, 10);
                (h = isNaN(h) ? 0 : h), (i = isNaN(i) ? 0 : i), (h -= c ? g.paddingLeft : g.paddingRight), (i -= d ? g.paddingTop : g.paddingBottom), (this.position.x = h), (this.position.y = i);
            }),
            (g.prototype.layoutPosition = function () {
                var a = this.layout.size,
                    b = this.layout.options,
                    c = {},
                    d = b.isOriginLeft ? "paddingLeft" : "paddingRight",
                    e = b.isOriginLeft ? "left" : "right",
                    f = b.isOriginLeft ? "right" : "left",
                    g = this.position.x + a[d];
                (c[e] = this.getXValue(g)), (c[f] = "");
                var h = b.isOriginTop ? "paddingTop" : "paddingBottom",
                    i = b.isOriginTop ? "top" : "bottom",
                    j = b.isOriginTop ? "bottom" : "top",
                    k = this.position.y + a[h];
                (c[i] = this.getYValue(k)), (c[j] = ""), this.css(c), this.emitEvent("layout", [this]);
            }),
            (g.prototype.getXValue = function (a) {
                var b = this.layout.options;
                return b.percentPosition && !b.isHorizontal ? (a / this.layout.size.width) * 100 + "%" : a + "px";
            }),
            (g.prototype.getYValue = function (a) {
                var b = this.layout.options;
                return b.percentPosition && b.isHorizontal ? (a / this.layout.size.height) * 100 + "%" : a + "px";
            }),
            (g.prototype._transitionTo = function (a, b) {
                this.getPosition();
                var c = this.position.x,
                    d = this.position.y,
                    e = parseInt(a, 10),
                    f = parseInt(b, 10),
                    g = e === this.position.x && f === this.position.y;
                if ((this.setPosition(a, b), g && !this.isTransitioning)) return void this.layoutPosition();
                var h = a - c,
                    i = b - d,
                    j = {};
                (j.transform = this.getTranslate(h, i)), this.transition({ to: j, onTransitionEnd: { transform: this.layoutPosition }, isCleaning: !0 });
            }),
            (g.prototype.getTranslate = function (a, b) {
                var c = this.layout.options;
                return (a = c.isOriginLeft ? a : -a), (b = c.isOriginTop ? b : -b), n ? "translate3d(" + a + "px, " + b + "px, 0)" : "translate(" + a + "px, " + b + "px)";
            }),
            (g.prototype.goTo = function (a, b) {
                this.setPosition(a, b), this.layoutPosition();
            }),
            (g.prototype.moveTo = m ? g.prototype._transitionTo : g.prototype.goTo),
            (g.prototype.setPosition = function (a, b) {
                (this.position.x = parseInt(a, 10)), (this.position.y = parseInt(b, 10));
            }),
            (g.prototype._nonTransition = function (a) {
                this.css(a.to), a.isCleaning && this._removeStyles(a.to);
                for (var b in a.onTransitionEnd) a.onTransitionEnd[b].call(this);
            }),
            (g.prototype._transition = function (a) {
                if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(a);
                var b = this._transn;
                for (var c in a.onTransitionEnd) b.onEnd[c] = a.onTransitionEnd[c];
                for (c in a.to) (b.ingProperties[c] = !0), a.isCleaning && (b.clean[c] = !0);
                if (a.from) {
                    this.css(a.from);
                    var d = this.element.offsetHeight;
                    d = null;
                }
                this.enableTransition(a.to), this.css(a.to), (this.isTransitioning = !0);
            });
        var r = "opacity," + h(q.transform || "transform");
        (g.prototype.enableTransition = function () {
            this.isTransitioning || (this.css({ transitionProperty: r, transitionDuration: this.layout.options.transitionDuration }), this.element.addEventListener(o, this, !1));
        }),
            (g.prototype.transition = g.prototype[k ? "_transition" : "_nonTransition"]),
            (g.prototype.onwebkitTransitionEnd = function (a) {
                this.ontransitionend(a);
            }),
            (g.prototype.onotransitionend = function (a) {
                this.ontransitionend(a);
            });
        var s = { "-webkit-transform": "transform", "-moz-transform": "transform", "-o-transform": "transform" };
        (g.prototype.ontransitionend = function (a) {
            if (a.target === this.element) {
                var b = this._transn,
                    c = s[a.propertyName] || a.propertyName;
                if ((delete b.ingProperties[c], f(b.ingProperties) && this.disableTransition(), c in b.clean && ((this.element.style[a.propertyName] = ""), delete b.clean[c]), c in b.onEnd)) {
                    var d = b.onEnd[c];
                    d.call(this), delete b.onEnd[c];
                }
                this.emitEvent("transitionEnd", [this]);
            }
        }),
            (g.prototype.disableTransition = function () {
                this.removeTransitionStyles(), this.element.removeEventListener(o, this, !1), (this.isTransitioning = !1);
            }),
            (g.prototype._removeStyles = function (a) {
                var b = {};
                for (var c in a) b[c] = "";
                this.css(b);
            });
        var t = { transitionProperty: "", transitionDuration: "" };
        return (
            (g.prototype.removeTransitionStyles = function () {
                this.css(t);
            }),
            (g.prototype.removeElem = function () {
                this.element.parentNode.removeChild(this.element), this.css({ display: "" }), this.emitEvent("remove", [this]);
            }),
            (g.prototype.remove = function () {
                if (!k || !parseFloat(this.layout.options.transitionDuration)) return void this.removeElem();
                var a = this;
                this.once("transitionEnd", function () {
                    a.removeElem();
                }),
                    this.hide();
            }),
            (g.prototype.reveal = function () {
                delete this.isHidden, this.css({ display: "" });
                var a = this.layout.options,
                    b = {},
                    c = this.getHideRevealTransitionEndProperty("visibleStyle");
                (b[c] = this.onRevealTransitionEnd), this.transition({ from: a.hiddenStyle, to: a.visibleStyle, isCleaning: !0, onTransitionEnd: b });
            }),
            (g.prototype.onRevealTransitionEnd = function () {
                this.isHidden || this.emitEvent("reveal");
            }),
            (g.prototype.getHideRevealTransitionEndProperty = function (a) {
                var b = this.layout.options[a];
                if (b.opacity) return "opacity";
                for (var c in b) return c;
            }),
            (g.prototype.hide = function () {
                (this.isHidden = !0), this.css({ display: "" });
                var a = this.layout.options,
                    b = {},
                    c = this.getHideRevealTransitionEndProperty("hiddenStyle");
                (b[c] = this.onHideTransitionEnd), this.transition({ from: a.visibleStyle, to: a.hiddenStyle, isCleaning: !0, onTransitionEnd: b });
            }),
            (g.prototype.onHideTransitionEnd = function () {
                this.isHidden && (this.css({ display: "none" }), this.emitEvent("hide"));
            }),
            (g.prototype.destroy = function () {
                this.css({ position: "", left: "", right: "", top: "", bottom: "", transition: "", transform: "" });
            }),
            g
        );
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("outlayer/outlayer", ["eventie/eventie", "eventEmitter/EventEmitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function (c, d, e, f, g) {
                  return b(a, c, d, e, f, g);
              })
            : "object" == typeof exports
            ? (module.exports = b(a, require("eventie"), require("wolfy87-eventemitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")))
            : (a.Outlayer = b(a, a.eventie, a.EventEmitter, a.getSize, a.fizzyUIUtils, a.Outlayer.Item));
    })(window, function (a, b, c, d, e, f) {
        "use strict";
        function g(a, b) {
            var c = e.getQueryElement(a);
            if (!c) return void (h && h.error("Bad element for " + this.constructor.namespace + ": " + (c || a)));
            (this.element = c), i && (this.$element = i(this.element)), (this.options = e.extend({}, this.constructor.defaults)), this.option(b);
            var d = ++k;
            (this.element.outlayerGUID = d), (l[d] = this), this._create(), this.options.isInitLayout && this.layout();
        }
        var h = a.console,
            i = a.jQuery,
            j = function () {},
            k = 0,
            l = {};
        return (
            (g.namespace = "outlayer"),
            (g.Item = f),
            (g.defaults = {
                containerStyle: { position: "relative" },
                isInitLayout: !0,
                isOriginLeft: !0,
                isOriginTop: !0,
                isResizeBound: !0,
                isResizingContainer: !0,
                transitionDuration: "0.4s",
                hiddenStyle: { opacity: 0, transform: "scale(0.001)" },
                visibleStyle: { opacity: 1, transform: "scale(1)" },
            }),
            e.extend(g.prototype, c.prototype),
            (g.prototype.option = function (a) {
                e.extend(this.options, a);
            }),
            (g.prototype._create = function () {
                this.reloadItems(), (this.stamps = []), this.stamp(this.options.stamp), e.extend(this.element.style, this.options.containerStyle), this.options.isResizeBound && this.bindResize();
            }),
            (g.prototype.reloadItems = function () {
                this.items = this._itemize(this.element.children);
            }),
            (g.prototype._itemize = function (a) {
                for (var b = this._filterFindItemElements(a), c = this.constructor.Item, d = [], e = 0, f = b.length; e < f; e++) {
                    var g = b[e],
                        h = new c(g, this);
                    d.push(h);
                }
                return d;
            }),
            (g.prototype._filterFindItemElements = function (a) {
                return e.filterFindElements(a, this.options.itemSelector);
            }),
            (g.prototype.getItemElements = function () {
                for (var a = [], b = 0, c = this.items.length; b < c; b++) a.push(this.items[b].element);
                return a;
            }),
            (g.prototype.layout = function () {
                this._resetLayout(), this._manageStamps();
                var a = void 0 !== this.options.isLayoutInstant ? this.options.isLayoutInstant : !this._isLayoutInited;
                this.layoutItems(this.items, a), (this._isLayoutInited = !0);
            }),
            (g.prototype._init = g.prototype.layout),
            (g.prototype._resetLayout = function () {
                this.getSize();
            }),
            (g.prototype.getSize = function () {
                this.size = d(this.element);
            }),
            (g.prototype._getMeasurement = function (a, b) {
                var c,
                    f = this.options[a];
                f ? ("string" == typeof f ? (c = this.element.querySelector(f)) : e.isElement(f) && (c = f), (this[a] = c ? d(c)[b] : f)) : (this[a] = 0);
            }),
            (g.prototype.layoutItems = function (a, b) {
                (a = this._getItemsForLayout(a)), this._layoutItems(a, b), this._postLayout();
            }),
            (g.prototype._getItemsForLayout = function (a) {
                for (var b = [], c = 0, d = a.length; c < d; c++) {
                    var e = a[c];
                    e.isIgnored || b.push(e);
                }
                return b;
            }),
            (g.prototype._layoutItems = function (a, b) {
                if ((this._emitCompleteOnItems("layout", a), a && a.length)) {
                    for (var c = [], d = 0, e = a.length; d < e; d++) {
                        var f = a[d],
                            g = this._getItemLayoutPosition(f);
                        (g.item = f), (g.isInstant = b || f.isLayoutInstant), c.push(g);
                    }
                    this._processLayoutQueue(c);
                }
            }),
            (g.prototype._getItemLayoutPosition = function () {
                return { x: 0, y: 0 };
            }),
            (g.prototype._processLayoutQueue = function (a) {
                for (var b = 0, c = a.length; b < c; b++) {
                    var d = a[b];
                    this._positionItem(d.item, d.x, d.y, d.isInstant);
                }
            }),
            (g.prototype._positionItem = function (a, b, c, d) {
                d ? a.goTo(b, c) : a.moveTo(b, c);
            }),
            (g.prototype._postLayout = function () {
                this.resizeContainer();
            }),
            (g.prototype.resizeContainer = function () {
                if (this.options.isResizingContainer) {
                    var a = this._getContainerSize();
                    a && (this._setContainerMeasure(a.width, !0), this._setContainerMeasure(a.height, !1));
                }
            }),
            (g.prototype._getContainerSize = j),
            (g.prototype._setContainerMeasure = function (a, b) {
                if (void 0 !== a) {
                    var c = this.size;
                    c.isBorderBox && (a += b ? c.paddingLeft + c.paddingRight + c.borderLeftWidth + c.borderRightWidth : c.paddingBottom + c.paddingTop + c.borderTopWidth + c.borderBottomWidth),
                        (a = Math.max(a, 0)),
                        (this.element.style[b ? "width" : "height"] = a + "px");
                }
            }),
            (g.prototype._emitCompleteOnItems = function (a, b) {
                function c() {
                    e.dispatchEvent(a + "Complete", null, [b]);
                }
                function d() {
                    g++, g === f && c();
                }
                var e = this,
                    f = b.length;
                if (!b || !f) return void c();
                for (var g = 0, h = 0, i = b.length; h < i; h++) {
                    var j = b[h];
                    j.once(a, d);
                }
            }),
            (g.prototype.dispatchEvent = function (a, b, c) {
                var d = b ? [b].concat(c) : c;
                if ((this.emitEvent(a, d), i))
                    if (((this.$element = this.$element || i(this.element)), b)) {
                        var e = i.Event(b);
                        (e.type = a), this.$element.trigger(e, c);
                    } else this.$element.trigger(a, c);
            }),
            (g.prototype.ignore = function (a) {
                var b = this.getItem(a);
                b && (b.isIgnored = !0);
            }),
            (g.prototype.unignore = function (a) {
                var b = this.getItem(a);
                b && delete b.isIgnored;
            }),
            (g.prototype.stamp = function (a) {
                if ((a = this._find(a))) {
                    this.stamps = this.stamps.concat(a);
                    for (var b = 0, c = a.length; b < c; b++) {
                        var d = a[b];
                        this.ignore(d);
                    }
                }
            }),
            (g.prototype.unstamp = function (a) {
                if ((a = this._find(a)))
                    for (var b = 0, c = a.length; b < c; b++) {
                        var d = a[b];
                        e.removeFrom(this.stamps, d), this.unignore(d);
                    }
            }),
            (g.prototype._find = function (a) {
                if (a) return "string" == typeof a && (a = this.element.querySelectorAll(a)), (a = e.makeArray(a));
            }),
            (g.prototype._manageStamps = function () {
                if (this.stamps && this.stamps.length) {
                    this._getBoundingRect();
                    for (var a = 0, b = this.stamps.length; a < b; a++) {
                        var c = this.stamps[a];
                        this._manageStamp(c);
                    }
                }
            }),
            (g.prototype._getBoundingRect = function () {
                var a = this.element.getBoundingClientRect(),
                    b = this.size;
                this._boundingRect = {
                    left: a.left + b.paddingLeft + b.borderLeftWidth,
                    top: a.top + b.paddingTop + b.borderTopWidth,
                    right: a.right - (b.paddingRight + b.borderRightWidth),
                    bottom: a.bottom - (b.paddingBottom + b.borderBottomWidth),
                };
            }),
            (g.prototype._manageStamp = j),
            (g.prototype._getElementOffset = function (a) {
                var b = a.getBoundingClientRect(),
                    c = this._boundingRect,
                    e = d(a),
                    f = { left: b.left - c.left - e.marginLeft, top: b.top - c.top - e.marginTop, right: c.right - b.right - e.marginRight, bottom: c.bottom - b.bottom - e.marginBottom };
                return f;
            }),
            (g.prototype.handleEvent = function (a) {
                var b = "on" + a.type;
                this[b] && this[b](a);
            }),
            (g.prototype.bindResize = function () {
                this.isResizeBound || (b.bind(a, "resize", this), (this.isResizeBound = !0));
            }),
            (g.prototype.unbindResize = function () {
                this.isResizeBound && b.unbind(a, "resize", this), (this.isResizeBound = !1);
            }),
            (g.prototype.onresize = function () {
                function a() {
                    b.resize(), delete b.resizeTimeout;
                }
                this.resizeTimeout && clearTimeout(this.resizeTimeout);
                var b = this;
                this.resizeTimeout = setTimeout(a, 100);
            }),
            (g.prototype.resize = function () {
                this.isResizeBound && this.needsResizeLayout() && this.layout();
            }),
            (g.prototype.needsResizeLayout = function () {
                var a = d(this.element),
                    b = this.size && a;
                return b && a.innerWidth !== this.size.innerWidth;
            }),
            (g.prototype.addItems = function (a) {
                var b = this._itemize(a);
                return b.length && (this.items = this.items.concat(b)), b;
            }),
            (g.prototype.appended = function (a) {
                var b = this.addItems(a);
                b.length && (this.layoutItems(b, !0), this.reveal(b));
            }),
            (g.prototype.prepended = function (a) {
                var b = this._itemize(a);
                if (b.length) {
                    var c = this.items.slice(0);
                    (this.items = b.concat(c)), this._resetLayout(), this._manageStamps(), this.layoutItems(b, !0), this.reveal(b), this.layoutItems(c);
                }
            }),
            (g.prototype.reveal = function (a) {
                this._emitCompleteOnItems("reveal", a);
                for (var b = a && a.length, c = 0; b && c < b; c++) {
                    var d = a[c];
                    d.reveal();
                }
            }),
            (g.prototype.hide = function (a) {
                this._emitCompleteOnItems("hide", a);
                for (var b = a && a.length, c = 0; b && c < b; c++) {
                    var d = a[c];
                    d.hide();
                }
            }),
            (g.prototype.revealItemElements = function (a) {
                var b = this.getItems(a);
                this.reveal(b);
            }),
            (g.prototype.hideItemElements = function (a) {
                var b = this.getItems(a);
                this.hide(b);
            }),
            (g.prototype.getItem = function (a) {
                for (var b = 0, c = this.items.length; b < c; b++) {
                    var d = this.items[b];
                    if (d.element === a) return d;
                }
            }),
            (g.prototype.getItems = function (a) {
                a = e.makeArray(a);
                for (var b = [], c = 0, d = a.length; c < d; c++) {
                    var f = a[c],
                        g = this.getItem(f);
                    g && b.push(g);
                }
                return b;
            }),
            (g.prototype.remove = function (a) {
                var b = this.getItems(a);
                if ((this._emitCompleteOnItems("remove", b), b && b.length))
                    for (var c = 0, d = b.length; c < d; c++) {
                        var f = b[c];
                        f.remove(), e.removeFrom(this.items, f);
                    }
            }),
            (g.prototype.destroy = function () {
                var a = this.element.style;
                (a.height = ""), (a.position = ""), (a.width = "");
                for (var b = 0, c = this.items.length; b < c; b++) {
                    var d = this.items[b];
                    d.destroy();
                }
                this.unbindResize();
                var e = this.element.outlayerGUID;
                delete l[e], delete this.element.outlayerGUID, i && i.removeData(this.element, this.constructor.namespace);
            }),
            (g.data = function (a) {
                a = e.getQueryElement(a);
                var b = a && a.outlayerGUID;
                return b && l[b];
            }),
            (g.create = function (a, b) {
                function c() {
                    g.apply(this, arguments);
                }
                return (
                    Object.create ? (c.prototype = Object.create(g.prototype)) : e.extend(c.prototype, g.prototype),
                    (c.prototype.constructor = c),
                    (c.defaults = e.extend({}, g.defaults)),
                    e.extend(c.defaults, b),
                    (c.prototype.settings = {}),
                    (c.namespace = a),
                    (c.data = g.data),
                    (c.Item = function () {
                        f.apply(this, arguments);
                    }),
                    (c.Item.prototype = new f()),
                    e.htmlInit(c, a),
                    i && i.bridget && i.bridget(a, c),
                    c
                );
            }),
            (g.Item = f),
            g
        );
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("isotope/js/item", ["outlayer/outlayer"], b)
            : "object" == typeof exports
            ? (module.exports = b(require("outlayer")))
            : ((a.Isotope = a.Isotope || {}), (a.Isotope.Item = b(a.Outlayer)));
    })(window, function (a) {
        "use strict";
        function b() {
            a.Item.apply(this, arguments);
        }
        (b.prototype = new a.Item()),
            (b.prototype._create = function () {
                (this.id = this.layout.itemGUID++), a.Item.prototype._create.call(this), (this.sortData = {});
            }),
            (b.prototype.updateSortData = function () {
                if (!this.isIgnored) {
                    (this.sortData.id = this.id), (this.sortData["original-order"] = this.id), (this.sortData.random = Math.random());
                    var a = this.layout.options.getSortData,
                        b = this.layout._sorters;
                    for (var c in a) {
                        var d = b[c];
                        this.sortData[c] = d(this.element, this);
                    }
                }
            });
        var c = b.prototype.destroy;
        return (
            (b.prototype.destroy = function () {
                c.apply(this, arguments), this.css({ display: "" });
            }),
            b
        );
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("isotope/js/layout-mode", ["get-size/get-size", "outlayer/outlayer"], b)
            : "object" == typeof exports
            ? (module.exports = b(require("get-size"), require("outlayer")))
            : ((a.Isotope = a.Isotope || {}), (a.Isotope.LayoutMode = b(a.getSize, a.Outlayer)));
    })(window, function (a, b) {
        "use strict";
        function c(a) {
            (this.isotope = a), a && ((this.options = a.options[this.namespace]), (this.element = a.element), (this.items = a.filteredItems), (this.size = a.size));
        }
        return (
            (function () {
                function a(a) {
                    return function () {
                        return b.prototype[a].apply(this.isotope, arguments);
                    };
                }
                for (var d = ["_resetLayout", "_getItemLayoutPosition", "_manageStamp", "_getContainerSize", "_getElementOffset", "needsResizeLayout"], e = 0, f = d.length; e < f; e++) {
                    var g = d[e];
                    c.prototype[g] = a(g);
                }
            })(),
            (c.prototype.needsVerticalResizeLayout = function () {
                var b = a(this.isotope.element),
                    c = this.isotope.size && b;
                return c && b.innerHeight != this.isotope.size.innerHeight;
            }),
            (c.prototype._getMeasurement = function () {
                this.isotope._getMeasurement.apply(this, arguments);
            }),
            (c.prototype.getColumnWidth = function () {
                this.getSegmentSize("column", "Width");
            }),
            (c.prototype.getRowHeight = function () {
                this.getSegmentSize("row", "Height");
            }),
            (c.prototype.getSegmentSize = function (a, b) {
                var c = a + b,
                    d = "outer" + b;
                if ((this._getMeasurement(c, d), !this[c])) {
                    var e = this.getFirstItemSize();
                    this[c] = (e && e[d]) || this.isotope.size["inner" + b];
                }
            }),
            (c.prototype.getFirstItemSize = function () {
                var b = this.isotope.filteredItems[0];
                return b && b.element && a(b.element);
            }),
            (c.prototype.layout = function () {
                this.isotope.layout.apply(this.isotope, arguments);
            }),
            (c.prototype.getSize = function () {
                this.isotope.getSize(), (this.size = this.isotope.size);
            }),
            (c.modes = {}),
            (c.create = function (a, b) {
                function d() {
                    c.apply(this, arguments);
                }
                return (d.prototype = new c()), b && (d.options = b), (d.prototype.namespace = a), (c.modes[a] = d), d;
            }),
            c
        );
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("masonry/masonry", ["outlayer/outlayer", "get-size/get-size", "fizzy-ui-utils/utils"], b)
            : "object" == typeof exports
            ? (module.exports = b(require("outlayer"), require("get-size"), require("fizzy-ui-utils")))
            : (a.Masonry = b(a.Outlayer, a.getSize, a.fizzyUIUtils));
    })(window, function (a, b, c) {
        var d = a.create("masonry");
        return (
            (d.prototype._resetLayout = function () {
                this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns();
                var a = this.cols;
                for (this.colYs = []; a--; ) this.colYs.push(0);
                this.maxY = 0;
            }),
            (d.prototype.measureColumns = function () {
                if ((this.getContainerWidth(), !this.columnWidth)) {
                    var a = this.items[0],
                        c = a && a.element;
                    this.columnWidth = (c && b(c).outerWidth) || this.containerWidth;
                }
                var d = (this.columnWidth += this.gutter),
                    e = this.containerWidth + this.gutter,
                    f = e / d,
                    g = d - (e % d),
                    h = g && g < 1 ? "round" : "floor";
                (f = Math[h](f)), (this.cols = Math.max(f, 1));
            }),
            (d.prototype.getContainerWidth = function () {
                var a = this.options.isFitWidth ? this.element.parentNode : this.element,
                    c = b(a);
                this.containerWidth = c && c.innerWidth;
            }),
            (d.prototype._getItemLayoutPosition = function (a) {
                a.getSize();
                var b = a.size.outerWidth % this.columnWidth,
                    d = b && b < 1 ? "round" : "ceil",
                    e = Math[d](a.size.outerWidth / this.columnWidth);
                e = Math.min(e, this.cols);
                for (var f = this._getColGroup(e), g = Math.min.apply(Math, f), h = c.indexOf(f, g), i = { x: this.columnWidth * h, y: g }, j = g + a.size.outerHeight, k = this.cols + 1 - f.length, l = 0; l < k; l++) this.colYs[h + l] = j;
                return i;
            }),
            (d.prototype._getColGroup = function (a) {
                if (a < 2) return this.colYs;
                for (var b = [], c = this.cols + 1 - a, d = 0; d < c; d++) {
                    var e = this.colYs.slice(d, d + a);
                    b[d] = Math.max.apply(Math, e);
                }
                return b;
            }),
            (d.prototype._manageStamp = function (a) {
                var c = b(a),
                    d = this._getElementOffset(a),
                    e = this.options.isOriginLeft ? d.left : d.right,
                    f = e + c.outerWidth,
                    g = Math.floor(e / this.columnWidth);
                g = Math.max(0, g);
                var h = Math.floor(f / this.columnWidth);
                (h -= f % this.columnWidth ? 0 : 1), (h = Math.min(this.cols - 1, h));
                for (var i = (this.options.isOriginTop ? d.top : d.bottom) + c.outerHeight, j = g; j <= h; j++) this.colYs[j] = Math.max(i, this.colYs[j]);
            }),
            (d.prototype._getContainerSize = function () {
                this.maxY = Math.max.apply(Math, this.colYs);
                var a = { height: this.maxY };
                return this.options.isFitWidth && (a.width = this._getContainerFitWidth()), a;
            }),
            (d.prototype._getContainerFitWidth = function () {
                for (var a = 0, b = this.cols; --b && 0 === this.colYs[b]; ) a++;
                return (this.cols - a) * this.columnWidth - this.gutter;
            }),
            (d.prototype.needsResizeLayout = function () {
                var a = this.containerWidth;
                return this.getContainerWidth(), a !== this.containerWidth;
            }),
            d
        );
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("isotope/js/layout-modes/masonry", ["../layout-mode", "masonry/masonry"], b)
            : "object" == typeof exports
            ? (module.exports = b(require("../layout-mode"), require("masonry-layout")))
            : b(a.Isotope.LayoutMode, a.Masonry);
    })(window, function (a, b) {
        "use strict";
        function c(a, b) {
            for (var c in b) a[c] = b[c];
            return a;
        }
        var d = a.create("masonry"),
            e = d.prototype._getElementOffset,
            f = d.prototype.layout,
            g = d.prototype._getMeasurement;
        c(d.prototype, b.prototype), (d.prototype._getElementOffset = e), (d.prototype.layout = f), (d.prototype._getMeasurement = g);
        var h = d.prototype.measureColumns;
        d.prototype.measureColumns = function () {
            (this.items = this.isotope.filteredItems), h.call(this);
        };
        var i = d.prototype._manageStamp;
        return (
            (d.prototype._manageStamp = function () {
                (this.options.isOriginLeft = this.isotope.options.isOriginLeft), (this.options.isOriginTop = this.isotope.options.isOriginTop), i.apply(this, arguments);
            }),
            d
        );
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd ? define("isotope/js/layout-modes/fit-rows", ["../layout-mode"], b) : "object" == typeof exports ? (module.exports = b(require("../layout-mode"))) : b(a.Isotope.LayoutMode);
    })(window, function (a) {
        "use strict";
        var b = a.create("fitRows");
        return (
            (b.prototype._resetLayout = function () {
                (this.x = 0), (this.y = 0), (this.maxY = 0), this._getMeasurement("gutter", "outerWidth");
            }),
            (b.prototype._getItemLayoutPosition = function (a) {
                a.getSize();
                var b = a.size.outerWidth + this.gutter,
                    c = this.isotope.size.innerWidth + this.gutter;
                0 !== this.x && b + this.x > c && ((this.x = 0), (this.y = this.maxY));
                var d = { x: this.x, y: this.y };
                return (this.maxY = Math.max(this.maxY, this.y + a.size.outerHeight)), (this.x += b), d;
            }),
            (b.prototype._getContainerSize = function () {
                return { height: this.maxY };
            }),
            b
        );
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd ? define("isotope/js/layout-modes/vertical", ["../layout-mode"], b) : "object" == typeof exports ? (module.exports = b(require("../layout-mode"))) : b(a.Isotope.LayoutMode);
    })(window, function (a) {
        "use strict";
        var b = a.create("vertical", { horizontalAlignment: 0 });
        return (
            (b.prototype._resetLayout = function () {
                this.y = 0;
            }),
            (b.prototype._getItemLayoutPosition = function (a) {
                a.getSize();
                var b = (this.isotope.size.innerWidth - a.size.outerWidth) * this.options.horizontalAlignment,
                    c = this.y;
                return (this.y += a.size.outerHeight), { x: b, y: c };
            }),
            (b.prototype._getContainerSize = function () {
                return { height: this.y };
            }),
            b
        );
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define([
                  "outlayer/outlayer",
                  "get-size/get-size",
                  "matches-selector/matches-selector",
                  "fizzy-ui-utils/utils",
                  "isotope/js/item",
                  "isotope/js/layout-mode",
                  "isotope/js/layout-modes/masonry",
                  "isotope/js/layout-modes/fit-rows",
                  "isotope/js/layout-modes/vertical",
              ], function (c, d, e, f, g, h) {
                  return b(a, c, d, e, f, g, h);
              })
            : "object" == typeof exports
            ? (module.exports = b(
                  a,
                  require("outlayer"),
                  require("get-size"),
                  require("desandro-matches-selector"),
                  require("fizzy-ui-utils"),
                  require("./item"),
                  require("./layout-mode"),
                  require("./layout-modes/masonry"),
                  require("./layout-modes/fit-rows"),
                  require("./layout-modes/vertical")
              ))
            : (a.Isotope = b(a, a.Outlayer, a.getSize, a.matchesSelector, a.fizzyUIUtils, a.Isotope.Item, a.Isotope.LayoutMode));
    })(window, function (a, b, c, d, e, f, g) {
        function h(a, b) {
            return function (c, d) {
                for (var e = 0, f = a.length; e < f; e++) {
                    var g = a[e],
                        h = c.sortData[g],
                        i = d.sortData[g];
                    if (h > i || h < i) {
                        var j = void 0 !== b[g] ? b[g] : b,
                            k = j ? 1 : -1;
                        return (h > i ? 1 : -1) * k;
                    }
                }
                return 0;
            };
        }
        var i = a.jQuery,
            j = String.prototype.trim
                ? function (a) {
                      return a.trim();
                  }
                : function (a) {
                      return a.replace(/^\s+|\s+$/g, "");
                  },
            k = document.documentElement,
            l = k.textContent
                ? function (a) {
                      return a.textContent;
                  }
                : function (a) {
                      return a.innerText;
                  },
            m = b.create("isotope", { layoutMode: "masonry", isJQueryFiltering: !0, sortAscending: !0 });
        (m.Item = f),
            (m.LayoutMode = g),
            (m.prototype._create = function () {
                (this.itemGUID = 0), (this._sorters = {}), this._getSorters(), b.prototype._create.call(this), (this.modes = {}), (this.filteredItems = this.items), (this.sortHistory = ["original-order"]);
                for (var a in g.modes) this._initLayoutMode(a);
            }),
            (m.prototype.reloadItems = function () {
                (this.itemGUID = 0), b.prototype.reloadItems.call(this);
            }),
            (m.prototype._itemize = function () {
                for (var a = b.prototype._itemize.apply(this, arguments), c = 0, d = a.length; c < d; c++) {
                    var e = a[c];
                    e.id = this.itemGUID++;
                }
                return this._updateItemsSortData(a), a;
            }),
            (m.prototype._initLayoutMode = function (a) {
                var b = g.modes[a],
                    c = this.options[a] || {};
                (this.options[a] = b.options ? e.extend(b.options, c) : c), (this.modes[a] = new b(this));
            }),
            (m.prototype.layout = function () {
                return !this._isLayoutInited && this.options.isInitLayout ? void this.arrange() : void this._layout();
            }),
            (m.prototype._layout = function () {
                var a = this._getIsInstant();
                this._resetLayout(), this._manageStamps(), this.layoutItems(this.filteredItems, a), (this._isLayoutInited = !0);
            }),
            (m.prototype.arrange = function (a) {
                function b() {
                    d.reveal(c.needReveal), d.hide(c.needHide);
                }
                this.option(a), this._getIsInstant();
                var c = this._filter(this.items);
                this.filteredItems = c.matches;
                var d = this;
                this._bindArrangeComplete(), this._isInstant ? this._noTransition(b) : b(), this._sort(), this._layout();
            }),
            (m.prototype._init = m.prototype.arrange),
            (m.prototype._getIsInstant = function () {
                var a = void 0 !== this.options.isLayoutInstant ? this.options.isLayoutInstant : !this._isLayoutInited;
                return (this._isInstant = a), a;
            }),
            (m.prototype._bindArrangeComplete = function () {
                function a() {
                    b && c && d && e.dispatchEvent("arrangeComplete", null, [e.filteredItems]);
                }
                var b,
                    c,
                    d,
                    e = this;
                this.once("layoutComplete", function () {
                    (b = !0), a();
                }),
                    this.once("hideComplete", function () {
                        (c = !0), a();
                    }),
                    this.once("revealComplete", function () {
                        (d = !0), a();
                    });
            }),
            (m.prototype._filter = function (a) {
                var b = this.options.filter;
                b = b || "*";
                for (var c = [], d = [], e = [], f = this._getFilterTest(b), g = 0, h = a.length; g < h; g++) {
                    var i = a[g];
                    if (!i.isIgnored) {
                        var j = f(i);
                        j && c.push(i), j && i.isHidden ? d.push(i) : j || i.isHidden || e.push(i);
                    }
                }
                return { matches: c, needReveal: d, needHide: e };
            }),
            (m.prototype._getFilterTest = function (a) {
                return i && this.options.isJQueryFiltering
                    ? function (b) {
                          return i(b.element).is(a);
                      }
                    : "function" == typeof a
                    ? function (b) {
                          return a(b.element);
                      }
                    : function (b) {
                          return d(b.element, a);
                      };
            }),
            (m.prototype.updateSortData = function (a) {
                var b;
                a ? ((a = e.makeArray(a)), (b = this.getItems(a))) : (b = this.items), this._getSorters(), this._updateItemsSortData(b);
            }),
            (m.prototype._getSorters = function () {
                var a = this.options.getSortData;
                for (var b in a) {
                    var c = a[b];
                    this._sorters[b] = n(c);
                }
            }),
            (m.prototype._updateItemsSortData = function (a) {
                for (var b = a && a.length, c = 0; b && c < b; c++) {
                    var d = a[c];
                    d.updateSortData();
                }
            });
        var n = (function () {
            function a(a) {
                if ("string" != typeof a) return a;
                var c = j(a).split(" "),
                    d = c[0],
                    e = d.match(/^\[(.+)\]$/),
                    f = e && e[1],
                    g = b(f, d),
                    h = m.sortDataParsers[c[1]];
                return (a = h
                    ? function (a) {
                          return a && h(g(a));
                      }
                    : function (a) {
                          return a && g(a);
                      });
            }
            function b(a, b) {
                var c;
                return (c = a
                    ? function (b) {
                          return b.getAttribute(a);
                      }
                    : function (a) {
                          var c = a.querySelector(b);
                          return c && l(c);
                      });
            }
            return a;
        })();
        (m.sortDataParsers = {
            parseInt: function (a) {
                return parseInt(a, 10);
            },
            parseFloat: function (a) {
                return parseFloat(a);
            },
        }),
            (m.prototype._sort = function () {
                var a = this.options.sortBy;
                if (a) {
                    var b = [].concat.apply(a, this.sortHistory),
                        c = h(b, this.options.sortAscending);
                    this.filteredItems.sort(c), a != this.sortHistory[0] && this.sortHistory.unshift(a);
                }
            }),
            (m.prototype._mode = function () {
                var a = this.options.layoutMode,
                    b = this.modes[a];
                if (!b) throw new Error("No layout mode: " + a);
                return (b.options = this.options[a]), b;
            }),
            (m.prototype._resetLayout = function () {
                b.prototype._resetLayout.call(this), this._mode()._resetLayout();
            }),
            (m.prototype._getItemLayoutPosition = function (a) {
                return this._mode()._getItemLayoutPosition(a);
            }),
            (m.prototype._manageStamp = function (a) {
                this._mode()._manageStamp(a);
            }),
            (m.prototype._getContainerSize = function () {
                return this._mode()._getContainerSize();
            }),
            (m.prototype.needsResizeLayout = function () {
                return this._mode().needsResizeLayout();
            }),
            (m.prototype.appended = function (a) {
                var b = this.addItems(a);
                if (b.length) {
                    var c = this._filterRevealAdded(b);
                    this.filteredItems = this.filteredItems.concat(c);
                }
            }),
            (m.prototype.prepended = function (a) {
                var b = this._itemize(a);
                if (b.length) {
                    this._resetLayout(), this._manageStamps();
                    var c = this._filterRevealAdded(b);
                    this.layoutItems(this.filteredItems), (this.filteredItems = c.concat(this.filteredItems)), (this.items = b.concat(this.items));
                }
            }),
            (m.prototype._filterRevealAdded = function (a) {
                var b = this._filter(a);
                return this.hide(b.needHide), this.reveal(b.matches), this.layoutItems(b.matches, !0), b.matches;
            }),
            (m.prototype.insert = function (a) {
                var b = this.addItems(a);
                if (b.length) {
                    var c,
                        d,
                        e = b.length;
                    for (c = 0; c < e; c++) (d = b[c]), this.element.appendChild(d.element);
                    var f = this._filter(b).matches;
                    for (c = 0; c < e; c++) b[c].isLayoutInstant = !0;
                    for (this.arrange(), c = 0; c < e; c++) delete b[c].isLayoutInstant;
                    this.reveal(f);
                }
            });
        var o = m.prototype.remove;
        return (
            (m.prototype.remove = function (a) {
                a = e.makeArray(a);
                var b = this.getItems(a);
                o.call(this, a);
                var c = b && b.length;
                if (c)
                    for (var d = 0; d < c; d++) {
                        var f = b[d];
                        e.removeFrom(this.filteredItems, f);
                    }
            }),
            (m.prototype.shuffle = function () {
                for (var a = 0, b = this.items.length; a < b; a++) {
                    var c = this.items[a];
                    c.sortData.random = Math.random();
                }
                (this.options.sortBy = "random"), this._sort(), this._layout();
            }),
            (m.prototype._noTransition = function (a) {
                var b = this.options.transitionDuration;
                this.options.transitionDuration = 0;
                var c = a.call(this);
                return (this.options.transitionDuration = b), c;
            }),
            (m.prototype.getFilteredItemElements = function () {
                for (var a = [], b = 0, c = this.filteredItems.length; b < c; b++) a.push(this.filteredItems[b].element);
                return a;
            }),
            m
        );
    }),
    (function (a) {
        "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof exports ? require("jquery") : jQuery);
    })(function (a) {
        function b(a) {
            return h.raw ? a : encodeURIComponent(a);
        }
        function c(a) {
            return h.raw ? a : decodeURIComponent(a);
        }
        function d(a) {
            return b(h.json ? JSON.stringify(a) : String(a));
        }
        function e(a) {
            0 === a.indexOf('"') && (a = a.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
            try {
                return (a = decodeURIComponent(a.replace(g, " "))), h.json ? JSON.parse(a) : a;
            } catch (b) {}
        }
        function f(b, c) {
            var d = h.raw ? b : e(b);
            return a.isFunction(c) ? c(d) : d;
        }
        var g = /\+/g,
            h = (a.cookie = function (e, g, i) {
                if (arguments.length > 1 && !a.isFunction(g)) {
                    if (((i = a.extend({}, h.defaults, i)), "number" == typeof i.expires)) {
                        var j = i.expires,
                            k = (i.expires = new Date());
                        k.setTime(+k + 864e5 * j);
                    }
                    return (document.cookie = [b(e), "=", d(g), i.expires ? "; expires=" + i.expires.toUTCString() : "", i.path ? "; path=" + i.path : "", i.domain ? "; domain=" + i.domain : "", i.secure ? "; secure" : ""].join(""));
                }
                for (var l = e ? void 0 : {}, m = document.cookie ? document.cookie.split("; ") : [], n = 0, o = m.length; n < o; n++) {
                    var p = m[n].split("="),
                        q = c(p.shift()),
                        r = p.join("=");
                    if (e && e === q) {
                        l = f(r, g);
                        break;
                    }
                    e || void 0 === (r = f(r)) || (l[q] = r);
                }
                return l;
            });
        (h.defaults = {}),
            (a.removeCookie = function (b, c) {
                return void 0 !== a.cookie(b) && (a.cookie(b, "", a.extend({}, c, { expires: -1 })), !a.cookie(b));
            });
    }),
    !(function (a) {
        window.fp_fadingEffectExtension = function () {
            function b() {
                a(n).on("afterResponsive", c);
            }
            function c(a, b) {
                b ? ((g = !1), h.turnOff()) : ((g = f.autoScrolling), h.turnOn());
            }
            var d,
                e,
                f,
                g,
                h = this,
                i = a.fn.fullpage.getFullpageData(),
                j = i.options,
                k = i.internals,
                l = j.scrollingSpeed,
                m = "fullpage-wrapper",
                n = "." + m,
                o = "active",
                p = "." + o,
                q = "fp-section",
                r = "." + q,
                s = r + p,
                t = "fp-slide",
                u = "." + t,
                v = "fp-slidesContainer",
                w = "." + v,
                x = u + p,
                y = "fp-fading-animations",
                z = "#" + y,
                A = "fp-fading-sheet",
                B = "#" + A;
            (h.apply = function () {
                b(), (f = a.extend(!0, {}, j)), (g = f.autoScrolling), (j.scrollBar = !1), h.isFadingPanel("sections") && a.fn.fullpage.setAutoScrolling(!0);
                var c = h.isFadingPanel("slides") ? h.getStyles(u) : "",
                    d = h.isFadingPanel("sections") ? h.getStyles(r) : "";
                j.fadingEffect && h.appendStyleSheet(A, d + c), clearTimeout(e), (e = setTimeout(h.applyAnimation, 300));
            }),
                (h.isFadingPanel = function (a) {
                    return j.fadingEffect === !0 || j.fadingEffect === a;
                }),
                (h.appendStyleSheet = function (b, c) {
                    a('<style id="' + b + '">' + c + "</style>").appendTo("head");
                }),
                (h.applyAnimation = function () {
                    d = h.getTransition();
                    var a = h.isFadingPanel("slides") ? h.getPanelAnimation(u) : "",
                        b = h.isFadingPanel("sections") ? h.getPanelAnimation(r) : "";
                    h.appendStyleSheet(y, a + b);
                }),
                (h.getPanelAnimation = function (a) {
                    return a + "{-webkit-transition: " + d + ";transition: " + d + ";}";
                }),
                (h.getStyles = function (a) {
                    return h.getContainerStyles(a) + "" + h.getPanelStyles(a) + h.getActivePanelStyles(a);
                }),
                (h.getContainerStyles = function (a) {
                    return a === u ? ".fp-slidesContainer {width: 100% !important;transform: none!important;}" : "";
                }),
                (h.getPanelStyles = function (a) {
                    return a + "{width: 100% !important;position: absolute;left: 0;top: 0;visibility: hidden;opacity: 0;}";
                }),
                (h.getActivePanelStyles = function (a) {
                    return a + ".active{visibility: visible;opacity: 1;}";
                }),
                (h.update = function (b) {
                    a(z).remove(), (l = b), h.applyAnimation();
                }),
                (h.getTransition = function () {
                    return "all " + l + "ms " + j.easingcss3;
                }),
                (h.turnOff = function () {
                    if (a(B).length) {
                        a(z).remove();
                        var b = a(s).find(x),
                            c = a(s).find(w);
                        k.removeAnimation(c), a(B).remove(), (j.scrollBar = f.scrollBar), a.fn.fullpage.setAutoScrolling(g), b.length && k.silentLandscapeScroll(b);
                    }
                }),
                (h.turnOn = function () {
                    a(B).length || (h.apply(), a("html,body").scrollTop(0), k.silentScroll(0));
                }),
                (h.c = k.c);
            var C = h["common".charAt(0)];
            return (
                "complete" === document.readyState && C("fadingEffect"),
                a(window).on("load", function () {
                    C("fadingEffect");
                }),
                h
            );
        };
    })(jQuery),
    !(function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define(["jquery"], function (c) {
                  return b(c, a, a.document, a.Math);
              })
            : "object" == typeof exports && exports
            ? (module.exports = b(require("jquery"), a, a.document, a.Math))
            : b(jQuery, a, a.document, a.Math);
    })("undefined" != typeof window ? window : this, function (a, b, c, d, e) {
        "use strict";
        var f = "fullpage-wrapper",
            g = "." + f,
            h = "fp-scrollable",
            i = "." + h,
            j = "fp-responsive",
            k = "fp-notransition",
            l = "fp-destroyed",
            m = "fp-enabled",
            n = "fp-viewing",
            o = "active",
            p = "." + o,
            q = "fp-completely",
            r = "." + q,
            s = ".section",
            t = "fp-section",
            u = "." + t,
            v = u + p,
            w = u + ":first",
            x = u + ":last",
            y = "fp-tableCell",
            z = "." + y,
            A = "fp-auto-height",
            B = "fp-normal-scroll",
            C = "fp-nav",
            D = "#" + C,
            E = "fp-tooltip",
            F = "." + E,
            G = "fp-show-active",
            H = ".slide",
            I = "fp-slide",
            J = "." + I,
            K = J + p,
            L = "fp-slides",
            M = "." + L,
            N = "fp-slidesContainer",
            O = "." + N,
            P = "fp-table",
            Q = "fp-slidesNav",
            R = "." + Q,
            S = R + " a",
            T = "fp-controlArrow",
            U = "." + T,
            V = "fp-prev",
            W = "." + V,
            X = T + " " + V,
            Y = U + W,
            Z = "fp-next",
            $ = "." + Z,
            _ = T + " " + Z,
            aa = U + $,
            ba = a(b),
            ca = a(c),
            da = { scrollbars: !0, mouseWheel: !0, hideScrollbars: !1, fadeScrollbars: !1, disableMouse: !0, interactiveScrollbars: !0 };
        (a.fn.fullpage = function (h) {
            function i(b, c) {
                b || fc(0), pc("autoScrolling", b, c);
                var d = a(v);
                h.autoScrolling && !h.scrollBar
                    ? (sc.css({ overflow: "hidden", height: "100%" }), T(Qc.recordHistory, "internal"), Bc.css({ "-ms-touch-action": "none", "touch-action": "none" }), d.length && fc(d.position().top))
                    : (sc.css({ overflow: "visible", height: "initial" }),
                      T(!1, "internal"),
                      Bc.css({ "-ms-touch-action": "", "touch-action": "" }),
                      kc(Bc),
                      d.length && (console.log("llama scroll"), sc.scrollTop(d.position().top), console.log("fiunish scroll"))),
                    Bc.trigger("setAutoScrolling", [b]);
            }
            function T(a, b) {
                pc("recordHistory", a, b);
            }
            function W(a, b) {
                "internal" !== b && h.fadingEffect && uc.fadingEffect && uc.fadingEffect.update(a), pc("scrollingSpeed", a, b);
            }
            function Z(a, b) {
                pc("fitToSection", a, b);
            }
            function $(a) {
                h.lockAnchors = a;
            }
            function fa(a) {
                a ? (Zb(), $b()) : (Yb(), _b());
            }
            function ga(b, c) {
                "undefined" != typeof c
                    ? ((c = c.replace(/ /g, "").split(",")),
                      a.each(c, function (a, c) {
                          hc(b, c, "m");
                      }))
                    : b
                    ? (fa(!0), ac())
                    : (fa(!1), bc());
            }
            function ha(b, c) {
                "undefined" != typeof c
                    ? ((c = c.replace(/ /g, "").split(",")),
                      a.each(c, function (a, c) {
                          hc(b, c, "k");
                      }))
                    : (h.keyboardScrolling = b);
            }
            function ia() {
                var b = a(v).prev(u);
                b.length || (!h.loopTop && !h.continuousVertical) || (b = a(u).last()), b.length && Wa(b, null, !0);
            }
            function ja() {
                var b = a(v).next(u);
                b.length || (!h.loopBottom && !h.continuousVertical) || (b = a(u).first()), b.length && Wa(b, null, !1);
            }
            function ka(a, b) {
                W(0, "internal"), la(a, b), W(Qc.scrollingSpeed, "internal");
            }
            function la(a, b) {
                var c = Ob(a);
                "undefined" != typeof b ? Qb(a, b) : c.length > 0 && Wa(c);
            }
            function ma(a) {
                Ta("right", a);
            }
            function na(a) {
                Ta("left", a);
            }
            function oa(b) {
                if (!Bc.hasClass(l)) {
                    (Dc = !0),
                        (Cc = ba.height()),
                        a(u).each(function () {
                            var b = a(this).find(M),
                                c = a(this).find(J);
                            h.verticalCentered &&
                                a(this)
                                    .find(z)
                                    .css("height", Mb(a(this)) + "px"),
                                a(this).css("height", xa(a(this)) + "px"),
                                h.scrollOverflow &&
                                    (c.length
                                        ? c.each(function () {
                                              Kb(a(this));
                                          })
                                        : Kb(a(this))),
                                c.length > 1 && wb(b, b.find(K));
                        });
                    var c = a(v),
                        d = c.index(u);
                    d && ka(d + 1), (Dc = !1), a.isFunction(h.afterResize) && b && h.afterResize.call(Bc), a.isFunction(h.afterReBuild) && !b && h.afterReBuild.call(Bc);
                }
            }
            function pa(b) {
                var c = tc.hasClass(j);
                b
                    ? c ||
                      (i(!1, "internal"),
                      Z(!1, "internal"),
                      a(D).hide(),
                      tc.addClass(j),
                      a.isFunction(h.afterResponsive) && h.afterResponsive.call(Bc, b),
                      h.responsiveSlides && uc.responsiveSlides && uc.responsiveSlides.toSections(),
                      Bc.trigger("afterResponsive", [b]))
                    : c &&
                      (i(Qc.autoScrolling, "internal"),
                      Z(Qc.autoScrolling, "internal"),
                      a(D).show(),
                      tc.removeClass(j),
                      a.isFunction(h.afterResponsive) && h.afterResponsive.call(Bc, b),
                      h.responsiveSlides && uc.responsiveSlides && uc.responsiveSlides.toSlides(),
                      Bc.trigger("afterResponsive", [b]));
            }
            function qa() {
                return {
                    options: h,
                    internals: {
                        canScroll: Fc,
                        isScrollAllowed: Hc,
                        getDestinationPosition: Va,
                        isTouch: Ac,
                        c: ib,
                        getXmovement: Jb,
                        removeAnimation: Eb,
                        getTransforms: gc,
                        lazyLoad: ab,
                        addAnimation: Db,
                        performHorizontalMove: zb,
                        landscapeScroll: wb,
                        silentLandscapeScroll: ec,
                        keepSlidesPosition: Ua,
                        silentScroll: fc,
                        styleSlides: wa,
                        scrollHandler: Ia,
                        getEventsPage: dc,
                        getMSPointer: cc,
                        isReallyTouch: Pa,
                        checkParentForNormalScrollElement: Oa,
                        usingExtension: lc,
                        toggleControlArrows: xb,
                    },
                };
            }
            function ra() {
                h.css3 && (h.css3 = Xb()), (h.scrollBar = h.scrollBar || h.hybrid), ua(), va(), ga(!0), i(h.autoScrolling, "internal");
                var b = a(v).find(K);
                b.length && (0 !== a(v).index(u) || (0 === a(v).index(u) && 0 !== b.index())) && ec(b), Cb(), Wb(), "complete" === c.readyState && jb(), ba.on("load", jb);
            }
            function sa() {
                ba.on("scroll", Ia).on("hashchange", kb).blur(rb).resize(Bb),
                    ca
                        .keydown(lb)
                        .keyup(nb)
                        .on("click touchstart", D + " a", sb)
                        .on("click touchstart", S, tb)
                        .on("click", F, mb),
                    a(u).on("click touchstart", U, qb),
                    h.normalScrollElements &&
                        (ca.on("mouseenter", h.normalScrollElements, function () {
                            fa(!1);
                        }),
                        ca.on("mouseleave", h.normalScrollElements, function () {
                            fa(!0);
                        }));
            }
            function ta(a) {
                var c = "fp_" + a + "Extension";
                (Rc[a] = h[a + "Key"]), (uc[a] = "undefined" != typeof b[c] ? new b[c]() : null), uc[a] && uc[a].c(a);
            }
            function ua() {
                var b = Bc.find(h.sectionSelector);
                h.anchors.length ||
                    (h.anchors = b
                        .filter("[data-anchor]")
                        .map(function () {
                            return a(this).data("anchor").toString();
                        })
                        .get()),
                    h.navigationTooltips.length ||
                        (h.navigationTooltips = b
                            .filter("[data-tooltip]")
                            .map(function () {
                                return a(this).data("tooltip").toString();
                            })
                            .get());
            }
            function va() {
                Bc.css({ height: "100%", position: "relative" }),
                    Bc.addClass(f),
                    a("html").addClass(m),
                    (Cc = ba.height()),
                    Bc.removeClass(l),
                    Aa(),
                    mc("parallax", "init"),
                    a(u).each(function (b) {
                        var c = a(this),
                            d = c.find(J),
                            e = d.length;
                        ya(c, b), za(c, b), e > 0 ? wa(c, d, e) : h.verticalCentered && Lb(c);
                    }),
                    h.fixedElements && h.css3 && a(h.fixedElements).appendTo(tc),
                    h.navigation && Ca(),
                    Ea(),
                    h.fadingEffect && uc.fadingEffect && uc.fadingEffect.apply(),
                    h.scrollOverflow ? ("complete" === c.readyState && Da(), ba.on("load", Da)) : Ha();
            }
            function wa(b, c, d) {
                var e = 100 * d,
                    f = 100 / d;
                c.wrapAll('<div class="' + N + '" />'),
                    c.parent().wrap('<div class="' + L + '" />'),
                    b.find(O).css("width", e + "%"),
                    d > 1 && (h.controlArrows && Ba(b), h.slidesNavigation && Sb(b, d)),
                    c.each(function (b) {
                        a(this).css("width", f + "%"), h.verticalCentered && Lb(a(this));
                    });
                var g = b.find(K);
                g.length && (0 !== a(v).index(u) || (0 === a(v).index(u) && 0 !== g.index())) ? ec(g) : c.eq(0).addClass(o);
            }
            function xa(a) {
                return h.offsetSections && uc.offsetSections ? uc.offsetSections.getWindowHeight(a) : Cc;
            }
            function ya(b, c) {
                c || 0 !== a(v).length || b.addClass(o),
                    b.css("height", xa(b) + "px"),
                    h.paddingTop && b.css("padding-top", h.paddingTop),
                    h.paddingBottom && b.css("padding-bottom", h.paddingBottom),
                    "undefined" != typeof h.sectionsColor[c] && b.css("background-color", h.sectionsColor[c]),
                    "undefined" != typeof h.anchors[c] && b.attr("data-anchor", h.anchors[c]);
            }
            function za(b, c) {
                "undefined" != typeof h.anchors[c] && b.hasClass(o) && Hb(h.anchors[c], c), h.menu && h.css3 && a(h.menu).closest(g).length && a(h.menu).appendTo(tc);
            }
            function Aa() {
                Bc.find(h.sectionSelector).addClass(t), Bc.find(h.slideSelector).addClass(I);
            }
            function Ba(a) {
                a.find(M).after('<div class="' + X + '"></div><div class="' + _ + '"></div>'),
                    "#fff" != h.controlArrowColor &&
                        (a.find(aa).css("border-color", "transparent transparent transparent " + h.controlArrowColor), a.find(Y).css("border-color", "transparent " + h.controlArrowColor + " transparent transparent")),
                    h.loopHorizontal || a.find(Y).hide();
            }
            function Ca() {
                tc.append('<div id="' + C + '"><ul></ul></div>');
                var b = a(D);
                b.addClass(function () {
                    return h.showActiveTooltip ? G + " " + h.navigationPosition : h.navigationPosition;
                });
                for (var c = 0; c < a(u).length; c++) {
                    var d = "";
                    h.anchors.length && (d = h.anchors[c]);
                    var e = '<li><a href="#' + d + '"><span></span></a>',
                        f = h.navigationTooltips[c];
                    "undefined" != typeof f && "" !== f && (e += '<div class="' + E + " " + h.navigationPosition + '">' + f + "</div>"), (e += "</li>"), b.find("ul").append(e);
                }
                a(D).css("margin-top", "-" + a(D).height() / 2 + "px"), a(D).find("li").eq(a(v).index(u)).find("a").addClass(o);
            }
            function Da() {
                a(u).each(function () {
                    var b = a(this).find(J);
                    b.length
                        ? b.each(function () {
                              Kb(a(this));
                          })
                        : Kb(a(this));
                }),
                    Ha();
            }
            function Ea() {
                Bc.find('iframe[src*="youtube.com/embed/"]').each(function () {
                    Fa(a(this), "enablejsapi=1");
                });
            }
            function Fa(a, b) {
                var c = a.attr("src");
                a.attr("src", c + Ga(c) + b);
            }
            function Ga(a) {
                return /\?/.test(a) ? "&" : "?";
            }
            function Ha() {
                var b = a(v);
                b.addClass(q),
                    h.scrollOverflowHandler.afterRender && h.scrollOverflowHandler.afterRender(b),
                    ab(b),
                    bb(b),
                    h.scrollOverflowHandler.afterLoad(),
                    a.isFunction(h.afterLoad) && h.afterLoad.call(b, b.data("anchor"), b.index(u) + 1),
                    a.isFunction(h.afterRender) && h.afterRender.call(Bc);
            }
            function Ia() {
                Zc || (requestAnimationFrame(Ja), (Zc = !0));
            }
            function Ja() {
                Bc.trigger("onScroll");
                var b;
                if ((!h.autoScrolling || h.scrollBar || lc("dragAndMove")) && !oc()) {
                    var e = lc("dragAndMove") ? d.abs(uc.dragAndMove.getCurrentScroll()) : ba.scrollTop(),
                        f = (Ka(e), 0),
                        g = e + ba.height() / 2,
                        i = lc("dragAndMove") ? uc.dragAndMove.getDocumentHeight() : tc.height() - ba.height(),
                        j = i === e,
                        k = c.querySelectorAll(u);
                    if (j) f = k.length - 1;
                    else if (e)
                        for (var l = 0; l < k.length; ++l) {
                            var m = k[l];
                            m.offsetTop <= g && (f = l);
                        }
                    else f = 0;
                    if (((b = a(k).eq(f)), !b.hasClass(o))) {
                        Sc = !0;
                        var n,
                            p,
                            q = a(v),
                            r = q.index(u) + 1,
                            s = Ib(b),
                            t = b.data("anchor"),
                            w = b.index(u) + 1,
                            x = b.find(K);
                        x.length && ((p = x.data("anchor")), (n = x.index())),
                            Fc &&
                                (b.addClass(o).siblings().removeClass(o),
                                mc("parallax", "afterLoad"),
                                a.isFunction(h.onLeave) && h.onLeave.call(q, r, w, s),
                                a.isFunction(h.afterLoad) && h.afterLoad.call(b, t, w),
                                h.resetSliders && uc.resetSliders && uc.resetSliders.apply({ localIsResizing: Dc, leavingSection: r }),
                                db(q),
                                ab(b),
                                bb(b),
                                Hb(t, w - 1),
                                h.anchors.length && (vc = t),
                                Tb(n, p, t, w)),
                            clearTimeout(Lc),
                            (Lc = setTimeout(function () {
                                Sc = !1;
                            }, 100));
                    }
                    h.fitToSection &&
                        (clearTimeout(Mc),
                        (Mc = setTimeout(function () {
                            Fc && h.fitToSection && (a(v).is(b) && (Dc = !0), Wa(a(v)), (Dc = !1));
                        }, h.fitToSectionDelay)));
                }
                Zc = !1;
            }
            function Ka(a) {
                var b = a > Tc ? "down" : "up";
                return (Tc = a), ($c = a), b;
            }
            function La(a, b) {
                if (Hc.m[a]) {
                    var c = "down" === a ? "bottom" : "top",
                        d = "down" === a ? ja : ia;
                    if ((uc.scrollHorizontally && (d = uc.scrollHorizontally.getScrollSection(a, d)), b.length > 0)) {
                        if (!h.scrollOverflowHandler.isScrolled(c, b)) return !0;
                        d();
                    } else d();
                }
            }
            function Ma(a) {
                var b = a.originalEvent;
                !Oa(a.target) && h.autoScrolling && Pa(b) && a.preventDefault();
            }
            function Na(b) {
                var c = b.originalEvent,
                    e = a(c.target).closest(u);
                if (!Oa(b.target) && Pa(c)) {
                    h.autoScrolling && b.preventDefault();
                    var f = h.scrollOverflowHandler.scrollable(e),
                        g = dc(c);
                    (Wc = g.y),
                        (Xc = g.x),
                        e.find(M).length && d.abs(Vc - Xc) > d.abs(Uc - Wc)
                            ? !yc && d.abs(Vc - Xc) > (ba.outerWidth() / 100) * h.touchSensitivity && (Vc > Xc ? Hc.m.right && ma(e) : Hc.m.left && na(e))
                            : h.autoScrolling && Fc && d.abs(Uc - Wc) > (ba.height() / 100) * h.touchSensitivity && (Uc > Wc ? La("down", f) : Wc > Uc && La("up", f));
                }
            }
            function Oa(b, c) {
                c = c || 0;
                var d = a(b).parent();
                return !!(c < h.normalScrollElementTouchThreshold && d.is(h.normalScrollElements)) || (c != h.normalScrollElementTouchThreshold && Oa(d, ++c));
            }
            function Pa(a) {
                return "undefined" == typeof a.pointerType || "mouse" != a.pointerType;
            }
            function Qa(a) {
                var b = a.originalEvent;
                if ((h.fitToSection && sc.stop(), Pa(b))) {
                    var c = dc(b);
                    (Uc = c.y), (Vc = c.x);
                }
            }
            function Ra(a, b) {
                for (var c = 0, e = a.slice(d.max(a.length - b, 1)), f = 0; f < e.length; f++) c += e[f];
                return d.ceil(c / b);
            }
            function Sa(c) {
                var e = new Date().getTime(),
                    f = a(r).hasClass(B);
                if (h.autoScrolling && !xc && !f) {
                    c = c || b.event;
                    var g = c.wheelDelta || -c.deltaY || -c.detail,
                        i = d.max(-1, d.min(1, g)),
                        j = "undefined" != typeof c.wheelDeltaX || "undefined" != typeof c.deltaX,
                        k = d.abs(c.wheelDeltaX) < d.abs(c.wheelDelta) || d.abs(c.deltaX) < d.abs(c.deltaY) || !j;
                    Gc.length > 149 && Gc.shift(), Gc.push(d.abs(g)), h.scrollBar && (c.preventDefault ? c.preventDefault() : (c.returnValue = !1));
                    var l = a(v),
                        m = h.scrollOverflowHandler.scrollable(l),
                        n = e - Yc;
                    if (((Yc = e), n > 200 && (Gc = []), Fc && !nc())) {
                        var o = Ra(Gc, 10),
                            p = Ra(Gc, 70),
                            q = o >= p;
                        q && k && (i < 0 ? La("down", m) : La("up", m));
                    }
                    return !1;
                }
                h.fitToSection && sc.stop();
            }
            function Ta(b, c) {
                var d = "undefined" == typeof c ? a(v) : c,
                    e = d.find(M);
                if (!(!e.length || nc() || yc || e.find(J).length < 2)) {
                    var f = e.find(K),
                        g = null;
                    if (((g = "left" === b ? f.prev(J) : f.next(J)), !g.length)) {
                        if (!h.loopHorizontal) return;
                        g = "left" === b ? f.siblings(":last") : f.siblings(":first");
                    }
                    (yc = !0), wb(e, g, b);
                }
            }
            function Ua() {
                a(K).each(function () {
                    ec(a(this), "internal");
                });
            }
            function Va(a) {
                var b = a.position(),
                    c = b.top,
                    d = lc("dragAndMove") && uc.dragAndMove.isGrabbing ? uc.dragAndMove.isScrollingDown() : b.top > $c,
                    e = c - Cc + a.outerHeight(),
                    f = h.bigSectionsDestination;
                return (
                    a.outerHeight() > Cc ? ((d || f) && "bottom" !== f) || (c = e) : (d || (Dc && a.is(":last-child"))) && (c = e), h.offsetSections && uc.offsetSections && (c = uc.offsetSections.getSectionPosition(d, c, a)), ($c = c), c
                );
            }
            function Wa(b, c, d) {
                if ("undefined" != typeof b && b.length) {
                    var e,
                        f,
                        g = Va(b),
                        i = {
                            element: b,
                            callback: c,
                            isMovementUp: d,
                            dtop: g,
                            yMovement: Ib(b),
                            anchorLink: b.data("anchor"),
                            sectionIndex: b.index(u),
                            activeSlide: b.find(K),
                            activeSection: a(v),
                            leavingSection: a(v).index(u) + 1,
                            localIsResizing: Dc,
                        };
                    (i.activeSection.is(b) && !Dc) ||
                        (h.scrollBar && ba.scrollTop() === i.dtop && !b.hasClass(A)) ||
                        (i.activeSlide.length && ((e = i.activeSlide.data("anchor")), (f = i.activeSlide.index())),
                        mc("parallax", "apply", i),
                        h.autoScrolling && h.continuousVertical && "undefined" != typeof i.isMovementUp && ((!i.isMovementUp && "up" == i.yMovement) || (i.isMovementUp && "down" == i.yMovement)) && (i = Za(i)),
                        (a.isFunction(h.onLeave) && !i.localIsResizing && h.onLeave.call(i.activeSection, i.leavingSection, i.sectionIndex + 1, i.yMovement) === !1) ||
                            (lc("scrollOverflowReset") && uc.scrollOverflowReset.setPrevious(i.activeSection),
                            db(i.activeSection),
                            h.scrollOverflowHandler.beforeLeave(),
                            b.addClass(o).siblings().removeClass(o),
                            ab(b),
                            h.scrollOverflowHandler.onLeave(),
                            (Fc = !1),
                            Tb(f, e, i.anchorLink, i.sectionIndex),
                            Xa(i),
                            (vc = i.anchorLink),
                            Hb(i.anchorLink, i.sectionIndex)));
                }
            }
            function Xa(b) {
                if (h.css3 && h.autoScrolling && !h.scrollBar) {
                    var c = "translate3d(0px, -" + d.round(b.dtop) + "px, 0px)";
                    Nb(c, !0),
                        h.scrollingSpeed
                            ? (clearTimeout(Jc),
                              (Jc = setTimeout(function () {
                                  _a(b);
                              }, h.scrollingSpeed)))
                            : _a(b);
                } else {
                    var e = Ya(b);
                    a(e.element)
                        .animate(e.options, h.scrollingSpeed, h.easing)
                        .promise()
                        .done(function () {
                            h.scrollBar
                                ? setTimeout(function () {
                                      _a(b);
                                  }, 30)
                                : _a(b);
                        });
                }
            }
            function Ya(a) {
                var b = {};
                return h.autoScrolling && !h.scrollBar ? ((b.options = { top: -a.dtop }), (b.element = g)) : ((b.options = { scrollTop: a.dtop }), (b.element = "html, body")), b;
            }
            function Za(b) {
                return (
                    b.isMovementUp ? b.activeSection.before(b.activeSection.nextAll(u)) : b.activeSection.after(b.activeSection.prevAll(u).get().reverse()),
                    fc(a(v).position().top),
                    Ua(),
                    (b.wrapAroundElements = b.activeSection),
                    (b.dtop = b.element.position().top),
                    (b.yMovement = Ib(b.element)),
                    (b.leavingSection = b.activeSection.index(u) + 1),
                    (b.sectionIndex = b.element.index(u)),
                    a(g).trigger("onContinuousVertical", [b]),
                    b
                );
            }
            function $a(b) {
                b.wrapAroundElements &&
                    b.wrapAroundElements.length &&
                    (b.isMovementUp ? a(w).before(b.wrapAroundElements) : a(x).after(b.wrapAroundElements), fc(a(v).position().top), Ua(), (b.sectionIndex = b.element.index(u)), (b.leavingSection = b.activeSection.index(u) + 1));
            }
            function _a(b) {
                $a(b),
                    a.isFunction(h.afterLoad) && !b.localIsResizing && h.afterLoad.call(b.element, b.anchorLink, b.sectionIndex + 1),
                    h.scrollOverflowHandler.afterLoad(),
                    mc("parallax", "afterLoad"),
                    lc("scrollOverflowReset") && uc.scrollOverflowReset.reset(),
                    h.resetSliders && uc.resetSliders && uc.resetSliders.apply(b),
                    b.localIsResizing || bb(b.element),
                    b.element.addClass(q).siblings().removeClass(q),
                    (Fc = !0),
                    a.isFunction(b.callback) && b.callback.call(this);
            }
            function ab(b) {
                if (h.lazyLoading) {
                    var c,
                        d = eb(b);
                    d.find("img[data-src], source[data-src], audio[data-src], iframe[data-src]").each(function () {
                        (c = a(this)), c.attr("src", c.data("src")), c.removeAttr("data-src"), c.is("source") && c.closest("video").get(0).load();
                    });
                }
            }
            function bb(b) {
                var c = eb(b);
                c.find("video, audio").each(function () {
                    var b = a(this).get(0);
                    b.hasAttribute("data-autoplay") && "function" == typeof b.play && b.play();
                }),
                    c.find('iframe[src*="youtube.com/embed/"]').each(function () {
                        var b = a(this).get(0);
                        b.hasAttribute("data-autoplay") && cb(b),
                            (b.onload = function () {
                                b.hasAttribute("data-autoplay") && cb(b);
                            });
                    });
            }
            function cb(a) {
                a.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
            }
            function db(b) {
                var c = eb(b);
                c.find("video, audio").each(function () {
                    var b = a(this).get(0);
                    b.hasAttribute("data-keepplaying") || "function" != typeof b.pause || b.pause();
                }),
                    c.find('iframe[src*="youtube.com/embed/"]').each(function () {
                        var b = a(this).get(0);
                        /youtube\.com\/embed\//.test(a(this).attr("src")) && !b.hasAttribute("data-keepplaying") && a(this).get(0).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
                    });
            }
            function eb(b) {
                var c = b.find(K);
                return c.length && (b = a(c)), b;
            }
            function fb(a) {
                function b(a) {
                    var b,
                        d,
                        e,
                        f,
                        h,
                        i,
                        j,
                        k = "",
                        l = 0;
                    for (a = a.replace(/[^A-Za-z0-9+\/=]/g, ""); l < a.length; )
                        (f = g.indexOf(a.charAt(l++))),
                            (h = g.indexOf(a.charAt(l++))),
                            (i = g.indexOf(a.charAt(l++))),
                            (j = g.indexOf(a.charAt(l++))),
                            (b = (f << 2) | (h >> 4)),
                            (d = ((15 & h) << 4) | (i >> 2)),
                            (e = ((3 & i) << 6) | j),
                            (k += String.fromCharCode(b)),
                            64 != i && (k += String.fromCharCode(d)),
                            64 != j && (k += String.fromCharCode(e));
                    return (k = c(k));
                }
                function c(a) {
                    for (var b, c = "", d = 0, e = 0, f = 0; d < a.length; )
                        (e = a.charCodeAt(d)),
                            e < 128
                                ? ((c += String.fromCharCode(e)), d++)
                                : e > 191 && e < 224
                                ? ((f = a.charCodeAt(d + 1)), (c += String.fromCharCode(((31 & e) << 6) | (63 & f))), (d += 2))
                                : ((f = a.charCodeAt(d + 1)), (b = a.charCodeAt(d + 2)), (c += String.fromCharCode(((15 & e) << 12) | ((63 & f) << 6) | (63 & b))), (d += 3));
                    return c;
                }
                function d(a) {
                    return a;
                }
                function e(a) {
                    return a.slice(3).slice(0, -3);
                }
                function f(a) {
                    var c = a.split("_");
                    if (c.length > 1) {
                        var d = c[1],
                            f = a.replace(e(c[1]), "").split("_")[0],
                            g = f;
                        return g + "_" + b(d.slice(3).slice(0, -3));
                    }
                    return e(a);
                }
                var g = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                return d(f(b(a)));
            }
            function gb() {
                if (c.domain.length) {
                    var a = c.domain.replace(/^(www\.)/, "").split("."),
                        b = (a.shift(), a.join("."));
                    return b.replace(/(^\.*)|(\.*$)/g, "");
                }
                return "";
            }
            function hb(a) {
                var b = gb(),
                    c = ["localhost", "127.0.0.1", "jshell.net", "UDdDQU5ZNlNN"],
                    d = c[0],
                    e = c[1],
                    f = c[2],
                    g = fb(c[3]),
                    h = [d, e, f].indexOf(b) < 0 && 0 !== b.length,
                    i = "undefined" != typeof Rc[a] && Rc[a].length;
                if (!i && h) return !1;
                var j = i ? fb(Rc[a]) : "";
                j = j.split("_");
                var k = j.length > 1 && j[1].indexOf(a, j[1].length - a.length) > -1,
                    l = j[0].indexOf(b, j[0].length - b.length) < 0;
                return (!(l && h && g != j[0]) && k) || !h;
            }
            function ib(a) {
                var b = fb("boobs"),
                    c = d.random() < 0.5;
                if (!hb(a)) {
                    var e,
                        f = "9999999",
                        g = "z-index",
                        h = function () {
                            (e = c ? tc.find("div").first() : tc.find("div").last()), e.css(g) !== f && (c ? tc.prepend(b) : tc.append(b));
                        };
                    h(), setInterval(h, 2e3);
                }
            }
            function jb() {
                var a = b.location.hash.replace("#", "").split("/"),
                    c = decodeURIComponent(a[0]),
                    d = decodeURIComponent(a[1]);
                c && (h.animateAnchor ? Qb(c, d) : ka(c, d));
            }
            function kb() {
                if (!Sc && !h.lockAnchors) {
                    var a = b.location.hash.replace("#", "").split("/"),
                        c = decodeURIComponent(a[0]),
                        d = decodeURIComponent(a[1]),
                        e = "undefined" == typeof vc,
                        f = "undefined" == typeof vc && "undefined" == typeof d && !yc;
                    c.length && ((c && c !== vc && !e) || f || (!yc && wc != d)) && Qb(c, d);
                }
            }
            function lb(b) {
                clearTimeout(Nc);
                var c = a(":focus");
                if (!c.is("textarea") && !c.is("input") && !c.is("select") && "true" !== c.attr("contentEditable") && "" !== c.attr("contentEditable") && h.keyboardScrolling && h.autoScrolling) {
                    var d = b.which,
                        e = [40, 38, 32, 33, 34];
                    a.inArray(d, e) > -1 && b.preventDefault(),
                        (xc = b.ctrlKey),
                        (Nc = setTimeout(function () {
                            ub(b);
                        }, 150));
                }
            }
            function mb() {
                a(this).prev().trigger("click");
            }
            function nb(a) {
                Ec && (xc = a.ctrlKey);
            }
            function ob(a) {
                2 == a.which && ((_c = a.pageY), Bc.on("mousemove", vb));
            }
            function pb(a) {
                2 == a.which && Bc.off("mousemove");
            }
            function qb() {
                var b = a(this).closest(u);
                a(this).hasClass(V) ? Hc.m.left && na(b) : Hc.m.right && ma(b);
            }
            function rb() {
                (Ec = !1), (xc = !1);
            }
            function sb(b) {
                b.preventDefault();
                var c = a(this).parent().index();
                Wa(a(u).eq(c));
            }
            function tb(b) {
                b.preventDefault();
                var c = a(this).closest(u).find(M),
                    d = c.find(J).eq(a(this).closest("li").index());
                wb(c, d);
            }
            function ub(b) {
                var c = b.shiftKey;
                if (Fc || !([37, 39].indexOf(b.which) < 0))
                    switch (b.which) {
                        case 38:
                        case 33:
                            Hc.k.up && ia();
                            break;
                        case 32:
                            if (c && Hc.k.up) {
                                ia();
                                break;
                            }
                        case 40:
                        case 34:
                            Hc.k.down && ja();
                            break;
                        case 36:
                            Hc.k.up && la(1);
                            break;
                        case 35:
                            Hc.k.down && la(a(u).length);
                            break;
                        case 37:
                            Hc.k.left && na();
                            break;
                        case 39:
                            Hc.k.right && ma();
                            break;
                        default:
                            return;
                    }
            }
            function vb(a) {
                Fc && (a.pageY < _c && Hc.m.up ? ia() : a.pageY > _c && Hc.m.down && ja()), (_c = a.pageY);
            }
            function wb(b, c, d) {
                var e = b.closest(u),
                    f = {
                        slides: b,
                        destiny: c,
                        direction: d,
                        destinyPos: c.position(),
                        slideIndex: c.index(),
                        section: e,
                        sectionIndex: e.index(u),
                        anchorLink: e.data("anchor"),
                        slidesNav: e.find(R),
                        slideAnchor: Vb(c),
                        prevSlide: e.find(K),
                        prevSlideIndex: e.find(K).index(),
                        localIsResizing: Dc,
                    };
                return (
                    (f.xMovement = Jb(f.prevSlideIndex, f.slideIndex)),
                    f.localIsResizing || (Fc = !1),
                    mc("parallax", "applyHorizontal", f),
                    h.onSlideLeave && !f.localIsResizing && "none" !== f.xMovement && a.isFunction(h.onSlideLeave) && h.onSlideLeave.call(f.prevSlide, f.anchorLink, f.sectionIndex + 1, f.prevSlideIndex, f.xMovement, f.slideIndex) === !1
                        ? void (yc = !1)
                        : (c.addClass(o).siblings().removeClass(o),
                          f.localIsResizing || (db(f.prevSlide), ab(c)),
                          xb(f),
                          e.hasClass(o) && Tb(f.slideIndex, f.slideAnchor, f.anchorLink, f.sectionIndex),
                          uc.continuousHorizontal && uc.continuousHorizontal.apply(f),
                          oc() ? yb(f) : zb(b, f, !0),
                          void (h.interlockedSlides && uc.interlockedSlides && uc.interlockedSlides.apply(f)))
                );
            }
            function xb(a) {
                !h.loopHorizontal && h.controlArrows && (a.section.find(Y).toggle(0 !== a.slideIndex), a.section.find(aa).toggle(!a.destiny.is(":last-child")));
            }
            function yb(b) {
                uc.continuousHorizontal && uc.continuousHorizontal.afterSlideLoads(b),
                    Ab(b.slidesNav, b.slideIndex),
                    b.localIsResizing || (mc("parallax", "afterSlideLoads"), a.isFunction(h.afterSlideLoad) && h.afterSlideLoad.call(b.destiny, b.anchorLink, b.sectionIndex + 1, b.slideAnchor, b.slideIndex), (Fc = !0), bb(b.destiny)),
                    (yc = !1),
                    uc.interlockedSlides && uc.interlockedSlides.apply(b);
            }
            function zb(a, b, c) {
                var e = b.destinyPos;
                if (h.css3) {
                    var f = "translate3d(-" + d.round(e.left) + "px, 0px, 0px)";
                    Db(a.find(O)).css(gc(f)),
                        (Kc = setTimeout(
                            function () {
                                c && yb(b);
                            },
                            h.scrollingSpeed,
                            h.easing
                        ));
                } else
                    a.animate({ scrollLeft: d.round(e.left) }, h.scrollingSpeed, h.easing, function () {
                        c && yb(b);
                    });
            }
            function Ab(a, b) {
                a.find(p).removeClass(o), a.find("li").eq(b).find("a").addClass(o);
            }
            function Bb() {
                if ((Bc.trigger("onResize"), Cb(), zc)) {
                    var b = a(c.activeElement);
                    if (!b.is("textarea") && !b.is("input") && !b.is("select")) {
                        var e = ba.height();
                        d.abs(e - ad) > (20 * d.max(ad, e)) / 100 && (oa(!0), (ad = e));
                    }
                } else
                    clearTimeout(Ic),
                        (Ic = setTimeout(function () {
                            oa(!0);
                        }, 350));
            }
            function Cb() {
                var a = h.responsive || h.responsiveWidth,
                    b = h.responsiveHeight,
                    c = a && ba.outerWidth() < a,
                    d = b && ba.height() < b;
                a && b ? pa(c || d) : a ? pa(c) : b && pa(d);
            }
            function Db(a) {
                var b = "all " + h.scrollingSpeed + "ms " + h.easingcss3;
                return a.removeClass(k), a.css({ "-webkit-transition": b, transition: b });
            }
            function Eb(a) {
                return a.addClass(k);
            }
            function Fb(b, c) {
                h.navigation &&
                    (a(D).find(p).removeClass(o),
                    b
                        ? a(D)
                              .find('a[href="#' + b + '"]')
                              .addClass(o)
                        : a(D).find("li").eq(c).find("a").addClass(o));
            }
            function Gb(b) {
                h.menu &&
                    (a(h.menu).find(p).removeClass(o),
                    a(h.menu)
                        .find('[data-menuanchor="' + b + '"]')
                        .addClass(o));
            }
            function Hb(a, b) {
                Gb(a), Fb(a, b);
            }
            function Ib(b) {
                var c = a(v).index(u),
                    d = b.index(u);
                return c == d ? "none" : c > d ? "up" : "down";
            }
            function Jb(a, b) {
                return a == b ? "none" : a > b ? "left" : "right";
            }
            function Kb(a) {
                if (!a.hasClass("fp-noscroll")) {
                    a.css("overflow", "hidden");
                    var b,
                        c = h.scrollOverflowHandler,
                        d = c.wrapContent(),
                        e = a.closest(u),
                        f = c.scrollable(a);
                    f.length ? (b = c.scrollHeight(a)) : ((b = a.get(0).scrollHeight), h.verticalCentered && (b = a.find(z).get(0).scrollHeight));
                    var g = Mb(e);
                    b > g ? (f.length ? c.update(a, g) : (h.verticalCentered ? a.find(z).wrapInner(d) : a.wrapInner(d), c.create(a, g, h.scrollOverflowOptions))) : c.remove(a), a.css("overflow", "");
                }
            }
            function Lb(a) {
                a.hasClass(P) || a.addClass(P).wrapInner('<div class="' + y + '" style="height:' + Mb(a) + 'px;" />');
            }
            function Mb(a) {
                var b = xa(a);
                if (h.paddingTop || h.paddingBottom) {
                    var c = a;
                    c.hasClass(t) || (c = a.closest(u));
                    var d = parseInt(c.css("padding-top")) + parseInt(c.css("padding-bottom"));
                    b = Cc - d;
                }
                return b;
            }
            function Nb(a, b) {
                b ? Db(Bc) : Eb(Bc),
                    Bc.css(gc(a)),
                    setTimeout(function () {
                        Bc.removeClass(k);
                    }, 10);
            }
            function Ob(b) {
                var c = Bc.find(u + '[data-anchor="' + b + '"]');
                return c.length || (c = a(u).eq(b - 1)), c;
            }
            function Pb(a, b) {
                var c = b.find(M),
                    d = c.find(J + '[data-anchor="' + a + '"]');
                return d.length || (d = c.find(J).eq(a)), d;
            }
            function Qb(a, b) {
                var c = Ob(a);
                c.length &&
                    ("undefined" == typeof b && (b = 0),
                    a === vc || c.hasClass(o)
                        ? Rb(c, b)
                        : Wa(c, function () {
                              Rb(c, b);
                          }));
            }
            function Rb(a, b) {
                if ("undefined" != typeof b) {
                    var c = a.find(M),
                        d = Pb(b, a);
                    d.length && wb(c, d);
                }
            }
            function Sb(a, b) {
                a.append('<div class="' + Q + '"><ul></ul></div>');
                var c = a.find(R);
                c.addClass(h.slidesNavPosition);
                for (var d = 0; d < b; d++) c.find("ul").append('<li><a href="#"><span></span></a></li>');
                c.css("margin-left", "-" + c.width() / 2 + "px"), c.find("li").first().find("a").addClass(o);
            }
            function Tb(a, b, c, d) {
                var e = "";
                h.anchors.length && !h.lockAnchors && (a ? ("undefined" != typeof c && (e = c), "undefined" == typeof b && (b = a), (wc = b), Ub(e + "/" + b)) : "undefined" != typeof a ? ((wc = b), Ub(c)) : Ub(c)), Wb();
            }
            function Ub(a) {
                if (h.recordHistory) location.hash = a;
                else if (zc || Ac) b.history.replaceState(e, e, "#" + a);
                else {
                    var c = b.location.href.split("#")[0];
                    b.location.replace(c + "#" + a);
                }
            }
            function Vb(a) {
                var b = a.data("anchor"),
                    c = a.index();
                return "undefined" == typeof b && (b = c), b;
            }
            function Wb() {
                var b = a(v),
                    c = b.find(K),
                    d = Vb(b),
                    e = Vb(c),
                    f = String(d);
                c.length && (f = f + "-" + e), (f = f.replace("/", "-").replace("#", ""));
                var g = new RegExp("\\b\\s?" + n + "-[^\\s]+\\b", "g");
                (tc[0].className = tc[0].className.replace(g, "")), tc.addClass(n + "-" + f);
            }
            function Xb() {
                var a,
                    d = c.createElement("p"),
                    f = { webkitTransform: "-webkit-transform", OTransform: "-o-transform", msTransform: "-ms-transform", MozTransform: "-moz-transform", transform: "transform" };
                c.body.insertBefore(d, null);
                for (var g in f) d.style[g] !== e && ((d.style[g] = "translate3d(1px,1px,1px)"), (a = b.getComputedStyle(d).getPropertyValue(f[g])));
                return c.body.removeChild(d), a !== e && a.length > 0 && "none" !== a;
            }
            function Yb() {
                c.addEventListener ? (c.removeEventListener("mousewheel", Sa, !1), c.removeEventListener("wheel", Sa, !1), c.removeEventListener("MozMousePixelScroll", Sa, !1)) : c.detachEvent("onmousewheel", Sa);
            }
            function Zb() {
                var a,
                    d = "";
                b.addEventListener ? (a = "addEventListener") : ((a = "attachEvent"), (d = "on"));
                var f = "onwheel" in c.createElement("div") ? "wheel" : c.onmousewheel !== e ? "mousewheel" : "DOMMouseScroll";
                "DOMMouseScroll" == f ? c[a](d + "MozMousePixelScroll", Sa, !1) : c[a](d + f, Sa, !1);
            }
            function $b() {
                Bc.on("mousedown", ob).on("mouseup", pb);
            }
            function _b() {
                Bc.off("mousedown", ob).off("mouseup", pb);
            }
            function ac() {
                (zc || Ac) && (h.autoScrolling && tc.off(Pc.touchmove).on(Pc.touchmove, Ma), a(g).off(Pc.touchstart).on(Pc.touchstart, Qa).off(Pc.touchmove).on(Pc.touchmove, Na));
            }
            function bc() {
                (zc || Ac) && a(g).off(Pc.touchstart).off(Pc.touchmove);
            }
            function cc() {
                var a;
                return (a = b.PointerEvent ? { down: "pointerdown", move: "pointermove" } : { down: "MSPointerDown", move: "MSPointerMove" });
            }
            function dc(a) {
                var b = [];
                return (
                    (b.y = "undefined" != typeof a.pageY && (a.pageY || a.pageX) ? a.pageY : a.touches[0].pageY),
                    (b.x = "undefined" != typeof a.pageX && (a.pageY || a.pageX) ? a.pageX : a.touches[0].pageX),
                    Ac && Pa(a) && h.scrollBar && ((b.y = a.touches[0].pageY), (b.x = a.touches[0].pageX)),
                    b
                );
            }
            function ec(a, b) {
                W(0, "internal"), "undefined" != typeof b && (Dc = !0), wb(a.closest(M), a), "undefined" != typeof b && (Dc = !1), W(Qc.scrollingSpeed, "internal");
            }
            function fc(a) {
                var b = d.round(a);
                if (h.css3 && h.autoScrolling && !h.scrollBar) {
                    var c = "translate3d(0px, -" + b + "px, 0px)";
                    Nb(c, !1);
                } else h.autoScrolling && !h.scrollBar ? Bc.css("top", -b) : sc.scrollTop(b);
            }
            function gc(a) {
                return { "-webkit-transform": a, "-moz-transform": a, "-ms-transform": a, transform: a };
            }
            function hc(a, b, c) {
                switch (b) {
                    case "up":
                        Hc[c].up = a;
                        break;
                    case "down":
                        Hc[c].down = a;
                        break;
                    case "left":
                        Hc[c].left = a;
                        break;
                    case "right":
                        Hc[c].right = a;
                        break;
                    case "all":
                        "m" == c ? ga(a) : ha(a);
                }
            }
            function ic(b) {
                Bc.trigger("destroy", [b]),
                    i(!1, "internal"),
                    ga(!1),
                    ha(!1),
                    Bc.addClass(l),
                    clearTimeout(Kc),
                    clearTimeout(Jc),
                    clearTimeout(Ic),
                    clearTimeout(Lc),
                    clearTimeout(Mc),
                    ba.off("scroll", Ia).off("hashchange", kb).off("resize", Bb),
                    ca
                        .off("click touchstart", D + " a")
                        .off("mouseenter", D + " li")
                        .off("mouseleave", D + " li")
                        .off("click touchstart", S)
                        .off("mouseover", h.normalScrollElements)
                        .off("mouseout", h.normalScrollElements),
                    a(u).off("click touchstart", U),
                    lc("dragAndMove") && uc.dragAndMove.destroy(),
                    clearTimeout(Kc),
                    clearTimeout(Jc),
                    b && jc();
            }
            function jc() {
                fc(0),
                    Bc.find("img[data-src], source[data-src], audio[data-src], iframe[data-src]").each(function () {
                        a(this).attr("src", a(this).data("src")), a(this).removeAttr("data-src");
                    }),
                    a(D + ", " + R + ", " + U).remove(),
                    a(u).css({ height: "", "background-color": "", padding: "" }),
                    a(J).css({ width: "" }),
                    Bc.css({ height: "", position: "", "-ms-touch-action": "", "touch-action": "" }),
                    sc.css({ overflow: "", height: "" }),
                    a("html").removeClass(m),
                    tc.removeClass(j),
                    a.each(tc.get(0).className.split(/\s+/), function (a, b) {
                        0 === b.indexOf(n) && tc.removeClass(b);
                    }),
                    a(u + ", " + J).each(function () {
                        h.scrollOverflowHandler.remove(a(this)), a(this).removeClass(P + " " + o);
                    }),
                    kc(Bc),
                    Bc.find(z + ", " + O + ", " + M).each(function () {
                        a(this).replaceWith(this.childNodes);
                    }),
                    sc.scrollTop(0);
                var b = [t, I, N];
                a.each(b, function (b, c) {
                    a("." + c).removeClass(c);
                });
            }
            function kc(a) {
                return a.css({ "-webkit-transition": "none", transition: "none" });
            }
            function lc(a) {
                return null !== h[a] && "object" == typeof h[a] ? h[a].enabled && uc[a] : h[a] && uc[a];
            }
            function mc(a, b, c) {
                var d = Array.isArray(c) ? c.join(", ") : c;
                lc(a) && uc[a][b](d);
            }
            function nc() {
                return lc("dragAndMove") && uc.dragAndMove.isAnimating;
            }
            function oc() {
                return lc("dragAndMove") && uc.dragAndMove.isGrabbing;
            }
            function pc(a, b, c) {
                (h[a] = b), "internal" !== c && (Qc[a] = b);
            }
            function qc() {
                return a("html").hasClass(m)
                    ? void rc("error", "Fullpage.js can only be initialized once and you are doing it multiple times!")
                    : (h.continuousVertical && (h.loopTop || h.loopBottom) && ((h.continuousVertical = !1), rc("warn", "Option `loopTop/loopBottom` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),
                      h.scrollBar && h.scrollOverflow && rc("warn", "Option `scrollBar` is mutually exclusive with `scrollOverflow`. Sections with scrollOverflow might not work well in Firefox"),
                      !h.continuousVertical ||
                          (!h.scrollBar && h.autoScrolling) ||
                          ((h.continuousVertical = !1), rc("warn", "Scroll bars (`scrollBar:true` or `autoScrolling:false`) are mutually exclusive with `continuousVertical`; `continuousVertical` disabled")),
                      void a.each(h.anchors, function (b, c) {
                          var d = ca.find("[name]").filter(function () {
                                  return a(this).attr("name") && a(this).attr("name").toLowerCase() == c.toLowerCase();
                              }),
                              e = ca.find("[id]").filter(function () {
                                  return a(this).attr("id") && a(this).attr("id").toLowerCase() == c.toLowerCase();
                              });
                          (e.length || d.length) &&
                              (rc("error", "data-anchor tags can not have the same value as any `id` element on the site (or `name` element for IE)."),
                              e.length && rc("error", '"' + c + '" is is being used by another element `id` property'),
                              d.length && rc("error", '"' + c + '" is is being used by another element `name` property'));
                      }));
            }
            function rc(a, b) {
                console && console[a] && console[a]("fullPage: " + b);
            }
            if (a("html").hasClass(m)) return void qc();
            var sc = a("html, body"),
                tc = a("body"),
                uc = a.fn.fullpage;
            h = a.extend(
                !0,
                {
                    menu: !1,
                    anchors: [],
                    lockAnchors: !1,
                    navigation: !1,
                    navigationPosition: "right",
                    navigationTooltips: [],
                    showActiveTooltip: !1,
                    slidesNavigation: !1,
                    slidesNavPosition: "bottom",
                    scrollBar: !1,
                    hybrid: !1,
                    css3: !0,
                    scrollingSpeed: 700,
                    autoScrolling: !0,
                    fitToSection: !0,
                    fitToSectionDelay: 1e3,
                    easing: "easeInOutCubic",
                    easingcss3: "ease",
                    loopBottom: !1,
                    loopTop: !1,
                    loopHorizontal: !0,
                    continuousVertical: !1,
                    continuousHorizontal: !1,
                    scrollHorizontally: !1,
                    interlockedSlides: !1,
                    dragAndMove: !1,
                    offsetSections: !1,
                    resetSliders: !1,
                    fadingEffect: !1,
                    normalScrollElements: null,
                    scrollOverflow: !1,
                    scrollOverflowReset: !1,
                    scrollOverflowHandler: ea,
                    scrollOverflowOptions: null,
                    touchSensitivity: 5,
                    normalScrollElementTouchThreshold: 5,
                    bigSectionsDestination: null,
                    keyboardScrolling: !0,
                    animateAnchor: !0,
                    recordHistory: !0,
                    controlArrows: !0,
                    controlArrowColor: "#fff",
                    verticalCentered: !0,
                    sectionsColor: [],
                    paddingTop: 0,
                    paddingBottom: 0,
                    fixedElements: null,
                    responsive: 0,
                    responsiveWidth: 0,
                    responsiveHeight: 0,
                    responsiveSlides: !1,
                    parallax: !1,
                    parallaxOptions: { type: "reveal", percentage: 62, property: "translate" },
                    sectionSelector: s,
                    slideSelector: H,
                    afterLoad: null,
                    onLeave: null,
                    afterRender: null,
                    afterResize: null,
                    afterReBuild: null,
                    afterSlideLoad: null,
                    onSlideLeave: null,
                    afterResponsive: null,
                    lazyLoading: !0,
                },
                h
            );
            var vc,
                wc,
                xc,
                yc = !1,
                zc = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/),
                Ac = "ontouchstart" in b || navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints,
                Bc = a(this),
                Cc = ba.height(),
                Dc = !1,
                Ec = !0,
                Fc = !0,
                Gc = [],
                Hc = {};
            (Hc.m = { up: !0, down: !0, left: !0, right: !0 }), (Hc.k = a.extend(!0, {}, Hc.m));
            var Ic,
                Jc,
                Kc,
                Lc,
                Mc,
                Nc,
                Oc = cc(),
                Pc = { touchmove: "ontouchmove" in b ? "touchmove" : Oc.move, touchstart: "ontouchstart" in b ? "touchstart" : Oc.down },
                Qc = a.extend(!0, {}, h),
                Rc = {};
            qc(),
                (da.click = Ac),
                (h.scrollOverflowOptions = a.extend(da, h.scrollOverflowOptions)),
                a.extend(a.easing, {
                    easeInOutCubic: function (a, b, c, d, e) {
                        return (b /= e / 2) < 1 ? (d / 2) * b * b * b + c : (d / 2) * ((b -= 2) * b * b + 2) + c;
                    },
                }),
                a(this).length &&
                    ((uc.setAutoScrolling = i),
                    (uc.setRecordHistory = T),
                    (uc.setScrollingSpeed = W),
                    (uc.setFitToSection = Z),
                    (uc.setLockAnchors = $),
                    (uc.setMouseWheelScrolling = fa),
                    (uc.setAllowScrolling = ga),
                    (uc.setKeyboardScrolling = ha),
                    (uc.moveSectionUp = ia),
                    (uc.moveSectionDown = ja),
                    (uc.silentMoveTo = ka),
                    (uc.moveTo = la),
                    (uc.moveSlideRight = ma),
                    (uc.moveSlideLeft = na),
                    (uc.reBuild = oa),
                    (uc.setResponsive = pa),
                    (uc.getFullpageData = qa),
                    (uc.destroy = ic),
                    (uc.landscapeScroll = wb),
                    ta("continuousHorizontal"),
                    ta("scrollHorizontally"),
                    ta("resetSliders"),
                    ta("interlockedSlides"),
                    ta("responsiveSlides"),
                    ta("fadingEffect"),
                    ta("dragAndMove"),
                    ta("offsetSections"),
                    ta("scrollOverflowReset"),
                    ta("parallax"),
                    lc("dragAndMove") && uc.dragAndMove.init(),
                    ra(),
                    sa(),
                    lc("dragAndMove") && uc.dragAndMove.turnOffTouch());
            var Sc = !1,
                Tc = 0,
                Uc = 0,
                Vc = 0,
                Wc = 0,
                Xc = 0;
            !(function () {
                var a = b.requestAnimationFrame || b.mozRequestAnimationFrame || b.webkitRequestAnimationFrame || b.msRequestAnimationFrame;
                b.requestAnimationFrame = a;
            })();
            var Yc = new Date().getTime(),
                Zc = !1,
                $c = 0,
                _c = 0,
                ad = Cc;
        }),
            "undefined" != typeof IScroll &&
                ((IScroll.prototype.wheelOn = function () {
                    this.wrapper.addEventListener("wheel", this), this.wrapper.addEventListener("mousewheel", this), this.wrapper.addEventListener("DOMMouseScroll", this);
                }),
                (IScroll.prototype.wheelOff = function () {
                    this.wrapper.removeEventListener("wheel", this), this.wrapper.removeEventListener("mousewheel", this), this.wrapper.removeEventListener("DOMMouseScroll", this);
                }));
        var ea = {
            refreshId: null,
            iScrollInstances: [],
            toggleWheel: function (b) {
                var c = a(v).find(i);
                c.each(function () {
                    var c = a(this).data("iscrollInstance");
                    "undefined" != typeof c && c && (b ? c.wheelOn() : c.wheelOff());
                });
            },
            onLeave: function () {
                ea.toggleWheel(!1);
            },
            beforeLeave: function () {
                ea.onLeave();
            },
            afterLoad: function () {
                ea.toggleWheel(!0);
            },
            create: function (b, c, d) {
                var e = b.find(i);
                e.height(c),
                    e.each(function () {
                        var b = a(this),
                            c = b.data("iscrollInstance");
                        c &&
                            a.each(ea.iScrollInstances, function () {
                                a(this).destroy();
                            }),
                            (c = new IScroll(b.get(0), d)),
                            c.on("scrollEnd", function () {
                                (this.fp_isAtTop = this.y > -30), (this.fp_isAtEnd = this.y - this.maxScrollY < 30);
                            }),
                            ea.iScrollInstances.push(c),
                            c.wheelOff(),
                            b.data("iscrollInstance", c);
                    });
            },
            isScrolled: function (a, b) {
                var c = b.data("iscrollInstance");
                return !c || ("top" === a ? c.y >= 0 && !b.scrollTop() : "bottom" === a ? 0 - c.y + b.scrollTop() + 1 + b.innerHeight() >= b[0].scrollHeight : void 0);
            },
            scrollable: function (a) {
                return a.find(M).length ? a.find(K).find(i) : a.find(i);
            },
            scrollHeight: function (a) {
                return a.find(i).children().first().get(0).scrollHeight;
            },
            remove: function (a) {
                var b = a.find(i);
                if (b.length) {
                    var c = b.data("iscrollInstance");
                    c && c.destroy(), b.data("iscrollInstance", null);
                }
                a.find(i).children().first().children().first().unwrap().unwrap();
            },
            update: function (b, c) {
                clearTimeout(ea.refreshId),
                    (ea.refreshId = setTimeout(function () {
                        a.each(ea.iScrollInstances, function () {
                            a(this).get(0).refresh();
                        });
                    }, 150)),
                    b
                        .find(i)
                        .css("height", c + "px")
                        .parent()
                        .css("height", c + "px");
            },
            wrapContent: function () {
                return '<div class="' + h + '"><div class="fp-scroller"></div></div>';
            },
        };
    }),
    (function (a) {
        "use strict";
        a.fn.idle = function (b) {
            var c,
                d,
                e = { idle: 6e4, events: "mousemove keydown mousedown touchstart", onIdle: function () {}, onActive: function () {}, onHide: function () {}, onShow: function () {}, keepTracking: !0, startAtIdle: !1, recurIdleCall: !1 },
                f = b.startAtIdle || !1,
                g = !b.startAtIdle || !0,
                h = a.extend({}, e, b),
                i = null;
            return (
                a(this).on("idle:stop", {}, function (b) {
                    a(this).off(h.events), (h.keepTracking = !1), c(i, h);
                }),
                (c = function (a, b) {
                    if ((f && ((f = !1), b.onActive.call()), clearTimeout(a), b.keepTracking)) return d(b);
                }),
                (d = function (a) {
                    var b,
                        c = a.recurIdleCall ? setInterval : setTimeout;
                    return (b = c(function () {
                        (f = !0), a.onIdle.call();
                    }, a.idle));
                }),
                this.each(function () {
                    (i = d(h)),
                        a(this).on(h.events, function (a) {
                            i = c(i, h);
                        }),
                        (h.onShow || h.onHide) &&
                            a(document).on("visibilitychange webkitvisibilitychange mozvisibilitychange msvisibilitychange", function () {
                                document.hidden || document.webkitHidden || document.mozHidden || document.msHidden ? g && ((g = !1), h.onHide.call()) : g || ((g = !0), h.onShow.call());
                            });
                })
            );
        };
    })(jQuery),
    (function (a) {
        a.fn.magnify &&
            (a(
                "<style>.lens-mobile {position:fixed;top:0;left:0;width:100%;height:100%;background:#ccc;display:none;overflow:scroll;-webkit-overflow-scrolling:touch;z-index:9999;}.magnify-mobile>.close {position:fixed;top:10px;right:10px;width:32px;height:32px;background:#333;border-radius:16px;color:#fff;display:inline-block;font:normal bold 20px/32px sans-serif;letter-spacing:0;opacity:0.8;text-align:center;text-shadow:none;z-index:9999;}@media only screen and (min-device-width:320px) and (max-device-width:773px) {/* Assume QHD (1440 x 2560) is highest mobile resolution */.lens-mobile { display:block; }}</style>"
            ).appendTo("head"),
            a(window).on("load", function () {
                a("body").append('<div class="magnify-mobile"><div class="lens-mobile"></div></div>');
                var b = a(".lens-mobile");
                if (b.is(":visible") && ("ontouchstart" in window || (window.DocumentTouch && document instanceof DocumentTouch) || navigator.msMaxTouchPoints)) {
                    var c = a(".magnify"),
                        d = a(".magnify-mobile");
                    c.off(),
                        d.hide().append('<i class="close">&times;</i>'),
                        d.children(".close").on("touchstart", function () {
                            d.toggle();
                        }),
                        c.children("img").on({
                            touchend: function () {
                                if (!a(this).data("drag")) {
                                    var c = a(this).data("scrollOffset");
                                    d.toggle(), b.scrollLeft(c.x), b.scrollTop(c.y);
                                }
                            },
                            touchmove: function () {
                                a(this).data("drag", !0);
                            },
                            touchstart: function (c) {
                                b.html(
                                    '<img src="' +
                                        a(this)
                                            .prev(".magnify-lens")
                                            .css("background-image")
                                            .replace(/url\(["']?|["']?\)/g, "") +
                                        '" alt="">'
                                );
                                var d = a(this),
                                    e = d.data("zoomSize"),
                                    f = c.originalEvent.touches[0].pageX - d.offset().left,
                                    g = f / d.width(),
                                    h = c.originalEvent.touches[0].pageY - d.offset().top,
                                    i = h / d.height();
                                d.data("scrollOffset", { x: e.width * g - window.innerWidth / 2, y: e.height * i - window.innerHeight / 2 }), a(this).data("drag", !1);
                            },
                        });
                }
            }));
    })(jQuery),
    (function (a) {
        a.fn.magnify = function (b) {
            b = a.extend({ src: "", speed: 100, timeout: -1, finalWidth: null, finalHeight: null, magnifiedWidth: null, magnifiedHeight: null, limitBounds: !1, afterLoad: function () {} }, b);
            var c = this,
                d = a("html"),
                e = function (c) {
                    var e = a(c),
                        f = e.closest("a"),
                        h = {};
                    for (var i in b) h[i] = e.attr("data-magnify-" + i.toLowerCase());
                    var j = h.src || b.src || f.attr("href") || "";
                    if (j) {
                        var k,
                            l,
                            m,
                            n,
                            o,
                            p,
                            q,
                            r,
                            s,
                            t,
                            u = 0,
                            v = 0,
                            w = function () {
                                var a = k.offset();
                                return (
                                    (t = {
                                        top: e.offset().top - a.top + parseInt(e.css("border-top-width")) + parseInt(e.css("padding-top")),
                                        left: e.offset().left - a.left + parseInt(e.css("border-left-width")) + parseInt(e.css("padding-left")),
                                    }),
                                    (a.top += t.top),
                                    (a.left += t.left),
                                    a
                                );
                            },
                            x = function () {
                                l.is(":visible") &&
                                    l.fadeOut(b.speed, function () {
                                        d.removeClass("magnifying").trigger("magnifyend");
                                    });
                            };
                        isNaN(+h.speed) || (b.speed = +h.speed),
                            isNaN(+h.timeout) || (b.timeout = +h.timeout),
                            isNaN(+h.finalWidth) || (b.finalWidth = +h.finalWidth),
                            isNaN(+h.finalHeight) || (b.finalHeight = +h.finalHeight),
                            isNaN(+h.magnifiedWidth) || (b.magnifiedWidth = +h.magnifiedWidth),
                            isNaN(+h.magnifiedHeight) || (b.magnifiedHeight = +h.magnifiedHeight),
                            "true" === h.limitBounds && (b.limitBounds = !0),
                            "function" == typeof window[h.afterLoad] && (b.afterLoad = window[h.afterLoad]),
                            e.data("originalStyle", e.attr("style"));
                        var y = new Image();
                        a(y).on({
                            load: function () {
                                var c, i;
                                e.css("display", "block"),
                                    e.parent(".magnify").length || e.wrap('<div class="magnify"></div>'),
                                    (k = e.parent(".magnify")),
                                    e.prev(".magnify-lens").length
                                        ? k.children(".magnify-lens").css("background-image", "url('" + j + "')")
                                        : e.before('<div class="magnify-lens loading" style="background:url(\'' + j + "') 0 0 no-repeat\"></div>"),
                                    (l = k.children(".magnify-lens")),
                                    l.removeClass("loading"),
                                    (m = b.finalWidth || e.width()),
                                    (n = b.finalHeight || e.height()),
                                    (o = b.magnifiedWidth || y.width),
                                    (p = b.magnifiedHeight || y.height),
                                    (q = l.width()),
                                    (r = l.height()),
                                    (s = w()),
                                    b.limitBounds && ((u = q / 2 / (o / m)), (v = r / 2 / (p / n))),
                                    (o === y.width && p === y.height) || l.css("background-size", o + "px " + p + "px"),
                                    e.data("zoomSize", { width: o, height: p }),
                                    (y = null),
                                    b.afterLoad(),
                                    k.off().on({
                                        "mousemove touchmove": function (a) {
                                            if ((a.preventDefault(), !n)) return void g();
                                            if (
                                                ((c = (a.pageX || a.originalEvent.touches[0].pageX) - s.left),
                                                (i = (a.pageY || a.originalEvent.touches[0].pageY) - s.top),
                                                l.is(":animated") || (c > u && c < m - u && i > v && i < n - v ? l.is(":hidden") && (d.addClass("magnifying").trigger("magnifystart"), l.fadeIn(b.speed)) : x()),
                                                l.is(":visible"))
                                            ) {
                                                var e = "";
                                                if (o && p) {
                                                    var f = -Math.round((c / m) * o - q / 2),
                                                        h = -Math.round((i / n) * p - r / 2);
                                                    if (b.limitBounds) {
                                                        var j = -Math.round(((m - u) / m) * o - q / 2),
                                                            k = -Math.round(((n - v) / n) * p - r / 2);
                                                        f > 0 ? (f = 0) : f < j && (f = j), h > 0 ? (h = 0) : h < k && (h = k);
                                                    }
                                                    e = f + "px " + h + "px";
                                                }
                                                l.css({ top: Math.round(i - r / 2) + t.top + "px", left: Math.round(c - q / 2) + t.left + "px", "background-position": e });
                                            }
                                        },
                                        mouseenter: function () {
                                            s = w();
                                        },
                                        mouseleave: x,
                                    }),
                                    b.timeout >= 0 &&
                                        k.on("touchend", function () {
                                            setTimeout(x, b.timeout);
                                        }),
                                    a("body").not(k).on("touchstart", x);
                                var z = e.attr("usemap");
                                if (z) {
                                    var A = a("map[name=" + z.slice(1) + "]");
                                    e.after(A),
                                        k.click(function (b) {
                                            if (b.clientX || b.clientY) {
                                                l.hide();
                                                var d = document.elementFromPoint(b.clientX || b.originalEvent.touches[0].clientX, b.clientY || b.originalEvent.touches[0].clientY);
                                                "AREA" === d.nodeName
                                                    ? d.click()
                                                    : a("area", A).each(function () {
                                                          var b = a(this).attr("coords").split(",");
                                                          if (c >= b[0] && c <= b[2] && i >= b[1] && i <= b[3]) return this.click(), !1;
                                                      });
                                            }
                                        });
                                }
                                f.length &&
                                    (f.css("display", "inline-block"),
                                    !f.attr("href") ||
                                        h.src ||
                                        b.src ||
                                        f.click(function (a) {
                                            a.preventDefault();
                                        }));
                            },
                            error: function () {
                                y = null;
                            },
                        }),
                            (y.src = j);
                    }
                },
                f = 0,
                g = function () {
                    clearTimeout(f),
                        (f = setTimeout(function () {
                            c.destroy(), c.magnify(b);
                        }, 100));
                };
            return (
                (this.destroy = function () {
                    return (
                        this.each(function () {
                            var b = a(this),
                                c = b.prev("div.magnify-lens"),
                                d = b.data("originalStyle");
                            b.parent("div.magnify").length && c.length && (d ? b.attr("style", d) : b.removeAttr("style"), b.unwrap(), c.remove());
                        }),
                        a(window).off("resize", g),
                        c
                    );
                }),
                a(window).resize(g),
                this.each(function () {
                    e(this);
                })
            );
        };
    })(jQuery),
    (function (a) {
        a.extend(a, {
            placeholder: {
                browser_supported: function () {
                    return void 0 !== this._supported ? this._supported : (this._supported = !!("placeholder" in a('<input type="text">')[0]));
                },
                shim: function (b) {
                    var c = { color: "#888", cls: "placeholder", selector: "input[placeholder], textarea[placeholder]" };
                    return a.extend(c, b), !this.browser_supported() && a(c.selector)._placeholder_shim(c);
                },
            },
        }),
            a.extend(a.fn, {
                _placeholder_shim: function (b) {
                    function c(b) {
                        var c = a(b).offsetParent().offset(),
                            d = a(b).offset();
                        return { top: d.top - c.top, left: d.left - c.left, width: a(b).width() };
                    }
                    function d(b) {
                        var e = b.data("target");
                        "undefined" != typeof e &&
                            (b.css(c(e)),
                            a(window).one("resize", function () {
                                d(b);
                            }));
                    }
                    return this.each(function () {
                        var e = a(this);
                        if (e.is(":visible") && !e.val()) {
                            if (e.data("placeholder")) {
                                var f = e.data("placeholder");
                                return f.css(c(e)), !0;
                            }
                            var g = {};
                            e.is("textarea") || "auto" == e.css("height") || (g = { lineHeight: e.css("height"), whiteSpace: "nowrap" });
                            var h = "border-box" === e.css("box-sizing"),
                                i = e.is("textarea"),
                                j = a("<label />")
                                    .text(e.attr("placeholder"))
                                    .addClass(b.cls)
                                    .css(
                                        a.extend(
                                            {
                                                position: "absolute",
                                                display: "inline",
                                                float: "none",
                                                overflow: "hidden",
                                                textAlign: "left",
                                                color: b.color,
                                                cursor: "text",
                                                paddingTop: !i && h ? "0" : e.css("padding-top"),
                                                paddingRight: e.css("padding-right"),
                                                paddingBottom: !i && h ? "0" : e.css("padding-bottom"),
                                                paddingLeft: e.css("padding-left"),
                                                fontSize: e.css("font-size"),
                                                fontFamily: e.css("font-family"),
                                                fontStyle: e.css("font-style"),
                                                fontWeight: e.css("font-weight"),
                                                textTransform: e.css("text-transform"),
                                                backgroundColor: "transparent",
                                                zIndex: 15,
                                            },
                                            g
                                        )
                                    )
                                    .css(c(this))
                                    .attr("for", this.id)
                                    .data("target", e)
                                    .click(function () {
                                        a(this).data("target").is(":disabled") || a(this).data("target").focus();
                                    })
                                    .insertBefore(this);
                            e
                                .data("placeholder", j)
                                .on("keydown", function () {
                                    j.hide();
                                })
                                .on("blur change", function () {
                                    j[e.val().length ? "hide" : "show"]();
                                }),
                                a(window).one("resize", function () {
                                    d(j);
                                });
                        }
                    });
                },
            });
    })(jQuery),
    jQuery(document)
        .add(window)
        .bind("ready load", function () {
            jQuery.placeholder && jQuery.placeholder.shim();
        }),
    !(function (a) {
        "use strict";
        "object" == typeof module && "object" == typeof module.exports ? a(require("jquery"), window, document) : a(jQuery, window, document);
    })(function (a, b, c, d) {
        "use strict";
        if (!b.history.pushState)
            return (
                (a.fn.smoothState = function () {
                    return this;
                }),
                void (a.fn.smoothState.options = {})
            );
        if (!a.fn.smoothState) {
            var e = a("html, body"),
                f = b.console,
                g = {
                    debug: !1,
                    anchors: "a",
                    hrefRegex: "",
                    forms: "form",
                    allowFormCaching: !1,
                    repeatDelay: 500,
                    blacklist: ".no-smoothState",
                    prefetch: !1,
                    prefetchOn: "mouseover touchstart",
                    prefetchBlacklist: ".no-prefetch",
                    locationHeader: "X-SmoothState-Location",
                    cacheLength: 0,
                    loadingClass: "is-loading",
                    scroll: !0,
                    alterRequest: function (a) {
                        return a;
                    },
                    alterChangeState: function (a, b, c) {
                        return a;
                    },
                    onBefore: function (a, b) {},
                    onStart: { duration: 0, render: function (a) {} },
                    onProgress: { duration: 0, render: function (a) {} },
                    onReady: {
                        duration: 0,
                        render: function (a, b) {
                            a.html(b);
                        },
                    },
                    onAfter: function (a, b) {},
                },
                h = {
                    isExternal: function (a) {
                        var c = a.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
                        return (
                            ("string" == typeof c[1] && c[1].length > 0 && c[1].toLowerCase() !== b.location.protocol) ||
                            ("string" == typeof c[2] && c[2].length > 0 && c[2].replace(new RegExp(":(" + { "http:": 80, "https:": 443 }[b.location.protocol] + ")?$"), "") !== b.location.host)
                        );
                    },
                    stripHash: function (a) {
                        return a.replace(/#.*/, "");
                    },
                    isHash: function (a, c) {
                        c = c || b.location.href;
                        var d = a.indexOf("#") > -1,
                            e = h.stripHash(a) === h.stripHash(c);
                        return d && e;
                    },
                    translate: function (b) {
                        var c = { dataType: "html", type: "GET" };
                        return (b = "string" == typeof b ? a.extend({}, c, { url: b }) : a.extend({}, c, b));
                    },
                    shouldLoadAnchor: function (a, b, c) {
                        var e = a.prop("href");
                        return !(h.isExternal(e) || h.isHash(e) || a.is(b) || a.prop("target") || (typeof c !== d && "" !== c && -1 === a.prop("href").search(c)));
                    },
                    clearIfOverCapacity: function (a, b) {
                        return (
                            Object.keys ||
                                (Object.keys = function (a) {
                                    var b,
                                        c = [];
                                    for (b in a) Object.prototype.hasOwnProperty.call(a, b) && c.push(b);
                                    return c;
                                }),
                            Object.keys(a).length > b && (a = {}),
                            a
                        );
                    },
                    storePageIn: function (b, c, d, e, f, g) {
                        var h = a("<html></html>").append(a(d));
                        return "undefined" == typeof f && (f = {}), "undefined" == typeof g && (g = c), (b[c] = { status: "loaded", title: h.find("title").first().text(), html: h.find("#" + e), doc: d, state: f, destUrl: g }), b;
                    },
                    triggerAllAnimationEndEvent: function (b, c) {
                        c = " " + c || "";
                        var d = 0,
                            e = "animationstart webkitAnimationStart oanimationstart MSAnimationStart",
                            f = "animationend webkitAnimationEnd oanimationend MSAnimationEnd",
                            g = "allanimationend",
                            i = function (c) {
                                a(c.delegateTarget).is(b) && (c.stopPropagation(), d++);
                            },
                            j = function (c) {
                                a(c.delegateTarget).is(b) && (c.stopPropagation(), d--, 0 === d && b.trigger(g));
                            };
                        b.on(e, i),
                            b.on(f, j),
                            b.on("allanimationend" + c, function () {
                                (d = 0), h.redraw(b);
                            });
                    },
                    redraw: function (a) {
                        a.height();
                    },
                },
                i = function (c) {
                    if (null !== c.state) {
                        var d = b.location.href,
                            e = a("#" + c.state.id),
                            f = e.data("smoothState"),
                            g = f.href !== d && !h.isHash(d, f.href),
                            i = c.state !== f.cache[f.href].state;
                        (g || i) && (i && f.clear(f.href), f.load(d, !1));
                    }
                },
                j = function (g, i) {
                    var j = a(g),
                        k = j.prop("id"),
                        l = null,
                        m = !1,
                        n = {},
                        o = {},
                        p = b.location.href,
                        q = function (a) {
                            (a = a || !1), a && n.hasOwnProperty(a) ? delete n[a] : (n = {}), (j.data("smoothState").cache = n);
                        },
                        r = function (b, c) {
                            c = c || a.noop;
                            var d = h.translate(b);
                            if (((n = h.clearIfOverCapacity(n, i.cacheLength)), !n.hasOwnProperty(d.url) || "undefined" != typeof d.data)) {
                                n[d.url] = { status: "fetching" };
                                var e = a.ajax(d);
                                e.done(function (a) {
                                    h.storePageIn(n, d.url, a, k), (j.data("smoothState").cache = n);
                                }),
                                    e.fail(function () {
                                        n[d.url].status = "error";
                                    }),
                                    i.locationHeader &&
                                        e.always(function (a, b, c) {
                                            var e = a.statusCode ? a : c,
                                                f = e.getResponseHeader(i.locationHeader);
                                            f && (n[d.url].destUrl = f);
                                        }),
                                    c && e.always(c);
                            }
                        },
                        s = function () {
                            if (l) {
                                var b = a(l, j);
                                if (b.length) {
                                    var c = b.offset().top;
                                    e.scrollTop(c);
                                }
                                l = null;
                            }
                        },
                        t = function (d) {
                            var g = "#" + k,
                                h = n[d] ? a(n[d].html.html()) : null;
                            h.length
                                ? ((c.title = n[d].title),
                                  (j.data("smoothState").href = d),
                                  i.loadingClass && e.removeClass(i.loadingClass),
                                  i.onReady.render(j, h),
                                  j.one("ss.onReadyEnd", function () {
                                      (m = !1), i.onAfter(j, h), i.scroll && s(), B(j);
                                  }),
                                  b.setTimeout(function () {
                                      j.trigger("ss.onReadyEnd");
                                  }, i.onReady.duration))
                                : !h && i.debug && f
                                ? f.warn("No element with an id of " + g + " in response from " + d + " in " + n)
                                : (b.location = d);
                        },
                        u = function (a, c, d) {
                            var g = h.translate(a);
                            "undefined" == typeof c && (c = !0), "undefined" == typeof d && (d = !0);
                            var l = !1,
                                m = !1,
                                p = {
                                    loaded: function () {
                                        var a = l ? "ss.onProgressEnd" : "ss.onStartEnd";
                                        if (
                                            (m && l
                                                ? m && t(g.url)
                                                : j.one(a, function () {
                                                      t(g.url), d || q(g.url);
                                                  }),
                                            c)
                                        ) {
                                            var e = n[g.url].destUrl;
                                            (o = i.alterChangeState({ id: k }, n[g.url].title, e)), (n[g.url].state = o), b.history.pushState(o, n[g.url].title, e);
                                        }
                                        m && !d && q(g.url);
                                    },
                                    fetching: function () {
                                        l ||
                                            ((l = !0),
                                            j.one("ss.onStartEnd", function () {
                                                i.loadingClass && e.addClass(i.loadingClass),
                                                    i.onProgress.render(j),
                                                    b.setTimeout(function () {
                                                        j.trigger("ss.onProgressEnd"), (m = !0);
                                                    }, i.onProgress.duration);
                                            })),
                                            b.setTimeout(function () {
                                                n.hasOwnProperty(g.url) && p[n[g.url].status]();
                                            }, 10);
                                    },
                                    error: function () {
                                        i.debug && f ? f.log("There was an error loading: " + g.url) : (b.location = g.url);
                                    },
                                };
                            n.hasOwnProperty(g.url) || r(g),
                                i.onStart.render(j),
                                b.setTimeout(function () {
                                    i.scroll && e.scrollTop(0), j.trigger("ss.onStartEnd");
                                }, i.onStart.duration),
                                p[n[g.url].status]();
                        },
                        v = function (b) {
                            var c,
                                d = a(b.currentTarget);
                            h.shouldLoadAnchor(d, i.blacklist, i.hrefRegex) && !m && (b.stopPropagation(), (c = h.translate(d.prop("href"))), (c = i.alterRequest(c)), r(c));
                        },
                        w = function (b) {
                            var c = a(b.currentTarget);
                            if (!b.metaKey && !b.ctrlKey && h.shouldLoadAnchor(c, i.blacklist, i.hrefRegex) && (b.stopPropagation(), b.preventDefault(), !z())) {
                                A();
                                var d = h.translate(c.prop("href"));
                                (m = !0), (l = c.prop("hash")), (d = i.alterRequest(d)), i.onBefore(c, j), u(d);
                            }
                        },
                        x = function (b) {
                            var c = a(b.currentTarget);
                            if (!c.is(i.blacklist) && (b.preventDefault(), b.stopPropagation(), !z())) {
                                A();
                                var e = { url: c.prop("action"), data: c.serialize(), type: c.prop("method") };
                                (m = !0), (e = i.alterRequest(e)), "get" === e.type.toLowerCase() && (e.url = e.url + "?" + e.data), i.onBefore(c, j), u(e, d, i.allowFormCaching);
                            }
                        },
                        y = 0,
                        z = function () {
                            var a = null === i.repeatDelay,
                                b = parseInt(Date.now()) > y;
                            return !(a || b);
                        },
                        A = function () {
                            y = parseInt(Date.now()) + parseInt(i.repeatDelay);
                        },
                        B = function (a) {
                            i.anchors && i.prefetch && a.find(i.anchors).not(i.prefetchBlacklist).on(i.prefetchOn, null, v);
                        },
                        C = function (a) {
                            i.anchors && (a.on("click", i.anchors, w), B(a)), i.forms && a.on("submit", i.forms, x);
                        },
                        D = function () {
                            var a = j.prop("class");
                            j.removeClass(a), h.redraw(j), j.addClass(a);
                        };
                    return (
                        (i = a.extend({}, a.fn.smoothState.options, i)),
                        null === b.history.state ? ((o = i.alterChangeState({ id: k }, c.title, p)), b.history.replaceState(o, c.title, p)) : (o = {}),
                        h.storePageIn(n, p, c.documentElement.outerHTML, k, o),
                        h.triggerAllAnimationEndEvent(j, "ss.onStartEnd ss.onProgressEnd ss.onEndEnd"),
                        C(j),
                        { href: p, cache: n, clear: q, load: u, fetch: r, restartCSSAnimations: D }
                    );
                },
                k = function (b) {
                    return this.each(function () {
                        var c = this.tagName.toLowerCase();
                        this.id && "body" !== c && "html" !== c && !a.data(this, "smoothState")
                            ? a.data(this, "smoothState", new j(this, b))
                            : !this.id && f
                            ? f.warn("Every smoothState container needs an id but the following one does not have one:", this)
                            : ("body" !== c && "html" !== c) || !f || f.warn("The smoothstate container cannot be the " + this.tagName + " tag");
                    });
                };
            (b.onpopstate = i), (a.smoothStateUtility = h), (a.fn.smoothState = k), (a.fn.smoothState.options = g);
        }
    }),
    (function (a, b) {
        var c,
            d = a.jQuery || a.Cowboy || (a.Cowboy = {});
        (d.throttle = c = function (a, c, e, f) {
            function g() {
                function d() {
                    (i = +new Date()), e.apply(j, l);
                }
                function g() {
                    h = b;
                }
                var j = this,
                    k = +new Date() - i,
                    l = arguments;
                f && !h && d(), h && clearTimeout(h), f === b && k > a ? d() : c !== !0 && (h = setTimeout(f ? g : d, f === b ? a - k : a));
            }
            var h,
                i = 0;
            return "boolean" != typeof c && ((f = e), (e = c), (c = b)), d.guid && (g.guid = e.guid = e.guid || d.guid++), g;
        }),
            (d.debounce = function (a, d, e) {
                return e === b ? c(a, d, !1) : c(a, e, d !== !1);
            });
    })(this),
    !(function (a, b) {
        "function" == typeof define && define.amd ? define(["jquery"], b) : b("object" == typeof exports ? require("jquery") : a.jQuery);
    })(this, function (a) {
        "use strict";
        function b(a) {
            var b,
                c,
                d,
                e,
                f,
                g,
                h,
                i = {};
            for (
                f = a
                    .replace(/\s*:\s*/g, ":")
                    .replace(/\s*,\s*/g, ",")
                    .split(","),
                    h = 0,
                    g = f.length;
                h < g && ((c = f[h]), c.search(/^(http|https|ftp):\/\//) === -1 && c.search(":") !== -1);
                h++
            )
                (b = c.indexOf(":")), (d = c.substring(0, b)), (e = c.substring(b + 1)), e || (e = void 0), "string" == typeof e && (e = "true" === e || ("false" !== e && e)), "string" == typeof e && (e = isNaN(e) ? e : +e), (i[d] = e);
            return null == d && null == e ? a : i;
        }
        function c(a) {
            a = "" + a;
            var b,
                c,
                d,
                e = a.split(/\s+/),
                f = "50%",
                g = "50%";
            for (d = 0, b = e.length; d < b; d++)
                (c = e[d]), "left" === c ? (f = "0%") : "right" === c ? (f = "100%") : "top" === c ? (g = "0%") : "bottom" === c ? (g = "100%") : "center" === c ? (0 === d ? (f = "50%") : (g = "50%")) : 0 === d ? (f = c) : (g = c);
            return { x: f, y: g };
        }
        function d(b, c) {
            var d = function () {
                c(this.src);
            };
            a('<img src="' + b + '.gif">').on("load", d), a('<img src="' + b + '.jpg">').on("load", d), a('<img src="' + b + '.jpeg">').on("load", d), a('<img src="' + b + '.png">').on("load", d);
        }
        function e(c, d, e) {
            if (((this.$element = a(c)), "string" == typeof d && (d = b(d)), e ? "string" == typeof e && (e = b(e)) : (e = {}), "string" == typeof d)) d = d.replace(/\.\w*$/, "");
            else if ("object" == typeof d) for (var f in d) d.hasOwnProperty(f) && (d[f] = d[f].replace(/\.\w*$/, ""));
            (this.settings = a.extend({}, g, e)), (this.path = d);
            try {
                this.init();
            } catch (i) {
                if (i.message !== h) throw i;
            }
        }
        var f = "vide",
            g = { volume: 1, playbackRate: 1, muted: !0, loop: !0, autoplay: !0, position: "50% 50%", posterType: "detect", resizing: !0, bgColor: "transparent", className: "" },
            h = "Not implemented";
        (e.prototype.init = function () {
            var b,
                e,
                f = this,
                g = f.path,
                i = g,
                j = "",
                k = f.$element,
                l = f.settings,
                m = c(l.position),
                n = l.posterType;
            (e = f.$wrapper = a("<div>")
                .addClass(l.className)
                .css({
                    position: "absolute",
                    "z-index": -1,
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    overflow: "hidden",
                    "-webkit-background-size": "cover",
                    "-moz-background-size": "cover",
                    "-o-background-size": "cover",
                    "background-size": "cover",
                    "background-color": l.bgColor,
                    "background-repeat": "no-repeat",
                    "background-position": m.x + " " + m.y,
                })),
                "object" == typeof g && (g.poster ? (i = g.poster) : g.mp4 ? (i = g.mp4) : g.webm ? (i = g.webm) : g.ogv && (i = g.ogv)),
                "detect" === n
                    ? d(i, function (a) {
                          e.css("background-image", "url(" + a + ")");
                      })
                    : "none" !== n && e.css("background-image", "url(" + i + "." + n + ")"),
                "static" === k.css("position") && k.css("position", "relative"),
                k.prepend(e),
                "object" == typeof g
                    ? (g.mp4 && (j += '<source src="' + g.mp4 + '.mp4" type="video/mp4">'),
                      g.webm && (j += '<source src="' + g.webm + '.webm" type="video/webm">'),
                      g.ogv && (j += '<source src="' + g.ogv + '.ogv" type="video/ogg">'),
                      (b = f.$video = a("<video>" + j + "</video>")))
                    : (b = f.$video = a('<video><source src="' + g + '.mp4" type="video/mp4"><source src="' + g + '.webm" type="video/webm"><source src="' + g + '.ogv" type="video/ogg"></video>'));
            try {
                b.prop({ autoplay: l.autoplay, loop: l.loop, volume: l.volume, muted: l.muted, defaultMuted: l.muted, playbackRate: l.playbackRate, defaultPlaybackRate: l.playbackRate });
            } catch (o) {
                throw new Error(h);
            }
            b
                .css({
                    margin: "auto",
                    position: "absolute",
                    "z-index": -1,
                    top: m.y,
                    left: m.x,
                    "-webkit-transform": "translate(-" + m.x + ", -" + m.y + ")",
                    "-ms-transform": "translate(-" + m.x + ", -" + m.y + ")",
                    "-moz-transform": "translate(-" + m.x + ", -" + m.y + ")",
                    transform: "translate(-" + m.x + ", -" + m.y + ")",
                    visibility: "hidden",
                    opacity: 0,
                })
                .one("canplaythrough.vide", function () {
                    f.resize();
                })
                .one("playing.vide", function () {
                    b.css({ visibility: "visible", opacity: 1 }), e.css("background-image", "none");
                }),
                k.on("resize.vide", function () {
                    l.resizing && f.resize();
                }),
                e.append(b);
        }),
            (e.prototype.getVideoObject = function () {
                return this.$video[0];
            }),
            (e.prototype.resize = function () {
                if (this.$video) {
                    var a = this.$wrapper,
                        b = this.$video,
                        c = b[0],
                        d = c.videoHeight,
                        e = c.videoWidth,
                        f = a.height(),
                        g = a.width();
                    g / e > f / d ? b.css({ width: g + 2, height: "auto" }) : b.css({ width: "auto", height: f + 2 });
                }
            }),
            (e.prototype.destroy = function () {
                delete a[f].lookup[this.index], this.$video && this.$video.off(f), this.$element.off(f).removeData(f), this.$wrapper.remove();
            }),
            (a[f] = { lookup: [] }),
            (a.fn[f] = function (b, c) {
                var d;
                return (
                    this.each(function () {
                        (d = a.data(this, f)), d && d.destroy(), (d = new e(this, b, c)), (d.index = a[f].lookup.push(d) - 1), a.data(this, f, d);
                    }),
                    this
                );
            }),
            a(document).ready(function () {
                var b = a(window);
                b.on("resize.vide", function () {
                    for (var b, c = a[f].lookup.length, d = 0; d < c; d++) (b = a[f].lookup[d]), b && b.settings.resizing && b.resize();
                }),
                    b.on("unload.vide", function () {
                        return !1;
                    }),
                    a(document)
                        .find("[data-vide-bg]")
                        .each(function (b, c) {
                            var d = a(c),
                                e = d.data("vide-options"),
                                g = d.data("vide-bg");
                            d[f](g, e);
                        });
            });
    }),
    !(function (a, b) {
        "function" == typeof define && define.amd
            ? define("jquery-bridget/jquery-bridget", ["jquery"], function (c) {
                  b(a, c);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("jquery")))
            : (a.jQueryBridget = b(a, a.jQuery));
    })(window, function (a, b) {
        function c(c, f, h) {
            function i(a, b, d) {
                var e,
                    f = "$()." + c + '("' + b + '")';
                return (
                    a.each(function (a, i) {
                        var j = h.data(i, c);
                        if (!j) return void g(c + " not initialized. Cannot call methods, i.e. " + f);
                        var k = j[b];
                        if (!k || "_" == b.charAt(0)) return void g(f + " is not a valid method");
                        var l = k.apply(j, d);
                        e = void 0 === e ? l : e;
                    }),
                    void 0 !== e ? e : a
                );
            }
            function j(a, b) {
                a.each(function (a, d) {
                    var e = h.data(d, c);
                    e ? (e.option(b), e._init()) : ((e = new f(d, b)), h.data(d, c, e));
                });
            }
            (h = h || b || a.jQuery),
                h &&
                    (f.prototype.option ||
                        (f.prototype.option = function (a) {
                            h.isPlainObject(a) && (this.options = h.extend(!0, this.options, a));
                        }),
                    (h.fn[c] = function (a) {
                        if ("string" == typeof a) {
                            var b = e.call(arguments, 1);
                            return i(this, a, b);
                        }
                        return j(this, a), this;
                    }),
                    d(h));
        }
        function d(a) {
            !a || (a && a.bridget) || (a.bridget = c);
        }
        var e = Array.prototype.slice,
            f = a.console,
            g =
                "undefined" == typeof f
                    ? function () {}
                    : function (a) {
                          f.error(a);
                      };
        return d(b || a.jQuery), c;
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("get-size/get-size", [], function () {
                  return b();
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b())
            : (a.getSize = b());
    })(window, function () {
        function a(a) {
            var b = parseFloat(a),
                c = -1 == a.indexOf("%") && !isNaN(b);
            return c && b;
        }
        function b() {}
        function c() {
            for (var a = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, b = 0; j > b; b++) {
                var c = i[b];
                a[c] = 0;
            }
            return a;
        }
        function d(a) {
            var b = getComputedStyle(a);
            return b || h("Style returned " + b + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"), b;
        }
        function e() {
            if (!k) {
                k = !0;
                var b = document.createElement("div");
                (b.style.width = "200px"), (b.style.padding = "1px 2px 3px 4px"), (b.style.borderStyle = "solid"), (b.style.borderWidth = "1px 2px 3px 4px"), (b.style.boxSizing = "border-box");
                var c = document.body || document.documentElement;
                c.appendChild(b);
                var e = d(b);
                (f.isBoxSizeOuter = g = 200 == a(e.width)), c.removeChild(b);
            }
        }
        function f(b) {
            if ((e(), "string" == typeof b && (b = document.querySelector(b)), b && "object" == typeof b && b.nodeType)) {
                var f = d(b);
                if ("none" == f.display) return c();
                var h = {};
                (h.width = b.offsetWidth), (h.height = b.offsetHeight);
                for (var k = (h.isBorderBox = "border-box" == f.boxSizing), l = 0; j > l; l++) {
                    var m = i[l],
                        n = f[m],
                        o = parseFloat(n);
                    h[m] = isNaN(o) ? 0 : o;
                }
                var p = h.paddingLeft + h.paddingRight,
                    q = h.paddingTop + h.paddingBottom,
                    r = h.marginLeft + h.marginRight,
                    s = h.marginTop + h.marginBottom,
                    t = h.borderLeftWidth + h.borderRightWidth,
                    u = h.borderTopWidth + h.borderBottomWidth,
                    v = k && g,
                    w = a(f.width);
                w !== !1 && (h.width = w + (v ? 0 : p + t));
                var x = a(f.height);
                return x !== !1 && (h.height = x + (v ? 0 : q + u)), (h.innerWidth = h.width - (p + t)), (h.innerHeight = h.height - (q + u)), (h.outerWidth = h.width + r), (h.outerHeight = h.height + s), h;
            }
        }
        var g,
            h =
                "undefined" == typeof console
                    ? b
                    : function (a) {
                          console.error(a);
                      },
            i = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            j = i.length,
            k = !1;
        return f;
    }),
    (function (a, b) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", b) : "object" == typeof module && module.exports ? (module.exports = b()) : (a.EvEmitter = b());
    })("undefined" != typeof window ? window : this, function () {
        function a() {}
        var b = a.prototype;
        return (
            (b.on = function (a, b) {
                if (a && b) {
                    var c = (this._events = this._events || {}),
                        d = (c[a] = c[a] || []);
                    return -1 == d.indexOf(b) && d.push(b), this;
                }
            }),
            (b.once = function (a, b) {
                if (a && b) {
                    this.on(a, b);
                    var c = (this._onceEvents = this._onceEvents || {}),
                        d = (c[a] = c[a] || {});
                    return (d[b] = !0), this;
                }
            }),
            (b.off = function (a, b) {
                var c = this._events && this._events[a];
                if (c && c.length) {
                    var d = c.indexOf(b);
                    return -1 != d && c.splice(d, 1), this;
                }
            }),
            (b.emitEvent = function (a, b) {
                var c = this._events && this._events[a];
                if (c && c.length) {
                    var d = 0,
                        e = c[d];
                    b = b || [];
                    for (var f = this._onceEvents && this._onceEvents[a]; e; ) {
                        var g = f && f[e];
                        g && (this.off(a, e), delete f[e]), e.apply(this, b), (d += g ? 0 : 1), (e = c[d]);
                    }
                    return this;
                }
            }),
            a
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function (c) {
                  return b(a, c);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("ev-emitter")))
            : (a.Unipointer = b(a, a.EvEmitter));
    })(window, function (a, b) {
        function c() {}
        function d() {}
        var e = (d.prototype = Object.create(b.prototype));
        (e.bindStartEvent = function (a) {
            this._bindStartEvent(a, !0);
        }),
            (e.unbindStartEvent = function (a) {
                this._bindStartEvent(a, !1);
            }),
            (e._bindStartEvent = function (b, c) {
                c = void 0 === c || !!c;
                var d = c ? "addEventListener" : "removeEventListener";
                a.navigator.pointerEnabled ? b[d]("pointerdown", this) : a.navigator.msPointerEnabled ? b[d]("MSPointerDown", this) : (b[d]("mousedown", this), b[d]("touchstart", this));
            }),
            (e.handleEvent = function (a) {
                var b = "on" + a.type;
                this[b] && this[b](a);
            }),
            (e.getTouch = function (a) {
                for (var b = 0; b < a.length; b++) {
                    var c = a[b];
                    if (c.identifier == this.pointerIdentifier) return c;
                }
            }),
            (e.onmousedown = function (a) {
                var b = a.button;
                (b && 0 !== b && 1 !== b) || this._pointerDown(a, a);
            }),
            (e.ontouchstart = function (a) {
                this._pointerDown(a, a.changedTouches[0]);
            }),
            (e.onMSPointerDown = e.onpointerdown = function (a) {
                this._pointerDown(a, a);
            }),
            (e._pointerDown = function (a, b) {
                this.isPointerDown || ((this.isPointerDown = !0), (this.pointerIdentifier = void 0 !== b.pointerId ? b.pointerId : b.identifier), this.pointerDown(a, b));
            }),
            (e.pointerDown = function (a, b) {
                this._bindPostStartEvents(a), this.emitEvent("pointerDown", [a, b]);
            });
        var f = { mousedown: ["mousemove", "mouseup"], touchstart: ["touchmove", "touchend", "touchcancel"], pointerdown: ["pointermove", "pointerup", "pointercancel"], MSPointerDown: ["MSPointerMove", "MSPointerUp", "MSPointerCancel"] };
        return (
            (e._bindPostStartEvents = function (b) {
                if (b) {
                    var c = f[b.type];
                    c.forEach(function (b) {
                        a.addEventListener(b, this);
                    }, this),
                        (this._boundPointerEvents = c);
                }
            }),
            (e._unbindPostStartEvents = function () {
                this._boundPointerEvents &&
                    (this._boundPointerEvents.forEach(function (b) {
                        a.removeEventListener(b, this);
                    }, this),
                    delete this._boundPointerEvents);
            }),
            (e.onmousemove = function (a) {
                this._pointerMove(a, a);
            }),
            (e.onMSPointerMove = e.onpointermove = function (a) {
                a.pointerId == this.pointerIdentifier && this._pointerMove(a, a);
            }),
            (e.ontouchmove = function (a) {
                var b = this.getTouch(a.changedTouches);
                b && this._pointerMove(a, b);
            }),
            (e._pointerMove = function (a, b) {
                this.pointerMove(a, b);
            }),
            (e.pointerMove = function (a, b) {
                this.emitEvent("pointerMove", [a, b]);
            }),
            (e.onmouseup = function (a) {
                this._pointerUp(a, a);
            }),
            (e.onMSPointerUp = e.onpointerup = function (a) {
                a.pointerId == this.pointerIdentifier && this._pointerUp(a, a);
            }),
            (e.ontouchend = function (a) {
                var b = this.getTouch(a.changedTouches);
                b && this._pointerUp(a, b);
            }),
            (e._pointerUp = function (a, b) {
                this._pointerDone(), this.pointerUp(a, b);
            }),
            (e.pointerUp = function (a, b) {
                this.emitEvent("pointerUp", [a, b]);
            }),
            (e._pointerDone = function () {
                (this.isPointerDown = !1), delete this.pointerIdentifier, this._unbindPostStartEvents(), this.pointerDone();
            }),
            (e.pointerDone = c),
            (e.onMSPointerCancel = e.onpointercancel = function (a) {
                a.pointerId == this.pointerIdentifier && this._pointerCancel(a, a);
            }),
            (e.ontouchcancel = function (a) {
                var b = this.getTouch(a.changedTouches);
                b && this._pointerCancel(a, b);
            }),
            (e._pointerCancel = function (a, b) {
                this._pointerDone(), this.pointerCancel(a, b);
            }),
            (e.pointerCancel = function (a, b) {
                this.emitEvent("pointerCancel", [a, b]);
            }),
            (d.getPointerPoint = function (a) {
                return { x: a.pageX, y: a.pageY };
            }),
            d
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("unidragger/unidragger", ["unipointer/unipointer"], function (c) {
                  return b(a, c);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("unipointer")))
            : (a.Unidragger = b(a, a.Unipointer));
    })(window, function (a, b) {
        function c() {}
        function d() {}
        var e = (d.prototype = Object.create(b.prototype));
        (e.bindHandles = function () {
            this._bindHandles(!0);
        }),
            (e.unbindHandles = function () {
                this._bindHandles(!1);
            });
        var f = a.navigator;
        return (
            (e._bindHandles = function (a) {
                a = void 0 === a || !!a;
                var b;
                b = f.pointerEnabled
                    ? function (b) {
                          b.style.touchAction = a ? "none" : "";
                      }
                    : f.msPointerEnabled
                    ? function (b) {
                          b.style.msTouchAction = a ? "none" : "";
                      }
                    : c;
                for (var d = a ? "addEventListener" : "removeEventListener", e = 0; e < this.handles.length; e++) {
                    var g = this.handles[e];
                    this._bindStartEvent(g, a), b(g), g[d]("click", this);
                }
            }),
            (e.pointerDown = function (a, b) {
                if ("INPUT" == a.target.nodeName && "range" == a.target.type) return (this.isPointerDown = !1), void delete this.pointerIdentifier;
                this._dragPointerDown(a, b);
                var c = document.activeElement;
                c && c.blur && c.blur(), this._bindPostStartEvents(a), this.emitEvent("pointerDown", [a, b]);
            }),
            (e._dragPointerDown = function (a, c) {
                this.pointerDownPoint = b.getPointerPoint(c);
                var d = this.canPreventDefaultOnPointerDown(a, c);
                d && a.preventDefault();
            }),
            (e.canPreventDefaultOnPointerDown = function (a) {
                return "SELECT" != a.target.nodeName;
            }),
            (e.pointerMove = function (a, b) {
                var c = this._dragPointerMove(a, b);
                this.emitEvent("pointerMove", [a, b, c]), this._dragMove(a, b, c);
            }),
            (e._dragPointerMove = function (a, c) {
                var d = b.getPointerPoint(c),
                    e = { x: d.x - this.pointerDownPoint.x, y: d.y - this.pointerDownPoint.y };
                return !this.isDragging && this.hasDragStarted(e) && this._dragStart(a, c), e;
            }),
            (e.hasDragStarted = function (a) {
                return Math.abs(a.x) > 3 || Math.abs(a.y) > 3;
            }),
            (e.pointerUp = function (a, b) {
                this.emitEvent("pointerUp", [a, b]), this._dragPointerUp(a, b);
            }),
            (e._dragPointerUp = function (a, b) {
                this.isDragging ? this._dragEnd(a, b) : this._staticClick(a, b);
            }),
            (e._dragStart = function (a, c) {
                (this.isDragging = !0), (this.dragStartPoint = b.getPointerPoint(c)), (this.isPreventingClicks = !0), this.dragStart(a, c);
            }),
            (e.dragStart = function (a, b) {
                this.emitEvent("dragStart", [a, b]);
            }),
            (e._dragMove = function (a, b, c) {
                this.isDragging && this.dragMove(a, b, c);
            }),
            (e.dragMove = function (a, b, c) {
                a.preventDefault(), this.emitEvent("dragMove", [a, b, c]);
            }),
            (e._dragEnd = function (a, b) {
                (this.isDragging = !1),
                    setTimeout(
                        function () {
                            delete this.isPreventingClicks;
                        }.bind(this)
                    ),
                    this.dragEnd(a, b);
            }),
            (e.dragEnd = function (a, b) {
                this.emitEvent("dragEnd", [a, b]);
            }),
            (e.onclick = function (a) {
                this.isPreventingClicks && a.preventDefault();
            }),
            (e._staticClick = function (a, b) {
                if (!this.isIgnoringMouseUp || "mouseup" != a.type) {
                    var c = a.target.nodeName;
                    ("INPUT" == c || "TEXTAREA" == c) && a.target.focus(),
                        this.staticClick(a, b),
                        "mouseup" != a.type &&
                            ((this.isIgnoringMouseUp = !0),
                            setTimeout(
                                function () {
                                    delete this.isIgnoringMouseUp;
                                }.bind(this),
                                400
                            ));
                }
            }),
            (e.staticClick = function (a, b) {
                this.emitEvent("staticClick", [a, b]);
            }),
            (d.getPointerPoint = b.getPointerPoint),
            d
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define(["get-size/get-size", "unidragger/unidragger"], function (c, d) {
                  return b(a, c, d);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("get-size"), require("unidragger")))
            : (a.Draggabilly = b(a, a.getSize, a.Unidragger));
    })(window, function (a, b, c) {
        function d() {}
        function e(a, b) {
            for (var c in b) a[c] = b[c];
            return a;
        }
        function f(a) {
            return a instanceof HTMLElement;
        }
        function g(a, b) {
            (this.element = "string" == typeof a ? i.querySelector(a) : a), n && (this.$element = n(this.element)), (this.options = e({}, this.constructor.defaults)), this.option(b), this._create();
        }
        function h(a, b, c) {
            return (c = c || "round"), b ? Math[c](a / b) * b : a;
        }
        var i = a.document,
            j = a.requestAnimationFrame || a.webkitRequestAnimationFrame || a.mozRequestAnimationFrame,
            k = 0;
        j ||
            (j = function (a) {
                var b = new Date().getTime(),
                    c = Math.max(0, 16 - (b - k)),
                    d = setTimeout(a, c);
                return (k = b + c), d;
            });
        var l = i.documentElement,
            m = "string" == typeof l.style.transform ? "transform" : "WebkitTransform",
            n = a.jQuery,
            o = (g.prototype = Object.create(c.prototype));
        (g.defaults = {}),
            (o.option = function (a) {
                e(this.options, a);
            });
        var p = { relative: !0, absolute: !0, fixed: !0 };
        return (
            (o._create = function () {
                (this.position = {}), this._getPosition(), (this.startPoint = { x: 0, y: 0 }), (this.dragPoint = { x: 0, y: 0 }), (this.startPosition = e({}, this.position));
                var a = getComputedStyle(this.element);
                p[a.position] || (this.element.style.position = "relative"), this.enable(), this.setHandles();
            }),
            (o.setHandles = function () {
                (this.handles = this.options.handle ? this.element.querySelectorAll(this.options.handle) : [this.element]), this.bindHandles();
            }),
            (o.dispatchEvent = function (b, c, d) {
                var e = [c].concat(d);
                this.emitEvent(b, e);
                var f = a.jQuery;
                if (f && this.$element)
                    if (c) {
                        var g = f.Event(c);
                        (g.type = b), this.$element.trigger(g, d);
                    } else this.$element.trigger(b, d);
            }),
            (o._getPosition = function () {
                var a = getComputedStyle(this.element),
                    b = this._getPositionCoord(a.left, "width"),
                    c = this._getPositionCoord(a.top, "height");
                (this.position.x = isNaN(b) ? 0 : b), (this.position.y = isNaN(c) ? 0 : c), this._addTransformPosition(a);
            }),
            (o._getPositionCoord = function (a, c) {
                if (-1 != a.indexOf("%")) {
                    var d = b(this.element.parentNode);
                    return d ? (parseFloat(a) / 100) * d[c] : 0;
                }
                return parseInt(a, 10);
            }),
            (o._addTransformPosition = function (a) {
                var b = a[m];
                if (0 === b.indexOf("matrix")) {
                    var c = b.split(","),
                        d = 0 === b.indexOf("matrix3d") ? 12 : 4,
                        e = parseInt(c[d], 10),
                        f = parseInt(c[d + 1], 10);
                    (this.position.x += e), (this.position.y += f);
                }
            }),
            (o.pointerDown = function (a, b) {
                this._dragPointerDown(a, b);
                var c = i.activeElement;
                c && c.blur && c != i.body && c.blur(), this._bindPostStartEvents(a), this.element.classList.add("is-pointer-down"), this.dispatchEvent("pointerDown", a, [b]);
            }),
            (o.pointerMove = function (a, b) {
                var c = this._dragPointerMove(a, b);
                this.dispatchEvent("pointerMove", a, [b, c]), this._dragMove(a, b, c);
            }),
            (o.dragStart = function (a, b) {
                this.isEnabled &&
                    (this._getPosition(),
                    this.measureContainment(),
                    (this.startPosition.x = this.position.x),
                    (this.startPosition.y = this.position.y),
                    this.setLeftTop(),
                    (this.dragPoint.x = 0),
                    (this.dragPoint.y = 0),
                    this.element.classList.add("is-dragging"),
                    this.dispatchEvent("dragStart", a, [b]),
                    this.animate());
            }),
            (o.measureContainment = function () {
                var a = this.options.containment;
                if (a) {
                    var c = f(a) ? a : "string" == typeof a ? i.querySelector(a) : this.element.parentNode,
                        d = b(this.element),
                        e = b(c),
                        g = this.element.getBoundingClientRect(),
                        h = c.getBoundingClientRect(),
                        j = e.borderLeftWidth + e.borderRightWidth,
                        k = e.borderTopWidth + e.borderBottomWidth,
                        l = (this.relativeStartPosition = { x: g.left - (h.left + e.borderLeftWidth), y: g.top - (h.top + e.borderTopWidth) });
                    this.containSize = { width: e.width - j - l.x - d.width, height: e.height - k - l.y - d.height };
                }
            }),
            (o.dragMove = function (a, b, c) {
                if (this.isEnabled) {
                    var d = c.x,
                        e = c.y,
                        f = this.options.grid,
                        g = f && f[0],
                        i = f && f[1];
                    (d = h(d, g)),
                        (e = h(e, i)),
                        (d = this.containDrag("x", d, g)),
                        (e = this.containDrag("y", e, i)),
                        (d = "y" == this.options.axis ? 0 : d),
                        (e = "x" == this.options.axis ? 0 : e),
                        (this.position.x = this.startPosition.x + d),
                        (this.position.y = this.startPosition.y + e),
                        (this.dragPoint.x = d),
                        (this.dragPoint.y = e),
                        this.dispatchEvent("dragMove", a, [b, c]);
                }
            }),
            (o.containDrag = function (a, b, c) {
                if (!this.options.containment) return b;
                var d = "x" == a ? "width" : "height",
                    e = this.relativeStartPosition[a],
                    f = h(-e, c, "ceil"),
                    g = this.containSize[d];
                return (g = h(g, c, "floor")), Math.min(g, Math.max(f, b));
            }),
            (o.pointerUp = function (a, b) {
                this.element.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", a, [b]), this._dragPointerUp(a, b);
            }),
            (o.dragEnd = function (a, b) {
                this.isEnabled && (m && ((this.element.style[m] = ""), this.setLeftTop()), this.element.classList.remove("is-dragging"), this.dispatchEvent("dragEnd", a, [b]));
            }),
            (o.animate = function () {
                if (this.isDragging) {
                    this.positionDrag();
                    var a = this;
                    j(function () {
                        a.animate();
                    });
                }
            }),
            (o.setLeftTop = function () {
                (this.element.style.left = this.position.x + "px"), (this.element.style.top = this.position.y + "px");
            }),
            (o.positionDrag = function () {
                this.element.style[m] = "translate3d( " + this.dragPoint.x + "px, " + this.dragPoint.y + "px, 0)";
            }),
            (o.staticClick = function (a, b) {
                this.dispatchEvent("staticClick", a, [b]);
            }),
            (o.enable = function () {
                this.isEnabled = !0;
            }),
            (o.disable = function () {
                (this.isEnabled = !1), this.isDragging && this.dragEnd();
            }),
            (o.destroy = function () {
                this.disable(), (this.element.style[m] = ""), (this.element.style.left = ""), (this.element.style.top = ""), (this.element.style.position = ""), this.unbindHandles(), this.$element && this.$element.removeData("draggabilly");
            }),
            (o._init = d),
            n && n.bridget && n.bridget("draggabilly", g),
            g
        );
    }),
    !(function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("jquery-bridget/jquery-bridget", ["jquery"], function (c) {
                  b(a, c);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("jquery")))
            : (a.jQueryBridget = b(a, a.jQuery));
    })(window, function (a, b) {
        "use strict";
        function c(c, f, h) {
            function i(a, b, d) {
                var e,
                    f = "$()." + c + '("' + b + '")';
                return (
                    a.each(function (a, i) {
                        var j = h.data(i, c);
                        if (!j) return void g(c + " not initialized. Cannot call methods, i.e. " + f);
                        var k = j[b];
                        if (!k || "_" == b.charAt(0)) return void g(f + " is not a valid method");
                        var l = k.apply(j, d);
                        e = void 0 === e ? l : e;
                    }),
                    void 0 !== e ? e : a
                );
            }
            function j(a, b) {
                a.each(function (a, d) {
                    var e = h.data(d, c);
                    e ? (e.option(b), e._init()) : ((e = new f(d, b)), h.data(d, c, e));
                });
            }
            (h = h || b || a.jQuery),
                h &&
                    (f.prototype.option ||
                        (f.prototype.option = function (a) {
                            h.isPlainObject(a) && (this.options = h.extend(!0, this.options, a));
                        }),
                    (h.fn[c] = function (a) {
                        if ("string" == typeof a) {
                            var b = e.call(arguments, 1);
                            return i(this, a, b);
                        }
                        return j(this, a), this;
                    }),
                    d(h));
        }
        function d(a) {
            !a || (a && a.bridget) || (a.bridget = c);
        }
        var e = Array.prototype.slice,
            f = a.console,
            g =
                "undefined" == typeof f
                    ? function () {}
                    : function (a) {
                          f.error(a);
                      };
        return d(b || a.jQuery), c;
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("get-size/get-size", [], function () {
                  return b();
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b())
            : (a.getSize = b());
    })(window, function () {
        "use strict";
        function a(a) {
            var b = parseFloat(a),
                c = -1 == a.indexOf("%") && !isNaN(b);
            return c && b;
        }
        function b() {}
        function c() {
            for (var a = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, b = 0; j > b; b++) {
                var c = i[b];
                a[c] = 0;
            }
            return a;
        }
        function d(a) {
            var b = getComputedStyle(a);
            return b || h("Style returned " + b + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"), b;
        }
        function e() {
            if (!k) {
                k = !0;
                var b = document.createElement("div");
                (b.style.width = "200px"), (b.style.padding = "1px 2px 3px 4px"), (b.style.borderStyle = "solid"), (b.style.borderWidth = "1px 2px 3px 4px"), (b.style.boxSizing = "border-box");
                var c = document.body || document.documentElement;
                c.appendChild(b);
                var e = d(b);
                (f.isBoxSizeOuter = g = 200 == a(e.width)), c.removeChild(b);
            }
        }
        function f(b) {
            if ((e(), "string" == typeof b && (b = document.querySelector(b)), b && "object" == typeof b && b.nodeType)) {
                var f = d(b);
                if ("none" == f.display) return c();
                var h = {};
                (h.width = b.offsetWidth), (h.height = b.offsetHeight);
                for (var k = (h.isBorderBox = "border-box" == f.boxSizing), l = 0; j > l; l++) {
                    var m = i[l],
                        n = f[m],
                        o = parseFloat(n);
                    h[m] = isNaN(o) ? 0 : o;
                }
                var p = h.paddingLeft + h.paddingRight,
                    q = h.paddingTop + h.paddingBottom,
                    r = h.marginLeft + h.marginRight,
                    s = h.marginTop + h.marginBottom,
                    t = h.borderLeftWidth + h.borderRightWidth,
                    u = h.borderTopWidth + h.borderBottomWidth,
                    v = k && g,
                    w = a(f.width);
                w !== !1 && (h.width = w + (v ? 0 : p + t));
                var x = a(f.height);
                return x !== !1 && (h.height = x + (v ? 0 : q + u)), (h.innerWidth = h.width - (p + t)), (h.innerHeight = h.height - (q + u)), (h.outerWidth = h.width + r), (h.outerHeight = h.height + s), h;
            }
        }
        var g,
            h =
                "undefined" == typeof console
                    ? b
                    : function (a) {
                          console.error(a);
                      },
            i = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            j = i.length,
            k = !1;
        return f;
    }),
    (function (a, b) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", b) : "object" == typeof module && module.exports ? (module.exports = b()) : (a.EvEmitter = b());
    })(this, function () {
        function a() {}
        var b = a.prototype;
        return (
            (b.on = function (a, b) {
                if (a && b) {
                    var c = (this._events = this._events || {}),
                        d = (c[a] = c[a] || []);
                    return -1 == d.indexOf(b) && d.push(b), this;
                }
            }),
            (b.once = function (a, b) {
                if (a && b) {
                    this.on(a, b);
                    var c = (this._onceEvents = this._onceEvents || {}),
                        d = (c[a] = c[a] || {});
                    return (d[b] = !0), this;
                }
            }),
            (b.off = function (a, b) {
                var c = this._events && this._events[a];
                if (c && c.length) {
                    var d = c.indexOf(b);
                    return -1 != d && c.splice(d, 1), this;
                }
            }),
            (b.emitEvent = function (a, b) {
                var c = this._events && this._events[a];
                if (c && c.length) {
                    var d = 0,
                        e = c[d];
                    b = b || [];
                    for (var f = this._onceEvents && this._onceEvents[a]; e; ) {
                        var g = f && f[e];
                        g && (this.off(a, e), delete f[e]), e.apply(this, b), (d += g ? 0 : 1), (e = c[d]);
                    }
                    return this;
                }
            }),
            a
        );
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", b) : "object" == typeof module && module.exports ? (module.exports = b()) : (a.matchesSelector = b());
    })(window, function () {
        "use strict";
        var a = (function () {
            var a = Element.prototype;
            if (a.matches) return "matches";
            if (a.matchesSelector) return "matchesSelector";
            for (var b = ["webkit", "moz", "ms", "o"], c = 0; c < b.length; c++) {
                var d = b[c],
                    e = d + "MatchesSelector";
                if (a[e]) return e;
            }
        })();
        return function (b, c) {
            return b[a](c);
        };
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (c) {
                  return b(a, c);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("desandro-matches-selector")))
            : (a.fizzyUIUtils = b(a, a.matchesSelector));
    })(window, function (a, b) {
        var c = {};
        (c.extend = function (a, b) {
            for (var c in b) a[c] = b[c];
            return a;
        }),
            (c.modulo = function (a, b) {
                return ((a % b) + b) % b;
            }),
            (c.makeArray = function (a) {
                var b = [];
                if (Array.isArray(a)) b = a;
                else if (a && "number" == typeof a.length) for (var c = 0; c < a.length; c++) b.push(a[c]);
                else b.push(a);
                return b;
            }),
            (c.removeFrom = function (a, b) {
                var c = a.indexOf(b);
                -1 != c && a.splice(c, 1);
            }),
            (c.getParent = function (a, c) {
                for (; a != document.body; ) if (((a = a.parentNode), b(a, c))) return a;
            }),
            (c.getQueryElement = function (a) {
                return "string" == typeof a ? document.querySelector(a) : a;
            }),
            (c.handleEvent = function (a) {
                var b = "on" + a.type;
                this[b] && this[b](a);
            }),
            (c.filterFindElements = function (a, d) {
                a = c.makeArray(a);
                var e = [];
                return (
                    a.forEach(function (a) {
                        if (a instanceof HTMLElement) {
                            if (!d) return void e.push(a);
                            b(a, d) && e.push(a);
                            for (var c = a.querySelectorAll(d), f = 0; f < c.length; f++) e.push(c[f]);
                        }
                    }),
                    e
                );
            }),
            (c.debounceMethod = function (a, b, c) {
                var d = a.prototype[b],
                    e = b + "Timeout";
                a.prototype[b] = function () {
                    var a = this[e];
                    a && clearTimeout(a);
                    var b = arguments,
                        f = this;
                    this[e] = setTimeout(function () {
                        d.apply(f, b), delete f[e];
                    }, c || 100);
                };
            }),
            (c.docReady = function (a) {
                "complete" == document.readyState ? a() : document.addEventListener("DOMContentLoaded", a);
            }),
            (c.toDashed = function (a) {
                return a
                    .replace(/(.)([A-Z])/g, function (a, b, c) {
                        return b + "-" + c;
                    })
                    .toLowerCase();
            });
        var d = a.console;
        return (
            (c.htmlInit = function (b, e) {
                c.docReady(function () {
                    var f = c.toDashed(e),
                        g = "data-" + f,
                        h = document.querySelectorAll("[" + g + "]"),
                        i = document.querySelectorAll(".js-" + f),
                        j = c.makeArray(h).concat(c.makeArray(i)),
                        k = g + "-options",
                        l = a.jQuery;
                    j.forEach(function (a) {
                        var c,
                            f = a.getAttribute(g) || a.getAttribute(k);
                        try {
                            c = f && JSON.parse(f);
                        } catch (h) {
                            return void (d && d.error("Error parsing " + g + " on " + a.className + ": " + h));
                        }
                        var i = new b(a, c);
                        l && l.data(a, e, i);
                    });
                });
            }),
            c
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], b)
            : "object" == typeof module && module.exports
            ? (module.exports = b(require("ev-emitter"), require("get-size")))
            : ((a.Outlayer = {}), (a.Outlayer.Item = b(a.EvEmitter, a.getSize)));
    })(window, function (a, b) {
        "use strict";
        function c(a) {
            for (var b in a) return !1;
            return (b = null), !0;
        }
        function d(a, b) {
            a && ((this.element = a), (this.layout = b), (this.position = { x: 0, y: 0 }), this._create());
        }
        function e(a) {
            return a.replace(/([A-Z])/g, function (a) {
                return "-" + a.toLowerCase();
            });
        }
        var f = document.documentElement.style,
            g = "string" == typeof f.transition ? "transition" : "WebkitTransition",
            h = "string" == typeof f.transform ? "transform" : "WebkitTransform",
            i = { WebkitTransition: "webkitTransitionEnd", transition: "transitionend" }[g],
            j = { transform: h, transition: g, transitionDuration: g + "Duration", transitionProperty: g + "Property", transitionDelay: g + "Delay" },
            k = (d.prototype = Object.create(a.prototype));
        (k.constructor = d),
            (k._create = function () {
                (this._transn = { ingProperties: {}, clean: {}, onEnd: {} }), this.css({ position: "absolute" });
            }),
            (k.handleEvent = function (a) {
                var b = "on" + a.type;
                this[b] && this[b](a);
            }),
            (k.getSize = function () {
                this.size = b(this.element);
            }),
            (k.css = function (a) {
                var b = this.element.style;
                for (var c in a) {
                    var d = j[c] || c;
                    b[d] = a[c];
                }
            }),
            (k.getPosition = function () {
                var a = getComputedStyle(this.element),
                    b = this.layout._getOption("originLeft"),
                    c = this.layout._getOption("originTop"),
                    d = a[b ? "left" : "right"],
                    e = a[c ? "top" : "bottom"],
                    f = this.layout.size,
                    g = -1 != d.indexOf("%") ? (parseFloat(d) / 100) * f.width : parseInt(d, 10),
                    h = -1 != e.indexOf("%") ? (parseFloat(e) / 100) * f.height : parseInt(e, 10);
                (g = isNaN(g) ? 0 : g), (h = isNaN(h) ? 0 : h), (g -= b ? f.paddingLeft : f.paddingRight), (h -= c ? f.paddingTop : f.paddingBottom), (this.position.x = g), (this.position.y = h);
            }),
            (k.layoutPosition = function () {
                var a = this.layout.size,
                    b = {},
                    c = this.layout._getOption("originLeft"),
                    d = this.layout._getOption("originTop"),
                    e = c ? "paddingLeft" : "paddingRight",
                    f = c ? "left" : "right",
                    g = c ? "right" : "left",
                    h = this.position.x + a[e];
                (b[f] = this.getXValue(h)), (b[g] = "");
                var i = d ? "paddingTop" : "paddingBottom",
                    j = d ? "top" : "bottom",
                    k = d ? "bottom" : "top",
                    l = this.position.y + a[i];
                (b[j] = this.getYValue(l)), (b[k] = ""), this.css(b), this.emitEvent("layout", [this]);
            }),
            (k.getXValue = function (a) {
                var b = this.layout._getOption("horizontal");
                return this.layout.options.percentPosition && !b ? (a / this.layout.size.width) * 100 + "%" : a + "px";
            }),
            (k.getYValue = function (a) {
                var b = this.layout._getOption("horizontal");
                return this.layout.options.percentPosition && b ? (a / this.layout.size.height) * 100 + "%" : a + "px";
            }),
            (k._transitionTo = function (a, b) {
                this.getPosition();
                var c = this.position.x,
                    d = this.position.y,
                    e = parseInt(a, 10),
                    f = parseInt(b, 10),
                    g = e === this.position.x && f === this.position.y;
                if ((this.setPosition(a, b), g && !this.isTransitioning)) return void this.layoutPosition();
                var h = a - c,
                    i = b - d,
                    j = {};
                (j.transform = this.getTranslate(h, i)), this.transition({ to: j, onTransitionEnd: { transform: this.layoutPosition }, isCleaning: !0 });
            }),
            (k.getTranslate = function (a, b) {
                var c = this.layout._getOption("originLeft"),
                    d = this.layout._getOption("originTop");
                return (a = c ? a : -a), (b = d ? b : -b), "translate3d(" + a + "px, " + b + "px, 0)";
            }),
            (k.goTo = function (a, b) {
                this.setPosition(a, b), this.layoutPosition();
            }),
            (k.moveTo = k._transitionTo),
            (k.setPosition = function (a, b) {
                (this.position.x = parseInt(a, 10)), (this.position.y = parseInt(b, 10));
            }),
            (k._nonTransition = function (a) {
                this.css(a.to), a.isCleaning && this._removeStyles(a.to);
                for (var b in a.onTransitionEnd) a.onTransitionEnd[b].call(this);
            }),
            (k.transition = function (a) {
                if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(a);
                var b = this._transn;
                for (var c in a.onTransitionEnd) b.onEnd[c] = a.onTransitionEnd[c];
                for (c in a.to) (b.ingProperties[c] = !0), a.isCleaning && (b.clean[c] = !0);
                if (a.from) {
                    this.css(a.from);
                    var d = this.element.offsetHeight;
                    d = null;
                }
                this.enableTransition(a.to), this.css(a.to), (this.isTransitioning = !0);
            });
        var l = "opacity," + e(h);
        (k.enableTransition = function () {
            if (!this.isTransitioning) {
                var a = this.layout.options.transitionDuration;
                (a = "number" == typeof a ? a + "ms" : a), this.css({ transitionProperty: l, transitionDuration: a, transitionDelay: this.staggerDelay || 0 }), this.element.addEventListener(i, this, !1);
            }
        }),
            (k.onwebkitTransitionEnd = function (a) {
                this.ontransitionend(a);
            }),
            (k.onotransitionend = function (a) {
                this.ontransitionend(a);
            });
        var m = { "-webkit-transform": "transform" };
        (k.ontransitionend = function (a) {
            if (a.target === this.element) {
                var b = this._transn,
                    d = m[a.propertyName] || a.propertyName;
                if ((delete b.ingProperties[d], c(b.ingProperties) && this.disableTransition(), d in b.clean && ((this.element.style[a.propertyName] = ""), delete b.clean[d]), d in b.onEnd)) {
                    var e = b.onEnd[d];
                    e.call(this), delete b.onEnd[d];
                }
                this.emitEvent("transitionEnd", [this]);
            }
        }),
            (k.disableTransition = function () {
                this.removeTransitionStyles(), this.element.removeEventListener(i, this, !1), (this.isTransitioning = !1);
            }),
            (k._removeStyles = function (a) {
                var b = {};
                for (var c in a) b[c] = "";
                this.css(b);
            });
        var n = { transitionProperty: "", transitionDuration: "", transitionDelay: "" };
        return (
            (k.removeTransitionStyles = function () {
                this.css(n);
            }),
            (k.stagger = function (a) {
                (a = isNaN(a) ? 0 : a), (this.staggerDelay = a + "ms");
            }),
            (k.removeElem = function () {
                this.element.parentNode.removeChild(this.element), this.css({ display: "" }), this.emitEvent("remove", [this]);
            }),
            (k.remove = function () {
                return g && parseFloat(this.layout.options.transitionDuration)
                    ? (this.once("transitionEnd", function () {
                          this.removeElem();
                      }),
                      void this.hide())
                    : void this.removeElem();
            }),
            (k.reveal = function () {
                delete this.isHidden, this.css({ display: "" });
                var a = this.layout.options,
                    b = {},
                    c = this.getHideRevealTransitionEndProperty("visibleStyle");
                (b[c] = this.onRevealTransitionEnd), this.transition({ from: a.hiddenStyle, to: a.visibleStyle, isCleaning: !0, onTransitionEnd: b });
            }),
            (k.onRevealTransitionEnd = function () {
                this.isHidden || this.emitEvent("reveal");
            }),
            (k.getHideRevealTransitionEndProperty = function (a) {
                var b = this.layout.options[a];
                if (b.opacity) return "opacity";
                for (var c in b) return c;
            }),
            (k.hide = function () {
                (this.isHidden = !0), this.css({ display: "" });
                var a = this.layout.options,
                    b = {},
                    c = this.getHideRevealTransitionEndProperty("hiddenStyle");
                (b[c] = this.onHideTransitionEnd), this.transition({ from: a.visibleStyle, to: a.hiddenStyle, isCleaning: !0, onTransitionEnd: b });
            }),
            (k.onHideTransitionEnd = function () {
                this.isHidden && (this.css({ display: "none" }), this.emitEvent("hide"));
            }),
            (k.destroy = function () {
                this.css({ position: "", left: "", right: "", top: "", bottom: "", transition: "", transform: "" });
            }),
            d
        );
    }),
    (function (a, b) {
        "use strict";
        "function" == typeof define && define.amd
            ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function (c, d, e, f) {
                  return b(a, c, d, e, f);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = b(a, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")))
            : (a.Outlayer = b(a, a.EvEmitter, a.getSize, a.fizzyUIUtils, a.Outlayer.Item));
    })(window, function (a, b, c, d, e) {
        "use strict";
        function f(a, b) {
            var c = d.getQueryElement(a);
            if (!c) return void (i && i.error("Bad element for " + this.constructor.namespace + ": " + (c || a)));
            (this.element = c), j && (this.$element = j(this.element)), (this.options = d.extend({}, this.constructor.defaults)), this.option(b);
            var e = ++l;
            (this.element.outlayerGUID = e), (m[e] = this), this._create();
            var f = this._getOption("initLayout");
            f && this.layout();
        }
        function g(a) {
            function b() {
                a.apply(this, arguments);
            }
            return (b.prototype = Object.create(a.prototype)), (b.prototype.constructor = b), b;
        }
        function h(a) {
            if ("number" == typeof a) return a;
            var b = a.match(/(^\d*\.?\d*)(\w*)/),
                c = b && b[1],
                d = b && b[2];
            if (!c.length) return 0;
            c = parseFloat(c);
            var e = o[d] || 1;
            return c * e;
        }
        var i = a.console,
            j = a.jQuery,
            k = function () {},
            l = 0,
            m = {};
        (f.namespace = "outlayer"),
            (f.Item = e),
            (f.defaults = {
                containerStyle: { position: "relative" },
                initLayout: !0,
                originLeft: !0,
                originTop: !0,
                resize: !0,
                resizeContainer: !0,
                transitionDuration: "0.4s",
                hiddenStyle: { opacity: 0, transform: "scale(0.001)" },
                visibleStyle: { opacity: 1, transform: "scale(1)" },
            });
        var n = f.prototype;
        d.extend(n, b.prototype),
            (n.option = function (a) {
                d.extend(this.options, a);
            }),
            (n._getOption = function (a) {
                var b = this.constructor.compatOptions[a];
                return b && void 0 !== this.options[b] ? this.options[b] : this.options[a];
            }),
            (f.compatOptions = {
                initLayout: "isInitLayout",
                horizontal: "isHorizontal",
                layoutInstant: "isLayoutInstant",
                originLeft: "isOriginLeft",
                originTop: "isOriginTop",
                resize: "isResizeBound",
                resizeContainer: "isResizingContainer",
            }),
            (n._create = function () {
                this.reloadItems(), (this.stamps = []), this.stamp(this.options.stamp), d.extend(this.element.style, this.options.containerStyle);
                var a = this._getOption("resize");
                a && this.bindResize();
            }),
            (n.reloadItems = function () {
                this.items = this._itemize(this.element.children);
            }),
            (n._itemize = function (a) {
                for (var b = this._filterFindItemElements(a), c = this.constructor.Item, d = [], e = 0; e < b.length; e++) {
                    var f = b[e],
                        g = new c(f, this);
                    d.push(g);
                }
                return d;
            }),
            (n._filterFindItemElements = function (a) {
                return d.filterFindElements(a, this.options.itemSelector);
            }),
            (n.getItemElements = function () {
                return this.items.map(function (a) {
                    return a.element;
                });
            }),
            (n.layout = function () {
                this._resetLayout(), this._manageStamps();
                var a = this._getOption("layoutInstant"),
                    b = void 0 !== a ? a : !this._isLayoutInited;
                this.layoutItems(this.items, b), (this._isLayoutInited = !0);
            }),
            (n._init = n.layout),
            (n._resetLayout = function () {
                this.getSize();
            }),
            (n.getSize = function () {
                this.size = c(this.element);
            }),
            (n._getMeasurement = function (a, b) {
                var d,
                    e = this.options[a];
                e ? ("string" == typeof e ? (d = this.element.querySelector(e)) : e instanceof HTMLElement && (d = e), (this[a] = d ? c(d)[b] : e)) : (this[a] = 0);
            }),
            (n.layoutItems = function (a, b) {
                (a = this._getItemsForLayout(a)), this._layoutItems(a, b), this._postLayout();
            }),
            (n._getItemsForLayout = function (a) {
                return a.filter(function (a) {
                    return !a.isIgnored;
                });
            }),
            (n._layoutItems = function (a, b) {
                if ((this._emitCompleteOnItems("layout", a), a && a.length)) {
                    var c = [];
                    a.forEach(function (a) {
                        var d = this._getItemLayoutPosition(a);
                        (d.item = a), (d.isInstant = b || a.isLayoutInstant), c.push(d);
                    }, this),
                        this._processLayoutQueue(c);
                }
            }),
            (n._getItemLayoutPosition = function () {
                return { x: 0, y: 0 };
            }),
            (n._processLayoutQueue = function (a) {
                this.updateStagger(),
                    a.forEach(function (a, b) {
                        this._positionItem(a.item, a.x, a.y, a.isInstant, b);
                    }, this);
            }),
            (n.updateStagger = function () {
                var a = this.options.stagger;
                return null === a || void 0 === a ? void (this.stagger = 0) : ((this.stagger = h(a)), this.stagger);
            }),
            (n._positionItem = function (a, b, c, d, e) {
                d ? a.goTo(b, c) : (a.stagger(e * this.stagger), a.moveTo(b, c));
            }),
            (n._postLayout = function () {
                this.resizeContainer();
            }),
            (n.resizeContainer = function () {
                var a = this._getOption("resizeContainer");
                if (a) {
                    var b = this._getContainerSize();
                    b && (this._setContainerMeasure(b.width, !0), this._setContainerMeasure(b.height, !1));
                }
            }),
            (n._getContainerSize = k),
            (n._setContainerMeasure = function (a, b) {
                if (void 0 !== a) {
                    var c = this.size;
                    c.isBorderBox && (a += b ? c.paddingLeft + c.paddingRight + c.borderLeftWidth + c.borderRightWidth : c.paddingBottom + c.paddingTop + c.borderTopWidth + c.borderBottomWidth),
                        (a = Math.max(a, 0)),
                        (this.element.style[b ? "width" : "height"] = a + "px");
                }
            }),
            (n._emitCompleteOnItems = function (a, b) {
                function c() {
                    e.dispatchEvent(a + "Complete", null, [b]);
                }
                function d() {
                    g++, g == f && c();
                }
                var e = this,
                    f = b.length;
                if (!b || !f) return void c();
                var g = 0;
                b.forEach(function (b) {
                    b.once(a, d);
                });
            }),
            (n.dispatchEvent = function (a, b, c) {
                var d = b ? [b].concat(c) : c;
                if ((this.emitEvent(a, d), j))
                    if (((this.$element = this.$element || j(this.element)), b)) {
                        var e = j.Event(b);
                        (e.type = a), this.$element.trigger(e, c);
                    } else this.$element.trigger(a, c);
            }),
            (n.ignore = function (a) {
                var b = this.getItem(a);
                b && (b.isIgnored = !0);
            }),
            (n.unignore = function (a) {
                var b = this.getItem(a);
                b && delete b.isIgnored;
            }),
            (n.stamp = function (a) {
                (a = this._find(a)), a && ((this.stamps = this.stamps.concat(a)), a.forEach(this.ignore, this));
            }),
            (n.unstamp = function (a) {
                (a = this._find(a)),
                    a &&
                        a.forEach(function (a) {
                            d.removeFrom(this.stamps, a), this.unignore(a);
                        }, this);
            }),
            (n._find = function (a) {
                return a ? ("string" == typeof a && (a = this.element.querySelectorAll(a)), (a = d.makeArray(a))) : void 0;
            }),
            (n._manageStamps = function () {
                this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this));
            }),
            (n._getBoundingRect = function () {
                var a = this.element.getBoundingClientRect(),
                    b = this.size;
                this._boundingRect = {
                    left: a.left + b.paddingLeft + b.borderLeftWidth,
                    top: a.top + b.paddingTop + b.borderTopWidth,
                    right: a.right - (b.paddingRight + b.borderRightWidth),
                    bottom: a.bottom - (b.paddingBottom + b.borderBottomWidth),
                };
            }),
            (n._manageStamp = k),
            (n._getElementOffset = function (a) {
                var b = a.getBoundingClientRect(),
                    d = this._boundingRect,
                    e = c(a),
                    f = { left: b.left - d.left - e.marginLeft, top: b.top - d.top - e.marginTop, right: d.right - b.right - e.marginRight, bottom: d.bottom - b.bottom - e.marginBottom };
                return f;
            }),
            (n.handleEvent = d.handleEvent),
            (n.bindResize = function () {
                a.addEventListener("resize", this), (this.isResizeBound = !0);
            }),
            (n.unbindResize = function () {
                a.removeEventListener("resize", this), (this.isResizeBound = !1);
            }),
            (n.onresize = function () {
                this.resize();
            }),
            d.debounceMethod(f, "onresize", 100),
            (n.resize = function () {
                this.isResizeBound && this.needsResizeLayout() && this.layout();
            }),
            (n.needsResizeLayout = function () {
                var a = c(this.element),
                    b = this.size && a;
                return b && a.innerWidth !== this.size.innerWidth;
            }),
            (n.addItems = function (a) {
                var b = this._itemize(a);
                return b.length && (this.items = this.items.concat(b)), b;
            }),
            (n.appended = function (a) {
                var b = this.addItems(a);
                b.length && (this.layoutItems(b, !0), this.reveal(b));
            }),
            (n.prepended = function (a) {
                var b = this._itemize(a);
                if (b.length) {
                    var c = this.items.slice(0);
                    (this.items = b.concat(c)), this._resetLayout(), this._manageStamps(), this.layoutItems(b, !0), this.reveal(b), this.layoutItems(c);
                }
            }),
            (n.reveal = function (a) {
                if ((this._emitCompleteOnItems("reveal", a), a && a.length)) {
                    var b = this.updateStagger();
                    a.forEach(function (a, c) {
                        a.stagger(c * b), a.reveal();
                    });
                }
            }),
            (n.hide = function (a) {
                if ((this._emitCompleteOnItems("hide", a), a && a.length)) {
                    var b = this.updateStagger();
                    a.forEach(function (a, c) {
                        a.stagger(c * b), a.hide();
                    });
                }
            }),
            (n.revealItemElements = function (a) {
                var b = this.getItems(a);
                this.reveal(b);
            }),
            (n.hideItemElements = function (a) {
                var b = this.getItems(a);
                this.hide(b);
            }),
            (n.getItem = function (a) {
                for (var b = 0; b < this.items.length; b++) {
                    var c = this.items[b];
                    if (c.element == a) return c;
                }
            }),
            (n.getItems = function (a) {
                a = d.makeArray(a);
                var b = [];
                return (
                    a.forEach(function (a) {
                        var c = this.getItem(a);
                        c && b.push(c);
                    }, this),
                    b
                );
            }),
            (n.remove = function (a) {
                var b = this.getItems(a);
                this._emitCompleteOnItems("remove", b),
                    b &&
                        b.length &&
                        b.forEach(function (a) {
                            a.remove(), d.removeFrom(this.items, a);
                        }, this);
            }),
            (n.destroy = function () {
                var a = this.element.style;
                (a.height = ""),
                    (a.position = ""),
                    (a.width = ""),
                    this.items.forEach(function (a) {
                        a.destroy();
                    }),
                    this.unbindResize();
                var b = this.element.outlayerGUID;
                delete m[b], delete this.element.outlayerGUID, j && j.removeData(this.element, this.constructor.namespace);
            }),
            (f.data = function (a) {
                a = d.getQueryElement(a);
                var b = a && a.outlayerGUID;
                return b && m[b];
            }),
            (f.create = function (a, b) {
                var c = g(f);
                return (
                    (c.defaults = d.extend({}, f.defaults)),
                    d.extend(c.defaults, b),
                    (c.compatOptions = d.extend({}, f.compatOptions)),
                    (c.namespace = a),
                    (c.data = f.data),
                    (c.Item = g(e)),
                    d.htmlInit(c, a),
                    j && j.bridget && j.bridget(a, c),
                    c
                );
            });
        var o = { ms: 1, s: 1e3 };
        return (f.Item = e), f;
    }),
    (function (a, b) {
        "function" == typeof define && define.amd ? define("packery/js/rect", b) : "object" == typeof module && module.exports ? (module.exports = b()) : ((a.Packery = a.Packery || {}), (a.Packery.Rect = b()));
    })(window, function () {
        "use strict";
        function a(b) {
            for (var c in a.defaults) this[c] = a.defaults[c];
            for (c in b) this[c] = b[c];
        }
        a.defaults = { x: 0, y: 0, width: 0, height: 0 };
        var b = a.prototype;
        return (
            (b.contains = function (a) {
                var b = a.width || 0,
                    c = a.height || 0;
                return this.x <= a.x && this.y <= a.y && this.x + this.width >= a.x + b && this.y + this.height >= a.y + c;
            }),
            (b.overlaps = function (a) {
                var b = this.x + this.width,
                    c = this.y + this.height,
                    d = a.x + a.width,
                    e = a.y + a.height;
                return this.x < d && b > a.x && this.y < e && c > a.y;
            }),
            (b.getMaximalFreeRects = function (b) {
                if (!this.overlaps(b)) return !1;
                var c,
                    d = [],
                    e = this.x + this.width,
                    f = this.y + this.height,
                    g = b.x + b.width,
                    h = b.y + b.height;
                return (
                    this.y < b.y && ((c = new a({ x: this.x, y: this.y, width: this.width, height: b.y - this.y })), d.push(c)),
                    e > g && ((c = new a({ x: g, y: this.y, width: e - g, height: this.height })), d.push(c)),
                    f > h && ((c = new a({ x: this.x, y: h, width: this.width, height: f - h })), d.push(c)),
                    this.x < b.x && ((c = new a({ x: this.x, y: this.y, width: b.x - this.x, height: this.height })), d.push(c)),
                    d
                );
            }),
            (b.canFit = function (a) {
                return this.width >= a.width && this.height >= a.height;
            }),
            a
        );
    }),
    (function (a, b) {
        if ("function" == typeof define && define.amd) define("packery/js/packer", ["./rect"], b);
        else if ("object" == typeof module && module.exports) module.exports = b(require("./rect"));
        else {
            var c = (a.Packery = a.Packery || {});
            c.Packer = b(c.Rect);
        }
    })(window, function (a) {
        "use strict";
        function b(a, b, c) {
            (this.width = a || 0), (this.height = b || 0), (this.sortDirection = c || "downwardLeftToRight"), this.reset();
        }
        var c = b.prototype;
        (c.reset = function () {
            this.spaces = [];
            var b = new a({ x: 0, y: 0, width: this.width, height: this.height });
            this.spaces.push(b), (this.sorter = d[this.sortDirection] || d.downwardLeftToRight);
        }),
            (c.pack = function (a) {
                for (var b = 0; b < this.spaces.length; b++) {
                    var c = this.spaces[b];
                    if (c.canFit(a)) {
                        this.placeInSpace(a, c);
                        break;
                    }
                }
            }),
            (c.columnPack = function (a) {
                for (var b = 0; b < this.spaces.length; b++) {
                    var c = this.spaces[b],
                        d = c.x <= a.x && c.x + c.width >= a.x + a.width && c.height >= a.height - 0.01;
                    if (d) {
                        (a.y = c.y), this.placed(a);
                        break;
                    }
                }
            }),
            (c.rowPack = function (a) {
                for (var b = 0; b < this.spaces.length; b++) {
                    var c = this.spaces[b],
                        d = c.y <= a.y && c.y + c.height >= a.y + a.height && c.width >= a.width - 0.01;
                    if (d) {
                        (a.x = c.x), this.placed(a);
                        break;
                    }
                }
            }),
            (c.placeInSpace = function (a, b) {
                (a.x = b.x), (a.y = b.y), this.placed(a);
            }),
            (c.placed = function (a) {
                for (var b = [], c = 0; c < this.spaces.length; c++) {
                    var d = this.spaces[c],
                        e = d.getMaximalFreeRects(a);
                    e ? b.push.apply(b, e) : b.push(d);
                }
                (this.spaces = b), this.mergeSortSpaces();
            }),
            (c.mergeSortSpaces = function () {
                b.mergeRects(this.spaces), this.spaces.sort(this.sorter);
            }),
            (c.addSpace = function (a) {
                this.spaces.push(a), this.mergeSortSpaces();
            }),
            (b.mergeRects = function (a) {
                var b = 0,
                    c = a[b];
                a: for (; c; ) {
                    for (var d = 0, e = a[b + d]; e; ) {
                        if (e == c) d++;
                        else {
                            if (e.contains(c)) {
                                a.splice(b, 1), (c = a[b]);
                                continue a;
                            }
                            c.contains(e) ? a.splice(b + d, 1) : d++;
                        }
                        e = a[b + d];
                    }
                    b++, (c = a[b]);
                }
                return a;
            });
        var d = {
            downwardLeftToRight: function (a, b) {
                return a.y - b.y || a.x - b.x;
            },
            rightwardTopToBottom: function (a, b) {
                return a.x - b.x || a.y - b.y;
            },
        };
        return b;
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("packery/js/item", ["outlayer/outlayer", "./rect"], b)
            : "object" == typeof module && module.exports
            ? (module.exports = b(require("outlayer"), require("./rect")))
            : (a.Packery.Item = b(a.Outlayer, a.Packery.Rect));
    })(window, function (a, b) {
        "use strict";
        var c = document.documentElement.style,
            d = "string" == typeof c.transform ? "transform" : "WebkitTransform",
            e = function () {
                a.Item.apply(this, arguments);
            },
            f = (e.prototype = Object.create(a.Item.prototype)),
            g = f._create;
        f._create = function () {
            g.call(this), (this.rect = new b());
        };
        var h = f.moveTo;
        return (
            (f.moveTo = function (a, b) {
                var c = Math.abs(this.position.x - a),
                    d = Math.abs(this.position.y - b),
                    e = this.layout.dragItemCount && !this.isPlacing && !this.isTransitioning && 1 > c && 1 > d;
                return e ? void this.goTo(a, b) : void h.apply(this, arguments);
            }),
            (f.enablePlacing = function () {
                this.removeTransitionStyles(), this.isTransitioning && d && (this.element.style[d] = "none"), (this.isTransitioning = !1), this.getSize(), this.layout._setRectSize(this.element, this.rect), (this.isPlacing = !0);
            }),
            (f.disablePlacing = function () {
                this.isPlacing = !1;
            }),
            (f.removeElem = function () {
                this.element.parentNode.removeChild(this.element), this.layout.packer.addSpace(this.rect), this.emitEvent("remove", [this]);
            }),
            (f.showDropPlaceholder = function () {
                var a = this.dropPlaceholder;
                a || ((a = this.dropPlaceholder = document.createElement("div")), (a.className = "packery-drop-placeholder"), (a.style.position = "absolute")),
                    (a.style.width = this.size.width + "px"),
                    (a.style.height = this.size.height + "px"),
                    this.positionDropPlaceholder(),
                    this.layout.element.appendChild(a);
            }),
            (f.positionDropPlaceholder = function () {
                this.dropPlaceholder.style[d] = "translate(" + this.rect.x + "px, " + this.rect.y + "px)";
            }),
            (f.hideDropPlaceholder = function () {
                var a = this.dropPlaceholder.parentNode;
                a && a.removeChild(this.dropPlaceholder);
            }),
            e
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define(["get-size/get-size", "outlayer/outlayer", "packery/js/rect", "packery/js/packer", "packery/js/item"], b)
            : "object" == typeof module && module.exports
            ? (module.exports = b(require("get-size"), require("outlayer"), require("./rect"), require("./packer"), require("./item")))
            : (a.Packery = b(a.getSize, a.Outlayer, a.Packery.Rect, a.Packery.Packer, a.Packery.Item));
    })(window, function (a, b, c, d, e) {
        "use strict";
        function f(a, b) {
            return a.position.y - b.position.y || a.position.x - b.position.x;
        }
        function g(a, b) {
            return a.position.x - b.position.x || a.position.y - b.position.y;
        }
        function h(a, b) {
            var c = b.x - a.x,
                d = b.y - a.y;
            return Math.sqrt(c * c + d * d);
        }
        c.prototype.canFit = function (a) {
            return this.width >= a.width - 1 && this.height >= a.height - 1;
        };
        var i = b.create("packery");
        i.Item = e;
        var j = i.prototype;
        (j._create = function () {
            b.prototype._create.call(this), (this.packer = new d()), (this.shiftPacker = new d()), (this.isEnabled = !0), (this.dragItemCount = 0);
            var a = this;
            (this.handleDraggabilly = {
                dragStart: function () {
                    a.itemDragStart(this.element);
                },
                dragMove: function () {
                    a.itemDragMove(this.element, this.position.x, this.position.y);
                },
                dragEnd: function () {
                    a.itemDragEnd(this.element);
                },
            }),
                (this.handleUIDraggable = {
                    start: function (b, c) {
                        c && a.itemDragStart(b.currentTarget);
                    },
                    drag: function (b, c) {
                        c && a.itemDragMove(b.currentTarget, c.position.left, c.position.top);
                    },
                    stop: function (b, c) {
                        c && a.itemDragEnd(b.currentTarget);
                    },
                });
        }),
            (j._resetLayout = function () {
                this.getSize(), this._getMeasurements();
                var a, b, c;
                this._getOption("horizontal") ? ((a = 1 / 0), (b = this.size.innerHeight + this.gutter), (c = "rightwardTopToBottom")) : ((a = this.size.innerWidth + this.gutter), (b = 1 / 0), (c = "downwardLeftToRight")),
                    (this.packer.width = this.shiftPacker.width = a),
                    (this.packer.height = this.shiftPacker.height = b),
                    (this.packer.sortDirection = this.shiftPacker.sortDirection = c),
                    this.packer.reset(),
                    (this.maxY = 0),
                    (this.maxX = 0);
            }),
            (j._getMeasurements = function () {
                this._getMeasurement("columnWidth", "width"), this._getMeasurement("rowHeight", "height"), this._getMeasurement("gutter", "width");
            }),
            (j._getItemLayoutPosition = function (a) {
                if ((this._setRectSize(a.element, a.rect), this.isShifting || this.dragItemCount > 0)) {
                    var b = this._getPackMethod();
                    this.packer[b](a.rect);
                } else this.packer.pack(a.rect);
                return this._setMaxXY(a.rect), a.rect;
            }),
            (j.shiftLayout = function () {
                (this.isShifting = !0), this.layout(), delete this.isShifting;
            }),
            (j._getPackMethod = function () {
                return this._getOption("horizontal") ? "rowPack" : "columnPack";
            }),
            (j._setMaxXY = function (a) {
                (this.maxX = Math.max(a.x + a.width, this.maxX)), (this.maxY = Math.max(a.y + a.height, this.maxY));
            }),
            (j._setRectSize = function (b, c) {
                var d = a(b),
                    e = d.outerWidth,
                    f = d.outerHeight;
                (e || f) && ((e = this._applyGridGutter(e, this.columnWidth)), (f = this._applyGridGutter(f, this.rowHeight))), (c.width = Math.min(e, this.packer.width)), (c.height = Math.min(f, this.packer.height));
            }),
            (j._applyGridGutter = function (a, b) {
                if (!b) return a + this.gutter;
                b += this.gutter;
                var c = a % b,
                    d = c && 1 > c ? "round" : "ceil";
                return (a = Math[d](a / b) * b);
            }),
            (j._getContainerSize = function () {
                return this._getOption("horizontal") ? { width: this.maxX - this.gutter } : { height: this.maxY - this.gutter };
            }),
            (j._manageStamp = function (a) {
                var b,
                    d = this.getItem(a);
                if (d && d.isPlacing) b = d.rect;
                else {
                    var e = this._getElementOffset(a);
                    b = new c({ x: this._getOption("originLeft") ? e.left : e.right, y: this._getOption("originTop") ? e.top : e.bottom });
                }
                this._setRectSize(a, b), this.packer.placed(b), this._setMaxXY(b);
            }),
            (j.sortItemsByPosition = function () {
                var a = this._getOption("horizontal") ? g : f;
                this.items.sort(a);
            }),
            (j.fit = function (a, b, c) {
                var d = this.getItem(a);
                d &&
                    (this.stamp(d.element),
                    d.enablePlacing(),
                    this.updateShiftTargets(d),
                    (b = void 0 === b ? d.rect.x : b),
                    (c = void 0 === c ? d.rect.y : c),
                    this.shift(d, b, c),
                    this._bindFitEvents(d),
                    d.moveTo(d.rect.x, d.rect.y),
                    this.shiftLayout(),
                    this.unstamp(d.element),
                    this.sortItemsByPosition(),
                    d.disablePlacing());
            }),
            (j._bindFitEvents = function (a) {
                function b() {
                    d++, 2 == d && c.dispatchEvent("fitComplete", null, [a]);
                }
                var c = this,
                    d = 0;
                a.once("layout", b), this.once("layoutComplete", b);
            }),
            (j.resize = function () {
                this.isResizeBound && this.needsResizeLayout() && (this.options.shiftPercentResize ? this.resizeShiftPercentLayout() : this.layout());
            }),
            (j.needsResizeLayout = function () {
                var b = a(this.element),
                    c = this._getOption("horizontal") ? "innerHeight" : "innerWidth";
                return b[c] != this.size[c];
            }),
            (j.resizeShiftPercentLayout = function () {
                var b = this._getItemsForLayout(this.items),
                    c = this._getOption("horizontal"),
                    d = c ? "y" : "x",
                    e = c ? "height" : "width",
                    f = c ? "rowHeight" : "columnWidth",
                    g = c ? "innerHeight" : "innerWidth",
                    h = this[f];
                if ((h = h && h + this.gutter)) {
                    this._getMeasurements();
                    var i = this[f] + this.gutter;
                    b.forEach(function (a) {
                        var b = Math.round(a.rect[d] / h);
                        a.rect[d] = b * i;
                    });
                } else {
                    var j = a(this.element)[g] + this.gutter,
                        k = this.packer[e];
                    b.forEach(function (a) {
                        a.rect[d] = (a.rect[d] / k) * j;
                    });
                }
                this.shiftLayout();
            }),
            (j.itemDragStart = function (a) {
                if (this.isEnabled) {
                    this.stamp(a);
                    var b = this.getItem(a);
                    b && (b.enablePlacing(), b.showDropPlaceholder(), this.dragItemCount++, this.updateShiftTargets(b));
                }
            }),
            (j.updateShiftTargets = function (a) {
                this.shiftPacker.reset(), this._getBoundingRect();
                var b = this._getOption("originLeft"),
                    d = this._getOption("originTop");
                this.stamps.forEach(function (a) {
                    var e = this.getItem(a);
                    if (!e || !e.isPlacing) {
                        var f = this._getElementOffset(a),
                            g = new c({ x: b ? f.left : f.right, y: d ? f.top : f.bottom });
                        this._setRectSize(a, g), this.shiftPacker.placed(g);
                    }
                }, this);
                var e = this._getOption("horizontal"),
                    f = e ? "rowHeight" : "columnWidth",
                    g = e ? "height" : "width";
                (this.shiftTargetKeys = []), (this.shiftTargets = []);
                var h,
                    i = this[f];
                if ((i = i && i + this.gutter)) {
                    var j = Math.ceil(a.rect[g] / i),
                        k = Math.floor((this.shiftPacker[g] + this.gutter) / i);
                    h = (k - j) * i;
                    for (var l = 0; k > l; l++) {
                        var m = e ? 0 : l * i,
                            n = e ? l * i : 0;
                        this._addShiftTarget(m, n, h);
                    }
                } else (h = this.shiftPacker[g] + this.gutter - a.rect[g]), this._addShiftTarget(0, 0, h);
                var o = this._getItemsForLayout(this.items),
                    p = this._getPackMethod();
                o.forEach(function (a) {
                    var b = a.rect;
                    this._setRectSize(a.element, b), this.shiftPacker[p](b), this._addShiftTarget(b.x, b.y, h);
                    var c = e ? b.x + b.width : b.x,
                        d = e ? b.y : b.y + b.height;
                    if ((this._addShiftTarget(c, d, h), i))
                        for (var f = Math.round(b[g] / i), j = 1; f > j; j++) {
                            var k = e ? c : b.x + i * j,
                                l = e ? b.y + i * j : d;
                            this._addShiftTarget(k, l, h);
                        }
                }, this);
            }),
            (j._addShiftTarget = function (a, b, c) {
                var d = this._getOption("horizontal") ? b : a;
                if (!(0 !== d && d > c)) {
                    var e = a + "," + b,
                        f = -1 != this.shiftTargetKeys.indexOf(e);
                    f || (this.shiftTargetKeys.push(e), this.shiftTargets.push({ x: a, y: b }));
                }
            }),
            (j.shift = function (a, b, c) {
                var d,
                    e = 1 / 0,
                    f = { x: b, y: c };
                this.shiftTargets.forEach(function (a) {
                    var b = h(a, f);
                    e > b && ((d = a), (e = b));
                }),
                    (a.rect.x = d.x),
                    (a.rect.y = d.y);
            });
        var k = 120;
        (j.itemDragMove = function (a, b, c) {
            function d() {
                f.shift(e, b, c), e.positionDropPlaceholder(), f.layout();
            }
            var e = this.isEnabled && this.getItem(a);
            if (e) {
                (b -= this.size.paddingLeft), (c -= this.size.paddingTop);
                var f = this,
                    g = new Date();
                this._itemDragTime && g - this._itemDragTime < k ? (clearTimeout(this.dragTimeout), (this.dragTimeout = setTimeout(d, k))) : (d(), (this._itemDragTime = g));
            }
        }),
            (j.itemDragEnd = function (a) {
                function b() {
                    d++, 2 == d && (c.element.classList.remove("is-positioning-post-drag"), c.hideDropPlaceholder(), e.dispatchEvent("dragItemPositioned", null, [c]));
                }
                var c = this.isEnabled && this.getItem(a);
                if (c) {
                    clearTimeout(this.dragTimeout), c.element.classList.add("is-positioning-post-drag");
                    var d = 0,
                        e = this;
                    c.once("layout", b),
                        this.once("layoutComplete", b),
                        c.moveTo(c.rect.x, c.rect.y),
                        this.layout(),
                        (this.dragItemCount = Math.max(0, this.dragItemCount - 1)),
                        this.sortItemsByPosition(),
                        c.disablePlacing(),
                        this.unstamp(c.element);
                }
            }),
            (j.bindDraggabillyEvents = function (a) {
                this._bindDraggabillyEvents(a, "on");
            }),
            (j.unbindDraggabillyEvents = function (a) {
                this._bindDraggabillyEvents(a, "off");
            }),
            (j._bindDraggabillyEvents = function (a, b) {
                var c = this.handleDraggabilly;
                a[b]("dragStart", c.dragStart), a[b]("dragMove", c.dragMove), a[b]("dragEnd", c.dragEnd);
            }),
            (j.bindUIDraggableEvents = function (a) {
                this._bindUIDraggableEvents(a, "on");
            }),
            (j.unbindUIDraggableEvents = function (a) {
                this._bindUIDraggableEvents(a, "off");
            }),
            (j._bindUIDraggableEvents = function (a, b) {
                var c = this.handleUIDraggable;
                a[b]("dragstart", c.start)[b]("drag", c.drag)[b]("dragstop", c.stop);
            });
        var l = j.destroy;
        return (
            (j.destroy = function () {
                l.apply(this, arguments), (this.isEnabled = !1);
            }),
            (i.Rect = c),
            (i.Packer = d),
            i
        );
    }),
    (function (a, b) {
        "object" == typeof exports && "undefined" != typeof module ? (module.exports = b()) : "function" == typeof define && define.amd ? define(b) : (a.moment = b());
    })(this, function () {
        "use strict";
        function a() {
            return Hc.apply(null, arguments);
        }
        function b(a) {
            Hc = a;
        }
        function c(a) {
            return "[object Array]" === Object.prototype.toString.call(a);
        }
        function d(a) {
            return a instanceof Date || "[object Date]" === Object.prototype.toString.call(a);
        }
        function e(a, b) {
            var c,
                d = [];
            for (c = 0; c < a.length; ++c) d.push(b(a[c], c));
            return d;
        }
        function f(a, b) {
            return Object.prototype.hasOwnProperty.call(a, b);
        }
        function g(a, b) {
            for (var c in b) f(b, c) && (a[c] = b[c]);
            return f(b, "toString") && (a.toString = b.toString), f(b, "valueOf") && (a.valueOf = b.valueOf), a;
        }
        function h(a, b, c, d) {
            return Ca(a, b, c, d, !0).utc();
        }
        function i() {
            return { empty: !1, unusedTokens: [], unusedInput: [], overflow: -2, charsLeftOver: 0, nullInput: !1, invalidMonth: null, invalidFormat: !1, userInvalidated: !1, iso: !1 };
        }
        function j(a) {
            return null == a._pf && (a._pf = i()), a._pf;
        }
        function k(a) {
            if (null == a._isValid) {
                var b = j(a);
                (a._isValid = !(isNaN(a._d.getTime()) || !(b.overflow < 0) || b.empty || b.invalidMonth || b.invalidWeekday || b.nullInput || b.invalidFormat || b.userInvalidated)),
                    a._strict && (a._isValid = a._isValid && 0 === b.charsLeftOver && 0 === b.unusedTokens.length && void 0 === b.bigHour);
            }
            return a._isValid;
        }
        function l(a) {
            var b = h(NaN);
            return null != a ? g(j(b), a) : (j(b).userInvalidated = !0), b;
        }
        function m(a, b) {
            var c, d, e;
            if (
                ("undefined" != typeof b._isAMomentObject && (a._isAMomentObject = b._isAMomentObject),
                "undefined" != typeof b._i && (a._i = b._i),
                "undefined" != typeof b._f && (a._f = b._f),
                "undefined" != typeof b._l && (a._l = b._l),
                "undefined" != typeof b._strict && (a._strict = b._strict),
                "undefined" != typeof b._tzm && (a._tzm = b._tzm),
                "undefined" != typeof b._isUTC && (a._isUTC = b._isUTC),
                "undefined" != typeof b._offset && (a._offset = b._offset),
                "undefined" != typeof b._pf && (a._pf = j(b)),
                "undefined" != typeof b._locale && (a._locale = b._locale),
                Jc.length > 0)
            )
                for (c in Jc) (d = Jc[c]), (e = b[d]), "undefined" != typeof e && (a[d] = e);
            return a;
        }
        function n(b) {
            m(this, b), (this._d = new Date(null != b._d ? b._d.getTime() : NaN)), Kc === !1 && ((Kc = !0), a.updateOffset(this), (Kc = !1));
        }
        function o(a) {
            return a instanceof n || (null != a && null != a._isAMomentObject);
        }
        function p(a) {
            return a < 0 ? Math.ceil(a) : Math.floor(a);
        }
        function q(a) {
            var b = +a,
                c = 0;
            return 0 !== b && isFinite(b) && (c = p(b)), c;
        }
        function r(a, b, c) {
            var d,
                e = Math.min(a.length, b.length),
                f = Math.abs(a.length - b.length),
                g = 0;
            for (d = 0; d < e; d++) ((c && a[d] !== b[d]) || (!c && q(a[d]) !== q(b[d]))) && g++;
            return g + f;
        }
        function s() {}
        function t(a) {
            return a ? a.toLowerCase().replace("_", "-") : a;
        }
        function u(a) {
            for (var b, c, d, e, f = 0; f < a.length; ) {
                for (e = t(a[f]).split("-"), b = e.length, c = t(a[f + 1]), c = c ? c.split("-") : null; b > 0; ) {
                    if ((d = v(e.slice(0, b).join("-")))) return d;
                    if (c && c.length >= b && r(e, c, !0) >= b - 1) break;
                    b--;
                }
                f++;
            }
            return null;
        }
        function v(a) {
            var b = null;
            if (!Lc[a] && "undefined" != typeof module && module && module.exports)
                try {
                    (b = Ic._abbr), require("./locale/" + a), w(b);
                } catch (c) {}
            return Lc[a];
        }
        function w(a, b) {
            var c;
            return a && ((c = "undefined" == typeof b ? y(a) : x(a, b)), c && (Ic = c)), Ic._abbr;
        }
        function x(a, b) {
            return null !== b ? ((b.abbr = a), (Lc[a] = Lc[a] || new s()), Lc[a].set(b), w(a), Lc[a]) : (delete Lc[a], null);
        }
        function y(a) {
            var b;
            if ((a && a._locale && a._locale._abbr && (a = a._locale._abbr), !a)) return Ic;
            if (!c(a)) {
                if ((b = v(a))) return b;
                a = [a];
            }
            return u(a);
        }
        function z(a, b) {
            var c = a.toLowerCase();
            Mc[c] = Mc[c + "s"] = Mc[b] = a;
        }
        function A(a) {
            return "string" == typeof a ? Mc[a] || Mc[a.toLowerCase()] : void 0;
        }
        function B(a) {
            var b,
                c,
                d = {};
            for (c in a) f(a, c) && ((b = A(c)), b && (d[b] = a[c]));
            return d;
        }
        function C(b, c) {
            return function (d) {
                return null != d ? (E(this, b, d), a.updateOffset(this, c), this) : D(this, b);
            };
        }
        function D(a, b) {
            return a._d["get" + (a._isUTC ? "UTC" : "") + b]();
        }
        function E(a, b, c) {
            return a._d["set" + (a._isUTC ? "UTC" : "") + b](c);
        }
        function F(a, b) {
            var c;
            if ("object" == typeof a) for (c in a) this.set(c, a[c]);
            else if (((a = A(a)), "function" == typeof this[a])) return this[a](b);
            return this;
        }
        function G(a, b, c) {
            var d = "" + Math.abs(a),
                e = b - d.length,
                f = a >= 0;
            return (f ? (c ? "+" : "") : "-") + Math.pow(10, Math.max(0, e)).toString().substr(1) + d;
        }
        function H(a, b, c, d) {
            var e = d;
            "string" == typeof d &&
                (e = function () {
                    return this[d]();
                }),
                a && (Qc[a] = e),
                b &&
                    (Qc[b[0]] = function () {
                        return G(e.apply(this, arguments), b[1], b[2]);
                    }),
                c &&
                    (Qc[c] = function () {
                        return this.localeData().ordinal(e.apply(this, arguments), a);
                    });
        }
        function I(a) {
            return a.match(/\[[\s\S]/) ? a.replace(/^\[|\]$/g, "") : a.replace(/\\/g, "");
        }
        function J(a) {
            var b,
                c,
                d = a.match(Nc);
            for (b = 0, c = d.length; b < c; b++) Qc[d[b]] ? (d[b] = Qc[d[b]]) : (d[b] = I(d[b]));
            return function (e) {
                var f = "";
                for (b = 0; b < c; b++) f += d[b] instanceof Function ? d[b].call(e, a) : d[b];
                return f;
            };
        }
        function K(a, b) {
            return a.isValid() ? ((b = L(b, a.localeData())), (Pc[b] = Pc[b] || J(b)), Pc[b](a)) : a.localeData().invalidDate();
        }
        function L(a, b) {
            function c(a) {
                return b.longDateFormat(a) || a;
            }
            var d = 5;
            for (Oc.lastIndex = 0; d >= 0 && Oc.test(a); ) (a = a.replace(Oc, c)), (Oc.lastIndex = 0), (d -= 1);
            return a;
        }
        function M(a) {
            return "function" == typeof a && "[object Function]" === Object.prototype.toString.call(a);
        }
        function N(a, b, c) {
            dd[a] = M(b)
                ? b
                : function (a) {
                      return a && c ? c : b;
                  };
        }
        function O(a, b) {
            return f(dd, a) ? dd[a](b._strict, b._locale) : new RegExp(P(a));
        }
        function P(a) {
            return a
                .replace("\\", "")
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (a, b, c, d, e) {
                    return b || c || d || e;
                })
                .replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
        }
        function Q(a, b) {
            var c,
                d = b;
            for (
                "string" == typeof a && (a = [a]),
                    "number" == typeof b &&
                        (d = function (a, c) {
                            c[b] = q(a);
                        }),
                    c = 0;
                c < a.length;
                c++
            )
                ed[a[c]] = d;
        }
        function R(a, b) {
            Q(a, function (a, c, d, e) {
                (d._w = d._w || {}), b(a, d._w, d, e);
            });
        }
        function S(a, b, c) {
            null != b && f(ed, a) && ed[a](b, c._a, c, a);
        }
        function T(a, b) {
            return new Date(Date.UTC(a, b + 1, 0)).getUTCDate();
        }
        function U(a) {
            return this._months[a.month()];
        }
        function V(a) {
            return this._monthsShort[a.month()];
        }
        function W(a, b, c) {
            var d, e, f;
            for (this._monthsParse || ((this._monthsParse = []), (this._longMonthsParse = []), (this._shortMonthsParse = [])), d = 0; d < 12; d++) {
                if (
                    ((e = h([2e3, d])),
                    c &&
                        !this._longMonthsParse[d] &&
                        ((this._longMonthsParse[d] = new RegExp("^" + this.months(e, "").replace(".", "") + "$", "i")), (this._shortMonthsParse[d] = new RegExp("^" + this.monthsShort(e, "").replace(".", "") + "$", "i"))),
                    c || this._monthsParse[d] || ((f = "^" + this.months(e, "") + "|^" + this.monthsShort(e, "")), (this._monthsParse[d] = new RegExp(f.replace(".", ""), "i"))),
                    c && "MMMM" === b && this._longMonthsParse[d].test(a))
                )
                    return d;
                if (c && "MMM" === b && this._shortMonthsParse[d].test(a)) return d;
                if (!c && this._monthsParse[d].test(a)) return d;
            }
        }
        function X(a, b) {
            var c;
            return "string" == typeof b && ((b = a.localeData().monthsParse(b)), "number" != typeof b) ? a : ((c = Math.min(a.date(), T(a.year(), b))), a._d["set" + (a._isUTC ? "UTC" : "") + "Month"](b, c), a);
        }
        function Y(b) {
            return null != b ? (X(this, b), a.updateOffset(this, !0), this) : D(this, "Month");
        }
        function Z() {
            return T(this.year(), this.month());
        }
        function $(a) {
            var b,
                c = a._a;
            return (
                c &&
                    j(a).overflow === -2 &&
                    ((b =
                        c[gd] < 0 || c[gd] > 11
                            ? gd
                            : c[hd] < 1 || c[hd] > T(c[fd], c[gd])
                            ? hd
                            : c[id] < 0 || c[id] > 24 || (24 === c[id] && (0 !== c[jd] || 0 !== c[kd] || 0 !== c[ld]))
                            ? id
                            : c[jd] < 0 || c[jd] > 59
                            ? jd
                            : c[kd] < 0 || c[kd] > 59
                            ? kd
                            : c[ld] < 0 || c[ld] > 999
                            ? ld
                            : -1),
                    j(a)._overflowDayOfYear && (b < fd || b > hd) && (b = hd),
                    (j(a).overflow = b)),
                a
            );
        }
        function _(b) {
            a.suppressDeprecationWarnings === !1 && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + b);
        }
        function aa(a, b) {
            var c = !0;
            return g(function () {
                return c && (_(a + "\n" + new Error().stack), (c = !1)), b.apply(this, arguments);
            }, b);
        }
        function ba(a, b) {
            od[a] || (_(b), (od[a] = !0));
        }
        function ca(a) {
            var b,
                c,
                d = a._i,
                e = pd.exec(d);
            if (e) {
                for (j(a).iso = !0, b = 0, c = qd.length; b < c; b++)
                    if (qd[b][1].exec(d)) {
                        a._f = qd[b][0];
                        break;
                    }
                for (b = 0, c = rd.length; b < c; b++)
                    if (rd[b][1].exec(d)) {
                        a._f += (e[6] || " ") + rd[b][0];
                        break;
                    }
                d.match(ad) && (a._f += "Z"), va(a);
            } else a._isValid = !1;
        }
        function da(b) {
            var c = sd.exec(b._i);
            return null !== c ? void (b._d = new Date(+c[1])) : (ca(b), void (b._isValid === !1 && (delete b._isValid, a.createFromInputFallback(b))));
        }
        function ea(a, b, c, d, e, f, g) {
            var h = new Date(a, b, c, d, e, f, g);
            return a < 1970 && h.setFullYear(a), h;
        }
        function fa(a) {
            var b = new Date(Date.UTC.apply(null, arguments));
            return a < 1970 && b.setUTCFullYear(a), b;
        }
        function ga(a) {
            return ha(a) ? 366 : 365;
        }
        function ha(a) {
            return (a % 4 === 0 && a % 100 !== 0) || a % 400 === 0;
        }
        function ia() {
            return ha(this.year());
        }
        function ja(a, b, c) {
            var d,
                e = c - b,
                f = c - a.day();
            return f > e && (f -= 7), f < e - 7 && (f += 7), (d = Da(a).add(f, "d")), { week: Math.ceil(d.dayOfYear() / 7), year: d.year() };
        }
        function ka(a) {
            return ja(a, this._week.dow, this._week.doy).week;
        }
        function la() {
            return this._week.dow;
        }
        function ma() {
            return this._week.doy;
        }
        function na(a) {
            var b = this.localeData().week(this);
            return null == a ? b : this.add(7 * (a - b), "d");
        }
        function oa(a) {
            var b = ja(this, 1, 4).week;
            return null == a ? b : this.add(7 * (a - b), "d");
        }
        function pa(a, b, c, d, e) {
            var f,
                g = 6 + e - d,
                h = fa(a, 0, 1 + g),
                i = h.getUTCDay();
            return i < e && (i += 7), (c = null != c ? 1 * c : e), (f = 1 + g + 7 * (b - 1) - i + c), { year: f > 0 ? a : a - 1, dayOfYear: f > 0 ? f : ga(a - 1) + f };
        }
        function qa(a) {
            var b = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
            return null == a ? b : this.add(a - b, "d");
        }
        function ra(a, b, c) {
            return null != a ? a : null != b ? b : c;
        }
        function sa(a) {
            var b = new Date();
            return a._useUTC ? [b.getUTCFullYear(), b.getUTCMonth(), b.getUTCDate()] : [b.getFullYear(), b.getMonth(), b.getDate()];
        }
        function ta(a) {
            var b,
                c,
                d,
                e,
                f = [];
            if (!a._d) {
                for (
                    d = sa(a),
                        a._w && null == a._a[hd] && null == a._a[gd] && ua(a),
                        a._dayOfYear && ((e = ra(a._a[fd], d[fd])), a._dayOfYear > ga(e) && (j(a)._overflowDayOfYear = !0), (c = fa(e, 0, a._dayOfYear)), (a._a[gd] = c.getUTCMonth()), (a._a[hd] = c.getUTCDate())),
                        b = 0;
                    b < 3 && null == a._a[b];
                    ++b
                )
                    a._a[b] = f[b] = d[b];
                for (; b < 7; b++) a._a[b] = f[b] = null == a._a[b] ? (2 === b ? 1 : 0) : a._a[b];
                24 === a._a[id] && 0 === a._a[jd] && 0 === a._a[kd] && 0 === a._a[ld] && ((a._nextDay = !0), (a._a[id] = 0)),
                    (a._d = (a._useUTC ? fa : ea).apply(null, f)),
                    null != a._tzm && a._d.setUTCMinutes(a._d.getUTCMinutes() - a._tzm),
                    a._nextDay && (a._a[id] = 24);
            }
        }
        function ua(a) {
            var b, c, d, e, f, g, h;
            (b = a._w),
                null != b.GG || null != b.W || null != b.E
                    ? ((f = 1), (g = 4), (c = ra(b.GG, a._a[fd], ja(Da(), 1, 4).year)), (d = ra(b.W, 1)), (e = ra(b.E, 1)))
                    : ((f = a._locale._week.dow), (g = a._locale._week.doy), (c = ra(b.gg, a._a[fd], ja(Da(), f, g).year)), (d = ra(b.w, 1)), null != b.d ? ((e = b.d), e < f && ++d) : (e = null != b.e ? b.e + f : f)),
                (h = pa(c, d, e, g, f)),
                (a._a[fd] = h.year),
                (a._dayOfYear = h.dayOfYear);
        }
        function va(b) {
            if (b._f === a.ISO_8601) return void ca(b);
            (b._a = []), (j(b).empty = !0);
            var c,
                d,
                e,
                f,
                g,
                h = "" + b._i,
                i = h.length,
                k = 0;
            for (e = L(b._f, b._locale).match(Nc) || [], c = 0; c < e.length; c++)
                (f = e[c]),
                    (d = (h.match(O(f, b)) || [])[0]),
                    d && ((g = h.substr(0, h.indexOf(d))), g.length > 0 && j(b).unusedInput.push(g), (h = h.slice(h.indexOf(d) + d.length)), (k += d.length)),
                    Qc[f] ? (d ? (j(b).empty = !1) : j(b).unusedTokens.push(f), S(f, d, b)) : b._strict && !d && j(b).unusedTokens.push(f);
            (j(b).charsLeftOver = i - k), h.length > 0 && j(b).unusedInput.push(h), j(b).bigHour === !0 && b._a[id] <= 12 && b._a[id] > 0 && (j(b).bigHour = void 0), (b._a[id] = wa(b._locale, b._a[id], b._meridiem)), ta(b), $(b);
        }
        function wa(a, b, c) {
            var d;
            return null == c ? b : null != a.meridiemHour ? a.meridiemHour(b, c) : null != a.isPM ? ((d = a.isPM(c)), d && b < 12 && (b += 12), d || 12 !== b || (b = 0), b) : b;
        }
        function xa(a) {
            var b, c, d, e, f;
            if (0 === a._f.length) return (j(a).invalidFormat = !0), void (a._d = new Date(NaN));
            for (e = 0; e < a._f.length; e++)
                (f = 0),
                    (b = m({}, a)),
                    null != a._useUTC && (b._useUTC = a._useUTC),
                    (b._f = a._f[e]),
                    va(b),
                    k(b) && ((f += j(b).charsLeftOver), (f += 10 * j(b).unusedTokens.length), (j(b).score = f), (null == d || f < d) && ((d = f), (c = b)));
            g(a, c || b);
        }
        function ya(a) {
            if (!a._d) {
                var b = B(a._i);
                (a._a = [b.year, b.month, b.day || b.date, b.hour, b.minute, b.second, b.millisecond]), ta(a);
            }
        }
        function za(a) {
            var b = new n($(Aa(a)));
            return b._nextDay && (b.add(1, "d"), (b._nextDay = void 0)), b;
        }
        function Aa(a) {
            var b = a._i,
                e = a._f;
            return (
                (a._locale = a._locale || y(a._l)),
                null === b || (void 0 === e && "" === b) ? l({ nullInput: !0 }) : ("string" == typeof b && (a._i = b = a._locale.preparse(b)), o(b) ? new n($(b)) : (c(e) ? xa(a) : e ? va(a) : d(b) ? (a._d = b) : Ba(a), a))
            );
        }
        function Ba(b) {
            var f = b._i;
            void 0 === f
                ? (b._d = new Date())
                : d(f)
                ? (b._d = new Date(+f))
                : "string" == typeof f
                ? da(b)
                : c(f)
                ? ((b._a = e(f.slice(0), function (a) {
                      return parseInt(a, 10);
                  })),
                  ta(b))
                : "object" == typeof f
                ? ya(b)
                : "number" == typeof f
                ? (b._d = new Date(f))
                : a.createFromInputFallback(b);
        }
        function Ca(a, b, c, d, e) {
            var f = {};
            return "boolean" == typeof c && ((d = c), (c = void 0)), (f._isAMomentObject = !0), (f._useUTC = f._isUTC = e), (f._l = c), (f._i = a), (f._f = b), (f._strict = d), za(f);
        }
        function Da(a, b, c, d) {
            return Ca(a, b, c, d, !1);
        }
        function Ea(a, b) {
            var d, e;
            if ((1 === b.length && c(b[0]) && (b = b[0]), !b.length)) return Da();
            for (d = b[0], e = 1; e < b.length; ++e) (b[e].isValid() && !b[e][a](d)) || (d = b[e]);
            return d;
        }
        function Fa() {
            var a = [].slice.call(arguments, 0);
            return Ea("isBefore", a);
        }
        function Ga() {
            var a = [].slice.call(arguments, 0);
            return Ea("isAfter", a);
        }
        function Ha(a) {
            var b = B(a),
                c = b.year || 0,
                d = b.quarter || 0,
                e = b.month || 0,
                f = b.week || 0,
                g = b.day || 0,
                h = b.hour || 0,
                i = b.minute || 0,
                j = b.second || 0,
                k = b.millisecond || 0;
            (this._milliseconds = +k + 1e3 * j + 6e4 * i + 36e5 * h), (this._days = +g + 7 * f), (this._months = +e + 3 * d + 12 * c), (this._data = {}), (this._locale = y()), this._bubble();
        }
        function Ia(a) {
            return a instanceof Ha;
        }
        function Ja(a, b) {
            H(a, 0, 0, function () {
                var a = this.utcOffset(),
                    c = "+";
                return a < 0 && ((a = -a), (c = "-")), c + G(~~(a / 60), 2) + b + G(~~a % 60, 2);
            });
        }
        function Ka(a) {
            var b = (a || "").match(ad) || [],
                c = b[b.length - 1] || [],
                d = (c + "").match(xd) || ["-", 0, 0],
                e = +(60 * d[1]) + q(d[2]);
            return "+" === d[0] ? e : -e;
        }
        function La(b, c) {
            var e, f;
            return c._isUTC ? ((e = c.clone()), (f = (o(b) || d(b) ? +b : +Da(b)) - +e), e._d.setTime(+e._d + f), a.updateOffset(e, !1), e) : Da(b).local();
        }
        function Ma(a) {
            return 15 * -Math.round(a._d.getTimezoneOffset() / 15);
        }
        function Na(b, c) {
            var d,
                e = this._offset || 0;
            return null != b
                ? ("string" == typeof b && (b = Ka(b)),
                  Math.abs(b) < 16 && (b = 60 * b),
                  !this._isUTC && c && (d = Ma(this)),
                  (this._offset = b),
                  (this._isUTC = !0),
                  null != d && this.add(d, "m"),
                  e !== b && (!c || this._changeInProgress ? bb(this, Ya(b - e, "m"), 1, !1) : this._changeInProgress || ((this._changeInProgress = !0), a.updateOffset(this, !0), (this._changeInProgress = null))),
                  this)
                : this._isUTC
                ? e
                : Ma(this);
        }
        function Oa(a, b) {
            return null != a ? ("string" != typeof a && (a = -a), this.utcOffset(a, b), this) : -this.utcOffset();
        }
        function Pa(a) {
            return this.utcOffset(0, a);
        }
        function Qa(a) {
            return this._isUTC && (this.utcOffset(0, a), (this._isUTC = !1), a && this.subtract(Ma(this), "m")), this;
        }
        function Ra() {
            return this._tzm ? this.utcOffset(this._tzm) : "string" == typeof this._i && this.utcOffset(Ka(this._i)), this;
        }
        function Sa(a) {
            return (a = a ? Da(a).utcOffset() : 0), (this.utcOffset() - a) % 60 === 0;
        }
        function Ta() {
            return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
        }
        function Ua() {
            if ("undefined" != typeof this._isDSTShifted) return this._isDSTShifted;
            var a = {};
            if ((m(a, this), (a = Aa(a)), a._a)) {
                var b = a._isUTC ? h(a._a) : Da(a._a);
                this._isDSTShifted = this.isValid() && r(a._a, b.toArray()) > 0;
            } else this._isDSTShifted = !1;
            return this._isDSTShifted;
        }
        function Va() {
            return !this._isUTC;
        }
        function Wa() {
            return this._isUTC;
        }
        function Xa() {
            return this._isUTC && 0 === this._offset;
        }
        function Ya(a, b) {
            var c,
                d,
                e,
                g = a,
                h = null;
            return (
                Ia(a)
                    ? (g = { ms: a._milliseconds, d: a._days, M: a._months })
                    : "number" == typeof a
                    ? ((g = {}), b ? (g[b] = a) : (g.milliseconds = a))
                    : (h = yd.exec(a))
                    ? ((c = "-" === h[1] ? -1 : 1), (g = { y: 0, d: q(h[hd]) * c, h: q(h[id]) * c, m: q(h[jd]) * c, s: q(h[kd]) * c, ms: q(h[ld]) * c }))
                    : (h = zd.exec(a))
                    ? ((c = "-" === h[1] ? -1 : 1), (g = { y: Za(h[2], c), M: Za(h[3], c), d: Za(h[4], c), h: Za(h[5], c), m: Za(h[6], c), s: Za(h[7], c), w: Za(h[8], c) }))
                    : null == g
                    ? (g = {})
                    : "object" == typeof g && ("from" in g || "to" in g) && ((e = _a(Da(g.from), Da(g.to))), (g = {}), (g.ms = e.milliseconds), (g.M = e.months)),
                (d = new Ha(g)),
                Ia(a) && f(a, "_locale") && (d._locale = a._locale),
                d
            );
        }
        function Za(a, b) {
            var c = a && parseFloat(a.replace(",", "."));
            return (isNaN(c) ? 0 : c) * b;
        }
        function $a(a, b) {
            var c = { milliseconds: 0, months: 0 };
            return (c.months = b.month() - a.month() + 12 * (b.year() - a.year())), a.clone().add(c.months, "M").isAfter(b) && --c.months, (c.milliseconds = +b - +a.clone().add(c.months, "M")), c;
        }
        function _a(a, b) {
            var c;
            return (b = La(b, a)), a.isBefore(b) ? (c = $a(a, b)) : ((c = $a(b, a)), (c.milliseconds = -c.milliseconds), (c.months = -c.months)), c;
        }
        function ab(a, b) {
            return function (c, d) {
                var e, f;
                return (
                    null === d || isNaN(+d) || (ba(b, "moment()." + b + "(period, number) is deprecated. Please use moment()." + b + "(number, period)."), (f = c), (c = d), (d = f)),
                    (c = "string" == typeof c ? +c : c),
                    (e = Ya(c, d)),
                    bb(this, e, a),
                    this
                );
            };
        }
        function bb(b, c, d, e) {
            var f = c._milliseconds,
                g = c._days,
                h = c._months;
            (e = null == e || e), f && b._d.setTime(+b._d + f * d), g && E(b, "Date", D(b, "Date") + g * d), h && X(b, D(b, "Month") + h * d), e && a.updateOffset(b, g || h);
        }
        function cb(a, b) {
            var c = a || Da(),
                d = La(c, this).startOf("day"),
                e = this.diff(d, "days", !0),
                f = e < -6 ? "sameElse" : e < -1 ? "lastWeek" : e < 0 ? "lastDay" : e < 1 ? "sameDay" : e < 2 ? "nextDay" : e < 7 ? "nextWeek" : "sameElse";
            return this.format((b && b[f]) || this.localeData().calendar(f, this, Da(c)));
        }
        function db() {
            return new n(this);
        }
        function eb(a, b) {
            var c;
            return (b = A("undefined" != typeof b ? b : "millisecond")), "millisecond" === b ? ((a = o(a) ? a : Da(a)), +this > +a) : ((c = o(a) ? +a : +Da(a)), c < +this.clone().startOf(b));
        }
        function fb(a, b) {
            var c;
            return (b = A("undefined" != typeof b ? b : "millisecond")), "millisecond" === b ? ((a = o(a) ? a : Da(a)), +this < +a) : ((c = o(a) ? +a : +Da(a)), +this.clone().endOf(b) < c);
        }
        function gb(a, b, c) {
            return this.isAfter(a, c) && this.isBefore(b, c);
        }
        function hb(a, b) {
            var c;
            return (b = A(b || "millisecond")), "millisecond" === b ? ((a = o(a) ? a : Da(a)), +this === +a) : ((c = +Da(a)), +this.clone().startOf(b) <= c && c <= +this.clone().endOf(b));
        }
        function ib(a, b, c) {
            var d,
                e,
                f = La(a, this),
                g = 6e4 * (f.utcOffset() - this.utcOffset());
            return (
                (b = A(b)),
                "year" === b || "month" === b || "quarter" === b
                    ? ((e = jb(this, f)), "quarter" === b ? (e /= 3) : "year" === b && (e /= 12))
                    : ((d = this - f), (e = "second" === b ? d / 1e3 : "minute" === b ? d / 6e4 : "hour" === b ? d / 36e5 : "day" === b ? (d - g) / 864e5 : "week" === b ? (d - g) / 6048e5 : d)),
                c ? e : p(e)
            );
        }
        function jb(a, b) {
            var c,
                d,
                e = 12 * (b.year() - a.year()) + (b.month() - a.month()),
                f = a.clone().add(e, "months");
            return b - f < 0 ? ((c = a.clone().add(e - 1, "months")), (d = (b - f) / (f - c))) : ((c = a.clone().add(e + 1, "months")), (d = (b - f) / (c - f))), -(e + d);
        }
        function kb() {
            return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
        }
        function lb() {
            var a = this.clone().utc();
            return 0 < a.year() && a.year() <= 9999 ? ("function" == typeof Date.prototype.toISOString ? this.toDate().toISOString() : K(a, "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")) : K(a, "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
        }
        function mb(b) {
            var c = K(this, b || a.defaultFormat);
            return this.localeData().postformat(c);
        }
        function nb(a, b) {
            return this.isValid() ? Ya({ to: this, from: a }).locale(this.locale()).humanize(!b) : this.localeData().invalidDate();
        }
        function ob(a) {
            return this.from(Da(), a);
        }
        function pb(a, b) {
            return this.isValid() ? Ya({ from: this, to: a }).locale(this.locale()).humanize(!b) : this.localeData().invalidDate();
        }
        function qb(a) {
            return this.to(Da(), a);
        }
        function rb(a) {
            var b;
            return void 0 === a ? this._locale._abbr : ((b = y(a)), null != b && (this._locale = b), this);
        }
        function sb() {
            return this._locale;
        }
        function tb(a) {
            switch ((a = A(a))) {
                case "year":
                    this.month(0);
                case "quarter":
                case "month":
                    this.date(1);
                case "week":
                case "isoWeek":
                case "day":
                    this.hours(0);
                case "hour":
                    this.minutes(0);
                case "minute":
                    this.seconds(0);
                case "second":
                    this.milliseconds(0);
            }
            return "week" === a && this.weekday(0), "isoWeek" === a && this.isoWeekday(1), "quarter" === a && this.month(3 * Math.floor(this.month() / 3)), this;
        }
        function ub(a) {
            return (
                (a = A(a)),
                void 0 === a || "millisecond" === a
                    ? this
                    : this.startOf(a)
                          .add(1, "isoWeek" === a ? "week" : a)
                          .subtract(1, "ms")
            );
        }
        function vb() {
            return +this._d - 6e4 * (this._offset || 0);
        }
        function wb() {
            return Math.floor(+this / 1e3);
        }
        function xb() {
            return this._offset ? new Date(+this) : this._d;
        }
        function yb() {
            var a = this;
            return [a.year(), a.month(), a.date(), a.hour(), a.minute(), a.second(), a.millisecond()];
        }
        function zb() {
            var a = this;
            return { years: a.year(), months: a.month(), date: a.date(), hours: a.hours(), minutes: a.minutes(), seconds: a.seconds(), milliseconds: a.milliseconds() };
        }
        function Ab() {
            return k(this);
        }
        function Bb() {
            return g({}, j(this));
        }
        function Cb() {
            return j(this).overflow;
        }
        function Db(a, b) {
            H(0, [a, a.length], 0, b);
        }
        function Eb(a, b, c) {
            return ja(Da([a, 11, 31 + b - c]), b, c).week;
        }
        function Fb(a) {
            var b = ja(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
            return null == a ? b : this.add(a - b, "y");
        }
        function Gb(a) {
            var b = ja(this, 1, 4).year;
            return null == a ? b : this.add(a - b, "y");
        }
        function Hb() {
            return Eb(this.year(), 1, 4);
        }
        function Ib() {
            var a = this.localeData()._week;
            return Eb(this.year(), a.dow, a.doy);
        }
        function Jb(a) {
            return null == a ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (a - 1) + (this.month() % 3));
        }
        function Kb(a, b) {
            return "string" != typeof a ? a : isNaN(a) ? ((a = b.weekdaysParse(a)), "number" == typeof a ? a : null) : parseInt(a, 10);
        }
        function Lb(a) {
            return this._weekdays[a.day()];
        }
        function Mb(a) {
            return this._weekdaysShort[a.day()];
        }
        function Nb(a) {
            return this._weekdaysMin[a.day()];
        }
        function Ob(a) {
            var b, c, d;
            for (this._weekdaysParse = this._weekdaysParse || [], b = 0; b < 7; b++)
                if (
                    (this._weekdaysParse[b] ||
                        ((c = Da([2e3, 1]).day(b)), (d = "^" + this.weekdays(c, "") + "|^" + this.weekdaysShort(c, "") + "|^" + this.weekdaysMin(c, "")), (this._weekdaysParse[b] = new RegExp(d.replace(".", ""), "i"))),
                    this._weekdaysParse[b].test(a))
                )
                    return b;
        }
        function Pb(a) {
            var b = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
            return null != a ? ((a = Kb(a, this.localeData())), this.add(a - b, "d")) : b;
        }
        function Qb(a) {
            var b = (this.day() + 7 - this.localeData()._week.dow) % 7;
            return null == a ? b : this.add(a - b, "d");
        }
        function Rb(a) {
            return null == a ? this.day() || 7 : this.day(this.day() % 7 ? a : a - 7);
        }
        function Sb(a, b) {
            H(a, 0, 0, function () {
                return this.localeData().meridiem(this.hours(), this.minutes(), b);
            });
        }
        function Tb(a, b) {
            return b._meridiemParse;
        }
        function Ub(a) {
            return "p" === (a + "").toLowerCase().charAt(0);
        }
        function Vb(a, b, c) {
            return a > 11 ? (c ? "pm" : "PM") : c ? "am" : "AM";
        }
        function Wb(a, b) {
            b[ld] = q(1e3 * ("0." + a));
        }
        function Xb() {
            return this._isUTC ? "UTC" : "";
        }
        function Yb() {
            return this._isUTC ? "Coordinated Universal Time" : "";
        }
        function Zb(a) {
            return Da(1e3 * a);
        }
        function $b() {
            return Da.apply(null, arguments).parseZone();
        }
        function _b(a, b, c) {
            var d = this._calendar[a];
            return "function" == typeof d ? d.call(b, c) : d;
        }
        function ac(a) {
            var b = this._longDateFormat[a],
                c = this._longDateFormat[a.toUpperCase()];
            return b || !c
                ? b
                : ((this._longDateFormat[a] = c.replace(/MMMM|MM|DD|dddd/g, function (a) {
                      return a.slice(1);
                  })),
                  this._longDateFormat[a]);
        }
        function bc() {
            return this._invalidDate;
        }
        function cc(a) {
            return this._ordinal.replace("%d", a);
        }
        function dc(a) {
            return a;
        }
        function ec(a, b, c, d) {
            var e = this._relativeTime[c];
            return "function" == typeof e ? e(a, b, c, d) : e.replace(/%d/i, a);
        }
        function fc(a, b) {
            var c = this._relativeTime[a > 0 ? "future" : "past"];
            return "function" == typeof c ? c(b) : c.replace(/%s/i, b);
        }
        function gc(a) {
            var b, c;
            for (c in a) (b = a[c]), "function" == typeof b ? (this[c] = b) : (this["_" + c] = b);
            this._ordinalParseLenient = new RegExp(this._ordinalParse.source + "|" + /\d{1,2}/.source);
        }
        function hc(a, b, c, d) {
            var e = y(),
                f = h().set(d, b);
            return e[c](f, a);
        }
        function ic(a, b, c, d, e) {
            if (("number" == typeof a && ((b = a), (a = void 0)), (a = a || ""), null != b)) return hc(a, b, c, e);
            var f,
                g = [];
            for (f = 0; f < d; f++) g[f] = hc(a, f, c, e);
            return g;
        }
        function jc(a, b) {
            return ic(a, b, "months", 12, "month");
        }
        function kc(a, b) {
            return ic(a, b, "monthsShort", 12, "month");
        }
        function lc(a, b) {
            return ic(a, b, "weekdays", 7, "day");
        }
        function mc(a, b) {
            return ic(a, b, "weekdaysShort", 7, "day");
        }
        function nc(a, b) {
            return ic(a, b, "weekdaysMin", 7, "day");
        }
        function oc() {
            var a = this._data;
            return (
                (this._milliseconds = Wd(this._milliseconds)),
                (this._days = Wd(this._days)),
                (this._months = Wd(this._months)),
                (a.milliseconds = Wd(a.milliseconds)),
                (a.seconds = Wd(a.seconds)),
                (a.minutes = Wd(a.minutes)),
                (a.hours = Wd(a.hours)),
                (a.months = Wd(a.months)),
                (a.years = Wd(a.years)),
                this
            );
        }
        function pc(a, b, c, d) {
            var e = Ya(b, c);
            return (a._milliseconds += d * e._milliseconds), (a._days += d * e._days), (a._months += d * e._months), a._bubble();
        }
        function qc(a, b) {
            return pc(this, a, b, 1);
        }
        function rc(a, b) {
            return pc(this, a, b, -1);
        }
        function sc(a) {
            return a < 0 ? Math.floor(a) : Math.ceil(a);
        }
        function tc() {
            var a,
                b,
                c,
                d,
                e,
                f = this._milliseconds,
                g = this._days,
                h = this._months,
                i = this._data;
            return (
                (f >= 0 && g >= 0 && h >= 0) || (f <= 0 && g <= 0 && h <= 0) || ((f += 864e5 * sc(vc(h) + g)), (g = 0), (h = 0)),
                (i.milliseconds = f % 1e3),
                (a = p(f / 1e3)),
                (i.seconds = a % 60),
                (b = p(a / 60)),
                (i.minutes = b % 60),
                (c = p(b / 60)),
                (i.hours = c % 24),
                (g += p(c / 24)),
                (e = p(uc(g))),
                (h += e),
                (g -= sc(vc(e))),
                (d = p(h / 12)),
                (h %= 12),
                (i.days = g),
                (i.months = h),
                (i.years = d),
                this
            );
        }
        function uc(a) {
            return (4800 * a) / 146097;
        }
        function vc(a) {
            return (146097 * a) / 4800;
        }
        function wc(a) {
            var b,
                c,
                d = this._milliseconds;
            if (((a = A(a)), "month" === a || "year" === a)) return (b = this._days + d / 864e5), (c = this._months + uc(b)), "month" === a ? c : c / 12;
            switch (((b = this._days + Math.round(vc(this._months))), a)) {
                case "week":
                    return b / 7 + d / 6048e5;
                case "day":
                    return b + d / 864e5;
                case "hour":
                    return 24 * b + d / 36e5;
                case "minute":
                    return 1440 * b + d / 6e4;
                case "second":
                    return 86400 * b + d / 1e3;
                case "millisecond":
                    return Math.floor(864e5 * b) + d;
                default:
                    throw new Error("Unknown unit " + a);
            }
        }
        function xc() {
            return this._milliseconds + 864e5 * this._days + (this._months % 12) * 2592e6 + 31536e6 * q(this._months / 12);
        }
        function yc(a) {
            return function () {
                return this.as(a);
            };
        }
        function zc(a) {
            return (a = A(a)), this[a + "s"]();
        }
        function Ac(a) {
            return function () {
                return this._data[a];
            };
        }
        function Bc() {
            return p(this.days() / 7);
        }
        function Cc(a, b, c, d, e) {
            return e.relativeTime(b || 1, !!c, a, d);
        }
        function Dc(a, b, c) {
            var d = Ya(a).abs(),
                e = ke(d.as("s")),
                f = ke(d.as("m")),
                g = ke(d.as("h")),
                h = ke(d.as("d")),
                i = ke(d.as("M")),
                j = ke(d.as("y")),
                k = (e < le.s && ["s", e]) ||
                    (1 === f && ["m"]) ||
                    (f < le.m && ["mm", f]) ||
                    (1 === g && ["h"]) ||
                    (g < le.h && ["hh", g]) ||
                    (1 === h && ["d"]) ||
                    (h < le.d && ["dd", h]) ||
                    (1 === i && ["M"]) ||
                    (i < le.M && ["MM", i]) ||
                    (1 === j && ["y"]) || ["yy", j];
            return (k[2] = b), (k[3] = +a > 0), (k[4] = c), Cc.apply(null, k);
        }
        function Ec(a, b) {
            return void 0 !== le[a] && (void 0 === b ? le[a] : ((le[a] = b), !0));
        }
        function Fc(a) {
            var b = this.localeData(),
                c = Dc(this, !a, b);
            return a && (c = b.pastFuture(+this, c)), b.postformat(c);
        }
        function Gc() {
            var a,
                b,
                c,
                d = me(this._milliseconds) / 1e3,
                e = me(this._days),
                f = me(this._months);
            (a = p(d / 60)), (b = p(a / 60)), (d %= 60), (a %= 60), (c = p(f / 12)), (f %= 12);
            var g = c,
                h = f,
                i = e,
                j = b,
                k = a,
                l = d,
                m = this.asSeconds();
            return m ? (m < 0 ? "-" : "") + "P" + (g ? g + "Y" : "") + (h ? h + "M" : "") + (i ? i + "D" : "") + (j || k || l ? "T" : "") + (j ? j + "H" : "") + (k ? k + "M" : "") + (l ? l + "S" : "") : "P0D";
        }
        var Hc,
            Ic,
            Jc = (a.momentProperties = []),
            Kc = !1,
            Lc = {},
            Mc = {},
            Nc = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
            Oc = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
            Pc = {},
            Qc = {},
            Rc = /\d/,
            Sc = /\d\d/,
            Tc = /\d{3}/,
            Uc = /\d{4}/,
            Vc = /[+-]?\d{6}/,
            Wc = /\d\d?/,
            Xc = /\d{1,3}/,
            Yc = /\d{1,4}/,
            Zc = /[+-]?\d{1,6}/,
            $c = /\d+/,
            _c = /[+-]?\d+/,
            ad = /Z|[+-]\d\d:?\d\d/gi,
            bd = /[+-]?\d+(\.\d{1,3})?/,
            cd = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i,
            dd = {},
            ed = {},
            fd = 0,
            gd = 1,
            hd = 2,
            id = 3,
            jd = 4,
            kd = 5,
            ld = 6;
        H("M", ["MM", 2], "Mo", function () {
            return this.month() + 1;
        }),
            H("MMM", 0, 0, function (a) {
                return this.localeData().monthsShort(this, a);
            }),
            H("MMMM", 0, 0, function (a) {
                return this.localeData().months(this, a);
            }),
            z("month", "M"),
            N("M", Wc),
            N("MM", Wc, Sc),
            N("MMM", cd),
            N("MMMM", cd),
            Q(["M", "MM"], function (a, b) {
                b[gd] = q(a) - 1;
            }),
            Q(["MMM", "MMMM"], function (a, b, c, d) {
                var e = c._locale.monthsParse(a, d, c._strict);
                null != e ? (b[gd] = e) : (j(c).invalidMonth = a);
            });
        var md = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            nd = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            od = {};
        a.suppressDeprecationWarnings = !1;
        var pd = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
            qd = [
                ["YYYYYY-MM-DD", /[+-]\d{6}-\d{2}-\d{2}/],
                ["YYYY-MM-DD", /\d{4}-\d{2}-\d{2}/],
                ["GGGG-[W]WW-E", /\d{4}-W\d{2}-\d/],
                ["GGGG-[W]WW", /\d{4}-W\d{2}/],
                ["YYYY-DDD", /\d{4}-\d{3}/],
            ],
            rd = [
                ["HH:mm:ss.SSSS", /(T| )\d\d:\d\d:\d\d\.\d+/],
                ["HH:mm:ss", /(T| )\d\d:\d\d:\d\d/],
                ["HH:mm", /(T| )\d\d:\d\d/],
                ["HH", /(T| )\d\d/],
            ],
            sd = /^\/?Date\((\-?\d+)/i;
        (a.createFromInputFallback = aa("moment construction falls back to js Date. This is discouraged and will be removed in upcoming major release. Please refer to https://github.com/moment/moment/issues/1407 for more info.", function (
            a
        ) {
            a._d = new Date(a._i + (a._useUTC ? " UTC" : ""));
        })),
            H(0, ["YY", 2], 0, function () {
                return this.year() % 100;
            }),
            H(0, ["YYYY", 4], 0, "year"),
            H(0, ["YYYYY", 5], 0, "year"),
            H(0, ["YYYYYY", 6, !0], 0, "year"),
            z("year", "y"),
            N("Y", _c),
            N("YY", Wc, Sc),
            N("YYYY", Yc, Uc),
            N("YYYYY", Zc, Vc),
            N("YYYYYY", Zc, Vc),
            Q(["YYYYY", "YYYYYY"], fd),
            Q("YYYY", function (b, c) {
                c[fd] = 2 === b.length ? a.parseTwoDigitYear(b) : q(b);
            }),
            Q("YY", function (b, c) {
                c[fd] = a.parseTwoDigitYear(b);
            }),
            (a.parseTwoDigitYear = function (a) {
                return q(a) + (q(a) > 68 ? 1900 : 2e3);
            });
        var td = C("FullYear", !1);
        H("w", ["ww", 2], "wo", "week"),
            H("W", ["WW", 2], "Wo", "isoWeek"),
            z("week", "w"),
            z("isoWeek", "W"),
            N("w", Wc),
            N("ww", Wc, Sc),
            N("W", Wc),
            N("WW", Wc, Sc),
            R(["w", "ww", "W", "WW"], function (a, b, c, d) {
                b[d.substr(0, 1)] = q(a);
            });
        var ud = { dow: 0, doy: 6 };
        H("DDD", ["DDDD", 3], "DDDo", "dayOfYear"),
            z("dayOfYear", "DDD"),
            N("DDD", Xc),
            N("DDDD", Tc),
            Q(["DDD", "DDDD"], function (a, b, c) {
                c._dayOfYear = q(a);
            }),
            (a.ISO_8601 = function () {});
        var vd = aa("moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548", function () {
                var a = Da.apply(null, arguments);
                return a < this ? this : a;
            }),
            wd = aa("moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548", function () {
                var a = Da.apply(null, arguments);
                return a > this ? this : a;
            });
        Ja("Z", ":"),
            Ja("ZZ", ""),
            N("Z", ad),
            N("ZZ", ad),
            Q(["Z", "ZZ"], function (a, b, c) {
                (c._useUTC = !0), (c._tzm = Ka(a));
            });
        var xd = /([\+\-]|\d\d)/gi;
        a.updateOffset = function () {};
        var yd = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/,
            zd = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;
        Ya.fn = Ha.prototype;
        var Ad = ab(1, "add"),
            Bd = ab(-1, "subtract");
        a.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
        var Cd = aa("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (a) {
            return void 0 === a ? this.localeData() : this.locale(a);
        });
        H(0, ["gg", 2], 0, function () {
            return this.weekYear() % 100;
        }),
            H(0, ["GG", 2], 0, function () {
                return this.isoWeekYear() % 100;
            }),
            Db("gggg", "weekYear"),
            Db("ggggg", "weekYear"),
            Db("GGGG", "isoWeekYear"),
            Db("GGGGG", "isoWeekYear"),
            z("weekYear", "gg"),
            z("isoWeekYear", "GG"),
            N("G", _c),
            N("g", _c),
            N("GG", Wc, Sc),
            N("gg", Wc, Sc),
            N("GGGG", Yc, Uc),
            N("gggg", Yc, Uc),
            N("GGGGG", Zc, Vc),
            N("ggggg", Zc, Vc),
            R(["gggg", "ggggg", "GGGG", "GGGGG"], function (a, b, c, d) {
                b[d.substr(0, 2)] = q(a);
            }),
            R(["gg", "GG"], function (b, c, d, e) {
                c[e] = a.parseTwoDigitYear(b);
            }),
            H("Q", 0, 0, "quarter"),
            z("quarter", "Q"),
            N("Q", Rc),
            Q("Q", function (a, b) {
                b[gd] = 3 * (q(a) - 1);
            }),
            H("D", ["DD", 2], "Do", "date"),
            z("date", "D"),
            N("D", Wc),
            N("DD", Wc, Sc),
            N("Do", function (a, b) {
                return a ? b._ordinalParse : b._ordinalParseLenient;
            }),
            Q(["D", "DD"], hd),
            Q("Do", function (a, b) {
                b[hd] = q(a.match(Wc)[0], 10);
            });
        var Dd = C("Date", !0);
        H("d", 0, "do", "day"),
            H("dd", 0, 0, function (a) {
                return this.localeData().weekdaysMin(this, a);
            }),
            H("ddd", 0, 0, function (a) {
                return this.localeData().weekdaysShort(this, a);
            }),
            H("dddd", 0, 0, function (a) {
                return this.localeData().weekdays(this, a);
            }),
            H("e", 0, 0, "weekday"),
            H("E", 0, 0, "isoWeekday"),
            z("day", "d"),
            z("weekday", "e"),
            z("isoWeekday", "E"),
            N("d", Wc),
            N("e", Wc),
            N("E", Wc),
            N("dd", cd),
            N("ddd", cd),
            N("dddd", cd),
            R(["dd", "ddd", "dddd"], function (a, b, c) {
                var d = c._locale.weekdaysParse(a);
                null != d ? (b.d = d) : (j(c).invalidWeekday = a);
            }),
            R(["d", "e", "E"], function (a, b, c, d) {
                b[d] = q(a);
            });
        var Ed = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            Fd = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            Gd = "Su_Mo_Tu_We_Th_Fr_Sa".split("_");
        H("H", ["HH", 2], 0, "hour"),
            H("h", ["hh", 2], 0, function () {
                return this.hours() % 12 || 12;
            }),
            Sb("a", !0),
            Sb("A", !1),
            z("hour", "h"),
            N("a", Tb),
            N("A", Tb),
            N("H", Wc),
            N("h", Wc),
            N("HH", Wc, Sc),
            N("hh", Wc, Sc),
            Q(["H", "HH"], id),
            Q(["a", "A"], function (a, b, c) {
                (c._isPm = c._locale.isPM(a)), (c._meridiem = a);
            }),
            Q(["h", "hh"], function (a, b, c) {
                (b[id] = q(a)), (j(c).bigHour = !0);
            });
        var Hd = /[ap]\.?m?\.?/i,
            Id = C("Hours", !0);
        H("m", ["mm", 2], 0, "minute"), z("minute", "m"), N("m", Wc), N("mm", Wc, Sc), Q(["m", "mm"], jd);
        var Jd = C("Minutes", !1);
        H("s", ["ss", 2], 0, "second"), z("second", "s"), N("s", Wc), N("ss", Wc, Sc), Q(["s", "ss"], kd);
        var Kd = C("Seconds", !1);
        H("S", 0, 0, function () {
            return ~~(this.millisecond() / 100);
        }),
            H(0, ["SS", 2], 0, function () {
                return ~~(this.millisecond() / 10);
            }),
            H(0, ["SSS", 3], 0, "millisecond"),
            H(0, ["SSSS", 4], 0, function () {
                return 10 * this.millisecond();
            }),
            H(0, ["SSSSS", 5], 0, function () {
                return 100 * this.millisecond();
            }),
            H(0, ["SSSSSS", 6], 0, function () {
                return 1e3 * this.millisecond();
            }),
            H(0, ["SSSSSSS", 7], 0, function () {
                return 1e4 * this.millisecond();
            }),
            H(0, ["SSSSSSSS", 8], 0, function () {
                return 1e5 * this.millisecond();
            }),
            H(0, ["SSSSSSSSS", 9], 0, function () {
                return 1e6 * this.millisecond();
            }),
            z("millisecond", "ms"),
            N("S", Xc, Rc),
            N("SS", Xc, Sc),
            N("SSS", Xc, Tc);
        var Ld;
        for (Ld = "SSSS"; Ld.length <= 9; Ld += "S") N(Ld, $c);
        for (Ld = "S"; Ld.length <= 9; Ld += "S") Q(Ld, Wb);
        var Md = C("Milliseconds", !1);
        H("z", 0, 0, "zoneAbbr"), H("zz", 0, 0, "zoneName");
        var Nd = n.prototype;
        (Nd.add = Ad),
            (Nd.calendar = cb),
            (Nd.clone = db),
            (Nd.diff = ib),
            (Nd.endOf = ub),
            (Nd.format = mb),
            (Nd.from = nb),
            (Nd.fromNow = ob),
            (Nd.to = pb),
            (Nd.toNow = qb),
            (Nd.get = F),
            (Nd.invalidAt = Cb),
            (Nd.isAfter = eb),
            (Nd.isBefore = fb),
            (Nd.isBetween = gb),
            (Nd.isSame = hb),
            (Nd.isValid = Ab),
            (Nd.lang = Cd),
            (Nd.locale = rb),
            (Nd.localeData = sb),
            (Nd.max = wd),
            (Nd.min = vd),
            (Nd.parsingFlags = Bb),
            (Nd.set = F),
            (Nd.startOf = tb),
            (Nd.subtract = Bd),
            (Nd.toArray = yb),
            (Nd.toObject = zb),
            (Nd.toDate = xb),
            (Nd.toISOString = lb),
            (Nd.toJSON = lb),
            (Nd.toString = kb),
            (Nd.unix = wb),
            (Nd.valueOf = vb),
            (Nd.year = td),
            (Nd.isLeapYear = ia),
            (Nd.weekYear = Fb),
            (Nd.isoWeekYear = Gb),
            (Nd.quarter = Nd.quarters = Jb),
            (Nd.month = Y),
            (Nd.daysInMonth = Z),
            (Nd.week = Nd.weeks = na),
            (Nd.isoWeek = Nd.isoWeeks = oa),
            (Nd.weeksInYear = Ib),
            (Nd.isoWeeksInYear = Hb),
            (Nd.date = Dd),
            (Nd.day = Nd.days = Pb),
            (Nd.weekday = Qb),
            (Nd.isoWeekday = Rb),
            (Nd.dayOfYear = qa),
            (Nd.hour = Nd.hours = Id),
            (Nd.minute = Nd.minutes = Jd),
            (Nd.second = Nd.seconds = Kd),
            (Nd.millisecond = Nd.milliseconds = Md),
            (Nd.utcOffset = Na),
            (Nd.utc = Pa),
            (Nd.local = Qa),
            (Nd.parseZone = Ra),
            (Nd.hasAlignedHourOffset = Sa),
            (Nd.isDST = Ta),
            (Nd.isDSTShifted = Ua),
            (Nd.isLocal = Va),
            (Nd.isUtcOffset = Wa),
            (Nd.isUtc = Xa),
            (Nd.isUTC = Xa),
            (Nd.zoneAbbr = Xb),
            (Nd.zoneName = Yb),
            (Nd.dates = aa("dates accessor is deprecated. Use date instead.", Dd)),
            (Nd.months = aa("months accessor is deprecated. Use month instead", Y)),
            (Nd.years = aa("years accessor is deprecated. Use year instead", td)),
            (Nd.zone = aa("moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779", Oa));
        var Od = Nd,
            Pd = { sameDay: "[Today at] LT", nextDay: "[Tomorrow at] LT", nextWeek: "dddd [at] LT", lastDay: "[Yesterday at] LT", lastWeek: "[Last] dddd [at] LT", sameElse: "L" },
            Qd = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" },
            Rd = "Invalid date",
            Sd = "%d",
            Td = /\d{1,2}/,
            Ud = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" },
            Vd = s.prototype;
        (Vd._calendar = Pd),
            (Vd.calendar = _b),
            (Vd._longDateFormat = Qd),
            (Vd.longDateFormat = ac),
            (Vd._invalidDate = Rd),
            (Vd.invalidDate = bc),
            (Vd._ordinal = Sd),
            (Vd.ordinal = cc),
            (Vd._ordinalParse = Td),
            (Vd.preparse = dc),
            (Vd.postformat = dc),
            (Vd._relativeTime = Ud),
            (Vd.relativeTime = ec),
            (Vd.pastFuture = fc),
            (Vd.set = gc),
            (Vd.months = U),
            (Vd._months = md),
            (Vd.monthsShort = V),
            (Vd._monthsShort = nd),
            (Vd.monthsParse = W),
            (Vd.week = ka),
            (Vd._week = ud),
            (Vd.firstDayOfYear = ma),
            (Vd.firstDayOfWeek = la),
            (Vd.weekdays = Lb),
            (Vd._weekdays = Ed),
            (Vd.weekdaysMin = Nb),
            (Vd._weekdaysMin = Gd),
            (Vd.weekdaysShort = Mb),
            (Vd._weekdaysShort = Fd),
            (Vd.weekdaysParse = Ob),
            (Vd.isPM = Ub),
            (Vd._meridiemParse = Hd),
            (Vd.meridiem = Vb),
            w("en", {
                ordinalParse: /\d{1,2}(th|st|nd|rd)/,
                ordinal: function (a) {
                    var b = a % 10,
                        c = 1 === q((a % 100) / 10) ? "th" : 1 === b ? "st" : 2 === b ? "nd" : 3 === b ? "rd" : "th";
                    return a + c;
                },
            }),
            (a.lang = aa("moment.lang is deprecated. Use moment.locale instead.", w)),
            (a.langData = aa("moment.langData is deprecated. Use moment.localeData instead.", y));
        var Wd = Math.abs,
            Xd = yc("ms"),
            Yd = yc("s"),
            Zd = yc("m"),
            $d = yc("h"),
            _d = yc("d"),
            ae = yc("w"),
            be = yc("M"),
            ce = yc("y"),
            de = Ac("milliseconds"),
            ee = Ac("seconds"),
            fe = Ac("minutes"),
            ge = Ac("hours"),
            he = Ac("days"),
            ie = Ac("months"),
            je = Ac("years"),
            ke = Math.round,
            le = { s: 45, m: 45, h: 22, d: 26, M: 11 },
            me = Math.abs,
            ne = Ha.prototype;
        (ne.abs = oc),
            (ne.add = qc),
            (ne.subtract = rc),
            (ne.as = wc),
            (ne.asMilliseconds = Xd),
            (ne.asSeconds = Yd),
            (ne.asMinutes = Zd),
            (ne.asHours = $d),
            (ne.asDays = _d),
            (ne.asWeeks = ae),
            (ne.asMonths = be),
            (ne.asYears = ce),
            (ne.valueOf = xc),
            (ne._bubble = tc),
            (ne.get = zc),
            (ne.milliseconds = de),
            (ne.seconds = ee),
            (ne.minutes = fe),
            (ne.hours = ge),
            (ne.days = he),
            (ne.weeks = Bc),
            (ne.months = ie),
            (ne.years = je),
            (ne.humanize = Fc),
            (ne.toISOString = Gc),
            (ne.toString = Gc),
            (ne.toJSON = Gc),
            (ne.locale = rb),
            (ne.localeData = sb),
            (ne.toIsoString = aa("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", Gc)),
            (ne.lang = Cd),
            H("X", 0, 0, "unix"),
            H("x", 0, 0, "valueOf"),
            N("x", _c),
            N("X", bd),
            Q("X", function (a, b, c) {
                c._d = new Date(1e3 * parseFloat(a, 10));
            }),
            Q("x", function (a, b, c) {
                c._d = new Date(q(a));
            }),
            (a.version = "2.10.6"),
            b(Da),
            (a.fn = Od),
            (a.min = Fa),
            (a.max = Ga),
            (a.utc = h),
            (a.unix = Zb),
            (a.months = jc),
            (a.isDate = d),
            (a.locale = w),
            (a.invalid = l),
            (a.duration = Ya),
            (a.isMoment = o),
            (a.weekdays = lc),
            (a.parseZone = $b),
            (a.localeData = y),
            (a.isDuration = Ia),
            (a.monthsShort = kc),
            (a.weekdaysMin = nc),
            (a.defineLocale = x),
            (a.weekdaysShort = mc),
            (a.normalizeUnits = A),
            (a.relativeTimeThreshold = Ec);
        var oe = a;
        return oe;
    }),
    (function (a, b) {
        "use strict";
        var c;
        if ("object" == typeof exports) {
            try {
                c = require("moment");
            } catch (d) {}
            module.exports = b(c);
        } else
            "function" == typeof define && define.amd
                ? define(function (a) {
                      var d = "moment";
                      try {
                          c = a(d);
                      } catch (e) {}
                      return b(c);
                  })
                : (a.Pikaday = b(a.moment));
    })(this, function (a) {
        "use strict";
        var b = "function" == typeof a,
            c = !!window.addEventListener,
            d = window.document,
            e = window.setTimeout,
            f = function (a, b, d, e) {
                c ? a.addEventListener(b, d, !!e) : a.attachEvent("on" + b, d);
            },
            g = function (a, b, d, e) {
                c ? a.removeEventListener(b, d, !!e) : a.detachEvent("on" + b, d);
            },
            h = function (a, b, c) {
                var e;
                d.createEvent ? ((e = d.createEvent("HTMLEvents")), e.initEvent(b, !0, !1), (e = t(e, c)), a.dispatchEvent(e)) : d.createEventObject && ((e = d.createEventObject()), (e = t(e, c)), a.fireEvent("on" + b, e));
            },
            i = function (a) {
                return a.trim ? a.trim() : a.replace(/^\s+|\s+$/g, "");
            },
            j = function (a, b) {
                return (" " + a.className + " ").indexOf(" " + b + " ") !== -1;
            },
            k = function (a, b) {
                j(a, b) || (a.className = "" === a.className ? b : a.className + " " + b);
            },
            l = function (a, b) {
                a.className = i((" " + a.className + " ").replace(" " + b + " ", " "));
            },
            m = function (a) {
                return /Array/.test(Object.prototype.toString.call(a));
            },
            n = function (a) {
                return /Date/.test(Object.prototype.toString.call(a)) && !isNaN(a.getTime());
            },
            o = function (a) {
                var b = a.getDay();
                return 0 === b || 6 === b;
            },
            p = function (a) {
                return (a % 4 === 0 && a % 100 !== 0) || a % 400 === 0;
            },
            q = function (a, b) {
                return [31, p(a) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][b];
            },
            r = function (a) {
                n(a) && a.setHours(0, 0, 0, 0);
            },
            s = function (a, b) {
                return a.getTime() === b.getTime();
            },
            t = function (a, b, c) {
                var d, e;
                for (d in b)
                    (e = void 0 !== a[d]),
                        e && "object" == typeof b[d] && null !== b[d] && void 0 === b[d].nodeName
                            ? n(b[d])
                                ? c && (a[d] = new Date(b[d].getTime()))
                                : m(b[d])
                                ? c && (a[d] = b[d].slice(0))
                                : (a[d] = t({}, b[d], c))
                            : (!c && e) || (a[d] = b[d]);
                return a;
            },
            u = function (a) {
                return a.month < 0 && ((a.year -= Math.ceil(Math.abs(a.month) / 12)), (a.month += 12)), a.month > 11 && ((a.year += Math.floor(Math.abs(a.month) / 12)), (a.month -= 12)), a;
            },
            v = {
                field: null,
                bound: void 0,
                position: "bottom left",
                reposition: !0,
                format: "YYYY-MM-DD",
                defaultDate: null,
                setDefaultDate: !1,
                firstDay: 0,
                formatStrict: !1,
                minDate: null,
                maxDate: null,
                yearRange: 10,
                showWeekNumber: !1,
                minYear: 0,
                maxYear: 9999,
                minMonth: void 0,
                maxMonth: void 0,
                startRange: null,
                endRange: null,
                isRTL: !1,
                yearSuffix: "",
                showMonthAfterYear: !1,
                showDaysInNextAndPreviousMonths: !1,
                numberOfMonths: 1,
                mainCalendar: "left",
                container: void 0,
                i18n: {
                    previousMonth: "Previous Month",
                    nextMonth: "Next Month",
                    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                    weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                    weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                },
                theme: null,
                onSelect: null,
                onOpen: null,
                onClose: null,
                onDraw: null,
            },
            w = function (a, b, c) {
                for (b += a.firstDay; b >= 7; ) b -= 7;
                return c ? a.i18n.weekdaysShort[b] : a.i18n.weekdays[b];
            },
            x = function (a) {
                var b = [];
                if (a.isEmpty) {
                    if (!a.showDaysInNextAndPreviousMonths) return '<td class="is-empty"></td>';
                    b.push("is-outside-current-month");
                }
                return (
                    a.isDisabled && b.push("is-disabled"),
                    a.isToday && b.push("is-today"),
                    a.isSelected && b.push("is-selected"),
                    a.isInRange && b.push("is-inrange"),
                    a.isStartRange && b.push("is-startrange"),
                    a.isEndRange && b.push("is-endrange"),
                    '<td data-day="' +
                        a.day +
                        '" class="' +
                        b.join(" ") +
                        '"><button class="pika-button pika-day" type="button" data-pika-year="' +
                        a.year +
                        '" data-pika-month="' +
                        a.month +
                        '" data-pika-day="' +
                        a.day +
                        '">' +
                        a.day +
                        "</button></td>"
                );
            },
            y = function (a, b, c) {
                var d = new Date(c, 0, 1),
                    e = Math.ceil(((new Date(c, b, a) - d) / 864e5 + d.getDay() + 1) / 7);
                return '<td class="pika-week">' + e + "</td>";
            },
            z = function (a, b) {
                return "<tr>" + (b ? a.reverse() : a).join("") + "</tr>";
            },
            A = function (a) {
                return "<tbody>" + a.join("") + "</tbody>";
            },
            B = function (a) {
                var b,
                    c = [];
                for (a.showWeekNumber && c.push("<th></th>"), b = 0; b < 7; b++) c.push('<th scope="col"><abbr title="' + w(a, b) + '">' + w(a, b, !0) + "</abbr></th>");
                return "<thead>" + (a.isRTL ? c.reverse() : c).join("") + "</thead>";
            },
            C = function (a, b, c, d, e) {
                var f,
                    g,
                    h,
                    i,
                    j,
                    k = a._o,
                    l = c === k.minYear,
                    n = c === k.maxYear,
                    o = '<div class="pika-title">',
                    p = !0,
                    q = !0;
                for (h = [], f = 0; f < 12; f++)
                    h.push('<option value="' + (c === e ? f - b : 12 + f - b) + '"' + (f === d ? " selected" : "") + ((l && f < k.minMonth) || (n && f > k.maxMonth) ? "disabled" : "") + ">" + k.i18n.months[f] + "</option>");
                for (
                    i = '<div class="pika-label">' + k.i18n.months[d] + '<select class="pika-select pika-select-month" tabindex="-1">' + h.join("") + "</select></div>",
                        m(k.yearRange) ? ((f = k.yearRange[0]), (g = k.yearRange[1] + 1)) : ((f = c - k.yearRange), (g = 1 + c + k.yearRange)),
                        h = [];
                    f < g && f <= k.maxYear;
                    f++
                )
                    f >= k.minYear && h.push('<option value="' + f + '"' + (f === c ? " selected" : "") + ">" + f + "</option>");
                return (
                    (j = '<div class="pika-label">' + c + k.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + h.join("") + "</select></div>"),
                    (o += k.showMonthAfterYear ? j + i : i + j),
                    l && (0 === d || k.minMonth >= d) && (p = !1),
                    n && (11 === d || k.maxMonth <= d) && (q = !1),
                    0 === b && (o += '<button class="pika-prev' + (p ? "" : " is-disabled") + '" type="button">' + k.i18n.previousMonth + "</button>"),
                    b === a._o.numberOfMonths - 1 && (o += '<button class="pika-next' + (q ? "" : " is-disabled") + '" type="button">' + k.i18n.nextMonth + "</button>"),
                    (o += "</div>")
                );
            },
            D = function (a, b) {
                return '<table cellpadding="0" cellspacing="0" class="pika-table">' + B(a) + A(b) + "</table>";
            },
            E = function (g) {
                var h = this,
                    i = h.config(g);
                (h._onMouseDown = function (a) {
                    if (h._v) {
                        a = a || window.event;
                        var b = a.target || a.srcElement;
                        if (b)
                            if (
                                (j(b, "is-disabled") ||
                                    (j(b, "pika-button") && !j(b, "is-empty")
                                        ? (h.setDate(new Date(b.getAttribute("data-pika-year"), b.getAttribute("data-pika-month"), b.getAttribute("data-pika-day"))),
                                          i.bound &&
                                              e(function () {
                                                  h.hide(), i.field && i.field.blur();
                                              }, 100))
                                        : j(b, "pika-prev")
                                        ? h.prevMonth()
                                        : j(b, "pika-next") && h.nextMonth()),
                                j(b, "pika-select"))
                            )
                                h._c = !0;
                            else {
                                if (!a.preventDefault) return (a.returnValue = !1), !1;
                                a.preventDefault();
                            }
                    }
                }),
                    (h._onChange = function (a) {
                        a = a || window.event;
                        var b = a.target || a.srcElement;
                        b && (j(b, "pika-select-month") ? h.gotoMonth(b.value) : j(b, "pika-select-year") && h.gotoYear(b.value));
                    }),
                    (h._onInputChange = function (c) {
                        var d;
                        c.firedBy !== h && (b ? ((d = a(i.field.value, i.format, i.formatStrict)), (d = d && d.isValid() ? d.toDate() : null)) : (d = new Date(Date.parse(i.field.value))), n(d) && h.setDate(d), h._v || h.show());
                    }),
                    (h._onInputFocus = function () {
                        h.show();
                    }),
                    (h._onInputClick = function () {
                        h.show();
                    }),
                    (h._onInputBlur = function () {
                        var a = d.activeElement;
                        do if (j(a, "pika-single")) return;
                        while ((a = a.parentNode));
                        h._c ||
                            (h._b = e(function () {
                                h.hide();
                            }, 50)),
                            (h._c = !1);
                    }),
                    (h._onClick = function (a) {
                        a = a || window.event;
                        var b = a.target || a.srcElement,
                            d = b;
                        if (b) {
                            !c && j(b, "pika-select") && (b.onchange || (b.setAttribute("onchange", "return;"), f(b, "change", h._onChange)));
                            do if (j(d, "pika-single") || d === i.trigger) return;
                            while ((d = d.parentNode));
                            h._v && b !== i.trigger && d !== i.trigger && h.hide();
                        }
                    }),
                    (h.el = d.createElement("div")),
                    (h.el.className = "pika-single" + (i.isRTL ? " is-rtl" : "") + (i.theme ? " " + i.theme : "")),
                    f(h.el, "mousedown", h._onMouseDown, !0),
                    f(h.el, "touchend", h._onMouseDown, !0),
                    f(h.el, "change", h._onChange),
                    i.field &&
                        (i.container ? i.container.appendChild(h.el) : i.bound ? d.body.appendChild(h.el) : i.field.parentNode.insertBefore(h.el, i.field.nextSibling),
                        f(i.field, "change", h._onInputChange),
                        i.defaultDate || (b && i.field.value ? (i.defaultDate = a(i.field.value, i.format).toDate()) : (i.defaultDate = new Date(Date.parse(i.field.value))), (i.setDefaultDate = !0)));
                var k = i.defaultDate;
                n(k) ? (i.setDefaultDate ? h.setDate(k, !0) : h.gotoDate(k)) : h.gotoDate(new Date()),
                    i.bound ? (this.hide(), (h.el.className += " is-bound"), f(i.trigger, "click", h._onInputClick), f(i.trigger, "focus", h._onInputFocus), f(i.trigger, "blur", h._onInputBlur)) : this.show();
            };
        return (
            (E.prototype = {
                config: function (a) {
                    this._o || (this._o = t({}, v, !0));
                    var b = t(this._o, a, !0);
                    (b.isRTL = !!b.isRTL),
                        (b.field = b.field && b.field.nodeName ? b.field : null),
                        (b.theme = "string" == typeof b.theme && b.theme ? b.theme : null),
                        (b.bound = !!(void 0 !== b.bound ? b.field && b.bound : b.field)),
                        (b.trigger = b.trigger && b.trigger.nodeName ? b.trigger : b.field),
                        (b.disableWeekends = !!b.disableWeekends),
                        (b.disableDayFn = "function" == typeof b.disableDayFn ? b.disableDayFn : null);
                    var c = parseInt(b.numberOfMonths, 10) || 1;
                    if (
                        ((b.numberOfMonths = c > 4 ? 4 : c),
                        n(b.minDate) || (b.minDate = !1),
                        n(b.maxDate) || (b.maxDate = !1),
                        b.minDate && b.maxDate && b.maxDate < b.minDate && (b.maxDate = b.minDate = !1),
                        b.minDate && this.setMinDate(b.minDate),
                        b.maxDate && this.setMaxDate(b.maxDate),
                        m(b.yearRange))
                    ) {
                        var d = new Date().getFullYear() - 10;
                        (b.yearRange[0] = parseInt(b.yearRange[0], 10) || d), (b.yearRange[1] = parseInt(b.yearRange[1], 10) || d);
                    } else (b.yearRange = Math.abs(parseInt(b.yearRange, 10)) || v.yearRange), b.yearRange > 100 && (b.yearRange = 100);
                    return b;
                },
                toString: function (c) {
                    return n(this._d) ? (b ? a(this._d).format(c || this._o.format) : this._d.toDateString()) : "";
                },
                getMoment: function () {
                    return b ? a(this._d) : null;
                },
                setMoment: function (c, d) {
                    b && a.isMoment(c) && this.setDate(c.toDate(), d);
                },
                getDate: function () {
                    return n(this._d) ? new Date(this._d.getTime()) : null;
                },
                setDate: function (a, b) {
                    if (!a) return (this._d = null), this._o.field && ((this._o.field.value = ""), h(this._o.field, "change", { firedBy: this })), this.draw();
                    if (("string" == typeof a && (a = new Date(Date.parse(a))), n(a))) {
                        var c = this._o.minDate,
                            d = this._o.maxDate;
                        n(c) && a < c ? (a = c) : n(d) && a > d && (a = d),
                            (this._d = new Date(a.getTime())),
                            r(this._d),
                            this.gotoDate(this._d),
                            this._o.field && ((this._o.field.value = this.toString()), h(this._o.field, "change", { firedBy: this })),
                            b || "function" != typeof this._o.onSelect || this._o.onSelect.call(this, this.getDate());
                    }
                },
                gotoDate: function (a) {
                    var b = !0;
                    if (n(a)) {
                        if (this.calendars) {
                            var c = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                                d = new Date(this.calendars[this.calendars.length - 1].year, this.calendars[this.calendars.length - 1].month, 1),
                                e = a.getTime();
                            d.setMonth(d.getMonth() + 1), d.setDate(d.getDate() - 1), (b = e < c.getTime() || d.getTime() < e);
                        }
                        b && ((this.calendars = [{ month: a.getMonth(), year: a.getFullYear() }]), "right" === this._o.mainCalendar && (this.calendars[0].month += 1 - this._o.numberOfMonths)), this.adjustCalendars();
                    }
                },
                adjustCalendars: function () {
                    this.calendars[0] = u(this.calendars[0]);
                    for (var a = 1; a < this._o.numberOfMonths; a++) this.calendars[a] = u({ month: this.calendars[0].month + a, year: this.calendars[0].year });
                    this.draw();
                },
                gotoToday: function () {
                    this.gotoDate(new Date());
                },
                gotoMonth: function (a) {
                    isNaN(a) || ((this.calendars[0].month = parseInt(a, 10)), this.adjustCalendars());
                },
                nextMonth: function () {
                    this.calendars[0].month++, this.adjustCalendars();
                },
                prevMonth: function () {
                    this.calendars[0].month--, this.adjustCalendars();
                },
                gotoYear: function (a) {
                    isNaN(a) || ((this.calendars[0].year = parseInt(a, 10)), this.adjustCalendars());
                },
                setMinDate: function (a) {
                    r(a), (this._o.minDate = a), (this._o.minYear = a.getFullYear()), (this._o.minMonth = a.getMonth()), this.draw();
                },
                setMaxDate: function (a) {
                    r(a), (this._o.maxDate = a), (this._o.maxYear = a.getFullYear()), (this._o.maxMonth = a.getMonth()), this.draw();
                },
                setStartRange: function (a) {
                    this._o.startRange = a;
                },
                setEndRange: function (a) {
                    this._o.endRange = a;
                },
                draw: function (a) {
                    if (this._v || a) {
                        var b = this._o,
                            c = b.minYear,
                            d = b.maxYear,
                            f = b.minMonth,
                            g = b.maxMonth,
                            h = "";
                        this._y <= c && ((this._y = c), !isNaN(f) && this._m < f && (this._m = f)), this._y >= d && ((this._y = d), !isNaN(g) && this._m > g && (this._m = g));
                        for (var i = 0; i < b.numberOfMonths; i++)
                            h += '<div class="pika-lendar">' + C(this, i, this.calendars[i].year, this.calendars[i].month, this.calendars[0].year) + this.render(this.calendars[i].year, this.calendars[i].month) + "</div>";
                        if (
                            ((this.el.innerHTML = h),
                            b.bound &&
                                "hidden" !== b.field.type &&
                                e(function () {
                                    b.trigger.focus();
                                }, 1),
                            "function" == typeof this._o.onDraw)
                        ) {
                            var j = this;
                            e(function () {
                                j._o.onDraw.call(j);
                            }, 0);
                        }
                    }
                },
                adjustPosition: function () {
                    var a, b, c, e, f, g, h, i, j, k;
                    if (!this._o.container) {
                        if (
                            ((this.el.style.position = "absolute"),
                            (a = this._o.trigger),
                            (b = a),
                            (c = this.el.offsetWidth),
                            (e = this.el.offsetHeight),
                            (f = window.innerWidth || d.documentElement.clientWidth),
                            (g = window.innerHeight || d.documentElement.clientHeight),
                            (h = window.pageYOffset || d.body.scrollTop || d.documentElement.scrollTop),
                            "function" == typeof a.getBoundingClientRect)
                        )
                            (k = a.getBoundingClientRect()), (i = k.left + window.pageXOffset), (j = k.bottom + window.pageYOffset);
                        else for (i = b.offsetLeft, j = b.offsetTop + b.offsetHeight; (b = b.offsetParent); ) (i += b.offsetLeft), (j += b.offsetTop);
                        ((this._o.reposition && i + c > f) || (this._o.position.indexOf("right") > -1 && i - c + a.offsetWidth > 0)) && (i = i - c + a.offsetWidth),
                            ((this._o.reposition && j + e > g + h) || (this._o.position.indexOf("top") > -1 && j - e - a.offsetHeight > 0)) && (j = j - e - a.offsetHeight),
                            (this.el.style.left = i + "px"),
                            (this.el.style.top = j + "px");
                    }
                },
                render: function (a, b) {
                    var c = this._o,
                        d = new Date(),
                        e = q(a, b),
                        f = new Date(a, b, 1).getDay(),
                        g = [],
                        h = [];
                    r(d), c.firstDay > 0 && ((f -= c.firstDay), f < 0 && (f += 7));
                    for (var i = 0 === b ? 11 : b - 1, j = 11 === b ? 0 : b + 1, k = 0 === b ? a - 1 : a, l = 11 === b ? a + 1 : a, m = q(k, i), p = e + f, t = p; t > 7; ) t -= 7;
                    p += 7 - t;
                    for (var u = 0, v = 0; u < p; u++) {
                        var w = new Date(a, b, 1 + (u - f)),
                            A = !!n(this._d) && s(w, this._d),
                            B = s(w, d),
                            C = u < f || u >= e + f,
                            E = 1 + (u - f),
                            F = b,
                            G = a,
                            H = c.startRange && s(c.startRange, w),
                            I = c.endRange && s(c.endRange, w),
                            J = c.startRange && c.endRange && c.startRange < w && w < c.endRange,
                            K = (c.minDate && w < c.minDate) || (c.maxDate && w > c.maxDate) || (c.disableWeekends && o(w)) || (c.disableDayFn && c.disableDayFn(w));
                        C && (u < f ? ((E = m + E), (F = i), (G = k)) : ((E -= e), (F = j), (G = l)));
                        var L = { day: E, month: F, year: G, isSelected: A, isToday: B, isDisabled: K, isEmpty: C, isStartRange: H, isEndRange: I, isInRange: J, showDaysInNextAndPreviousMonths: c.showDaysInNextAndPreviousMonths };
                        h.push(x(L)), 7 === ++v && (c.showWeekNumber && h.unshift(y(u - f, b, a)), g.push(z(h, c.isRTL)), (h = []), (v = 0));
                    }
                    return D(c, g);
                },
                isVisible: function () {
                    return this._v;
                },
                show: function () {
                    this._v || (l(this.el, "is-hidden"), (this._v = !0), this.draw(), this._o.bound && (f(d, "click", this._onClick), this.adjustPosition()), "function" == typeof this._o.onOpen && this._o.onOpen.call(this));
                },
                hide: function () {
                    var a = this._v;
                    a !== !1 &&
                        (this._o.bound && g(d, "click", this._onClick),
                        (this.el.style.position = "static"),
                        (this.el.style.left = "auto"),
                        (this.el.style.top = "auto"),
                        k(this.el, "is-hidden"),
                        (this._v = !1),
                        void 0 !== a && "function" == typeof this._o.onClose && this._o.onClose.call(this));
                },
                destroy: function () {
                    this.hide(),
                        g(this.el, "mousedown", this._onMouseDown, !0),
                        g(this.el, "touchend", this._onMouseDown, !0),
                        g(this.el, "change", this._onChange),
                        this._o.field &&
                            (g(this._o.field, "change", this._onInputChange),
                            this._o.bound && (g(this._o.trigger, "click", this._onInputClick), g(this._o.trigger, "focus", this._onInputFocus), g(this._o.trigger, "blur", this._onInputBlur))),
                        this.el.parentNode && this.el.parentNode.removeChild(this.el);
                },
            }),
            E
        );
    }),
    (function (a) {
        "use strict";
        var b = "selectric",
            c = "Input Items Open Disabled TempShow HideSelect Wrapper Hover Responsive Above Scroll Group GroupLabel",
            d = ".sl",
            e = {
                onChange: function (b) {
                    a(b).change();
                },
                maxHeight: 300,
                keySearchTimeout: 500,
                arrowButtonMarkup: '<b class="button">&#x25be;</b>',
                disableOnMobile: !0,
                openOnHover: !1,
                hoverIntentTimeout: 500,
                expandToItemText: !1,
                responsive: !1,
                preventWindowScroll: !0,
                inheritOriginalWidth: !1,
                allowWrap: !0,
                customClass: { prefix: b, camelCase: !1, overwrite: !0 },
                optionsItemBuilder: "{text}",
                labelBuilder: "{text}",
            },
            f = {
                add: function (a, b, c) {
                    this[a] || (this[a] = {}), (this[a][b] = c);
                },
                remove: function (a, b) {
                    delete this[a][b];
                },
            },
            g = {
                replaceDiacritics: function (a) {
                    for (var b = "40-46 50-53 54-57 62-70 71-74 61 47 77".replace(/\d+/g, "\\3$&").split(" "), c = b.length; c--; ) a = a.toLowerCase().replace(RegExp("[" + b[c] + "]", "g"), "aeiouncy".charAt(c));
                    return a;
                },
                format: function (a) {
                    var b = arguments;
                    return ("" + a).replace(/{(\d+|(\w+))}/g, function (a, c, d) {
                        return d && b[1] ? b[1][d] : b[c];
                    });
                },
                nextEnabledItem: function (a, b) {
                    for (; a[(b = (b + 1) % a.length)].disabled; );
                    return b;
                },
                previousEnabledItem: function (a, b) {
                    for (; a[(b = (b > 0 ? b : a.length) - 1)].disabled; );
                    return b;
                },
                toDash: function (a) {
                    return a.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
                },
                triggerCallback: function (c, d) {
                    var e = d.element,
                        h = d.options["on" + c];
                    a.isFunction(h) && h.call(e, e, d),
                        f[c] &&
                            a.each(f[c], function () {
                                this.call(e, e, d);
                            }),
                        a(e).trigger(b + "-" + g.toDash(c), d);
                },
            },
            h = a(document),
            i = a(window),
            j = function (f, j) {
                function k(b) {
                    if (((K.options = a.extend(!0, {}, e, K.options, b)), (K.classes = {}), (K.element = f), g.triggerCallback("BeforeInit", K), K.options.disableOnMobile && O)) return void (K.disableOnMobile = !0);
                    u(!0);
                    var d = K.options.customClass,
                        h = c.split(" "),
                        i = L.width();
                    a.each(h, function (a, b) {
                        var c = d.prefix + b;
                        K.classes[b.toLowerCase()] = d.camelCase ? c : g.toDash(c);
                    }),
                        (v = a("<input/>", { class: K.classes.input, readonly: O })),
                        (w = a("<div/>", { class: K.classes.items, tabindex: -1 })),
                        (x = a("<div/>", { class: K.classes.scroll })),
                        (y = a("<div/>", { class: d.prefix, html: K.options.arrowButtonMarkup })),
                        (z = a('<p class="label"/>')),
                        (A = L.wrap("<div>").parent().append(y.prepend(z), w, v)),
                        (I = { open: p, close: r, destroy: u, refresh: m, init: k }),
                        L.on(I).wrap('<div class="' + K.classes.hideselect + '">'),
                        a.extend(K, I),
                        (J = K.options.labelBuilder),
                        K.options.inheritOriginalWidth && i > 0 && A.width(i),
                        l();
                }
                function l() {
                    K.items = [];
                    var b = L.children(),
                        c = "<ul>",
                        e = b.filter(":selected").index(),
                        f = 0;
                    (D = C = ~e ? e : 0),
                        (H = b.length) &&
                            (b.each(function () {
                                function b() {
                                    var b = a(this),
                                        d = b.html(),
                                        e = b.prop("disabled"),
                                        h = K.options.optionsItemBuilder;
                                    (K.items[f] = { element: b, value: b.val(), text: d, slug: g.replaceDiacritics(d), disabled: e }),
                                        (c += g.format(
                                            '<li data-index="{1}" class="{2}">{3}</li>',
                                            f,
                                            a.trim([f == D ? "selected" : "", f == H - 1 ? "last" : "", e ? "disabled" : ""].join(" ")),
                                            a.isFunction(h) ? h(K.items[f], b, f) : g.format(h, K.items[f])
                                        )),
                                        f++;
                                }
                                var d = a(this);
                                if (d.is("optgroup")) {
                                    var e = d.prop("disabled"),
                                        h = d.children();
                                    (c += g.format('<ul class="{1}"><li class="{2}">{3}</li>', a.trim([K.classes.group, e ? "disabled" : "", d.prop("class")].join(" ")), K.classes.grouplabel, d.prop("label"))),
                                        e && h.prop("disabled", !0),
                                        h.each(b),
                                        (c += "</ul>");
                                } else b.call(d);
                            }),
                            w.append(x.html(c + "</ul>")),
                            z.html(a.isFunction(J) ? J(K.items[D]) : g.format(J, K.items[D]))),
                        y.add(L).add(A).add(v).off(d),
                        A.prop(
                            "class",
                            [K.classes.wrapper, K.options.customClass.overwrite ? L.prop("class").replace(/\S+/g, K.options.customClass.prefix + "-$&") : L.prop("class"), K.options.responsive ? K.classes.responsive : ""].join(" ")
                        ),
                        L.prop("disabled")
                            ? (A.addClass(K.classes.disabled), v.prop("disabled", !0))
                            : ((N = !0),
                              A.removeClass(K.classes.disabled).on("mouseenter" + d + " mouseleave" + d, function (b) {
                                  a(this).toggleClass(K.classes.hover), K.options.openOnHover && (clearTimeout(K.closeTimer), "mouseleave" == b.type ? (K.closeTimer = setTimeout(r, K.options.hoverIntentTimeout)) : p());
                              }),
                              y.on("click" + d, function (a) {
                                  M ? r() : p(a);
                              }),
                              v
                                  .prop({ tabindex: P, disabled: !1 })
                                  .on("keypress" + d, n)
                                  .on("keydown" + d, function (a) {
                                      n(a),
                                          clearTimeout(K.resetStr),
                                          (K.resetStr = setTimeout(function () {
                                              v.val("");
                                          }, K.options.keySearchTimeout));
                                      var b = a.keyCode || a.which;
                                      if (b > 36 && b < 41) {
                                          if (!K.options.allowWrap && ((b < 39 && 0 == C) || (b > 38 && C + 1 == K.items.length))) return;
                                          s(g[(b < 39 ? "previous" : "next") + "EnabledItem"](K.items, C));
                                      }
                                  })
                                  .on("focusin" + d, function (a) {
                                      v.one("blur", function () {
                                          v.blur();
                                      }),
                                          M || p(a);
                                  })
                                  .on("oninput" in v[0] ? "input" : "keyup", function () {
                                      v.val().length &&
                                          a.each(K.items, function (a, b) {
                                              if (RegExp("^" + v.val(), "i").test(b.slug) && !b.disabled) return s(a), !1;
                                          });
                                  }),
                              L.prop("tabindex", !1),
                              (B = a("li", w.removeAttr("style"))
                                  .on({
                                      mousedown: function (a) {
                                          a.preventDefault(), a.stopPropagation();
                                      },
                                      click: function () {
                                          return s(a(this).data("index"), !0), !1;
                                      },
                                  })
                                  .filter("[data-index]"))),
                        g.triggerCallback("Init", K);
                }
                function m() {
                    g.triggerCallback("Refresh", K), l();
                }
                function n(a) {
                    var b = a.keyCode || a.which;
                    13 == b && a.preventDefault(), /^(9|13|27)$/.test(b) && (a.stopPropagation(), s(C, !0));
                }
                function o() {
                    var a = w.closest(":visible").children(":hidden").addClass(K.classes.tempshow),
                        b = K.options.maxHeight,
                        c = w.outerWidth(),
                        d = y.outerWidth() - (c - w.width());
                    !K.options.expandToItemText || d > c ? (G = d) : (w.css("overflow", "scroll"), A.width(9e4), (G = w.width()), w.css("overflow", ""), A.width("")),
                        w.width(G).height() > b && w.height(b),
                        a.removeClass(K.classes.tempshow);
                }
                function p(c) {
                    g.triggerCallback("BeforeOpen", K),
                        c && (c.preventDefault(), c.stopPropagation()),
                        N &&
                            (o(),
                            a("." + K.classes.hideselect, "." + K.classes.open)
                                .children()
                                [b]("close"),
                            (M = !0),
                            (E = w.outerHeight()),
                            (F = w.height()),
                            A.addClass(K.classes.open),
                            v.val("").is(":focus") || v.focus(),
                            h.on("click" + d, r).on("scroll" + d, q),
                            q(),
                            K.options.preventWindowScroll &&
                                h.on("mousewheel" + d + " DOMMouseScroll" + d, "." + K.classes.scroll, function (b) {
                                    var c = b.originalEvent,
                                        d = a(this).scrollTop(),
                                        e = 0;
                                    "detail" in c && (e = c.detail * -1),
                                        "wheelDelta" in c && (e = c.wheelDelta),
                                        "wheelDeltaY" in c && (e = c.wheelDeltaY),
                                        "deltaY" in c && (e = c.deltaY * -1),
                                        ((d == this.scrollHeight - F && e < 0) || (0 == d && e > 0)) && b.preventDefault();
                                }),
                            t(C),
                            g.triggerCallback("Open", K));
                }
                function q() {
                    A.toggleClass(K.classes.above, A.offset().top + A.outerHeight() + E > i.scrollTop() + i.height());
                }
                function r() {
                    if ((g.triggerCallback("BeforeClose", K), D != C)) {
                        g.triggerCallback("BeforeChange", K);
                        var b = K.items[C].text;
                        L.prop("selectedIndex", (D = C)).data("value", b), z.html(a.isFunction(J) ? J(K.items[C]) : g.format(J, K.items[C])), g.triggerCallback("Change", K);
                    }
                    h.off(d), A.removeClass(K.classes.open), (M = !1), g.triggerCallback("Close", K);
                }
                function s(a, b) {
                    void 0 != a &&
                        (K.items[a].disabled ||
                            (B.removeClass("selected")
                                .eq((C = a))
                                .addClass("selected"),
                            t(a),
                            b && r()));
                }
                function t(a) {
                    var b = B.eq(a).outerHeight(),
                        c = B[a].offsetTop,
                        d = x.scrollTop(),
                        e = c + 2 * b;
                    x.scrollTop(e > d + E ? e - E : c - b < d ? c - b : d);
                }
                function u(a) {
                    N && (w.add(y).add(v).remove(), !a && L.removeData(b).removeData("value"), L.prop("tabindex", P).off(d).off(I).unwrap().unwrap(), (N = !1));
                }
                var v,
                    w,
                    x,
                    y,
                    z,
                    A,
                    B,
                    C,
                    D,
                    E,
                    F,
                    G,
                    H,
                    I,
                    J,
                    K = this,
                    L = a(f),
                    M = !1,
                    N = !1,
                    O = /android|ip(hone|od|ad)/i.test(navigator.userAgent),
                    P = L.prop("tabindex");
                k(j);
            };
        (a.fn[b] = function (c) {
            return this.each(function () {
                var d = a.data(this, b);
                d && !d.disableOnMobile ? ("" + c === c && d[c] ? d[c]() : d.init(c)) : a.data(this, b, new j(this, c));
            });
        }),
            (a.fn[b].hooks = f);
    })(jQuery),
    (function (a) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], a) : "undefined" != typeof exports ? (module.exports = a(require("jquery"))) : a(jQuery);
    })(function (a) {
        "use strict";
        var b = window.Slick || {};
        (b = (function () {
            function b(b, d) {
                var e,
                    f = this;
                (f.defaults = {
                    accessibility: !0,
                    adaptiveHeight: !1,
                    appendArrows: a(b),
                    appendDots: a(b),
                    arrows: !0,
                    asNavFor: null,
                    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                    nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                    autoplay: !1,
                    autoplaySpeed: 3e3,
                    centerMode: !1,
                    centerPadding: "50px",
                    cssEase: "ease",
                    customPaging: function (b, c) {
                        return a('<button type="button" />').text(c + 1);
                    },
                    dots: !1,
                    dotsClass: "slick-dots",
                    draggable: !0,
                    easing: "linear",
                    edgeFriction: 0.35,
                    fade: !1,
                    focusOnSelect: !1,
                    focusOnChange: !1,
                    infinite: !0,
                    initialSlide: 0,
                    lazyLoad: "ondemand",
                    mobileFirst: !1,
                    pauseOnHover: !0,
                    pauseOnFocus: !0,
                    pauseOnDotsHover: !1,
                    respondTo: "window",
                    responsive: null,
                    rows: 1,
                    rtl: !1,
                    slide: "",
                    slidesPerRow: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    swipe: !0,
                    swipeToSlide: !1,
                    touchMove: !0,
                    touchThreshold: 5,
                    useCSS: !0,
                    useTransform: !0,
                    variableWidth: !1,
                    vertical: !1,
                    verticalSwiping: !1,
                    waitForAnimate: !0,
                    zIndex: 1e3,
                }),
                    (f.initials = {
                        animating: !1,
                        dragging: !1,
                        autoPlayTimer: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        $dots: null,
                        listWidth: null,
                        listHeight: null,
                        loadIndex: 0,
                        $nextArrow: null,
                        $prevArrow: null,
                        scrolling: !1,
                        slideCount: null,
                        slideWidth: null,
                        $slideTrack: null,
                        $slides: null,
                        sliding: !1,
                        slideOffset: 0,
                        swipeLeft: null,
                        swiping: !1,
                        $list: null,
                        touchObject: {},
                        transformsEnabled: !1,
                        unslicked: !1,
                    }),
                    a.extend(f, f.initials),
                    (f.activeBreakpoint = null),
                    (f.animType = null),
                    (f.animProp = null),
                    (f.breakpoints = []),
                    (f.breakpointSettings = []),
                    (f.cssTransitions = !1),
                    (f.focussed = !1),
                    (f.interrupted = !1),
                    (f.hidden = "hidden"),
                    (f.paused = !0),
                    (f.positionProp = null),
                    (f.respondTo = null),
                    (f.rowCount = 1),
                    (f.shouldClick = !0),
                    (f.$slider = a(b)),
                    (f.$slidesCache = null),
                    (f.transformType = null),
                    (f.transitionType = null),
                    (f.visibilityChange = "visibilitychange"),
                    (f.windowWidth = 0),
                    (f.windowTimer = null),
                    (e = a(b).data("slick") || {}),
                    (f.options = a.extend({}, f.defaults, d, e)),
                    (f.currentSlide = f.options.initialSlide),
                    (f.originalSettings = f.options),
                    "undefined" != typeof document.mozHidden
                        ? ((f.hidden = "mozHidden"), (f.visibilityChange = "mozvisibilitychange"))
                        : "undefined" != typeof document.webkitHidden && ((f.hidden = "webkitHidden"), (f.visibilityChange = "webkitvisibilitychange")),
                    (f.autoPlay = a.proxy(f.autoPlay, f)),
                    (f.autoPlayClear = a.proxy(f.autoPlayClear, f)),
                    (f.autoPlayIterator = a.proxy(f.autoPlayIterator, f)),
                    (f.changeSlide = a.proxy(f.changeSlide, f)),
                    (f.clickHandler = a.proxy(f.clickHandler, f)),
                    (f.selectHandler = a.proxy(f.selectHandler, f)),
                    (f.setPosition = a.proxy(f.setPosition, f)),
                    (f.swipeHandler = a.proxy(f.swipeHandler, f)),
                    (f.dragHandler = a.proxy(f.dragHandler, f)),
                    (f.keyHandler = a.proxy(f.keyHandler, f)),
                    (f.instanceUid = c++),
                    (f.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                    f.registerBreakpoints(),
                    f.init(!0);
            }
            var c = 0;
            return b;
        })()),
            (b.prototype.activateADA = function () {
                var a = this;
                a.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
            }),
            (b.prototype.addSlide = b.prototype.slickAdd = function (b, c, d) {
                var e = this;
                if ("boolean" == typeof c) (d = c), (c = null);
                else if (c < 0 || c >= e.slideCount) return !1;
                e.unload(),
                    "number" == typeof c
                        ? 0 === c && 0 === e.$slides.length
                            ? a(b).appendTo(e.$slideTrack)
                            : d
                            ? a(b).insertBefore(e.$slides.eq(c))
                            : a(b).insertAfter(e.$slides.eq(c))
                        : d === !0
                        ? a(b).prependTo(e.$slideTrack)
                        : a(b).appendTo(e.$slideTrack),
                    (e.$slides = e.$slideTrack.children(this.options.slide)),
                    e.$slideTrack.children(this.options.slide).detach(),
                    e.$slideTrack.append(e.$slides),
                    e.$slides.each(function (b, c) {
                        a(c).attr("data-slick-index", b);
                    }),
                    (e.$slidesCache = e.$slides),
                    e.reinit();
            }),
            (b.prototype.animateHeight = function () {
                var a = this;
                if (1 === a.options.slidesToShow && a.options.adaptiveHeight === !0 && a.options.vertical === !1) {
                    var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
                    a.$list.animate({ height: b }, a.options.speed);
                }
            }),
            (b.prototype.animateSlide = function (b, c) {
                var d = {},
                    e = this;
                e.animateHeight(),
                    e.options.rtl === !0 && e.options.vertical === !1 && (b = -b),
                    e.transformsEnabled === !1
                        ? e.options.vertical === !1
                            ? e.$slideTrack.animate({ left: b }, e.options.speed, e.options.easing, c)
                            : e.$slideTrack.animate({ top: b }, e.options.speed, e.options.easing, c)
                        : e.cssTransitions === !1
                        ? (e.options.rtl === !0 && (e.currentLeft = -e.currentLeft),
                          a({ animStart: e.currentLeft }).animate(
                              { animStart: b },
                              {
                                  duration: e.options.speed,
                                  easing: e.options.easing,
                                  step: function (a) {
                                      (a = Math.ceil(a)), e.options.vertical === !1 ? ((d[e.animType] = "translate(" + a + "px, 0px)"), e.$slideTrack.css(d)) : ((d[e.animType] = "translate(0px," + a + "px)"), e.$slideTrack.css(d));
                                  },
                                  complete: function () {
                                      c && c.call();
                                  },
                              }
                          ))
                        : (e.applyTransition(),
                          (b = Math.ceil(b)),
                          e.options.vertical === !1 ? (d[e.animType] = "translate3d(" + b + "px, 0px, 0px)") : (d[e.animType] = "translate3d(0px," + b + "px, 0px)"),
                          e.$slideTrack.css(d),
                          c &&
                              setTimeout(function () {
                                  e.disableTransition(), c.call();
                              }, e.options.speed));
            }),
            (b.prototype.getNavTarget = function () {
                var b = this,
                    c = b.options.asNavFor;
                return c && null !== c && (c = a(c).not(b.$slider)), c;
            }),
            (b.prototype.asNavFor = function (b) {
                var c = this,
                    d = c.getNavTarget();
                null !== d &&
                    "object" == typeof d &&
                    d.each(function () {
                        var c = a(this).slick("getSlick");
                        c.unslicked || c.slideHandler(b, !0);
                    });
            }),
            (b.prototype.applyTransition = function (a) {
                var b = this,
                    c = {};
                b.options.fade === !1 ? (c[b.transitionType] = b.transformType + " " + b.options.speed + "ms " + b.options.cssEase) : (c[b.transitionType] = "opacity " + b.options.speed + "ms " + b.options.cssEase),
                    b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
            }),
            (b.prototype.autoPlay = function () {
                var a = this;
                a.autoPlayClear(), a.slideCount > a.options.slidesToShow && (a.autoPlayTimer = setInterval(a.autoPlayIterator, a.options.autoplaySpeed));
            }),
            (b.prototype.autoPlayClear = function () {
                var a = this;
                a.autoPlayTimer && clearInterval(a.autoPlayTimer);
            }),
            (b.prototype.autoPlayIterator = function () {
                var a = this,
                    b = a.currentSlide + a.options.slidesToScroll;
                a.paused ||
                    a.interrupted ||
                    a.focussed ||
                    (a.options.infinite === !1 &&
                        (1 === a.direction && a.currentSlide + 1 === a.slideCount - 1 ? (a.direction = 0) : 0 === a.direction && ((b = a.currentSlide - a.options.slidesToScroll), a.currentSlide - 1 === 0 && (a.direction = 1))),
                    a.slideHandler(b));
            }),
            (b.prototype.buildArrows = function () {
                var b = this;
                b.options.arrows === !0 &&
                    ((b.$prevArrow = a(b.options.prevArrow).addClass("slick-arrow")),
                    (b.$nextArrow = a(b.options.nextArrow).addClass("slick-arrow")),
                    b.slideCount > b.options.slidesToShow
                        ? (b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.prependTo(b.options.appendArrows),
                          b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.appendTo(b.options.appendArrows),
                          b.options.infinite !== !0 && b.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                        : b.$prevArrow.add(b.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
            }),
            (b.prototype.buildDots = function () {
                var b,
                    c,
                    d = this;
                if (d.options.dots === !0) {
                    for (d.$slider.addClass("slick-dotted"), c = a("<ul />").addClass(d.options.dotsClass), b = 0; b <= d.getDotCount(); b += 1) c.append(a("<li />").append(d.options.customPaging.call(this, d, b)));
                    (d.$dots = c.appendTo(d.options.appendDots)), d.$dots.find("li").first().addClass("slick-active");
                }
            }),
            (b.prototype.buildOut = function () {
                var b = this;
                (b.$slides = b.$slider.children(b.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                    (b.slideCount = b.$slides.length),
                    b.$slides.each(function (b, c) {
                        a(c)
                            .attr("data-slick-index", b)
                            .data("originalStyling", a(c).attr("style") || "");
                    }),
                    b.$slider.addClass("slick-slider"),
                    (b.$slideTrack = 0 === b.slideCount ? a('<div class="slick-track"/>').appendTo(b.$slider) : b.$slides.wrapAll('<div class="slick-track"/>').parent()),
                    (b.$list = b.$slideTrack.wrap('<div class="slick-list"/>').parent()),
                    b.$slideTrack.css("opacity", 0),
                    (b.options.centerMode !== !0 && b.options.swipeToSlide !== !0) || (b.options.slidesToScroll = 1),
                    a("img[data-lazy]", b.$slider).not("[src]").addClass("slick-loading"),
                    b.setupInfinite(),
                    b.buildArrows(),
                    b.buildDots(),
                    b.updateDots(),
                    b.setSlideClasses("number" == typeof b.currentSlide ? b.currentSlide : 0),
                    b.options.draggable === !0 && b.$list.addClass("draggable");
            }),
            (b.prototype.buildRows = function () {
                var a,
                    b,
                    c,
                    d,
                    e,
                    f,
                    g,
                    h = this;
                if (((d = document.createDocumentFragment()), (f = h.$slider.children()), h.options.rows > 1)) {
                    for (g = h.options.slidesPerRow * h.options.rows, e = Math.ceil(f.length / g), a = 0; a < e; a++) {
                        var i = document.createElement("div");
                        for (b = 0; b < h.options.rows; b++) {
                            var j = document.createElement("div");
                            for (c = 0; c < h.options.slidesPerRow; c++) {
                                var k = a * g + (b * h.options.slidesPerRow + c);
                                f.get(k) && j.appendChild(f.get(k));
                            }
                            i.appendChild(j);
                        }
                        d.appendChild(i);
                    }
                    h.$slider.empty().append(d),
                        h.$slider
                            .children()
                            .children()
                            .children()
                            .css({ width: 100 / h.options.slidesPerRow + "%", display: "inline-block" });
                }
            }),
            (b.prototype.checkResponsive = function (b, c) {
                var d,
                    e,
                    f,
                    g = this,
                    h = !1,
                    i = g.$slider.width(),
                    j = window.innerWidth || a(window).width();
                if (("window" === g.respondTo ? (f = j) : "slider" === g.respondTo ? (f = i) : "min" === g.respondTo && (f = Math.min(j, i)), g.options.responsive && g.options.responsive.length && null !== g.options.responsive)) {
                    e = null;
                    for (d in g.breakpoints) g.breakpoints.hasOwnProperty(d) && (g.originalSettings.mobileFirst === !1 ? f < g.breakpoints[d] && (e = g.breakpoints[d]) : f > g.breakpoints[d] && (e = g.breakpoints[d]));
                    null !== e
                        ? null !== g.activeBreakpoint
                            ? (e !== g.activeBreakpoint || c) &&
                              ((g.activeBreakpoint = e),
                              "unslick" === g.breakpointSettings[e] ? g.unslick(e) : ((g.options = a.extend({}, g.originalSettings, g.breakpointSettings[e])), b === !0 && (g.currentSlide = g.options.initialSlide), g.refresh(b)),
                              (h = e))
                            : ((g.activeBreakpoint = e),
                              "unslick" === g.breakpointSettings[e] ? g.unslick(e) : ((g.options = a.extend({}, g.originalSettings, g.breakpointSettings[e])), b === !0 && (g.currentSlide = g.options.initialSlide), g.refresh(b)),
                              (h = e))
                        : null !== g.activeBreakpoint && ((g.activeBreakpoint = null), (g.options = g.originalSettings), b === !0 && (g.currentSlide = g.options.initialSlide), g.refresh(b), (h = e)),
                        b || h === !1 || g.$slider.trigger("breakpoint", [g, h]);
                }
            }),
            (b.prototype.changeSlide = function (b, c) {
                var d,
                    e,
                    f,
                    g = this,
                    h = a(b.currentTarget);
                switch ((h.is("a") && b.preventDefault(), h.is("li") || (h = h.closest("li")), (f = g.slideCount % g.options.slidesToScroll !== 0), (d = f ? 0 : (g.slideCount - g.currentSlide) % g.options.slidesToScroll), b.data.message)) {
                    case "previous":
                        (e = 0 === d ? g.options.slidesToScroll : g.options.slidesToShow - d), g.slideCount > g.options.slidesToShow && g.slideHandler(g.currentSlide - e, !1, c);
                        break;
                    case "next":
                        (e = 0 === d ? g.options.slidesToScroll : d), g.slideCount > g.options.slidesToShow && g.slideHandler(g.currentSlide + e, !1, c);
                        break;
                    case "index":
                        var i = 0 === b.data.index ? 0 : b.data.index || h.index() * g.options.slidesToScroll;
                        g.slideHandler(g.checkNavigable(i), !1, c), h.children().trigger("focus");
                        break;
                    default:
                        return;
                }
            }),
            (b.prototype.checkNavigable = function (a) {
                var b,
                    c,
                    d = this;
                if (((b = d.getNavigableIndexes()), (c = 0), a > b[b.length - 1])) a = b[b.length - 1];
                else
                    for (var e in b) {
                        if (a < b[e]) {
                            a = c;
                            break;
                        }
                        c = b[e];
                    }
                return a;
            }),
            (b.prototype.cleanUpEvents = function () {
                var b = this;
                b.options.dots &&
                    null !== b.$dots &&
                    (a("li", b.$dots).off("click.slick", b.changeSlide).off("mouseenter.slick", a.proxy(b.interrupt, b, !0)).off("mouseleave.slick", a.proxy(b.interrupt, b, !1)),
                    b.options.accessibility === !0 && b.$dots.off("keydown.slick", b.keyHandler)),
                    b.$slider.off("focus.slick blur.slick"),
                    b.options.arrows === !0 &&
                        b.slideCount > b.options.slidesToShow &&
                        (b.$prevArrow && b.$prevArrow.off("click.slick", b.changeSlide),
                        b.$nextArrow && b.$nextArrow.off("click.slick", b.changeSlide),
                        b.options.accessibility === !0 && (b.$prevArrow && b.$prevArrow.off("keydown.slick", b.keyHandler), b.$nextArrow && b.$nextArrow.off("keydown.slick", b.keyHandler))),
                    b.$list.off("touchstart.slick mousedown.slick", b.swipeHandler),
                    b.$list.off("touchmove.slick mousemove.slick", b.swipeHandler),
                    b.$list.off("touchend.slick mouseup.slick", b.swipeHandler),
                    b.$list.off("touchcancel.slick mouseleave.slick", b.swipeHandler),
                    b.$list.off("click.slick", b.clickHandler),
                    a(document).off(b.visibilityChange, b.visibility),
                    b.cleanUpSlideEvents(),
                    b.options.accessibility === !0 && b.$list.off("keydown.slick", b.keyHandler),
                    b.options.focusOnSelect === !0 && a(b.$slideTrack).children().off("click.slick", b.selectHandler),
                    a(window).off("orientationchange.slick.slick-" + b.instanceUid, b.orientationChange),
                    a(window).off("resize.slick.slick-" + b.instanceUid, b.resize),
                    a("[draggable!=true]", b.$slideTrack).off("dragstart", b.preventDefault),
                    a(window).off("load.slick.slick-" + b.instanceUid, b.setPosition);
            }),
            (b.prototype.cleanUpSlideEvents = function () {
                var b = this;
                b.$list.off("mouseenter.slick", a.proxy(b.interrupt, b, !0)), b.$list.off("mouseleave.slick", a.proxy(b.interrupt, b, !1));
            }),
            (b.prototype.cleanUpRows = function () {
                var a,
                    b = this;
                b.options.rows > 1 && ((a = b.$slides.children().children()), a.removeAttr("style"), b.$slider.empty().append(a));
            }),
            (b.prototype.clickHandler = function (a) {
                var b = this;
                b.shouldClick === !1 && (a.stopImmediatePropagation(), a.stopPropagation(), a.preventDefault());
            }),
            (b.prototype.destroy = function (b) {
                var c = this;
                c.autoPlayClear(),
                    (c.touchObject = {}),
                    c.cleanUpEvents(),
                    a(".slick-cloned", c.$slider).detach(),
                    c.$dots && c.$dots.remove(),
                    c.$prevArrow &&
                        c.$prevArrow.length &&
                        (c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), c.htmlExpr.test(c.options.prevArrow) && c.$prevArrow.remove()),
                    c.$nextArrow &&
                        c.$nextArrow.length &&
                        (c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), c.htmlExpr.test(c.options.nextArrow) && c.$nextArrow.remove()),
                    c.$slides &&
                        (c.$slides
                            .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                            .removeAttr("aria-hidden")
                            .removeAttr("data-slick-index")
                            .each(function () {
                                a(this).attr("style", a(this).data("originalStyling"));
                            }),
                        c.$slideTrack.children(this.options.slide).detach(),
                        c.$slideTrack.detach(),
                        c.$list.detach(),
                        c.$slider.append(c.$slides)),
                    c.cleanUpRows(),
                    c.$slider.removeClass("slick-slider"),
                    c.$slider.removeClass("slick-initialized"),
                    c.$slider.removeClass("slick-dotted"),
                    (c.unslicked = !0),
                    b || c.$slider.trigger("destroy", [c]);
            }),
            (b.prototype.disableTransition = function (a) {
                var b = this,
                    c = {};
                (c[b.transitionType] = ""), b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
            }),
            (b.prototype.fadeSlide = function (a, b) {
                var c = this;
                c.cssTransitions === !1
                    ? (c.$slides.eq(a).css({ zIndex: c.options.zIndex }), c.$slides.eq(a).animate({ opacity: 1 }, c.options.speed, c.options.easing, b))
                    : (c.applyTransition(a),
                      c.$slides.eq(a).css({ opacity: 1, zIndex: c.options.zIndex }),
                      b &&
                          setTimeout(function () {
                              c.disableTransition(a), b.call();
                          }, c.options.speed));
            }),
            (b.prototype.fadeSlideOut = function (a) {
                var b = this;
                b.cssTransitions === !1 ? b.$slides.eq(a).animate({ opacity: 0, zIndex: b.options.zIndex - 2 }, b.options.speed, b.options.easing) : (b.applyTransition(a), b.$slides.eq(a).css({ opacity: 0, zIndex: b.options.zIndex - 2 }));
            }),
            (b.prototype.filterSlides = b.prototype.slickFilter = function (a) {
                var b = this;
                null !== a && ((b.$slidesCache = b.$slides), b.unload(), b.$slideTrack.children(this.options.slide).detach(), b.$slidesCache.filter(a).appendTo(b.$slideTrack), b.reinit());
            }),
            (b.prototype.focusHandler = function () {
                var b = this;
                b.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (c) {
                    c.stopImmediatePropagation();
                    var d = a(this);
                    setTimeout(function () {
                        b.options.pauseOnFocus && ((b.focussed = d.is(":focus")), b.autoPlay());
                    }, 0);
                });
            }),
            (b.prototype.getCurrent = b.prototype.slickCurrentSlide = function () {
                var a = this;
                return a.currentSlide;
            }),
            (b.prototype.getDotCount = function () {
                var a = this,
                    b = 0,
                    c = 0,
                    d = 0;
                if (a.options.infinite === !0)
                    if (a.slideCount <= a.options.slidesToShow) ++d;
                    else for (; b < a.slideCount; ) ++d, (b = c + a.options.slidesToScroll), (c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow);
                else if (a.options.centerMode === !0) d = a.slideCount;
                else if (a.options.asNavFor) for (; b < a.slideCount; ) ++d, (b = c + a.options.slidesToScroll), (c += a.options.slidesToScroll <= a.options.slidesToShow ? a.options.slidesToScroll : a.options.slidesToShow);
                else d = 1 + Math.ceil((a.slideCount - a.options.slidesToShow) / a.options.slidesToScroll);
                return d - 1;
            }),
            (b.prototype.getLeft = function (a) {
                var b,
                    c,
                    d,
                    e,
                    f = this,
                    g = 0;
                return (
                    (f.slideOffset = 0),
                    (c = f.$slides.first().outerHeight(!0)),
                    f.options.infinite === !0
                        ? (f.slideCount > f.options.slidesToShow &&
                              ((f.slideOffset = f.slideWidth * f.options.slidesToShow * -1),
                              (e = -1),
                              f.options.vertical === !0 && f.options.centerMode === !0 && (2 === f.options.slidesToShow ? (e = -1.5) : 1 === f.options.slidesToShow && (e = -2)),
                              (g = c * f.options.slidesToShow * e)),
                          f.slideCount % f.options.slidesToScroll !== 0 &&
                              a + f.options.slidesToScroll > f.slideCount &&
                              f.slideCount > f.options.slidesToShow &&
                              (a > f.slideCount
                                  ? ((f.slideOffset = (f.options.slidesToShow - (a - f.slideCount)) * f.slideWidth * -1), (g = (f.options.slidesToShow - (a - f.slideCount)) * c * -1))
                                  : ((f.slideOffset = (f.slideCount % f.options.slidesToScroll) * f.slideWidth * -1), (g = (f.slideCount % f.options.slidesToScroll) * c * -1))))
                        : a + f.options.slidesToShow > f.slideCount && ((f.slideOffset = (a + f.options.slidesToShow - f.slideCount) * f.slideWidth), (g = (a + f.options.slidesToShow - f.slideCount) * c)),
                    f.slideCount <= f.options.slidesToShow && ((f.slideOffset = 0), (g = 0)),
                    f.options.centerMode === !0 && f.slideCount <= f.options.slidesToShow
                        ? (f.slideOffset = (f.slideWidth * Math.floor(f.options.slidesToShow)) / 2 - (f.slideWidth * f.slideCount) / 2)
                        : f.options.centerMode === !0 && f.options.infinite === !0
                        ? (f.slideOffset += f.slideWidth * Math.floor(f.options.slidesToShow / 2) - f.slideWidth)
                        : f.options.centerMode === !0 && ((f.slideOffset = 0), (f.slideOffset += f.slideWidth * Math.floor(f.options.slidesToShow / 2))),
                    (b = f.options.vertical === !1 ? a * f.slideWidth * -1 + f.slideOffset : a * c * -1 + g),
                    f.options.variableWidth === !0 &&
                        ((d = f.slideCount <= f.options.slidesToShow || f.options.infinite === !1 ? f.$slideTrack.children(".slick-slide").eq(a) : f.$slideTrack.children(".slick-slide").eq(a + f.options.slidesToShow)),
                        (b = f.options.rtl === !0 ? (d[0] ? (f.$slideTrack.width() - d[0].offsetLeft - d.width()) * -1 : 0) : d[0] ? d[0].offsetLeft * -1 : 0),
                        f.options.centerMode === !0 &&
                            ((d = f.slideCount <= f.options.slidesToShow || f.options.infinite === !1 ? f.$slideTrack.children(".slick-slide").eq(a) : f.$slideTrack.children(".slick-slide").eq(a + f.options.slidesToShow + 1)),
                            (b = f.options.rtl === !0 ? (d[0] ? (f.$slideTrack.width() - d[0].offsetLeft - d.width()) * -1 : 0) : d[0] ? d[0].offsetLeft * -1 : 0),
                            (b += (f.$list.width() - d.outerWidth()) / 2))),
                    b
                );
            }),
            (b.prototype.getOption = b.prototype.slickGetOption = function (a) {
                var b = this;
                return b.options[a];
            }),
            (b.prototype.getNavigableIndexes = function () {
                var a,
                    b = this,
                    c = 0,
                    d = 0,
                    e = [];
                for (b.options.infinite === !1 ? (a = b.slideCount) : ((c = b.options.slidesToScroll * -1), (d = b.options.slidesToScroll * -1), (a = 2 * b.slideCount)); c < a; )
                    e.push(c), (c = d + b.options.slidesToScroll), (d += b.options.slidesToScroll <= b.options.slidesToShow ? b.options.slidesToScroll : b.options.slidesToShow);
                return e;
            }),
            (b.prototype.getSlick = function () {
                return this;
            }),
            (b.prototype.getSlideCount = function () {
                var b,
                    c,
                    d,
                    e = this;
                return (
                    (d = e.options.centerMode === !0 ? e.slideWidth * Math.floor(e.options.slidesToShow / 2) : 0),
                    e.options.swipeToSlide === !0
                        ? (e.$slideTrack.find(".slick-slide").each(function (b, f) {
                              if (f.offsetLeft - d + a(f).outerWidth() / 2 > e.swipeLeft * -1) return (c = f), !1;
                          }),
                          (b = Math.abs(a(c).attr("data-slick-index") - e.currentSlide) || 1))
                        : e.options.slidesToScroll
                );
            }),
            (b.prototype.goTo = b.prototype.slickGoTo = function (a, b) {
                var c = this;
                c.changeSlide({ data: { message: "index", index: parseInt(a) } }, b);
            }),
            (b.prototype.init = function (b) {
                var c = this;
                a(c.$slider).hasClass("slick-initialized") ||
                    (a(c.$slider).addClass("slick-initialized"), c.buildRows(), c.buildOut(), c.setProps(), c.startLoad(), c.loadSlider(), c.initializeEvents(), c.updateArrows(), c.updateDots(), c.checkResponsive(!0), c.focusHandler()),
                    b && c.$slider.trigger("init", [c]),
                    c.options.accessibility === !0 && c.initADA(),
                    c.options.autoplay && ((c.paused = !1), c.autoPlay());
            }),
            (b.prototype.initADA = function () {
                var b = this,
                    c = Math.ceil(b.slideCount / b.options.slidesToShow),
                    d = b.getNavigableIndexes().filter(function (a) {
                        return a >= 0 && a < b.slideCount;
                    });
                b.$slides.add(b.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }),
                    null !== b.$dots &&
                        (b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function (c) {
                            var e = d.indexOf(c);
                            a(this).attr({ role: "tabpanel", id: "slick-slide" + b.instanceUid + c, tabindex: -1 }), e !== -1 && a(this).attr({ "aria-describedby": "slick-slide-control" + b.instanceUid + e });
                        }),
                        b.$dots
                            .attr("role", "tablist")
                            .find("li")
                            .each(function (e) {
                                var f = d[e];
                                a(this).attr({ role: "presentation" }),
                                    a(this)
                                        .find("button")
                                        .first()
                                        .attr({ role: "tab", id: "slick-slide-control" + b.instanceUid + e, "aria-controls": "slick-slide" + b.instanceUid + f, "aria-label": e + 1 + " of " + c, "aria-selected": null, tabindex: "-1" });
                            })
                            .eq(b.currentSlide)
                            .find("button")
                            .attr({ "aria-selected": "true", tabindex: "0" })
                            .end());
                for (var e = b.currentSlide, f = e + b.options.slidesToShow; e < f; e++) b.$slides.eq(e).attr("tabindex", 0);
                b.activateADA();
            }),
            (b.prototype.initArrowEvents = function () {
                var a = this;
                a.options.arrows === !0 &&
                    a.slideCount > a.options.slidesToShow &&
                    (a.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, a.changeSlide),
                    a.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, a.changeSlide),
                    a.options.accessibility === !0 && (a.$prevArrow.on("keydown.slick", a.keyHandler), a.$nextArrow.on("keydown.slick", a.keyHandler)));
            }),
            (b.prototype.initDotEvents = function () {
                var b = this;
                b.options.dots === !0 && (a("li", b.$dots).on("click.slick", { message: "index" }, b.changeSlide), b.options.accessibility === !0 && b.$dots.on("keydown.slick", b.keyHandler)),
                    b.options.dots === !0 && b.options.pauseOnDotsHover === !0 && a("li", b.$dots).on("mouseenter.slick", a.proxy(b.interrupt, b, !0)).on("mouseleave.slick", a.proxy(b.interrupt, b, !1));
            }),
            (b.prototype.initSlideEvents = function () {
                var b = this;
                b.options.pauseOnHover && (b.$list.on("mouseenter.slick", a.proxy(b.interrupt, b, !0)), b.$list.on("mouseleave.slick", a.proxy(b.interrupt, b, !1)));
            }),
            (b.prototype.initializeEvents = function () {
                var b = this;
                b.initArrowEvents(),
                    b.initDotEvents(),
                    b.initSlideEvents(),
                    b.$list.on("touchstart.slick mousedown.slick", { action: "start" }, b.swipeHandler),
                    b.$list.on("touchmove.slick mousemove.slick", { action: "move" }, b.swipeHandler),
                    b.$list.on("touchend.slick mouseup.slick", { action: "end" }, b.swipeHandler),
                    b.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, b.swipeHandler),
                    b.$list.on("click.slick", b.clickHandler),
                    a(document).on(b.visibilityChange, a.proxy(b.visibility, b)),
                    b.options.accessibility === !0 && b.$list.on("keydown.slick", b.keyHandler),
                    b.options.focusOnSelect === !0 && a(b.$slideTrack).children().on("click.slick", b.selectHandler),
                    a(window).on("orientationchange.slick.slick-" + b.instanceUid, a.proxy(b.orientationChange, b)),
                    a(window).on("resize.slick.slick-" + b.instanceUid, a.proxy(b.resize, b)),
                    a("[draggable!=true]", b.$slideTrack).on("dragstart", b.preventDefault),
                    a(window).on("load.slick.slick-" + b.instanceUid, b.setPosition),
                    a(b.setPosition);
            }),
            (b.prototype.initUI = function () {
                var a = this;
                a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.show(), a.$nextArrow.show()), a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.show();
            }),
            (b.prototype.keyHandler = function (a) {
                var b = this;
                a.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                    (37 === a.keyCode && b.options.accessibility === !0
                        ? b.changeSlide({ data: { message: b.options.rtl === !0 ? "next" : "previous" } })
                        : 39 === a.keyCode && b.options.accessibility === !0 && b.changeSlide({ data: { message: b.options.rtl === !0 ? "previous" : "next" } }));
            }),
            (b.prototype.lazyLoad = function () {
                function b(b) {
                    a("img[data-lazy]", b).each(function () {
                        var b = a(this),
                            c = a(this).attr("data-lazy"),
                            d = a(this).attr("data-srcset"),
                            e = a(this).attr("data-sizes") || g.$slider.attr("data-sizes"),
                            f = document.createElement("img");
                        (f.onload = function () {
                            b.animate({ opacity: 0 }, 100, function () {
                                d && (b.attr("srcset", d), e && b.attr("sizes", e)),
                                    b.attr("src", c).animate({ opacity: 1 }, 200, function () {
                                        b.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
                                    }),
                                    g.$slider.trigger("lazyLoaded", [g, b, c]);
                            });
                        }),
                            (f.onerror = function () {
                                b.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), g.$slider.trigger("lazyLoadError", [g, b, c]);
                            }),
                            (f.src = c);
                    });
                }
                var c,
                    d,
                    e,
                    f,
                    g = this;
                if (
                    (g.options.centerMode === !0
                        ? g.options.infinite === !0
                            ? ((e = g.currentSlide + (g.options.slidesToShow / 2 + 1)), (f = e + g.options.slidesToShow + 2))
                            : ((e = Math.max(0, g.currentSlide - (g.options.slidesToShow / 2 + 1))), (f = 2 + (g.options.slidesToShow / 2 + 1) + g.currentSlide))
                        : ((e = g.options.infinite ? g.options.slidesToShow + g.currentSlide : g.currentSlide), (f = Math.ceil(e + g.options.slidesToShow)), g.options.fade === !0 && (e > 0 && e--, f <= g.slideCount && f++)),
                    (c = g.$slider.find(".slick-slide").slice(e, f)),
                    "anticipated" === g.options.lazyLoad)
                )
                    for (var h = e - 1, i = f, j = g.$slider.find(".slick-slide"), k = 0; k < g.options.slidesToScroll; k++) h < 0 && (h = g.slideCount - 1), (c = c.add(j.eq(h))), (c = c.add(j.eq(i))), h--, i++;
                b(c),
                    g.slideCount <= g.options.slidesToShow
                        ? ((d = g.$slider.find(".slick-slide")), b(d))
                        : g.currentSlide >= g.slideCount - g.options.slidesToShow
                        ? ((d = g.$slider.find(".slick-cloned").slice(0, g.options.slidesToShow)), b(d))
                        : 0 === g.currentSlide && ((d = g.$slider.find(".slick-cloned").slice(g.options.slidesToShow * -1)), b(d));
            }),
            (b.prototype.loadSlider = function () {
                var a = this;
                a.setPosition(), a.$slideTrack.css({ opacity: 1 }), a.$slider.removeClass("slick-loading"), a.initUI(), "progressive" === a.options.lazyLoad && a.progressiveLazyLoad();
            }),
            (b.prototype.next = b.prototype.slickNext = function () {
                var a = this;
                a.changeSlide({ data: { message: "next" } });
            }),
            (b.prototype.orientationChange = function () {
                var a = this;
                a.checkResponsive(), a.setPosition();
            }),
            (b.prototype.pause = b.prototype.slickPause = function () {
                var a = this;
                a.autoPlayClear(), (a.paused = !0);
            }),
            (b.prototype.play = b.prototype.slickPlay = function () {
                var a = this;
                a.autoPlay(), (a.options.autoplay = !0), (a.paused = !1), (a.focussed = !1), (a.interrupted = !1);
            }),
            (b.prototype.postSlide = function (b) {
                var c = this;
                if (
                    !c.unslicked &&
                    (c.$slider.trigger("afterChange", [c, b]),
                    (c.animating = !1),
                    c.slideCount > c.options.slidesToShow && c.setPosition(),
                    (c.swipeLeft = null),
                    c.options.autoplay && c.autoPlay(),
                    c.options.accessibility === !0 && (c.initADA(), c.options.focusOnChange))
                ) {
                    var d = a(c.$slides.get(c.currentSlide));
                    d.attr("tabindex", 0).focus();
                }
            }),
            (b.prototype.prev = b.prototype.slickPrev = function () {
                var a = this;
                a.changeSlide({ data: { message: "previous" } });
            }),
            (b.prototype.preventDefault = function (a) {
                a.preventDefault();
            }),
            (b.prototype.progressiveLazyLoad = function (b) {
                b = b || 1;
                var c,
                    d,
                    e,
                    f,
                    g,
                    h = this,
                    i = a("img[data-lazy]", h.$slider);
                i.length
                    ? ((c = i.first()),
                      (d = c.attr("data-lazy")),
                      (e = c.attr("data-srcset")),
                      (f = c.attr("data-sizes") || h.$slider.attr("data-sizes")),
                      (g = document.createElement("img")),
                      (g.onload = function () {
                          e && (c.attr("srcset", e), f && c.attr("sizes", f)),
                              c.attr("src", d).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),
                              h.options.adaptiveHeight === !0 && h.setPosition(),
                              h.$slider.trigger("lazyLoaded", [h, c, d]),
                              h.progressiveLazyLoad();
                      }),
                      (g.onerror = function () {
                          b < 3
                              ? setTimeout(function () {
                                    h.progressiveLazyLoad(b + 1);
                                }, 500)
                              : (c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), h.$slider.trigger("lazyLoadError", [h, c, d]), h.progressiveLazyLoad());
                      }),
                      (g.src = d))
                    : h.$slider.trigger("allImagesLoaded", [h]);
            }),
            (b.prototype.refresh = function (b) {
                var c,
                    d,
                    e = this;
                (d = e.slideCount - e.options.slidesToShow),
                    !e.options.infinite && e.currentSlide > d && (e.currentSlide = d),
                    e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
                    (c = e.currentSlide),
                    e.destroy(!0),
                    a.extend(e, e.initials, { currentSlide: c }),
                    e.init(),
                    b || e.changeSlide({ data: { message: "index", index: c } }, !1);
            }),
            (b.prototype.registerBreakpoints = function () {
                var b,
                    c,
                    d,
                    e = this,
                    f = e.options.responsive || null;
                if ("array" === a.type(f) && f.length) {
                    e.respondTo = e.options.respondTo || "window";
                    for (b in f)
                        if (((d = e.breakpoints.length - 1), f.hasOwnProperty(b))) {
                            for (c = f[b].breakpoint; d >= 0; ) e.breakpoints[d] && e.breakpoints[d] === c && e.breakpoints.splice(d, 1), d--;
                            e.breakpoints.push(c), (e.breakpointSettings[c] = f[b].settings);
                        }
                    e.breakpoints.sort(function (a, b) {
                        return e.options.mobileFirst ? a - b : b - a;
                    });
                }
            }),
            (b.prototype.reinit = function () {
                var b = this;
                (b.$slides = b.$slideTrack.children(b.options.slide).addClass("slick-slide")),
                    (b.slideCount = b.$slides.length),
                    b.currentSlide >= b.slideCount && 0 !== b.currentSlide && (b.currentSlide = b.currentSlide - b.options.slidesToScroll),
                    b.slideCount <= b.options.slidesToShow && (b.currentSlide = 0),
                    b.registerBreakpoints(),
                    b.setProps(),
                    b.setupInfinite(),
                    b.buildArrows(),
                    b.updateArrows(),
                    b.initArrowEvents(),
                    b.buildDots(),
                    b.updateDots(),
                    b.initDotEvents(),
                    b.cleanUpSlideEvents(),
                    b.initSlideEvents(),
                    b.checkResponsive(!1, !0),
                    b.options.focusOnSelect === !0 && a(b.$slideTrack).children().on("click.slick", b.selectHandler),
                    b.setSlideClasses("number" == typeof b.currentSlide ? b.currentSlide : 0),
                    b.setPosition(),
                    b.focusHandler(),
                    (b.paused = !b.options.autoplay),
                    b.autoPlay(),
                    b.$slider.trigger("reInit", [b]);
            }),
            (b.prototype.resize = function () {
                var b = this;
                a(window).width() !== b.windowWidth &&
                    (clearTimeout(b.windowDelay),
                    (b.windowDelay = window.setTimeout(function () {
                        (b.windowWidth = a(window).width()), b.checkResponsive(), b.unslicked || b.setPosition();
                    }, 50)));
            }),
            (b.prototype.removeSlide = b.prototype.slickRemove = function (a, b, c) {
                var d = this;
                return (
                    "boolean" == typeof a ? ((b = a), (a = b === !0 ? 0 : d.slideCount - 1)) : (a = b === !0 ? --a : a),
                    !(d.slideCount < 1 || a < 0 || a > d.slideCount - 1) &&
                        (d.unload(),
                        c === !0 ? d.$slideTrack.children().remove() : d.$slideTrack.children(this.options.slide).eq(a).remove(),
                        (d.$slides = d.$slideTrack.children(this.options.slide)),
                        d.$slideTrack.children(this.options.slide).detach(),
                        d.$slideTrack.append(d.$slides),
                        (d.$slidesCache = d.$slides),
                        void d.reinit())
                );
            }),
            (b.prototype.setCSS = function (a) {
                var b,
                    c,
                    d = this,
                    e = {};
                d.options.rtl === !0 && (a = -a),
                    (b = "left" == d.positionProp ? Math.ceil(a) + "px" : "0px"),
                    (c = "top" == d.positionProp ? Math.ceil(a) + "px" : "0px"),
                    (e[d.positionProp] = a),
                    d.transformsEnabled === !1
                        ? d.$slideTrack.css(e)
                        : ((e = {}), d.cssTransitions === !1 ? ((e[d.animType] = "translate(" + b + ", " + c + ")"), d.$slideTrack.css(e)) : ((e[d.animType] = "translate3d(" + b + ", " + c + ", 0px)"), d.$slideTrack.css(e)));
            }),
            (b.prototype.setDimensions = function () {
                var a = this;
                a.options.vertical === !1
                    ? a.options.centerMode === !0 && a.$list.css({ padding: "0px " + a.options.centerPadding })
                    : (a.$list.height(a.$slides.first().outerHeight(!0) * a.options.slidesToShow), a.options.centerMode === !0 && a.$list.css({ padding: a.options.centerPadding + " 0px" })),
                    (a.listWidth = a.$list.width()),
                    (a.listHeight = a.$list.height()),
                    a.options.vertical === !1 && a.options.variableWidth === !1
                        ? ((a.slideWidth = Math.ceil(a.listWidth / a.options.slidesToShow)), a.$slideTrack.width(Math.ceil(a.slideWidth * a.$slideTrack.children(".slick-slide").length)))
                        : a.options.variableWidth === !0
                        ? a.$slideTrack.width(5e3 * a.slideCount)
                        : ((a.slideWidth = Math.ceil(a.listWidth)), a.$slideTrack.height(Math.ceil(a.$slides.first().outerHeight(!0) * a.$slideTrack.children(".slick-slide").length)));
                var b = a.$slides.first().outerWidth(!0) - a.$slides.first().width();
                a.options.variableWidth === !1 && a.$slideTrack.children(".slick-slide").width(a.slideWidth - b);
            }),
            (b.prototype.setFade = function () {
                var b,
                    c = this;
                c.$slides.each(function (d, e) {
                    (b = c.slideWidth * d * -1),
                        c.options.rtl === !0 ? a(e).css({ position: "relative", right: b, top: 0, zIndex: c.options.zIndex - 2, opacity: 0 }) : a(e).css({ position: "relative", left: b, top: 0, zIndex: c.options.zIndex - 2, opacity: 0 });
                }),
                    c.$slides.eq(c.currentSlide).css({ zIndex: c.options.zIndex - 1, opacity: 1 });
            }),
            (b.prototype.setHeight = function () {
                var a = this;
                if (1 === a.options.slidesToShow && a.options.adaptiveHeight === !0 && a.options.vertical === !1) {
                    var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
                    a.$list.css("height", b);
                }
            }),
            (b.prototype.setOption = b.prototype.slickSetOption = function () {
                var b,
                    c,
                    d,
                    e,
                    f,
                    g = this,
                    h = !1;
                if (
                    ("object" === a.type(arguments[0])
                        ? ((d = arguments[0]), (h = arguments[1]), (f = "multiple"))
                        : "string" === a.type(arguments[0]) &&
                          ((d = arguments[0]), (e = arguments[1]), (h = arguments[2]), "responsive" === arguments[0] && "array" === a.type(arguments[1]) ? (f = "responsive") : "undefined" != typeof arguments[1] && (f = "single")),
                    "single" === f)
                )
                    g.options[d] = e;
                else if ("multiple" === f)
                    a.each(d, function (a, b) {
                        g.options[a] = b;
                    });
                else if ("responsive" === f)
                    for (c in e)
                        if ("array" !== a.type(g.options.responsive)) g.options.responsive = [e[c]];
                        else {
                            for (b = g.options.responsive.length - 1; b >= 0; ) g.options.responsive[b].breakpoint === e[c].breakpoint && g.options.responsive.splice(b, 1), b--;
                            g.options.responsive.push(e[c]);
                        }
                h && (g.unload(), g.reinit());
            }),
            (b.prototype.setPosition = function () {
                var a = this;
                a.setDimensions(), a.setHeight(), a.options.fade === !1 ? a.setCSS(a.getLeft(a.currentSlide)) : a.setFade(), a.$slider.trigger("setPosition", [a]);
            }),
            (b.prototype.setProps = function () {
                var a = this,
                    b = document.body.style;
                (a.positionProp = a.options.vertical === !0 ? "top" : "left"),
                    "top" === a.positionProp ? a.$slider.addClass("slick-vertical") : a.$slider.removeClass("slick-vertical"),
                    (void 0 === b.WebkitTransition && void 0 === b.MozTransition && void 0 === b.msTransition) || (a.options.useCSS === !0 && (a.cssTransitions = !0)),
                    a.options.fade && ("number" == typeof a.options.zIndex ? a.options.zIndex < 3 && (a.options.zIndex = 3) : (a.options.zIndex = a.defaults.zIndex)),
                    void 0 !== b.OTransform && ((a.animType = "OTransform"), (a.transformType = "-o-transform"), (a.transitionType = "OTransition"), void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)),
                    void 0 !== b.MozTransform &&
                        ((a.animType = "MozTransform"), (a.transformType = "-moz-transform"), (a.transitionType = "MozTransition"), void 0 === b.perspectiveProperty && void 0 === b.MozPerspective && (a.animType = !1)),
                    void 0 !== b.webkitTransform &&
                        ((a.animType = "webkitTransform"), (a.transformType = "-webkit-transform"), (a.transitionType = "webkitTransition"), void 0 === b.perspectiveProperty && void 0 === b.webkitPerspective && (a.animType = !1)),
                    void 0 !== b.msTransform && ((a.animType = "msTransform"), (a.transformType = "-ms-transform"), (a.transitionType = "msTransition"), void 0 === b.msTransform && (a.animType = !1)),
                    void 0 !== b.transform && a.animType !== !1 && ((a.animType = "transform"), (a.transformType = "transform"), (a.transitionType = "transition")),
                    (a.transformsEnabled = a.options.useTransform && null !== a.animType && a.animType !== !1);
            }),
            (b.prototype.setSlideClasses = function (a) {
                var b,
                    c,
                    d,
                    e,
                    f = this;
                if (((c = f.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true")), f.$slides.eq(a).addClass("slick-current"), f.options.centerMode === !0)) {
                    var g = f.options.slidesToShow % 2 === 0 ? 1 : 0;
                    (b = Math.floor(f.options.slidesToShow / 2)),
                        f.options.infinite === !0 &&
                            (a >= b && a <= f.slideCount - 1 - b
                                ? f.$slides
                                      .slice(a - b + g, a + b + 1)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")
                                : ((d = f.options.slidesToShow + a),
                                  c
                                      .slice(d - b + 1 + g, d + b + 2)
                                      .addClass("slick-active")
                                      .attr("aria-hidden", "false")),
                            0 === a ? c.eq(c.length - 1 - f.options.slidesToShow).addClass("slick-center") : a === f.slideCount - 1 && c.eq(f.options.slidesToShow).addClass("slick-center")),
                        f.$slides.eq(a).addClass("slick-center");
                } else
                    a >= 0 && a <= f.slideCount - f.options.slidesToShow
                        ? f.$slides
                              .slice(a, a + f.options.slidesToShow)
                              .addClass("slick-active")
                              .attr("aria-hidden", "false")
                        : c.length <= f.options.slidesToShow
                        ? c.addClass("slick-active").attr("aria-hidden", "false")
                        : ((e = f.slideCount % f.options.slidesToShow),
                          (d = f.options.infinite === !0 ? f.options.slidesToShow + a : a),
                          f.options.slidesToShow == f.options.slidesToScroll && f.slideCount - a < f.options.slidesToShow
                              ? c
                                    .slice(d - (f.options.slidesToShow - e), d + e)
                                    .addClass("slick-active")
                                    .attr("aria-hidden", "false")
                              : c
                                    .slice(d, d + f.options.slidesToShow)
                                    .addClass("slick-active")
                                    .attr("aria-hidden", "false"));
                ("ondemand" !== f.options.lazyLoad && "anticipated" !== f.options.lazyLoad) || f.lazyLoad();
            }),
            (b.prototype.setupInfinite = function () {
                var b,
                    c,
                    d,
                    e = this;
                if ((e.options.fade === !0 && (e.options.centerMode = !1), e.options.infinite === !0 && e.options.fade === !1 && ((c = null), e.slideCount > e.options.slidesToShow))) {
                    for (d = e.options.centerMode === !0 ? e.options.slidesToShow + 1 : e.options.slidesToShow, b = e.slideCount; b > e.slideCount - d; b -= 1)
                        (c = b - 1),
                            a(e.$slides[c])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", c - e.slideCount)
                                .prependTo(e.$slideTrack)
                                .addClass("slick-cloned");
                    for (b = 0; b < d + e.slideCount; b += 1)
                        (c = b),
                            a(e.$slides[c])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", c + e.slideCount)
                                .appendTo(e.$slideTrack)
                                .addClass("slick-cloned");
                    e.$slideTrack
                        .find(".slick-cloned")
                        .find("[id]")
                        .each(function () {
                            a(this).attr("id", "");
                        });
                }
            }),
            (b.prototype.interrupt = function (a) {
                var b = this;
                a || b.autoPlay(), (b.interrupted = a);
            }),
            (b.prototype.selectHandler = function (b) {
                var c = this,
                    d = a(b.target).is(".slick-slide") ? a(b.target) : a(b.target).parents(".slick-slide"),
                    e = parseInt(d.attr("data-slick-index"));
                return e || (e = 0), c.slideCount <= c.options.slidesToShow ? void c.slideHandler(e, !1, !0) : void c.slideHandler(e);
            }),
            (b.prototype.slideHandler = function (a, b, c) {
                var d,
                    e,
                    f,
                    g,
                    h,
                    i = null,
                    j = this;
                if (((b = b || !1), !((j.animating === !0 && j.options.waitForAnimate === !0) || (j.options.fade === !0 && j.currentSlide === a))))
                    return (
                        b === !1 && j.asNavFor(a),
                        (d = a),
                        (i = j.getLeft(d)),
                        (g = j.getLeft(j.currentSlide)),
                        (j.currentLeft = null === j.swipeLeft ? g : j.swipeLeft),
                        j.options.infinite === !1 && j.options.centerMode === !1 && (a < 0 || a > j.getDotCount() * j.options.slidesToScroll)
                            ? void (
                                  j.options.fade === !1 &&
                                  ((d = j.currentSlide),
                                  c !== !0
                                      ? j.animateSlide(g, function () {
                                            j.postSlide(d);
                                        })
                                      : j.postSlide(d))
                              )
                            : j.options.infinite === !1 && j.options.centerMode === !0 && (a < 0 || a > j.slideCount - j.options.slidesToScroll)
                            ? void (
                                  j.options.fade === !1 &&
                                  ((d = j.currentSlide),
                                  c !== !0
                                      ? j.animateSlide(g, function () {
                                            j.postSlide(d);
                                        })
                                      : j.postSlide(d))
                              )
                            : (j.options.autoplay && clearInterval(j.autoPlayTimer),
                              (e =
                                  d < 0
                                      ? j.slideCount % j.options.slidesToScroll !== 0
                                          ? j.slideCount - (j.slideCount % j.options.slidesToScroll)
                                          : j.slideCount + d
                                      : d >= j.slideCount
                                      ? j.slideCount % j.options.slidesToScroll !== 0
                                          ? 0
                                          : d - j.slideCount
                                      : d),
                              (j.animating = !0),
                              j.$slider.trigger("beforeChange", [j, j.currentSlide, e]),
                              (f = j.currentSlide),
                              (j.currentSlide = e),
                              j.setSlideClasses(j.currentSlide),
                              j.options.asNavFor && ((h = j.getNavTarget()), (h = h.slick("getSlick")), h.slideCount <= h.options.slidesToShow && h.setSlideClasses(j.currentSlide)),
                              j.updateDots(),
                              j.updateArrows(),
                              j.options.fade === !0
                                  ? (c !== !0
                                        ? (j.fadeSlideOut(f),
                                          j.fadeSlide(e, function () {
                                              j.postSlide(e);
                                          }))
                                        : j.postSlide(e),
                                    void j.animateHeight())
                                  : void (c !== !0
                                        ? j.animateSlide(i, function () {
                                              j.postSlide(e);
                                          })
                                        : j.postSlide(e)))
                    );
            }),
            (b.prototype.startLoad = function () {
                var a = this;
                a.options.arrows === !0 && a.slideCount > a.options.slidesToShow && (a.$prevArrow.hide(), a.$nextArrow.hide()),
                    a.options.dots === !0 && a.slideCount > a.options.slidesToShow && a.$dots.hide(),
                    a.$slider.addClass("slick-loading");
            }),
            (b.prototype.swipeDirection = function () {
                var a,
                    b,
                    c,
                    d,
                    e = this;
                return (
                    (a = e.touchObject.startX - e.touchObject.curX),
                    (b = e.touchObject.startY - e.touchObject.curY),
                    (c = Math.atan2(b, a)),
                    (d = Math.round((180 * c) / Math.PI)),
                    d < 0 && (d = 360 - Math.abs(d)),
                    d <= 45 && d >= 0
                        ? e.options.rtl === !1
                            ? "left"
                            : "right"
                        : d <= 360 && d >= 315
                        ? e.options.rtl === !1
                            ? "left"
                            : "right"
                        : d >= 135 && d <= 225
                        ? e.options.rtl === !1
                            ? "right"
                            : "left"
                        : e.options.verticalSwiping === !0
                        ? d >= 35 && d <= 135
                            ? "down"
                            : "up"
                        : "vertical"
                );
            }),
            (b.prototype.swipeEnd = function (a) {
                var b,
                    c,
                    d = this;
                if (((d.dragging = !1), (d.swiping = !1), d.scrolling)) return (d.scrolling = !1), !1;
                if (((d.interrupted = !1), (d.shouldClick = !(d.touchObject.swipeLength > 10)), void 0 === d.touchObject.curX)) return !1;
                if ((d.touchObject.edgeHit === !0 && d.$slider.trigger("edge", [d, d.swipeDirection()]), d.touchObject.swipeLength >= d.touchObject.minSwipe)) {
                    switch ((c = d.swipeDirection())) {
                        case "left":
                        case "down":
                            (b = d.options.swipeToSlide ? d.checkNavigable(d.currentSlide + d.getSlideCount()) : d.currentSlide + d.getSlideCount()), (d.currentDirection = 0);
                            break;
                        case "right":
                        case "up":
                            (b = d.options.swipeToSlide ? d.checkNavigable(d.currentSlide - d.getSlideCount()) : d.currentSlide - d.getSlideCount()), (d.currentDirection = 1);
                    }
                    "vertical" != c && (d.slideHandler(b), (d.touchObject = {}), d.$slider.trigger("swipe", [d, c]));
                } else d.touchObject.startX !== d.touchObject.curX && (d.slideHandler(d.currentSlide), (d.touchObject = {}));
            }),
            (b.prototype.swipeHandler = function (a) {
                var b = this;
                if (!(b.options.swipe === !1 || ("ontouchend" in document && b.options.swipe === !1) || (b.options.draggable === !1 && a.type.indexOf("mouse") !== -1)))
                    switch (
                        ((b.touchObject.fingerCount = a.originalEvent && void 0 !== a.originalEvent.touches ? a.originalEvent.touches.length : 1),
                        (b.touchObject.minSwipe = b.listWidth / b.options.touchThreshold),
                        b.options.verticalSwiping === !0 && (b.touchObject.minSwipe = b.listHeight / b.options.touchThreshold),
                        a.data.action)
                    ) {
                        case "start":
                            b.swipeStart(a);
                            break;
                        case "move":
                            b.swipeMove(a);
                            break;
                        case "end":
                            b.swipeEnd(a);
                    }
            }),
            (b.prototype.swipeMove = function (a) {
                var b,
                    c,
                    d,
                    e,
                    f,
                    g,
                    h = this;
                return (
                    (f = void 0 !== a.originalEvent ? a.originalEvent.touches : null),
                    !(!h.dragging || h.scrolling || (f && 1 !== f.length)) &&
                        ((b = h.getLeft(h.currentSlide)),
                        (h.touchObject.curX = void 0 !== f ? f[0].pageX : a.clientX),
                        (h.touchObject.curY = void 0 !== f ? f[0].pageY : a.clientY),
                        (h.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(h.touchObject.curX - h.touchObject.startX, 2)))),
                        (g = Math.round(Math.sqrt(Math.pow(h.touchObject.curY - h.touchObject.startY, 2)))),
                        !h.options.verticalSwiping && !h.swiping && g > 4
                            ? ((h.scrolling = !0), !1)
                            : (h.options.verticalSwiping === !0 && (h.touchObject.swipeLength = g),
                              (c = h.swipeDirection()),
                              void 0 !== a.originalEvent && h.touchObject.swipeLength > 4 && ((h.swiping = !0), a.preventDefault()),
                              (e = (h.options.rtl === !1 ? 1 : -1) * (h.touchObject.curX > h.touchObject.startX ? 1 : -1)),
                              h.options.verticalSwiping === !0 && (e = h.touchObject.curY > h.touchObject.startY ? 1 : -1),
                              (d = h.touchObject.swipeLength),
                              (h.touchObject.edgeHit = !1),
                              h.options.infinite === !1 &&
                                  ((0 === h.currentSlide && "right" === c) || (h.currentSlide >= h.getDotCount() && "left" === c)) &&
                                  ((d = h.touchObject.swipeLength * h.options.edgeFriction), (h.touchObject.edgeHit = !0)),
                              h.options.vertical === !1 ? (h.swipeLeft = b + d * e) : (h.swipeLeft = b + d * (h.$list.height() / h.listWidth) * e),
                              h.options.verticalSwiping === !0 && (h.swipeLeft = b + d * e),
                              h.options.fade !== !0 && h.options.touchMove !== !1 && (h.animating === !0 ? ((h.swipeLeft = null), !1) : void h.setCSS(h.swipeLeft))))
                );
            }),
            (b.prototype.swipeStart = function (a) {
                var b,
                    c = this;
                return (
                    (c.interrupted = !0),
                    1 !== c.touchObject.fingerCount || c.slideCount <= c.options.slidesToShow
                        ? ((c.touchObject = {}), !1)
                        : (void 0 !== a.originalEvent && void 0 !== a.originalEvent.touches && (b = a.originalEvent.touches[0]),
                          (c.touchObject.startX = c.touchObject.curX = void 0 !== b ? b.pageX : a.clientX),
                          (c.touchObject.startY = c.touchObject.curY = void 0 !== b ? b.pageY : a.clientY),
                          void (c.dragging = !0))
                );
            }),
            (b.prototype.unfilterSlides = b.prototype.slickUnfilter = function () {
                var a = this;
                null !== a.$slidesCache && (a.unload(), a.$slideTrack.children(this.options.slide).detach(), a.$slidesCache.appendTo(a.$slideTrack), a.reinit());
            }),
            (b.prototype.unload = function () {
                var b = this;
                a(".slick-cloned", b.$slider).remove(),
                    b.$dots && b.$dots.remove(),
                    b.$prevArrow && b.htmlExpr.test(b.options.prevArrow) && b.$prevArrow.remove(),
                    b.$nextArrow && b.htmlExpr.test(b.options.nextArrow) && b.$nextArrow.remove(),
                    b.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
            }),
            (b.prototype.unslick = function (a) {
                var b = this;
                b.$slider.trigger("unslick", [b, a]), b.destroy();
            }),
            (b.prototype.updateArrows = function () {
                var a,
                    b = this;
                (a = Math.floor(b.options.slidesToShow / 2)),
                    b.options.arrows === !0 &&
                        b.slideCount > b.options.slidesToShow &&
                        !b.options.infinite &&
                        (b.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        b.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        0 === b.currentSlide
                            ? (b.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), b.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                            : b.currentSlide >= b.slideCount - b.options.slidesToShow && b.options.centerMode === !1
                            ? (b.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), b.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                            : b.currentSlide >= b.slideCount - 1 &&
                              b.options.centerMode === !0 &&
                              (b.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), b.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
            }),
            (b.prototype.updateDots = function () {
                var a = this;
                null !== a.$dots &&
                    (a.$dots.find("li").removeClass("slick-active").end(),
                    a.$dots
                        .find("li")
                        .eq(Math.floor(a.currentSlide / a.options.slidesToScroll))
                        .addClass("slick-active"));
            }),
            (b.prototype.visibility = function () {
                var a = this;
                a.options.autoplay && (document[a.hidden] ? (a.interrupted = !0) : (a.interrupted = !1));
            }),
            (a.fn.slick = function () {
                var a,
                    c,
                    d = this,
                    e = arguments[0],
                    f = Array.prototype.slice.call(arguments, 1),
                    g = d.length;
                for (a = 0; a < g; a++) if (("object" == typeof e || "undefined" == typeof e ? (d[a].slick = new b(d[a], e)) : (c = d[a].slick[e].apply(d[a].slick, f)), "undefined" != typeof c)) return c;
                return d;
            });
    });
var $window = $(window),
    $document = $(document),
    $body = $("body"),
    $html = $("html"),
    $navBar = $("#desktop-nav"),
    pnpHelper = {},
    navHeights = { xs: 57, sm: 65, md: 73, lg: 81, xlg: 96 };
(pnpHelper.bootstrap = {
    xs: 768,
    md: 992,
    lg: 1200,
    xlg: 1500,
    ipadLanscape: 1024,
    ipadPortrait: 768,
    isXs: function () {
        return $window.outerWidth() < pnpHelper.bootstrap.xs;
    },
    isSm: function () {
        return $window.outerWidth() >= pnpHelper.bootstrap.xs;
    },
    isMd: function () {
        return $window.outerWidth() >= pnpHelper.bootstrap.md;
    },
    isLg: function () {
        return $window.outerWidth() >= pnpHelper.bootstrap.lg;
    },
    isXlg: function () {
        return $window.outerWidth() >= pnpHelper.bootstrap.xlg;
    },
}),
    (pnpHelper.getNavHeight = function () {
        return pnpHelper.bootstrap.isXlg() ? navHeights.xlg : pnpHelper.bootstrap.isLg() ? navHeights.lg : pnpHelper.bootstrap.isMd() ? navHeights.md : pnpHelper.bootstrap.isSm() ? navHeights.sm : 0;
    }),
    (pnpHelper.onResizeFinished = function (a, b) {
        var c;
        $window.on("resize", function (b) {
            clearTimeout(c), (c = setTimeout(a, 50));
        }),
            b && a.call();
    }),
    (pnpHelper.scroll = {
        scrollPast: function (a, b) {
            if (b) var c = b;
            else var c = $(a);
            var d = c.offset().top + c.outerHeight(!0) - pnpHelper.getNavHeight();
            pnpHelper.scroll.doScroll(d);
        },
        scrollTo: function (a, b, c) {
            var d = $(a).offset().top;
            (d -= pnpHelper.getNavHeight()), c && (d -= c), pnpHelper.scroll.doScroll(d, b);
        },
        doScroll: function (a, b) {
            b || (b = null), a && $("html,body").animate({ scrollTop: a }, 500, b);
        },
    }),
    (pnpHelper.preloadImage = function (a) {
        Log.info("Preloading image: " + a);
        var b = new Image();
        b.src = a;
    }),
    (pnpHelper.dependencyCheck = {
        fixTo: "fixTo",
        viewportChecker: "viewportChecker",
        jqueryCookie: "jqueryCookie",
        slickSlider: "slickSlider",
        hoverIntent: "hoverIntent",
        bootstrapModal: "bootstrapModal",
        fullPageJs: "fullPageJs",
        requireDependencies: function (a, b) {
            function c(b) {
                console.error("MISSING DEPENDENCY: The component '" + a + "' requires the JS library '" + b + "'. Please add it to the project."), (d = !0);
            }
            if (b && b.length) {
                var d = !1;
                for (var e in b) {
                    var f = b[e];
                    f === pnpHelper.dependencyCheck.fixTo
                        ? window.fixto || c(f)
                        : f === pnpHelper.dependencyCheck.viewportChecker
                        ? $.fn.viewportChecker || c(f)
                        : f === pnpHelper.dependencyCheck.jqueryCookie
                        ? $.cookie || c(f)
                        : f === pnpHelper.dependencyCheck.slickSlider
                        ? $.fn.slick || c(f)
                        : f === pnpHelper.dependencyCheck.hoverIntent
                        ? $.fn.hoverIntent || c(f)
                        : f === pnpHelper.dependencyCheck.bootstrapModal
                        ? $.fn.modal || c(f)
                        : f === pnpHelper.dependencyCheck.fullPageJs
                        ? $.fn.fullpage || c(f)
                        : console.warn("A check for dependency '" + f + "' was not found.");
                }
                return d;
            }
            return console.warn("No dependencies passed to dependencyCheck.requireDependencies() function"), !1;
        },
    }),
    (pnpHelper.browser = { isFirefox: !1, isChrome: !1, isSafari: !1, isIOS: !1, isIE: !1, version: { ie: !1, ios: !1 } }),
    doBrowserCheck(!1),
    (function () {
        var a = function () {};
        window.console || (window.console = { log: a, info: a, warn: a, debug: a, error: a });
    })();
var touch = Modernizr.prefixed("MaxTouchPoints", navigator);
if (
    (!Modernizr.touch && (touch || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0)) && ((Modernizr.touch = !0), $html.addClass("touch").removeClass("no-touch")),
    (pnpHelper.ajaxNavigation = function () {
        var a = [];
        this.loadPage = function (b, c, d) {
            function e(a) {
                c &&
                    (a
                        ? (window.history.pushState && window.history.pushState(a, a.title, b),
                          $("#content > article").height($("#content > article").outerHeight()),
                          $("#content > article").html(a.html),
                          $("title").text(a.title),
                          $("#content > article").height("auto"),
                          $.pnp.initPage())
                        : console.error("A valid page cannot be found for URL " + thisSlideUrl, a)),
                    d && d(a);
            }
            a[b]
                ? (console.log("Returning page from cache"), e(a[b]))
                : (console.log("Returning page"),
                  $.get(b, function (c) {
                      var d = $(c).find("#content > article").html(),
                          f = $(c).filter("title").text();
                      (a[b] = { html: d, title: f }), e(a[b]);
                  }));
        };
    }),
    (pnpHelper.modal = {
        open: function (a) {
            var b = 0,
                c = 0;
            $(a)
                .on("shown.bs.modal", function (b) {
                    $.pnp.initPage(), wpcf7.initForm($(a).find(".wpcf7 > form"));
                })
                .on("show.bs.modal", function () {
                    (b = $("body").css("top")), (c = $("body").scrollTop()), $body.css({ top: -c });
                })
                .on("hidden.bs.modal", function () {
                    $body.css({ top: b }), $body.scrollTop(c);
                })
                .modal();
        },
    }),
    (function (a) {
        (a.pnp = {}),
            (a.pnp.initPlaceholderShim = function () {
                a.placeholder.shim();
            }),
            (a.pnp.initSelectric = function () {
                a('select:not(".-unstyled")').selectric({
                    onChange: function () {
                        0 === a(this).val().length ? (a(this).addClass("placeholder"), a(this).selectric("refresh")) : (a(this).removeClass("placeholder"), a(this).selectric("refresh"));
                    },
                    onClose: function () {
                        "select_required" === a(this).attr("data-validation") &&
                            (0 === a(this).val().length
                                ? (a(this).closest(".selectric-wrapper").find(".selectric").addClass("error").removeClass("valid"),
                                  a(this).closest(".form-group").hasClass("has-error") || a(this).closest(".form-group").addClass("has-error").append('<span class="help-block form-error">This is a required field</span>'))
                                : (a(this).closest(".selectric-wrapper").find(".selectric").addClass("valid").removeClass("error"), a(this).closest(".has-error").removeClass("has-error").find(".form-error").remove()));
                    },
                });
            }),
            (a.pnp.initDatePicker = function () {
                a(".datepicker").each(function () {
                    var b = new Date();
                    b.setDate(b.getDate() + 1), "future" == a(this).data("pnp-pikaday-config") ? new Pikaday({ field: a(this)[0], format: "DD/MM/YYYY", minDate: b }) : new Pikaday({ field: a(this)[0], format: "DD/MM/YYYY" });
                });
            }),
            (a.pnp.initFormValidation = function () {
                a.validate({
                    modules: "uk, date, security",
                    scrollToTopOnError: !1,
                    onValidate: function (b) {
                        var c = [];
                        return (
                            b.find('select[data-validation="pnp_select_required"]:hidden').each(function () {
                                0 === a(this).val().length
                                    ? (c.push({ element: a(this), message: "This is a required field" }), a(this).closest(".selectric-wrapper").find(".selectric").addClass("error").removeClass("valid"))
                                    : a(this).closest(".selectric-wrapper").find(".selectric").removeClass("error").addClass("valid");
                            }),
                            0 === c.length || c
                        );
                    },
                }),
                    $document.on("click", "[data-pnp-validate-postcode]", function () {
                        var b = a(this);
                        return (
                            a(a(this).data("pnp-validate-postcode")).validate(function (c, d) {
                                c && a(b.data("pnp-show-postcode")).slideDown();
                            }),
                            !1
                        );
                    });
            }),
            (a.pnp.initFixto = function () {
                a("[data-pnp-fixto], [data-pnp-fixto-parent]").length &&
                    (a("[data-pnp-fixto]").fixTo("body", { top: pnpHelper.getNavHeight() }),
                    a("[data-pnp-fixto-parent]").each(function () {
                        a(this).fixTo(a(this).parent(), {});
                    }));
            }),
            (a.pnp.initDropdowns = function () {
                a(".dropdown").dropdown();
            }),
            (a.pnp.initScrollHijack = function () {
                if ($body.hasClass("page-template-tpl-one-page-scroll-php")) {
                    if (pnpHelper.dependencyCheck.requireDependencies("Scroll Hijack", [pnpHelper.dependencyCheck.fullPageJs])) return;
                    pnpHelper.bootstrap.isSm() &&
                        a(".fullpage-section").length > 1 &&
                        a("#content > article").fullpage({
                            scrollBar: !0,
                            scrollingSpeed: 1e3,
                            navigation: !0,
                            responsiveWidth: 768,
                            navigationPosition: "right",
                            fixedElements: "#page-header",
                            fadingEffect: !0,
                            fadingEffectKey: "_",
                            sectionSelector: ".fullpage-section",
                            slideSelector: ".fullpage-slide",
                        });
                }
            });
        var b = { 37: 1, 38: 1, 39: 1, 40: 1 };
        (a.pnp.preventDefault = function (a) {
            (a = a || window.event), a.preventDefault && a.preventDefault(), (a.returnValue = !1);
        }),
            (a.pnp.preventDefaultForScrollKeys = function (c) {
                if (b[c.keyCode]) return a.pnp.preventDefault(c), !1;
            }),
            (a.pnp.disableScroll = function () {
                window.addEventListener && window.addEventListener("DOMMouseScroll", a.pnp.preventDefault, !1),
                    (window.onwheel = a.pnp.preventDefault),
                    (window.onmousewheel = document.onmousewheel = a.pnp.preventDefault),
                    (window.ontouchmove = a.pnp.preventDefault),
                    (document.onkeydown = a.pnp.preventDefaultForScrollKeys);
            }),
            (a.pnp.enableScroll = function () {
                window.removeEventListener && window.removeEventListener("DOMMouseScroll", a.pnp.preventDefault, !1),
                    (window.onmousewheel = document.onmousewheel = null),
                    (window.onwheel = null),
                    (window.ontouchmove = null),
                    (document.onkeydown = null);
            }),
            (a.pnp.initHeaderBanner = function () {
                var b = a(".component-header-banner");
                b.length &&
                    b.each(function () {
                        a(".slider-nav").css("display", "none");
                        var b = a(this);
                        b.find(".caption").css({ display: "block" });
                        var c = a(this).find("h4").text();
                        a(".project>.case").html(c),
                            b.find(".caption button").append('<div class="left">'),
                            b.find(".caption button").append('<div class="top">'),
                            b.find(".caption button").append('<div class="right">'),
                            b.find(".caption button").append('<div class="bottom">'),
                            TweenMax.from(".caption .inner .subtitle", 1, { autoAlpha: 0, delay: 0.4, ease: Cubic.easeOut }),
                            TweenMax.from(".caption .inner h4", 2, { autoAlpha: 0, delay: 0.5, ease: Cubic.easeOut }),
                            TweenMax.from(".shader", 1, { autoAlpha: 0, delay: 0.5, ease: Cubic.easeOut });
                        var d = a(this).find(".background"),
                            e = d.attr("data-video"),
                            f = d.attr("data-poster");
                        if (
                            ("" !== e &&
                                void 0 !== e &&
                                a(this)
                                    .find(".background")
                                    .vide({ mp4: e, poster: f }, { volume: 0, playbackRate: 1, muted: !0, loop: !0, autoplay: !1, position: "0% 50%", posterType: "jpg", resizing: !0, bgColor: "#000000", className: "" }),
                            b.find("p").length)
                        ) {
                            var g = new SplitText(b.find("p"), { type: "chars,words,lines", position: "absolute" });
                            b.find(".caption button").css("visibility", "hidden"),
                                b.find(".caption button").removeClass("in"),
                                TweenMax.staggerFrom(
                                    g.words,
                                    2,
                                    {
                                        autoAlpha: 0,
                                        ease: Cubic.easeOut,
                                        delay: 1,
                                        onStart: function () {
                                            void 0 !== b.find(".background").data("vide") && b.find(".background").data("vide").getVideoObject().play();
                                        },
                                        onComplete: function () {
                                            b.find(".caption button, .caption button span").css("visibility", "visible").addClass("in");
                                        },
                                    },
                                    0.05
                                ),
                                a(".caption button").click(function () {
                                    TweenMax.to(window, 2, { scrollTo: { y: window.headHeight, autoKill: !1 }, ease: Cubic.easeInOut });
                                });
                        } else
                            setTimeout(function () {
                                void 0 !== b.find(".background").data("vide") && b.find(".background").data("vide").getVideoObject().play();
                            }, 300);
                    });
            }),
            (a.pnp.initStackedLayers = function () {
                var b = a(".component-stacked-layers");
                b.length &&
                    b.each(function () {
                        a(this)
                            .find(".stacked")
                            .each(function (b) {
                                a(this).fixTo(a(this).parent(), {});
                            });
                    });
            }),
            (a.pnp.triggeredFromFooter = !1),
            (a.pnp.currentTarget = ""),
            (a.pnp.initColouredText = function () {
                var b = a(".component-coloured-text");
                b.length &&
                    b.each(function () {
                        var b = a(this);
                        b.hasClass("checked") ||
                            (b.viewportChecker({
                                callbackFunction: function (a, c) {
                                    var d = b.attr("data-txt-colour"),
                                        e = b.attr("data-bg-colour");
                                    TweenMax.to(b, 2, { backgroundColor: e, delay: 0.5, ease: Cubic.easeInOut }), TweenMax.to(b.find(".inner"), 2, { color: d, delay: 0.5, ease: Cubic.easeInOut });
                                },
                            }),
                            b.addClass("checked"));
                    });
            }),
            (a.pnp.initScrollMagic = function () {
                function b() {
                    var b = a(".slider-nav"),
                        d = new TimelineMax();
                    d.add(TweenMax.to(b.find(".caption"), 2, { alpha: 0, y: -10, ease: Linear.easeNone }), 0);
                    new ScrollMagic.Scene({ triggerHook: "onLeave", duration: 0.6 * b.height() })
                        .setTween(d)
                        .addTo(c)
                        .on("enter leave", function (b) {
                            "enter" == b.type
                                ? (TweenMax.to(a(".nav-container .project"), 0.5, { alpha: 0 }),
                                  a(".nav-container").hasClass("white") || a(".nav-container").addClass("white"),
                                  a(".nav-container").hasClass("black") && a(".nav-container").removeClass("black"))
                                : TweenMax.to(a(".nav-container .project"), 0.5, { alpha: 1 });
                        });
                }
                (window.controller = new ScrollMagic.Controller()), (window.scenes = []);
                var c = window.controller,
                    d = a(".layout").length - 1;
                a(".layout").each(function (b) {
                    function e(b) {
                        if (a(window).width() > 767)
                            switch (f.attr("data-header")) {
                                case "white":
                                    a(".nav-container").hasClass("white") || a(".nav-container").addClass("white"), a(".nav-container").hasClass("black") && a(".nav-container").removeClass("black");
                                    break;
                                case "black":
                                    a(".nav-container").hasClass("white") && a(".nav-container").removeClass("white"), a(".nav-container").hasClass("black") || a(".nav-container").addClass("black");
                            }
                    }
                    var f = a(this),
                        g = "mm-" + b,
                        h = f.find(".component"),
                        i = !1;
                    f.attr("id", g),
                        b === d && f.addClass("last-layout"),
                        h.each(function (d) {
                            var h = a(this).attr("class").split(" ")[1],
                                j = a(this),
                                k = new ScrollMagic.Scene({ triggerHook: "onLeave", triggerElement: "#" + g, duration: f.height() }).addTo(c).on("enter leave", function (a) {
                                    e(a.type);
                                });
                            switch ((i && k.addIndicators({ name: "layout-" + b }), window.scenes.push(k), h)) {
                                case "slider-nav":
                                    var l = new TimelineMax();
                                    l.add(TweenMax.to(f.find(".caption"), 2, { alpha: 0, y: -10, ease: Linear.easeNone }), 0);
                                    new ScrollMagic.Scene({ triggerHook: "onLeave", triggerElement: "#" + g, duration: 0.6 * f.height() })
                                        .setTween(l)
                                        .addTo(c)
                                        .on("enter leave", function (b) {
                                            "enter" == b.type ? TweenMax.to(a(".nav-container .project"), 0.5, { alpha: 0 }) : TweenMax.to(a(".nav-container .project"), 0.5, { alpha: 1 });
                                        });
                                    break;
                                case "component-header-banner":
                                    var l = new TimelineMax();
                                    l.add(TweenMax.to(f.find(".caption"), 2, { alpha: 0, y: -10, ease: Linear.easeNone }), 0);
                                    new ScrollMagic.Scene({ triggerHook: "onLeave", triggerElement: "#" + g, duration: 0.6 * f.height() })
                                        .setTween(l)
                                        .addTo(c)
                                        .on("enter leave", function (b) {
                                            "enter" == b.type ? TweenMax.to(a(".nav-container .project"), 0.5, { alpha: 0 }) : TweenMax.to(a(".nav-container .project"), 0.5, { alpha: 1 });
                                        });
                                    break;
                                case "component-full-bleed-image":
                                    var l = new TimelineMax(),
                                        m = "1" === j.attr("data-parallax");
                                    "reveal" === j.attr("data-transition")
                                        ? (l.add(TweenMax.fromTo(f.find(".image-mask .left, .image-mask .right"), 2, { width: "40%", ease: Linear.easeNone }, { width: 0 }), 0),
                                          m && l.add(TweenMax.from(f.find(".image-container"), 2, { y: "-20%", ease: Linear.easeNone }), 0))
                                        : (l.add(TweenMax.from(f.find(".image-mask"), 2, { x: "-30%", ease: Linear.easeNone }), 0),
                                          m
                                              ? l.add(TweenMax.from(f.find(".image-container"), 2, { x: "30%", y: "-20%", ease: Linear.easeNone }), 0)
                                              : l.add(TweenMax.from(f.find(".image-container"), 2, { x: "30%", ease: Linear.easeNone }), 0));
                                    new ScrollMagic.Scene({ triggerHook: "onEnter", triggerElement: "#" + g, duration: f.height() }).setTween(l).addTo(c);
                                    break;
                                case "component-parallax-image":
                                    var l = new TimelineMax();
                                    l.add(TweenMax.from(a(this).find(".image"), 2, { y: "-20%", ease: Linear.easeNone, force3D: !0 }), 0);
                                    new ScrollMagic.Scene({ triggerHook: "onEnter", triggerElement: "#" + g, duration: "200%" }).setTween(l).addTo(c);
                                    break;
                                case "component-coloured-text":
                                    if (j.hasClass("lined")) {
                                        var l = new TimelineMax();
                                        l.add(TweenMax.from(j.find(".line"), 1, { delay: 1, scaleY: 0, transformOrigin: "top left", ease: Linear.easeNone, force3D: "auto" }), 0);
                                        new ScrollMagic.Scene({ triggerHook: "onEnter", triggerElement: "#" + g, duration: f.height() }).setTween(l).addTo(c);
                                    }
                                    break;
                                case "component-process":
                                    var l = new TimelineMax({ delay: 0 });
                                    j.find(".steps>li").each(function (b) {
                                        var c = a(this);
                                        c.attr("id", "step-" + b),
                                            l.add(TweenMax.to(c.find(".number"), 1, { autoAlpha: 0.4, ease: Cubic.easeOut })),
                                            c.find(".section-title").length && l.add(TweenMax.to(c.find(".section-title"), 1, { autoAlpha: 1, x: 0, ease: Cubic.easeOut })),
                                            l
                                                .add(TweenMax.from(c.find(".line"), 1, { scaleY: 0, transformOrigin: "top left", ease: Linear.easeNone, force3D: "auto" }))
                                                .add(TweenMax.to(c.find(".title"), 1, { autoAlpha: 0.8, x: 0, ease: Cubic.easeOut }), "-=0.5")
                                                .add(TweenMax.to(c.find(".description"), 1, { autoAlpha: 0.7, x: 0, ease: Cubic.easeOut }), "-=0.5");
                                    });
                                    new ScrollMagic.Scene({ triggerHook: 0.75, triggerElement: "#" + g, duration: f.height() }).setTween(l).addTo(c);
                            }
                        });
                }),
                    b();
            }),
            (a.pnp.initViewportChecker = function () {
                if (!Modernizr.touch) {
                    if (!a.fn.viewportChecker) return void console.error("MISSING DEPENDANCY: The component 'animate-on-scroll' requires the library 'jquery-viewport-checker'. Please update packages.json to include this library.");
                    a("[data-pnp-animation-delay]").each(function () {
                        a(this).css("animation-delay", a(this).data("pnp-animation-delay"));
                    }),
                        a("[data-pnp-animation-duration]").each(function () {
                            a(this).css("animation-duration", a(this).data("pnp-animation-duration"));
                        }),
                        a("[data-pnp-animate]").each(function () {
                            a(this)
                                .addClass("aos-transparent")
                                .viewportChecker({ classToAdd: "aos-not-transparent animated " + a(this).data("pnp-animate"), offset: "10%", invertBottomOffset: !0 });
                        });
                }
            }),
            (a.pnp.initZoomhandler = function () {
                var a = (window.outerWidth - 8) / window.innerWidth,
                    b = null;
                b = a >= 0.46 && a <= 0.54 ? "-4" : a <= 0.64 ? "-3" : a <= 0.76 ? "-2" : a <= 0.92 ? "-1" : a <= 1.1 ? "0" : a <= 1.32 ? "1" : a <= 1.58 ? "2" : a <= 1.9 ? "3" : a <= 2.28 ? "4" : a <= 2.7 ? "5" : "unknown";
            }),
            (a.pnp.responsiveImages = function () {
                var b = a(window).width() < 768;
                a(".background").each(function () {
                    var c = a(this),
                        d = c.attr("data-mobile");
                    b && void 0 !== d && c.css("background-image", "url(" + d + ")");
                });
            }),
            (a.pnp.initSmoothstate = function () {
                var b = a("#content");
                b.wrapInner('<div class="old-content">'),
                    a(".smoothstate").length &&
                        b.smoothState({
                            debug: !0,
                            anchors: ".smoothstate a, .smoothstate button",
                            blacklist: "form, .no-smoothState, .wpcf7-form",
                            forms: "form",
                            prefetch: !0,
                            prefetchOn: "aim",
                            scroll: !1,
                            loadingClass: "",
                            onBefore: function (a, b) {},
                            onStart: {
                                duration: 1500,
                                render: function (b) {
                                    null !== window.countDown && void 0 !== window.countDown && (window.countDown.pause(), window.countDown.seek(0));
                                    var c = a(".component-expanding-cta");
                                    c.addClass("clicked"),
                                        a(".nav-container").hasClass("white") || a(".nav-container").addClass("white"),
                                        a(".nav-container").hasClass("black") && a(".nav-container").removeClass("black"),
                                        TweenMax.to(a(".nav-container .project"), 0.5, { auto: 0 }),
                                        a.pnp.triggeredFromFooter &&
                                            TweenMax.to(c.find("a"), 1.5, {
                                                height: "100vh",
                                                ease: Cubic.easeInOut,
                                                onStart: function () {
                                                    if (
                                                        (a(".slider-nav").length &&
                                                            (a(".nav-container").hasClass("black") && a(".nav-container").removeClass("black"),
                                                            a(".slider-nav ul li").each(function (b) {
                                                                var c = a(this),
                                                                    d = c.find(".inner").attr("data-link");
                                                                if (a.pnp.currentTarget.indexOf(d) > -1 && "http://mm.test" !== d && "http://minaleandmannnew.pnpd.co.uk" !== d && "https://minaleandmannnew.pnpd.co.uk" !== d) {
                                                                    var e = a(".slider-nav>.slider-wrapper>.slides"),
                                                                        f = e.data("flickity");
                                                                    f.select(b, !1, !0);
                                                                    var g = a(".slider-nav .captions-full ul"),
                                                                        h = g.data("flickity");
                                                                    h.select(b, !1, !0);
                                                                }
                                                            })),
                                                        window.scenes.length > 0)
                                                    ) {
                                                        for (var b = 0; b < window.scenes.length; b++) window.scenes[b].destroy(!0), (window.scenes[b] = null);
                                                        window.controller.destroy(!0), (window.controller = null);
                                                    }
                                                },
                                            });
                                },
                            },
                            onReady: {
                                duration: 10,
                                render: function (b, c) {
                                    if ((b.append(c), a.pnp.triggeredFromFooter))
                                        a(".slider-nav").length &&
                                            (a(".slider-nav").css("display", "block"),
                                            a(".captions-full, .captions-full .caption").css("visibility", "hidden"),
                                            a(".captions-full .caption .loadpage").css("visibility", "hidden").removeClass("in"),
                                            TweenMax.set(a(".captions-full"), { autoAlpha: 0 }),
                                            TweenMax.set(a(".captions-full .is-selected").find("h4"), { autoAlpha: 0 }),
                                            TweenMax.set(a(".captions-full .is-selected").find(".subtitle"), { autoAlpha: 0 }),
                                            TweenMax.set(a(".captions-full .is-selected").find("p"), { autoAlpha: 0 }),
                                            a(window).width() < 767 && TweenMax.set(a(".captions-full .is-selected").find(".seo-title"), { autoAlpha: 0 }),
                                            TweenMax.set(a(".captions-full .is-selected").find("p"), { autoAlpha: 0 }),
                                            setTimeout(function () {
                                                a(".nav-container").hasClass("black") && a(".nav-container").removeClass("black"),
                                                    a(".captions-full, .captions-full .caption").css("visibility", "visible"),
                                                    TweenMax.to(a(".captions-full"), 0.5, {
                                                        autoAlpha: 1,
                                                        onComplete: function () {
                                                            window.zoomEffect(),
                                                                TweenMax.to(".arrow", 0.5, { delay: 1, autoAlpha: 1 }),
                                                                TweenMax.to(a(".captions-full .is-selected").find(".subtitle"), 1, { autoAlpha: 1, delay: 0.1, ease: Cubic.easeOut }),
                                                                TweenMax.to(a(".captions-full .is-selected").find("h4"), 5, { autoAlpha: 1, delay: 0.5, ease: Cubic.easeOut }),
                                                                a(window).width() < 767 && TweenMax.to(a(".captions-full .is-selected").find(".seo-title"), 1, { autoAlpha: 0.5, delay: 0.7 }),
                                                                TweenMax.set(a(".captions-full .is-selected").find("p"), { autoAlpha: 1 });
                                                            var b = new SplitText(a(".captions-full .is-selected").find("p"), { type: "chars,words,lines" });
                                                            TweenMax.staggerFrom(
                                                                b.words,
                                                                2,
                                                                {
                                                                    autoAlpha: 0,
                                                                    ease: Cubic.easeOut,
                                                                    delay: 0.5,
                                                                    onStart: function () {
                                                                        a(".captions-full .is-selected .caption").css("visibility", "visible");
                                                                    },
                                                                    onComplete: function () {
                                                                        a(".captions-full .is-selected .caption").find(".loadpage").css("visibility", "visible").addClass("in");
                                                                    },
                                                                },
                                                                0.04
                                                            ),
                                                                a(".project .case").html(a(".captions-full li.is-selected .inner .caption h4").text());
                                                        },
                                                    });
                                            }, 10)),
                                            a.pnp.enableScroll(),
                                            a(".nav-container").hasClass("black") && a(".nav-container").removeClass("black"),
                                            $window.trigger("resize");
                                    else if (a(".slider-nav").length) {
                                        var d = a(window).width() < 768 ? window.headHeight - 57 : window.headHeight;
                                        TweenMax.to(window, 2, {
                                            scrollTo: { y: d, autoKill: !1 },
                                            ease: Cubic.easeInOut,
                                            onStart: function () {
                                                a.pnp.enableScroll();
                                            },
                                        });
                                    }
                                    a(".old-content").remove(), a("html,body").scrollTop(0), a.pnp.initPage(), a.pnp.initViewportChecker();
                                },
                            },
                            onAfter: function (b, c) {
                                a("input[name=current-url]").length && a("input[name=current-url]").attr("value", window.location.href), $window.trigger("resize");
                            },
                        });
            }),
            (a.pnp.initPage = function (b) {
                a.pnp.initPlaceholderShim(),
                    a.pnp.initSelectric(),
                    a.pnp.initDatePicker(),
                    a.pnp.initFormValidation(),
                    a.pnp.initFixto(),
                    a.pnp.initDropdowns(),
                    a.pnp.initScrollHijack(),
                    a.pnp.initHeaderBanner(),
                    a.pnp.initExpandingCTA(),
                    a.pnp.initColouredText(),
                    a.pnp.initStackedLayers(),
                    a.pnp.initPinned(),
                    a.pnp.initGoogleMaps(),
                    a.pnp.initAccordion(),
                    a.pnp.initCards(),
                    a.pnp.initCustomContactForm7(),
                    a.pnp.initShowcase(),
                    a.pnp.initProcess(),
                    a.pnp.initSmoothstate(),
                    a.pnp.InitMagnify(),
                    a.pnp.initTeam(),
                    a.pnp.responsiveImages(),
                    a.pnp.initFullBleedImages(),
                    a.pnp.initParallaxMedia(),
                    a.pnp.initCustomText(),
                    a.pnp.initPress(),
                    a.pnp.initButtons(),
                    a.pnp.initScrollMagic(),
                    (a.pnp.triggeredFromFooter = !1),
                    b && (a.pnp.initModals(), a.pnp.initBanners(), a.pnp.initSubNav(), a.pnp.initMicrointeractions(), a.pnp.initSliders(), a.pnp.overlayer.init()),
                    setTimeout(function () {
                        $window.trigger("resize");
                    }, 0);
            }),
            (a.pnp.unbindPage = function () {});
    })(jQuery),
    $document.ready(function () {
        $.pnp.initPage(!0);
    }),
    $("#accordion-search-form").length > 0)
) {
    var faqs = [];
    $("[data-pnp-search-results]")
        .find(".component-accordion .panel")
        .each(function (a) {
            var b = $(this).find(".trigger").text().toLowerCase(),
                c = $(this).find(".reveal").text().toLowerCase();
            faqs.push(b + c), $(this).attr("id", "faq-" + a);
        });
    var $searchBox = $("#accordion-search-box"),
        $numResults = $("#num-results"),
        doSearch = function () {
            $body.addClass("search-active");
            for (var a = $searchBox.val().toLowerCase(), b = new RegExp("\\b" + a + "\\b", "i"), c = 0; c < faqs.length; c++)
                b.test(faqs[c]) ? $("#faq-" + c + ".filtered-out").removeClass("filtered-out") : $("#faq-" + c).addClass("filtered-out");
            var d = $("[data-pnp-search-results] .panel:not(.filtered-out)").size();
            $numResults.find(".num-results").html(d),
                $numResults.show(),
                1 == d ? $("#num-results span#plural").hide() : $("#num-results span#plural").show(),
                $(".component-accordion").addClass("filtered-out"),
                $(".component-accordion .panel:not(.filtered-out)").each(function () {
                    $(this).closest(".component-accordion").removeClass("filtered-out");
                }),
                $window.trigger("resize"),
                pnpHelper.scroll.scrollTo("#num-results");
        };
    $searchBox.keyup(function (a) {
        if (0 != $(this).val().length) {
            var b = a.keyCode || a.which;
            return 13 === b && doSearch(), !1;
        }
        $(".panel.filtered-out").removeClass("filtered-out"), $body.removeClass("search-active");
    }),
        $document.on("click", "#clear-search", function () {
            return $(".filtered-out").removeClass("filtered-out"), $("#num-results").hide(), $(".component.component-text").show(), $("#faq-search-box").val(""), $window.trigger("resize"), !1;
        }),
        $document.on("submit", "#accordion-search-form", function (a) {
            $searchBox.val().length > 0 ? doSearch() : ($(".panel.filtered-out").removeClass("filtered-out"), $body.removeClass("search-active")), a.preventDefault();
        });
}
$(function () {
    $(".has-background-video").length > 0 && (pnpHelper.onResizeFinished(initBannerVideos), $window.trigger("resize"));
}),
    (function (a) {
        $document.on("click", "[data-pnp-toggle-class]", function () {
            return a(a(this).data("pnp-target")).toggleClass(a(this).data("pnp-class")), !1;
        }),
            $document.on("click", "[data-pnp-add-class]", function () {
                return a(a(this).data("pnp-target")).addClass(a(this).data("pnp-class")), !1;
            }),
            $document.on("click", "[data-pnp-remove-class]", function () {
                return a(a(this).data("pnp-target")).removeClass(a(this).data("pnp-class")), !1;
            }),
            $document.on("click", "[data-pnp-show-toggle]", function () {
                return a(a(this).data("pnp-hide-target")).hide(), a(a(this).data("pnp-show-target")).show(), a.event.trigger({ type: "pnp-show-toggle-complete" }), !1;
            }),
            $document.on("click", "[data-pnp-slide-toggle]", function () {
                return a(a(this).data("pnp-slide-toggle")).is(":visible") ? a(this).addClass("-out").removeClass("-in") : a(this).addClass("-in").removeClass("-out"), a(a(this).data("pnp-slide-toggle")).slideToggle(), !1;
            }),
            $document.on("click", "[data-pnp-slide-up]", function () {
                return a(a(this).data("pnp-slide-up")).slideUp(), !1;
            }),
            $document.on("click", "[data-pnp-slide-down]", function () {
                return a(a(this).data("pnp-slide-down")).slideDown(), !1;
            }),
            $document.on("change", "[data-pnp-slide-toggle-change]", function () {
                a(a(this).data("pnp-slide-toggle-change")).is(":checked") ? a(this).addClass("-out").removeClass("-in") : a(this).addClass("-in").removeClass("-out"), a(a(this).data("pnp-slide-toggle-change")).slideToggle();
            }),
            $document.on("click", "[data-pnp-back]", function () {
                return window.history.back(), !1;
            }),
            $document.on("click", "[data-pnp-return-false]", function () {
                return !1;
            }),
            $document.on("click", "[data-pnp-scroll-to],[data-pnp-scroll-past]", function () {
                if (a(this).data("pnp-scroll-past")) {
                    var b = a(this).data("pnp-scroll-past");
                    pnpHelper.scroll.scrollPast(a(this).closest(b));
                } else a(this).data("pnp-scroll-to") && pnpHelper.scroll.scrollTo(a(this).data("pnp-scroll-to"));
                return !1;
            }),
            $window
                .bind("resize", function () {
                    a("[data-pnp-equate-height]").each(function () {
                        a(this).find(a(this).data("pnp-equate-height")).css("height", "auto");
                        var b = a(this)
                                .find(a(this).data("pnp-equate-height"))
                                .map(function () {
                                    return a(this).outerHeight();
                                })
                                .get(),
                            c = Math.max.apply(null, b);
                        (pnpHelper.bootstrap.isMd() || 1 == a(this).data("resize-mobile")) &&
                            a(this)
                                .find(a(this).data("pnp-equate-height"))
                                .css("height", c + "px");
                    });
                })
                .trigger("resize");
    })(jQuery),
    ($.pnp.initAccordion = function () {
        if ($(".component-accordion").length > 0) {
            var a = 300;
            $(".component-accordion .trigger").on("click", function () {
                var b = $(this).closest(".component-accordion"),
                    c = $(this).closest(".panel");
                if (c.hasClass("active"))
                    c.removeClass("active")
                        .find(".reveal")
                        .slideUp(a, function () {
                            $window.trigger("resize");
                        });
                else {
                    var d = b.find(".panel.active");
                    d.removeClass("active").find(".reveal").slideUp(a),
                        c
                            .addClass("active")
                            .find(".reveal")
                            .slideDown(a, function () {
                                $window.trigger("resize");
                            });
                }
                return !1;
            }),
                $(".component-accordion .trigger.initial-active").trigger("click");
        }
    }),
    ($.pnp.initBanners = function () {
        function a() {
            pnpHelper.bootstrap.isSm() &&
                $(".component-banner.-video:not(.-playing)").each(function () {
                    var a = $(this),
                        b = $(this).find("video");
                    if (b.length) {
                        b.attr("autoplay", !0).removeAttr("preload"), a.addClass("-playing");
                        try {
                            b.get(0).play();
                        } catch (c) {
                            console.log("Unable to play video", c);
                        }
                    } else console.warn("Unable to play background hero video, no video found");
                });
        }
        if ($(".component-banner").length > 0) {
            if ($(".component-banner.-video").length > 0) {
                var b;
                $window
                    .resize(function () {
                        clearTimeout(b), (b = setTimeout(a, 300));
                    })
                    .load(a);
            }
            $(".component-banner.-carousel").length > 0 &&
                $(".component-banner.-carousel").each(function () {
                    var a = $(this);
                    if (a.find(".carousel-container .slide").length > 0) {
                        if (a.hasClass("-page-slider")) {
                            var b = 0,
                                c = a.data("pnp-this-page-url");
                            a.find(".carousel-container .slide").each(function (a) {
                                if ($(this).data("pnp-page-url") === c) return void (b = a);
                            });
                            var d = a.find(".carousel-container").slick({ infinite: !0, mobileFirst: !0, speed: 1e3, slidesToShow: 1, slidesToScroll: 1, arrows: !1, dots: !0, swipeToSlide: !0, initialSlide: b });
                            a.find(".carousel-prev").hover(
                                function () {
                                    a.find(".slick-slider").addClass("peek-left");
                                },
                                function () {
                                    a.find(".slick-slider").removeClass("peek-left");
                                }
                            ),
                                a.find(".carousel-next").hover(
                                    function () {
                                        a.find(".slick-slider").addClass("peek-right");
                                    },
                                    function () {
                                        a.find(".slick-slider").removeClass("peek-right");
                                    }
                                );
                            var e = new pnpHelper.ajaxNavigation();
                            d.on("afterChange", function (a, b, c, d) {
                                var f = $(b.$slides[c]).data("pnp-page-url");
                                e.loadPage(f, !0, function (a) {});
                            });
                        } else var d = $(this).find(".carousel-container").slick({ infinite: !0, mobileFirst: !0, speed: 1e3, slidesToShow: 1, slidesToScroll: 1, arrows: !1, dots: !0, swipeToSlide: !0 });
                        $document.on("click", ".carousel-next", function (a) {
                            return d.slick("slickNext"), !1;
                        }),
                            $document.on("click", ".carousel-prev", function (a) {
                                return d.slick("slickPrev"), !1;
                            });
                    }
                });
        }
    }),
    ($.pnp.initCards = function () {
        function a(a, b, d) {
            (d.current_page = 1),
                a.find(".pagination").on("click", function () {
                    return (
                        $(this).hasClass("-prev") && d.current_page > 1 ? d.current_page-- : $(this).hasClass("-next") && d.current_page++,
                        $.when(c(d)).done(function (c) {
                            "" == c ? a.find(".pagination.-next").hide() : a.find(".pagination.-next").show(), console.log(c), b.empty().append(c);
                        }),
                        !1
                    );
                });
        }
        function b(a, b, d) {
            var e = !0;
            (d.current_page = 1),
                a.find(".ajax-infinite-scroll-marker").viewportChecker({
                    repeat: !0,
                    callbackFunction: function (a, f) {
                        "Remove" != f &&
                            0 != e &&
                            (d.current_page++,
                            $.when(c(d)).done(function (a) {
                                return "" == a ? void (e = !1) : (b.append(a), void $window.trigger("resize"));
                            }));
                    },
                });
        }
        function c(a) {
            var b = $.Deferred(),
                c = { ajax: !0, action: "do_ajax_shortcode" };
            return (
                (c = $.extend(c, a)),
                console.log("test"),
                console.log(c),
                $.post(ajax_object.ajax_url, c, function (a) {
                    b.resolve(a);
                }),
                b
            );
        }
        $(".component-cards").each(function () {
            var c = $(this),
                d = c.find("[data-ajax]"),
                e = d.data("ajax");
            if ((c.find(".pagination").length && a(c, d, e), c.find(".ajax-infinite-scroll-marker").length && b(c, d, e), c.find(".filter-terms").length)) {
                var f = c.find(".isotope-container").isotope({ itemSelector: ".item", layoutMode: "fitRows" });
                c.find(".filter-terms .term").on("click", function () {
                    var a = $(this).attr("data-term-id");
                    return a == -1 ? (f.isotope({ filter: "*" }), $(this).closest(".filter-terms").find(".-reset").hide()) : (f.isotope({ filter: ".term-id-" + a }), $(this).closest(".filter-terms").find(".-reset").show()), !1;
                });
            }
        });
    }),
    ($.pnp.initCustomText = function () {
        function a() {
            var a = window.navigator.userAgent,
                b = a.indexOf("MSIE ");
            if (b > 0) return parseInt(a.substring(b + 5, a.indexOf(".", b)), 10);
            var c = a.indexOf("Trident/");
            if (c > 0) {
                var d = a.indexOf("rv:");
                return parseInt(a.substring(d + 3, a.indexOf(".", d)), 10);
            }
            var e = a.indexOf("Edge/");
            return e > 0 && parseInt(a.substring(e + 5, a.indexOf(".", e)), 10);
        }
        if ($(".component-coloured-text").length) {
            a();
            $(".component-coloured-text").each(function () {
                "#ffffff" == $(this).attr("data-bg-colour") &&
                    ($(this).find(".mm-button").removeClass("white"), $(this).parent().parent().parent().parent().next().find(".jpg").length && $(window).width() > 747 && $(this).addClass("has-next")),
                    ("#1b1b1e" != $(this).attr("data-bg-colour") && "#000000" != $(this).attr("data-bg-colour")) ||
                        ($(this).find(".content p").css("opacity", "0.7"),
                        $(window).width() < 767 && $(this).parent().parent().parent().parent().next().find(".jpg").length && $(this).addClass("has-next"),
                        $(this).parent().parent().parent().parent().next().find(".component-full-bleed-image").length && $(this).addClass("has-next"));
                var a = $(this).find(".pinned");
                a.length && $(window).width() > 747 && a.fixTo(a.parent(), { top: 70 });
            }),
                $(".buttons a").each(function () {
                    var a = $(this);
                    "1" === a.attr("data-contact") &&
                        a.click(function (a) {
                            a.preventDefault();
                            var b = $(".mm-overlay").attr("data-title"),
                                c = $(".mm-overlay").attr("data-content");
                            $.pnp.overlayer.populate(b, null, c, !0), $.pnp.overlayer.show();
                        });
                }),
                $(".mm-button.create, .mm-button.construct").click(function () {
                    var a = $(this).attr("data-title"),
                        b = $(this).attr("data-content");
                    $.pnp.overlayer.populate(a, null, b, !1), $.pnp.overlayer.show();
                }),
                $(".no-caption").length &&
                    setTimeout(function () {
                        $(".no-caption").each(function () {
                            var a = $(this),
                                b = a.find(".image img");
                            b.width() < 320 && null !== b.width() && a.removeClass("no-caption");
                        });
                    }, 20);
        }
    }),
    ($.pnp.initButtons = function () {
        $(".buttons").length &&
            $(".buttons").each(function () {
                function a(a, b) {
                    var c = b.width() + 40,
                        d = b.height() + 22,
                        e = (a.pageX - b.offset().left - c / 2) * (c > d ? d / c : 1),
                        f = (a.pageY - b.offset().top - d / 2) * (d > c ? c / d : 1),
                        g = Math.round((Math.atan2(f, e) * (180 / Math.PI) + 180) / 90 + 3) % 4;
                    return g;
                }
                $(this).children("a").length > 1 &&
                    $(".buttons a").each(function (b) {
                        var c = $(this);
                        c.prepend('<div class="overlay"></div>'), c.removeClass("left").removeClass("right").addClass("dynamic"), c.wrap();
                        var d = c.find(".overlay");
                        TweenMax.set(d, { scaleX: 0 }),
                            c.mouseenter(function (e) {
                                var f = a(e, c);
                                switch ((c.addClass("over"), f)) {
                                    case 0:
                                        b > 0 ? TweenMax.to(d, 0.5, { scaleX: 1, transformOrigin: "0% 50%", ease: Cubic.easeOut }) : TweenMax.to(d, 0.5, { scaleX: 1, transformOrigin: "0 50%", ease: Cubic.easeOut });
                                        break;
                                    case 1:
                                        b > 0 ? TweenMax.to(d, 0.5, { scaleX: 1, transformOrigin: "0% 50%", ease: Cubic.easeOut }) : TweenMax.to(d, 0.5, { scaleX: 1, transformOrigin: "100% 50%", ease: Cubic.easeOut });
                                        break;
                                    case 2:
                                        b > 0 ? TweenMax.to(d, 0.5, { scaleX: 1, transformOrigin: "0% 50%", ease: Cubic.easeOut }) : TweenMax.to(d, 0.5, { scaleX: 1, transformOrigin: "0 50%", ease: Cubic.easeOut });
                                        break;
                                    case 3:
                                        TweenMax.to(d, 0.5, { scaleX: 1, transformOrigin: "0 50%", ease: Cubic.easeOut });
                                }
                            }),
                            c.mouseleave(function (b) {
                                var e = a(b, c);
                                switch ((c.removeClass("over"), e)) {
                                    case 0:
                                        TweenMax.to(d, 0.5, { scaleX: 0, transformOrigin: "100% 50%", ease: Cubic.easeOut });
                                        break;
                                    case 1:
                                        TweenMax.to(d, 0.5, { scaleX: 0, transformOrigin: "100% 50%", ease: Cubic.easeOut });
                                        break;
                                    case 2:
                                        TweenMax.to(d, 0.5, { scaleX: 0, transformOrigin: "0 50%", ease: Cubic.easeOut });
                                        break;
                                    case 3:
                                        TweenMax.to(d, 0.5, { scaleX: 0, transformOrigin: "0 50%", ease: Cubic.easeOut });
                                }
                            });
                    });
            });
    }),
    ($.pnp.initExpandingCTA = function () {
        function a() {
            var a = window.navigator.userAgent,
                b = a.indexOf("MSIE ");
            if (b > 0) return parseInt(a.substring(b + 5, a.indexOf(".", b)), 10);
            var c = a.indexOf("Trident/");
            if (c > 0) {
                var d = a.indexOf("rv:");
                return parseInt(a.substring(d + 3, a.indexOf(".", d)), 10);
            }
            var e = a.indexOf("Edge/");
            return e > 0 && parseInt(a.substring(e + 5, a.indexOf(".", e)), 10);
        }
        var b = $(".component-expanding-cta"),
            c = a();
        b.length &&
            ((!c && $(".slider-nav").length) || b.removeClass("smoothstate"),
            b.find("a").click(function (a) {
                ($.pnp.triggeredFromFooter = !0), ($.pnp.currentTarget = $(this).attr("href"));
            }));
    }),
    ($.pnp.initCustomContactForm7 = function () {
        $(".wpcf7").on("wpcf7:invalid", function (a) {
            $(".equalise").addClass("-transition"), $window.trigger("resize");
        }),
            $("input[name=current-url]").length && $("input[name=current-url]").attr("value", window.location.href),
            $("body").hasClass("contact") && $(window).width() > 767 && $(".component-form").find("h2").appendTo($(".component-form").find(".content")),
            $("body").hasClass("contact") &&
                $(window).width() < 768 &&
                ($(".component-form").find("h2").appendTo($(".component-form").find(".text-container")),
                $(".component-form").find(".content").appendTo($(".component-form").find(".form-container").parent()).css({ display: "inline-block", "margin-top": "6%" }));
    }),
    ($.pnp.initFullBleedImages = function () {
        $(".component-full-bleed-image").length &&
            $(".component-full-bleed-image").each(function () {
                $(this).parent().parent().parent().parent().next().find(".component-full-bleed-image").length && ($(this).parent().parent().parent().parent().css("padding", 0), $(this).addClass("next")),
                    $(this).parent().parent().parent().parent().prev().find(".brand-color").length && $(this).addClass("after-brand");
            });
    }),
    ($.pnp.initGoogleMaps = function () {
        function a(a, b, c, e, f) {
            c[a].addListener("click", function () {
                d(a, b, c, e), f.prop("selectedIndex", a).selectric("refresh");
            });
        }
        function b(a, b, c) {
            var d = new google.maps.Circle({ strokeColor: "#FF0000", strokeOpacity: 0.8, strokeWeight: 2, fillColor: "#FF0000", fillOpacity: 0.35, map: a, center: c, radius: b });
            return d;
        }
        function c(a, b, c) {
            function d() {
                null !== e.getAnimation() ? e.setAnimation(null) : e.setAnimation(google.maps.Animation.BOUNCE);
            }
            var e = new google.maps.Marker({ position: b, map: a, icon: { url: c, scaledSize: new google.maps.Size(56.5, 71) }, animation: google.maps.Animation.DROP });
            return e.addListener("click", d), e;
        }
        function d(a, b, c, d) {
            b.panTo(c[a].position), d.find(".map-panel:visible").slideUp(), d.find(".map-panel.map-" + a).slideDown();
        }
        var e = { scrollwheel: !1, zoom: 14 };
        $(".component-google-map").length &&
            $(".component-google-map").each(function (f) {
                var g = [];
                (e.img = $(this).data("img")),
                    (e.markers = $(this).data("markers")),
                    (e.radiuses = $(this).data("radiuses")),
                    (e.lat = "51.0199613"),
                    (e.lng = "-0.4694492"),
                    (e.disableDefaultUI = !0),
                    (e.styles = [
                        { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
                        { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
                        { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                        { featureType: "poi", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                        { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
                        { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#dadada" }] },
                        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                        { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                        { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                        { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9c9c9" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                    ]);
                var h = new google.maps.Map($(this)[0], e),
                    i = new google.maps.LatLng(e.lat, e.lng);
                h.setCenter(i);
                var j = new google.maps.LatLngBounds();
                for (var k in e.markers) {
                    var l = e.markers[k],
                        i = new google.maps.LatLng(l.lat, l.lng),
                        m = e.img,
                        n = c(h, i, m);
                    g.push(n), j.extend(i);
                }
                for (var k in e.radiuses) {
                    var o = e.radiuses[k],
                        i = new google.maps.LatLng(o.lat, o.lng);
                    b(h, parseInt(o.size), i), j.extend(i);
                }
                if (e.markers.length + e.radiuses.length === 1) {
                    if (1 === e.markers.length) {
                        var i = new google.maps.LatLng(e.markers[0].lat, e.markers[0].lng);
                        h.setZoom(13);
                    } else {
                        var i = new google.maps.LatLng(e.radiuses[0].lat, e.radiuses[0].lng);
                        h.setZoom(10);
                    }
                    h.setCenter(i);
                } else if ((h.fitBounds(j), $(this).hasClass("-search") || $(this).hasClass("-google_map_key")))
                    var p = google.maps.event.addListener(h, "idle", function () {
                        h.setZoom(h.getZoom() - 1), google.maps.event.removeListener(p);
                    });
                if ($(this).hasClass("-google_map_key")) {
                    var q = $(this).closest(".component-google-map-container");
                    q.find(".map-key-toggle").addClass("map-key-toggle-" + f),
                        $(".map-key-toggle-" + f).on("selectric-change, change", function (a, b, c) {
                            d($(this).val(), h, g, q);
                        });
                    for (var r = $(this).parent(".component-google-map-container").find(".map-key-toggle"), s = 0; s < g.length; s++) a(s, h, g, q, r);
                }
                if ($(this).hasClass("-search")) {
                    var t;
                    $('[data-pnp-slider-config="property-search"]')
                        .slick({ infinite: !0, mobileFirst: !0, slidesToShow: 1, slidesToScroll: 1, speed: 600, dots: !1, swipeToSlide: !0, prevArrow: "#prop-prev", nextArrow: "#prop-next" })
                        .on("beforeChange", function (a, b, c, d) {
                            $("#current_properties").html(d + 1), t && t.setIcon(e.img);
                            var f = g[d];
                            f.setIcon("/wp-content/themes/pegasus/dist/img/marker.png"), h.panTo(f.position), (t = f);
                        });
                }
            });
    }),
    (function (a) {
        a(".component.component-header-banner")
            .find("button")
            .click(function () {
                var b = a(this).closest(".component.layout"),
                    c = a(b).next(".component.layout");
                a("html, body").animate({ scrollTop: a(c).offset().top }, 2e3);
            });
    })(jQuery),
    $(function () {
        $('[data-toggle="tooltip"]').tooltip({ trigger: "click", placement: "auto" }),
            pnpHelper.onResizeFinished(function () {
                $('[data-toggle="tooltip"]').tooltip("show");
            }),
            $(".point-btn").on("click", function () {
                var a = $(this).closest(".component-floorplan"),
                    b = a.find(".point-container");
                return (
                    a.find(".img-container, .button").toggleClass("-in"),
                    b.is(":visible")
                        ? b.slideUp(400, function () {
                              $window.trigger("resize").trigger("scroll");
                          })
                        : b.slideDown(400, function () {
                              a.find(".hotspot-tooltip[aria-describedby]").trigger("click"), $window.trigger("resize").trigger("scroll");
                          }),
                    !1
                );
            });
    }),
    $(function () {
        var a = 5e3,
            b = $(".preload .component-loading-screen"),
            c = $(".captions-full li:first-child .caption h5").length ? $(".captions-full li:first-child .caption h5") : $(".captions-full li:first-child .caption p");
        if (b.length)
            if ((console.log("found loading screen"), b.hasClass("-standard"))) $(".preload .component-loading-screen").delay(a).fadeOut();
            else if (b.hasClass("-intro"))
                b.find(".page-intro").addClass("-in"),
                    setTimeout(function () {
                        b.find(".bullet").addClass("-in");
                    }, 1200),
                    setTimeout(function () {
                        b.find(".inner").addClass("-out"), b.find(".background").addClass("-out");
                    }, 4e3),
                    setTimeout(function () {
                        b.fadeOut();
                    }, a);
            else if (b.hasClass("-text")) {
                $(".intro-text").css("display", "block");
                var d = $(".st0");
                TweenMax.set(c, { autoAlpha: 0 }),
                    TweenMax.set(".minale-logo, .captions-full li:first-child .caption .subtitle, .captions-full li:first-child .caption h4", { autoAlpha: 0 }),
                    TweenMax.fromTo(".minale-logo", 2, { autoAlpha: 0 }, { autoAlpha: 1, delay: 0.5 }),
                    TweenMax.to(".minale-logo", 1.5, { autoAlpha: 0, ease: Cubic.easeOut, delay: 2.5 }),
                    TweenMax.staggerFrom(d, 3, { autoAlpha: 0, ease: Cubic.easeOut }, 0.1),
                    TweenMax.staggerTo(d, 1.5, { autoAlpha: 0, ease: Cubic.easeInOut, delay: 2 }, 0.1),
                    TweenMax.allTo([".background>.top", ".background>.bottom"], 1, {
                        height: 0,
                        ease: Cubic.easeOut,
                        delay: 4,
                        onStart: function () {
                            TweenMax.set(".minale-logo, .captions-full li:first-child .caption .subtitle, .captions-full li:first-child .caption h4", { autoAlpha: 0 }),
                                $(".captions-full").css("display", "block"),
                                TweenMax.set(c, { autoAlpha: 0 });
                        },
                        onComplete: function () {
                            if ((b.remove(), $(".captions-full").length)) {
                                TweenMax.set($(".captions-full p"), { autoAlpha: 1 }),
                                    $(".captions-full p").css("opacity", 1),
                                    TweenMax.fromTo(".captions-full li:first-child .caption .subtitle", 0.5, { autoAlpha: 0, ease: Cubic.easeOut }, { autoAlpha: 1 }),
                                    TweenMax.fromTo(".captions-full li:first-child .caption h4", 0.5, { autoAlpha: 0, delay: 0.2, ease: Cubic.easeOut }, { autoAlpha: 1 });
                                var a = new SplitText(c, { type: "chars,words,lines" });
                                TweenMax.set(c, { autoAlpha: 1 }), TweenMax.staggerFrom(a.words, 2, { autoAlpha: 0, ease: Cubic.easeOut }, 0.02);
                            }
                        },
                    });
            }
        var e = !1;
        $("body").delegate("a", "click", function () {
            e = !0;
        }),
            (window.onbeforeunload = function () {});
    }),
    ($.pnp.InitMagnify = function () {
        function a() {
            $(".select-view li").removeClass("active");
        }
        function b() {
            $(".component-magnifying-image").each(function () {
                var a = $(this).find(".views"),
                    b = ($(this).find(".view"), $(this).find(".select-view>ul")),
                    c = b.offset().left + b.width();
                $(window).width() > 1e3 && TweenMax.set(a, { x: c, width: $(window).width() - c - 180 });
            });
        }
        if (".component-magnifying-image".length) {
            $(".zoom").magnify(),
                $(".select-view li:first-child").addClass("active"),
                $(".component-magnifying-image").each(function () {
                    var b = $(this),
                        c = !!$(this).find(".fade-mode").length,
                        d = ($(this).find(".views"), $(this).find(".view"), $(this).find(".pinned"));
                    if (d.length && $(window).width() > 747) {
                        var e = $(window).width() < 747 ? 80 : 110;
                        d.fixTo(d.parent(), { top: e });
                    }
                    $(".select-view li").each(function () {
                        $(this).click(function () {
                            var d = $(this).attr("data-key");
                            if ((console.log("clicked " + d), a(), $(this).addClass("active"), c)) {
                                var e = $(".view[data-key='" + d + "']").find(".last");
                                e.css("opacity", 0);
                            }
                            var f = 2;
                            TweenMax.to(b.find(".views"), 2, { height: $(".view[data-key='" + d + "']").height(), ease: Cubic.easeInOut }),
                                TweenMax.to(".view[data-key='" + d + "']", f, {
                                    autoAlpha: 1,
                                    onComplete: function () {
                                        c && TweenMax.to(e, f, { autoAlpha: 1, delay: 1 });
                                    },
                                }),
                                TweenMax.to(".view:not([data-key='" + d + "'])", f, { autoAlpha: 0 });
                        });
                    });
                }),
                $(window).resize(function () {
                    b();
                }),
                b();
            var c = $(".view[data-key='0']").find(".last");
            $(".component-magnifying-image").viewportChecker({
                callbackFunction: function (a, d) {
                    console.log("magnify in sight!"), TweenMax.fromTo(c, 0.5, { autoAlpha: 0, delay: 1 }, { autoAlpha: 1 }), b();
                },
            });
        }
    }),
    (function (a) {
        if (!pnpHelper.dependencyCheck.requireDependencies("Microinteration", [pnpHelper.dependencyCheck.jqueryCookie])) {
            a.cookie.json = !0;
            var b = 999,
                c = "micro-interactions",
                d = a.cookie(c);
            d || (d = { total: 0, counts: {}, closes: [] }),
                (a.fn.microInteraction = function (e) {
                    var f = a(this),
                        g = this,
                        h = f.data("pnp-mi-id"),
                        i = "1" == f.data("pnp-mi-debug-mode"),
                        j = { removeAfter: 0, showRepeatedly: !0, classOnShow: "animated fadeInUp", classOnHide: "animated fadeOutDown" };
                    return (
                        e && (j = a.extend({}, j, e)),
                        i && (j.showRepeatedly = !0),
                        f.find("[data-pnp-mi-close]").click(function () {
                            return g.hideInteraction(), a("html").removeClass("mi-open"), !1;
                        }),
                        (this.hideInteraction = function () {
                            var a = j.classOnShow.split(" ");
                            if (a.length > 1) for (var b = 0; b < a.length; b++) f.removeClass(a[b]);
                            else f.removeClass(j.classOnShow);
                            f.addClass(j.classOnHide),
                                d.closes.push(h),
                                g.updateCookie(),
                                setTimeout(function () {
                                    f.hide();
                                }, 1e3);
                        }),
                        (this.showInteraction = function () {
                            i && (console.info("Number of times you have seen this microinteraction:", g.getShowCount()), console.info("Total number of microinteractions seen:", d.total)),
                                ((d.total < b && a.inArray(h, d.closes) == -1 && (j.showRepeatedly || 0 == g.getShowCount())) || i) &&
                                    (a("html").addClass("mi-open"),
                                    f.show(),
                                    f.addClass(j.classOnShow),
                                    g.incrementShowCount(),
                                    g.updateCookie(),
                                    j.removeAfter > 0 &&
                                        setTimeout(function () {
                                            g.hideInteraction(), a("html").removeClass("mi-open");
                                        }, j.removeAfter));
                        }),
                        (this.getShowCount = function () {
                            return d.counts[h] || (d.counts[h] = 0), d.counts[h];
                        }),
                        (this.incrementShowCount = function () {
                            g.getShowCount(), d.counts[h]++, d.total++;
                        }),
                        (this.updateCookie = function () {
                            a.cookie(c, d, { path: "/" });
                        }),
                        this
                    );
                });
        }
    })(jQuery),
    ($.pnp.initMicrointeractions = function () {
        $(".component-microinteraction").length &&
            $("[data-pnp-mi-delay]").each(function () {
                var a = $(this),
                    b = {};
                a.data("pnp-mi-config") && (b = { removeAfter: 0, showRepeatedly: !0, classOnShow: "animated fadeInUp", classOnHide: "animated fadeOutDown" }),
                    (_delay = 5e3),
                    parseInt(a.data("pnp-mi-delay")) && (_delay = a.data("pnp-mi-delay"));
                var c = a.microInteraction(b);
                setTimeout(function () {
                    c.showInteraction();
                }, _delay);
            });
    }),
    ($.pnp.initModals = function () {
        if (!pnpHelper.dependencyCheck.requireDependencies("Modals", [pnpHelper.dependencyCheck.bootstrapModal])) {
            $("[data-pnp-open-in-modal]").not(".modal").length &&
                (setTimeout(function () {
                    var a = $("#modal-skeleton");
                    $("[data-pnp-open-in-modal]")
                        .not(".modal")
                        .each(function (b) {
                            var c = $(this),
                                d = "modal-container";
                            c.data("pnp-open-in-modal").length > 0 && (d += " " + c.data("pnp-open-in-modal"));
                            var e = new Url(c.attr("href"));
                            (e.query.modal = "yes"),
                                console.log("Preloading modal:" + e),
                                $.get(e, function (e) {
                                    var f = e;
                                    (f = f.replace("pnp-modal-link", "")),
                                        $body.append("<div id='modal-" + b + "' class='" + d + "'>" + a.html() + "</div>"),
                                        $("#modal-" + b + " .modal-body").html(f),
                                        c.attr("data-pnp-modal-id", "#modal-" + b),
                                        d.indexOf("-basket-modal") > -1 && $("#modal-" + b + " > .modal").on("show.bs.modal", function (a) {});
                                }).fail(function (a) {
                                    console.warn("Unable to preload modal " + e, a);
                                });
                        });
                }, 1e3),
                $document.on("click", "[data-pnp-modal-id]", function () {
                    return pnpHelper.modal.open($(this).data("pnp-modal-id") + " > .modal"), !1;
                }),
                $document.on("click", ".modal-backdrop.fade.in", function () {
                    $document.find(".pnp-modal.in").modal("hide");
                }));
        }
    }),
    $(function () {
        $(".nav-container .has-children").hoverIntent(
            function () {
                $(this).find(".dropdown-menu").show();
            },
            function () {
                $(this).find(".dropdown-menu").hide();
            }
        );
    }),
    $(function () {
        function a() {
            $(".navbar-toggle-multi-level").removeClass("active"), $html.removeClass("mob-nav-in"), d.fadeOut();
        }
        function b() {
            $(".navbar-toggle-multi-level").addClass("active"), $html.addClass("mob-nav-in"), d.fadeIn();
        }
        function c() {
            $html.hasClass("mob-nav-in") ? a() : b();
        }
        if ($(".multi-level-mob-menu").length > 0) {
            var d = $("#side-menu-veil");
            $document.on("click", ".navbar-toggle-multi-level", function () {
                return c(), !1;
            }),
                $document.on("click", "#side-menu-veil", function () {
                    return c(), !1;
                });
            var e;
            $document.on("click", ".pnp-nav-has-child-menu", function () {
                return (
                    $(this).parent().find("aside").first().addClass("in"),
                    navigator.userAgent.indexOf("Safari") > -1 && ((e = $("#menu-main-menu").scrollTop()), $("#menu-main-menu").scrollTop(0), $("#menu-main-menu").css("overflow-y", "hidden")),
                    !1
                );
            }),
                $document.on("click", ".pnp-nav-back", function () {
                    return $(this).closest("aside").removeClass("in"), null != e && ($("#menu-main-menu").css("overflow-y", "auto"), $("#menu-main-menu").scrollTop(e)), !1;
                });
        }
    }),
    $(function () {
        $(".mobile-standard").length > 0 &&
            $document.on("click", ".navbar-toggle-overlay", function () {
                var a = $(this),
                    b = $(".overlay-mob-menu");
                b.is(":visible") ? (a.removeClass("active"), b.fadeOut()) : (a.addClass("active"), b.fadeIn());
            });
    }),
    $(function () {
        $(".mobile-standard").length > 0 &&
            $document.on("click", ".navbar-toggle-standard", function () {
                var a = $(this),
                    b = $("#mob-nav-container");
                b.is(":visible") ? (a.removeClass("active"), b.slideUp()) : (a.addClass("active"), b.slideDown());
            });
    }),
    ($.pnp.overlayer = {
        init: function () {
            $(".mm-overlay .shade, .mm-close").click(function () {
                console.log("closing"), $.pnp.overlayer.hide();
            });
        },
        show: function () {
            $(".mm-overlay, .mm-close").css("display", "block"),
                $("body").css("overflow-y", "hidden"),
                TweenMax.to(".view-toggle", 0.3, { autoAlpha: 0 }),
                $(".nav-container").hasClass("black") || $(".nav-container").addClass("black"),
                $(window).width() < 747 && ($(".nav-container.black .image .header-logo").css("fill", "#00222b"), $(".nav-container").hasClass("full-background") && $(".nav-container").removeClass("full-background")),
                $(".navbar-toggle").addClass("active"),
                $(".navbar-toggle").addClass("black"),
                TweenMax.fromTo(".mm-overlay .shade", 1.5, { autoAlpha: 0 }, { autoAlpha: 1, ease: Cubic.easeOut }),
                TweenMax.fromTo(
                    ".mm-overlay .inner",
                    1.5,
                    { x: "100%" },
                    {
                        x: "0%",
                        force3D: "auto",
                        ease: Cubic.easeOut,
                        delay: 0.2,
                        onStart: function () {
                            $(".mm-overlay").find(".wrap").scrollTop(0), TweenMax.to(".mm-close", 0.2, { autoAlpha: 1, delay: 0.5 });
                        },
                    }
                );
        },
        hide: function () {
            $("body").css("overflow-y", "auto"),
                $(".navbar-toggle").removeClass("active"),
                $(".navbar-toggle").removeClass("black"),
                TweenMax.to(".view-toggle", 0.3, { autoAlpha: 1 }),
                TweenMax.to(".mm-overlay .shade", 0.5, { autoAlpha: 0, ease: Cubic.easeOut }),
                TweenMax.to(".mm-close", 0.1, { autoAlpha: 0 }),
                $(window).width() < 747 && ($(".nav-container.black .image .header-logo").css("fill", "#ffffff"), $(".nav-container").hasClass("full-background") || $(".nav-container").addClass("full-background")),
                TweenMax.to(".mm-overlay .inner", 1, {
                    x: "100%",
                    ease: Cubic.easeOut,
                    onComplete: function () {
                        $(".mm-overlay, .mm-close").css("display", "none"), console.log("showing team overlay y: " + $(".mm-overlay").find(".wrap").scrollTop());
                    },
                });
        },
        populate: function (a, b, c, d) {
            $(".mm-overlay>.inner .title").text(a),
                null !== b ? $(".mm-overlay>.inner .subtitle").text(b).css("display", "block") : $(".mm-overlay>.inner .subtitle").css("display", "none"),
                $(".mm-overlay>.inner .content").html(c),
                d ? $(".mm-overlay>.inner>.wrap").find(".form-wrap").css("display", "block") : $(".mm-overlay>.inner>.wrap").find(".form-wrap").css("display", "none");
        },
    }),
    ($.pnp.initParallaxMedia = function () {
        var a = $(".component-parallax-image");
        a.length &&
            a.each(function (a) {
                var b = $(this).parent().parent().parent().parent();
                if ((b.hasClass("padded") || (b.addClass("padded"), $(this).find(".col-xs-12").css({ "padding-top": 0, "padding-bottom": 0 })), $(this).find(".video").length)) {
                    var c = $(this).find(".video"),
                        d = c.attr("data-video"),
                        e = c.attr("data-poster");
                    "" !== d && void 0 !== d && c.vide({ mp4: d, poster: e }, { volume: 0, playbackRate: 1, muted: !0, loop: !0, autoplay: !0, position: "0% 50%", posterType: "jpg", resizing: !0, bgColor: "#000000", className: "" });
                }
            });
    }),
    ($.pnp.initPinned = function () {
        var a = $(".component-pinned-text.pinned");
        a.length &&
            a.each(function () {
                var b = $(this);
                b.fixTo(a.parent(), { top: 90 }), b.parent().hasClass("equalise") || (b.parent().parent().attr("data-pnp-equate-height", ".equalise"), b.parent().parent().find(".col-sm-6").addClass("equalise"), $(window).trigger("resize"));
            });
    }),
    ($.pnp.initPress = function () {
        $(".component-press").length &&
            (console.log("found press component!"),
            $(".component-press .item").each(function () {
                var a = $(this);
                void 0 !== a.attr("data-overlay") &&
                    void 0 !== a.attr("data-content") &&
                    (a.addClass("clickable"),
                    a.click(function (b) {
                        b.preventDefault();
                        var c = a.attr("data-title"),
                            d = a.attr("data-content");
                        $.pnp.overlayer.populate(c, null, d, !1), $(".mm-overlay .content").find("img").attr("sizes", "(max-width: 1000px) 1000vw 1000px"), $.pnp.overlayer.show();
                    }));
            }));
    }),
    ($.pnp.initProcess = function () {
        $(".component-process").length &&
            $(".component-process").each(function () {
                var a = $(this);
                a.parent().parent().parent().parent().next().find(".component-process").length && a.addClass("next"), a.parent().parent().parent().parent().next().find(".jpg").length && a.addClass("has-next");
            });
    }),
    ($.pnp.initShowcase = function () {
        $(".component-showcase").length &&
            (($.fn.showcase = function () {
                pnpHelper.dependencyCheck.requireDependencies("Showcase", [pnpHelper.dependencyCheck.fixTo, pnpHelper.dependencyCheck.viewportChecker]) ||
                    $(this).each(function (a) {
                        function b(a) {
                            e.find(".active").removeClass("active"),
                                e
                                    .find('[data-pnp-showcase="' + a + '"]')
                                    .closest("li")
                                    .addClass("active"),
                                h.hasClass("-showcase_fade_images") && (h.find(".showcase-wrapper-0 .showcase-image.-in").removeClass("-in"), h.find(".showcase-wrapper-0 .showcase-image-" + a).addClass("-in"));
                        }
                        function c(a) {
                            f = !0;
                            var b = d.find('.showcase-item[data-pnp-showcase="' + a + '"]');
                            pnpHelper.scroll.scrollTo(
                                b,
                                function () {
                                    f = !1;
                                },
                                pnpHelper.getNavHeight()
                            );
                        }
                        var d = $(this),
                            e = d.find(".scroll-indicators"),
                            f = !1,
                            g = -1,
                            h = $(this);
                        if ($(this).find(".sticky-bar").length > 0) {
                            var i = $(this).find(".sticky-bar");
                            i.fixTo("body", { useNativeSticky: !0, top: pnpHelper.getNavHeight() }),
                                pnpHelper.onResizeFinished(function () {
                                    pnpHelper.bootstrap.isSm() ? (i.fixTo("start"), i.fixTo("setOptions", { top: pnpHelper.getNavHeight() })) : i.fixTo("stop");
                                });
                        }
                        if ($(this).hasClass("-showcase_fixed_images") || $(this).hasClass("-showcase_fade_images")) {
                            var j = $(this).find(".showcase-wrapper-0").fixTo(".component-showcase", { useNativeSticky: !1, top: pnpHelper.getNavHeight() });
                            pnpHelper.onResizeFinished(function () {
                                pnpHelper.bootstrap.isSm() ? (j.fixTo("start"), j.fixTo("setOptions", { top: pnpHelper.getNavHeight() })) : j.fixTo("stop");
                            });
                        }
                        $(this).find(".scroll-indicators").length > 0 && $(this).find(".scroll-indicators").fixTo(".component-showcase", { useNativeSticky: !1 }),
                            $(this)
                                .find(".scroll-indicators a")
                                .click(function () {
                                    var a = $(this).data("pnp-showcase");
                                    return b(a), c(a), !1;
                                }),
                            $(this)
                                .find(".showcase-item")
                                .viewportChecker({
                                    repeat: !0,
                                    offset: "50%",
                                    callbackFunction: function (a, c) {
                                        g == a.data("pnp-showcase") || f || (b(a.data("pnp-showcase")), (g = a.data("pnp-showcase")));
                                    },
                                });
                    });
            }),
            $(".component-showcase").showcase());
    }),
    $(function () {
        function a() {
            var a = window.navigator.userAgent,
                b = a.indexOf("MSIE ");
            if (b > 0) return parseInt(a.substring(b + 5, a.indexOf(".", b)), 10);
            var c = a.indexOf("Trident/");
            if (c > 0) {
                var d = a.indexOf("rv:");
                return parseInt(a.substring(d + 3, a.indexOf(".", d)), 10);
            }
            var e = a.indexOf("Edge/");
            return e > 0 && parseInt(a.substring(e + 5, a.indexOf(".", e)), 10);
        }
        function b() {
            TweenMax.staggerFromTo(".menu-wrapper>ul.text-menu>li, .first-level li, .second-level li", 1, { x: 100, autoAlpha: 0 }, { x: 0, autoAlpha: 1, ease: Cubic.easeOut }, 0.1);
        }
        function c() {
            TweenMax.staggerTo(".menu-wrapper>ul.text-menu>li, .first-level li, .second-level li", 0.5, { x: 50, autoAlpha: 0, ease: Cubic.easeInOut, onComplete: m }, 0.05);
        }
        function d(a) {
            var b = Math.max(0, Math.min(1, a)),
                c = $(".progress").width(),
                d = $(".progress-bar").width(),
                e = c - d;
            TweenMax.set(".progress-bar", { x: b * e + "px" });
        }
        function e(a) {
            (a = a || 0),
                C.slides.forEach(function (a, b) {
                    var c = B[b],
                        d = ((a.target + C.x) * -1) / 3;
                    u.hasClass("ready") && D ? TweenMax.set(c, { x: d }) : TweenMax.to(c, 0.5, { x: 0, ease: Cubic.easeOut });
                });
        }
        function f(a, b, c) {
            return Math.max(0, Math.min(1, a - c / (b - c)));
        }
        function g() {
            window.countDown = TweenMax.fromTo(
                ".countdown>.bar",
                8,
                { width: 0 },
                {
                    width: "100%",
                    delay: 8,
                    ease: Cubic.easeInOut,
                    onComplete: function () {
                        t.flickity("next");
                        var a = parseInt(C.selectedIndex + 1),
                            b = parseInt(C.slides.length);
                        a < b ? g() : TweenMax.set(".countdown>.bar", { width: 0 });
                    },
                }
            );
        }
        function h(a) {
            var b = a.replace(/\/$/, ""),
                c = b.replace(/^http:/, "https:");
            return c;
        }
        function i(a, b) {
            var c = a;
            if (window.location.href !== c && c !== v && "/" !== c) l(), window.mobilecheck() || $.pnp.disableScroll(), $("html,body").scrollTop(0), s.load(a);
            else {
                var d = $(window).width() < 767 ? window.headHeight - 57 : window.headHeight;
                TweenMax.to(window, 2, {
                    scrollTo: { y: d, autoKill: !1, rotation: 0.01 },
                    ease: Cubic.easeInOut,
                    onComplete: function () {
                        $.pnp.enableScroll();
                    },
                });
            }
        }
        function j() {
            (C.options.draggable = !1),
                (C.options.selectedAttraction = x),
                (C.options.friction = y),
                C.updateDraggable(),
                $(".next, .back").css({ width: "20%" }),
                A.set({ enable: !0 }),
                TweenMax.to(window, 0.5, { scrollTo: { y: 0, autoKill: !1 }, ease: Power3.easeOut }),
                TweenMax.to(u.find(".append"), 0.5, { autoAlpha: 0 }),
                setTimeout(function () {
                    u.removeClass("zoom"), $(".nav-container").hasClass("black") && $(".nav-container").removeClass("black");
                }, 300),
                TweenMax.to(".slider-nav>.slider-wrapper", 2, {
                    scale: 1,
                    ease: Cubic.easeInOut,
                    onStart: function () {
                        $(".slider-nav>.slider-wrapper").removeClass("zoomed-out");
                        var a = $(".slick-current").children("a");
                        a.attr("title"), a.attr("href");
                        setTimeout(function () {
                            $(".captions-full ul li").find("button").removeClass("in").css("visibility", "hidden");
                        }, 500);
                    },
                    onComplete: function () {
                        u.hasClass("ready") || u.addClass("ready"),
                            TweenMax.set(".captions-full .is-selected .subtitle, .captions-full .is-selected h4, .captions-full .is-selected p", { autoAlpha: 0 }),
                            TweenMax.set(".captions-full .is-selected .seo-title", { autoAlpha: 0 }),
                            TweenMax.to(".slider-nav>.slider-wrapper .caption, .slider-nav .captions-full", 1, {
                                autoAlpha: 1,
                                onComplete: function () {
                                    $(window).width() < 767
                                        ? TweenMax.to($(".captions-full .is-selected").find(".seo-title"), 1, {
                                              autoAlpha: 0.5,
                                              delay: 0.35,
                                              ease: Cubic.easeOut,
                                              onComplete: function () {
                                                  $(".captions-full ul li.is-selected").find("button").not(".in").addClass("in").css("visibility", "visible");
                                              },
                                          })
                                        : TweenMax.to($(".captions-full .is-selected").find("p"), 1, {
                                              autoAlpha: 1,
                                              delay: 0.5,
                                              ease: Cubic.easeOut,
                                              onComplete: function () {
                                                  $(".captions-full ul li.is-selected").find("button").not(".in").addClass("in").css("visibility", "visible");
                                              },
                                          }),
                                        TweenMax.to($(".captions-full .is-selected").find("h4"), 1, { autoAlpha: 1, delay: 0.2, ease: Cubic.easeOut, onComplete: function () {} }),
                                        TweenMax.to($(".captions-full .is-selected").find(".subtitle"), 1, {
                                            autoAlpha: 1,
                                            delay: 0.1,
                                            ease: Cubic.easeOut,
                                            onComplete: function () {
                                                TweenMax.to($(".captions-full").find("p"), 0.5, { autoAlpha: 1 }), $(".captions-full ul li.is-selected").find("button").not(".in").addClass("in").css("visibility", "visible");
                                            },
                                        }),
                                        TweenMax.to($(".captions-full .is-selected").find(".subtitle").find(".seo-title"), 1, { autoAlpha: 0.5, delay: 0.15, ease: Cubic.easeOut });
                                },
                            });
                    },
                }),
                TweenMax.to(".slider-nav .arrow", 0.5, { autoAlpha: 1, delay: 0.5 }),
                r || TweenMax.to(".slides li .background", 0.3, { x: 0 }),
                TweenMax.to(".progress-wrap, .section-wrap", 0.5, { autoAlpha: 0 }),
                TweenMax.to(".countdown", 0.5, { delay: 0.5, autoAlpha: 1 });
        }
        function k(a) {
            a = a || 0;
            var b = $(window).width() < 768 ? 38 : 45,
                c = $(window).width() < 768 ? 0.5 : 0.4;
            (C.options.draggable = !0),
                (C.options.selectedAttraction = 0.01),
                (C.options.friction = 0.18),
                C.updateDraggable(),
                $.pnp.disableScroll(),
                $(".nav-container").hasClass("black") && $(".nav-container").removeClass("black"),
                a
                    ? ($(".slides li .background").each(function () {
                          $(this).addClass("no-transition");
                      }),
                      setTimeout(function () {
                          $(".slides li .background").each(function () {
                              $(this).removeClass("no-transition");
                          });
                      }, 10),
                      null !== window.countDown && void 0 !== window.countDown && window.countDown.pause(0),
                      $(".next, .back").css({ width: "5%" }),
                      A.set({ enable: !1 }),
                      u.addClass("zoom"),
                      TweenMax.set(".slides", { top: 0 }),
                      r || TweenMax.set(".slides li .background", { x: 0 }),
                      TweenMax.set(".progress-wrap", { autoAlpha: 1 }),
                      TweenMax.set(".countdown, .slider-nav .arrow, .slider-nav>.slider-wrapper .caption, .slider-nav .captions-full", { autoAlpha: 0 }),
                      TweenMax.set(u, { transformOrigin: "50vw " + b + "vh", scale: c }),
                      u.removeClass("ready"),
                      u.addClass("zoomed-out"),
                      TweenMax.set(u.find(".append"), { autoAlpha: 1 }))
                    : (TweenMax.to(window, 0, { scrollTo: { y: 0, autoKill: !1 }, autoKill: !1, ease: Power3.easeOut }),
                      u.hasClass("ready") &&
                          (null !== window.countDown && void 0 !== window.countDown && window.countDown.pause(0),
                          $(".next, .back").css({ width: "5%" }),
                          A.set({ enable: !1 }),
                          "true" === localStorage.getItem("auto_zoom") ? TweenMax.set(".captions-full", { autoAlpha: 0 }) : TweenMax.to(".captions-full", 0.2, { autoAlpha: 0 }),
                          u.addClass("zoom"),
                          window.zoomEffect(!0),
                          TweenMax.to(".progress-wrap, .section-wrap", 0.5, { delay: 2, autoAlpha: 1 }),
                          TweenMax.to(".countdown", 0.5, { autoAlpha: 0 }),
                          TweenMax.to(".slider-nav>.slider-wrapper .caption, .slider-nav .captions-full", 0.4, { autoAlpha: 0 }),
                          TweenMax.to(".slider-nav .arrow", 0.4, { autoAlpha: 0 }),
                          r || window.mobilecheck() || window.ie || e(!0),
                          TweenMax.to(u, 2, {
                              transformOrigin: "50vw " + b + "vh",
                              scale: c,
                              ease: Cubic.easeInOut,
                              onComplete: function () {
                                  TweenMax.to(u.find(".append"), 0.5, {
                                      autoAlpha: 1,
                                      onStart: function () {
                                          u.removeClass("ready"), u.addClass("zoomed-out"), TweenMax.to(".captions-full", 0.2, { autoAlpha: 0 }), r || window.mobilecheck() || window.ie || e();
                                      },
                                  });
                              },
                          }),
                          TweenMax.to(".slides", 2, { top: 0, ease: Cubic.easeInOut }),
                          r || TweenMax.to(".slides li .background", 0.3, { x: 0 })));
        }
        function l() {
            $(".project .case").html($(".captions-full li.is-selected .inner .caption h4").text());
        }
        function m() {
            TweenMax.set($(".main"), { x: 0 }),
                TweenMax.set($(".submenu.first, .submenu.second"), { x: 0, autoAlpha: 0 }),
                $("#side-menu-container, #desktop-nav ").removeClass("extended"),
                $("#side-menu-container, #desktop-nav ").removeClass("expanded"),
                $(".first-level, .second-level").css("display", "none"),
                TweenMax.set($(".side-menu-container .main, .submenu"), { x: "100%" }),
                TweenMax.set($(".submenu"), { autoAlpha: 0 }),
                $(".submenu.first").removeClass("active"),
                $(".main a").removeClass("active"),
                n();
        }
        function n() {
            TweenMax.to($('ul.text-menu li a:not(".hovering, .active")'), 0.5, { alpha: 0.5, ease: Cubic.easeOut });
        }
        function o(a, b) {
            b = b || 0;
            var c;
            if (2 === b) {
                c = $(window).width() < 768 ? "-11%" : "20%";
                var d = "hidden" === $(".submenu.second").css("visibility") ? 0 : 0.5;
                TweenMax.to(".submenu.second", d, {
                    autoAlpha: 0,
                    onComplete: function () {
                        $("#side-menu-container, #desktop-nav").addClass("extended"),
                            $("a [data-trigger='" + a + "']").addClass("active"),
                            $(".submenu.second .text-menu, .submenu.second .line").css({ display: "none" }),
                            $(".submenu.second")
                                .find("." + a)
                                .css({ display: "table-cell" }),
                            $(".submenu.second")
                                .find("." + a)
                                .parent()
                                .find(".line")
                                .css({ display: "table-cell" }),
                            TweenMax.set($(".submenu.second li"), { x: 50, autoAlpha: 0 }),
                            TweenMax.set(
                                $(".submenu.second")
                                    .find("." + a)
                                    .parent()
                                    .find(".line"),
                                { scaleY: 0 }
                            ),
                            TweenMax.to($(".sub-link[data-trigger='" + a + "']"), 0.5, { autoAlpha: 1 }),
                            TweenMax.to($(".main"), 1, { x: c, ease: Cubic.easeInOut }),
                            TweenMax.to($(".submenu.first, .submenu.second"), 1, {
                                x: c,
                                autoAlpha: 1,
                                ease: Cubic.easeInOut,
                                onComplete: function () {
                                    n();
                                },
                            }),
                            TweenMax.staggerTo(
                                $(".submenu.second")
                                    .find("." + a)
                                    .find("li"),
                                1,
                                { x: 0, autoAlpha: 1, ease: Cubic.easeOut, delay: 0.5 },
                                0.1
                            ),
                            TweenMax.to(
                                $(".submenu.second")
                                    .find("." + a)
                                    .parent()
                                    .find(".line"),
                                2,
                                { scaleY: 1, transformOrigin: "top left", force3D: "auto", delay: 1, ease: Cubic.easeOut }
                            ),
                            $(".submenu.second").attr("data-current", a);
                    },
                });
            } else {
                c = "50%";
                var d = "hidden" === $(".submenu.first").css("visibility") ? 0 : 0.5;
                TweenMax.to(".submenu.second", 0.5, { autoAlpha: 0, ease: Cubic.easeOut }),
                    TweenMax.to(".submenu.first", d, {
                        autoAlpha: 0,
                        onComplete: function () {
                            $("#side-menu-container, #desktop-nav").addClass("expanded"),
                                $("a [data-trigger='" + a + "']").addClass("active"),
                                $(".submenu.first .text-menu, .submenu.first .line").css({ display: "none" }),
                                $(".submenu.first")
                                    .find("." + a)
                                    .css({ display: "table-cell" }),
                                $(".submenu.first")
                                    .find("." + a)
                                    .parent()
                                    .find(".line")
                                    .css({ display: "table-cell" }),
                                TweenMax.to(".submenu.second", 1, { x: c, autoAlpha: 0, ease: Cubic.easeInOut }),
                                TweenMax.set($(".submenu.first li"), { x: 50, autoAlpha: 0 }),
                                TweenMax.set(
                                    $(".submenu.first")
                                        .find("." + a)
                                        .parent()
                                        .find(".line"),
                                    { scaleY: 0 }
                                ),
                                TweenMax.to($(".sub-link[data-trigger='" + a + "']"), 0.5, { autoAlpha: 1 }),
                                TweenMax.to($(".main"), 1, { x: c, ease: Cubic.easeInOut }),
                                TweenMax.to($(".submenu.first"), 1, {
                                    x: c,
                                    autoAlpha: 1,
                                    ease: Cubic.easeInOut,
                                    onComplete: function () {
                                        n();
                                    },
                                }),
                                TweenMax.staggerTo(
                                    $(".submenu.first")
                                        .find("." + a)
                                        .find("li"),
                                    1,
                                    { x: 0, autoAlpha: 1, ease: Cubic.easeOut, delay: 0.5 },
                                    0.1
                                ),
                                TweenMax.to(
                                    $(".submenu.first")
                                        .find("." + a)
                                        .parent()
                                        .find(".line"),
                                    2,
                                    { scaleY: 1, transformOrigin: "top left", force3D: "auto", delay: 1, ease: Cubic.easeOut }
                                ),
                                $(".submenu.first").attr("data-current", a);
                        },
                    });
            }
        }
        function p(a, b) {
            b = b || 0;
            var c;
            2 === b
                ? ((c = "100%"),
                  (a = void 0 !== a ? a : $(".submenu.second").attr("data-current")),
                  $("#side-menu-container, #desktop-nav").removeClass("extended"),
                  $(".submenu.second").removeClass("active"),
                  $(".main a").removeClass("active"),
                  TweenMax.staggerTo(
                      $(".submenu.second")
                          .find("." + a)
                          .find("li"),
                      1,
                      { x: 50, autoAlpha: 0, ease: Cubic.easeOut },
                      -0.1
                  ),
                  TweenMax.to($(".main"), 1, { x: "100%", ease: Cubic.easeInOut }),
                  TweenMax.to($(".submenu.second"), 1, {
                      x: "100%",
                      autoAlpha: 0,
                      ease: Cubic.easeInOut,
                      onComplete: function () {
                          $(".submenu.second").attr("data-current") !== a && void 0 !== a && (o(a, 2), $(".main a[data-trigger='" + a + "']").addClass("active"), n());
                      },
                  }))
                : ((c = "50%"),
                  (a = void 0 !== a ? a : $(".submenu.first").attr("data-current")),
                  $("#side-menu-container, #desktop-nav").removeClass("expanded"),
                  $(".submenu.first").removeClass("active"),
                  $(".main a").removeClass("active"),
                  TweenMax.staggerTo(
                      $(".submenu.first")
                          .find("." + a)
                          .find("li"),
                      1,
                      { x: 50, autoAlpha: 0, ease: Cubic.easeOut },
                      -0.1
                  ),
                  TweenMax.to($(".main"), 1, { x: c, ease: Cubic.easeInOut }),
                  TweenMax.to($(".submenu.first"), 1, {
                      x: c,
                      autoAlpha: 0,
                      ease: Cubic.easeInOut,
                      onComplete: function () {
                          $(".submenu.first").attr("data-current") !== a && void 0 !== a && (o(a), $(".main a[data-trigger='" + a + "']").addClass("active"), n());
                      },
                  }));
        }
        function q() {
            if ($(".slider-nav").length && (window.mobilecheck() || $(window).width() < 767)) {
                var a = window.innerHeight;
                (window.headHeight = a), TweenMax.to(".slider-nav", 0.5, { height: a, ease: Cubic.easeOut });
            }
        }
        var r = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (((window.ie = a()), $(".slider-nav").length)) {
            TweenMax.lagSmoothing(400, 10);
            var s = $("#content").smoothState().data("smoothState");
            $("p:empty").remove();
            var t = $(".slider-nav>.slider-wrapper>.slides"),
                u = ($(".slider-nav .captions-full ul"), $(".overlay-menu"), $(".slider-nav>.slider-wrapper")),
                v = ($(".view-toggle"), $("body").attr("data-domain")),
                w = !1;
            TweenMax.set(".slider-nav>.slider-wrapper", { scale: 1, opacity: 1, force3D: "auto" });
            var x = 0.0101,
                y = 0.18;
            t.flickity({ initialIndex: 0, draggable: !1, autoPlay: !1, pauseAutoPlayOnHover: !0, pageDots: !1, prevNextButtons: !1, selectedAttraction: x, friction: y, dragThreshold: 10, sync: ".captions-full ul" }),
                $(".captions-full ul").on("ready.flickity", function () {
                    TweenMax.set($(".captions-full"), { autoAlpha: 0 }),
                        TweenMax.set($(".captions-full .is-selected").find("h4"), { autoAlpha: 0 }),
                        TweenMax.set($(".captions-full .is-selected").find(".subtitle"), { autoAlpha: 0 }),
                        TweenMax.set($(".captions-full .is-selected").find("p"), { autoAlpha: 0 }),
                        $(window).width() < 767 && TweenMax.set($(".captions-full .is-selected").find(".seo-title"), { autoAlpha: 0 }),
                        $(".captions-full .is-selected").find("p").css("visibility", "hidden"),
                        setTimeout(function () {
                            E &&
                                (TweenMax.set($(".captions-full"), { autoAlpha: 0 }),
                                TweenMax.set($(".captions-full .is-selected").find("h4"), { autoAlpha: 0 }),
                                TweenMax.set($(".captions-full .is-selected").find(".subtitle"), { autoAlpha: 0 }),
                                TweenMax.set($(".captions-full .is-selected").find("p"), { autoAlpha: 0 }),
                                $(window).width() < 767 && TweenMax.set($(".captions-full .is-selected").find(".seo-title"), { autoAlpha: 0 }),
                                TweenMax.to($(".captions-full"), 0.5, {
                                    autoAlpha: 1,
                                    delay: 0.5,
                                    onComplete: function () {
                                        var a = $(".captions-full ul .is-selected");
                                        if (
                                            ((w = !0),
                                            window.zoomEffect(),
                                            TweenMax.fromTo(a.find(".subtitle"), 1, { autoAlpha: 0 }, { autoAlpha: 1, delay: 0.1, ease: Cubic.easeOut }),
                                            TweenMax.fromTo(a.find("h4"), 5, { autoAlpha: 0 }, { autoAlpha: 1, delay: 0.5, ease: Cubic.easeOut }),
                                            $(window).width() < 767 && TweenMax.fromTo(a.find(".seo-title"), 5, { autoAlpha: 0 }, { autoAlpha: 0.5, delay: 0.7, ease: Cubic.easeOut }),
                                            a.find("p").length)
                                        ) {
                                            var b = new SplitText(a.find("p"), { type: "chars,words,lines" });
                                            TweenMax.staggerFrom(
                                                b.words,
                                                2,
                                                {
                                                    autoAlpha: 0,
                                                    ease: Cubic.easeOut,
                                                    delay: 0.5,
                                                    onStart: function () {
                                                        TweenMax.set($(".captions-full p"), { autoAlpha: 1 }), $(".captions-full p").css("visibility", "visible");
                                                    },
                                                    onComplete: function () {
                                                        a.find(".loadpage").addClass("in").css("visibility", "visible");
                                                    },
                                                },
                                                0.04
                                            );
                                        } else
                                            TweenMax.to($(".captions-full .is-selected").find("h4"), 5, {
                                                autoAlpha: 1,
                                                delay: 0.5,
                                                ease: Cubic.easeOut,
                                                onComplete: function () {
                                                    a.find(".loadpage").length && a.find(".loadpage").addClass("in").css("visibility", "visible");
                                                },
                                            }),
                                                "hidden" !== $(".captions-full").css("visibility")
                                                    ? (TweenMax.to($(".captions-full .is-selected").find(".subtitle"), 1, { autoAlpha: 1, delay: 0.1, ease: Cubic.easeOut }),
                                                      $(".captions-full p").css({ visibility: "visible", opacity: 1 }),
                                                      $(".captions-full ul li.is-selected").find("button").addClass("in").css("visibility", "visible"))
                                                    : TweenMax.to($(".captions-full .is-selected").find(".subtitle"), 1, { autoAlpha: 1, delay: 0.6, ease: Cubic.easeOut });
                                    },
                                }));
                        }, 100);
                }),
                $(".captions-full ul").flickity({ draggable: !1, autoPlay: !1, initialIndex: 0, pageDots: !1, prevNextButtons: !1, selectedAttraction: x, friction: y, dragThreshold: 10 }),
                (window.mobilecheck = function () {
                    var a = !1;
                    return (
                        (function (b) {
                            (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|Android|BlackBerry|iPhone|iPad|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                                b
                            ) ||
                                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                                    b.substr(0, 4)
                                )) &&
                                (a = !0);
                        })(navigator.userAgent || navigator.vendor || window.opera),
                        a
                    );
                });
            var z = document.getElementById("sliderNav"),
                A = new Hammer(z);
            window.mobilecheck() &&
                (A.on("swipeleft", function (a) {
                    $(".slider-nav>.slider-wrapper").hasClass("zoomed-out") || (t.flickity("next"), null !== window.countDown && void 0 !== window.countDown && window.countDown.pause(0));
                }),
                A.on("swiperight", function (a) {
                    $(".slider-nav>.slider-wrapper").hasClass("zoomed-out") || (t.flickity("previous"), null !== window.countDown && void 0 !== window.countDown && window.countDown.pause(0));
                })),
                (window.headHeight = $(window).height());
            var B = t.find(".background"),
                C = t.data("flickity");
            Draggable.create($(".progress-bar"), {
                type: "x",
                overshootTolerance: 0,
                edgeResistance: 0.65,
                bounds: $(".progress"),
                throwProps: !0,
                onDrag: function () {
                    var a = f(this.endX / this.maxX, 1, 0),
                        b = C.cells.length,
                        c = Math.floor(b * a);
                    t.flickity("select", c);
                },
            }),
                u.addClass("ready"),
                void 0 != u.find(".background").data("vide") && u.find(".background").data("vide").getVideoObject().play();
            $(".navbar-toggle-overlay"), $(".overlay-menu");
            (window.countDown = null),
                TweenMax.set(".countdown>.bar", { width: 0 }),
                $("body").idle({
                    onIdle: function () {
                        null !== window.countDown && window.autoPlay && window.countDown.play();
                    },
                    onActive: function () {
                        null !== window.countDown && window.countDown.pause(0);
                    },
                    idle: 6e3,
                    events: "mousemove mouseclick keydown keypress mousewheel click",
                }),
                $("body").click(function () {
                    null !== window.countDown && window.countDown.pause(0);
                }),
                $("body").mousemove(function () {
                    null !== window.countDown && window.countDown.pause(0);
                }),
                (window.zoomEffect = function (a) {
                    a = a || 0;
                    var b = t.find(".is-selected").children(".inner").children(".background");
                    a
                        ? window.mobilecheck()
                            ? TweenMax.to(t.find(".cell").children(".inner").children(".background"), 2, { scale: 1, ease: Cubic.easeOut, overwrite: "all" })
                            : b.hasClass("video")
                            ? b.data("vide").getVideoObject().pause()
                            : TweenMax.to(t.find(".cell").children(".inner").children(".background"), 2, { scale: 1, ease: Cubic.easeOut, overwrite: "all" })
                        : (t
                              .find(".cell")
                              .not(".is-selected")
                              .each(function () {
                                  TweenMax.set($(this).children(".inner").children(".background"), { scale: 1 }),
                                      !window.mobilecheck() && $(this).find(".background.video").hasClass("video") && $(this).find(".background.video").data("vide").getVideoObject().pause();
                              }),
                          window.mobilecheck()
                              ? TweenMax.to(b, 30, { scale: 1.2, delay: 0.5, ease: Cubic.easeOut })
                              : b.hasClass("video")
                              ? b.data("vide").getVideoObject().play()
                              : TweenMax.to(b, 30, { scale: 1.2, delay: 0.5, ease: Cubic.easeOut }));
                });
            var D = !0;
            t.on("settle.flickity", function () {
                (D = !0),
                    s.fetch(t.find(".is-selected").children(".inner").attr("data-link")),
                    $(".slider-nav>.slider-wrapper").hasClass("zoomed-out") ||
                        (window.zoomEffect(),
                        $(".captions-full ul li").not(".is-selected").find("button").removeClass("in").css("visibility", "hidden"),
                        $(".captions-full ul li.is-selected").find("button").addClass("in").css("visibility", "visible"));
            }),
                t.on("select.flickity", function () {
                    var a = parseInt(C.selectedIndex + 1),
                        b = parseInt(C.slides.length);
                    a > 1 ? $(".slider-nav .back").not(".arrow").css("display", "block") : $(".slider-nav .back").not(".arrow").css("display", "none"),
                        a < b ? $(".slider-nav .next").not(".arrow").css("display", "block") : $(".slider-nav .next").not(".arrow").css("display", "none"),
                        null !== window.countDown && window.countDown.pause(0),
                        $(".section-wrap .current").text() !== t.find(".is-selected").attr("data-section") &&
                            TweenMax.to(".section-wrap .current", 0.5, {
                                autoAlpha: 0,
                                ease: Cubic.easeOut,
                                onComplete: function () {
                                    t.find(".is-selected").attr("data-section")
                                        ? (TweenMax.to(".section-wrap .inner", 0.5, { autoAlpha: 1 }), $(".section-wrap .current").text(t.find(".is-selected").attr("data-section")))
                                        : ($(".section-wrap .current").empty(), TweenMax.to(".section-wrap .inner", 0.5, { autoAlpha: 0 })),
                                        TweenMax.to(".section-wrap .current", 0.5, { autoAlpha: 1, ease: Cubic.easeOut });
                                },
                            });
                }),
                t.on("dragStart.flickity", function () {
                    (D = !1), window.mobilecheck() || $.pnp.disableScroll(), $("html,body").scrollTop(0);
                }),
                t.on("dragMove.flickity", function () {
                    D = !1;
                }),
                t.on("dragEnd.flickity", function () {
                    D = !1;
                }),
                t.on("scroll.flickity", function (a, b) {
                    r || window.mobilecheck() || window.ie || e(), d(b);
                });
            var E = !1;
            $(".slides li").each(function (a) {
                var b = $(this),
                    c = a;
                if (window.mobilecheck() && $(window).width() < 768) {
                    var d = b.find(".background");
                    d.css("background-image", "url(" + d.attr("data-mobile") + ")");
                }
                b.click(function (c) {
                    c.preventDefault(), null !== window.countDown && window.countDown.pause(0), D && u.hasClass("zoomed-out") && (b.hasClass("is-selected") && j(), t.flickity("select", a, !1, !1));
                });
                var e = $(this).find(".background"),
                    f = e.attr("data-video"),
                    i = e.attr("data-poster");
                "" === f ||
                    void 0 === f ||
                    window.mobilecheck() ||
                    $(this).find(".background").vide({ mp4: f, poster: i }, { volume: 0, playbackRate: 1, muted: !0, loop: !0, autoplay: !1, position: "0% 50%", posterType: "jpg", resizing: !0, bgColor: "#000000", className: "" });
                var k = h(b.children(".inner").attr("data-link"));
                window.location.href.indexOf(k) > -1 && "/" !== k && k !== v
                    ? (t.flickity("select", c, !1, !0), $(".captions-full ul").flickity("select", c, !1, !0), (E = !0), b.hasClass("sub-slide"))
                    : h(window.location.href) === v && ((E = !0), (window.autoPlay = !0), g(), t.flickity("select", 0, !1, !0)),
                    void 0 != b.find(".background").data("vide") && b.find(".background").data("vide").getVideoObject().play();
            }),
                E ? l() : $(".sub-slide").length && k(!0),
                $(".next, .back").on("mousemove", function (a) {
                    var b = a,
                        c = $(this),
                        d = c.find(".cursor"),
                        e = b.clientX - c.offset().left,
                        f = b.clientY - c.offset().top;
                    TweenMax.to(d, 0.2, { x: e, y: f, ease: Cubic.easeOut });
                }),
                $(".next").click(function () {
                    t.flickity("next"), $.pnp.disableScroll(), $("html,body").scrollTop(0), null !== window.countDown && window.countDown.pause(0);
                }),
                $(".back").click(function () {
                    t.flickity("previous"), $.pnp.disableScroll(), $("html,body").scrollTop(0), null !== window.countDown && window.countDown.pause(0);
                }),
                $document.on("click", ".navbar-toggle-overlay", function () {
                    var a = $(this),
                        d = $(".overlay-menu");
                    d.is(":visible")
                        ? (a.removeClass("active"), d.fadeOut(), c(), $(".nav-container .image, .view-toggle").removeClass("white"), $(".project").removeClass("hidden"))
                        : (a.addClass("active"), d.fadeIn(), b(), $(".project").addClass("hidden"), $(".nav-container .image, .view-toggle").addClass("white"));
                }),
                $(".captions-full ul li").each(function () {
                    function a() {
                        b.hasClass("active") && "auto_next" === b.attr("data-transition")
                            ? setTimeout(function () {
                                  t.flickity("next");
                              }, 500)
                            : b.hasClass("direct")
                            ? (location.href = b.children(".inner").attr("data-link"))
                            : i(b.children(".inner").attr("data-link")),
                            b.hasClass("extended") && localStorage.setItem("autoPlay", "true");
                    }
                    var b = $(this);
                    b.find(".caption button").append('<div class="left">'),
                        b.find(".caption button").append('<div class="top">'),
                        b.find(".caption button").append('<div class="right">'),
                        b.find(".caption button").append('<div class="bottom">'),
                        $(window).width() < 767 && b.find(".seo-title").insertAfter($(this).find("h4")),
                        b.find("button").click(function () {
                            a(), (window.autoPlay = !1);
                        });
                }),
                $(".view-toggle").click(function () {
                    u.hasClass("zoomed-out") ? j() : k(), $(".overlay-menu").is(":visible") && ($(".navbar-toggle-overlay").removeClass("active"), $(".overlay-menu").fadeOut());
                });
        } else
            setTimeout(function () {
                $(".contact").length && !$(".nav-container").hasClass("black") && ($(".nav-container").removeClass("white"), $(".nav-container").addClass("black"), $(window).width() < 768 && $(".nav-container").addClass("full-background"));
            }, 10),
                $document.on("click", ".navbar-toggle-overlay", function () {
                    var a = $(this),
                        d = $(".overlay-menu");
                    d.is(":visible") ? (a.removeClass("active"), c(), d.fadeOut(), p()) : (a.addClass("active"), b(), d.fadeIn());
                });
        TweenMax.set($(".side-menu-container .main, .submenu"), { x: "100%" }),
            TweenMax.set($(".submenu"), { autoAlpha: 0 }),
            $(".submenu.first .back").click(function () {
                $("#side-menu-container, #desktop-nav").removeClass("expanded"),
                    TweenMax.to(".submenu.first", 1, { x: "100%", autoAlpha: 0, ease: Cubic.easeInOut, overwrite: "all" }),
                    TweenMax.to(".main.menu-wrapper, .submenu.second", 1, {
                        x: "100%",
                        autoAlpha: 1,
                        ease: Cubic.easeInOut,
                        onComplete: function () {
                            n();
                        },
                    });
            }),
            $(".submenu.second .back").click(function () {
                $("#side-menu-container, #desktop-nav").removeClass("extended"),
                    TweenMax.to(".submenu.second", 1, { x: "50%", autoAlpha: 0, ease: Cubic.easeInOut, overwrite: "all" }),
                    TweenMax.to(".main.menu-wrapper, .submenu.first", 1, {
                        x: "50%",
                        autoAlpha: 1,
                        ease: Cubic.easeInOut,
                        onComplete: function () {
                            n();
                        },
                    });
            });
        $(".side-menu-container a").each(function () {
            $(this).click(function () {
                $(this).hasClass("portfolio") ? ((window.autoPlay = !0), localStorage.setItem("autoPlay", "true")) : ((window.autoPlay = !1), localStorage.setItem("autoPlay", "false"));
            });
        }),
            $(".side-menu-container .main>ul>li").each(function (a) {
                var b = $(this),
                    c = b.find(".first-level"),
                    d = (c.find("li"), b.find(".parent>a"));
                $(".main.menu-wrapper");
                b.hover(
                    function () {
                        d.hasClass("active") || TweenMax.to(d, 0.5, { autoAlpha: 1 });
                    },
                    function () {
                        d.hasClass("active") || TweenMax.to(d, 0.5, { autoAlpha: 0.5 });
                    }
                ),
                    b.find(".parent").hasClass("has-children") &&
                        d.click(function (a) {
                            a.preventDefault(), $(".main, .first-level").find(".active").removeClass("active"), d.addClass("active"), o(d.attr("data-trigger")), n();
                        });
            }),
            $(".first-level li").each(function () {
                var a = $(this),
                    b = a.find("a");
                a.parent().parent().find(".parent").find("a"), $(".main.menu-wrapper");
                a.hover(
                    function () {
                        b.hasClass("active") || TweenMax.to(b, 0.5, { autoAlpha: 1 });
                    },
                    function () {
                        b.hasClass("active") || TweenMax.to(b, 0.5, { autoAlpha: 0.5 });
                    }
                ),
                    void 0 !== b.attr("data-trigger") &&
                        b.click(function (a) {
                            a.preventDefault(), $(".first-level").find(".active").removeClass("active"), b.addClass("active"), o(b.attr("data-trigger"), 2), n();
                        });
            }),
            $(window).scroll(function () {
                $(".slider-nav").length &&
                    ($(window).scrollTop() > $(".slider-nav").offset().top + $(".slider-nav").height() && (null !== window.countDown && void 0 !== window.countDown && window.countDown.pause(0), (window.autoPlay = !1)),
                    "none" === $(".mm-overlay").css("display") &&
                        ($(window).width() < 768 && $(window).scrollTop() > $(".slider-nav").offset().top + $(".slider-nav").height() - 65
                            ? $(".nav-container").addClass("full-background")
                            : $(".nav-container").removeClass("full-background")),
                    $(window).scrollTop() < window.headHeight && $(".nav-container").hasClass("black") && $(".nav-container").removeClass("black"));
            }),
            $(window).resize(function () {
                q();
            }),
            q();
    }),
    ($.pnp.initSliders = function () {
        if ($(".slider-container").length) {
            if (pnpHelper.dependencyCheck.requireDependencies("Slider", [pnpHelper.dependencyCheck.slickSlider])) return;
            $(".slider-container:visible:not(.slick-initialized)").each(function () {
                function a(a) {
                    return $.extend({ infinite: !0, mobileFirst: !1, speed: 400 }, a);
                }
                var b = $(this).data("pnp-slider-config");
                $(this).slick(a(b));
            });
        }
    }),
    ($.pnp.initSubNav = function () {
        ($.fn.anchorPointBar = function (a, b) {
            var c = this,
                d = $(this),
                e = d.find("ul"),
                f = 0,
                g = !1,
                h = 0,
                i = 0,
                j = 0,
                k = { elemSelector: "[data-pnp-apb-anchor]", stickToNav: !0, replaceNav: !1, scrollDuration: 1e3, responsiveWidth: 767 };
            a && $.extend(k, a),
                d.closest("[data-pnp-search-results]").length > 0 && 0 == d.closest("[data-pnp-search-results]").find(".anchor-component").length && (k.elemSelector = "[data-pnp-search-results] h2"),
                (this.addAnchorPoint = function (a, b) {
                    var c = "";
                    void 0 === b && (b = ""), 0 == f && (c = "active");
                    var d = a.data("pnp-apb-anchor");
                    (null != d && 0 != d.length) || (d = a.text()), e.append('<li class="' + c + '" data-pnp-apb-anchor-index="' + f + '"><a href="#" class="nav-line-height ' + b + '">' + d + "</a></li>"), f++;
                }),
                (this.init = function () {
                    function a() {
                        $window.width() > k.responsiveWidth && ($window.scrollTop() >= f ? m.addClass("-fixed") : m.removeClass("-fixed"));
                    }
                    if (!$.fn.viewportChecker) return void console.error("MISSING DEPENDENCY: The component 'anchor-point-bar' requires the library 'jquery-viewport-checker'. Please update packages.json to include this library.");
                    if (
                        (b ||
                            ($(k.elemSelector).each(function (a) {
                                $(this).attr("data-pnp-apb-index", a);
                            }),
                            $document.on("click", ".anchor-points a", function () {
                                if (!g) {
                                    var a = $(this).closest("[data-pnp-apb-anchor-index]").data("pnp-apb-anchor-index");
                                    if (((g = !0), $('[data-pnp-apb-index="' + a + '"]').length)) {
                                        var b = $('[data-pnp-apb-index="' + a + '"]').offset().top;
                                        (b -= d.outerHeight()),
                                            k.stickToNav && (b -= pnpHelper.getNavHeight()),
                                            $("html, body").animate({ scrollTop: b + "px" }, k.scrollDuration, function () {
                                                (g = !1), (h = 0), (i = 0), (j = 0);
                                            });
                                    }
                                }
                                return !1;
                            })),
                        !c.hasClass("-vertical") && (k.stickToNav || k.replaceNav))
                    ) {
                        var e,
                            f = d.offset().top,
                            l = k.replaceNav ? 0 : pnpHelper.getNavHeight(),
                            m = d.find(".inner");
                        k.stickToNav && (f -= pnpHelper.getNavHeight()),
                            a(),
                            $window.scroll(a).resize(function () {
                                $window.width() > k.responsiveWidth &&
                                    (clearTimeout(e),
                                    (e = setTimeout(function () {
                                        (f = d.offset().top), k.stickToNav && (f -= $navBar.height()), (l = k.stickToNav ? $navBar.height() : 0);
                                    }, 300)));
                            });
                    }
                }),
                0 == e.find("[data-pnp-apb-anchor-index]").length &&
                    (c.init(),
                    b ||
                        $(k.elemSelector).each(function (a) {
                            c.addAnchorPoint($(this));
                        }));
        }),
            $(".component-subnav.-internal").length > 0 && $(".component-subnav.-internal").anchorPointBar(null, !1),
            $(".component-subnav.-external").length > 0 && $(".component-subnav.-external").anchorPointBar(null, !0),
            $("[data-pnp-apb-index]").viewportChecker({
                repeat: !0,
                callbackFunction: function (a, b) {
                    var c = $("[data-pnp-apb-anchor-index]").eq($(a).data("pnp-apb-index"));
                    "add" == b ? c.addClass("active") : c.removeClass("active");
                },
            });
    }),
    ($.pnp.initTeam = function () {
        $(".component-team").length &&
            (console.log("found team component!"),
            $(".component-team .profile").each(function () {
                var a = $(this),
                    b = a.attr("data-name"),
                    c = a.attr("data-position"),
                    d = a.attr("data-img"),
                    e = '<img src="' + d + '"/>' + a.attr("data-content");
                a.attr("data-trigger") &&
                    a.click(function () {
                        console.log("click!"), $.pnp.overlayer.populate(b, c, e, !1), $.pnp.overlayer.show();
                    });
            }));
    });
